'/* eslint-disable */'
import { HasuraArray } from './hasura-array';
import { AppletDesignConfig } from './mes/applet-designs/applet-design-config.zod';
import { AttributeSettingConfiguration } from './attribute-settings/attribute-settings-config.zod';
import { CreateMaterialData } from './material-create-data';
import { SerialNumberGenerateData, SerialNumberGenerateDatetimeTokenData, SerialNumberGenerateAlignContentData, SerialNumberGenerateSequenceData } from './serial-number-generate-data';
import { Deployment, LinkedDesignVersionConfig } from '../src/mes/appletDeployment.zod';
import type { MaterialClassMeta, MaterialModelMeta } from './material-class-meta';
import type { InheritlessSpecConfig, ProcessConfig, ProcessSpecConfig } from '../src/process-config.zod';
import type { ProcessCollectData } from '@redviking/argonaut-util/src/plv8-schemas/process-collect-data.zod';
import type { MarriageDataInput } from '@redviking/argonaut-util/src/plv8-schemas/marry-material.zod';
import type { TraverseAssembliesOpts } from '@redviking/argonaut-util/src/plv8-schemas/traverse-assemblies-opts.zod';
import type { AuthProviderLocalSettingConfig } from '@redviking/argonaut-util/src/api/auth-provider/local.ts';
import type { AuthProviderMsalSettingConfig } from '@redviking/argonaut-util/src/api/auth-provider/msal.ts';
import type { AppletRunnerHealth, AppletRuntimesHealth } from '@redviking/argonaut-util/types/mes/runner-health.d.ts';
import type { MaterialClassModelLinkedMedia, MaterialClassModelLinkedProfilePicture } from '@redviking/argonaut-util/src/material-class';
import { SerialNumFmtConfig } from '@redviking/argonaut-util/src/serial-numbers';
import type { WorkInstructionVersion, WorkInstructionInstanceStepCompletionProgress, GetOrCreateWorkInstructionInstanceInputs } from '@redviking/argonaut-util/types/work-instruction-version';
import type { ConnectionConfig } from '@redviking/argonaut-util/types/connections/connection-config';
import { MediaMeta } from './media-types';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _json: any;
  _text: HasuraArray<string>;
  _uuid: HasuraArray<string>;
  applet_runner_health: AppletRunnerHealth;
  applet_runtimes_health: AppletRuntimesHealth;
  argo_attribute_setting_config: AttributeSettingConfiguration;
  argo_auth_provider_local_setting_config: AuthProviderLocalSettingConfig;
  argo_auth_provider_msal_setting_config: AuthProviderMsalSettingConfig;
  argo_connection_config_config: ConnectionConfig;
  argo_create_material_data: CreateMaterialData;
  argo_get_or_create_work_instruction_data: GetOrCreateWorkInstructionInstanceInputs;
  argo_marry_material_data: MarriageDataInput;
  argo_material_class_meta: MaterialClassMeta;
  argo_material_class_model_linked_media: MaterialClassModelLinkedMedia;
  argo_material_class_model_linked_profile_picture: MaterialClassModelLinkedProfilePicture;
  argo_material_model_meta: MaterialModelMeta;
  argo_media_meta: MediaMeta;
  argo_serial_number_format_datetime_token_data_args: SerialNumberGenerateDatetimeTokenData;
  argo_serial_number_generate_align_content_data_args: SerialNumberGenerateAlignContentData;
  argo_serial_number_generate_data: SerialNumberGenerateData;
  argo_serial_number_generate_sequence_data_args: SerialNumberGenerateSequenceData;
  argo_sn_format_config: SerialNumFmtConfig;
  argo_traverse_assemblies_opts: TraverseAssembliesOpts;
  argo_work_instruction_instance_step_completion_progress: WorkInstructionInstanceStepCompletionProgress;
  argo_work_instruction_instance_step_completion_progress_partial: Partial<WorkInstructionInstanceStepCompletionProgress>;
  argo_work_instruction_version_config: WorkInstructionVersion;
  bigint: number | string;
  float8: any;
  interval: any;
  json: unknown;
  jsonb: unknown;
  numeric: number;
  process_collect_args_data: ProcessCollectData;
  process_config: ProcessConfig;
  process_spec_config: ProcessSpecConfig;
  process_spec_config_inheritless: InheritlessSpecConfig;
  smallint: number;
  timestamp: any;
  timestamptz: string;
  tsrange: any;
  uuid: string;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: Maybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: Maybe<Array<Scalars['String']>>;
  _eq?: Maybe<Array<Scalars['String']>>;
  _gt?: Maybe<Array<Scalars['String']>>;
  _gte?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Array<Scalars['String']>>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Array<Scalars['String']>>;
  _lte?: Maybe<Array<Scalars['String']>>;
  _neq?: Maybe<Array<Scalars['String']>>;
  _nin?: Maybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};




/** columns and relationships of "applet.deployment" */
export type AppletDeployment = {
  __typename?: 'applet_deployment';
  config: Scalars['jsonb'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  linked_design_versions: Array<AppletDeploymentLinkedDesignVersion>;
  /** An aggregate relationship */
  linked_design_versions_aggregate: AppletDeploymentLinkedDesignVersionAggregate;
  name: Scalars['String'];
  name_unique: Scalars['String'];
  notes: Scalars['String'];
  /** An object relationship */
  runner: AppletRunner;
  runner_id: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version: Scalars['smallint'];
};


/** columns and relationships of "applet.deployment" */
export type AppletDeploymentConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "applet.deployment" */
export type AppletDeploymentLinkedDesignVersionsArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


/** columns and relationships of "applet.deployment" */
export type AppletDeploymentLinkedDesignVersionsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};

/** aggregated selection of "applet.deployment" */
export type AppletDeploymentAggregate = {
  __typename?: 'applet_deployment_aggregate';
  aggregate?: Maybe<AppletDeploymentAggregateFields>;
  nodes: Array<AppletDeployment>;
};

export type AppletDeploymentAggregateBoolExp = {
  bool_and?: Maybe<AppletDeploymentAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<AppletDeploymentAggregateBoolExpBoolOr>;
  count?: Maybe<AppletDeploymentAggregateBoolExpCount>;
};

export type AppletDeploymentAggregateBoolExpBoolAnd = {
  arguments: AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletDeploymentBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppletDeploymentAggregateBoolExpBoolOr = {
  arguments: AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletDeploymentBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppletDeploymentAggregateBoolExpCount = {
  arguments?: Maybe<Array<AppletDeploymentSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletDeploymentBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applet.deployment" */
export type AppletDeploymentAggregateFields = {
  __typename?: 'applet_deployment_aggregate_fields';
  avg?: Maybe<AppletDeploymentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppletDeploymentMaxFields>;
  min?: Maybe<AppletDeploymentMinFields>;
  stddev?: Maybe<AppletDeploymentStddevFields>;
  stddev_pop?: Maybe<AppletDeploymentStddevPopFields>;
  stddev_samp?: Maybe<AppletDeploymentStddevSampFields>;
  sum?: Maybe<AppletDeploymentSumFields>;
  var_pop?: Maybe<AppletDeploymentVarPopFields>;
  var_samp?: Maybe<AppletDeploymentVarSampFields>;
  variance?: Maybe<AppletDeploymentVarianceFields>;
};


/** aggregate fields of "applet.deployment" */
export type AppletDeploymentAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletDeploymentSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applet.deployment" */
export type AppletDeploymentAggregateOrderBy = {
  avg?: Maybe<AppletDeploymentAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AppletDeploymentMaxOrderBy>;
  min?: Maybe<AppletDeploymentMinOrderBy>;
  stddev?: Maybe<AppletDeploymentStddevOrderBy>;
  stddev_pop?: Maybe<AppletDeploymentStddevPopOrderBy>;
  stddev_samp?: Maybe<AppletDeploymentStddevSampOrderBy>;
  sum?: Maybe<AppletDeploymentSumOrderBy>;
  var_pop?: Maybe<AppletDeploymentVarPopOrderBy>;
  var_samp?: Maybe<AppletDeploymentVarSampOrderBy>;
  variance?: Maybe<AppletDeploymentVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppletDeploymentAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "applet.deployment" */
export type AppletDeploymentArrRelInsertInput = {
  data: Array<AppletDeploymentInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<AppletDeploymentOnConflict>;
};

/** aggregate avg on columns */
export type AppletDeploymentAvgFields = {
  __typename?: 'applet_deployment_avg_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applet.deployment" */
export type AppletDeploymentAvgOrderBy = {
  version?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applet.deployment". All fields are combined with a logical 'AND'. */
export type AppletDeploymentBoolExp = {
  _and?: Maybe<Array<AppletDeploymentBoolExp>>;
  _not?: Maybe<AppletDeploymentBoolExp>;
  _or?: Maybe<Array<AppletDeploymentBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  linked_design_versions?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
  linked_design_versions_aggregate?: Maybe<AppletDeploymentLinkedDesignVersionAggregateBoolExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  notes?: Maybe<StringComparisonExp>;
  runner?: Maybe<AppletRunnerBoolExp>;
  runner_id?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  version?: Maybe<SmallintComparisonExp>;
};

/** unique or primary key constraints on table "applet.deployment" */
export enum AppletDeploymentConstraint {
  /** unique or primary key constraint on columns "deployment_id" */
  AppletDeploymentPkey = 'applet_deployment_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AppletDeploymentUniqueName = 'applet_deployment_unique_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppletDeploymentDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppletDeploymentDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppletDeploymentDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "applet.deployment" */
export type AppletDeploymentIncInput = {
  version?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "applet.deployment" */
export type AppletDeploymentInsertInput = {
  config?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  linked_design_versions?: Maybe<AppletDeploymentLinkedDesignVersionArrRelInsertInput>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner?: Maybe<AppletRunnerObjRelInsertInput>;
  runner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['smallint']>;
};

/** The link table for applet deployments and their design versions */
export type AppletDeploymentLinkedDesignVersion = {
  __typename?: 'applet_deployment_linked_design_version';
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  deployment: AppletDeployment;
  deployment_id: Scalars['uuid'];
  /** An object relationship */
  design_version: AppletDesignVersion;
  design_version_id: Scalars['uuid'];
  id: Scalars['uuid'];
};


/** The link table for applet deployments and their design versions */
export type AppletDeploymentLinkedDesignVersionConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionAggregate = {
  __typename?: 'applet_deployment_linked_design_version_aggregate';
  aggregate?: Maybe<AppletDeploymentLinkedDesignVersionAggregateFields>;
  nodes: Array<AppletDeploymentLinkedDesignVersion>;
};

export type AppletDeploymentLinkedDesignVersionAggregateBoolExp = {
  count?: Maybe<AppletDeploymentLinkedDesignVersionAggregateBoolExpCount>;
};

export type AppletDeploymentLinkedDesignVersionAggregateBoolExpCount = {
  arguments?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionAggregateFields = {
  __typename?: 'applet_deployment_linked_design_version_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AppletDeploymentLinkedDesignVersionMaxFields>;
  min?: Maybe<AppletDeploymentLinkedDesignVersionMinFields>;
};


/** aggregate fields of "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<AppletDeploymentLinkedDesignVersionMaxOrderBy>;
  min?: Maybe<AppletDeploymentLinkedDesignVersionMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppletDeploymentLinkedDesignVersionAppendInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionArrRelInsertInput = {
  data: Array<AppletDeploymentLinkedDesignVersionInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<AppletDeploymentLinkedDesignVersionOnConflict>;
};

/** Boolean expression to filter rows from the table "applet.deployment_linked_design_version". All fields are combined with a logical 'AND'. */
export type AppletDeploymentLinkedDesignVersionBoolExp = {
  _and?: Maybe<Array<AppletDeploymentLinkedDesignVersionBoolExp>>;
  _not?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
  _or?: Maybe<Array<AppletDeploymentLinkedDesignVersionBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  deployment?: Maybe<AppletDeploymentBoolExp>;
  deployment_id?: Maybe<UuidComparisonExp>;
  design_version?: Maybe<AppletDesignVersionBoolExp>;
  design_version_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionConstraint {
  /** unique or primary key constraint on columns "deployment_linked_design_version_id" */
  AppletDeploymentLinkedDesignVersionPkey = 'applet_deployment_linked_design_version_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppletDeploymentLinkedDesignVersionDeleteAtPathInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppletDeploymentLinkedDesignVersionDeleteElemInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppletDeploymentLinkedDesignVersionDeleteKeyInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionInsertInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
  deployment?: Maybe<AppletDeploymentObjRelInsertInput>;
  deployment_id?: Maybe<Scalars['uuid']>;
  design_version?: Maybe<AppletDesignVersionObjRelInsertInput>;
  design_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AppletDeploymentLinkedDesignVersionMaxFields = {
  __typename?: 'applet_deployment_linked_design_version_max_fields';
  deployment_id?: Maybe<Scalars['uuid']>;
  design_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionMaxOrderBy = {
  deployment_id?: Maybe<OrderBy>;
  design_version_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AppletDeploymentLinkedDesignVersionMinFields = {
  __typename?: 'applet_deployment_linked_design_version_min_fields';
  deployment_id?: Maybe<Scalars['uuid']>;
  design_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionMinOrderBy = {
  deployment_id?: Maybe<OrderBy>;
  design_version_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionMutationResponse = {
  __typename?: 'applet_deployment_linked_design_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletDeploymentLinkedDesignVersion>;
};

/** on_conflict condition type for table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionOnConflict = {
  constraint: AppletDeploymentLinkedDesignVersionConstraint;
  update_columns?: Array<AppletDeploymentLinkedDesignVersionUpdateColumn>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};

/** Ordering options when selecting data from "applet.deployment_linked_design_version". */
export type AppletDeploymentLinkedDesignVersionOrderBy = {
  config?: Maybe<OrderBy>;
  deployment?: Maybe<AppletDeploymentOrderBy>;
  deployment_id?: Maybe<OrderBy>;
  design_version?: Maybe<AppletDesignVersionOrderBy>;
  design_version_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.deployment_linked_design_version */
export type AppletDeploymentLinkedDesignVersionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppletDeploymentLinkedDesignVersionPrependInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "applet.deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionSetInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
  deployment_id?: Maybe<Scalars['uuid']>;
  design_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "applet_deployment_linked_design_version" */
export type AppletDeploymentLinkedDesignVersionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletDeploymentLinkedDesignVersionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletDeploymentLinkedDesignVersionStreamCursorValueInput = {
  /** The required configuration / context for this applet design version to be deployed */
  config?: Maybe<Scalars['jsonb']>;
  deployment_id?: Maybe<Scalars['uuid']>;
  design_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "applet.deployment_linked_design_version" */
export enum AppletDeploymentLinkedDesignVersionUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  DeploymentId = 'deployment_id',
  /** column name */
  DesignVersionId = 'design_version_id',
  /** column name */
  Id = 'id'
}

export type AppletDeploymentLinkedDesignVersionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<AppletDeploymentLinkedDesignVersionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<AppletDeploymentLinkedDesignVersionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<AppletDeploymentLinkedDesignVersionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<AppletDeploymentLinkedDesignVersionDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<AppletDeploymentLinkedDesignVersionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletDeploymentLinkedDesignVersionSetInput>;
  /** filter the rows which have to be updated */
  where: AppletDeploymentLinkedDesignVersionBoolExp;
};

/** aggregate max on columns */
export type AppletDeploymentMaxFields = {
  __typename?: 'applet_deployment_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "applet.deployment" */
export type AppletDeploymentMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  notes?: Maybe<OrderBy>;
  runner_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AppletDeploymentMinFields = {
  __typename?: 'applet_deployment_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "applet.deployment" */
export type AppletDeploymentMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  notes?: Maybe<OrderBy>;
  runner_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version?: Maybe<OrderBy>;
};

/** response of any mutation on the table "applet.deployment" */
export type AppletDeploymentMutationResponse = {
  __typename?: 'applet_deployment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletDeployment>;
};

/** input type for inserting object relation for remote table "applet.deployment" */
export type AppletDeploymentObjRelInsertInput = {
  data: AppletDeploymentInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<AppletDeploymentOnConflict>;
};

/** on_conflict condition type for table "applet.deployment" */
export type AppletDeploymentOnConflict = {
  constraint: AppletDeploymentConstraint;
  update_columns?: Array<AppletDeploymentUpdateColumn>;
  where?: Maybe<AppletDeploymentBoolExp>;
};

/** Ordering options when selecting data from "applet.deployment". */
export type AppletDeploymentOrderBy = {
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  linked_design_versions_aggregate?: Maybe<AppletDeploymentLinkedDesignVersionAggregateOrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  notes?: Maybe<OrderBy>;
  runner?: Maybe<AppletRunnerOrderBy>;
  runner_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.deployment */
export type AppletDeploymentPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppletDeploymentPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Notes = 'notes',
  /** column name */
  RunnerId = 'runner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Version = 'version'
}

/** select "applet_deployment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "applet_deployment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "applet.deployment" */
export enum AppletDeploymentSelectColumnAppletDeploymentAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "applet.deployment" */
export type AppletDeploymentSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type AppletDeploymentStddevFields = {
  __typename?: 'applet_deployment_stddev_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applet.deployment" */
export type AppletDeploymentStddevOrderBy = {
  version?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AppletDeploymentStddevPopFields = {
  __typename?: 'applet_deployment_stddev_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applet.deployment" */
export type AppletDeploymentStddevPopOrderBy = {
  version?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AppletDeploymentStddevSampFields = {
  __typename?: 'applet_deployment_stddev_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applet.deployment" */
export type AppletDeploymentStddevSampOrderBy = {
  version?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "applet_deployment" */
export type AppletDeploymentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletDeploymentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletDeploymentStreamCursorValueInput = {
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type AppletDeploymentSumFields = {
  __typename?: 'applet_deployment_sum_fields';
  version?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "applet.deployment" */
export type AppletDeploymentSumOrderBy = {
  version?: Maybe<OrderBy>;
};

/** update columns of table "applet.deployment" */
export enum AppletDeploymentUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Notes = 'notes',
  /** column name */
  RunnerId = 'runner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Version = 'version'
}

export type AppletDeploymentUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<AppletDeploymentAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<AppletDeploymentDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<AppletDeploymentDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<AppletDeploymentDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<AppletDeploymentIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<AppletDeploymentPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletDeploymentSetInput>;
  /** filter the rows which have to be updated */
  where: AppletDeploymentBoolExp;
};

/** aggregate var_pop on columns */
export type AppletDeploymentVarPopFields = {
  __typename?: 'applet_deployment_var_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applet.deployment" */
export type AppletDeploymentVarPopOrderBy = {
  version?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AppletDeploymentVarSampFields = {
  __typename?: 'applet_deployment_var_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applet.deployment" */
export type AppletDeploymentVarSampOrderBy = {
  version?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AppletDeploymentVarianceFields = {
  __typename?: 'applet_deployment_variance_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applet.deployment" */
export type AppletDeploymentVarianceOrderBy = {
  version?: Maybe<OrderBy>;
};

/** A definition for an applet. Specifics are defined in the design version. */
export type AppletDesign = {
  __typename?: 'applet_design';
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  /** An array relationship */
  design_versions: Array<AppletDesignVersion>;
  /** An aggregate relationship */
  design_versions_aggregate: AppletDesignVersionAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
};


/** A definition for an applet. Specifics are defined in the design version. */
export type AppletDesignDesignVersionsArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


/** A definition for an applet. Specifics are defined in the design version. */
export type AppletDesignDesignVersionsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};

/** aggregated selection of "applet.design" */
export type AppletDesignAggregate = {
  __typename?: 'applet_design_aggregate';
  aggregate?: Maybe<AppletDesignAggregateFields>;
  nodes: Array<AppletDesign>;
};

/** aggregate fields of "applet.design" */
export type AppletDesignAggregateFields = {
  __typename?: 'applet_design_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AppletDesignMaxFields>;
  min?: Maybe<AppletDesignMinFields>;
};


/** aggregate fields of "applet.design" */
export type AppletDesignAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletDesignSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "applet.design". All fields are combined with a logical 'AND'. */
export type AppletDesignBoolExp = {
  _and?: Maybe<Array<AppletDesignBoolExp>>;
  _not?: Maybe<AppletDesignBoolExp>;
  _or?: Maybe<Array<AppletDesignBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  design_versions?: Maybe<AppletDesignVersionBoolExp>;
  design_versions_aggregate?: Maybe<AppletDesignVersionAggregateBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "applet.design" */
export enum AppletDesignConstraint {
  /** unique or primary key constraint on columns "design_id" */
  AppletDesignPkey = 'applet_design_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AppletUniqueName = 'applet_unique_name'
}

/** input type for inserting data into table "applet.design" */
export type AppletDesignInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  design_versions?: Maybe<AppletDesignVersionArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AppletDesignMaxFields = {
  __typename?: 'applet_design_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AppletDesignMinFields = {
  __typename?: 'applet_design_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "applet.design" */
export type AppletDesignMutationResponse = {
  __typename?: 'applet_design_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletDesign>;
};

/** input type for inserting object relation for remote table "applet.design" */
export type AppletDesignObjRelInsertInput = {
  data: AppletDesignInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<AppletDesignOnConflict>;
};

/** on_conflict condition type for table "applet.design" */
export type AppletDesignOnConflict = {
  constraint: AppletDesignConstraint;
  update_columns?: Array<AppletDesignUpdateColumn>;
  where?: Maybe<AppletDesignBoolExp>;
};

/** Ordering options when selecting data from "applet.design". */
export type AppletDesignOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  design_versions_aggregate?: Maybe<AppletDesignVersionAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.design */
export type AppletDesignPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "applet.design" */
export enum AppletDesignSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique'
}

/** input type for updating data in table "applet.design" */
export type AppletDesignSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "applet_design" */
export type AppletDesignStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletDesignStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletDesignStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
};

/** update columns of table "applet.design" */
export enum AppletDesignUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique'
}

export type AppletDesignUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletDesignSetInput>;
  /** filter the rows which have to be updated */
  where: AppletDesignBoolExp;
};

/** A version of an applet design */
export type AppletDesignVersion = {
  __typename?: 'applet_design_version';
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  approved_by?: Maybe<ArgoUser>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the applet design */
  config: Scalars['jsonb'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  design: AppletDesign;
  design_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  linked_deployments: Array<AppletDeploymentLinkedDesignVersion>;
  /** An aggregate relationship */
  linked_deployments_aggregate: AppletDeploymentLinkedDesignVersionAggregate;
  /** Note or comments about the version. Can be changed at any time */
  notes: Scalars['String'];
  /** An object relationship */
  previous_design_version?: Maybe<AppletDesignVersion>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  status: AppletDesignVersionStatusEnum;
  /** An object relationship */
  status_enum: AppletDesignVersionStatus;
  /** An array relationship */
  successors: Array<AppletDesignVersion>;
  /** An aggregate relationship */
  successors_aggregate: AppletDesignVersionAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};


/** A version of an applet design */
export type AppletDesignVersionConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A version of an applet design */
export type AppletDesignVersionLinkedDeploymentsArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


/** A version of an applet design */
export type AppletDesignVersionLinkedDeploymentsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


/** A version of an applet design */
export type AppletDesignVersionSuccessorsArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


/** A version of an applet design */
export type AppletDesignVersionSuccessorsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};

/** aggregated selection of "applet.design_version" */
export type AppletDesignVersionAggregate = {
  __typename?: 'applet_design_version_aggregate';
  aggregate?: Maybe<AppletDesignVersionAggregateFields>;
  nodes: Array<AppletDesignVersion>;
};

export type AppletDesignVersionAggregateBoolExp = {
  count?: Maybe<AppletDesignVersionAggregateBoolExpCount>;
};

export type AppletDesignVersionAggregateBoolExpCount = {
  arguments?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletDesignVersionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applet.design_version" */
export type AppletDesignVersionAggregateFields = {
  __typename?: 'applet_design_version_aggregate_fields';
  avg?: Maybe<AppletDesignVersionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppletDesignVersionMaxFields>;
  min?: Maybe<AppletDesignVersionMinFields>;
  stddev?: Maybe<AppletDesignVersionStddevFields>;
  stddev_pop?: Maybe<AppletDesignVersionStddevPopFields>;
  stddev_samp?: Maybe<AppletDesignVersionStddevSampFields>;
  sum?: Maybe<AppletDesignVersionSumFields>;
  var_pop?: Maybe<AppletDesignVersionVarPopFields>;
  var_samp?: Maybe<AppletDesignVersionVarSampFields>;
  variance?: Maybe<AppletDesignVersionVarianceFields>;
};


/** aggregate fields of "applet.design_version" */
export type AppletDesignVersionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applet.design_version" */
export type AppletDesignVersionAggregateOrderBy = {
  avg?: Maybe<AppletDesignVersionAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AppletDesignVersionMaxOrderBy>;
  min?: Maybe<AppletDesignVersionMinOrderBy>;
  stddev?: Maybe<AppletDesignVersionStddevOrderBy>;
  stddev_pop?: Maybe<AppletDesignVersionStddevPopOrderBy>;
  stddev_samp?: Maybe<AppletDesignVersionStddevSampOrderBy>;
  sum?: Maybe<AppletDesignVersionSumOrderBy>;
  var_pop?: Maybe<AppletDesignVersionVarPopOrderBy>;
  var_samp?: Maybe<AppletDesignVersionVarSampOrderBy>;
  variance?: Maybe<AppletDesignVersionVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppletDesignVersionAppendInput = {
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "applet.design_version" */
export type AppletDesignVersionArrRelInsertInput = {
  data: Array<AppletDesignVersionInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<AppletDesignVersionOnConflict>;
};

/** aggregate avg on columns */
export type AppletDesignVersionAvgFields = {
  __typename?: 'applet_design_version_avg_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applet.design_version" */
export type AppletDesignVersionAvgOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applet.design_version". All fields are combined with a logical 'AND'. */
export type AppletDesignVersionBoolExp = {
  _and?: Maybe<Array<AppletDesignVersionBoolExp>>;
  _not?: Maybe<AppletDesignVersionBoolExp>;
  _or?: Maybe<Array<AppletDesignVersionBoolExp>>;
  approved_at?: Maybe<TimestamptzComparisonExp>;
  approved_by?: Maybe<ArgoUserBoolExp>;
  approved_by_id?: Maybe<UuidComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  design?: Maybe<AppletDesignBoolExp>;
  design_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  linked_deployments?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
  linked_deployments_aggregate?: Maybe<AppletDeploymentLinkedDesignVersionAggregateBoolExp>;
  notes?: Maybe<StringComparisonExp>;
  previous_design_version?: Maybe<AppletDesignVersionBoolExp>;
  previous_design_version_id?: Maybe<UuidComparisonExp>;
  status?: Maybe<AppletDesignVersionStatusEnumComparisonExp>;
  status_enum?: Maybe<AppletDesignVersionStatusBoolExp>;
  successors?: Maybe<AppletDesignVersionBoolExp>;
  successors_aggregate?: Maybe<AppletDesignVersionAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  version_number?: Maybe<SmallintComparisonExp>;
};

/** unique or primary key constraints on table "applet.design_version" */
export enum AppletDesignVersionConstraint {
  /** unique or primary key constraint on columns "design_version_id" */
  AppletDesignVersionPkey = 'applet_design_version_pkey',
  /** unique or primary key constraint on columns "version_number", "design_id" */
  AppletDesignVersionUniqueVersionNumber = 'applet_design_version_unique_version_number'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppletDesignVersionDeleteAtPathInput = {
  /** The blueprint for this version of the applet design */
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppletDesignVersionDeleteElemInput = {
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppletDesignVersionDeleteKeyInput = {
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "applet.design_version" */
export type AppletDesignVersionIncInput = {
  version_number?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "applet.design_version" */
export type AppletDesignVersionInsertInput = {
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  design?: Maybe<AppletDesignObjRelInsertInput>;
  design_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  linked_deployments?: Maybe<AppletDeploymentLinkedDesignVersionArrRelInsertInput>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<Scalars['String']>;
  previous_design_version?: Maybe<AppletDesignVersionObjRelInsertInput>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<AppletDesignVersionStatusEnum>;
  status_enum?: Maybe<AppletDesignVersionStatusObjRelInsertInput>;
  successors?: Maybe<AppletDesignVersionArrRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type AppletDesignVersionMaxFields = {
  __typename?: 'applet_design_version_max_fields';
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  design_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<Scalars['String']>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "applet.design_version" */
export type AppletDesignVersionMaxOrderBy = {
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<OrderBy>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  design_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<OrderBy>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AppletDesignVersionMinFields = {
  __typename?: 'applet_design_version_min_fields';
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  design_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<Scalars['String']>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "applet.design_version" */
export type AppletDesignVersionMinOrderBy = {
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<OrderBy>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  design_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<OrderBy>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** response of any mutation on the table "applet.design_version" */
export type AppletDesignVersionMutationResponse = {
  __typename?: 'applet_design_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletDesignVersion>;
};

/** input type for inserting object relation for remote table "applet.design_version" */
export type AppletDesignVersionObjRelInsertInput = {
  data: AppletDesignVersionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<AppletDesignVersionOnConflict>;
};

/** on_conflict condition type for table "applet.design_version" */
export type AppletDesignVersionOnConflict = {
  constraint: AppletDesignVersionConstraint;
  update_columns?: Array<AppletDesignVersionUpdateColumn>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};

/** Ordering options when selecting data from "applet.design_version". */
export type AppletDesignVersionOrderBy = {
  approved_at?: Maybe<OrderBy>;
  approved_by?: Maybe<ArgoUserOrderBy>;
  approved_by_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  design?: Maybe<AppletDesignOrderBy>;
  design_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  linked_deployments_aggregate?: Maybe<AppletDeploymentLinkedDesignVersionAggregateOrderBy>;
  notes?: Maybe<OrderBy>;
  previous_design_version?: Maybe<AppletDesignVersionOrderBy>;
  previous_design_version_id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_enum?: Maybe<AppletDesignVersionStatusOrderBy>;
  successors_aggregate?: Maybe<AppletDesignVersionAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.design_version */
export type AppletDesignVersionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppletDesignVersionPrependInput = {
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "applet.design_version" */
export enum AppletDesignVersionSelectColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DesignId = 'design_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PreviousDesignVersionId = 'previous_design_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

/** input type for updating data in table "applet.design_version" */
export type AppletDesignVersionSetInput = {
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  design_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<Scalars['String']>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<AppletDesignVersionStatusEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** Status enum for applet design versions */
export type AppletDesignVersionStatus = {
  __typename?: 'applet_design_version_status';
  text: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "applet.design_version_status" */
export type AppletDesignVersionStatusAggregate = {
  __typename?: 'applet_design_version_status_aggregate';
  aggregate?: Maybe<AppletDesignVersionStatusAggregateFields>;
  nodes: Array<AppletDesignVersionStatus>;
};

/** aggregate fields of "applet.design_version_status" */
export type AppletDesignVersionStatusAggregateFields = {
  __typename?: 'applet_design_version_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AppletDesignVersionStatusMaxFields>;
  min?: Maybe<AppletDesignVersionStatusMinFields>;
};


/** aggregate fields of "applet.design_version_status" */
export type AppletDesignVersionStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletDesignVersionStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "applet.design_version_status". All fields are combined with a logical 'AND'. */
export type AppletDesignVersionStatusBoolExp = {
  _and?: Maybe<Array<AppletDesignVersionStatusBoolExp>>;
  _not?: Maybe<AppletDesignVersionStatusBoolExp>;
  _or?: Maybe<Array<AppletDesignVersionStatusBoolExp>>;
  text?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "applet.design_version_status" */
export enum AppletDesignVersionStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  AppletDesignVersionStatusPkey = 'applet_design_version_status_pkey'
}

export enum AppletDesignVersionStatusEnum {
  Approved = 'approved',
  Retired = 'retired',
  Staged = 'staged',
  Submitted = 'submitted'
}

/** Boolean expression to compare columns of type "applet_design_version_status_enum". All fields are combined with logical 'AND'. */
export type AppletDesignVersionStatusEnumComparisonExp = {
  _eq?: Maybe<AppletDesignVersionStatusEnum>;
  _in?: Maybe<Array<AppletDesignVersionStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<AppletDesignVersionStatusEnum>;
  _nin?: Maybe<Array<AppletDesignVersionStatusEnum>>;
};

/** input type for inserting data into table "applet.design_version_status" */
export type AppletDesignVersionStatusInsertInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AppletDesignVersionStatusMaxFields = {
  __typename?: 'applet_design_version_status_max_fields';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AppletDesignVersionStatusMinFields = {
  __typename?: 'applet_design_version_status_min_fields';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "applet.design_version_status" */
export type AppletDesignVersionStatusMutationResponse = {
  __typename?: 'applet_design_version_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletDesignVersionStatus>;
};

/** input type for inserting object relation for remote table "applet.design_version_status" */
export type AppletDesignVersionStatusObjRelInsertInput = {
  data: AppletDesignVersionStatusInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<AppletDesignVersionStatusOnConflict>;
};

/** on_conflict condition type for table "applet.design_version_status" */
export type AppletDesignVersionStatusOnConflict = {
  constraint: AppletDesignVersionStatusConstraint;
  update_columns?: Array<AppletDesignVersionStatusUpdateColumn>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};

/** Ordering options when selecting data from "applet.design_version_status". */
export type AppletDesignVersionStatusOrderBy = {
  text?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.design_version_status */
export type AppletDesignVersionStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "applet.design_version_status" */
export enum AppletDesignVersionStatusSelectColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "applet.design_version_status" */
export type AppletDesignVersionStatusSetInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "applet_design_version_status" */
export type AppletDesignVersionStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletDesignVersionStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletDesignVersionStatusStreamCursorValueInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "applet.design_version_status" */
export enum AppletDesignVersionStatusUpdateColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

export type AppletDesignVersionStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletDesignVersionStatusSetInput>;
  /** filter the rows which have to be updated */
  where: AppletDesignVersionStatusBoolExp;
};

/** aggregate stddev on columns */
export type AppletDesignVersionStddevFields = {
  __typename?: 'applet_design_version_stddev_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applet.design_version" */
export type AppletDesignVersionStddevOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AppletDesignVersionStddevPopFields = {
  __typename?: 'applet_design_version_stddev_pop_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applet.design_version" */
export type AppletDesignVersionStddevPopOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AppletDesignVersionStddevSampFields = {
  __typename?: 'applet_design_version_stddev_samp_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applet.design_version" */
export type AppletDesignVersionStddevSampOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "applet_design_version" */
export type AppletDesignVersionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletDesignVersionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletDesignVersionStreamCursorValueInput = {
  /** When the applet version was approved. Set automatically by trigger fn */
  approved_at?: Maybe<Scalars['timestamptz']>;
  /** The user that approved this version (if any) */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the applet design */
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  design_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Note or comments about the version. Can be changed at any time */
  notes?: Maybe<Scalars['String']>;
  /** The version this was forked or copied from (if any) */
  previous_design_version_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<AppletDesignVersionStatusEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type AppletDesignVersionSumFields = {
  __typename?: 'applet_design_version_sum_fields';
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "applet.design_version" */
export type AppletDesignVersionSumOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** update columns of table "applet.design_version" */
export enum AppletDesignVersionUpdateColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DesignId = 'design_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PreviousDesignVersionId = 'previous_design_version_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

export type AppletDesignVersionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<AppletDesignVersionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<AppletDesignVersionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<AppletDesignVersionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<AppletDesignVersionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<AppletDesignVersionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<AppletDesignVersionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletDesignVersionSetInput>;
  /** filter the rows which have to be updated */
  where: AppletDesignVersionBoolExp;
};

/** aggregate var_pop on columns */
export type AppletDesignVersionVarPopFields = {
  __typename?: 'applet_design_version_var_pop_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applet.design_version" */
export type AppletDesignVersionVarPopOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AppletDesignVersionVarSampFields = {
  __typename?: 'applet_design_version_var_samp_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applet.design_version" */
export type AppletDesignVersionVarSampOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AppletDesignVersionVarianceFields = {
  __typename?: 'applet_design_version_variance_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applet.design_version" */
export type AppletDesignVersionVarianceOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** Registration codes used to connect a runner to a context */
export type AppletRegistrationCode = {
  __typename?: 'applet_registration_code';
  code: Scalars['String'];
  context_id: Scalars['uuid'];
  created_at: Scalars['bigint'];
  created_by_id: Scalars['uuid'];
};

/** aggregated selection of "applet.registration_code" */
export type AppletRegistrationCodeAggregate = {
  __typename?: 'applet_registration_code_aggregate';
  aggregate?: Maybe<AppletRegistrationCodeAggregateFields>;
  nodes: Array<AppletRegistrationCode>;
};

/** aggregate fields of "applet.registration_code" */
export type AppletRegistrationCodeAggregateFields = {
  __typename?: 'applet_registration_code_aggregate_fields';
  avg?: Maybe<AppletRegistrationCodeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppletRegistrationCodeMaxFields>;
  min?: Maybe<AppletRegistrationCodeMinFields>;
  stddev?: Maybe<AppletRegistrationCodeStddevFields>;
  stddev_pop?: Maybe<AppletRegistrationCodeStddevPopFields>;
  stddev_samp?: Maybe<AppletRegistrationCodeStddevSampFields>;
  sum?: Maybe<AppletRegistrationCodeSumFields>;
  var_pop?: Maybe<AppletRegistrationCodeVarPopFields>;
  var_samp?: Maybe<AppletRegistrationCodeVarSampFields>;
  variance?: Maybe<AppletRegistrationCodeVarianceFields>;
};


/** aggregate fields of "applet.registration_code" */
export type AppletRegistrationCodeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletRegistrationCodeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AppletRegistrationCodeAvgFields = {
  __typename?: 'applet_registration_code_avg_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "applet.registration_code". All fields are combined with a logical 'AND'. */
export type AppletRegistrationCodeBoolExp = {
  _and?: Maybe<Array<AppletRegistrationCodeBoolExp>>;
  _not?: Maybe<AppletRegistrationCodeBoolExp>;
  _or?: Maybe<Array<AppletRegistrationCodeBoolExp>>;
  code?: Maybe<StringComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<BigintComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "applet.registration_code" */
export enum AppletRegistrationCodeConstraint {
  /** unique or primary key constraint on columns "context_id", "created_by_id" */
  RegistrationCodePkey = 'registration_code_pkey'
}

/** input type for incrementing numeric columns in table "applet.registration_code" */
export type AppletRegistrationCodeIncInput = {
  created_at?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "applet.registration_code" */
export type AppletRegistrationCodeInsertInput = {
  code?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['bigint']>;
  created_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AppletRegistrationCodeMaxFields = {
  __typename?: 'applet_registration_code_max_fields';
  code?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['bigint']>;
  created_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type AppletRegistrationCodeMinFields = {
  __typename?: 'applet_registration_code_min_fields';
  code?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['bigint']>;
  created_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "applet.registration_code" */
export type AppletRegistrationCodeMutationResponse = {
  __typename?: 'applet_registration_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletRegistrationCode>;
};

/** on_conflict condition type for table "applet.registration_code" */
export type AppletRegistrationCodeOnConflict = {
  constraint: AppletRegistrationCodeConstraint;
  update_columns?: Array<AppletRegistrationCodeUpdateColumn>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};

/** Ordering options when selecting data from "applet.registration_code". */
export type AppletRegistrationCodeOrderBy = {
  code?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.registration_code */
export type AppletRegistrationCodePkColumnsInput = {
  context_id: Scalars['uuid'];
  created_by_id: Scalars['uuid'];
};

/** select columns of table "applet.registration_code" */
export enum AppletRegistrationCodeSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id'
}

/** input type for updating data in table "applet.registration_code" */
export type AppletRegistrationCodeSetInput = {
  code?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['bigint']>;
  created_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AppletRegistrationCodeStddevFields = {
  __typename?: 'applet_registration_code_stddev_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AppletRegistrationCodeStddevPopFields = {
  __typename?: 'applet_registration_code_stddev_pop_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AppletRegistrationCodeStddevSampFields = {
  __typename?: 'applet_registration_code_stddev_samp_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "applet_registration_code" */
export type AppletRegistrationCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletRegistrationCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletRegistrationCodeStreamCursorValueInput = {
  code?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['bigint']>;
  created_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AppletRegistrationCodeSumFields = {
  __typename?: 'applet_registration_code_sum_fields';
  created_at?: Maybe<Scalars['bigint']>;
};

/** update columns of table "applet.registration_code" */
export enum AppletRegistrationCodeUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id'
}

export type AppletRegistrationCodeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<AppletRegistrationCodeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletRegistrationCodeSetInput>;
  /** filter the rows which have to be updated */
  where: AppletRegistrationCodeBoolExp;
};

/** aggregate var_pop on columns */
export type AppletRegistrationCodeVarPopFields = {
  __typename?: 'applet_registration_code_var_pop_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AppletRegistrationCodeVarSampFields = {
  __typename?: 'applet_registration_code_var_samp_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AppletRegistrationCodeVarianceFields = {
  __typename?: 'applet_registration_code_variance_fields';
  created_at?: Maybe<Scalars['Float']>;
};

/** A service that is ultimately responsible for applet execution */
export type AppletRunner = {
  __typename?: 'applet_runner';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  deployments: Array<AppletDeployment>;
  /** An aggregate relationship */
  deployments_aggregate: AppletDeploymentAggregate;
  enabled: Scalars['Boolean'];
  health_runner: Scalars['applet_runner_health'];
  health_runtimes: Scalars['applet_runtimes_health'];
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id: Scalars['String'];
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  notes: Scalars['String'];
  /** An array relationship */
  runner_contexts: Array<AppletRunnerContext>;
  /** An aggregate relationship */
  runner_contexts_aggregate: AppletRunnerContextAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerDeploymentsArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerDeploymentsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerHealthRunnerArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerHealthRuntimesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerRunnerContextsArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


/** A service that is ultimately responsible for applet execution */
export type AppletRunnerRunnerContextsAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};

/** aggregated selection of "applet.runner" */
export type AppletRunnerAggregate = {
  __typename?: 'applet_runner_aggregate';
  aggregate?: Maybe<AppletRunnerAggregateFields>;
  nodes: Array<AppletRunner>;
};

/** aggregate fields of "applet.runner" */
export type AppletRunnerAggregateFields = {
  __typename?: 'applet_runner_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AppletRunnerMaxFields>;
  min?: Maybe<AppletRunnerMinFields>;
};


/** aggregate fields of "applet.runner" */
export type AppletRunnerAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletRunnerSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppletRunnerAppendInput = {
  health_runner?: Maybe<Scalars['applet_runner_health']>;
  health_runtimes?: Maybe<Scalars['applet_runtimes_health']>;
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "applet.runner". All fields are combined with a logical 'AND'. */
export type AppletRunnerBoolExp = {
  _and?: Maybe<Array<AppletRunnerBoolExp>>;
  _not?: Maybe<AppletRunnerBoolExp>;
  _or?: Maybe<Array<AppletRunnerBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  deployments?: Maybe<AppletDeploymentBoolExp>;
  deployments_aggregate?: Maybe<AppletDeploymentAggregateBoolExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  health_runner?: Maybe<JsonbComparisonExp>;
  health_runtimes?: Maybe<JsonbComparisonExp>;
  id?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  notes?: Maybe<StringComparisonExp>;
  runner_contexts?: Maybe<AppletRunnerContextBoolExp>;
  runner_contexts_aggregate?: Maybe<AppletRunnerContextAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "applet.runner" */
export enum AppletRunnerConstraint {
  /** unique or primary key constraint on columns "runner_id" */
  AppletRunnerPkey = 'applet_runner_pkey'
}

/** Link table bewteen Runners and a context. */
export type AppletRunnerContext = {
  __typename?: 'applet_runner_context';
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  runner: AppletRunner;
  runner_id: Scalars['String'];
};

/** aggregated selection of "applet.runner_context" */
export type AppletRunnerContextAggregate = {
  __typename?: 'applet_runner_context_aggregate';
  aggregate?: Maybe<AppletRunnerContextAggregateFields>;
  nodes: Array<AppletRunnerContext>;
};

export type AppletRunnerContextAggregateBoolExp = {
  count?: Maybe<AppletRunnerContextAggregateBoolExpCount>;
};

export type AppletRunnerContextAggregateBoolExpCount = {
  arguments?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AppletRunnerContextBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applet.runner_context" */
export type AppletRunnerContextAggregateFields = {
  __typename?: 'applet_runner_context_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AppletRunnerContextMaxFields>;
  min?: Maybe<AppletRunnerContextMinFields>;
};


/** aggregate fields of "applet.runner_context" */
export type AppletRunnerContextAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applet.runner_context" */
export type AppletRunnerContextAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<AppletRunnerContextMaxOrderBy>;
  min?: Maybe<AppletRunnerContextMinOrderBy>;
};

/** input type for inserting array relation for remote table "applet.runner_context" */
export type AppletRunnerContextArrRelInsertInput = {
  data: Array<AppletRunnerContextInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<AppletRunnerContextOnConflict>;
};

/** Boolean expression to filter rows from the table "applet.runner_context". All fields are combined with a logical 'AND'. */
export type AppletRunnerContextBoolExp = {
  _and?: Maybe<Array<AppletRunnerContextBoolExp>>;
  _not?: Maybe<AppletRunnerContextBoolExp>;
  _or?: Maybe<Array<AppletRunnerContextBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  runner?: Maybe<AppletRunnerBoolExp>;
  runner_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "applet.runner_context" */
export enum AppletRunnerContextConstraint {
  /** unique or primary key constraint on columns "runner_context_id" */
  AppletRunnerContextPkey = 'applet_runner_context_pkey',
  /** unique or primary key constraint on columns "context_id", "runner_id" */
  AppletUniqueRunnerContext = 'applet_unique_runner_context'
}

/** input type for inserting data into table "applet.runner_context" */
export type AppletRunnerContextInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  runner?: Maybe<AppletRunnerObjRelInsertInput>;
  runner_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AppletRunnerContextMaxFields = {
  __typename?: 'applet_runner_context_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  runner_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "applet.runner_context" */
export type AppletRunnerContextMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  runner_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AppletRunnerContextMinFields = {
  __typename?: 'applet_runner_context_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  runner_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "applet.runner_context" */
export type AppletRunnerContextMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  runner_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "applet.runner_context" */
export type AppletRunnerContextMutationResponse = {
  __typename?: 'applet_runner_context_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletRunnerContext>;
};

/** on_conflict condition type for table "applet.runner_context" */
export type AppletRunnerContextOnConflict = {
  constraint: AppletRunnerContextConstraint;
  update_columns?: Array<AppletRunnerContextUpdateColumn>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};

/** Ordering options when selecting data from "applet.runner_context". */
export type AppletRunnerContextOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  runner?: Maybe<AppletRunnerOrderBy>;
  runner_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.runner_context */
export type AppletRunnerContextPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "applet.runner_context" */
export enum AppletRunnerContextSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RunnerId = 'runner_id'
}

/** input type for updating data in table "applet.runner_context" */
export type AppletRunnerContextSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  runner_id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "applet_runner_context" */
export type AppletRunnerContextStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletRunnerContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletRunnerContextStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  runner_id?: Maybe<Scalars['String']>;
};

/** update columns of table "applet.runner_context" */
export enum AppletRunnerContextUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RunnerId = 'runner_id'
}

export type AppletRunnerContextUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletRunnerContextSetInput>;
  /** filter the rows which have to be updated */
  where: AppletRunnerContextBoolExp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppletRunnerDeleteAtPathInput = {
  health_runner?: Maybe<Array<Scalars['String']>>;
  health_runtimes?: Maybe<Array<Scalars['String']>>;
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppletRunnerDeleteElemInput = {
  health_runner?: Maybe<Scalars['Int']>;
  health_runtimes?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppletRunnerDeleteKeyInput = {
  health_runner?: Maybe<Scalars['String']>;
  health_runtimes?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
};


/** input type for inserting data into table "applet.runner" */
export type AppletRunnerInsertInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deployments?: Maybe<AppletDeploymentArrRelInsertInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  health_runner?: Maybe<Scalars['jsonb']>;
  health_runtimes?: Maybe<Scalars['jsonb']>;
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  runner_contexts?: Maybe<AppletRunnerContextArrRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppletRunnerMaxFields = {
  __typename?: 'applet_runner_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AppletRunnerMinFields = {
  __typename?: 'applet_runner_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "applet.runner" */
export type AppletRunnerMutationResponse = {
  __typename?: 'applet_runner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppletRunner>;
};

/** input type for inserting object relation for remote table "applet.runner" */
export type AppletRunnerObjRelInsertInput = {
  data: AppletRunnerInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<AppletRunnerOnConflict>;
};

/** on_conflict condition type for table "applet.runner" */
export type AppletRunnerOnConflict = {
  constraint: AppletRunnerConstraint;
  update_columns?: Array<AppletRunnerUpdateColumn>;
  where?: Maybe<AppletRunnerBoolExp>;
};

/** Ordering options when selecting data from "applet.runner". */
export type AppletRunnerOrderBy = {
  created_at?: Maybe<OrderBy>;
  deployments_aggregate?: Maybe<AppletDeploymentAggregateOrderBy>;
  enabled?: Maybe<OrderBy>;
  health_runner?: Maybe<OrderBy>;
  health_runtimes?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  notes?: Maybe<OrderBy>;
  runner_contexts_aggregate?: Maybe<AppletRunnerContextAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
};

/** primary key columns input for table: applet.runner */
export type AppletRunnerPkColumnsInput = {
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppletRunnerPrependInput = {
  health_runner?: Maybe<Scalars['jsonb']>;
  health_runtimes?: Maybe<Scalars['jsonb']>;
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "applet.runner" */
export enum AppletRunnerSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HealthRunner = 'health_runner',
  /** column name */
  HealthRuntimes = 'health_runtimes',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "applet.runner" */
export type AppletRunnerSetInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  enabled?: Maybe<Scalars['Boolean']>;
  health_runner?: Maybe<Scalars['applet_runner_health']>;
  health_runtimes?: Maybe<Scalars['applet_runtimes_health']>;
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "applet_runner" */
export type AppletRunnerStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AppletRunnerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppletRunnerStreamCursorValueInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  enabled?: Maybe<Scalars['Boolean']>;
  health_runner?: Maybe<Scalars['jsonb']>;
  health_runtimes?: Maybe<Scalars['jsonb']>;
  /** The id of the runner, following the DNS label standard (RFC 1035). This is done in case it must be used in k8s. */
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "applet.runner" */
export enum AppletRunnerUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HealthRunner = 'health_runner',
  /** column name */
  HealthRuntimes = 'health_runtimes',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type AppletRunnerUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<AppletRunnerAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<AppletRunnerDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<AppletRunnerDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<AppletRunnerDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<AppletRunnerPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AppletRunnerSetInput>;
  /** filter the rows which have to be updated */
  where: AppletRunnerBoolExp;
};


/** Argonaut Access Control Lists enable or disable access to exposed tables through the permission system */
export type ArgoAcl = {
  __typename?: 'argo_acl';
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** A longer description than the display name */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** The ACL identifier used in permissions */
  id: Scalars['String'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An array relationship */
  role_acls: Array<ArgoRoleAcl>;
  /** An aggregate relationship */
  role_acls_aggregate: ArgoRoleAclAggregate;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<ArgoUser>;
};


/** Argonaut Access Control Lists enable or disable access to exposed tables through the permission system */
export type ArgoAclMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Argonaut Access Control Lists enable or disable access to exposed tables through the permission system */
export type ArgoAclRoleAclsArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


/** Argonaut Access Control Lists enable or disable access to exposed tables through the permission system */
export type ArgoAclRoleAclsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};

/** aggregated selection of "argo.acl" */
export type ArgoAclAggregate = {
  __typename?: 'argo_acl_aggregate';
  aggregate?: Maybe<ArgoAclAggregateFields>;
  nodes: Array<ArgoAcl>;
};

/** aggregate fields of "argo.acl" */
export type ArgoAclAggregateFields = {
  __typename?: 'argo_acl_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAclMaxFields>;
  min?: Maybe<ArgoAclMinFields>;
};


/** aggregate fields of "argo.acl" */
export type ArgoAclAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAclAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.acl". All fields are combined with a logical 'AND'. */
export type ArgoAclBoolExp = {
  _and?: Maybe<Array<ArgoAclBoolExp>>;
  _not?: Maybe<ArgoAclBoolExp>;
  _or?: Maybe<Array<ArgoAclBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  role_acls?: Maybe<ArgoRoleAclBoolExp>;
  role_acls_aggregate?: Maybe<ArgoRoleAclAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
};

/** unique or primary key constraints on table "argo.acl" */
export enum ArgoAclConstraint {
  /** unique or primary key constraint on columns "acl_id" */
  AclPkey = 'acl_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAclDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAclDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAclDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.acl" */
export type ArgoAclInsertInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A longer description than the display name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ACL identifier used in permissions */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  role_acls?: Maybe<ArgoRoleAclArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoAclMaxFields = {
  __typename?: 'argo_acl_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A longer description than the display name */
  description?: Maybe<Scalars['String']>;
  /** The ACL identifier used in permissions */
  id?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoAclMinFields = {
  __typename?: 'argo_acl_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A longer description than the display name */
  description?: Maybe<Scalars['String']>;
  /** The ACL identifier used in permissions */
  id?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.acl" */
export type ArgoAclMutationResponse = {
  __typename?: 'argo_acl_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAcl>;
};

/** input type for inserting object relation for remote table "argo.acl" */
export type ArgoAclObjRelInsertInput = {
  data: ArgoAclInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAclOnConflict>;
};

/** on_conflict condition type for table "argo.acl" */
export type ArgoAclOnConflict = {
  constraint: ArgoAclConstraint;
  update_columns?: Array<ArgoAclUpdateColumn>;
  where?: Maybe<ArgoAclBoolExp>;
};

/** Ordering options when selecting data from "argo.acl". */
export type ArgoAclOrderBy = {
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  role_acls_aggregate?: Maybe<ArgoRoleAclAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
};

/** primary key columns input for table: argo.acl */
export type ArgoAclPkColumnsInput = {
  /** The ACL identifier used in permissions */
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAclPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.acl" */
export enum ArgoAclSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.acl" */
export type ArgoAclSetInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A longer description than the display name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ACL identifier used in permissions */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_acl" */
export type ArgoAclStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAclStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAclStreamCursorValueInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A longer description than the display name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ACL identifier used in permissions */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.acl" */
export enum ArgoAclUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAclUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAclAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAclDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAclDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAclDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAclPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAclSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAclBoolExp;
};

/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttribute = {
  __typename?: 'argo_attribute';
  /** An array relationship */
  attribute_data: Array<ArgoAttributeData>;
  /** An aggregate relationship */
  attribute_data_aggregate: ArgoAttributeDataAggregate;
  /** An object relationship */
  attribute_schema: ArgoAttributeSchema;
  /** The attribute schema this entry links to */
  attribute_schema_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Description of this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  location_attributes: Array<ArgoLocationAttribute>;
  /** An aggregate relationship */
  location_attributes_aggregate: ArgoLocationAttributeAggregate;
  /** An array relationship */
  material_attributes: Array<ArgoMaterialAttribute>;
  /** An aggregate relationship */
  material_attributes_aggregate: ArgoMaterialAttributeAggregate;
  /** An array relationship */
  material_class_attributes: Array<ArgoMaterialClassAttribute>;
  /** An aggregate relationship */
  material_class_attributes_aggregate: ArgoMaterialClassAttributeAggregate;
  /** An array relationship */
  material_model_attributes: Array<ArgoMaterialModelAttribute>;
  /** An aggregate relationship */
  material_model_attributes_aggregate: ArgoMaterialModelAttributeAggregate;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeAttributeDataArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeAttributeDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeLocationAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeLocationAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialClassAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialClassAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialModelAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMaterialModelAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.attribute" */
export type ArgoAttributeAggregate = {
  __typename?: 'argo_attribute_aggregate';
  aggregate?: Maybe<ArgoAttributeAggregateFields>;
  nodes: Array<ArgoAttribute>;
};

export type ArgoAttributeAggregateBoolExp = {
  bool_and?: Maybe<ArgoAttributeAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoAttributeAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoAttributeAggregateBoolExpCount>;
};

export type ArgoAttributeAggregateBoolExpBoolAnd = {
  arguments: ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeAggregateBoolExpBoolOr = {
  arguments: ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.attribute" */
export type ArgoAttributeAggregateFields = {
  __typename?: 'argo_attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeMaxFields>;
  min?: Maybe<ArgoAttributeMinFields>;
};


/** aggregate fields of "argo.attribute" */
export type ArgoAttributeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.attribute" */
export type ArgoAttributeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAttributeMaxOrderBy>;
  min?: Maybe<ArgoAttributeMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.attribute" */
export type ArgoAttributeArrRelInsertInput = {
  data: Array<ArgoAttributeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.attribute". All fields are combined with a logical 'AND'. */
export type ArgoAttributeBoolExp = {
  _and?: Maybe<Array<ArgoAttributeBoolExp>>;
  _not?: Maybe<ArgoAttributeBoolExp>;
  _or?: Maybe<Array<ArgoAttributeBoolExp>>;
  attribute_data?: Maybe<ArgoAttributeDataBoolExp>;
  attribute_data_aggregate?: Maybe<ArgoAttributeDataAggregateBoolExp>;
  attribute_schema?: Maybe<ArgoAttributeSchemaBoolExp>;
  attribute_schema_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location_attributes?: Maybe<ArgoLocationAttributeBoolExp>;
  location_attributes_aggregate?: Maybe<ArgoLocationAttributeAggregateBoolExp>;
  material_attributes?: Maybe<ArgoMaterialAttributeBoolExp>;
  material_attributes_aggregate?: Maybe<ArgoMaterialAttributeAggregateBoolExp>;
  material_class_attributes?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  material_class_attributes_aggregate?: Maybe<ArgoMaterialClassAttributeAggregateBoolExp>;
  material_model_attributes?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  material_model_attributes_aggregate?: Maybe<ArgoMaterialModelAttributeAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  remote_ref_id?: Maybe<StringComparisonExp>;
  root_attribute_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute" */
export enum ArgoAttributeConstraint {
  /** unique or primary key constraint on columns "attribute_id" */
  AttributePkey = 'attribute_pkey',
  /** unique or primary key constraint on columns "context_id", "remote_ref_id" */
  RemoteRefIdUnique = 'remote_ref_id_unique'
}

/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeData = {
  __typename?: 'argo_attribute_data';
  /** An object relationship */
  attribute: ArgoAttribute;
  /** The attribute this entry links to */
  attribute_id: Scalars['uuid'];
  /** An object relationship */
  attribute_schema_definition: ArgoAttributeSchemaDefinition;
  attribute_schema_definition_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  num_val?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "argo.attribute_data_num_as_text" */
  num_val_as_text?: Maybe<Scalars['String']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Attributes that can define custom data/ui to be used in relation to other core topics */
export type ArgoAttributeDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.attribute_data" */
export type ArgoAttributeDataAggregate = {
  __typename?: 'argo_attribute_data_aggregate';
  aggregate?: Maybe<ArgoAttributeDataAggregateFields>;
  nodes: Array<ArgoAttributeData>;
};

export type ArgoAttributeDataAggregateBoolExp = {
  bool_and?: Maybe<ArgoAttributeDataAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoAttributeDataAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoAttributeDataAggregateBoolExpCount>;
};

export type ArgoAttributeDataAggregateBoolExpBoolAnd = {
  arguments: ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeDataBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeDataAggregateBoolExpBoolOr = {
  arguments: ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeDataBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.attribute_data" */
export type ArgoAttributeDataAggregateFields = {
  __typename?: 'argo_attribute_data_aggregate_fields';
  avg?: Maybe<ArgoAttributeDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeDataMaxFields>;
  min?: Maybe<ArgoAttributeDataMinFields>;
  stddev?: Maybe<ArgoAttributeDataStddevFields>;
  stddev_pop?: Maybe<ArgoAttributeDataStddevPopFields>;
  stddev_samp?: Maybe<ArgoAttributeDataStddevSampFields>;
  sum?: Maybe<ArgoAttributeDataSumFields>;
  var_pop?: Maybe<ArgoAttributeDataVarPopFields>;
  var_samp?: Maybe<ArgoAttributeDataVarSampFields>;
  variance?: Maybe<ArgoAttributeDataVarianceFields>;
};


/** aggregate fields of "argo.attribute_data" */
export type ArgoAttributeDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.attribute_data" */
export type ArgoAttributeDataAggregateOrderBy = {
  avg?: Maybe<ArgoAttributeDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAttributeDataMaxOrderBy>;
  min?: Maybe<ArgoAttributeDataMinOrderBy>;
  stddev?: Maybe<ArgoAttributeDataStddevOrderBy>;
  stddev_pop?: Maybe<ArgoAttributeDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoAttributeDataStddevSampOrderBy>;
  sum?: Maybe<ArgoAttributeDataSumOrderBy>;
  var_pop?: Maybe<ArgoAttributeDataVarPopOrderBy>;
  var_samp?: Maybe<ArgoAttributeDataVarSampOrderBy>;
  variance?: Maybe<ArgoAttributeDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.attribute_data" */
export type ArgoAttributeDataArrRelInsertInput = {
  data: Array<ArgoAttributeDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeDataOnConflict>;
};

/** aggregate avg on columns */
export type ArgoAttributeDataAvgFields = {
  __typename?: 'argo_attribute_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.attribute_data". All fields are combined with a logical 'AND'. */
export type ArgoAttributeDataBoolExp = {
  _and?: Maybe<Array<ArgoAttributeDataBoolExp>>;
  _not?: Maybe<ArgoAttributeDataBoolExp>;
  _or?: Maybe<Array<ArgoAttributeDataBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  attribute_schema_definition_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  num_val_as_text?: Maybe<StringComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_data" */
export enum ArgoAttributeDataConstraint {
  /** unique or primary key constraint on columns "attribute_data_id" */
  AttributeDataPkey = 'attribute_data_pkey',
  /** unique or primary key constraint on columns "context_id", "attribute_id", "attribute_schema_definition_id" */
  AttributeDataUnique = 'attribute_data_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAttributeDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAttributeDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAttributeDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.attribute_data" */
export type ArgoAttributeDataIncInput = {
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.attribute_data" */
export type ArgoAttributeDataInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  /** The attribute this entry links to */
  attribute_id?: Maybe<Scalars['uuid']>;
  attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionObjRelInsertInput>;
  attribute_schema_definition_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAttributeDataMaxFields = {
  __typename?: 'argo_attribute_data_max_fields';
  /** The attribute this entry links to */
  attribute_id?: Maybe<Scalars['uuid']>;
  attribute_schema_definition_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "argo.attribute_data_num_as_text" */
  num_val_as_text?: Maybe<Scalars['String']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataMaxOrderBy = {
  /** The attribute this entry links to */
  attribute_id?: Maybe<OrderBy>;
  attribute_schema_definition_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAttributeDataMinFields = {
  __typename?: 'argo_attribute_data_min_fields';
  /** The attribute this entry links to */
  attribute_id?: Maybe<Scalars['uuid']>;
  attribute_schema_definition_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "argo.attribute_data_num_as_text" */
  num_val_as_text?: Maybe<Scalars['String']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataMinOrderBy = {
  /** The attribute this entry links to */
  attribute_id?: Maybe<OrderBy>;
  attribute_schema_definition_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.attribute_data" */
export type ArgoAttributeDataMutationResponse = {
  __typename?: 'argo_attribute_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeData>;
};

/** on_conflict condition type for table "argo.attribute_data" */
export type ArgoAttributeDataOnConflict = {
  constraint: ArgoAttributeDataConstraint;
  update_columns?: Array<ArgoAttributeDataUpdateColumn>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_data". */
export type ArgoAttributeDataOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionOrderBy>;
  attribute_schema_definition_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  num_val_as_text?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_data */
export type ArgoAttributeDataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  AttributeSchemaDefinitionId = 'attribute_schema_definition_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.attribute_data" */
export type ArgoAttributeDataSetInput = {
  /** The attribute this entry links to */
  attribute_id?: Maybe<Scalars['uuid']>;
  attribute_schema_definition_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoAttributeDataStddevFields = {
  __typename?: 'argo_attribute_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoAttributeDataStddevPopFields = {
  __typename?: 'argo_attribute_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoAttributeDataStddevSampFields = {
  __typename?: 'argo_attribute_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_attribute_data" */
export type ArgoAttributeDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeDataStreamCursorValueInput = {
  /** The attribute this entry links to */
  attribute_id?: Maybe<Scalars['uuid']>;
  attribute_schema_definition_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoAttributeDataSumFields = {
  __typename?: 'argo_attribute_data_sum_fields';
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "argo.attribute_data" */
export enum ArgoAttributeDataUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  AttributeSchemaDefinitionId = 'attribute_schema_definition_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAttributeDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAttributeDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAttributeDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAttributeDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAttributeDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoAttributeDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAttributeDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeDataSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeDataBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoAttributeDataVarPopFields = {
  __typename?: 'argo_attribute_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoAttributeDataVarSampFields = {
  __typename?: 'argo_attribute_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoAttributeDataVarianceFields = {
  __typename?: 'argo_attribute_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.attribute_data" */
export type ArgoAttributeDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAttributeDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAttributeDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAttributeDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** Attirbute History Status Type */
export type ArgoAttributeHistoryStatusType = {
  __typename?: 'argo_attribute_history_status_type';
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status: Scalars['String'];
};

/** aggregated selection of "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeAggregate = {
  __typename?: 'argo_attribute_history_status_type_aggregate';
  aggregate?: Maybe<ArgoAttributeHistoryStatusTypeAggregateFields>;
  nodes: Array<ArgoAttributeHistoryStatusType>;
};

/** aggregate fields of "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeAggregateFields = {
  __typename?: 'argo_attribute_history_status_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeHistoryStatusTypeMaxFields>;
  min?: Maybe<ArgoAttributeHistoryStatusTypeMinFields>;
};


/** aggregate fields of "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeHistoryStatusTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.attribute_history_status_type". All fields are combined with a logical 'AND'. */
export type ArgoAttributeHistoryStatusTypeBoolExp = {
  _and?: Maybe<Array<ArgoAttributeHistoryStatusTypeBoolExp>>;
  _not?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
  _or?: Maybe<Array<ArgoAttributeHistoryStatusTypeBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeConstraint {
  /** unique or primary key constraint on columns "status" */
  AttributeHistoryStatusTypePkey = 'attribute_history_status_type_pkey'
}

export enum ArgoAttributeHistoryStatusTypeEnum {
  /** Attribute added to item */
  Added = 'added',
  /** Attribute removed from item */
  Removed = 'removed',
  /** Attribute updated on item */
  Updated = 'updated'
}

/** Boolean expression to compare columns of type "argo_attribute_history_status_type_enum". All fields are combined with logical 'AND'. */
export type ArgoAttributeHistoryStatusTypeEnumComparisonExp = {
  _eq?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  _in?: Maybe<Array<ArgoAttributeHistoryStatusTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  _nin?: Maybe<Array<ArgoAttributeHistoryStatusTypeEnum>>;
};

/** input type for inserting data into table "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeInsertInput = {
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoAttributeHistoryStatusTypeMaxFields = {
  __typename?: 'argo_attribute_history_status_type_max_fields';
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoAttributeHistoryStatusTypeMinFields = {
  __typename?: 'argo_attribute_history_status_type_min_fields';
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeMutationResponse = {
  __typename?: 'argo_attribute_history_status_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeHistoryStatusType>;
};

/** input type for inserting object relation for remote table "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeObjRelInsertInput = {
  data: ArgoAttributeHistoryStatusTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeHistoryStatusTypeOnConflict>;
};

/** on_conflict condition type for table "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeOnConflict = {
  constraint: ArgoAttributeHistoryStatusTypeConstraint;
  update_columns?: Array<ArgoAttributeHistoryStatusTypeUpdateColumn>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_history_status_type". */
export type ArgoAttributeHistoryStatusTypeOrderBy = {
  description?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_history_status_type */
export type ArgoAttributeHistoryStatusTypePkColumnsInput = {
  /** The status */
  status: Scalars['String'];
};

/** select columns of table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeSetInput = {
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_attribute_history_status_type" */
export type ArgoAttributeHistoryStatusTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeHistoryStatusTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeHistoryStatusTypeStreamCursorValueInput = {
  /** The description */
  description?: Maybe<Scalars['String']>;
  /** The status */
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.attribute_history_status_type" */
export enum ArgoAttributeHistoryStatusTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type ArgoAttributeHistoryStatusTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeHistoryStatusTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeHistoryStatusTypeBoolExp;
};

/** input type for inserting data into table "argo.attribute" */
export type ArgoAttributeInsertInput = {
  attribute_data?: Maybe<ArgoAttributeDataArrRelInsertInput>;
  attribute_schema?: Maybe<ArgoAttributeSchemaObjRelInsertInput>;
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  location_attributes?: Maybe<ArgoLocationAttributeArrRelInsertInput>;
  material_attributes?: Maybe<ArgoMaterialAttributeArrRelInsertInput>;
  material_class_attributes?: Maybe<ArgoMaterialClassAttributeArrRelInsertInput>;
  material_model_attributes?: Maybe<ArgoMaterialModelAttributeArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAttributeMaxFields = {
  __typename?: 'argo_attribute_max_fields';
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.attribute" */
export type ArgoAttributeMaxOrderBy = {
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<OrderBy>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAttributeMinFields = {
  __typename?: 'argo_attribute_min_fields';
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.attribute" */
export type ArgoAttributeMinOrderBy = {
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<OrderBy>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.attribute" */
export type ArgoAttributeMutationResponse = {
  __typename?: 'argo_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttribute>;
};

/** input type for inserting object relation for remote table "argo.attribute" */
export type ArgoAttributeObjRelInsertInput = {
  data: ArgoAttributeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeOnConflict>;
};

/** on_conflict condition type for table "argo.attribute" */
export type ArgoAttributeOnConflict = {
  constraint: ArgoAttributeConstraint;
  update_columns?: Array<ArgoAttributeUpdateColumn>;
  where?: Maybe<ArgoAttributeBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute". */
export type ArgoAttributeOrderBy = {
  attribute_data_aggregate?: Maybe<ArgoAttributeDataAggregateOrderBy>;
  attribute_schema?: Maybe<ArgoAttributeSchemaOrderBy>;
  attribute_schema_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_attributes_aggregate?: Maybe<ArgoLocationAttributeAggregateOrderBy>;
  material_attributes_aggregate?: Maybe<ArgoMaterialAttributeAggregateOrderBy>;
  material_class_attributes_aggregate?: Maybe<ArgoMaterialClassAttributeAggregateOrderBy>;
  material_model_attributes_aggregate?: Maybe<ArgoMaterialModelAttributeAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  remote_ref_id?: Maybe<OrderBy>;
  root_attribute_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute */
export type ArgoAttributePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchema = {
  __typename?: 'argo_attribute_schema';
  /** An array relationship */
  attribute_schema_definitions: Array<ArgoAttributeSchemaDefinition>;
  /** An aggregate relationship */
  attribute_schema_definitions_aggregate: ArgoAttributeSchemaDefinitionAggregate;
  /** An object relationship */
  attribute_schema_type: ArgoAttributeSchemaType;
  /** An array relationship */
  attributes: Array<ArgoAttribute>;
  /** An aggregate relationship */
  attributes_aggregate: ArgoAttributeAggregate;
  color: Scalars['String'];
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Description of this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  type: ArgoAttributeSchemaTypeEnum;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaAttributeSchemaDefinitionsArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaAttributeSchemaDefinitionsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.attribute_schema" */
export type ArgoAttributeSchemaAggregate = {
  __typename?: 'argo_attribute_schema_aggregate';
  aggregate?: Maybe<ArgoAttributeSchemaAggregateFields>;
  nodes: Array<ArgoAttributeSchema>;
};

export type ArgoAttributeSchemaAggregateBoolExp = {
  bool_and?: Maybe<ArgoAttributeSchemaAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoAttributeSchemaAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoAttributeSchemaAggregateBoolExpCount>;
};

export type ArgoAttributeSchemaAggregateBoolExpBoolAnd = {
  arguments: ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeSchemaAggregateBoolExpBoolOr = {
  arguments: ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeSchemaAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.attribute_schema" */
export type ArgoAttributeSchemaAggregateFields = {
  __typename?: 'argo_attribute_schema_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeSchemaMaxFields>;
  min?: Maybe<ArgoAttributeSchemaMinFields>;
};


/** aggregate fields of "argo.attribute_schema" */
export type ArgoAttributeSchemaAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.attribute_schema" */
export type ArgoAttributeSchemaAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAttributeSchemaMaxOrderBy>;
  min?: Maybe<ArgoAttributeSchemaMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeSchemaAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.attribute_schema" */
export type ArgoAttributeSchemaArrRelInsertInput = {
  data: Array<ArgoAttributeSchemaInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.attribute_schema". All fields are combined with a logical 'AND'. */
export type ArgoAttributeSchemaBoolExp = {
  _and?: Maybe<Array<ArgoAttributeSchemaBoolExp>>;
  _not?: Maybe<ArgoAttributeSchemaBoolExp>;
  _or?: Maybe<Array<ArgoAttributeSchemaBoolExp>>;
  attribute_schema_definitions?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  attribute_schema_definitions_aggregate?: Maybe<ArgoAttributeSchemaDefinitionAggregateBoolExp>;
  attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
  attributes?: Maybe<ArgoAttributeBoolExp>;
  attributes_aggregate?: Maybe<ArgoAttributeAggregateBoolExp>;
  color?: Maybe<StringComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  type?: Maybe<ArgoAttributeSchemaTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_schema" */
export enum ArgoAttributeSchemaConstraint {
  /** unique or primary key constraint on columns "context_id", "type", "name_unique" */
  AttributeSchemaEnforceUnique = 'attribute_schema_enforce_unique',
  /** unique or primary key constraint on columns "attribute_schema_id" */
  AttributeSchemaPkey = 'attribute_schema_pkey'
}

/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaDefinition = {
  __typename?: 'argo_attribute_schema_definition';
  /** An array relationship */
  attribute_data: Array<ArgoAttributeData>;
  /** An aggregate relationship */
  attribute_data_aggregate: ArgoAttributeDataAggregate;
  /** An object relationship */
  attribute_schema: ArgoAttributeSchema;
  attribute_schema_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  data_type: ArgoAttributeSchemaDefinitionType;
  /** Description of this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  /** The primitive type the attribute value is going to be */
  type: ArgoAttributeSchemaDefinitionTypeEnum;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not the DB will also validate the data */
  validation_api_check: Scalars['Boolean'];
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required: Scalars['Boolean'];
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaDefinitionAttributeDataArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaDefinitionAttributeDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


/** Table to define the data structure/type and UI to be used for an attribute */
export type ArgoAttributeSchemaDefinitionMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionAggregate = {
  __typename?: 'argo_attribute_schema_definition_aggregate';
  aggregate?: Maybe<ArgoAttributeSchemaDefinitionAggregateFields>;
  nodes: Array<ArgoAttributeSchemaDefinition>;
};

export type ArgoAttributeSchemaDefinitionAggregateBoolExp = {
  bool_and?: Maybe<ArgoAttributeSchemaDefinitionAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoAttributeSchemaDefinitionAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoAttributeSchemaDefinitionAggregateBoolExpCount>;
};

export type ArgoAttributeSchemaDefinitionAggregateBoolExpBoolAnd = {
  arguments: ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeSchemaDefinitionAggregateBoolExpBoolOr = {
  arguments: ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAttributeSchemaDefinitionAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionAggregateFields = {
  __typename?: 'argo_attribute_schema_definition_aggregate_fields';
  avg?: Maybe<ArgoAttributeSchemaDefinitionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeSchemaDefinitionMaxFields>;
  min?: Maybe<ArgoAttributeSchemaDefinitionMinFields>;
  stddev?: Maybe<ArgoAttributeSchemaDefinitionStddevFields>;
  stddev_pop?: Maybe<ArgoAttributeSchemaDefinitionStddevPopFields>;
  stddev_samp?: Maybe<ArgoAttributeSchemaDefinitionStddevSampFields>;
  sum?: Maybe<ArgoAttributeSchemaDefinitionSumFields>;
  var_pop?: Maybe<ArgoAttributeSchemaDefinitionVarPopFields>;
  var_samp?: Maybe<ArgoAttributeSchemaDefinitionVarSampFields>;
  variance?: Maybe<ArgoAttributeSchemaDefinitionVarianceFields>;
};


/** aggregate fields of "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionAggregateOrderBy = {
  avg?: Maybe<ArgoAttributeSchemaDefinitionAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAttributeSchemaDefinitionMaxOrderBy>;
  min?: Maybe<ArgoAttributeSchemaDefinitionMinOrderBy>;
  stddev?: Maybe<ArgoAttributeSchemaDefinitionStddevOrderBy>;
  stddev_pop?: Maybe<ArgoAttributeSchemaDefinitionStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoAttributeSchemaDefinitionStddevSampOrderBy>;
  sum?: Maybe<ArgoAttributeSchemaDefinitionSumOrderBy>;
  var_pop?: Maybe<ArgoAttributeSchemaDefinitionVarPopOrderBy>;
  var_samp?: Maybe<ArgoAttributeSchemaDefinitionVarSampOrderBy>;
  variance?: Maybe<ArgoAttributeSchemaDefinitionVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeSchemaDefinitionAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionArrRelInsertInput = {
  data: Array<ArgoAttributeSchemaDefinitionInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionOnConflict>;
};

/** aggregate avg on columns */
export type ArgoAttributeSchemaDefinitionAvgFields = {
  __typename?: 'argo_attribute_schema_definition_avg_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionAvgOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.attribute_schema_definition". All fields are combined with a logical 'AND'. */
export type ArgoAttributeSchemaDefinitionBoolExp = {
  _and?: Maybe<Array<ArgoAttributeSchemaDefinitionBoolExp>>;
  _not?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  _or?: Maybe<Array<ArgoAttributeSchemaDefinitionBoolExp>>;
  attribute_data?: Maybe<ArgoAttributeDataBoolExp>;
  attribute_data_aggregate?: Maybe<ArgoAttributeDataAggregateBoolExp>;
  attribute_schema?: Maybe<ArgoAttributeSchemaBoolExp>;
  attribute_schema_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_type?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  type?: Maybe<ArgoAttributeSchemaDefinitionTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  validation_api_check?: Maybe<BooleanComparisonExp>;
  validation_max?: Maybe<NumericComparisonExp>;
  validation_min?: Maybe<NumericComparisonExp>;
  validation_pattern?: Maybe<StringComparisonExp>;
  validation_required?: Maybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_schema_id", "name_unique" */
  AttributeSchemaDefinitionEnforceUnique = 'attribute_schema_definition_enforce_unique',
  /** unique or primary key constraint on columns "attribute_schema_definition_id" */
  AttributeSchemaDefinitionPkey = 'attribute_schema_definition_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAttributeSchemaDefinitionDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAttributeSchemaDefinitionDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAttributeSchemaDefinitionDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionIncInput = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionInsertInput = {
  attribute_data?: Maybe<ArgoAttributeDataArrRelInsertInput>;
  attribute_schema?: Maybe<ArgoAttributeSchemaObjRelInsertInput>;
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  data_type?: Maybe<ArgoAttributeSchemaDefinitionTypeObjRelInsertInput>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The primitive type the attribute value is going to be */
  type?: Maybe<ArgoAttributeSchemaDefinitionTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not the DB will also validate the data */
  validation_api_check?: Maybe<Scalars['Boolean']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ArgoAttributeSchemaDefinitionMaxFields = {
  __typename?: 'argo_attribute_schema_definition_max_fields';
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionMaxOrderBy = {
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAttributeSchemaDefinitionMinFields = {
  __typename?: 'argo_attribute_schema_definition_min_fields';
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionMinOrderBy = {
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionMutationResponse = {
  __typename?: 'argo_attribute_schema_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeSchemaDefinition>;
};

/** input type for inserting object relation for remote table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionObjRelInsertInput = {
  data: ArgoAttributeSchemaDefinitionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionOnConflict>;
};

/** on_conflict condition type for table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionOnConflict = {
  constraint: ArgoAttributeSchemaDefinitionConstraint;
  update_columns?: Array<ArgoAttributeSchemaDefinitionUpdateColumn>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_schema_definition". */
export type ArgoAttributeSchemaDefinitionOrderBy = {
  attribute_data_aggregate?: Maybe<ArgoAttributeDataAggregateOrderBy>;
  attribute_schema?: Maybe<ArgoAttributeSchemaOrderBy>;
  attribute_schema_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_type?: Maybe<ArgoAttributeSchemaDefinitionTypeOrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  validation_api_check?: Maybe<OrderBy>;
  validation_max?: Maybe<OrderBy>;
  validation_min?: Maybe<OrderBy>;
  validation_pattern?: Maybe<OrderBy>;
  validation_required?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_schema_definition */
export type ArgoAttributeSchemaDefinitionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeSchemaDefinitionPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_attribute_schema_definition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_attribute_schema_definition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** input type for updating data in table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionSetInput = {
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The primitive type the attribute value is going to be */
  type?: Maybe<ArgoAttributeSchemaDefinitionTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not the DB will also validate the data */
  validation_api_check?: Maybe<Scalars['Boolean']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ArgoAttributeSchemaDefinitionStddevFields = {
  __typename?: 'argo_attribute_schema_definition_stddev_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionStddevOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoAttributeSchemaDefinitionStddevPopFields = {
  __typename?: 'argo_attribute_schema_definition_stddev_pop_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionStddevPopOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoAttributeSchemaDefinitionStddevSampFields = {
  __typename?: 'argo_attribute_schema_definition_stddev_samp_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionStddevSampOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeSchemaDefinitionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeSchemaDefinitionStreamCursorValueInput = {
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The primitive type the attribute value is going to be */
  type?: Maybe<ArgoAttributeSchemaDefinitionTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not the DB will also validate the data */
  validation_api_check?: Maybe<Scalars['Boolean']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type ArgoAttributeSchemaDefinitionSumFields = {
  __typename?: 'argo_attribute_schema_definition_sum_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionSumOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** Attribute Schema Definition Data Type ENUM */
export type ArgoAttributeSchemaDefinitionType = {
  __typename?: 'argo_attribute_schema_definition_type';
  /** An array relationship */
  attribute_schema_definitions: Array<ArgoAttributeSchemaDefinition>;
  /** An aggregate relationship */
  attribute_schema_definitions_aggregate: ArgoAttributeSchemaDefinitionAggregate;
  /** The description of the data type */
  description: Scalars['String'];
  /** The data type */
  type: Scalars['String'];
};


/** Attribute Schema Definition Data Type ENUM */
export type ArgoAttributeSchemaDefinitionTypeAttributeSchemaDefinitionsArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


/** Attribute Schema Definition Data Type ENUM */
export type ArgoAttributeSchemaDefinitionTypeAttributeSchemaDefinitionsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};

/** aggregated selection of "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeAggregate = {
  __typename?: 'argo_attribute_schema_definition_type_aggregate';
  aggregate?: Maybe<ArgoAttributeSchemaDefinitionTypeAggregateFields>;
  nodes: Array<ArgoAttributeSchemaDefinitionType>;
};

/** aggregate fields of "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeAggregateFields = {
  __typename?: 'argo_attribute_schema_definition_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeSchemaDefinitionTypeMaxFields>;
  min?: Maybe<ArgoAttributeSchemaDefinitionTypeMinFields>;
};


/** aggregate fields of "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.attribute_schema_definition_type". All fields are combined with a logical 'AND'. */
export type ArgoAttributeSchemaDefinitionTypeBoolExp = {
  _and?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeBoolExp>>;
  _not?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
  _or?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeBoolExp>>;
  attribute_schema_definitions?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
  attribute_schema_definitions_aggregate?: Maybe<ArgoAttributeSchemaDefinitionAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  AttributeSchemaDefinitionTypePkey = 'attribute_schema_definition_type_pkey'
}

export enum ArgoAttributeSchemaDefinitionTypeEnum {
  /** Numeric data type */
  Number = 'number',
  /** String or Text data type */
  Text = 'text'
}

/** Boolean expression to compare columns of type "argo_attribute_schema_definition_type_enum". All fields are combined with logical 'AND'. */
export type ArgoAttributeSchemaDefinitionTypeEnumComparisonExp = {
  _eq?: Maybe<ArgoAttributeSchemaDefinitionTypeEnum>;
  _in?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoAttributeSchemaDefinitionTypeEnum>;
  _nin?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeEnum>>;
};

/** input type for inserting data into table "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeInsertInput = {
  attribute_schema_definitions?: Maybe<ArgoAttributeSchemaDefinitionArrRelInsertInput>;
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoAttributeSchemaDefinitionTypeMaxFields = {
  __typename?: 'argo_attribute_schema_definition_type_max_fields';
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoAttributeSchemaDefinitionTypeMinFields = {
  __typename?: 'argo_attribute_schema_definition_type_min_fields';
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeMutationResponse = {
  __typename?: 'argo_attribute_schema_definition_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeSchemaDefinitionType>;
};

/** input type for inserting object relation for remote table "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeObjRelInsertInput = {
  data: ArgoAttributeSchemaDefinitionTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionTypeOnConflict>;
};

/** on_conflict condition type for table "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeOnConflict = {
  constraint: ArgoAttributeSchemaDefinitionTypeConstraint;
  update_columns?: Array<ArgoAttributeSchemaDefinitionTypeUpdateColumn>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_schema_definition_type". */
export type ArgoAttributeSchemaDefinitionTypeOrderBy = {
  attribute_schema_definitions_aggregate?: Maybe<ArgoAttributeSchemaDefinitionAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_schema_definition_type */
export type ArgoAttributeSchemaDefinitionTypePkColumnsInput = {
  /** The data type */
  type: Scalars['String'];
};

/** select columns of table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "argo.attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeSetInput = {
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_attribute_schema_definition_type" */
export type ArgoAttributeSchemaDefinitionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeSchemaDefinitionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeSchemaDefinitionTypeStreamCursorValueInput = {
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type ArgoAttributeSchemaDefinitionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeSchemaDefinitionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeSchemaDefinitionTypeBoolExp;
};

/** update columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required'
}

export type ArgoAttributeSchemaDefinitionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAttributeSchemaDefinitionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAttributeSchemaDefinitionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAttributeSchemaDefinitionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAttributeSchemaDefinitionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoAttributeSchemaDefinitionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAttributeSchemaDefinitionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeSchemaDefinitionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeSchemaDefinitionBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoAttributeSchemaDefinitionVarPopFields = {
  __typename?: 'argo_attribute_schema_definition_var_pop_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionVarPopOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoAttributeSchemaDefinitionVarSampFields = {
  __typename?: 'argo_attribute_schema_definition_var_samp_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionVarSampOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoAttributeSchemaDefinitionVarianceFields = {
  __typename?: 'argo_attribute_schema_definition_variance_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.attribute_schema_definition" */
export type ArgoAttributeSchemaDefinitionVarianceOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAttributeSchemaDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAttributeSchemaDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAttributeSchemaDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.attribute_schema" */
export type ArgoAttributeSchemaInsertInput = {
  attribute_schema_definitions?: Maybe<ArgoAttributeSchemaDefinitionArrRelInsertInput>;
  attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeObjRelInsertInput>;
  attributes?: Maybe<ArgoAttributeArrRelInsertInput>;
  color?: Maybe<Scalars['String']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<ArgoAttributeSchemaTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAttributeSchemaMaxFields = {
  __typename?: 'argo_attribute_schema_max_fields';
  color?: Maybe<Scalars['String']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.attribute_schema" */
export type ArgoAttributeSchemaMaxOrderBy = {
  color?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAttributeSchemaMinFields = {
  __typename?: 'argo_attribute_schema_min_fields';
  color?: Maybe<Scalars['String']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.attribute_schema" */
export type ArgoAttributeSchemaMinOrderBy = {
  color?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.attribute_schema" */
export type ArgoAttributeSchemaMutationResponse = {
  __typename?: 'argo_attribute_schema_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeSchema>;
};

/** input type for inserting object relation for remote table "argo.attribute_schema" */
export type ArgoAttributeSchemaObjRelInsertInput = {
  data: ArgoAttributeSchemaInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaOnConflict>;
};

/** on_conflict condition type for table "argo.attribute_schema" */
export type ArgoAttributeSchemaOnConflict = {
  constraint: ArgoAttributeSchemaConstraint;
  update_columns?: Array<ArgoAttributeSchemaUpdateColumn>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_schema". */
export type ArgoAttributeSchemaOrderBy = {
  attribute_schema_definitions_aggregate?: Maybe<ArgoAttributeSchemaDefinitionAggregateOrderBy>;
  attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeOrderBy>;
  attributes_aggregate?: Maybe<ArgoAttributeAggregateOrderBy>;
  color?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_schema */
export type ArgoAttributeSchemaPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAttributeSchemaPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_schema_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_schema_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaSelectColumnArgoAttributeSchemaAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.attribute_schema" */
export type ArgoAttributeSchemaSetInput = {
  color?: Maybe<Scalars['String']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<ArgoAttributeSchemaTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_attribute_schema" */
export type ArgoAttributeSchemaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeSchemaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeSchemaStreamCursorValueInput = {
  color?: Maybe<Scalars['String']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<ArgoAttributeSchemaTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Attribute Schema Type ENUM */
export type ArgoAttributeSchemaType = {
  __typename?: 'argo_attribute_schema_type';
  /** An array relationship */
  attribute_schemas: Array<ArgoAttributeSchema>;
  /** An aggregate relationship */
  attribute_schemas_aggregate: ArgoAttributeSchemaAggregate;
  /** The description of the attribute schema type */
  description: Scalars['String'];
  /** The type of entity the attributes of this Schema can be linked to */
  type: Scalars['String'];
};


/** Attribute Schema Type ENUM */
export type ArgoAttributeSchemaTypeAttributeSchemasArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


/** Attribute Schema Type ENUM */
export type ArgoAttributeSchemaTypeAttributeSchemasAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};

/** aggregated selection of "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeAggregate = {
  __typename?: 'argo_attribute_schema_type_aggregate';
  aggregate?: Maybe<ArgoAttributeSchemaTypeAggregateFields>;
  nodes: Array<ArgoAttributeSchemaType>;
};

/** aggregate fields of "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeAggregateFields = {
  __typename?: 'argo_attribute_schema_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAttributeSchemaTypeMaxFields>;
  min?: Maybe<ArgoAttributeSchemaTypeMinFields>;
};


/** aggregate fields of "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAttributeSchemaTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.attribute_schema_type". All fields are combined with a logical 'AND'. */
export type ArgoAttributeSchemaTypeBoolExp = {
  _and?: Maybe<Array<ArgoAttributeSchemaTypeBoolExp>>;
  _not?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
  _or?: Maybe<Array<ArgoAttributeSchemaTypeBoolExp>>;
  attribute_schemas?: Maybe<ArgoAttributeSchemaBoolExp>;
  attribute_schemas_aggregate?: Maybe<ArgoAttributeSchemaAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  AttributeSchemaTypePkey = 'attribute_schema_type_pkey'
}

export enum ArgoAttributeSchemaTypeEnum {
  /** App */
  App = 'app',
  /** App Template */
  AppTemplate = 'app_template',
  /** App Type */
  AppType = 'app_type',
  /** Data Element */
  DataElement = 'data_element',
  /** Location */
  Location = 'location',
  /** Material */
  Material = 'material',
  /** Material Class */
  MaterialClass = 'material_class',
  /** Material Model */
  MaterialModel = 'material_model'
}

/** Boolean expression to compare columns of type "argo_attribute_schema_type_enum". All fields are combined with logical 'AND'. */
export type ArgoAttributeSchemaTypeEnumComparisonExp = {
  _eq?: Maybe<ArgoAttributeSchemaTypeEnum>;
  _in?: Maybe<Array<ArgoAttributeSchemaTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoAttributeSchemaTypeEnum>;
  _nin?: Maybe<Array<ArgoAttributeSchemaTypeEnum>>;
};

/** input type for inserting data into table "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeInsertInput = {
  attribute_schemas?: Maybe<ArgoAttributeSchemaArrRelInsertInput>;
  /** The description of the attribute schema type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity the attributes of this Schema can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoAttributeSchemaTypeMaxFields = {
  __typename?: 'argo_attribute_schema_type_max_fields';
  /** The description of the attribute schema type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity the attributes of this Schema can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoAttributeSchemaTypeMinFields = {
  __typename?: 'argo_attribute_schema_type_min_fields';
  /** The description of the attribute schema type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity the attributes of this Schema can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeMutationResponse = {
  __typename?: 'argo_attribute_schema_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAttributeSchemaType>;
};

/** input type for inserting object relation for remote table "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeObjRelInsertInput = {
  data: ArgoAttributeSchemaTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAttributeSchemaTypeOnConflict>;
};

/** on_conflict condition type for table "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeOnConflict = {
  constraint: ArgoAttributeSchemaTypeConstraint;
  update_columns?: Array<ArgoAttributeSchemaTypeUpdateColumn>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.attribute_schema_type". */
export type ArgoAttributeSchemaTypeOrderBy = {
  attribute_schemas_aggregate?: Maybe<ArgoAttributeSchemaAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.attribute_schema_type */
export type ArgoAttributeSchemaTypePkColumnsInput = {
  /** The type of entity the attributes of this Schema can be linked to */
  type: Scalars['String'];
};

/** select columns of table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "argo.attribute_schema_type" */
export type ArgoAttributeSchemaTypeSetInput = {
  /** The description of the attribute schema type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity the attributes of this Schema can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_attribute_schema_type" */
export type ArgoAttributeSchemaTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeSchemaTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeSchemaTypeStreamCursorValueInput = {
  /** The description of the attribute schema type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity the attributes of this Schema can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type ArgoAttributeSchemaTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeSchemaTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeSchemaTypeBoolExp;
};

/** update columns of table "argo.attribute_schema" */
export enum ArgoAttributeSchemaUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAttributeSchemaUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAttributeSchemaAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAttributeSchemaDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAttributeSchemaDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAttributeSchemaDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAttributeSchemaPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeSchemaSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeSchemaBoolExp;
};

/** select columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  RemoteRefId = 'remote_ref_id',
  /** column name */
  RootAttributeId = 'root_attribute_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.attribute" */
export type ArgoAttributeSetInput = {
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Streaming cursor of the table "argo_attribute" */
export type ArgoAttributeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAttributeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAttributeStreamCursorValueInput = {
  /** The attribute schema this entry links to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** reference to a primary key for a foreign database */
  remote_ref_id?: Maybe<Scalars['String']>;
  /** The attribute id that all subsequent versions of the attribute share */
  root_attribute_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.attribute" */
export enum ArgoAttributeUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  RemoteRefId = 'remote_ref_id',
  /** column name */
  RootAttributeId = 'root_attribute_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAttributeUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAttributeAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAttributeDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAttributeDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAttributeDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAttributePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAttributeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAttributeBoolExp;
};

/** Automatically populated CRUD audit data */
export type ArgoAudit = {
  __typename?: 'argo_audit';
  /** The CRUD operation performed */
  action: Scalars['String'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** The DB data related to the CRUD operation performed */
  data: Scalars['jsonb'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A helpful human-readable message to display */
  message: Scalars['String'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema: Scalars['String'];
  /** The DB table for the operation performed */
  table: Scalars['String'];
};


/** Automatically populated CRUD audit data */
export type ArgoAuditDataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Automatically populated CRUD audit data */
export type ArgoAuditMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.audit" */
export type ArgoAuditAggregate = {
  __typename?: 'argo_audit_aggregate';
  aggregate?: Maybe<ArgoAuditAggregateFields>;
  nodes: Array<ArgoAudit>;
};

/** aggregate fields of "argo.audit" */
export type ArgoAuditAggregateFields = {
  __typename?: 'argo_audit_aggregate_fields';
  avg?: Maybe<ArgoAuditAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoAuditMaxFields>;
  min?: Maybe<ArgoAuditMinFields>;
  stddev?: Maybe<ArgoAuditStddevFields>;
  stddev_pop?: Maybe<ArgoAuditStddevPopFields>;
  stddev_samp?: Maybe<ArgoAuditStddevSampFields>;
  sum?: Maybe<ArgoAuditSumFields>;
  var_pop?: Maybe<ArgoAuditVarPopFields>;
  var_samp?: Maybe<ArgoAuditVarSampFields>;
  variance?: Maybe<ArgoAuditVarianceFields>;
};


/** aggregate fields of "argo.audit" */
export type ArgoAuditAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuditSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuditAppendInput = {
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoAuditAvgFields = {
  __typename?: 'argo_audit_avg_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.audit". All fields are combined with a logical 'AND'. */
export type ArgoAuditBoolExp = {
  _and?: Maybe<Array<ArgoAuditBoolExp>>;
  _not?: Maybe<ArgoAuditBoolExp>;
  _or?: Maybe<Array<ArgoAuditBoolExp>>;
  action?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  data?: Maybe<JsonbComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  message?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  pk_bigint?: Maybe<BigintComparisonExp>;
  pk_text?: Maybe<StringComparisonExp>;
  pk_uuid?: Maybe<UuidComparisonExp>;
  schema?: Maybe<StringComparisonExp>;
  table?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.audit" */
export enum ArgoAuditConstraint {
  /** unique or primary key constraint on columns "audit_id" */
  AuditPkey = 'audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuditDeleteAtPathInput = {
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuditDeleteElemInput = {
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuditDeleteKeyInput = {
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.audit" */
export type ArgoAuditIncInput = {
  pk_bigint?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.audit" */
export type ArgoAuditInsertInput = {
  /** The CRUD operation performed */
  action?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A helpful human-readable message to display */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema?: Maybe<Scalars['String']>;
  /** The DB table for the operation performed */
  table?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoAuditMaxFields = {
  __typename?: 'argo_audit_max_fields';
  /** The CRUD operation performed */
  action?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A helpful human-readable message to display */
  message?: Maybe<Scalars['String']>;
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema?: Maybe<Scalars['String']>;
  /** The DB table for the operation performed */
  table?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoAuditMinFields = {
  __typename?: 'argo_audit_min_fields';
  /** The CRUD operation performed */
  action?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A helpful human-readable message to display */
  message?: Maybe<Scalars['String']>;
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema?: Maybe<Scalars['String']>;
  /** The DB table for the operation performed */
  table?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.audit" */
export type ArgoAuditMutationResponse = {
  __typename?: 'argo_audit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAudit>;
};

/** on_conflict condition type for table "argo.audit" */
export type ArgoAuditOnConflict = {
  constraint: ArgoAuditConstraint;
  update_columns?: Array<ArgoAuditUpdateColumn>;
  where?: Maybe<ArgoAuditBoolExp>;
};

/** Ordering options when selecting data from "argo.audit". */
export type ArgoAuditOrderBy = {
  action?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  data?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  message?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  pk_bigint?: Maybe<OrderBy>;
  pk_text?: Maybe<OrderBy>;
  pk_uuid?: Maybe<OrderBy>;
  schema?: Maybe<OrderBy>;
  table?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.audit */
export type ArgoAuditPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuditPrependInput = {
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.audit" */
export enum ArgoAuditSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  PkBigint = 'pk_bigint',
  /** column name */
  PkText = 'pk_text',
  /** column name */
  PkUuid = 'pk_uuid',
  /** column name */
  Schema = 'schema',
  /** column name */
  Table = 'table'
}

/** input type for updating data in table "argo.audit" */
export type ArgoAuditSetInput = {
  /** The CRUD operation performed */
  action?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A helpful human-readable message to display */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema?: Maybe<Scalars['String']>;
  /** The DB table for the operation performed */
  table?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArgoAuditStddevFields = {
  __typename?: 'argo_audit_stddev_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoAuditStddevPopFields = {
  __typename?: 'argo_audit_stddev_pop_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoAuditStddevSampFields = {
  __typename?: 'argo_audit_stddev_samp_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_audit" */
export type ArgoAuditStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuditStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuditStreamCursorValueInput = {
  /** The CRUD operation performed */
  action?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The DB data related to the CRUD operation performed */
  data?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A helpful human-readable message to display */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  pk_bigint?: Maybe<Scalars['bigint']>;
  pk_text?: Maybe<Scalars['String']>;
  pk_uuid?: Maybe<Scalars['uuid']>;
  /** The DB schema for the operation performed */
  schema?: Maybe<Scalars['String']>;
  /** The DB table for the operation performed */
  table?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoAuditSumFields = {
  __typename?: 'argo_audit_sum_fields';
  pk_bigint?: Maybe<Scalars['bigint']>;
};

/** update columns of table "argo.audit" */
export enum ArgoAuditUpdateColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  PkBigint = 'pk_bigint',
  /** column name */
  PkText = 'pk_text',
  /** column name */
  PkUuid = 'pk_uuid',
  /** column name */
  Schema = 'schema',
  /** column name */
  Table = 'table'
}

export type ArgoAuditUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuditAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuditDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuditDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuditDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoAuditIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuditPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuditSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuditBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoAuditVarPopFields = {
  __typename?: 'argo_audit_var_pop_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoAuditVarSampFields = {
  __typename?: 'argo_audit_var_samp_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoAuditVarianceFields = {
  __typename?: 'argo_audit_variance_fields';
  pk_bigint?: Maybe<Scalars['Float']>;
};

/** Authentication Providers */
export type ArgoAuthProvider = {
  __typename?: 'argo_auth_provider';
  /** An array relationship */
  auth_provider_records: Array<ArgoAuthProviderRecord>;
  /** An aggregate relationship */
  auth_provider_records_aggregate: ArgoAuthProviderRecordAggregate;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** A description of each value */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** ENUM single-column primary key of type text */
  id: Scalars['String'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Authentication Providers */
export type ArgoAuthProviderAuthProviderRecordsArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


/** Authentication Providers */
export type ArgoAuthProviderAuthProviderRecordsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


/** Authentication Providers */
export type ArgoAuthProviderMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider" */
export type ArgoAuthProviderAggregate = {
  __typename?: 'argo_auth_provider_aggregate';
  aggregate?: Maybe<ArgoAuthProviderAggregateFields>;
  nodes: Array<ArgoAuthProvider>;
};

/** aggregate fields of "argo.auth_provider" */
export type ArgoAuthProviderAggregateFields = {
  __typename?: 'argo_auth_provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderMaxFields>;
  min?: Maybe<ArgoAuthProviderMinFields>;
};


/** aggregate fields of "argo.auth_provider" */
export type ArgoAuthProviderAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderBoolExp>>;
  _not?: Maybe<ArgoAuthProviderBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderBoolExp>>;
  auth_provider_records?: Maybe<ArgoAuthProviderRecordBoolExp>;
  auth_provider_records_aggregate?: Maybe<ArgoAuthProviderRecordAggregateBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.auth_provider" */
export enum ArgoAuthProviderConstraint {
  /** unique or primary key constraint on columns "auth_provider_id" */
  AuthProviderPkey = 'auth_provider_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_provider" */
export type ArgoAuthProviderInsertInput = {
  auth_provider_records?: Maybe<ArgoAuthProviderRecordArrRelInsertInput>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A description of each value */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** ENUM single-column primary key of type text */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Local Authentication Provider */
export type ArgoAuthProviderLocal = {
  __typename?: 'argo_auth_provider_local';
  /** An object relationship */
  auth_provider_record: ArgoAuthProviderRecord;
  /** The auth provider record for this entry */
  auth_provider_record_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** The email used for the local login */
  email: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** A single sequence of failed attempts */
  failed_attempts: Scalars['Int'];
  /** Expected to always be user */
  hasura_role: Scalars['String'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** Whether or not multi-factor authentication is enabled */
  mfa_enabled: Scalars['Boolean'];
  /** A UUID used to identify the MFA session during a login request */
  mfa_session: Scalars['uuid'];
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash: Scalars['String'];
  /** When this entry was last updated */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: ArgoUser;
  /** The user if authentication is successful */
  user_id: Scalars['uuid'];
};


/** Local Authentication Provider */
export type ArgoAuthProviderLocalMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider_local" */
export type ArgoAuthProviderLocalAggregate = {
  __typename?: 'argo_auth_provider_local_aggregate';
  aggregate?: Maybe<ArgoAuthProviderLocalAggregateFields>;
  nodes: Array<ArgoAuthProviderLocal>;
};

export type ArgoAuthProviderLocalAggregateBoolExp = {
  bool_and?: Maybe<ArgoAuthProviderLocalAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoAuthProviderLocalAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoAuthProviderLocalAggregateBoolExpCount>;
};

export type ArgoAuthProviderLocalAggregateBoolExpBoolAnd = {
  arguments: ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAuthProviderLocalBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAuthProviderLocalAggregateBoolExpBoolOr = {
  arguments: ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAuthProviderLocalBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoAuthProviderLocalAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAuthProviderLocalBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.auth_provider_local" */
export type ArgoAuthProviderLocalAggregateFields = {
  __typename?: 'argo_auth_provider_local_aggregate_fields';
  avg?: Maybe<ArgoAuthProviderLocalAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderLocalMaxFields>;
  min?: Maybe<ArgoAuthProviderLocalMinFields>;
  stddev?: Maybe<ArgoAuthProviderLocalStddevFields>;
  stddev_pop?: Maybe<ArgoAuthProviderLocalStddevPopFields>;
  stddev_samp?: Maybe<ArgoAuthProviderLocalStddevSampFields>;
  sum?: Maybe<ArgoAuthProviderLocalSumFields>;
  var_pop?: Maybe<ArgoAuthProviderLocalVarPopFields>;
  var_samp?: Maybe<ArgoAuthProviderLocalVarSampFields>;
  variance?: Maybe<ArgoAuthProviderLocalVarianceFields>;
};


/** aggregate fields of "argo.auth_provider_local" */
export type ArgoAuthProviderLocalAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalAggregateOrderBy = {
  avg?: Maybe<ArgoAuthProviderLocalAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAuthProviderLocalMaxOrderBy>;
  min?: Maybe<ArgoAuthProviderLocalMinOrderBy>;
  stddev?: Maybe<ArgoAuthProviderLocalStddevOrderBy>;
  stddev_pop?: Maybe<ArgoAuthProviderLocalStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoAuthProviderLocalStddevSampOrderBy>;
  sum?: Maybe<ArgoAuthProviderLocalSumOrderBy>;
  var_pop?: Maybe<ArgoAuthProviderLocalVarPopOrderBy>;
  var_samp?: Maybe<ArgoAuthProviderLocalVarSampOrderBy>;
  variance?: Maybe<ArgoAuthProviderLocalVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderLocalAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalArrRelInsertInput = {
  data: Array<ArgoAuthProviderLocalInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthProviderLocalOnConflict>;
};

/** aggregate avg on columns */
export type ArgoAuthProviderLocalAvgFields = {
  __typename?: 'argo_auth_provider_local_avg_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalAvgOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider_local". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderLocalBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderLocalBoolExp>>;
  _not?: Maybe<ArgoAuthProviderLocalBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderLocalBoolExp>>;
  auth_provider_record?: Maybe<ArgoAuthProviderRecordBoolExp>;
  auth_provider_record_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  email?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  failed_attempts?: Maybe<IntComparisonExp>;
  hasura_role?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  lock_expires_at?: Maybe<TimestamptzComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  mfa_enabled?: Maybe<BooleanComparisonExp>;
  mfa_session?: Maybe<UuidComparisonExp>;
  otp_secret?: Maybe<StringComparisonExp>;
  password_hash?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderLocalAuthProviderRecordIdKey = 'auth_provider_local_auth_provider_record_id_key',
  /** unique or primary key constraint on columns "email" */
  AuthProviderLocalEmailKey = 'auth_provider_local_email_key',
  /** unique or primary key constraint on columns "auth_provider_local_id" */
  AuthProviderLocalPkey = 'auth_provider_local_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AuthProviderLocalUserId = 'auth_provider_local_user_id'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderLocalDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderLocalDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderLocalDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalIncInput = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalInsertInput = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordObjRelInsertInput>;
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The email used for the local login */
  email?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not multi-factor authentication is enabled */
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<Scalars['uuid']>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAuthProviderLocalMaxFields = {
  __typename?: 'argo_auth_provider_local_max_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The email used for the local login */
  email?: Maybe<Scalars['String']>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<Scalars['uuid']>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalMaxOrderBy = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The email used for the local login */
  email?: Maybe<OrderBy>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
  /** Expected to always be user */
  hasura_role?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<OrderBy>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<OrderBy>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<OrderBy>;
  /** The stored password */
  password_hash?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user if authentication is successful */
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAuthProviderLocalMinFields = {
  __typename?: 'argo_auth_provider_local_min_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The email used for the local login */
  email?: Maybe<Scalars['String']>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<Scalars['uuid']>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalMinOrderBy = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The email used for the local login */
  email?: Maybe<OrderBy>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
  /** Expected to always be user */
  hasura_role?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<OrderBy>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<OrderBy>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<OrderBy>;
  /** The stored password */
  password_hash?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user if authentication is successful */
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalMutationResponse = {
  __typename?: 'argo_auth_provider_local_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProviderLocal>;
};

/** input type for inserting object relation for remote table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalObjRelInsertInput = {
  data: ArgoAuthProviderLocalInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthProviderLocalOnConflict>;
};

/** on_conflict condition type for table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalOnConflict = {
  constraint: ArgoAuthProviderLocalConstraint;
  update_columns?: Array<ArgoAuthProviderLocalUpdateColumn>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider_local". */
export type ArgoAuthProviderLocalOrderBy = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordOrderBy>;
  auth_provider_record_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  failed_attempts?: Maybe<OrderBy>;
  hasura_role?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lock_expires_at?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  mfa_enabled?: Maybe<OrderBy>;
  mfa_session?: Maybe<OrderBy>;
  otp_secret?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider_local */
export type ArgoAuthProviderLocalPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderLocalPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  Meta = 'meta',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MfaSession = 'mfa_session',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "argo_auth_provider_local_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** select "argo_auth_provider_local_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** input type for updating data in table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalSetInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The email used for the local login */
  email?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not multi-factor authentication is enabled */
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<Scalars['uuid']>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Context Auth Configuration */
export type ArgoAuthProviderLocalSetting = {
  __typename?: 'argo_auth_provider_local_setting';
  /** An object relationship */
  auth_provider: ArgoAuthProvider;
  auth_provider_id: Scalars['String'];
  config: Scalars['argo_auth_provider_local_setting_config'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Context Auth Configuration */
export type ArgoAuthProviderLocalSettingConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingAggregate = {
  __typename?: 'argo_auth_provider_local_setting_aggregate';
  aggregate?: Maybe<ArgoAuthProviderLocalSettingAggregateFields>;
  nodes: Array<ArgoAuthProviderLocalSetting>;
};

/** aggregate fields of "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingAggregateFields = {
  __typename?: 'argo_auth_provider_local_setting_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderLocalSettingMaxFields>;
  min?: Maybe<ArgoAuthProviderLocalSettingMinFields>;
};


/** aggregate fields of "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderLocalSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderLocalSettingAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider_local_setting". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderLocalSettingBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderLocalSettingBoolExp>>;
  _not?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderLocalSettingBoolExp>>;
  auth_provider?: Maybe<ArgoAuthProviderBoolExp>;
  auth_provider_id?: Maybe<StringComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};


/** unique or primary key constraints on table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingConstraint {
  /** unique or primary key constraint on columns "context_id", "auth_provider_id" */
  AuthProviderLocalSettingAuthProviderIdContextIdKey = 'auth_provider_local_setting_auth_provider_id_context_id_key',
  /** unique or primary key constraint on columns "auth_provider_local_setting_id" */
  AuthProviderLocalSettingPkey = 'auth_provider_local_setting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderLocalSettingDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderLocalSettingDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderLocalSettingDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingInsertInput = {
  auth_provider?: Maybe<ArgoAuthProviderObjRelInsertInput>;
  auth_provider_id?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAuthProviderLocalSettingMaxFields = {
  __typename?: 'argo_auth_provider_local_setting_max_fields';
  auth_provider_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoAuthProviderLocalSettingMinFields = {
  __typename?: 'argo_auth_provider_local_setting_min_fields';
  auth_provider_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingMutationResponse = {
  __typename?: 'argo_auth_provider_local_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProviderLocalSetting>;
};

/** on_conflict condition type for table "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingOnConflict = {
  constraint: ArgoAuthProviderLocalSettingConstraint;
  update_columns?: Array<ArgoAuthProviderLocalSettingUpdateColumn>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider_local_setting". */
export type ArgoAuthProviderLocalSettingOrderBy = {
  auth_provider?: Maybe<ArgoAuthProviderOrderBy>;
  auth_provider_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider_local_setting */
export type ArgoAuthProviderLocalSettingPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderLocalSettingPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingSelectColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingSetInput = {
  auth_provider_id?: Maybe<Scalars['String']>;
  config: Scalars['argo_auth_provider_local_setting_config'];
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_auth_provider_local_setting" */
export type ArgoAuthProviderLocalSettingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderLocalSettingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderLocalSettingStreamCursorValueInput = {
  auth_provider_id?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.auth_provider_local_setting" */
export enum ArgoAuthProviderLocalSettingUpdateColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAuthProviderLocalSettingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderLocalSettingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderLocalSettingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderLocalSettingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderLocalSettingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderLocalSettingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderLocalSettingSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderLocalSettingBoolExp;
};

/** aggregate stddev on columns */
export type ArgoAuthProviderLocalStddevFields = {
  __typename?: 'argo_auth_provider_local_stddev_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalStddevOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoAuthProviderLocalStddevPopFields = {
  __typename?: 'argo_auth_provider_local_stddev_pop_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalStddevPopOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoAuthProviderLocalStddevSampFields = {
  __typename?: 'argo_auth_provider_local_stddev_samp_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalStddevSampOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_auth_provider_local" */
export type ArgoAuthProviderLocalStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderLocalStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderLocalStreamCursorValueInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The email used for the local login */
  email?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A date defining when the account will be unlocked */
  lock_expires_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not multi-factor authentication is enabled */
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  /** A UUID used to identify the MFA session during a login request */
  mfa_session?: Maybe<Scalars['uuid']>;
  /** The multi-factor authentication secret */
  otp_secret?: Maybe<Scalars['String']>;
  /** The stored password */
  password_hash?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoAuthProviderLocalSumFields = {
  __typename?: 'argo_auth_provider_local_sum_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalSumOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** update columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  Meta = 'meta',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MfaSession = 'mfa_session',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type ArgoAuthProviderLocalUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderLocalAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderLocalDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderLocalDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderLocalDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoAuthProviderLocalIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderLocalPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderLocalSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderLocalBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoAuthProviderLocalVarPopFields = {
  __typename?: 'argo_auth_provider_local_var_pop_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalVarPopOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoAuthProviderLocalVarSampFields = {
  __typename?: 'argo_auth_provider_local_var_samp_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalVarSampOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoAuthProviderLocalVarianceFields = {
  __typename?: 'argo_auth_provider_local_variance_fields';
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.auth_provider_local" */
export type ArgoAuthProviderLocalVarianceOrderBy = {
  /** A single sequence of failed attempts */
  failed_attempts?: Maybe<OrderBy>;
};

/** aggregate max on columns */
export type ArgoAuthProviderMaxFields = {
  __typename?: 'argo_auth_provider_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A description of each value */
  description?: Maybe<Scalars['String']>;
  /** ENUM single-column primary key of type text */
  id?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoAuthProviderMinFields = {
  __typename?: 'argo_auth_provider_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A description of each value */
  description?: Maybe<Scalars['String']>;
  /** ENUM single-column primary key of type text */
  id?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** MSAL Authentication Provider */
export type ArgoAuthProviderMsal = {
  __typename?: 'argo_auth_provider_msal';
  /** An object relationship */
  auth_provider_record: ArgoAuthProviderRecord;
  /** The auth provider record for this entry */
  auth_provider_record_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** Expected to always be user */
  hasura_role: Scalars['String'];
  /** The home account id used for the msal login */
  home_account_id: Scalars['String'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** A subset of response data received during msal login */
  rsp: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: ArgoUser;
  /** The user if authentication is successful */
  user_id: Scalars['uuid'];
};


/** MSAL Authentication Provider */
export type ArgoAuthProviderMsalMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** MSAL Authentication Provider */
export type ArgoAuthProviderMsalRspArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalAggregate = {
  __typename?: 'argo_auth_provider_msal_aggregate';
  aggregate?: Maybe<ArgoAuthProviderMsalAggregateFields>;
  nodes: Array<ArgoAuthProviderMsal>;
};

/** aggregate fields of "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalAggregateFields = {
  __typename?: 'argo_auth_provider_msal_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderMsalMaxFields>;
  min?: Maybe<ArgoAuthProviderMsalMinFields>;
};


/** aggregate fields of "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderMsalSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderMsalAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider_msal". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderMsalBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderMsalBoolExp>>;
  _not?: Maybe<ArgoAuthProviderMsalBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderMsalBoolExp>>;
  auth_provider_record?: Maybe<ArgoAuthProviderRecordBoolExp>;
  auth_provider_record_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  hasura_role?: Maybe<StringComparisonExp>;
  home_account_id?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  rsp?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderMsalAuthProviderRecordIdKey = 'auth_provider_msal_auth_provider_record_id_key',
  /** unique or primary key constraint on columns "home_account_id" */
  AuthProviderMsalHomeAccountIdKey = 'auth_provider_msal_home_account_id_key',
  /** unique or primary key constraint on columns "auth_provider_msal_id" */
  AuthProviderMsalPkey = 'auth_provider_msal_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AuthProviderMsalUserId = 'auth_provider_msal_user_id'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderMsalDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderMsalDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderMsalDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalInsertInput = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordObjRelInsertInput>;
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The home account id used for the msal login */
  home_account_id?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAuthProviderMsalMaxFields = {
  __typename?: 'argo_auth_provider_msal_max_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The home account id used for the msal login */
  home_account_id?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoAuthProviderMsalMinFields = {
  __typename?: 'argo_auth_provider_msal_min_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The home account id used for the msal login */
  home_account_id?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalMutationResponse = {
  __typename?: 'argo_auth_provider_msal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProviderMsal>;
};

/** on_conflict condition type for table "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalOnConflict = {
  constraint: ArgoAuthProviderMsalConstraint;
  update_columns?: Array<ArgoAuthProviderMsalUpdateColumn>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider_msal". */
export type ArgoAuthProviderMsalOrderBy = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordOrderBy>;
  auth_provider_record_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  hasura_role?: Maybe<OrderBy>;
  home_account_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  rsp?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider_msal */
export type ArgoAuthProviderMsalPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderMsalPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  HomeAccountId = 'home_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Rsp = 'rsp',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.auth_provider_msal" */
export type ArgoAuthProviderMsalSetInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The home account id used for the msal login */
  home_account_id?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Context Specific MSAL Configuration Setting */
export type ArgoAuthProviderMsalSetting = {
  __typename?: 'argo_auth_provider_msal_setting';
  /** An object relationship */
  auth_provider: ArgoAuthProvider;
  auth_provider_id: Scalars['String'];
  config: Scalars['argo_auth_provider_msal_setting_config'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Context Specific MSAL Configuration Setting */
export type ArgoAuthProviderMsalSettingConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingAggregate = {
  __typename?: 'argo_auth_provider_msal_setting_aggregate';
  aggregate?: Maybe<ArgoAuthProviderMsalSettingAggregateFields>;
  nodes: Array<ArgoAuthProviderMsalSetting>;
};

/** aggregate fields of "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingAggregateFields = {
  __typename?: 'argo_auth_provider_msal_setting_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderMsalSettingMaxFields>;
  min?: Maybe<ArgoAuthProviderMsalSettingMinFields>;
};


/** aggregate fields of "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderMsalSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderMsalSettingAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider_msal_setting". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderMsalSettingBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderMsalSettingBoolExp>>;
  _not?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderMsalSettingBoolExp>>;
  auth_provider?: Maybe<ArgoAuthProviderBoolExp>;
  auth_provider_id?: Maybe<StringComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};


/** unique or primary key constraints on table "argo.auth_provider_msal_setting" */
export enum ArgoAuthProviderMsalSettingConstraint {
  /** unique or primary key constraint on columns "context_id", "auth_provider_id" */
  AuthProviderMsalSettingAuthProviderIdContextIdKey = 'auth_provider_msal_setting_auth_provider_id_context_id_key',
  /** unique or primary key constraint on columns "auth_provider_msal_setting_id" */
  AuthProviderMsalSettingPkey = 'auth_provider_msal_setting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderMsalSettingDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderMsalSettingDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderMsalSettingDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingInsertInput = {
  auth_provider?: Maybe<ArgoAuthProviderObjRelInsertInput>;
  auth_provider_id?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAuthProviderMsalSettingMaxFields = {
  __typename?: 'argo_auth_provider_msal_setting_max_fields';
  auth_provider_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoAuthProviderMsalSettingMinFields = {
  __typename?: 'argo_auth_provider_msal_setting_min_fields';
  auth_provider_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingMutationResponse = {
  __typename?: 'argo_auth_provider_msal_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProviderMsalSetting>;
};

/** on_conflict condition type for table "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingOnConflict = {
  constraint: ArgoAuthProviderMsalSettingConstraint;
  update_columns?: Array<ArgoAuthProviderMsalSettingUpdateColumn>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider_msal_setting". */
export type ArgoAuthProviderMsalSettingOrderBy = {
  auth_provider?: Maybe<ArgoAuthProviderOrderBy>;
  auth_provider_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider_msal_setting */
export type ArgoAuthProviderMsalSettingPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderMsalSettingPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_provider_msal_setting" */
export enum ArgoAuthProviderMsalSettingSelectColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingSetInput = {
  auth_provider_id?: Maybe<Scalars['String']>;
  config: Scalars['argo_auth_provider_msal_setting_config'];
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_auth_provider_msal_setting" */
export type ArgoAuthProviderMsalSettingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderMsalSettingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderMsalSettingStreamCursorValueInput = {
  auth_provider_id?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.auth_provider_msal_setting" */
export enum ArgoAuthProviderMsalSettingUpdateColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAuthProviderMsalSettingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderMsalSettingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderMsalSettingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderMsalSettingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderMsalSettingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderMsalSettingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderMsalSettingSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderMsalSettingBoolExp;
};

/** Streaming cursor of the table "argo_auth_provider_msal" */
export type ArgoAuthProviderMsalStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderMsalStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderMsalStreamCursorValueInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Expected to always be user */
  hasura_role?: Maybe<Scalars['String']>;
  /** The home account id used for the msal login */
  home_account_id?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A subset of response data received during msal login */
  rsp?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user if authentication is successful */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  HomeAccountId = 'home_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Rsp = 'rsp',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type ArgoAuthProviderMsalUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderMsalAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderMsalDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderMsalDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderMsalDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderMsalPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderMsalSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderMsalBoolExp;
};

/** response of any mutation on the table "argo.auth_provider" */
export type ArgoAuthProviderMutationResponse = {
  __typename?: 'argo_auth_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProvider>;
};

/** input type for inserting object relation for remote table "argo.auth_provider" */
export type ArgoAuthProviderObjRelInsertInput = {
  data: ArgoAuthProviderInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthProviderOnConflict>;
};

/** on_conflict condition type for table "argo.auth_provider" */
export type ArgoAuthProviderOnConflict = {
  constraint: ArgoAuthProviderConstraint;
  update_columns?: Array<ArgoAuthProviderUpdateColumn>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider". */
export type ArgoAuthProviderOrderBy = {
  auth_provider_records_aggregate?: Maybe<ArgoAuthProviderRecordAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider */
export type ArgoAuthProviderPkColumnsInput = {
  /** ENUM single-column primary key of type text */
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Authentication Provider Record is a single table to reference each auth_provider regardless of its type */
export type ArgoAuthProviderRecord = {
  __typename?: 'argo_auth_provider_record';
  /** An object relationship */
  auth_provider: ArgoAuthProvider;
  /** The auth provider for this entry */
  auth_provider_id: Scalars['String'];
  /** An object relationship */
  auth_provider_local?: Maybe<ArgoAuthProviderLocal>;
  /** The primary key */
  auth_provider_record_id: Scalars['uuid'];
  /** An array relationship */
  auth_refresh_tokens: Array<ArgoAuthRefreshToken>;
  /** An aggregate relationship */
  auth_refresh_tokens_aggregate: ArgoAuthRefreshTokenAggregate;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
};


/** Authentication Provider Record is a single table to reference each auth_provider regardless of its type */
export type ArgoAuthProviderRecordAuthRefreshTokensArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Authentication Provider Record is a single table to reference each auth_provider regardless of its type */
export type ArgoAuthProviderRecordAuthRefreshTokensAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Authentication Provider Record is a single table to reference each auth_provider regardless of its type */
export type ArgoAuthProviderRecordMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_provider_record" */
export type ArgoAuthProviderRecordAggregate = {
  __typename?: 'argo_auth_provider_record_aggregate';
  aggregate?: Maybe<ArgoAuthProviderRecordAggregateFields>;
  nodes: Array<ArgoAuthProviderRecord>;
};

export type ArgoAuthProviderRecordAggregateBoolExp = {
  count?: Maybe<ArgoAuthProviderRecordAggregateBoolExpCount>;
};

export type ArgoAuthProviderRecordAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAuthProviderRecordBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.auth_provider_record" */
export type ArgoAuthProviderRecordAggregateFields = {
  __typename?: 'argo_auth_provider_record_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthProviderRecordMaxFields>;
  min?: Maybe<ArgoAuthProviderRecordMinFields>;
};


/** aggregate fields of "argo.auth_provider_record" */
export type ArgoAuthProviderRecordAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAuthProviderRecordMaxOrderBy>;
  min?: Maybe<ArgoAuthProviderRecordMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderRecordAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordArrRelInsertInput = {
  data: Array<ArgoAuthProviderRecordInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthProviderRecordOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.auth_provider_record". All fields are combined with a logical 'AND'. */
export type ArgoAuthProviderRecordBoolExp = {
  _and?: Maybe<Array<ArgoAuthProviderRecordBoolExp>>;
  _not?: Maybe<ArgoAuthProviderRecordBoolExp>;
  _or?: Maybe<Array<ArgoAuthProviderRecordBoolExp>>;
  auth_provider?: Maybe<ArgoAuthProviderBoolExp>;
  auth_provider_id?: Maybe<StringComparisonExp>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalBoolExp>;
  auth_provider_record_id?: Maybe<UuidComparisonExp>;
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenBoolExp>;
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderRecordPkey = 'auth_provider_record_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthProviderRecordDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthProviderRecordDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthProviderRecordDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordInsertInput = {
  auth_provider?: Maybe<ArgoAuthProviderObjRelInsertInput>;
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<Scalars['String']>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalObjRelInsertInput>;
  /** The primary key */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenArrRelInsertInput>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type ArgoAuthProviderRecordMaxFields = {
  __typename?: 'argo_auth_provider_record_max_fields';
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<Scalars['String']>;
  /** The primary key */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordMaxOrderBy = {
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<OrderBy>;
  /** The primary key */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAuthProviderRecordMinFields = {
  __typename?: 'argo_auth_provider_record_min_fields';
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<Scalars['String']>;
  /** The primary key */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordMinOrderBy = {
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<OrderBy>;
  /** The primary key */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordMutationResponse = {
  __typename?: 'argo_auth_provider_record_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthProviderRecord>;
};

/** input type for inserting object relation for remote table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordObjRelInsertInput = {
  data: ArgoAuthProviderRecordInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthProviderRecordOnConflict>;
};

/** on_conflict condition type for table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordOnConflict = {
  constraint: ArgoAuthProviderRecordConstraint;
  update_columns?: Array<ArgoAuthProviderRecordUpdateColumn>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_provider_record". */
export type ArgoAuthProviderRecordOrderBy = {
  auth_provider?: Maybe<ArgoAuthProviderOrderBy>;
  auth_provider_id?: Maybe<OrderBy>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalOrderBy>;
  auth_provider_record_id?: Maybe<OrderBy>;
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_provider_record */
export type ArgoAuthProviderRecordPkColumnsInput = {
  /** The primary key */
  auth_provider_record_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthProviderRecordPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordSelectColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Meta = 'meta'
}

/** input type for updating data in table "argo.auth_provider_record" */
export type ArgoAuthProviderRecordSetInput = {
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<Scalars['String']>;
  /** The primary key */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "argo_auth_provider_record" */
export type ArgoAuthProviderRecordStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderRecordStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderRecordStreamCursorValueInput = {
  /** The auth provider for this entry */
  auth_provider_id?: Maybe<Scalars['String']>;
  /** The primary key */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordUpdateColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Meta = 'meta'
}

export type ArgoAuthProviderRecordUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderRecordAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderRecordDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderRecordDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderRecordDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderRecordPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderRecordSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderRecordBoolExp;
};

/** select columns of table "argo.auth_provider" */
export enum ArgoAuthProviderSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.auth_provider" */
export type ArgoAuthProviderSetInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A description of each value */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** ENUM single-column primary key of type text */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_auth_provider" */
export type ArgoAuthProviderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthProviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthProviderStreamCursorValueInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A description of each value */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** ENUM single-column primary key of type text */
  id?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.auth_provider" */
export enum ArgoAuthProviderUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoAuthProviderUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthProviderAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthProviderDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthProviderDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthProviderDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthProviderPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthProviderSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthProviderBoolExp;
};

/** Refresh Tokens are expected to be managed by the user */
export type ArgoAuthRefreshToken = {
  __typename?: 'argo_auth_refresh_token';
  /** An object relationship */
  auth_provider_record: ArgoAuthProviderRecord;
  /** The auth provider record for this entry */
  auth_provider_record_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** When the refresh token is no longer valid */
  expires_at: Scalars['timestamptz'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The refresh token value */
  refresh_token: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: ArgoUser;
  /** The user */
  user_id: Scalars['uuid'];
};


/** Refresh Tokens are expected to be managed by the user */
export type ArgoAuthRefreshTokenMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenAggregate = {
  __typename?: 'argo_auth_refresh_token_aggregate';
  aggregate?: Maybe<ArgoAuthRefreshTokenAggregateFields>;
  nodes: Array<ArgoAuthRefreshToken>;
};

export type ArgoAuthRefreshTokenAggregateBoolExp = {
  count?: Maybe<ArgoAuthRefreshTokenAggregateBoolExpCount>;
};

export type ArgoAuthRefreshTokenAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoAuthRefreshTokenBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenAggregateFields = {
  __typename?: 'argo_auth_refresh_token_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoAuthRefreshTokenMaxFields>;
  min?: Maybe<ArgoAuthRefreshTokenMinFields>;
};


/** aggregate fields of "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoAuthRefreshTokenMaxOrderBy>;
  min?: Maybe<ArgoAuthRefreshTokenMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthRefreshTokenAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenArrRelInsertInput = {
  data: Array<ArgoAuthRefreshTokenInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoAuthRefreshTokenOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.auth_refresh_token". All fields are combined with a logical 'AND'. */
export type ArgoAuthRefreshTokenBoolExp = {
  _and?: Maybe<Array<ArgoAuthRefreshTokenBoolExp>>;
  _not?: Maybe<ArgoAuthRefreshTokenBoolExp>;
  _or?: Maybe<Array<ArgoAuthRefreshTokenBoolExp>>;
  auth_provider_record?: Maybe<ArgoAuthProviderRecordBoolExp>;
  auth_provider_record_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  expires_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  refresh_token?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenConstraint {
  /** unique or primary key constraint on columns "auth_refresh_token_id" */
  AuthRefreshTokenPkey = 'auth_refresh_token_pkey',
  /** unique or primary key constraint on columns "refresh_token" */
  AuthRefreshTokenRefreshTokenKey = 'auth_refresh_token_refresh_token_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoAuthRefreshTokenDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoAuthRefreshTokenDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoAuthRefreshTokenDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenInsertInput = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordObjRelInsertInput>;
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The refresh token value */
  refresh_token?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoAuthRefreshTokenMaxFields = {
  __typename?: 'argo_auth_refresh_token_max_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The refresh token value */
  refresh_token?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenMaxOrderBy = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The refresh token value */
  refresh_token?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user */
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoAuthRefreshTokenMinFields = {
  __typename?: 'argo_auth_refresh_token_min_fields';
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The refresh token value */
  refresh_token?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenMinOrderBy = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The refresh token value */
  refresh_token?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user */
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenMutationResponse = {
  __typename?: 'argo_auth_refresh_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoAuthRefreshToken>;
};

/** on_conflict condition type for table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenOnConflict = {
  constraint: ArgoAuthRefreshTokenConstraint;
  update_columns?: Array<ArgoAuthRefreshTokenUpdateColumn>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};

/** Ordering options when selecting data from "argo.auth_refresh_token". */
export type ArgoAuthRefreshTokenOrderBy = {
  auth_provider_record?: Maybe<ArgoAuthProviderRecordOrderBy>;
  auth_provider_record_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.auth_refresh_token */
export type ArgoAuthRefreshTokenPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoAuthRefreshTokenPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.auth_refresh_token" */
export type ArgoAuthRefreshTokenSetInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The refresh token value */
  refresh_token?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_auth_refresh_token" */
export type ArgoAuthRefreshTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoAuthRefreshTokenStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoAuthRefreshTokenStreamCursorValueInput = {
  /** The auth provider record for this entry */
  auth_provider_record_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** When the refresh token is no longer valid */
  expires_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The refresh token value */
  refresh_token?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type ArgoAuthRefreshTokenUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoAuthRefreshTokenAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoAuthRefreshTokenDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoAuthRefreshTokenDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoAuthRefreshTokenDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoAuthRefreshTokenPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoAuthRefreshTokenSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoAuthRefreshTokenBoolExp;
};

/** Head table for Calendar */
export type ArgoCalendar = {
  __typename?: 'argo_calendar';
  /** An array relationship */
  calendar_events: Array<ArgoCalendarEvent>;
  /** An aggregate relationship */
  calendar_events_aggregate: ArgoCalendarEventAggregate;
  /** An object relationship */
  calendar_locations?: Maybe<ArgoCalendarLocation>;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_default: Scalars['Boolean'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
  /** An object relationship */
  schedule?: Maybe<ArgoSchedule>;
  /** An array relationship */
  scheduleLocationsByScheduleId: Array<ArgoCalendarLocation>;
  /** An aggregate relationship */
  scheduleLocationsByScheduleId_aggregate: ArgoCalendarLocationAggregate;
  schedule_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  times?: Maybe<ArgoCalendarEvent>;
  timezone: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Head table for Calendar */
export type ArgoCalendarCalendarEventsArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Head table for Calendar */
export type ArgoCalendarCalendarEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Head table for Calendar */
export type ArgoCalendarMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Head table for Calendar */
export type ArgoCalendarScheduleLocationsByScheduleIdArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


/** Head table for Calendar */
export type ArgoCalendarScheduleLocationsByScheduleIdAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};

/** aggregated selection of "argo.calendar" */
export type ArgoCalendarAggregate = {
  __typename?: 'argo_calendar_aggregate';
  aggregate?: Maybe<ArgoCalendarAggregateFields>;
  nodes: Array<ArgoCalendar>;
};

export type ArgoCalendarAggregateBoolExp = {
  bool_and?: Maybe<ArgoCalendarAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoCalendarAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoCalendarAggregateBoolExpCount>;
};

export type ArgoCalendarAggregateBoolExpBoolAnd = {
  arguments: ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoCalendarAggregateBoolExpBoolOr = {
  arguments: ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoCalendarAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar" */
export type ArgoCalendarAggregateFields = {
  __typename?: 'argo_calendar_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarMaxFields>;
  min?: Maybe<ArgoCalendarMinFields>;
};


/** aggregate fields of "argo.calendar" */
export type ArgoCalendarAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar" */
export type ArgoCalendarAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarMaxOrderBy>;
  min?: Maybe<ArgoCalendarMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar" */
export type ArgoCalendarArrRelInsertInput = {
  data: Array<ArgoCalendarInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.calendar". All fields are combined with a logical 'AND'. */
export type ArgoCalendarBoolExp = {
  _and?: Maybe<Array<ArgoCalendarBoolExp>>;
  _not?: Maybe<ArgoCalendarBoolExp>;
  _or?: Maybe<Array<ArgoCalendarBoolExp>>;
  calendar_events?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateBoolExp>;
  calendar_locations?: Maybe<ArgoCalendarLocationBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_default?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  schedule?: Maybe<ArgoScheduleBoolExp>;
  scheduleLocationsByScheduleId?: Maybe<ArgoCalendarLocationBoolExp>;
  scheduleLocationsByScheduleId_aggregate?: Maybe<ArgoCalendarLocationAggregateBoolExp>;
  schedule_id?: Maybe<UuidComparisonExp>;
  times?: Maybe<ArgoCalendarEventBoolExp>;
  timezone?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar" */
export enum ArgoCalendarConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  CalendarNameUnique = 'calendar_name_unique',
  /** unique or primary key constraint on columns "calendar_id" */
  CalendarPkey = 'calendar_pkey'
}

/** columns and relationships of "argo.calendar_current_and_next" */
export type ArgoCalendarCurrentAndNext = {
  __typename?: 'argo_calendar_current_and_next';
  /** An object relationship */
  calendar?: Maybe<ArgoCalendar>;
  /** An object relationship */
  calendar_event?: Maybe<ArgoCalendarEvent>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['String']>;
  /** An object relationship */
  event?: Maybe<ArgoEvent>;
  event_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event_type?: Maybe<ArgoEventType>;
  event_type_id?: Maybe<Scalars['Int']>;
  filter_type?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  productive_time_elapsed?: Maybe<Scalars['float8']>;
  productive_time_remaining?: Maybe<Scalars['float8']>;
  range?: Maybe<Scalars['tsrange']>;
  time_end?: Maybe<Scalars['timestamp']>;
  time_start?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "argo.calendar_current_and_next" */
export type ArgoCalendarCurrentAndNextMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_current_and_next" */
export type ArgoCalendarCurrentAndNextAggregate = {
  __typename?: 'argo_calendar_current_and_next_aggregate';
  aggregate?: Maybe<ArgoCalendarCurrentAndNextAggregateFields>;
  nodes: Array<ArgoCalendarCurrentAndNext>;
};

/** aggregate fields of "argo.calendar_current_and_next" */
export type ArgoCalendarCurrentAndNextAggregateFields = {
  __typename?: 'argo_calendar_current_and_next_aggregate_fields';
  avg?: Maybe<ArgoCalendarCurrentAndNextAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarCurrentAndNextMaxFields>;
  min?: Maybe<ArgoCalendarCurrentAndNextMinFields>;
  stddev?: Maybe<ArgoCalendarCurrentAndNextStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarCurrentAndNextStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarCurrentAndNextStddevSampFields>;
  sum?: Maybe<ArgoCalendarCurrentAndNextSumFields>;
  var_pop?: Maybe<ArgoCalendarCurrentAndNextVarPopFields>;
  var_samp?: Maybe<ArgoCalendarCurrentAndNextVarSampFields>;
  variance?: Maybe<ArgoCalendarCurrentAndNextVarianceFields>;
};


/** aggregate fields of "argo.calendar_current_and_next" */
export type ArgoCalendarCurrentAndNextAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarCurrentAndNextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ArgoCalendarCurrentAndNextAvgFields = {
  __typename?: 'argo_calendar_current_and_next_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.calendar_current_and_next". All fields are combined with a logical 'AND'. */
export type ArgoCalendarCurrentAndNextBoolExp = {
  _and?: Maybe<Array<ArgoCalendarCurrentAndNextBoolExp>>;
  _not?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
  _or?: Maybe<Array<ArgoCalendarCurrentAndNextBoolExp>>;
  calendar?: Maybe<ArgoCalendarBoolExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  calendar_id?: Maybe<UuidComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  day?: Maybe<StringComparisonExp>;
  event?: Maybe<ArgoEventBoolExp>;
  event_id?: Maybe<UuidComparisonExp>;
  event_type?: Maybe<ArgoEventTypeBoolExp>;
  event_type_id?: Maybe<IntComparisonExp>;
  filter_type?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  productive_time_elapsed?: Maybe<Float8ComparisonExp>;
  productive_time_remaining?: Maybe<Float8ComparisonExp>;
  range?: Maybe<TsrangeComparisonExp>;
  time_end?: Maybe<TimestampComparisonExp>;
  time_start?: Maybe<TimestampComparisonExp>;
};

/** aggregate max on columns */
export type ArgoCalendarCurrentAndNextMaxFields = {
  __typename?: 'argo_calendar_current_and_next_max_fields';
  calendar_event_id?: Maybe<Scalars['uuid']>;
  calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['Int']>;
  filter_type?: Maybe<Scalars['String']>;
  productive_time_elapsed?: Maybe<Scalars['float8']>;
  productive_time_remaining?: Maybe<Scalars['float8']>;
  time_end?: Maybe<Scalars['timestamp']>;
  time_start?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type ArgoCalendarCurrentAndNextMinFields = {
  __typename?: 'argo_calendar_current_and_next_min_fields';
  calendar_event_id?: Maybe<Scalars['uuid']>;
  calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['Int']>;
  filter_type?: Maybe<Scalars['String']>;
  productive_time_elapsed?: Maybe<Scalars['float8']>;
  productive_time_remaining?: Maybe<Scalars['float8']>;
  time_end?: Maybe<Scalars['timestamp']>;
  time_start?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "argo.calendar_current_and_next". */
export type ArgoCalendarCurrentAndNextOrderBy = {
  calendar?: Maybe<ArgoCalendarOrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  calendar_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  day?: Maybe<OrderBy>;
  event?: Maybe<ArgoEventOrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type?: Maybe<ArgoEventTypeOrderBy>;
  event_type_id?: Maybe<OrderBy>;
  filter_type?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  productive_time_elapsed?: Maybe<OrderBy>;
  productive_time_remaining?: Maybe<OrderBy>;
  range?: Maybe<OrderBy>;
  time_end?: Maybe<OrderBy>;
  time_start?: Maybe<OrderBy>;
};

/** select columns of table "argo.calendar_current_and_next" */
export enum ArgoCalendarCurrentAndNextSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  FilterType = 'filter_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProductiveTimeElapsed = 'productive_time_elapsed',
  /** column name */
  ProductiveTimeRemaining = 'productive_time_remaining',
  /** column name */
  Range = 'range',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start'
}

/** aggregate stddev on columns */
export type ArgoCalendarCurrentAndNextStddevFields = {
  __typename?: 'argo_calendar_current_and_next_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarCurrentAndNextStddevPopFields = {
  __typename?: 'argo_calendar_current_and_next_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarCurrentAndNextStddevSampFields = {
  __typename?: 'argo_calendar_current_and_next_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_calendar_current_and_next" */
export type ArgoCalendarCurrentAndNextStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarCurrentAndNextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarCurrentAndNextStreamCursorValueInput = {
  calendar_event_id?: Maybe<Scalars['uuid']>;
  calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['Int']>;
  filter_type?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  productive_time_elapsed?: Maybe<Scalars['float8']>;
  productive_time_remaining?: Maybe<Scalars['float8']>;
  range?: Maybe<Scalars['tsrange']>;
  time_end?: Maybe<Scalars['timestamp']>;
  time_start?: Maybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type ArgoCalendarCurrentAndNextSumFields = {
  __typename?: 'argo_calendar_current_and_next_sum_fields';
  event_type_id?: Maybe<Scalars['Int']>;
  productive_time_elapsed?: Maybe<Scalars['float8']>;
  productive_time_remaining?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type ArgoCalendarCurrentAndNextVarPopFields = {
  __typename?: 'argo_calendar_current_and_next_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarCurrentAndNextVarSampFields = {
  __typename?: 'argo_calendar_current_and_next_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoCalendarCurrentAndNextVarianceFields = {
  __typename?: 'argo_calendar_current_and_next_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
  productive_time_elapsed?: Maybe<Scalars['Float']>;
  productive_time_remaining?: Maybe<Scalars['Float']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** Hour range for an event in a calendar. This defines the actual calendar with the possiblity of different event types overlapping */
export type ArgoCalendarEvent = {
  __typename?: 'argo_calendar_event';
  /** An object relationship */
  calendar: ArgoCalendar;
  /** The calendar for this entry */
  calendar_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day: ArgoScheduleDayEnum;
  /** An object relationship */
  event?: Maybe<ArgoEvent>;
  /** The event for this entry */
  event_id: Scalars['uuid'];
  /** The event type for this entry */
  event_type_id: Scalars['Int'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The time range for this entry */
  range: Scalars['tsrange'];
  /** An object relationship */
  schedule_day: ArgoScheduleDay;
  /** An object relationship */
  schedule_event?: Maybe<ArgoScheduleEvent>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  udf_data: Array<ArgoCalendarEventUdfData>;
  /** An aggregate relationship */
  udf_data_aggregate: ArgoCalendarEventUdfDataAggregate;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Hour range for an event in a calendar. This defines the actual calendar with the possiblity of different event types overlapping */
export type ArgoCalendarEventMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Hour range for an event in a calendar. This defines the actual calendar with the possiblity of different event types overlapping */
export type ArgoCalendarEventUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


/** Hour range for an event in a calendar. This defines the actual calendar with the possiblity of different event types overlapping */
export type ArgoCalendarEventUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};

/** aggregated selection of "argo.calendar_event" */
export type ArgoCalendarEventAggregate = {
  __typename?: 'argo_calendar_event_aggregate';
  aggregate?: Maybe<ArgoCalendarEventAggregateFields>;
  nodes: Array<ArgoCalendarEvent>;
};

export type ArgoCalendarEventAggregateBoolExp = {
  count?: Maybe<ArgoCalendarEventAggregateBoolExpCount>;
};

export type ArgoCalendarEventAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarEventBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar_event" */
export type ArgoCalendarEventAggregateFields = {
  __typename?: 'argo_calendar_event_aggregate_fields';
  avg?: Maybe<ArgoCalendarEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarEventMaxFields>;
  min?: Maybe<ArgoCalendarEventMinFields>;
  stddev?: Maybe<ArgoCalendarEventStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarEventStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarEventStddevSampFields>;
  sum?: Maybe<ArgoCalendarEventSumFields>;
  var_pop?: Maybe<ArgoCalendarEventVarPopFields>;
  var_samp?: Maybe<ArgoCalendarEventVarSampFields>;
  variance?: Maybe<ArgoCalendarEventVarianceFields>;
};


/** aggregate fields of "argo.calendar_event" */
export type ArgoCalendarEventAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar_event" */
export type ArgoCalendarEventAggregateOrderBy = {
  avg?: Maybe<ArgoCalendarEventAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarEventMaxOrderBy>;
  min?: Maybe<ArgoCalendarEventMinOrderBy>;
  stddev?: Maybe<ArgoCalendarEventStddevOrderBy>;
  stddev_pop?: Maybe<ArgoCalendarEventStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoCalendarEventStddevSampOrderBy>;
  sum?: Maybe<ArgoCalendarEventSumOrderBy>;
  var_pop?: Maybe<ArgoCalendarEventVarPopOrderBy>;
  var_samp?: Maybe<ArgoCalendarEventVarSampOrderBy>;
  variance?: Maybe<ArgoCalendarEventVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar_event" */
export type ArgoCalendarEventArrRelInsertInput = {
  data: Array<ArgoCalendarEventInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarEventOnConflict>;
};

/** aggregate avg on columns */
export type ArgoCalendarEventAvgFields = {
  __typename?: 'argo_calendar_event_avg_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventAvgOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.calendar_event". All fields are combined with a logical 'AND'. */
export type ArgoCalendarEventBoolExp = {
  _and?: Maybe<Array<ArgoCalendarEventBoolExp>>;
  _not?: Maybe<ArgoCalendarEventBoolExp>;
  _or?: Maybe<Array<ArgoCalendarEventBoolExp>>;
  calendar?: Maybe<ArgoCalendarBoolExp>;
  calendar_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  day?: Maybe<ArgoScheduleDayEnumComparisonExp>;
  event?: Maybe<ArgoEventBoolExp>;
  event_id?: Maybe<UuidComparisonExp>;
  event_type_id?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  range?: Maybe<TsrangeComparisonExp>;
  schedule_day?: Maybe<ArgoScheduleDayBoolExp>;
  schedule_event?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_event_id?: Maybe<UuidComparisonExp>;
  udf_data?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
  udf_data_aggregate?: Maybe<ArgoCalendarEventUdfDataAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar_event" */
export enum ArgoCalendarEventConstraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  CalendarEventPkey = 'calendar_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarEventDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarEventDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarEventDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.calendar_event" */
export type ArgoCalendarEventIncInput = {
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.calendar_event" */
export type ArgoCalendarEventInsertInput = {
  calendar?: Maybe<ArgoCalendarObjRelInsertInput>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  event?: Maybe<ArgoEventObjRelInsertInput>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  schedule_day?: Maybe<ArgoScheduleDayObjRelInsertInput>;
  schedule_event?: Maybe<ArgoScheduleEventObjRelInsertInput>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  udf_data?: Maybe<ArgoCalendarEventUdfDataArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarEventMaxFields = {
  __typename?: 'argo_calendar_event_max_fields';
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventMaxOrderBy = {
  /** The calendar for this entry */
  calendar_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The event for this entry */
  event_id?: Maybe<OrderBy>;
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarEventMinFields = {
  __typename?: 'argo_calendar_event_min_fields';
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventMinOrderBy = {
  /** The calendar for this entry */
  calendar_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The event for this entry */
  event_id?: Maybe<OrderBy>;
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar_event" */
export type ArgoCalendarEventMutationResponse = {
  __typename?: 'argo_calendar_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarEvent>;
};

/** input type for inserting object relation for remote table "argo.calendar_event" */
export type ArgoCalendarEventObjRelInsertInput = {
  data: ArgoCalendarEventInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarEventOnConflict>;
};

/** on_conflict condition type for table "argo.calendar_event" */
export type ArgoCalendarEventOnConflict = {
  constraint: ArgoCalendarEventConstraint;
  update_columns?: Array<ArgoCalendarEventUpdateColumn>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar_event". */
export type ArgoCalendarEventOrderBy = {
  calendar?: Maybe<ArgoCalendarOrderBy>;
  calendar_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  day?: Maybe<OrderBy>;
  event?: Maybe<ArgoEventOrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  range?: Maybe<OrderBy>;
  schedule_day?: Maybe<ArgoScheduleDayOrderBy>;
  schedule_event?: Maybe<ArgoScheduleEventOrderBy>;
  schedule_event_id?: Maybe<OrderBy>;
  udf_data_aggregate?: Maybe<ArgoCalendarEventUdfDataAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar_event */
export type ArgoCalendarEventPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_event" */
export enum ArgoCalendarEventSelectColumn {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** A prioritized sequence of sliced events for a calendar, memoized from f_event_sequence */
export type ArgoCalendarEventSequence = {
  __typename?: 'argo_calendar_event_sequence';
  /** An object relationship */
  calendar: ArgoCalendar;
  /** An object relationship */
  calendar_event: ArgoCalendarEvent;
  calendar_event_id: Scalars['uuid'];
  /** The calendar for this entry */
  calendar_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day: ArgoScheduleDayEnum;
  /** An object relationship */
  event: ArgoEvent;
  /** The event for this entry */
  event_id: Scalars['uuid'];
  /** The event type for this entry */
  event_type_id: Scalars['Int'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The time range for this entry */
  range: Scalars['tsrange'];
  /** An object relationship */
  schedule_day: ArgoScheduleDay;
  /** An object relationship */
  schedule_event?: Maybe<ArgoScheduleEvent>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** A prioritized sequence of sliced events for a calendar, memoized from f_event_sequence */
export type ArgoCalendarEventSequenceMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceAggregate = {
  __typename?: 'argo_calendar_event_sequence_aggregate';
  aggregate?: Maybe<ArgoCalendarEventSequenceAggregateFields>;
  nodes: Array<ArgoCalendarEventSequence>;
};

/** aggregate fields of "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceAggregateFields = {
  __typename?: 'argo_calendar_event_sequence_aggregate_fields';
  avg?: Maybe<ArgoCalendarEventSequenceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarEventSequenceMaxFields>;
  min?: Maybe<ArgoCalendarEventSequenceMinFields>;
  stddev?: Maybe<ArgoCalendarEventSequenceStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarEventSequenceStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarEventSequenceStddevSampFields>;
  sum?: Maybe<ArgoCalendarEventSequenceSumFields>;
  var_pop?: Maybe<ArgoCalendarEventSequenceVarPopFields>;
  var_samp?: Maybe<ArgoCalendarEventSequenceVarSampFields>;
  variance?: Maybe<ArgoCalendarEventSequenceVarianceFields>;
};


/** aggregate fields of "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarEventSequenceSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventSequenceAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoCalendarEventSequenceAvgFields = {
  __typename?: 'argo_calendar_event_sequence_avg_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.calendar_event_sequence". All fields are combined with a logical 'AND'. */
export type ArgoCalendarEventSequenceBoolExp = {
  _and?: Maybe<Array<ArgoCalendarEventSequenceBoolExp>>;
  _not?: Maybe<ArgoCalendarEventSequenceBoolExp>;
  _or?: Maybe<Array<ArgoCalendarEventSequenceBoolExp>>;
  calendar?: Maybe<ArgoCalendarBoolExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  calendar_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  day?: Maybe<ArgoScheduleDayEnumComparisonExp>;
  event?: Maybe<ArgoEventBoolExp>;
  event_id?: Maybe<UuidComparisonExp>;
  event_type_id?: Maybe<IntComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  range?: Maybe<TsrangeComparisonExp>;
  schedule_day?: Maybe<ArgoScheduleDayBoolExp>;
  schedule_event?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_event_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarEventSequenceDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarEventSequenceDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarEventSequenceDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceIncInput = {
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceInsertInput = {
  calendar?: Maybe<ArgoCalendarObjRelInsertInput>;
  calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  event?: Maybe<ArgoEventObjRelInsertInput>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  schedule_day?: Maybe<ArgoScheduleDayObjRelInsertInput>;
  schedule_event?: Maybe<ArgoScheduleEventObjRelInsertInput>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarEventSequenceMaxFields = {
  __typename?: 'argo_calendar_event_sequence_max_fields';
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoCalendarEventSequenceMinFields = {
  __typename?: 'argo_calendar_event_sequence_min_fields';
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceMutationResponse = {
  __typename?: 'argo_calendar_event_sequence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarEventSequence>;
};

/** Ordering options when selecting data from "argo.calendar_event_sequence". */
export type ArgoCalendarEventSequenceOrderBy = {
  calendar?: Maybe<ArgoCalendarOrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  calendar_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  day?: Maybe<OrderBy>;
  event?: Maybe<ArgoEventOrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  range?: Maybe<OrderBy>;
  schedule_day?: Maybe<ArgoScheduleDayOrderBy>;
  schedule_event?: Maybe<ArgoScheduleEventOrderBy>;
  schedule_event_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventSequencePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_event_sequence" */
export enum ArgoCalendarEventSequenceSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.calendar_event_sequence" */
export type ArgoCalendarEventSequenceSetInput = {
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoCalendarEventSequenceStddevFields = {
  __typename?: 'argo_calendar_event_sequence_stddev_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarEventSequenceStddevPopFields = {
  __typename?: 'argo_calendar_event_sequence_stddev_pop_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarEventSequenceStddevSampFields = {
  __typename?: 'argo_calendar_event_sequence_stddev_samp_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_calendar_event_sequence" */
export type ArgoCalendarEventSequenceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarEventSequenceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarEventSequenceStreamCursorValueInput = {
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoCalendarEventSequenceSumFields = {
  __typename?: 'argo_calendar_event_sequence_sum_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
};

export type ArgoCalendarEventSequenceUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarEventSequenceAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarEventSequenceDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarEventSequenceDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarEventSequenceDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoCalendarEventSequenceIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarEventSequencePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarEventSequenceSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarEventSequenceBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoCalendarEventSequenceVarPopFields = {
  __typename?: 'argo_calendar_event_sequence_var_pop_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarEventSequenceVarSampFields = {
  __typename?: 'argo_calendar_event_sequence_var_samp_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoCalendarEventSequenceVarianceFields = {
  __typename?: 'argo_calendar_event_sequence_variance_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** input type for updating data in table "argo.calendar_event" */
export type ArgoCalendarEventSetInput = {
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoCalendarEventStddevFields = {
  __typename?: 'argo_calendar_event_stddev_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventStddevOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarEventStddevPopFields = {
  __typename?: 'argo_calendar_event_stddev_pop_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventStddevPopOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarEventStddevSampFields = {
  __typename?: 'argo_calendar_event_stddev_samp_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventStddevSampOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_calendar_event" */
export type ArgoCalendarEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarEventStreamCursorValueInput = {
  /** The calendar for this entry */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A custom label to idenify the day of the shift regardless of the start day */
  day?: Maybe<ArgoScheduleDayEnum>;
  /** The event for this entry */
  event_id?: Maybe<Scalars['uuid']>;
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The time range for this entry */
  range?: Maybe<Scalars['tsrange']>;
  /** The optional schedule_event entry that created this entry */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoCalendarEventSumFields = {
  __typename?: 'argo_calendar_event_sum_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventSumOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** The UDF values assigned to Calendar Events */
export type ArgoCalendarEventUdfData = {
  __typename?: 'argo_calendar_event_udf_data';
  /** An object relationship */
  calendar_event: ArgoCalendarEvent;
  /** The Calendar Event this entry links to */
  calendar_event_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** An object relationship */
  udf_column: ArgoUdfColumn;
  /** The Event UDF Schema this entry links to */
  udf_column_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The UDF values assigned to Calendar Events */
export type ArgoCalendarEventUdfDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataAggregate = {
  __typename?: 'argo_calendar_event_udf_data_aggregate';
  aggregate?: Maybe<ArgoCalendarEventUdfDataAggregateFields>;
  nodes: Array<ArgoCalendarEventUdfData>;
};

export type ArgoCalendarEventUdfDataAggregateBoolExp = {
  count?: Maybe<ArgoCalendarEventUdfDataAggregateBoolExpCount>;
};

export type ArgoCalendarEventUdfDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataAggregateFields = {
  __typename?: 'argo_calendar_event_udf_data_aggregate_fields';
  avg?: Maybe<ArgoCalendarEventUdfDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarEventUdfDataMaxFields>;
  min?: Maybe<ArgoCalendarEventUdfDataMinFields>;
  stddev?: Maybe<ArgoCalendarEventUdfDataStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfDataStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfDataStddevSampFields>;
  sum?: Maybe<ArgoCalendarEventUdfDataSumFields>;
  var_pop?: Maybe<ArgoCalendarEventUdfDataVarPopFields>;
  var_samp?: Maybe<ArgoCalendarEventUdfDataVarSampFields>;
  variance?: Maybe<ArgoCalendarEventUdfDataVarianceFields>;
};


/** aggregate fields of "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataAggregateOrderBy = {
  avg?: Maybe<ArgoCalendarEventUdfDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarEventUdfDataMaxOrderBy>;
  min?: Maybe<ArgoCalendarEventUdfDataMinOrderBy>;
  stddev?: Maybe<ArgoCalendarEventUdfDataStddevOrderBy>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfDataStddevSampOrderBy>;
  sum?: Maybe<ArgoCalendarEventUdfDataSumOrderBy>;
  var_pop?: Maybe<ArgoCalendarEventUdfDataVarPopOrderBy>;
  var_samp?: Maybe<ArgoCalendarEventUdfDataVarSampOrderBy>;
  variance?: Maybe<ArgoCalendarEventUdfDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataArrRelInsertInput = {
  data: Array<ArgoCalendarEventUdfDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarEventUdfDataOnConflict>;
};

/** aggregate avg on columns */
export type ArgoCalendarEventUdfDataAvgFields = {
  __typename?: 'argo_calendar_event_udf_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.calendar_event_udf_data". All fields are combined with a logical 'AND'. */
export type ArgoCalendarEventUdfDataBoolExp = {
  _and?: Maybe<Array<ArgoCalendarEventUdfDataBoolExp>>;
  _not?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
  _or?: Maybe<Array<ArgoCalendarEventUdfDataBoolExp>>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataConstraint {
  /** unique or primary key constraint on columns "calendar_event_udf_data_id" */
  CalendarEventUdfDataPkey = 'calendar_event_udf_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "calendar_event_id" */
  CalendarEventUdfDataUnique = 'calendar_event_udf_data_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarEventUdfDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarEventUdfDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarEventUdfDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataIncInput = {
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataInsertInput = {
  calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarEventUdfDataMaxFields = {
  __typename?: 'argo_calendar_event_udf_data_max_fields';
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataMaxOrderBy = {
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarEventUdfDataMinFields = {
  __typename?: 'argo_calendar_event_udf_data_min_fields';
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataMinOrderBy = {
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataMutationResponse = {
  __typename?: 'argo_calendar_event_udf_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarEventUdfData>;
};

/** on_conflict condition type for table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataOnConflict = {
  constraint: ArgoCalendarEventUdfDataConstraint;
  update_columns?: Array<ArgoCalendarEventUdfDataUpdateColumn>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar_event_udf_data". */
export type ArgoCalendarEventUdfDataOrderBy = {
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar_event_udf_data */
export type ArgoCalendarEventUdfDataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataSetInput = {
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoCalendarEventUdfDataStddevFields = {
  __typename?: 'argo_calendar_event_udf_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarEventUdfDataStddevPopFields = {
  __typename?: 'argo_calendar_event_udf_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarEventUdfDataStddevSampFields = {
  __typename?: 'argo_calendar_event_udf_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarEventUdfDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarEventUdfDataStreamCursorValueInput = {
  /** The Calendar Event this entry links to */
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Event UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoCalendarEventUdfDataSumFields = {
  __typename?: 'argo_calendar_event_udf_data_sum_fields';
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataUpdateColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarEventUdfDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarEventUdfDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarEventUdfDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarEventUdfDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoCalendarEventUdfDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarEventUdfDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarEventUdfDataSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarEventUdfDataBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoCalendarEventUdfDataVarPopFields = {
  __typename?: 'argo_calendar_event_udf_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarEventUdfDataVarSampFields = {
  __typename?: 'argo_calendar_event_udf_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoCalendarEventUdfDataVarianceFields = {
  __typename?: 'argo_calendar_event_udf_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.calendar_event_udf_data" */
export type ArgoCalendarEventUdfDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** The default UDF values assigned to material during Calendar Event creation */
export type ArgoCalendarEventUdfDefaultData = {
  __typename?: 'argo_calendar_event_udf_default_data';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  num_val?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  schedule_event: ArgoScheduleEvent;
  /** The Schedule Event this entry links to */
  schedule_event_id: Scalars['uuid'];
  str_val?: Maybe<Scalars['String']>;
  /** An object relationship */
  udf_column: ArgoUdfColumn;
  /** The UDF Column this entry links to */
  udf_column_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The default UDF values assigned to material during Calendar Event creation */
export type ArgoCalendarEventUdfDefaultDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataAggregate = {
  __typename?: 'argo_calendar_event_udf_default_data_aggregate';
  aggregate?: Maybe<ArgoCalendarEventUdfDefaultDataAggregateFields>;
  nodes: Array<ArgoCalendarEventUdfDefaultData>;
};

export type ArgoCalendarEventUdfDefaultDataAggregateBoolExp = {
  count?: Maybe<ArgoCalendarEventUdfDefaultDataAggregateBoolExpCount>;
};

export type ArgoCalendarEventUdfDefaultDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataAggregateFields = {
  __typename?: 'argo_calendar_event_udf_default_data_aggregate_fields';
  avg?: Maybe<ArgoCalendarEventUdfDefaultDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarEventUdfDefaultDataMaxFields>;
  min?: Maybe<ArgoCalendarEventUdfDefaultDataMinFields>;
  stddev?: Maybe<ArgoCalendarEventUdfDefaultDataStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfDefaultDataStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfDefaultDataStddevSampFields>;
  sum?: Maybe<ArgoCalendarEventUdfDefaultDataSumFields>;
  var_pop?: Maybe<ArgoCalendarEventUdfDefaultDataVarPopFields>;
  var_samp?: Maybe<ArgoCalendarEventUdfDefaultDataVarSampFields>;
  variance?: Maybe<ArgoCalendarEventUdfDefaultDataVarianceFields>;
};


/** aggregate fields of "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataAggregateOrderBy = {
  avg?: Maybe<ArgoCalendarEventUdfDefaultDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarEventUdfDefaultDataMaxOrderBy>;
  min?: Maybe<ArgoCalendarEventUdfDefaultDataMinOrderBy>;
  stddev?: Maybe<ArgoCalendarEventUdfDefaultDataStddevOrderBy>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfDefaultDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfDefaultDataStddevSampOrderBy>;
  sum?: Maybe<ArgoCalendarEventUdfDefaultDataSumOrderBy>;
  var_pop?: Maybe<ArgoCalendarEventUdfDefaultDataVarPopOrderBy>;
  var_samp?: Maybe<ArgoCalendarEventUdfDefaultDataVarSampOrderBy>;
  variance?: Maybe<ArgoCalendarEventUdfDefaultDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfDefaultDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataArrRelInsertInput = {
  data: Array<ArgoCalendarEventUdfDefaultDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarEventUdfDefaultDataOnConflict>;
};

/** aggregate avg on columns */
export type ArgoCalendarEventUdfDefaultDataAvgFields = {
  __typename?: 'argo_calendar_event_udf_default_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.calendar_event_udf_default_data". All fields are combined with a logical 'AND'. */
export type ArgoCalendarEventUdfDefaultDataBoolExp = {
  _and?: Maybe<Array<ArgoCalendarEventUdfDefaultDataBoolExp>>;
  _not?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
  _or?: Maybe<Array<ArgoCalendarEventUdfDefaultDataBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  schedule_event?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_event_id?: Maybe<UuidComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataConstraint {
  /** unique or primary key constraint on columns "calendar_event_udf_default_data_id" */
  CalendarEventUdfDefaultDataPkey = 'calendar_event_udf_default_data_pkey',
  /** unique or primary key constraint on columns "schedule_event_id", "udf_column_id", "context_id" */
  CalendarEventUdfDefaultDataUnique = 'calendar_event_udf_default_data_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarEventUdfDefaultDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarEventUdfDefaultDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarEventUdfDefaultDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataIncInput = {
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  schedule_event?: Maybe<ArgoScheduleEventObjRelInsertInput>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  str_val?: Maybe<Scalars['String']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarEventUdfDefaultDataMaxFields = {
  __typename?: 'argo_calendar_event_udf_default_data_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  str_val?: Maybe<Scalars['String']>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarEventUdfDefaultDataMinFields = {
  __typename?: 'argo_calendar_event_udf_default_data_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  str_val?: Maybe<Scalars['String']>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataMutationResponse = {
  __typename?: 'argo_calendar_event_udf_default_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarEventUdfDefaultData>;
};

/** on_conflict condition type for table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataOnConflict = {
  constraint: ArgoCalendarEventUdfDefaultDataConstraint;
  update_columns?: Array<ArgoCalendarEventUdfDefaultDataUpdateColumn>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar_event_udf_default_data". */
export type ArgoCalendarEventUdfDefaultDataOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  schedule_event?: Maybe<ArgoScheduleEventOrderBy>;
  schedule_event_id?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar_event_udf_default_data */
export type ArgoCalendarEventUdfDefaultDataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfDefaultDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  str_val?: Maybe<Scalars['String']>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoCalendarEventUdfDefaultDataStddevFields = {
  __typename?: 'argo_calendar_event_udf_default_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarEventUdfDefaultDataStddevPopFields = {
  __typename?: 'argo_calendar_event_udf_default_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarEventUdfDefaultDataStddevSampFields = {
  __typename?: 'argo_calendar_event_udf_default_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarEventUdfDefaultDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarEventUdfDefaultDataStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  /** The Schedule Event this entry links to */
  schedule_event_id?: Maybe<Scalars['uuid']>;
  str_val?: Maybe<Scalars['String']>;
  /** The UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoCalendarEventUdfDefaultDataSumFields = {
  __typename?: 'argo_calendar_event_udf_default_data_sum_fields';
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "argo.calendar_event_udf_default_data" */
export enum ArgoCalendarEventUdfDefaultDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarEventUdfDefaultDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarEventUdfDefaultDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoCalendarEventUdfDefaultDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarEventUdfDefaultDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarEventUdfDefaultDataSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarEventUdfDefaultDataBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoCalendarEventUdfDefaultDataVarPopFields = {
  __typename?: 'argo_calendar_event_udf_default_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarEventUdfDefaultDataVarSampFields = {
  __typename?: 'argo_calendar_event_udf_default_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoCalendarEventUdfDefaultDataVarianceFields = {
  __typename?: 'argo_calendar_event_udf_default_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.calendar_event_udf_default_data" */
export type ArgoCalendarEventUdfDefaultDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Table to define the UDF columns linked to an Event */
export type ArgoCalendarEventUdfSchema = {
  __typename?: 'argo_calendar_event_udf_schema';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  event_type: ArgoEventType;
  /** The Event Type linked to this entry */
  event_type_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  udf_column?: Maybe<ArgoUdfColumn>;
  /** The UDF Column linked to this entry */
  udf_column_id: Scalars['uuid'];
  /** The UDF Column Type linked to this entry */
  udf_column_type: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define the UDF columns linked to an Event */
export type ArgoCalendarEventUdfSchemaMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaAggregate = {
  __typename?: 'argo_calendar_event_udf_schema_aggregate';
  aggregate?: Maybe<ArgoCalendarEventUdfSchemaAggregateFields>;
  nodes: Array<ArgoCalendarEventUdfSchema>;
};

export type ArgoCalendarEventUdfSchemaAggregateBoolExp = {
  count?: Maybe<ArgoCalendarEventUdfSchemaAggregateBoolExpCount>;
};

export type ArgoCalendarEventUdfSchemaAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaAggregateFields = {
  __typename?: 'argo_calendar_event_udf_schema_aggregate_fields';
  avg?: Maybe<ArgoCalendarEventUdfSchemaAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarEventUdfSchemaMaxFields>;
  min?: Maybe<ArgoCalendarEventUdfSchemaMinFields>;
  stddev?: Maybe<ArgoCalendarEventUdfSchemaStddevFields>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfSchemaStddevPopFields>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfSchemaStddevSampFields>;
  sum?: Maybe<ArgoCalendarEventUdfSchemaSumFields>;
  var_pop?: Maybe<ArgoCalendarEventUdfSchemaVarPopFields>;
  var_samp?: Maybe<ArgoCalendarEventUdfSchemaVarSampFields>;
  variance?: Maybe<ArgoCalendarEventUdfSchemaVarianceFields>;
};


/** aggregate fields of "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaAggregateOrderBy = {
  avg?: Maybe<ArgoCalendarEventUdfSchemaAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarEventUdfSchemaMaxOrderBy>;
  min?: Maybe<ArgoCalendarEventUdfSchemaMinOrderBy>;
  stddev?: Maybe<ArgoCalendarEventUdfSchemaStddevOrderBy>;
  stddev_pop?: Maybe<ArgoCalendarEventUdfSchemaStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoCalendarEventUdfSchemaStddevSampOrderBy>;
  sum?: Maybe<ArgoCalendarEventUdfSchemaSumOrderBy>;
  var_pop?: Maybe<ArgoCalendarEventUdfSchemaVarPopOrderBy>;
  var_samp?: Maybe<ArgoCalendarEventUdfSchemaVarSampOrderBy>;
  variance?: Maybe<ArgoCalendarEventUdfSchemaVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfSchemaAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaArrRelInsertInput = {
  data: Array<ArgoCalendarEventUdfSchemaInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarEventUdfSchemaOnConflict>;
};

/** aggregate avg on columns */
export type ArgoCalendarEventUdfSchemaAvgFields = {
  __typename?: 'argo_calendar_event_udf_schema_avg_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaAvgOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.calendar_event_udf_schema". All fields are combined with a logical 'AND'. */
export type ArgoCalendarEventUdfSchemaBoolExp = {
  _and?: Maybe<Array<ArgoCalendarEventUdfSchemaBoolExp>>;
  _not?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
  _or?: Maybe<Array<ArgoCalendarEventUdfSchemaBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  event_type?: Maybe<ArgoEventTypeBoolExp>;
  event_type_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  udf_column_type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "context_id" */
  CalendarEventUdfSchemaEnforceUnique = 'calendar_event_udf_schema_enforce_unique',
  /** unique or primary key constraint on columns "calendar_event_udf_schema_id" */
  CalendarEventUdfSchemaPkey = 'calendar_event_udf_schema_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarEventUdfSchemaDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarEventUdfSchemaDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarEventUdfSchemaDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaIncInput = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  event_type?: Maybe<ArgoEventTypeObjRelInsertInput>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarEventUdfSchemaMaxFields = {
  __typename?: 'argo_calendar_event_udf_schema_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<OrderBy>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarEventUdfSchemaMinFields = {
  __typename?: 'argo_calendar_event_udf_schema_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<OrderBy>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaMutationResponse = {
  __typename?: 'argo_calendar_event_udf_schema_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarEventUdfSchema>;
};

/** on_conflict condition type for table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaOnConflict = {
  constraint: ArgoCalendarEventUdfSchemaConstraint;
  update_columns?: Array<ArgoCalendarEventUdfSchemaUpdateColumn>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar_event_udf_schema". */
export type ArgoCalendarEventUdfSchemaOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  event_type?: Maybe<ArgoEventTypeOrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  udf_column_type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar_event_udf_schema */
export type ArgoCalendarEventUdfSchemaPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarEventUdfSchemaPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoCalendarEventUdfSchemaStddevFields = {
  __typename?: 'argo_calendar_event_udf_schema_stddev_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaStddevOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoCalendarEventUdfSchemaStddevPopFields = {
  __typename?: 'argo_calendar_event_udf_schema_stddev_pop_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaStddevPopOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoCalendarEventUdfSchemaStddevSampFields = {
  __typename?: 'argo_calendar_event_udf_schema_stddev_samp_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaStddevSampOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarEventUdfSchemaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarEventUdfSchemaStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoCalendarEventUdfSchemaSumFields = {
  __typename?: 'argo_calendar_event_udf_schema_sum_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaSumOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** update columns of table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarEventUdfSchemaUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarEventUdfSchemaAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarEventUdfSchemaDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarEventUdfSchemaDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarEventUdfSchemaDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoCalendarEventUdfSchemaIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarEventUdfSchemaPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarEventUdfSchemaSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarEventUdfSchemaBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoCalendarEventUdfSchemaVarPopFields = {
  __typename?: 'argo_calendar_event_udf_schema_var_pop_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaVarPopOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarEventUdfSchemaVarSampFields = {
  __typename?: 'argo_calendar_event_udf_schema_var_samp_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaVarSampOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoCalendarEventUdfSchemaVarianceFields = {
  __typename?: 'argo_calendar_event_udf_schema_variance_fields';
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.calendar_event_udf_schema" */
export type ArgoCalendarEventUdfSchemaVarianceOrderBy = {
  /** The Event Type linked to this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** update columns of table "argo.calendar_event" */
export enum ArgoCalendarEventUpdateColumn {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarEventUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarEventAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarEventDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarEventDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarEventDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoCalendarEventIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarEventPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarEventSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarEventBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoCalendarEventVarPopFields = {
  __typename?: 'argo_calendar_event_var_pop_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventVarPopOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoCalendarEventVarSampFields = {
  __typename?: 'argo_calendar_event_var_samp_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventVarSampOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoCalendarEventVarianceFields = {
  __typename?: 'argo_calendar_event_variance_fields';
  /** The event type for this entry */
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.calendar_event" */
export type ArgoCalendarEventVarianceOrderBy = {
  /** The event type for this entry */
  event_type_id?: Maybe<OrderBy>;
};

/** input type for inserting data into table "argo.calendar" */
export type ArgoCalendarInsertInput = {
  calendar_events?: Maybe<ArgoCalendarEventArrRelInsertInput>;
  calendar_locations?: Maybe<ArgoCalendarLocationObjRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule?: Maybe<ArgoScheduleObjRelInsertInput>;
  scheduleLocationsByScheduleId?: Maybe<ArgoCalendarLocationArrRelInsertInput>;
  schedule_id?: Maybe<Scalars['uuid']>;
  times?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  timezone?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Schedule to be active at a location during the active time range */
export type ArgoCalendarLocation = {
  __typename?: 'argo_calendar_location';
  /** The datetime stamp range that this record will be active at a location during */
  active_range: Scalars['tsrange'];
  /** An object relationship */
  calendar: ArgoCalendar;
  /** Schedule this entry is linked to */
  calendar_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  location: ArgoLocation;
  /** Location this entry is linked to */
  location_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoCalendarLocationMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.calendar_location" */
export type ArgoCalendarLocationAggregate = {
  __typename?: 'argo_calendar_location_aggregate';
  aggregate?: Maybe<ArgoCalendarLocationAggregateFields>;
  nodes: Array<ArgoCalendarLocation>;
};

export type ArgoCalendarLocationAggregateBoolExp = {
  bool_and?: Maybe<ArgoCalendarLocationAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoCalendarLocationAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoCalendarLocationAggregateBoolExpCount>;
};

export type ArgoCalendarLocationAggregateBoolExpBoolAnd = {
  arguments: ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarLocationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoCalendarLocationAggregateBoolExpBoolOr = {
  arguments: ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarLocationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoCalendarLocationAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoCalendarLocationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.calendar_location" */
export type ArgoCalendarLocationAggregateFields = {
  __typename?: 'argo_calendar_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoCalendarLocationMaxFields>;
  min?: Maybe<ArgoCalendarLocationMinFields>;
};


/** aggregate fields of "argo.calendar_location" */
export type ArgoCalendarLocationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.calendar_location" */
export type ArgoCalendarLocationAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoCalendarLocationMaxOrderBy>;
  min?: Maybe<ArgoCalendarLocationMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarLocationAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.calendar_location" */
export type ArgoCalendarLocationArrRelInsertInput = {
  data: Array<ArgoCalendarLocationInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarLocationOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.calendar_location". All fields are combined with a logical 'AND'. */
export type ArgoCalendarLocationBoolExp = {
  _and?: Maybe<Array<ArgoCalendarLocationBoolExp>>;
  _not?: Maybe<ArgoCalendarLocationBoolExp>;
  _or?: Maybe<Array<ArgoCalendarLocationBoolExp>>;
  active_range?: Maybe<TsrangeComparisonExp>;
  calendar?: Maybe<ArgoCalendarBoolExp>;
  calendar_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.calendar_location" */
export enum ArgoCalendarLocationConstraint {
  /** unique or primary key constraint on columns "calendar_location_id" */
  CalendarLocationPkey = 'calendar_location_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoCalendarLocationDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoCalendarLocationDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoCalendarLocationDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.calendar_location" */
export type ArgoCalendarLocationInsertInput = {
  /** The datetime stamp range that this record will be active at a location during */
  active_range?: Maybe<Scalars['tsrange']>;
  calendar?: Maybe<ArgoCalendarObjRelInsertInput>;
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** Location this entry is linked to */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoCalendarLocationMaxFields = {
  __typename?: 'argo_calendar_location_max_fields';
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Location this entry is linked to */
  location_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar_location" */
export type ArgoCalendarLocationMaxOrderBy = {
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Location this entry is linked to */
  location_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarLocationMinFields = {
  __typename?: 'argo_calendar_location_min_fields';
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Location this entry is linked to */
  location_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar_location" */
export type ArgoCalendarLocationMinOrderBy = {
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Location this entry is linked to */
  location_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar_location" */
export type ArgoCalendarLocationMutationResponse = {
  __typename?: 'argo_calendar_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendarLocation>;
};

/** input type for inserting object relation for remote table "argo.calendar_location" */
export type ArgoCalendarLocationObjRelInsertInput = {
  data: ArgoCalendarLocationInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarLocationOnConflict>;
};

/** on_conflict condition type for table "argo.calendar_location" */
export type ArgoCalendarLocationOnConflict = {
  constraint: ArgoCalendarLocationConstraint;
  update_columns?: Array<ArgoCalendarLocationUpdateColumn>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar_location". */
export type ArgoCalendarLocationOrderBy = {
  active_range?: Maybe<OrderBy>;
  calendar?: Maybe<ArgoCalendarOrderBy>;
  calendar_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar_location */
export type ArgoCalendarLocationPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarLocationPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumn {
  /** column name */
  ActiveRange = 'active_range',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_calendar_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_calendar_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.calendar_location" */
export type ArgoCalendarLocationSetInput = {
  /** The datetime stamp range that this record will be active at a location during */
  active_range?: Maybe<Scalars['tsrange']>;
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Location this entry is linked to */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_calendar_location" */
export type ArgoCalendarLocationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarLocationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarLocationStreamCursorValueInput = {
  /** The datetime stamp range that this record will be active at a location during */
  active_range?: Maybe<Scalars['tsrange']>;
  /** Schedule this entry is linked to */
  calendar_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Location this entry is linked to */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationUpdateColumn {
  /** column name */
  ActiveRange = 'active_range',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarLocationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarLocationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarLocationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarLocationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarLocationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarLocationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarLocationSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarLocationBoolExp;
};

/** aggregate max on columns */
export type ArgoCalendarMaxFields = {
  __typename?: 'argo_calendar_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.calendar" */
export type ArgoCalendarMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  schedule_id?: Maybe<OrderBy>;
  timezone?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoCalendarMinFields = {
  __typename?: 'argo_calendar_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.calendar" */
export type ArgoCalendarMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  schedule_id?: Maybe<OrderBy>;
  timezone?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.calendar" */
export type ArgoCalendarMutationResponse = {
  __typename?: 'argo_calendar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCalendar>;
};

/** input type for inserting object relation for remote table "argo.calendar" */
export type ArgoCalendarObjRelInsertInput = {
  data: ArgoCalendarInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoCalendarOnConflict>;
};

/** on_conflict condition type for table "argo.calendar" */
export type ArgoCalendarOnConflict = {
  constraint: ArgoCalendarConstraint;
  update_columns?: Array<ArgoCalendarUpdateColumn>;
  where?: Maybe<ArgoCalendarBoolExp>;
};

/** Ordering options when selecting data from "argo.calendar". */
export type ArgoCalendarOrderBy = {
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateOrderBy>;
  calendar_locations?: Maybe<ArgoCalendarLocationOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_default?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  schedule?: Maybe<ArgoScheduleOrderBy>;
  scheduleLocationsByScheduleId_aggregate?: Maybe<ArgoCalendarLocationAggregateOrderBy>;
  schedule_id?: Maybe<OrderBy>;
  times?: Maybe<ArgoCalendarEventOrderBy>;
  timezone?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.calendar */
export type ArgoCalendarPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoCalendarPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_calendar_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_calendar_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.calendar" */
export enum ArgoCalendarSelectColumnArgoCalendarAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "argo.calendar" */
export type ArgoCalendarSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_calendar" */
export type ArgoCalendarStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCalendarStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCalendarStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.calendar" */
export enum ArgoCalendarUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoCalendarUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoCalendarAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoCalendarDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoCalendarDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoCalendarDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoCalendarPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCalendarSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCalendarBoolExp;
};

/** Configuration describing how to connect and interact with external devices and system */
export type ArgoConnection = {
  __typename?: 'argo_connection';
  /** An array relationship */
  connection_configs: Array<ArgoConnectionConfig>;
  /** An aggregate relationship */
  connection_configs_aggregate: ArgoConnectionConfigAggregate;
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  /** The id of the connection */
  id: Scalars['uuid'];
  kind: ArgoConnectionKindEnum;
  name: Scalars['String'];
  name_unique: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Configuration describing how to connect and interact with external devices and system */
export type ArgoConnectionConnectionConfigsArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


/** Configuration describing how to connect and interact with external devices and system */
export type ArgoConnectionConnectionConfigsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};

/** aggregated selection of "argo.connection" */
export type ArgoConnectionAggregate = {
  __typename?: 'argo_connection_aggregate';
  aggregate?: Maybe<ArgoConnectionAggregateFields>;
  nodes: Array<ArgoConnection>;
};

/** aggregate fields of "argo.connection" */
export type ArgoConnectionAggregateFields = {
  __typename?: 'argo_connection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoConnectionMaxFields>;
  min?: Maybe<ArgoConnectionMinFields>;
};


/** aggregate fields of "argo.connection" */
export type ArgoConnectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoConnectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.connection". All fields are combined with a logical 'AND'. */
export type ArgoConnectionBoolExp = {
  _and?: Maybe<Array<ArgoConnectionBoolExp>>;
  _not?: Maybe<ArgoConnectionBoolExp>;
  _or?: Maybe<Array<ArgoConnectionBoolExp>>;
  connection_configs?: Maybe<ArgoConnectionConfigBoolExp>;
  connection_configs_aggregate?: Maybe<ArgoConnectionConfigAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  kind?: Maybe<ArgoConnectionKindEnumComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** A stateful representation of the configuration for a connection */
export type ArgoConnectionConfig = {
  __typename?: 'argo_connection_config';
  approved_by_id?: Maybe<Scalars['uuid']>;
  config: Scalars['jsonb'];
  /** An object relationship */
  connection: ArgoConnection;
  connection_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  /** The id of the connection configuration */
  id: Scalars['uuid'];
  status: ArgoConnectionConfigStatusEnum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};


/** A stateful representation of the configuration for a connection */
export type ArgoConnectionConfigConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.connection_config" */
export type ArgoConnectionConfigAggregate = {
  __typename?: 'argo_connection_config_aggregate';
  aggregate?: Maybe<ArgoConnectionConfigAggregateFields>;
  nodes: Array<ArgoConnectionConfig>;
};

export type ArgoConnectionConfigAggregateBoolExp = {
  count?: Maybe<ArgoConnectionConfigAggregateBoolExpCount>;
};

export type ArgoConnectionConfigAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoConnectionConfigBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.connection_config" */
export type ArgoConnectionConfigAggregateFields = {
  __typename?: 'argo_connection_config_aggregate_fields';
  avg?: Maybe<ArgoConnectionConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoConnectionConfigMaxFields>;
  min?: Maybe<ArgoConnectionConfigMinFields>;
  stddev?: Maybe<ArgoConnectionConfigStddevFields>;
  stddev_pop?: Maybe<ArgoConnectionConfigStddevPopFields>;
  stddev_samp?: Maybe<ArgoConnectionConfigStddevSampFields>;
  sum?: Maybe<ArgoConnectionConfigSumFields>;
  var_pop?: Maybe<ArgoConnectionConfigVarPopFields>;
  var_samp?: Maybe<ArgoConnectionConfigVarSampFields>;
  variance?: Maybe<ArgoConnectionConfigVarianceFields>;
};


/** aggregate fields of "argo.connection_config" */
export type ArgoConnectionConfigAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.connection_config" */
export type ArgoConnectionConfigAggregateOrderBy = {
  avg?: Maybe<ArgoConnectionConfigAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoConnectionConfigMaxOrderBy>;
  min?: Maybe<ArgoConnectionConfigMinOrderBy>;
  stddev?: Maybe<ArgoConnectionConfigStddevOrderBy>;
  stddev_pop?: Maybe<ArgoConnectionConfigStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoConnectionConfigStddevSampOrderBy>;
  sum?: Maybe<ArgoConnectionConfigSumOrderBy>;
  var_pop?: Maybe<ArgoConnectionConfigVarPopOrderBy>;
  var_samp?: Maybe<ArgoConnectionConfigVarSampOrderBy>;
  variance?: Maybe<ArgoConnectionConfigVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoConnectionConfigAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.connection_config" */
export type ArgoConnectionConfigArrRelInsertInput = {
  data: Array<ArgoConnectionConfigInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoConnectionConfigOnConflict>;
};

/** aggregate avg on columns */
export type ArgoConnectionConfigAvgFields = {
  __typename?: 'argo_connection_config_avg_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigAvgOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.connection_config". All fields are combined with a logical 'AND'. */
export type ArgoConnectionConfigBoolExp = {
  _and?: Maybe<Array<ArgoConnectionConfigBoolExp>>;
  _not?: Maybe<ArgoConnectionConfigBoolExp>;
  _or?: Maybe<Array<ArgoConnectionConfigBoolExp>>;
  approved_by_id?: Maybe<UuidComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  connection?: Maybe<ArgoConnectionBoolExp>;
  connection_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ArgoConnectionConfigStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  version_number?: Maybe<SmallintComparisonExp>;
};


/** unique or primary key constraints on table "argo.connection_config" */
export enum ArgoConnectionConfigConstraint {
  /** unique or primary key constraint on columns "connection_config_id" */
  ArgoConnectionConfigPkey = 'argo_connection_config_pkey',
  /** unique or primary key constraint on columns "connection_id" */
  ArgoConnectionConfigUniqueActiveVersion = 'argo_connection_config_unique_active_version',
  /** unique or primary key constraint on columns "version_number", "connection_id" */
  ArgoConnectionConfigUniqueVersionNumber = 'argo_connection_config_unique_version_number'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoConnectionConfigDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoConnectionConfigDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoConnectionConfigDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.connection_config" */
export type ArgoConnectionConfigIncInput = {
  version_number?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "argo.connection_config" */
export type ArgoConnectionConfigInsertInput = {
  approved_by_id?: Maybe<Scalars['uuid']>;
  config: Scalars['argo_connection_config_config'];
  connection?: Maybe<ArgoConnectionObjRelInsertInput>;
  connection_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection configuration */
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<ArgoConnectionConfigStatusEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type ArgoConnectionConfigMaxFields = {
  __typename?: 'argo_connection_config_max_fields';
  approved_by_id?: Maybe<Scalars['uuid']>;
  connection_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection configuration */
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigMaxOrderBy = {
  approved_by_id?: Maybe<OrderBy>;
  connection_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  /** The id of the connection configuration */
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoConnectionConfigMinFields = {
  __typename?: 'argo_connection_config_min_fields';
  approved_by_id?: Maybe<Scalars['uuid']>;
  connection_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection configuration */
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigMinOrderBy = {
  approved_by_id?: Maybe<OrderBy>;
  connection_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  /** The id of the connection configuration */
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.connection_config" */
export type ArgoConnectionConfigMutationResponse = {
  __typename?: 'argo_connection_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoConnectionConfig>;
};

/** on_conflict condition type for table "argo.connection_config" */
export type ArgoConnectionConfigOnConflict = {
  constraint: ArgoConnectionConfigConstraint;
  update_columns?: Array<ArgoConnectionConfigUpdateColumn>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};

/** Ordering options when selecting data from "argo.connection_config". */
export type ArgoConnectionConfigOrderBy = {
  approved_by_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  connection?: Maybe<ArgoConnectionOrderBy>;
  connection_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.connection_config */
export type ArgoConnectionConfigPkColumnsInput = {
  /** The id of the connection configuration */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoConnectionConfigPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.connection_config" */
export enum ArgoConnectionConfigSelectColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ConnectionId = 'connection_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

/** input type for updating data in table "argo.connection_config" */
export type ArgoConnectionConfigSetInput = {
  approved_by_id?: Maybe<Scalars['uuid']>;
  config?: Maybe<Scalars['argo_connection_config_config']>;
  connection_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection configuration */
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<ArgoConnectionConfigStatusEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** Status enum for connection configs */
export type ArgoConnectionConfigStatus = {
  __typename?: 'argo_connection_config_status';
  status: Scalars['String'];
};

/** aggregated selection of "argo.connection_config_status" */
export type ArgoConnectionConfigStatusAggregate = {
  __typename?: 'argo_connection_config_status_aggregate';
  aggregate?: Maybe<ArgoConnectionConfigStatusAggregateFields>;
  nodes: Array<ArgoConnectionConfigStatus>;
};

/** aggregate fields of "argo.connection_config_status" */
export type ArgoConnectionConfigStatusAggregateFields = {
  __typename?: 'argo_connection_config_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoConnectionConfigStatusMaxFields>;
  min?: Maybe<ArgoConnectionConfigStatusMinFields>;
};


/** aggregate fields of "argo.connection_config_status" */
export type ArgoConnectionConfigStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoConnectionConfigStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.connection_config_status". All fields are combined with a logical 'AND'. */
export type ArgoConnectionConfigStatusBoolExp = {
  _and?: Maybe<Array<ArgoConnectionConfigStatusBoolExp>>;
  _not?: Maybe<ArgoConnectionConfigStatusBoolExp>;
  _or?: Maybe<Array<ArgoConnectionConfigStatusBoolExp>>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoConnectionConfigStatusPkey = 'argo_connection_config_status_pkey'
}

export enum ArgoConnectionConfigStatusEnum {
  Released = 'released',
  Retired = 'retired',
  Staged = 'staged'
}

/** Boolean expression to compare columns of type "argo_connection_config_status_enum". All fields are combined with logical 'AND'. */
export type ArgoConnectionConfigStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoConnectionConfigStatusEnum>;
  _in?: Maybe<Array<ArgoConnectionConfigStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoConnectionConfigStatusEnum>;
  _nin?: Maybe<Array<ArgoConnectionConfigStatusEnum>>;
};

/** input type for inserting data into table "argo.connection_config_status" */
export type ArgoConnectionConfigStatusInsertInput = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoConnectionConfigStatusMaxFields = {
  __typename?: 'argo_connection_config_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoConnectionConfigStatusMinFields = {
  __typename?: 'argo_connection_config_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.connection_config_status" */
export type ArgoConnectionConfigStatusMutationResponse = {
  __typename?: 'argo_connection_config_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoConnectionConfigStatus>;
};

/** on_conflict condition type for table "argo.connection_config_status" */
export type ArgoConnectionConfigStatusOnConflict = {
  constraint: ArgoConnectionConfigStatusConstraint;
  update_columns?: Array<ArgoConnectionConfigStatusUpdateColumn>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.connection_config_status". */
export type ArgoConnectionConfigStatusOrderBy = {
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.connection_config_status */
export type ArgoConnectionConfigStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.connection_config_status" */
export type ArgoConnectionConfigStatusSetInput = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_connection_config_status" */
export type ArgoConnectionConfigStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoConnectionConfigStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoConnectionConfigStatusStreamCursorValueInput = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

export type ArgoConnectionConfigStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoConnectionConfigStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoConnectionConfigStatusBoolExp;
};

/** aggregate stddev on columns */
export type ArgoConnectionConfigStddevFields = {
  __typename?: 'argo_connection_config_stddev_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigStddevOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoConnectionConfigStddevPopFields = {
  __typename?: 'argo_connection_config_stddev_pop_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigStddevPopOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoConnectionConfigStddevSampFields = {
  __typename?: 'argo_connection_config_stddev_samp_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigStddevSampOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_connection_config" */
export type ArgoConnectionConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoConnectionConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoConnectionConfigStreamCursorValueInput = {
  approved_by_id?: Maybe<Scalars['uuid']>;
  config?: Maybe<Scalars['jsonb']>;
  connection_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection configuration */
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<ArgoConnectionConfigStatusEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  version_number?: Maybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type ArgoConnectionConfigSumFields = {
  __typename?: 'argo_connection_config_sum_fields';
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigSumOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** update columns of table "argo.connection_config" */
export enum ArgoConnectionConfigUpdateColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ConnectionId = 'connection_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

export type ArgoConnectionConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoConnectionConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoConnectionConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoConnectionConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoConnectionConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoConnectionConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoConnectionConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoConnectionConfigSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoConnectionConfigBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoConnectionConfigVarPopFields = {
  __typename?: 'argo_connection_config_var_pop_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigVarPopOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoConnectionConfigVarSampFields = {
  __typename?: 'argo_connection_config_var_samp_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigVarSampOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoConnectionConfigVarianceFields = {
  __typename?: 'argo_connection_config_variance_fields';
  version_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.connection_config" */
export type ArgoConnectionConfigVarianceOrderBy = {
  version_number?: Maybe<OrderBy>;
};

/** unique or primary key constraints on table "argo.connection" */
export enum ArgoConnectionConstraint {
  /** unique or primary key constraint on columns "connection_id" */
  ArgoConnectionPkey = 'argo_connection_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ArgoConnectionUniqueName = 'argo_connection_unique_name'
}

/** input type for inserting data into table "argo.connection" */
export type ArgoConnectionInsertInput = {
  connection_configs?: Maybe<ArgoConnectionConfigArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection */
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoConnectionKindEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Connection kind for a connection */
export type ArgoConnectionKind = {
  __typename?: 'argo_connection_kind';
  kind: Scalars['String'];
};

/** aggregated selection of "argo.connection_kind" */
export type ArgoConnectionKindAggregate = {
  __typename?: 'argo_connection_kind_aggregate';
  aggregate?: Maybe<ArgoConnectionKindAggregateFields>;
  nodes: Array<ArgoConnectionKind>;
};

/** aggregate fields of "argo.connection_kind" */
export type ArgoConnectionKindAggregateFields = {
  __typename?: 'argo_connection_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoConnectionKindMaxFields>;
  min?: Maybe<ArgoConnectionKindMinFields>;
};


/** aggregate fields of "argo.connection_kind" */
export type ArgoConnectionKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoConnectionKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.connection_kind". All fields are combined with a logical 'AND'. */
export type ArgoConnectionKindBoolExp = {
  _and?: Maybe<Array<ArgoConnectionKindBoolExp>>;
  _not?: Maybe<ArgoConnectionKindBoolExp>;
  _or?: Maybe<Array<ArgoConnectionKindBoolExp>>;
  kind?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.connection_kind" */
export enum ArgoConnectionKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  ArgoConnectionKindPkey = 'argo_connection_kind_pkey'
}

export enum ArgoConnectionKindEnum {
  IoLinkMaster = 'ioLinkMaster',
  MqttBroker = 'mqttBroker',
  Ptl110PickLight = 'ptl110PickLight',
  Serial = 'serial',
  TcpClient = 'tcpClient',
  TcpServer = 'tcpServer',
  UdpSocket = 'udpSocket'
}

/** Boolean expression to compare columns of type "argo_connection_kind_enum". All fields are combined with logical 'AND'. */
export type ArgoConnectionKindEnumComparisonExp = {
  _eq?: Maybe<ArgoConnectionKindEnum>;
  _in?: Maybe<Array<ArgoConnectionKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoConnectionKindEnum>;
  _nin?: Maybe<Array<ArgoConnectionKindEnum>>;
};

/** input type for inserting data into table "argo.connection_kind" */
export type ArgoConnectionKindInsertInput = {
  kind?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoConnectionKindMaxFields = {
  __typename?: 'argo_connection_kind_max_fields';
  kind?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoConnectionKindMinFields = {
  __typename?: 'argo_connection_kind_min_fields';
  kind?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.connection_kind" */
export type ArgoConnectionKindMutationResponse = {
  __typename?: 'argo_connection_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoConnectionKind>;
};

/** on_conflict condition type for table "argo.connection_kind" */
export type ArgoConnectionKindOnConflict = {
  constraint: ArgoConnectionKindConstraint;
  update_columns?: Array<ArgoConnectionKindUpdateColumn>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};

/** Ordering options when selecting data from "argo.connection_kind". */
export type ArgoConnectionKindOrderBy = {
  kind?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.connection_kind */
export type ArgoConnectionKindPkColumnsInput = {
  kind: Scalars['String'];
};

/** select columns of table "argo.connection_kind" */
export enum ArgoConnectionKindSelectColumn {
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "argo.connection_kind" */
export type ArgoConnectionKindSetInput = {
  kind?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_connection_kind" */
export type ArgoConnectionKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoConnectionKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoConnectionKindStreamCursorValueInput = {
  kind?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.connection_kind" */
export enum ArgoConnectionKindUpdateColumn {
  /** column name */
  Kind = 'kind'
}

export type ArgoConnectionKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoConnectionKindSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoConnectionKindBoolExp;
};

/** aggregate max on columns */
export type ArgoConnectionMaxFields = {
  __typename?: 'argo_connection_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection */
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoConnectionMinFields = {
  __typename?: 'argo_connection_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection */
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.connection" */
export type ArgoConnectionMutationResponse = {
  __typename?: 'argo_connection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoConnection>;
};

/** input type for inserting object relation for remote table "argo.connection" */
export type ArgoConnectionObjRelInsertInput = {
  data: ArgoConnectionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoConnectionOnConflict>;
};

/** on_conflict condition type for table "argo.connection" */
export type ArgoConnectionOnConflict = {
  constraint: ArgoConnectionConstraint;
  update_columns?: Array<ArgoConnectionUpdateColumn>;
  where?: Maybe<ArgoConnectionBoolExp>;
};

/** Ordering options when selecting data from "argo.connection". */
export type ArgoConnectionOrderBy = {
  connection_configs_aggregate?: Maybe<ArgoConnectionConfigAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.connection */
export type ArgoConnectionPkColumnsInput = {
  /** The id of the connection */
  id: Scalars['uuid'];
};

/** select columns of table "argo.connection" */
export enum ArgoConnectionSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.connection" */
export type ArgoConnectionSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection */
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoConnectionKindEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_connection" */
export type ArgoConnectionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoConnectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoConnectionStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The id of the connection */
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoConnectionKindEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.connection" */
export enum ArgoConnectionUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoConnectionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoConnectionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoConnectionBoolExp;
};

/** Multi-tenant identifiers */
export type ArgoContext = {
  __typename?: 'argo_context';
  /** An array relationship */
  auth_refresh_tokens: Array<ArgoAuthRefreshToken>;
  /** An aggregate relationship */
  auth_refresh_tokens_aggregate: ArgoAuthRefreshTokenAggregate;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** The description for this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The name for this entry */
  name: Scalars['String'];
  /** An array relationship */
  roles: Array<ArgoRole>;
  /** An aggregate relationship */
  roles_aggregate: ArgoRoleAggregate;
  /** When this entry was last updated */
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_contexts: Array<ArgoUserContext>;
  /** An aggregate relationship */
  user_contexts_aggregate: ArgoUserContextAggregate;
  /** An array relationship */
  user_roles: Array<ArgoUserRole>;
  /** An aggregate relationship */
  user_roles_aggregate: ArgoUserRoleAggregate;
};


/** Multi-tenant identifiers */
export type ArgoContextAuthRefreshTokensArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextAuthRefreshTokensAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Multi-tenant identifiers */
export type ArgoContextRolesArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextUserContextsArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextUserContextsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


/** Multi-tenant identifiers */
export type ArgoContextUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};

/** aggregated selection of "argo.context" */
export type ArgoContextAggregate = {
  __typename?: 'argo_context_aggregate';
  aggregate?: Maybe<ArgoContextAggregateFields>;
  nodes: Array<ArgoContext>;
};

/** aggregate fields of "argo.context" */
export type ArgoContextAggregateFields = {
  __typename?: 'argo_context_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoContextMaxFields>;
  min?: Maybe<ArgoContextMinFields>;
};


/** aggregate fields of "argo.context" */
export type ArgoContextAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoContextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoContextAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.context". All fields are combined with a logical 'AND'. */
export type ArgoContextBoolExp = {
  _and?: Maybe<Array<ArgoContextBoolExp>>;
  _not?: Maybe<ArgoContextBoolExp>;
  _or?: Maybe<Array<ArgoContextBoolExp>>;
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenBoolExp>;
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  roles?: Maybe<ArgoRoleBoolExp>;
  roles_aggregate?: Maybe<ArgoRoleAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_contexts?: Maybe<ArgoUserContextBoolExp>;
  user_contexts_aggregate?: Maybe<ArgoUserContextAggregateBoolExp>;
  user_roles?: Maybe<ArgoUserRoleBoolExp>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.context" */
export enum ArgoContextConstraint {
  /** unique or primary key constraint on columns "name" */
  ContextNameKey = 'context_name_key',
  /** unique or primary key constraint on columns "context_id" */
  ContextPkey = 'context_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoContextDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoContextDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoContextDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.context" */
export type ArgoContextInsertInput = {
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenArrRelInsertInput>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  roles?: Maybe<ArgoRoleArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_contexts?: Maybe<ArgoUserContextArrRelInsertInput>;
  user_roles?: Maybe<ArgoUserRoleArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoContextMaxFields = {
  __typename?: 'argo_context_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ArgoContextMinFields = {
  __typename?: 'argo_context_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "argo.context" */
export type ArgoContextMutationResponse = {
  __typename?: 'argo_context_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoContext>;
};

/** input type for inserting object relation for remote table "argo.context" */
export type ArgoContextObjRelInsertInput = {
  data: ArgoContextInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoContextOnConflict>;
};

/** on_conflict condition type for table "argo.context" */
export type ArgoContextOnConflict = {
  constraint: ArgoContextConstraint;
  update_columns?: Array<ArgoContextUpdateColumn>;
  where?: Maybe<ArgoContextBoolExp>;
};

/** Ordering options when selecting data from "argo.context". */
export type ArgoContextOrderBy = {
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  roles_aggregate?: Maybe<ArgoRoleAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_contexts_aggregate?: Maybe<ArgoUserContextAggregateOrderBy>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateOrderBy>;
};

/** primary key columns input for table: argo.context */
export type ArgoContextPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoContextPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.context" */
export enum ArgoContextSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "argo.context" */
export type ArgoContextSetInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "argo_context" */
export type ArgoContextStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoContextStreamCursorValueInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "argo.context" */
export enum ArgoContextUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ArgoContextUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoContextAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoContextDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoContextDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoContextDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoContextPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoContextSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoContextBoolExp;
};

export type ArgoCreateMaterialArgs = {
  create_material_data?: Maybe<Scalars['json']>;
  debug?: Maybe<Scalars['Boolean']>;
  material_data?: Maybe<Scalars['argo_create_material_data']>;
};


export type ArgoCreateMaterialsArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  material_data?: Maybe<Scalars['_json']>;
};

export type ArgoCreateWorkInstructionInstanceArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  work_instruction_data?: Maybe<Scalars['argo_get_or_create_work_instruction_data']>;
};

/** Cron Task Configuration */
export type ArgoCronTask = {
  __typename?: 'argo_cron_task';
  created_at: Scalars['timestamptz'];
  cron_name: Scalars['String'];
  db_function: Scalars['String'];
  enabled: Scalars['Boolean'];
  setting?: Maybe<Scalars['json']>;
};


/** Cron Task Configuration */
export type ArgoCronTaskSettingArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.cron_task" */
export type ArgoCronTaskAggregate = {
  __typename?: 'argo_cron_task_aggregate';
  aggregate?: Maybe<ArgoCronTaskAggregateFields>;
  nodes: Array<ArgoCronTask>;
};

/** aggregate fields of "argo.cron_task" */
export type ArgoCronTaskAggregateFields = {
  __typename?: 'argo_cron_task_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoCronTaskMaxFields>;
  min?: Maybe<ArgoCronTaskMinFields>;
};


/** aggregate fields of "argo.cron_task" */
export type ArgoCronTaskAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.cron_task". All fields are combined with a logical 'AND'. */
export type ArgoCronTaskBoolExp = {
  _and?: Maybe<Array<ArgoCronTaskBoolExp>>;
  _not?: Maybe<ArgoCronTaskBoolExp>;
  _or?: Maybe<Array<ArgoCronTaskBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  cron_name?: Maybe<StringComparisonExp>;
  db_function?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  setting?: Maybe<JsonComparisonExp>;
};

/** unique or primary key constraints on table "argo.cron_task" */
export enum ArgoCronTaskConstraint {
  /** unique or primary key constraint on columns "cron_name" */
  CronTaskPkey = 'cron_task_pkey'
}

/** input type for inserting data into table "argo.cron_task" */
export type ArgoCronTaskInsertInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  cron_name?: Maybe<Scalars['String']>;
  db_function?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  setting?: Maybe<Scalars['json']>;
};

/** aggregate max on columns */
export type ArgoCronTaskMaxFields = {
  __typename?: 'argo_cron_task_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cron_name?: Maybe<Scalars['String']>;
  db_function?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoCronTaskMinFields = {
  __typename?: 'argo_cron_task_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cron_name?: Maybe<Scalars['String']>;
  db_function?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.cron_task" */
export type ArgoCronTaskMutationResponse = {
  __typename?: 'argo_cron_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoCronTask>;
};

/** on_conflict condition type for table "argo.cron_task" */
export type ArgoCronTaskOnConflict = {
  constraint: ArgoCronTaskConstraint;
  update_columns?: Array<ArgoCronTaskUpdateColumn>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};

/** Ordering options when selecting data from "argo.cron_task". */
export type ArgoCronTaskOrderBy = {
  created_at?: Maybe<OrderBy>;
  cron_name?: Maybe<OrderBy>;
  db_function?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  setting?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.cron_task */
export type ArgoCronTaskPkColumnsInput = {
  cron_name: Scalars['String'];
};

/** select columns of table "argo.cron_task" */
export enum ArgoCronTaskSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CronName = 'cron_name',
  /** column name */
  DbFunction = 'db_function',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Setting = 'setting'
}

/** input type for updating data in table "argo.cron_task" */
export type ArgoCronTaskSetInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  cron_name?: Maybe<Scalars['String']>;
  db_function?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  setting?: Maybe<Scalars['json']>;
};

/** Streaming cursor of the table "argo_cron_task" */
export type ArgoCronTaskStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoCronTaskStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoCronTaskStreamCursorValueInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  cron_name?: Maybe<Scalars['String']>;
  db_function?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  setting?: Maybe<Scalars['json']>;
};

/** update columns of table "argo.cron_task" */
export enum ArgoCronTaskUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CronName = 'cron_name',
  /** column name */
  DbFunction = 'db_function',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Setting = 'setting'
}

export type ArgoCronTaskUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoCronTaskSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoCronTaskBoolExp;
};

/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEvent = {
  __typename?: 'argo_event';
  /** An array relationship */
  calendar_events: Array<ArgoCalendarEvent>;
  /** An aggregate relationship */
  calendar_events_aggregate: ArgoCalendarEventAggregate;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** An object relationship */
  event_type?: Maybe<ArgoEventType>;
  event_type_id?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
  /** An array relationship */
  schedule_events: Array<ArgoScheduleEvent>;
  /** An aggregate relationship */
  schedule_events_aggregate: ArgoScheduleEventAggregate;
  /** An object relationship */
  times?: Maybe<ArgoCalendarEvent>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<ArgoUser>;
  /** An object relationship */
  userByUpdatedById?: Maybe<ArgoUser>;
};


/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEventCalendarEventsArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEventCalendarEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEventMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEventScheduleEventsArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


/** Events to be used on a given Schedule and Calendar (Meta contains event identifier data) */
export type ArgoEventScheduleEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};

/** aggregated selection of "argo.event" */
export type ArgoEventAggregate = {
  __typename?: 'argo_event_aggregate';
  aggregate?: Maybe<ArgoEventAggregateFields>;
  nodes: Array<ArgoEvent>;
};

/** aggregate fields of "argo.event" */
export type ArgoEventAggregateFields = {
  __typename?: 'argo_event_aggregate_fields';
  avg?: Maybe<ArgoEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoEventMaxFields>;
  min?: Maybe<ArgoEventMinFields>;
  stddev?: Maybe<ArgoEventStddevFields>;
  stddev_pop?: Maybe<ArgoEventStddevPopFields>;
  stddev_samp?: Maybe<ArgoEventStddevSampFields>;
  sum?: Maybe<ArgoEventSumFields>;
  var_pop?: Maybe<ArgoEventVarPopFields>;
  var_samp?: Maybe<ArgoEventVarSampFields>;
  variance?: Maybe<ArgoEventVarianceFields>;
};


/** aggregate fields of "argo.event" */
export type ArgoEventAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoEventAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoEventAvgFields = {
  __typename?: 'argo_event_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.event". All fields are combined with a logical 'AND'. */
export type ArgoEventBoolExp = {
  _and?: Maybe<Array<ArgoEventBoolExp>>;
  _not?: Maybe<ArgoEventBoolExp>;
  _or?: Maybe<Array<ArgoEventBoolExp>>;
  calendar_events?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  event_type?: Maybe<ArgoEventTypeBoolExp>;
  event_type_id?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  schedule_events?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateBoolExp>;
  times?: Maybe<ArgoCalendarEventBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  userByUpdatedById?: Maybe<ArgoUserBoolExp>;
};

/** unique or primary key constraints on table "argo.event" */
export enum ArgoEventConstraint {
  /** unique or primary key constraint on columns "event_id" */
  EventPkey = 'event_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  EventUniqueName = 'event_unique_name',
  /** unique or primary key constraint on columns "event_type_id", "event_id" */
  UniqueEventTypeFk = 'unique_event_type_fk'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoEventDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoEventDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoEventDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.event" */
export type ArgoEventIncInput = {
  event_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.event" */
export type ArgoEventInsertInput = {
  calendar_events?: Maybe<ArgoCalendarEventArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  event_type?: Maybe<ArgoEventTypeObjRelInsertInput>;
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_events?: Maybe<ArgoScheduleEventArrRelInsertInput>;
  times?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  userByUpdatedById?: Maybe<ArgoUserObjRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoEventMaxFields = {
  __typename?: 'argo_event_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoEventMinFields = {
  __typename?: 'argo_event_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.event" */
export type ArgoEventMutationResponse = {
  __typename?: 'argo_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoEvent>;
};

/** input type for inserting object relation for remote table "argo.event" */
export type ArgoEventObjRelInsertInput = {
  data: ArgoEventInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoEventOnConflict>;
};

/** on_conflict condition type for table "argo.event" */
export type ArgoEventOnConflict = {
  constraint: ArgoEventConstraint;
  update_columns?: Array<ArgoEventUpdateColumn>;
  where?: Maybe<ArgoEventBoolExp>;
};

/** Ordering options when selecting data from "argo.event". */
export type ArgoEventOrderBy = {
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  event_type?: Maybe<ArgoEventTypeOrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateOrderBy>;
  times?: Maybe<ArgoCalendarEventOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  userByUpdatedById?: Maybe<ArgoUserOrderBy>;
};

/** primary key columns input for table: argo.event */
export type ArgoEventPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoEventPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.event" */
export enum ArgoEventSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.event" */
export type ArgoEventSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoEventStddevFields = {
  __typename?: 'argo_event_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoEventStddevPopFields = {
  __typename?: 'argo_event_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoEventStddevSampFields = {
  __typename?: 'argo_event_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_event" */
export type ArgoEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoEventStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoEventSumFields = {
  __typename?: 'argo_event_sum_fields';
  event_type_id?: Maybe<Scalars['Int']>;
};

/** Different types of Events (Shift/Break/Event) */
export type ArgoEventType = {
  __typename?: 'argo_event_type';
  /** An array relationship */
  calendar_event_udf_schemas: Array<ArgoCalendarEventUdfSchema>;
  /** An aggregate relationship */
  calendar_event_udf_schemas_aggregate: ArgoCalendarEventUdfSchemaAggregate;
  /** An array relationship */
  calendar_events: Array<ArgoCalendarEvent>;
  /** An aggregate relationship */
  calendar_events_aggregate: ArgoCalendarEventAggregate;
  id: Scalars['bigint'];
  is_non_productive: Scalars['Boolean'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
  priority: Scalars['Int'];
  /** An array relationship */
  schedule_events: Array<ArgoScheduleEvent>;
  /** An aggregate relationship */
  schedule_events_aggregate: ArgoScheduleEventAggregate;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeCalendarEventUdfSchemasArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeCalendarEventUdfSchemasAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeCalendarEventsArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeCalendarEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeScheduleEventsArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


/** Different types of Events (Shift/Break/Event) */
export type ArgoEventTypeScheduleEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};

/** aggregated selection of "argo.event_type" */
export type ArgoEventTypeAggregate = {
  __typename?: 'argo_event_type_aggregate';
  aggregate?: Maybe<ArgoEventTypeAggregateFields>;
  nodes: Array<ArgoEventType>;
};

/** aggregate fields of "argo.event_type" */
export type ArgoEventTypeAggregateFields = {
  __typename?: 'argo_event_type_aggregate_fields';
  avg?: Maybe<ArgoEventTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoEventTypeMaxFields>;
  min?: Maybe<ArgoEventTypeMinFields>;
  stddev?: Maybe<ArgoEventTypeStddevFields>;
  stddev_pop?: Maybe<ArgoEventTypeStddevPopFields>;
  stddev_samp?: Maybe<ArgoEventTypeStddevSampFields>;
  sum?: Maybe<ArgoEventTypeSumFields>;
  var_pop?: Maybe<ArgoEventTypeVarPopFields>;
  var_samp?: Maybe<ArgoEventTypeVarSampFields>;
  variance?: Maybe<ArgoEventTypeVarianceFields>;
};


/** aggregate fields of "argo.event_type" */
export type ArgoEventTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoEventTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ArgoEventTypeAvgFields = {
  __typename?: 'argo_event_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.event_type". All fields are combined with a logical 'AND'. */
export type ArgoEventTypeBoolExp = {
  _and?: Maybe<Array<ArgoEventTypeBoolExp>>;
  _not?: Maybe<ArgoEventTypeBoolExp>;
  _or?: Maybe<Array<ArgoEventTypeBoolExp>>;
  calendar_event_udf_schemas?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
  calendar_event_udf_schemas_aggregate?: Maybe<ArgoCalendarEventUdfSchemaAggregateBoolExp>;
  calendar_events?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateBoolExp>;
  id?: Maybe<BigintComparisonExp>;
  is_non_productive?: Maybe<BooleanComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  priority?: Maybe<IntComparisonExp>;
  schedule_events?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.event_type" */
export enum ArgoEventTypeConstraint {
  /** unique or primary key constraint on columns "name_unique" */
  EventTypeNameUnique = 'event_type_name_unique',
  /** unique or primary key constraint on columns "event_type_id" */
  EventTypePkey = 'event_type_pkey'
}

/** input type for incrementing numeric columns in table "argo.event_type" */
export type ArgoEventTypeIncInput = {
  id?: Maybe<Scalars['bigint']>;
  priority?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.event_type" */
export type ArgoEventTypeInsertInput = {
  calendar_event_udf_schemas?: Maybe<ArgoCalendarEventUdfSchemaArrRelInsertInput>;
  calendar_events?: Maybe<ArgoCalendarEventArrRelInsertInput>;
  id?: Maybe<Scalars['bigint']>;
  is_non_productive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  schedule_events?: Maybe<ArgoScheduleEventArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoEventTypeMaxFields = {
  __typename?: 'argo_event_type_max_fields';
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ArgoEventTypeMinFields = {
  __typename?: 'argo_event_type_min_fields';
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "argo.event_type" */
export type ArgoEventTypeMutationResponse = {
  __typename?: 'argo_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoEventType>;
};

/** input type for inserting object relation for remote table "argo.event_type" */
export type ArgoEventTypeObjRelInsertInput = {
  data: ArgoEventTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoEventTypeOnConflict>;
};

/** on_conflict condition type for table "argo.event_type" */
export type ArgoEventTypeOnConflict = {
  constraint: ArgoEventTypeConstraint;
  update_columns?: Array<ArgoEventTypeUpdateColumn>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.event_type". */
export type ArgoEventTypeOrderBy = {
  calendar_event_udf_schemas_aggregate?: Maybe<ArgoCalendarEventUdfSchemaAggregateOrderBy>;
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_non_productive?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  priority?: Maybe<OrderBy>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateOrderBy>;
};

/** primary key columns input for table: argo.event_type */
export type ArgoEventTypePkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "argo.event_type" */
export enum ArgoEventTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  IsNonProductive = 'is_non_productive',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Priority = 'priority'
}

/** input type for updating data in table "argo.event_type" */
export type ArgoEventTypeSetInput = {
  id?: Maybe<Scalars['bigint']>;
  is_non_productive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ArgoEventTypeStddevFields = {
  __typename?: 'argo_event_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoEventTypeStddevPopFields = {
  __typename?: 'argo_event_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoEventTypeStddevSampFields = {
  __typename?: 'argo_event_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_event_type" */
export type ArgoEventTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoEventTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoEventTypeStreamCursorValueInput = {
  id?: Maybe<Scalars['bigint']>;
  is_non_productive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ArgoEventTypeSumFields = {
  __typename?: 'argo_event_type_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  priority?: Maybe<Scalars['Int']>;
};

/** update columns of table "argo.event_type" */
export enum ArgoEventTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  IsNonProductive = 'is_non_productive',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Priority = 'priority'
}

export type ArgoEventTypeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoEventTypeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoEventTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoEventTypeBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoEventTypeVarPopFields = {
  __typename?: 'argo_event_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoEventTypeVarSampFields = {
  __typename?: 'argo_event_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoEventTypeVarianceFields = {
  __typename?: 'argo_event_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** update columns of table "argo.event" */
export enum ArgoEventUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoEventUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoEventAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoEventDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoEventDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoEventDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoEventIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoEventPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoEventSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoEventBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoEventVarPopFields = {
  __typename?: 'argo_event_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoEventVarSampFields = {
  __typename?: 'argo_event_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoEventVarianceFields = {
  __typename?: 'argo_event_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};


export type ArgoHasuraCronArgs = {
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['json']>;
  scheduled_time?: Maybe<Scalars['timestamptz']>;
};

/** Hasura permissions require a DB row to compare strings against */
export type ArgoHasuraPermission = {
  __typename?: 'argo_hasura_permission';
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The primary key */
  name: Scalars['String'];
};


/** Hasura permissions require a DB row to compare strings against */
export type ArgoHasuraPermissionMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.hasura_permission" */
export type ArgoHasuraPermissionAggregate = {
  __typename?: 'argo_hasura_permission_aggregate';
  aggregate?: Maybe<ArgoHasuraPermissionAggregateFields>;
  nodes: Array<ArgoHasuraPermission>;
};

/** aggregate fields of "argo.hasura_permission" */
export type ArgoHasuraPermissionAggregateFields = {
  __typename?: 'argo_hasura_permission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoHasuraPermissionMaxFields>;
  min?: Maybe<ArgoHasuraPermissionMinFields>;
};


/** aggregate fields of "argo.hasura_permission" */
export type ArgoHasuraPermissionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoHasuraPermissionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoHasuraPermissionAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.hasura_permission". All fields are combined with a logical 'AND'. */
export type ArgoHasuraPermissionBoolExp = {
  _and?: Maybe<Array<ArgoHasuraPermissionBoolExp>>;
  _not?: Maybe<ArgoHasuraPermissionBoolExp>;
  _or?: Maybe<Array<ArgoHasuraPermissionBoolExp>>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.hasura_permission" */
export enum ArgoHasuraPermissionConstraint {
  /** unique or primary key constraint on columns "name" */
  HasuraPermissionNameKey = 'hasura_permission_name_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoHasuraPermissionDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoHasuraPermissionDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoHasuraPermissionDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.hasura_permission" */
export type ArgoHasuraPermissionInsertInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoHasuraPermissionMaxFields = {
  __typename?: 'argo_hasura_permission_max_fields';
  /** The primary key */
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoHasuraPermissionMinFields = {
  __typename?: 'argo_hasura_permission_min_fields';
  /** The primary key */
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.hasura_permission" */
export type ArgoHasuraPermissionMutationResponse = {
  __typename?: 'argo_hasura_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoHasuraPermission>;
};

/** on_conflict condition type for table "argo.hasura_permission" */
export type ArgoHasuraPermissionOnConflict = {
  constraint: ArgoHasuraPermissionConstraint;
  update_columns?: Array<ArgoHasuraPermissionUpdateColumn>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};

/** Ordering options when selecting data from "argo.hasura_permission". */
export type ArgoHasuraPermissionOrderBy = {
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.hasura_permission */
export type ArgoHasuraPermissionPkColumnsInput = {
  /** The primary key */
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoHasuraPermissionPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.hasura_permission" */
export enum ArgoHasuraPermissionSelectColumn {
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "argo.hasura_permission" */
export type ArgoHasuraPermissionSetInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_hasura_permission" */
export type ArgoHasuraPermissionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoHasuraPermissionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoHasuraPermissionStreamCursorValueInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The primary key */
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.hasura_permission" */
export enum ArgoHasuraPermissionUpdateColumn {
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

export type ArgoHasuraPermissionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoHasuraPermissionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoHasuraPermissionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoHasuraPermissionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoHasuraPermissionDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoHasuraPermissionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoHasuraPermissionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoHasuraPermissionBoolExp;
};

/** User Configurable Links */
export type ArgoLink = {
  __typename?: 'argo_link';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description: Scalars['String'];
  /** The group name for this entry */
  group_name: Scalars['String'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The name for this entry */
  name: Scalars['String'];
  /** Whether this entry is shared */
  shared: Scalars['Boolean'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url: Scalars['String'];
};


/** User Configurable Links */
export type ArgoLinkMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.link" */
export type ArgoLinkAggregate = {
  __typename?: 'argo_link_aggregate';
  aggregate?: Maybe<ArgoLinkAggregateFields>;
  nodes: Array<ArgoLink>;
};

/** aggregate fields of "argo.link" */
export type ArgoLinkAggregateFields = {
  __typename?: 'argo_link_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLinkMaxFields>;
  min?: Maybe<ArgoLinkMinFields>;
};


/** aggregate fields of "argo.link" */
export type ArgoLinkAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLinkSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoLinkAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.link". All fields are combined with a logical 'AND'. */
export type ArgoLinkBoolExp = {
  _and?: Maybe<Array<ArgoLinkBoolExp>>;
  _not?: Maybe<ArgoLinkBoolExp>;
  _or?: Maybe<Array<ArgoLinkBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  group_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  shared?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  url?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.link" */
export enum ArgoLinkConstraint {
  /** unique or primary key constraint on columns "context_id", "group_name", "name" */
  LinkContextIdGroupNameNameKey = 'link_context_id_group_name_name_key',
  /** unique or primary key constraint on columns "link_id" */
  LinkPkey = 'link_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoLinkDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoLinkDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoLinkDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.link" */
export type ArgoLinkInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The group name for this entry */
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** Whether this entry is shared */
  shared?: Maybe<Scalars['Boolean']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoLinkMaxFields = {
  __typename?: 'argo_link_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The group name for this entry */
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoLinkMinFields = {
  __typename?: 'argo_link_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The group name for this entry */
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.link" */
export type ArgoLinkMutationResponse = {
  __typename?: 'argo_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLink>;
};

/** on_conflict condition type for table "argo.link" */
export type ArgoLinkOnConflict = {
  constraint: ArgoLinkConstraint;
  update_columns?: Array<ArgoLinkUpdateColumn>;
  where?: Maybe<ArgoLinkBoolExp>;
};

/** Ordering options when selecting data from "argo.link". */
export type ArgoLinkOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  group_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  shared?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  url?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.link */
export type ArgoLinkPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoLinkPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.link" */
export enum ArgoLinkSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Shared = 'shared',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "argo.link" */
export type ArgoLinkSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The group name for this entry */
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** Whether this entry is shared */
  shared?: Maybe<Scalars['Boolean']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_link" */
export type ArgoLinkStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLinkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLinkStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The description for this entry */
  description?: Maybe<Scalars['String']>;
  /** The group name for this entry */
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The name for this entry */
  name?: Maybe<Scalars['String']>;
  /** Whether this entry is shared */
  shared?: Maybe<Scalars['Boolean']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.link" */
export enum ArgoLinkUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Shared = 'shared',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type ArgoLinkUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoLinkAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoLinkDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoLinkDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoLinkDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoLinkPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLinkSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLinkBoolExp;
};

/** Argonaut Locations */
export type ArgoLocation = {
  __typename?: 'argo_location';
  /** An array relationship */
  calendar_locations: Array<ArgoCalendarLocation>;
  /** An aggregate relationship */
  calendar_locations_aggregate: ArgoCalendarLocationAggregate;
  /** An array relationship */
  child_locations: Array<ArgoVwLocationHierarchy>;
  /** An aggregate relationship */
  child_locations_aggregate: ArgoVwLocationHierarchyAggregate;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** An array relationship */
  fis_assets: Array<FisAsset>;
  /** An aggregate relationship */
  fis_assets_aggregate: FisAssetAggregate;
  id: Scalars['uuid'];
  /** Boolean flag to indicate if this is the default location for the context. Helps with unique contstraints as well as querying the default location */
  is_default?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  location_attributes: Array<ArgoLocationAttribute>;
  /** An aggregate relationship */
  location_attributes_aggregate: ArgoLocationAttributeAggregate;
  /** An object relationship */
  location_class?: Maybe<ArgoLocationClass>;
  location_class_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  locations: Array<ArgoLocation>;
  /** An aggregate relationship */
  locations_aggregate: ArgoLocationAggregate;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name: Scalars['String'];
  /** A case-insensitive name */
  name_unique: Scalars['String'];
  /** An array relationship */
  parentLocations: Array<ArgoVwLocationHierarchy>;
  /** An aggregate relationship */
  parentLocations_aggregate: ArgoVwLocationHierarchyAggregate;
  /** An object relationship */
  parent_location?: Maybe<ArgoLocation>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Argonaut Locations */
export type ArgoLocationCalendarLocationsArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationCalendarLocationsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationChildLocationsArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationChildLocationsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationFisAssetsArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationFisAssetsAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationLocationAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationLocationAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationLocationsArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationLocationsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Argonaut Locations */
export type ArgoLocationParentLocationsArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


/** Argonaut Locations */
export type ArgoLocationParentLocationsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};

export type ArgoLocationActiveCalendarArgs = {
  at_time?: Maybe<Scalars['timestamp']>;
  location_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.location" */
export type ArgoLocationAggregate = {
  __typename?: 'argo_location_aggregate';
  aggregate?: Maybe<ArgoLocationAggregateFields>;
  nodes: Array<ArgoLocation>;
};

export type ArgoLocationAggregateBoolExp = {
  bool_and?: Maybe<ArgoLocationAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoLocationAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoLocationAggregateBoolExpCount>;
};

export type ArgoLocationAggregateBoolExpBoolAnd = {
  arguments: ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoLocationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoLocationAggregateBoolExpBoolOr = {
  arguments: ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoLocationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoLocationAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoLocationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.location" */
export type ArgoLocationAggregateFields = {
  __typename?: 'argo_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLocationMaxFields>;
  min?: Maybe<ArgoLocationMinFields>;
};


/** aggregate fields of "argo.location" */
export type ArgoLocationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.location" */
export type ArgoLocationAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoLocationMaxOrderBy>;
  min?: Maybe<ArgoLocationMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoLocationAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.location" */
export type ArgoLocationArrRelInsertInput = {
  data: Array<ArgoLocationInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoLocationOnConflict>;
};

/** Location Attributes */
export type ArgoLocationAttribute = {
  __typename?: 'argo_location_attribute';
  /** An object relationship */
  attribute: ArgoAttribute;
  attribute_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  location: ArgoLocation;
  location_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.location_attribute" */
export type ArgoLocationAttributeAggregate = {
  __typename?: 'argo_location_attribute_aggregate';
  aggregate?: Maybe<ArgoLocationAttributeAggregateFields>;
  nodes: Array<ArgoLocationAttribute>;
};

export type ArgoLocationAttributeAggregateBoolExp = {
  count?: Maybe<ArgoLocationAttributeAggregateBoolExpCount>;
};

export type ArgoLocationAttributeAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoLocationAttributeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.location_attribute" */
export type ArgoLocationAttributeAggregateFields = {
  __typename?: 'argo_location_attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLocationAttributeMaxFields>;
  min?: Maybe<ArgoLocationAttributeMinFields>;
};


/** aggregate fields of "argo.location_attribute" */
export type ArgoLocationAttributeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.location_attribute" */
export type ArgoLocationAttributeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoLocationAttributeMaxOrderBy>;
  min?: Maybe<ArgoLocationAttributeMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.location_attribute" */
export type ArgoLocationAttributeArrRelInsertInput = {
  data: Array<ArgoLocationAttributeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoLocationAttributeOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.location_attribute". All fields are combined with a logical 'AND'. */
export type ArgoLocationAttributeBoolExp = {
  _and?: Maybe<Array<ArgoLocationAttributeBoolExp>>;
  _not?: Maybe<ArgoLocationAttributeBoolExp>;
  _or?: Maybe<Array<ArgoLocationAttributeBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.location_attribute" */
export enum ArgoLocationAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "location_id" */
  LocationAttributeLocationIdAttributeIdKey = 'location_attribute_location_id_attribute_id_key',
  /** unique or primary key constraint on columns "location_attribute_id" */
  LocationAttributePkey = 'location_attribute_pkey'
}

/** Attribute history for locations */
export type ArgoLocationAttributeHistory = {
  __typename?: 'argo_location_attribute_history';
  /** An object relationship */
  attribute: ArgoAttribute;
  /** The attribute id */
  attribute_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context id */
  context_id: Scalars['uuid'];
  /** The created at */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The created by id */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  history_status: ArgoAttributeHistoryStatusType;
  /** The location attribute history id */
  id: Scalars['uuid'];
  /** An object relationship */
  location: ArgoLocation;
  /** The location id */
  location_id: Scalars['uuid'];
  /** The status */
  status: ArgoAttributeHistoryStatusTypeEnum;
  /** The updated at */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryAggregate = {
  __typename?: 'argo_location_attribute_history_aggregate';
  aggregate?: Maybe<ArgoLocationAttributeHistoryAggregateFields>;
  nodes: Array<ArgoLocationAttributeHistory>;
};

/** aggregate fields of "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryAggregateFields = {
  __typename?: 'argo_location_attribute_history_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLocationAttributeHistoryMaxFields>;
  min?: Maybe<ArgoLocationAttributeHistoryMinFields>;
};


/** aggregate fields of "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLocationAttributeHistorySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.location_attribute_history". All fields are combined with a logical 'AND'. */
export type ArgoLocationAttributeHistoryBoolExp = {
  _and?: Maybe<Array<ArgoLocationAttributeHistoryBoolExp>>;
  _not?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
  _or?: Maybe<Array<ArgoLocationAttributeHistoryBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.location_attribute_history" */
export enum ArgoLocationAttributeHistoryConstraint {
  /** unique or primary key constraint on columns "location_attribute_history_id" */
  LocationAttributeHistoryPkey = 'location_attribute_history_pkey'
}

/** input type for inserting data into table "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeObjRelInsertInput>;
  /** The location attribute history id */
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** The location id */
  location_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoLocationAttributeHistoryMaxFields = {
  __typename?: 'argo_location_attribute_history_max_fields';
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The location id */
  location_id?: Maybe<Scalars['uuid']>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoLocationAttributeHistoryMinFields = {
  __typename?: 'argo_location_attribute_history_min_fields';
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The location id */
  location_id?: Maybe<Scalars['uuid']>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryMutationResponse = {
  __typename?: 'argo_location_attribute_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLocationAttributeHistory>;
};

/** on_conflict condition type for table "argo.location_attribute_history" */
export type ArgoLocationAttributeHistoryOnConflict = {
  constraint: ArgoLocationAttributeHistoryConstraint;
  update_columns?: Array<ArgoLocationAttributeHistoryUpdateColumn>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};

/** Ordering options when selecting data from "argo.location_attribute_history". */
export type ArgoLocationAttributeHistoryOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeOrderBy>;
  id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.location_attribute_history */
export type ArgoLocationAttributeHistoryPkColumnsInput = {
  /** The location attribute history id */
  id: Scalars['uuid'];
};

/** select columns of table "argo.location_attribute_history" */
export enum ArgoLocationAttributeHistorySelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.location_attribute_history" */
export type ArgoLocationAttributeHistorySetInput = {
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The location id */
  location_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_location_attribute_history" */
export type ArgoLocationAttributeHistoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLocationAttributeHistoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLocationAttributeHistoryStreamCursorValueInput = {
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The location id */
  location_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.location_attribute_history" */
export enum ArgoLocationAttributeHistoryUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoLocationAttributeHistoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLocationAttributeHistorySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLocationAttributeHistoryBoolExp;
};

/** input type for inserting data into table "argo.location_attribute" */
export type ArgoLocationAttributeInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  attribute_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  location_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoLocationAttributeMaxFields = {
  __typename?: 'argo_location_attribute_max_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.location_attribute" */
export type ArgoLocationAttributeMaxOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoLocationAttributeMinFields = {
  __typename?: 'argo_location_attribute_min_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.location_attribute" */
export type ArgoLocationAttributeMinOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.location_attribute" */
export type ArgoLocationAttributeMutationResponse = {
  __typename?: 'argo_location_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLocationAttribute>;
};

/** on_conflict condition type for table "argo.location_attribute" */
export type ArgoLocationAttributeOnConflict = {
  constraint: ArgoLocationAttributeConstraint;
  update_columns?: Array<ArgoLocationAttributeUpdateColumn>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};

/** Ordering options when selecting data from "argo.location_attribute". */
export type ArgoLocationAttributeOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.location_attribute */
export type ArgoLocationAttributePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.location_attribute" */
export enum ArgoLocationAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.location_attribute" */
export type ArgoLocationAttributeSetInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_location_attribute" */
export type ArgoLocationAttributeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLocationAttributeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLocationAttributeStreamCursorValueInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.location_attribute" */
export enum ArgoLocationAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoLocationAttributeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLocationAttributeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLocationAttributeBoolExp;
};

/** Boolean expression to filter rows from the table "argo.location". All fields are combined with a logical 'AND'. */
export type ArgoLocationBoolExp = {
  _and?: Maybe<Array<ArgoLocationBoolExp>>;
  _not?: Maybe<ArgoLocationBoolExp>;
  _or?: Maybe<Array<ArgoLocationBoolExp>>;
  calendar_locations?: Maybe<ArgoCalendarLocationBoolExp>;
  calendar_locations_aggregate?: Maybe<ArgoCalendarLocationAggregateBoolExp>;
  child_locations?: Maybe<ArgoVwLocationHierarchyBoolExp>;
  child_locations_aggregate?: Maybe<ArgoVwLocationHierarchyAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  fis_assets?: Maybe<FisAssetBoolExp>;
  fis_assets_aggregate?: Maybe<FisAssetAggregateBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  is_default?: Maybe<BooleanComparisonExp>;
  location_attributes?: Maybe<ArgoLocationAttributeBoolExp>;
  location_attributes_aggregate?: Maybe<ArgoLocationAttributeAggregateBoolExp>;
  location_class?: Maybe<ArgoLocationClassBoolExp>;
  location_class_id?: Maybe<UuidComparisonExp>;
  locations?: Maybe<ArgoLocationBoolExp>;
  locations_aggregate?: Maybe<ArgoLocationAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  parentLocations?: Maybe<ArgoVwLocationHierarchyBoolExp>;
  parentLocations_aggregate?: Maybe<ArgoVwLocationHierarchyAggregateBoolExp>;
  parent_location?: Maybe<ArgoLocationBoolExp>;
  parent_location_id?: Maybe<UuidComparisonExp>;
  profile_file_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** Table to define classifications for Locations */
export type ArgoLocationClass = {
  __typename?: 'argo_location_class';
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define classifications for Locations */
export type ArgoLocationClassMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.location_class" */
export type ArgoLocationClassAggregate = {
  __typename?: 'argo_location_class_aggregate';
  aggregate?: Maybe<ArgoLocationClassAggregateFields>;
  nodes: Array<ArgoLocationClass>;
};

/** aggregate fields of "argo.location_class" */
export type ArgoLocationClassAggregateFields = {
  __typename?: 'argo_location_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLocationClassMaxFields>;
  min?: Maybe<ArgoLocationClassMinFields>;
};


/** aggregate fields of "argo.location_class" */
export type ArgoLocationClassAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLocationClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoLocationClassAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.location_class". All fields are combined with a logical 'AND'. */
export type ArgoLocationClassBoolExp = {
  _and?: Maybe<Array<ArgoLocationClassBoolExp>>;
  _not?: Maybe<ArgoLocationClassBoolExp>;
  _or?: Maybe<Array<ArgoLocationClassBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  profile_file_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.location_class" */
export enum ArgoLocationClassConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  LocationClassNameUnique = 'location_class_name_unique',
  /** unique or primary key constraint on columns "location_class_id" */
  LocationClassPkey = 'location_class_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoLocationClassDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoLocationClassDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoLocationClassDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.location_class" */
export type ArgoLocationClassInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoLocationClassMaxFields = {
  __typename?: 'argo_location_class_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoLocationClassMinFields = {
  __typename?: 'argo_location_class_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.location_class" */
export type ArgoLocationClassMutationResponse = {
  __typename?: 'argo_location_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLocationClass>;
};

/** input type for inserting object relation for remote table "argo.location_class" */
export type ArgoLocationClassObjRelInsertInput = {
  data: ArgoLocationClassInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoLocationClassOnConflict>;
};

/** on_conflict condition type for table "argo.location_class" */
export type ArgoLocationClassOnConflict = {
  constraint: ArgoLocationClassConstraint;
  update_columns?: Array<ArgoLocationClassUpdateColumn>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};

/** Ordering options when selecting data from "argo.location_class". */
export type ArgoLocationClassOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.location_class */
export type ArgoLocationClassPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoLocationClassPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.location_class" */
export enum ArgoLocationClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.location_class" */
export type ArgoLocationClassSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_location_class" */
export type ArgoLocationClassStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLocationClassStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLocationClassStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.location_class" */
export enum ArgoLocationClassUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoLocationClassUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoLocationClassAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoLocationClassDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoLocationClassDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoLocationClassDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoLocationClassPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLocationClassSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLocationClassBoolExp;
};

/** unique or primary key constraints on table "argo.location" */
export enum ArgoLocationConstraint {
  /** unique or primary key constraint on columns "context_id", "is_default" */
  LocationIsDefaultPerContext = 'location_is_default_per_context',
  /** unique or primary key constraint on columns "context_id", "name" */
  LocationNameKey = 'location_name_key',
  /** unique or primary key constraint on columns "location_id" */
  LocationPkey = 'location_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoLocationDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoLocationDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoLocationDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.location" */
export type ArgoLocationInsertInput = {
  calendar_locations?: Maybe<ArgoCalendarLocationArrRelInsertInput>;
  child_locations?: Maybe<ArgoVwLocationHierarchyArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  fis_assets?: Maybe<FisAssetArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  /** Boolean flag to indicate if this is the default location for the context. Helps with unique contstraints as well as querying the default location */
  is_default?: Maybe<Scalars['Boolean']>;
  location_attributes?: Maybe<ArgoLocationAttributeArrRelInsertInput>;
  location_class?: Maybe<ArgoLocationClassObjRelInsertInput>;
  location_class_id?: Maybe<Scalars['uuid']>;
  locations?: Maybe<ArgoLocationArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  parentLocations?: Maybe<ArgoVwLocationHierarchyArrRelInsertInput>;
  parent_location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoLocationMaxFields = {
  __typename?: 'argo_location_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location_class_id?: Maybe<Scalars['uuid']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.location" */
export type ArgoLocationMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_class_id?: Maybe<OrderBy>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<OrderBy>;
  /** A case-insensitive name */
  name_unique?: Maybe<OrderBy>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoLocationMinFields = {
  __typename?: 'argo_location_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location_class_id?: Maybe<Scalars['uuid']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.location" */
export type ArgoLocationMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_class_id?: Maybe<OrderBy>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<OrderBy>;
  /** A case-insensitive name */
  name_unique?: Maybe<OrderBy>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.location" */
export type ArgoLocationMutationResponse = {
  __typename?: 'argo_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLocation>;
};

/** input type for inserting object relation for remote table "argo.location" */
export type ArgoLocationObjRelInsertInput = {
  data: ArgoLocationInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoLocationOnConflict>;
};

/** on_conflict condition type for table "argo.location" */
export type ArgoLocationOnConflict = {
  constraint: ArgoLocationConstraint;
  update_columns?: Array<ArgoLocationUpdateColumn>;
  where?: Maybe<ArgoLocationBoolExp>;
};

/** Ordering options when selecting data from "argo.location". */
export type ArgoLocationOrderBy = {
  calendar_locations_aggregate?: Maybe<ArgoCalendarLocationAggregateOrderBy>;
  child_locations_aggregate?: Maybe<ArgoVwLocationHierarchyAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  fis_assets_aggregate?: Maybe<FisAssetAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_default?: Maybe<OrderBy>;
  location_attributes_aggregate?: Maybe<ArgoLocationAttributeAggregateOrderBy>;
  location_class?: Maybe<ArgoLocationClassOrderBy>;
  location_class_id?: Maybe<OrderBy>;
  locations_aggregate?: Maybe<ArgoLocationAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  parentLocations_aggregate?: Maybe<ArgoVwLocationHierarchyAggregateOrderBy>;
  parent_location?: Maybe<ArgoLocationOrderBy>;
  parent_location_id?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.location */
export type ArgoLocationPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoLocationPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.location" */
export enum ArgoLocationSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LocationClassId = 'location_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentLocationId = 'parent_location_id',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.location" */
export enum ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.location" */
export enum ArgoLocationSelectColumnArgoLocationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "argo.location" */
export type ArgoLocationSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Boolean flag to indicate if this is the default location for the context. Helps with unique contstraints as well as querying the default location */
  is_default?: Maybe<Scalars['Boolean']>;
  location_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_location" */
export type ArgoLocationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLocationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLocationStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Boolean flag to indicate if this is the default location for the context. Helps with unique contstraints as well as querying the default location */
  is_default?: Maybe<Scalars['Boolean']>;
  location_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** Allows for a location to have a location structure */
  parent_location_id?: Maybe<Scalars['uuid']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.location" */
export enum ArgoLocationUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LocationClassId = 'location_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentLocationId = 'parent_location_id',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoLocationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoLocationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoLocationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoLocationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoLocationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoLocationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLocationSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLocationBoolExp;
};

/** Log messages */
export type ArgoLog = {
  __typename?: 'argo_log';
  /** The log category */
  category: ArgoLogCategoryEnum;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** The log level */
  level: ArgoLogLevelEnum;
  /** The log message */
  message: Scalars['String'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** Freeform field for where the log originated */
  source: Scalars['String'];
};


/** Log messages */
export type ArgoLogMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.log" */
export type ArgoLogAggregate = {
  __typename?: 'argo_log_aggregate';
  aggregate?: Maybe<ArgoLogAggregateFields>;
  nodes: Array<ArgoLog>;
};

/** aggregate fields of "argo.log" */
export type ArgoLogAggregateFields = {
  __typename?: 'argo_log_aggregate_fields';
  avg?: Maybe<ArgoLogAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoLogMaxFields>;
  min?: Maybe<ArgoLogMinFields>;
  stddev?: Maybe<ArgoLogStddevFields>;
  stddev_pop?: Maybe<ArgoLogStddevPopFields>;
  stddev_samp?: Maybe<ArgoLogStddevSampFields>;
  sum?: Maybe<ArgoLogSumFields>;
  var_pop?: Maybe<ArgoLogVarPopFields>;
  var_samp?: Maybe<ArgoLogVarSampFields>;
  variance?: Maybe<ArgoLogVarianceFields>;
};


/** aggregate fields of "argo.log" */
export type ArgoLogAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLogSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoLogAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoLogAvgFields = {
  __typename?: 'argo_log_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.log". All fields are combined with a logical 'AND'. */
export type ArgoLogBoolExp = {
  _and?: Maybe<Array<ArgoLogBoolExp>>;
  _not?: Maybe<ArgoLogBoolExp>;
  _or?: Maybe<Array<ArgoLogBoolExp>>;
  category?: Maybe<ArgoLogCategoryEnumComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  expires_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  level?: Maybe<ArgoLogLevelEnumComparisonExp>;
  message?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  source?: Maybe<StringComparisonExp>;
};

/** How the log should be categorized */
export type ArgoLogCategory = {
  __typename?: 'argo_log_category';
  category: Scalars['String'];
  description: Scalars['String'];
};

/** aggregated selection of "argo.log_category" */
export type ArgoLogCategoryAggregate = {
  __typename?: 'argo_log_category_aggregate';
  aggregate?: Maybe<ArgoLogCategoryAggregateFields>;
  nodes: Array<ArgoLogCategory>;
};

/** aggregate fields of "argo.log_category" */
export type ArgoLogCategoryAggregateFields = {
  __typename?: 'argo_log_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLogCategoryMaxFields>;
  min?: Maybe<ArgoLogCategoryMinFields>;
};


/** aggregate fields of "argo.log_category" */
export type ArgoLogCategoryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLogCategorySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.log_category". All fields are combined with a logical 'AND'. */
export type ArgoLogCategoryBoolExp = {
  _and?: Maybe<Array<ArgoLogCategoryBoolExp>>;
  _not?: Maybe<ArgoLogCategoryBoolExp>;
  _or?: Maybe<Array<ArgoLogCategoryBoolExp>>;
  category?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.log_category" */
export enum ArgoLogCategoryConstraint {
  /** unique or primary key constraint on columns "category" */
  LogCategoryPkey = 'log_category_pkey'
}

export enum ArgoLogCategoryEnum {
  /** Argonaut */
  Argonaut = 'argonaut',
  /** Device */
  Device = 'device',
  /** MES App */
  MesApp = 'mes_app',
  /** Other */
  Other = 'other',
  /** Service */
  Service = 'service',
  /** Spearhead */
  Spearhead = 'spearhead'
}

/** Boolean expression to compare columns of type "argo_log_category_enum". All fields are combined with logical 'AND'. */
export type ArgoLogCategoryEnumComparisonExp = {
  _eq?: Maybe<ArgoLogCategoryEnum>;
  _in?: Maybe<Array<ArgoLogCategoryEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoLogCategoryEnum>;
  _nin?: Maybe<Array<ArgoLogCategoryEnum>>;
};

/** input type for inserting data into table "argo.log_category" */
export type ArgoLogCategoryInsertInput = {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoLogCategoryMaxFields = {
  __typename?: 'argo_log_category_max_fields';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoLogCategoryMinFields = {
  __typename?: 'argo_log_category_min_fields';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.log_category" */
export type ArgoLogCategoryMutationResponse = {
  __typename?: 'argo_log_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLogCategory>;
};

/** on_conflict condition type for table "argo.log_category" */
export type ArgoLogCategoryOnConflict = {
  constraint: ArgoLogCategoryConstraint;
  update_columns?: Array<ArgoLogCategoryUpdateColumn>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};

/** Ordering options when selecting data from "argo.log_category". */
export type ArgoLogCategoryOrderBy = {
  category?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.log_category */
export type ArgoLogCategoryPkColumnsInput = {
  category: Scalars['String'];
};

/** select columns of table "argo.log_category" */
export enum ArgoLogCategorySelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "argo.log_category" */
export type ArgoLogCategorySetInput = {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_log_category" */
export type ArgoLogCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLogCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLogCategoryStreamCursorValueInput = {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.log_category" */
export enum ArgoLogCategoryUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description'
}

export type ArgoLogCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLogCategorySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLogCategoryBoolExp;
};

/** unique or primary key constraints on table "argo.log" */
export enum ArgoLogConstraint {
  /** unique or primary key constraint on columns "log_id" */
  LogPkey = 'log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoLogDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoLogDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoLogDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** A configuration for a log expiration */
export type ArgoLogDuration = {
  __typename?: 'argo_log_duration';
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  id?: Maybe<Scalars['uuid']>;
  /** The number of days to add to log expires_at column */
  interval: Scalars['interval'];
  /** The log level */
  level: ArgoLogLevelEnum;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** A configuration for a log expiration */
export type ArgoLogDurationMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.log_duration" */
export type ArgoLogDurationAggregate = {
  __typename?: 'argo_log_duration_aggregate';
  aggregate?: Maybe<ArgoLogDurationAggregateFields>;
  nodes: Array<ArgoLogDuration>;
};

/** aggregate fields of "argo.log_duration" */
export type ArgoLogDurationAggregateFields = {
  __typename?: 'argo_log_duration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLogDurationMaxFields>;
  min?: Maybe<ArgoLogDurationMinFields>;
};


/** aggregate fields of "argo.log_duration" */
export type ArgoLogDurationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLogDurationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoLogDurationAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.log_duration". All fields are combined with a logical 'AND'. */
export type ArgoLogDurationBoolExp = {
  _and?: Maybe<Array<ArgoLogDurationBoolExp>>;
  _not?: Maybe<ArgoLogDurationBoolExp>;
  _or?: Maybe<Array<ArgoLogDurationBoolExp>>;
  category?: Maybe<ArgoLogCategoryEnumComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  interval?: Maybe<IntervalComparisonExp>;
  level?: Maybe<ArgoLogLevelEnumComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "argo.log_duration" */
export enum ArgoLogDurationConstraint {
  /** unique or primary key constraint on columns "level", "category" */
  LogDurationCategoryLevelUnique = 'log_duration_category_level_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoLogDurationDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoLogDurationDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoLogDurationDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.log_duration" */
export type ArgoLogDurationInsertInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The number of days to add to log expires_at column */
  interval?: Maybe<Scalars['interval']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ArgoLogDurationMaxFields = {
  __typename?: 'argo_log_duration_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ArgoLogDurationMinFields = {
  __typename?: 'argo_log_duration_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "argo.log_duration" */
export type ArgoLogDurationMutationResponse = {
  __typename?: 'argo_log_duration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLogDuration>;
};

/** on_conflict condition type for table "argo.log_duration" */
export type ArgoLogDurationOnConflict = {
  constraint: ArgoLogDurationConstraint;
  update_columns?: Array<ArgoLogDurationUpdateColumn>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};

/** Ordering options when selecting data from "argo.log_duration". */
export type ArgoLogDurationOrderBy = {
  category?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  interval?: Maybe<OrderBy>;
  level?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoLogDurationPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.log_duration" */
export enum ArgoLogDurationSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Level = 'level',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "argo.log_duration" */
export type ArgoLogDurationSetInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The number of days to add to log expires_at column */
  interval?: Maybe<Scalars['interval']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "argo_log_duration" */
export type ArgoLogDurationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLogDurationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLogDurationStreamCursorValueInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The number of days to add to log expires_at column */
  interval?: Maybe<Scalars['interval']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "argo.log_duration" */
export enum ArgoLogDurationUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Level = 'level',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ArgoLogDurationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoLogDurationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoLogDurationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoLogDurationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoLogDurationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoLogDurationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLogDurationSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLogDurationBoolExp;
};

/** input type for incrementing numeric columns in table "argo.log" */
export type ArgoLogIncInput = {
  id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.log" */
export type ArgoLogInsertInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** The log message */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Freeform field for where the log originated */
  source?: Maybe<Scalars['String']>;
};

/** The log level */
export type ArgoLogLevel = {
  __typename?: 'argo_log_level';
  description: Scalars['String'];
  level: Scalars['String'];
};

/** aggregated selection of "argo.log_level" */
export type ArgoLogLevelAggregate = {
  __typename?: 'argo_log_level_aggregate';
  aggregate?: Maybe<ArgoLogLevelAggregateFields>;
  nodes: Array<ArgoLogLevel>;
};

/** aggregate fields of "argo.log_level" */
export type ArgoLogLevelAggregateFields = {
  __typename?: 'argo_log_level_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoLogLevelMaxFields>;
  min?: Maybe<ArgoLogLevelMinFields>;
};


/** aggregate fields of "argo.log_level" */
export type ArgoLogLevelAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoLogLevelSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.log_level". All fields are combined with a logical 'AND'. */
export type ArgoLogLevelBoolExp = {
  _and?: Maybe<Array<ArgoLogLevelBoolExp>>;
  _not?: Maybe<ArgoLogLevelBoolExp>;
  _or?: Maybe<Array<ArgoLogLevelBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  level?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.log_level" */
export enum ArgoLogLevelConstraint {
  /** unique or primary key constraint on columns "level" */
  LogLevelPkey = 'log_level_pkey'
}

export enum ArgoLogLevelEnum {
  /** Debug */
  Debug = 'debug',
  /** Error */
  Error = 'error',
  /** Info */
  Info = 'info',
  /** Warning */
  Warning = 'warning'
}

/** Boolean expression to compare columns of type "argo_log_level_enum". All fields are combined with logical 'AND'. */
export type ArgoLogLevelEnumComparisonExp = {
  _eq?: Maybe<ArgoLogLevelEnum>;
  _in?: Maybe<Array<ArgoLogLevelEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoLogLevelEnum>;
  _nin?: Maybe<Array<ArgoLogLevelEnum>>;
};

/** input type for inserting data into table "argo.log_level" */
export type ArgoLogLevelInsertInput = {
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoLogLevelMaxFields = {
  __typename?: 'argo_log_level_max_fields';
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoLogLevelMinFields = {
  __typename?: 'argo_log_level_min_fields';
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.log_level" */
export type ArgoLogLevelMutationResponse = {
  __typename?: 'argo_log_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLogLevel>;
};

/** on_conflict condition type for table "argo.log_level" */
export type ArgoLogLevelOnConflict = {
  constraint: ArgoLogLevelConstraint;
  update_columns?: Array<ArgoLogLevelUpdateColumn>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};

/** Ordering options when selecting data from "argo.log_level". */
export type ArgoLogLevelOrderBy = {
  description?: Maybe<OrderBy>;
  level?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.log_level */
export type ArgoLogLevelPkColumnsInput = {
  level: Scalars['String'];
};

/** select columns of table "argo.log_level" */
export enum ArgoLogLevelSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "argo.log_level" */
export type ArgoLogLevelSetInput = {
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_log_level" */
export type ArgoLogLevelStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLogLevelStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLogLevelStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.log_level" */
export enum ArgoLogLevelUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Level = 'level'
}

export type ArgoLogLevelUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLogLevelSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLogLevelBoolExp;
};

/** aggregate max on columns */
export type ArgoLogMaxFields = {
  __typename?: 'argo_log_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** The log message */
  message?: Maybe<Scalars['String']>;
  /** Freeform field for where the log originated */
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoLogMinFields = {
  __typename?: 'argo_log_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** The log message */
  message?: Maybe<Scalars['String']>;
  /** Freeform field for where the log originated */
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.log" */
export type ArgoLogMutationResponse = {
  __typename?: 'argo_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoLog>;
};

/** on_conflict condition type for table "argo.log" */
export type ArgoLogOnConflict = {
  constraint: ArgoLogConstraint;
  update_columns?: Array<ArgoLogUpdateColumn>;
  where?: Maybe<ArgoLogBoolExp>;
};

/** Ordering options when selecting data from "argo.log". */
export type ArgoLogOrderBy = {
  category?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  level?: Maybe<OrderBy>;
  message?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  source?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.log */
export type ArgoLogPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoLogPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.log" */
export enum ArgoLogSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "argo.log" */
export type ArgoLogSetInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** The log message */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Freeform field for where the log originated */
  source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArgoLogStddevFields = {
  __typename?: 'argo_log_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoLogStddevPopFields = {
  __typename?: 'argo_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoLogStddevSampFields = {
  __typename?: 'argo_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_log" */
export type ArgoLogStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoLogStreamCursorValueInput = {
  /** The log category */
  category?: Maybe<ArgoLogCategoryEnum>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** When the log is expected to be removed */
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** The log level */
  level?: Maybe<ArgoLogLevelEnum>;
  /** The log message */
  message?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Freeform field for where the log originated */
  source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoLogSumFields = {
  __typename?: 'argo_log_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "argo.log" */
export enum ArgoLogUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  Source = 'source'
}

export type ArgoLogUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoLogAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoLogDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoLogDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoLogDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoLogIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoLogPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoLogSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoLogBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoLogVarPopFields = {
  __typename?: 'argo_log_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoLogVarSampFields = {
  __typename?: 'argo_log_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoLogVarianceFields = {
  __typename?: 'argo_log_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type ArgoMarryMaterialArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  marry_material_data?: Maybe<Scalars['argo_marry_material_data']>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterial = {
  __typename?: 'argo_material';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  created_location?: Maybe<ArgoLocation>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  material_attributes: Array<ArgoMaterialAttribute>;
  /** An aggregate relationship */
  material_attributes_aggregate: ArgoMaterialAttributeAggregate;
  /** An object relationship */
  material_model: ArgoMaterialModel;
  /** The model that this material is related to */
  material_model_id: Scalars['uuid'];
  /** An object relationship */
  material_status: ArgoMaterialStatus;
  /** An array relationship */
  material_udf_data: Array<ArgoMaterialUdfData>;
  /** An aggregate relationship */
  material_udf_data_aggregate: ArgoMaterialUdfDataAggregate;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An array relationship */
  process_material_states: Array<ProcessMaterialState>;
  /** An aggregate relationship */
  process_material_states_aggregate: ProcessMaterialStateAggregate;
  /** The serial number identifying this piece of material */
  serial_number: Scalars['String'];
  /** The property setting this material as the only material with this serial number that is active within this context */
  serial_number_active: Scalars['Boolean'];
  /** The status of the material */
  status: ArgoMaterialStatusEnum;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  work_order_material?: Maybe<ArgoWorkOrderMaterial>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialMaterialAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialMaterialAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialMaterialUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialMaterialUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialProcessMaterialStatesArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


/** Table to define a record per physical piece of material created on the plant floor */
export type ArgoMaterialProcessMaterialStatesAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};

/** columns and relationships of "argo.material_activity" */
export type ArgoMaterialActivity = {
  __typename?: 'argo_material_activity';
  /** An object relationship */
  activity_kind: ArgoMaterialActivityKind;
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['uuid'];
  kind: ArgoMaterialActivityKindEnum;
  /** An object relationship */
  material: ArgoMaterial;
  material_activity_id: Scalars['uuid'];
  material_id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  note: Scalars['String'];
  status?: Maybe<ArgoMaterialStatusEnum>;
};


/** columns and relationships of "argo.material_activity" */
export type ArgoMaterialActivityMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_activity" */
export type ArgoMaterialActivityAggregate = {
  __typename?: 'argo_material_activity_aggregate';
  aggregate?: Maybe<ArgoMaterialActivityAggregateFields>;
  nodes: Array<ArgoMaterialActivity>;
};

/** aggregate fields of "argo.material_activity" */
export type ArgoMaterialActivityAggregateFields = {
  __typename?: 'argo_material_activity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialActivityMaxFields>;
  min?: Maybe<ArgoMaterialActivityMinFields>;
};


/** aggregate fields of "argo.material_activity" */
export type ArgoMaterialActivityAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialActivitySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialActivityAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.material_activity". All fields are combined with a logical 'AND'. */
export type ArgoMaterialActivityBoolExp = {
  _and?: Maybe<Array<ArgoMaterialActivityBoolExp>>;
  _not?: Maybe<ArgoMaterialActivityBoolExp>;
  _or?: Maybe<Array<ArgoMaterialActivityBoolExp>>;
  activity_kind?: Maybe<ArgoMaterialActivityKindBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  kind?: Maybe<ArgoMaterialActivityKindEnumComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_activity_id?: Maybe<UuidComparisonExp>;
  material_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  note?: Maybe<StringComparisonExp>;
  status?: Maybe<ArgoMaterialStatusEnumComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_activity" */
export enum ArgoMaterialActivityConstraint {
  /** unique or primary key constraint on columns "material_activity_id" */
  MaterialActivityPkey = 'material_activity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialActivityDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialActivityDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialActivityDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_activity" */
export type ArgoMaterialActivityInsertInput = {
  activity_kind?: Maybe<ArgoMaterialActivityKindObjRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoMaterialActivityKindEnum>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  material_activity_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoMaterialStatusEnum>;
};

/** columns and relationships of "argo.material_activity_kind" */
export type ArgoMaterialActivityKind = {
  __typename?: 'argo_material_activity_kind';
  description: Scalars['String'];
  kind: Scalars['String'];
};

/** aggregated selection of "argo.material_activity_kind" */
export type ArgoMaterialActivityKindAggregate = {
  __typename?: 'argo_material_activity_kind_aggregate';
  aggregate?: Maybe<ArgoMaterialActivityKindAggregateFields>;
  nodes: Array<ArgoMaterialActivityKind>;
};

/** aggregate fields of "argo.material_activity_kind" */
export type ArgoMaterialActivityKindAggregateFields = {
  __typename?: 'argo_material_activity_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialActivityKindMaxFields>;
  min?: Maybe<ArgoMaterialActivityKindMinFields>;
};


/** aggregate fields of "argo.material_activity_kind" */
export type ArgoMaterialActivityKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialActivityKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.material_activity_kind". All fields are combined with a logical 'AND'. */
export type ArgoMaterialActivityKindBoolExp = {
  _and?: Maybe<Array<ArgoMaterialActivityKindBoolExp>>;
  _not?: Maybe<ArgoMaterialActivityKindBoolExp>;
  _or?: Maybe<Array<ArgoMaterialActivityKindBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  kind?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_activity_kind" */
export enum ArgoMaterialActivityKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  MaterialActivityKindPkey = 'material_activity_kind_pkey'
}

export enum ArgoMaterialActivityKindEnum {
  /** Note was added */
  Note = 'note',
  /** Material status was changed */
  Status = 'status'
}

/** Boolean expression to compare columns of type "argo_material_activity_kind_enum". All fields are combined with logical 'AND'. */
export type ArgoMaterialActivityKindEnumComparisonExp = {
  _eq?: Maybe<ArgoMaterialActivityKindEnum>;
  _in?: Maybe<Array<ArgoMaterialActivityKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoMaterialActivityKindEnum>;
  _nin?: Maybe<Array<ArgoMaterialActivityKindEnum>>;
};

/** input type for inserting data into table "argo.material_activity_kind" */
export type ArgoMaterialActivityKindInsertInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMaterialActivityKindMaxFields = {
  __typename?: 'argo_material_activity_kind_max_fields';
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialActivityKindMinFields = {
  __typename?: 'argo_material_activity_kind_min_fields';
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_activity_kind" */
export type ArgoMaterialActivityKindMutationResponse = {
  __typename?: 'argo_material_activity_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialActivityKind>;
};

/** input type for inserting object relation for remote table "argo.material_activity_kind" */
export type ArgoMaterialActivityKindObjRelInsertInput = {
  data: ArgoMaterialActivityKindInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialActivityKindOnConflict>;
};

/** on_conflict condition type for table "argo.material_activity_kind" */
export type ArgoMaterialActivityKindOnConflict = {
  constraint: ArgoMaterialActivityKindConstraint;
  update_columns?: Array<ArgoMaterialActivityKindUpdateColumn>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};

/** Ordering options when selecting data from "argo.material_activity_kind". */
export type ArgoMaterialActivityKindOrderBy = {
  description?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_activity_kind */
export type ArgoMaterialActivityKindPkColumnsInput = {
  kind: Scalars['String'];
};

/** select columns of table "argo.material_activity_kind" */
export enum ArgoMaterialActivityKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "argo.material_activity_kind" */
export type ArgoMaterialActivityKindSetInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_material_activity_kind" */
export type ArgoMaterialActivityKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialActivityKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialActivityKindStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.material_activity_kind" */
export enum ArgoMaterialActivityKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

export type ArgoMaterialActivityKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialActivityKindSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialActivityKindBoolExp;
};

/** aggregate max on columns */
export type ArgoMaterialActivityMaxFields = {
  __typename?: 'argo_material_activity_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  material_activity_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialActivityMinFields = {
  __typename?: 'argo_material_activity_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  material_activity_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_activity" */
export type ArgoMaterialActivityMutationResponse = {
  __typename?: 'argo_material_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialActivity>;
};

/** on_conflict condition type for table "argo.material_activity" */
export type ArgoMaterialActivityOnConflict = {
  constraint: ArgoMaterialActivityConstraint;
  update_columns?: Array<ArgoMaterialActivityUpdateColumn>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};

/** Ordering options when selecting data from "argo.material_activity". */
export type ArgoMaterialActivityOrderBy = {
  activity_kind?: Maybe<ArgoMaterialActivityKindOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_activity_id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  note?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_activity */
export type ArgoMaterialActivityPkColumnsInput = {
  material_activity_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialActivityPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_activity" */
export enum ArgoMaterialActivitySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialActivityId = 'material_activity_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.material_activity" */
export type ArgoMaterialActivitySetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoMaterialActivityKindEnum>;
  material_activity_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoMaterialStatusEnum>;
};

/** Streaming cursor of the table "argo_material_activity" */
export type ArgoMaterialActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialActivityStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoMaterialActivityKindEnum>;
  material_activity_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoMaterialStatusEnum>;
};

/** update columns of table "argo.material_activity" */
export enum ArgoMaterialActivityUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialActivityId = 'material_activity_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status'
}

export type ArgoMaterialActivityUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialActivityAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialActivityDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialActivityDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialActivityDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialActivityPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialActivitySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialActivityBoolExp;
};

/** aggregated selection of "argo.material" */
export type ArgoMaterialAggregate = {
  __typename?: 'argo_material_aggregate';
  aggregate?: Maybe<ArgoMaterialAggregateFields>;
  nodes: Array<ArgoMaterial>;
};

export type ArgoMaterialAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialAggregateBoolExpCount>;
};

export type ArgoMaterialAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material" */
export type ArgoMaterialAggregateFields = {
  __typename?: 'argo_material_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialMaxFields>;
  min?: Maybe<ArgoMaterialMinFields>;
};


/** aggregate fields of "argo.material" */
export type ArgoMaterialAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material" */
export type ArgoMaterialAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialMaxOrderBy>;
  min?: Maybe<ArgoMaterialMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material" */
export type ArgoMaterialArrRelInsertInput = {
  data: Array<ArgoMaterialInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialOnConflict>;
};

/** Type only table; DOES NOT CONTAIN DATA */
export type ArgoMaterialAssembly = {
  __typename?: 'argo_material_assembly';
  /** An object relationship */
  assembly_material: ArgoMaterial;
  assembly_material_id: Scalars['uuid'];
  /** An object relationship */
  collection_data?: Maybe<ProcessCollectionData>;
  collection_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  component_material: ArgoMaterial;
  component_material_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  data_element_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  material_marriage: ArgoMaterialMarriage;
  material_marriage_id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  status: ArgoMaterialMarriageStatusEnum;
  status_note?: Maybe<Scalars['String']>;
};


/** Type only table; DOES NOT CONTAIN DATA */
export type ArgoMaterialAssemblyMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_assembly" */
export type ArgoMaterialAssemblyAggregate = {
  __typename?: 'argo_material_assembly_aggregate';
  aggregate?: Maybe<ArgoMaterialAssemblyAggregateFields>;
  nodes: Array<ArgoMaterialAssembly>;
};

/** aggregate fields of "argo.material_assembly" */
export type ArgoMaterialAssemblyAggregateFields = {
  __typename?: 'argo_material_assembly_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialAssemblyMaxFields>;
  min?: Maybe<ArgoMaterialAssemblyMinFields>;
};


/** aggregate fields of "argo.material_assembly" */
export type ArgoMaterialAssemblyAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialAssemblyAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.material_assembly". All fields are combined with a logical 'AND'. */
export type ArgoMaterialAssemblyBoolExp = {
  _and?: Maybe<Array<ArgoMaterialAssemblyBoolExp>>;
  _not?: Maybe<ArgoMaterialAssemblyBoolExp>;
  _or?: Maybe<Array<ArgoMaterialAssemblyBoolExp>>;
  assembly_material?: Maybe<ArgoMaterialBoolExp>;
  assembly_material_id?: Maybe<UuidComparisonExp>;
  collection_data?: Maybe<ProcessCollectionDataBoolExp>;
  collection_id?: Maybe<UuidComparisonExp>;
  component_material?: Maybe<ArgoMaterialBoolExp>;
  component_material_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  data_element_id?: Maybe<UuidComparisonExp>;
  material_marriage?: Maybe<ArgoMaterialMarriageBoolExp>;
  material_marriage_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  status?: Maybe<ArgoMaterialMarriageStatusEnumComparisonExp>;
  status_note?: Maybe<StringComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialAssemblyDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialAssemblyDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialAssemblyDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_assembly" */
export type ArgoMaterialAssemblyInsertInput = {
  assembly_material?: Maybe<ArgoMaterialObjRelInsertInput>;
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_data?: Maybe<ProcessCollectionDataObjRelInsertInput>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material?: Maybe<ArgoMaterialObjRelInsertInput>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage?: Maybe<ArgoMaterialMarriageObjRelInsertInput>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMaterialAssemblyMaxFields = {
  __typename?: 'argo_material_assembly_max_fields';
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  status_note?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialAssemblyMinFields = {
  __typename?: 'argo_material_assembly_min_fields';
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  status_note?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_assembly" */
export type ArgoMaterialAssemblyMutationResponse = {
  __typename?: 'argo_material_assembly_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialAssembly>;
};

/** Ordering options when selecting data from "argo.material_assembly". */
export type ArgoMaterialAssemblyOrderBy = {
  assembly_material?: Maybe<ArgoMaterialOrderBy>;
  assembly_material_id?: Maybe<OrderBy>;
  collection_data?: Maybe<ProcessCollectionDataOrderBy>;
  collection_id?: Maybe<OrderBy>;
  component_material?: Maybe<ArgoMaterialOrderBy>;
  component_material_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  data_element_id?: Maybe<OrderBy>;
  material_marriage?: Maybe<ArgoMaterialMarriageOrderBy>;
  material_marriage_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_note?: Maybe<OrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialAssemblyPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_assembly" */
export enum ArgoMaterialAssemblySelectColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note'
}

/** input type for updating data in table "argo.material_assembly" */
export type ArgoMaterialAssemblySetInput = {
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_material_assembly" */
export type ArgoMaterialAssemblyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialAssemblyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialAssemblyStreamCursorValueInput = {
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
};

export type ArgoMaterialAssemblyUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialAssemblyAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialAssemblyDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialAssemblyDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialAssemblyDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialAssemblyPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialAssemblySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialAssemblyBoolExp;
};

/** Material Attribute Link Table */
export type ArgoMaterialAttribute = {
  __typename?: 'argo_material_attribute';
  /** An object relationship */
  attribute: ArgoAttribute;
  attribute_id: Scalars['uuid'];
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  material: ArgoMaterial;
  material_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.material_attribute" */
export type ArgoMaterialAttributeAggregate = {
  __typename?: 'argo_material_attribute_aggregate';
  aggregate?: Maybe<ArgoMaterialAttributeAggregateFields>;
  nodes: Array<ArgoMaterialAttribute>;
};

export type ArgoMaterialAttributeAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialAttributeAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialAttributeAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialAttributeAggregateBoolExpCount>;
};

export type ArgoMaterialAttributeAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialAttributeAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialAttributeAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialAttributeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_attribute" */
export type ArgoMaterialAttributeAggregateFields = {
  __typename?: 'argo_material_attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialAttributeMaxFields>;
  min?: Maybe<ArgoMaterialAttributeMinFields>;
};


/** aggregate fields of "argo.material_attribute" */
export type ArgoMaterialAttributeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_attribute" */
export type ArgoMaterialAttributeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialAttributeMaxOrderBy>;
  min?: Maybe<ArgoMaterialAttributeMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.material_attribute" */
export type ArgoMaterialAttributeArrRelInsertInput = {
  data: Array<ArgoMaterialAttributeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialAttributeOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_attribute". All fields are combined with a logical 'AND'. */
export type ArgoMaterialAttributeBoolExp = {
  _and?: Maybe<Array<ArgoMaterialAttributeBoolExp>>;
  _not?: Maybe<ArgoMaterialAttributeBoolExp>;
  _or?: Maybe<Array<ArgoMaterialAttributeBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_attribute" */
export enum ArgoMaterialAttributeConstraint {
  /** unique or primary key constraint on columns "material_attribute_id" */
  MaterialAttributePkey = 'material_attribute_pkey',
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_id" */
  MaterialAttributeUnique = 'material_attribute_unique'
}

/** Attribute history for materials */
export type ArgoMaterialAttributeHistory = {
  __typename?: 'argo_material_attribute_history';
  /** An object relationship */
  attribute: ArgoAttribute;
  /** The attribute id */
  attribute_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  /** The context id */
  context_id: Scalars['uuid'];
  /** The created at */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The created by id */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  history_status: ArgoAttributeHistoryStatusType;
  /** The material attribute history id */
  id: Scalars['uuid'];
  /** An object relationship */
  material: ArgoMaterial;
  /** The material id */
  material_id: Scalars['uuid'];
  /** The status */
  status: ArgoAttributeHistoryStatusTypeEnum;
  /** The updated at */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryAggregate = {
  __typename?: 'argo_material_attribute_history_aggregate';
  aggregate?: Maybe<ArgoMaterialAttributeHistoryAggregateFields>;
  nodes: Array<ArgoMaterialAttributeHistory>;
};

/** aggregate fields of "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryAggregateFields = {
  __typename?: 'argo_material_attribute_history_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialAttributeHistoryMaxFields>;
  min?: Maybe<ArgoMaterialAttributeHistoryMinFields>;
};


/** aggregate fields of "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialAttributeHistorySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.material_attribute_history". All fields are combined with a logical 'AND'. */
export type ArgoMaterialAttributeHistoryBoolExp = {
  _and?: Maybe<Array<ArgoMaterialAttributeHistoryBoolExp>>;
  _not?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
  _or?: Maybe<Array<ArgoMaterialAttributeHistoryBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistoryConstraint {
  /** unique or primary key constraint on columns "material_attribute_history_id" */
  MaterialAttributeHistoryPkey = 'material_attribute_history_pkey'
}

/** input type for inserting data into table "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeObjRelInsertInput>;
  /** The material attribute history id */
  id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  /** The material id */
  material_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialAttributeHistoryMaxFields = {
  __typename?: 'argo_material_attribute_history_max_fields';
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The material attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The material id */
  material_id?: Maybe<Scalars['uuid']>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoMaterialAttributeHistoryMinFields = {
  __typename?: 'argo_material_attribute_history_min_fields';
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The material attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The material id */
  material_id?: Maybe<Scalars['uuid']>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryMutationResponse = {
  __typename?: 'argo_material_attribute_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialAttributeHistory>;
};

/** on_conflict condition type for table "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistoryOnConflict = {
  constraint: ArgoMaterialAttributeHistoryConstraint;
  update_columns?: Array<ArgoMaterialAttributeHistoryUpdateColumn>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};

/** Ordering options when selecting data from "argo.material_attribute_history". */
export type ArgoMaterialAttributeHistoryOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  history_status?: Maybe<ArgoAttributeHistoryStatusTypeOrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_attribute_history */
export type ArgoMaterialAttributeHistoryPkColumnsInput = {
  /** The material attribute history id */
  id: Scalars['uuid'];
};

/** select columns of table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistorySelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_attribute_history" */
export type ArgoMaterialAttributeHistorySetInput = {
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The material attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The material id */
  material_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_attribute_history" */
export type ArgoMaterialAttributeHistoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialAttributeHistoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialAttributeHistoryStreamCursorValueInput = {
  /** The attribute id */
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context id */
  context_id?: Maybe<Scalars['uuid']>;
  /** The created at */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The created by id */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The material attribute history id */
  id?: Maybe<Scalars['uuid']>;
  /** The material id */
  material_id?: Maybe<Scalars['uuid']>;
  /** The status */
  status?: Maybe<ArgoAttributeHistoryStatusTypeEnum>;
  /** The updated at */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The updated by id */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_attribute_history" */
export enum ArgoMaterialAttributeHistoryUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialAttributeHistoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialAttributeHistorySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialAttributeHistoryBoolExp;
};

/** input type for inserting data into table "argo.material_attribute" */
export type ArgoMaterialAttributeInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialAttributeMaxFields = {
  __typename?: 'argo_material_attribute_max_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_attribute" */
export type ArgoMaterialAttributeMaxOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialAttributeMinFields = {
  __typename?: 'argo_material_attribute_min_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_attribute" */
export type ArgoMaterialAttributeMinOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_attribute" */
export type ArgoMaterialAttributeMutationResponse = {
  __typename?: 'argo_material_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialAttribute>;
};

/** on_conflict condition type for table "argo.material_attribute" */
export type ArgoMaterialAttributeOnConflict = {
  constraint: ArgoMaterialAttributeConstraint;
  update_columns?: Array<ArgoMaterialAttributeUpdateColumn>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};

/** Ordering options when selecting data from "argo.material_attribute". */
export type ArgoMaterialAttributeOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_attribute */
export type ArgoMaterialAttributePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.material_attribute" */
export type ArgoMaterialAttributeSetInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_attribute" */
export type ArgoMaterialAttributeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialAttributeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialAttributeStreamCursorValueInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialAttributeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialAttributeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialAttributeBoolExp;
};

/** Boolean expression to filter rows from the table "argo.material". All fields are combined with a logical 'AND'. */
export type ArgoMaterialBoolExp = {
  _and?: Maybe<Array<ArgoMaterialBoolExp>>;
  _not?: Maybe<ArgoMaterialBoolExp>;
  _or?: Maybe<Array<ArgoMaterialBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  created_location?: Maybe<ArgoLocationBoolExp>;
  created_location_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_attributes?: Maybe<ArgoMaterialAttributeBoolExp>;
  material_attributes_aggregate?: Maybe<ArgoMaterialAttributeAggregateBoolExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  material_status?: Maybe<ArgoMaterialStatusBoolExp>;
  material_udf_data?: Maybe<ArgoMaterialUdfDataBoolExp>;
  material_udf_data_aggregate?: Maybe<ArgoMaterialUdfDataAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  process_material_states?: Maybe<ProcessMaterialStateBoolExp>;
  process_material_states_aggregate?: Maybe<ProcessMaterialStateAggregateBoolExp>;
  serial_number?: Maybe<StringComparisonExp>;
  serial_number_active?: Maybe<BooleanComparisonExp>;
  status?: Maybe<ArgoMaterialStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_order_material?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};

/** Table to define classifications for Material Models */
export type ArgoMaterialClass = {
  __typename?: 'argo_material_class';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_default?: Maybe<Scalars['Boolean']>;
  /** Json array of media links to storage for this material model */
  linked_media: Scalars['argo_material_class_model_linked_media'];
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture: Scalars['argo_material_class_model_linked_profile_picture'];
  /** An array relationship */
  material_class_attribute_settings: Array<ArgoMaterialClassAttributeSetting>;
  /** An aggregate relationship */
  material_class_attribute_settings_aggregate: ArgoMaterialClassAttributeSettingAggregate;
  /** An array relationship */
  material_class_attributes: Array<ArgoMaterialClassAttribute>;
  /** An aggregate relationship */
  material_class_attributes_aggregate: ArgoMaterialClassAttributeAggregate;
  /** An array relationship */
  material_class_processes: Array<ArgoMaterialClassProcess>;
  /** An aggregate relationship */
  material_class_processes_aggregate: ArgoMaterialClassProcessAggregate;
  /** An array relationship */
  material_model_processes: Array<ArgoVwMaterialModelProcessesByClass>;
  /** An aggregate relationship */
  material_model_processes_aggregate: ArgoVwMaterialModelProcessesByClassAggregate;
  /** An array relationship */
  material_models: Array<ArgoMaterialModel>;
  /** An aggregate relationship */
  material_models_aggregate: ArgoMaterialModelAggregate;
  material_quantity_type?: Maybe<ArgoMaterialQuantityKindEnum>;
  /** An array relationship */
  material_udf_schemas: Array<ArgoMaterialUdfSchema>;
  /** An aggregate relationship */
  material_udf_schemas_aggregate: ArgoMaterialUdfSchemaAggregate;
  /** An array relationship */
  materials: Array<ArgoVwMaterialByClass>;
  /** An aggregate relationship */
  materials_aggregate: ArgoVwMaterialByClassAggregate;
  /** A column for meta data */
  meta: Scalars['argo_material_class_meta'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  serial_number_formats: Array<ArgoSnFormat>;
  /** An aggregate relationship */
  serial_number_formats_aggregate: ArgoSnFormatAggregate;
  /** An object relationship */
  sn_format?: Maybe<ArgoSnFormat>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassLinkedMediaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassLinkedProfilePictureArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassAttributeSettingsArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassAttributeSettingsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassProcessesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialClassProcessesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialModelProcessesArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialModelProcessesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialModelsArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialModelsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialUdfSchemasArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialUdfSchemasAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialsArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMaterialsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassSerialNumberFormatsArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


/** Table to define classifications for Material Models */
export type ArgoMaterialClassSerialNumberFormatsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};

/** aggregated selection of "argo.material_class" */
export type ArgoMaterialClassAggregate = {
  __typename?: 'argo_material_class_aggregate';
  aggregate?: Maybe<ArgoMaterialClassAggregateFields>;
  nodes: Array<ArgoMaterialClass>;
};

/** aggregate fields of "argo.material_class" */
export type ArgoMaterialClassAggregateFields = {
  __typename?: 'argo_material_class_aggregate_fields';
  avg?: Maybe<ArgoMaterialClassAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialClassMaxFields>;
  min?: Maybe<ArgoMaterialClassMinFields>;
  stddev?: Maybe<ArgoMaterialClassStddevFields>;
  stddev_pop?: Maybe<ArgoMaterialClassStddevPopFields>;
  stddev_samp?: Maybe<ArgoMaterialClassStddevSampFields>;
  sum?: Maybe<ArgoMaterialClassSumFields>;
  var_pop?: Maybe<ArgoMaterialClassVarPopFields>;
  var_samp?: Maybe<ArgoMaterialClassVarSampFields>;
  variance?: Maybe<ArgoMaterialClassVarianceFields>;
};


/** aggregate fields of "argo.material_class" */
export type ArgoMaterialClassAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassAppendInput = {
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['jsonb']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Link Table between Material Class and Attributes */
export type ArgoMaterialClassAttribute = {
  __typename?: 'argo_material_class_attribute';
  /** An object relationship */
  attribute: ArgoAttribute;
  attribute_id: Scalars['uuid'];
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_class: ArgoMaterialClass;
  material_class_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeAggregate = {
  __typename?: 'argo_material_class_attribute_aggregate';
  aggregate?: Maybe<ArgoMaterialClassAttributeAggregateFields>;
  nodes: Array<ArgoMaterialClassAttribute>;
};

export type ArgoMaterialClassAttributeAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialClassAttributeAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialClassAttributeAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialClassAttributeAggregateBoolExpCount>;
};

export type ArgoMaterialClassAttributeAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialClassAttributeAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialClassAttributeAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeAggregateFields = {
  __typename?: 'argo_material_class_attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialClassAttributeMaxFields>;
  min?: Maybe<ArgoMaterialClassAttributeMinFields>;
};


/** aggregate fields of "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialClassAttributeMaxOrderBy>;
  min?: Maybe<ArgoMaterialClassAttributeMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeArrRelInsertInput = {
  data: Array<ArgoMaterialClassAttributeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialClassAttributeOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_class_attribute". All fields are combined with a logical 'AND'. */
export type ArgoMaterialClassAttributeBoolExp = {
  _and?: Maybe<Array<ArgoMaterialClassAttributeBoolExp>>;
  _not?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  _or?: Maybe<Array<ArgoMaterialClassAttributeBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_class_id" */
  MaterialClassAttributeAttributeIdMaterialClassIdKey = 'material_class_attribute_attribute_id_material_class_id_key',
  /** unique or primary key constraint on columns "material_class_attribute_id" */
  MaterialClassAttributePkey = 'material_class_attribute_pkey'
}

/** input type for inserting data into table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialClassAttributeMaxFields = {
  __typename?: 'argo_material_class_attribute_max_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeMaxOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialClassAttributeMinFields = {
  __typename?: 'argo_material_class_attribute_min_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeMinOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeMutationResponse = {
  __typename?: 'argo_material_class_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialClassAttribute>;
};

/** on_conflict condition type for table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeOnConflict = {
  constraint: ArgoMaterialClassAttributeConstraint;
  update_columns?: Array<ArgoMaterialClassAttributeUpdateColumn>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};

/** Ordering options when selecting data from "argo.material_class_attribute". */
export type ArgoMaterialClassAttributeOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_class_attribute */
export type ArgoMaterialClassAttributePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_class_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_class_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.material_class_attribute" */
export type ArgoMaterialClassAttributeSetInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Attribute setting */
export type ArgoMaterialClassAttributeSetting = {
  __typename?: 'argo_material_class_attribute_setting';
  /** An object relationship */
  attribute_schema: ArgoAttributeSchema;
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id: Scalars['uuid'];
  /** The attribute setting configuration */
  config: Scalars['argo_attribute_setting_config'];
  /** The context */
  context_id: Scalars['uuid'];
  /** The time the attribute setting was created */
  created_at: Scalars['timestamptz'];
  /** The user that created the attribute setting */
  created_by_id: Scalars['uuid'];
  /** The primary key */
  id: Scalars['uuid'];
  /** An object relationship */
  material_class: ArgoMaterialClass;
  /** The material class the attribute setting belongs to */
  material_class_id: Scalars['uuid'];
  /** The time the attribute setting was last updated */
  updated_at: Scalars['timestamptz'];
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Attribute setting */
export type ArgoMaterialClassAttributeSettingConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingAggregate = {
  __typename?: 'argo_material_class_attribute_setting_aggregate';
  aggregate?: Maybe<ArgoMaterialClassAttributeSettingAggregateFields>;
  nodes: Array<ArgoMaterialClassAttributeSetting>;
};

export type ArgoMaterialClassAttributeSettingAggregateBoolExp = {
  count?: Maybe<ArgoMaterialClassAttributeSettingAggregateBoolExpCount>;
};

export type ArgoMaterialClassAttributeSettingAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingAggregateFields = {
  __typename?: 'argo_material_class_attribute_setting_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialClassAttributeSettingMaxFields>;
  min?: Maybe<ArgoMaterialClassAttributeSettingMinFields>;
};


/** aggregate fields of "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialClassAttributeSettingMaxOrderBy>;
  min?: Maybe<ArgoMaterialClassAttributeSettingMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassAttributeSettingAppendInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingArrRelInsertInput = {
  data: Array<ArgoMaterialClassAttributeSettingInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialClassAttributeSettingOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_class_attribute_setting". All fields are combined with a logical 'AND'. */
export type ArgoMaterialClassAttributeSettingBoolExp = {
  _and?: Maybe<Array<ArgoMaterialClassAttributeSettingBoolExp>>;
  _not?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
  _or?: Maybe<Array<ArgoMaterialClassAttributeSettingBoolExp>>;
  attribute_schema?: Maybe<ArgoAttributeSchemaBoolExp>;
  attribute_schema_id?: Maybe<UuidComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingConstraint {
  /** unique or primary key constraint on columns "material_class_attribute_setting_id" */
  MaterialClassAttributeSettingPkey = 'material_class_attribute_setting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialClassAttributeSettingDeleteAtPathInput = {
  /** The attribute setting configuration */
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialClassAttributeSettingDeleteElemInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialClassAttributeSettingDeleteKeyInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingInsertInput = {
  attribute_schema?: Maybe<ArgoAttributeSchemaObjRelInsertInput>;
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialClassAttributeSettingMaxFields = {
  __typename?: 'argo_material_class_attribute_setting_max_fields';
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingMaxOrderBy = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context */
  context_id?: Maybe<OrderBy>;
  /** The time the attribute setting was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<OrderBy>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialClassAttributeSettingMinFields = {
  __typename?: 'argo_material_class_attribute_setting_min_fields';
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingMinOrderBy = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context */
  context_id?: Maybe<OrderBy>;
  /** The time the attribute setting was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<OrderBy>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingMutationResponse = {
  __typename?: 'argo_material_class_attribute_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialClassAttributeSetting>;
};

/** on_conflict condition type for table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingOnConflict = {
  constraint: ArgoMaterialClassAttributeSettingConstraint;
  update_columns?: Array<ArgoMaterialClassAttributeSettingUpdateColumn>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};

/** Ordering options when selecting data from "argo.material_class_attribute_setting". */
export type ArgoMaterialClassAttributeSettingOrderBy = {
  attribute_schema?: Maybe<ArgoAttributeSchemaOrderBy>;
  attribute_schema_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_class_attribute_setting */
export type ArgoMaterialClassAttributeSettingPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassAttributeSettingPrependInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingSetInput = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_class_attribute_setting" */
export type ArgoMaterialClassAttributeSettingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialClassAttributeSettingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialClassAttributeSettingStreamCursorValueInput = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material class the attribute setting belongs to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialClassAttributeSettingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialClassAttributeSettingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialClassAttributeSettingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialClassAttributeSettingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialClassAttributeSettingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialClassAttributeSettingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialClassAttributeSettingSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialClassAttributeSettingBoolExp;
};

/** Streaming cursor of the table "argo_material_class_attribute" */
export type ArgoMaterialClassAttributeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialClassAttributeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialClassAttributeStreamCursorValueInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialClassAttributeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialClassAttributeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialClassAttributeBoolExp;
};

/** aggregate avg on columns */
export type ArgoMaterialClassAvgFields = {
  __typename?: 'argo_material_class_avg_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.material_class". All fields are combined with a logical 'AND'. */
export type ArgoMaterialClassBoolExp = {
  _and?: Maybe<Array<ArgoMaterialClassBoolExp>>;
  _not?: Maybe<ArgoMaterialClassBoolExp>;
  _or?: Maybe<Array<ArgoMaterialClassBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_default?: Maybe<BooleanComparisonExp>;
  linked_media?: Maybe<JsonbComparisonExp>;
  linked_profile_picture?: Maybe<JsonbComparisonExp>;
  material_class_attribute_settings?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
  material_class_attribute_settings_aggregate?: Maybe<ArgoMaterialClassAttributeSettingAggregateBoolExp>;
  material_class_attributes?: Maybe<ArgoMaterialClassAttributeBoolExp>;
  material_class_attributes_aggregate?: Maybe<ArgoMaterialClassAttributeAggregateBoolExp>;
  material_class_processes?: Maybe<ArgoMaterialClassProcessBoolExp>;
  material_class_processes_aggregate?: Maybe<ArgoMaterialClassProcessAggregateBoolExp>;
  material_model_processes?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
  material_model_processes_aggregate?: Maybe<ArgoVwMaterialModelProcessesByClassAggregateBoolExp>;
  material_models?: Maybe<ArgoMaterialModelBoolExp>;
  material_models_aggregate?: Maybe<ArgoMaterialModelAggregateBoolExp>;
  material_quantity_type?: Maybe<ArgoMaterialQuantityKindEnumComparisonExp>;
  material_udf_schemas?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  material_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExp>;
  materials?: Maybe<ArgoVwMaterialByClassBoolExp>;
  materials_aggregate?: Maybe<ArgoVwMaterialByClassAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  profile_file_id?: Maybe<UuidComparisonExp>;
  serial_number_formats?: Maybe<ArgoSnFormatBoolExp>;
  serial_number_formats_aggregate?: Maybe<ArgoSnFormatAggregateBoolExp>;
  sn_format?: Maybe<ArgoSnFormatBoolExp>;
  sn_format_id?: Maybe<IntComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_class" */
export enum ArgoMaterialClassConstraint {
  /** unique or primary key constraint on columns "context_id", "name" */
  MaterialClassContextIdName = 'material_class_context_id_name',
  /** unique or primary key constraint on columns "context_id", "is_default" */
  MaterialClassIsDefaultCnstrnt = 'material_class_is_default_cnstrnt',
  /** unique or primary key constraint on columns "material_class_id" */
  MaterialClassPkey = 'material_class_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  MaterialClassUnique = 'material_class_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialClassDeleteAtPathInput = {
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Array<Scalars['String']>>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialClassDeleteElemInput = {
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['Int']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialClassDeleteKeyInput = {
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['String']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.material_class" */
export type ArgoMaterialClassIncInput = {
  sn_format_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.material_class" */
export type ArgoMaterialClassInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['jsonb']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  material_class_attribute_settings?: Maybe<ArgoMaterialClassAttributeSettingArrRelInsertInput>;
  material_class_attributes?: Maybe<ArgoMaterialClassAttributeArrRelInsertInput>;
  material_class_processes?: Maybe<ArgoMaterialClassProcessArrRelInsertInput>;
  material_model_processes?: Maybe<ArgoVwMaterialModelProcessesByClassArrRelInsertInput>;
  material_models?: Maybe<ArgoMaterialModelArrRelInsertInput>;
  material_quantity_type?: Maybe<ArgoMaterialQuantityKindEnum>;
  material_udf_schemas?: Maybe<ArgoMaterialUdfSchemaArrRelInsertInput>;
  materials?: Maybe<ArgoVwMaterialByClassArrRelInsertInput>;
  /** A column for meta data */
  meta: Scalars['argo_material_class_meta'];
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  serial_number_formats?: Maybe<ArgoSnFormatArrRelInsertInput>;
  sn_format?: Maybe<ArgoSnFormatObjRelInsertInput>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialClassMaxFields = {
  __typename?: 'argo_material_class_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** aggregate min on columns */
export type ArgoMaterialClassMinFields = {
  __typename?: 'argo_material_class_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};



/** response of any mutation on the table "argo.material_class" */
export type ArgoMaterialClassMutationResponse = {
  __typename?: 'argo_material_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialClass>;
};

/** input type for inserting object relation for remote table "argo.material_class" */
export type ArgoMaterialClassObjRelInsertInput = {
  data: ArgoMaterialClassInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialClassOnConflict>;
};

/** on_conflict condition type for table "argo.material_class" */
export type ArgoMaterialClassOnConflict = {
  constraint: ArgoMaterialClassConstraint;
  update_columns?: Array<ArgoMaterialClassUpdateColumn>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};

/** Ordering options when selecting data from "argo.material_class". */
export type ArgoMaterialClassOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_default?: Maybe<OrderBy>;
  linked_media?: Maybe<OrderBy>;
  linked_profile_picture?: Maybe<OrderBy>;
  material_class_attribute_settings_aggregate?: Maybe<ArgoMaterialClassAttributeSettingAggregateOrderBy>;
  material_class_attributes_aggregate?: Maybe<ArgoMaterialClassAttributeAggregateOrderBy>;
  material_class_processes_aggregate?: Maybe<ArgoMaterialClassProcessAggregateOrderBy>;
  material_model_processes_aggregate?: Maybe<ArgoVwMaterialModelProcessesByClassAggregateOrderBy>;
  material_models_aggregate?: Maybe<ArgoMaterialModelAggregateOrderBy>;
  material_quantity_type?: Maybe<OrderBy>;
  material_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateOrderBy>;
  materials_aggregate?: Maybe<ArgoVwMaterialByClassAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  serial_number_formats_aggregate?: Maybe<ArgoSnFormatAggregateOrderBy>;
  sn_format?: Maybe<ArgoSnFormatOrderBy>;
  sn_format_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_class */
export type ArgoMaterialClassPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassPrependInput = {
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['jsonb']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** The Process to be Linked to Material of this Class */
export type ArgoMaterialClassProcess = {
  __typename?: 'argo_material_class_process';
  /** Boolean representation of the status of a process in relation to the material model. Being set to false denotes the process will explicitly be avoided on material creation only. Being set to true will automatically link the process to the material on creation. */
  active: Scalars['Boolean'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_class: ArgoMaterialClass;
  /** Material Model for this entry */
  material_class_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  process: ProcessProcess;
  /** Process for this entry */
  process_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The Process to be Linked to Material of this Class */
export type ArgoMaterialClassProcessMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_class_process" */
export type ArgoMaterialClassProcessAggregate = {
  __typename?: 'argo_material_class_process_aggregate';
  aggregate?: Maybe<ArgoMaterialClassProcessAggregateFields>;
  nodes: Array<ArgoMaterialClassProcess>;
};

export type ArgoMaterialClassProcessAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialClassProcessAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialClassProcessAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialClassProcessAggregateBoolExpCount>;
};

export type ArgoMaterialClassProcessAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassProcessBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialClassProcessAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassProcessBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialClassProcessAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialClassProcessBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_class_process" */
export type ArgoMaterialClassProcessAggregateFields = {
  __typename?: 'argo_material_class_process_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialClassProcessMaxFields>;
  min?: Maybe<ArgoMaterialClassProcessMinFields>;
};


/** aggregate fields of "argo.material_class_process" */
export type ArgoMaterialClassProcessAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_class_process" */
export type ArgoMaterialClassProcessAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialClassProcessMaxOrderBy>;
  min?: Maybe<ArgoMaterialClassProcessMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassProcessAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_class_process" */
export type ArgoMaterialClassProcessArrRelInsertInput = {
  data: Array<ArgoMaterialClassProcessInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialClassProcessOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_class_process". All fields are combined with a logical 'AND'. */
export type ArgoMaterialClassProcessBoolExp = {
  _and?: Maybe<Array<ArgoMaterialClassProcessBoolExp>>;
  _not?: Maybe<ArgoMaterialClassProcessBoolExp>;
  _or?: Maybe<Array<ArgoMaterialClassProcessBoolExp>>;
  active?: Maybe<BooleanComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_class_process" */
export enum ArgoMaterialClassProcessConstraint {
  /** unique or primary key constraint on columns "material_class_process_id" */
  MaterialClassProcessPkey = 'material_class_process_pkey',
  /** unique or primary key constraint on columns "material_class_id", "process_id" */
  MaterialClassProcessUnique = 'material_class_process_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialClassProcessDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialClassProcessDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialClassProcessDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_class_process" */
export type ArgoMaterialClassProcessInsertInput = {
  /** Boolean representation of the status of a process in relation to the material model. Being set to false denotes the process will explicitly be avoided on material creation only. Being set to true will automatically link the process to the material on creation. */
  active?: Maybe<Scalars['Boolean']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  /** Material Model for this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialClassProcessMaxFields = {
  __typename?: 'argo_material_class_process_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_class_process" */
export type ArgoMaterialClassProcessMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material Model for this entry */
  material_class_id?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialClassProcessMinFields = {
  __typename?: 'argo_material_class_process_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_class_process" */
export type ArgoMaterialClassProcessMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material Model for this entry */
  material_class_id?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_class_process" */
export type ArgoMaterialClassProcessMutationResponse = {
  __typename?: 'argo_material_class_process_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialClassProcess>;
};

/** on_conflict condition type for table "argo.material_class_process" */
export type ArgoMaterialClassProcessOnConflict = {
  constraint: ArgoMaterialClassProcessConstraint;
  update_columns?: Array<ArgoMaterialClassProcessUpdateColumn>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};

/** Ordering options when selecting data from "argo.material_class_process". */
export type ArgoMaterialClassProcessOrderBy = {
  active?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_class_process */
export type ArgoMaterialClassProcessPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialClassProcessPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_class_process_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "argo_material_class_process_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "argo.material_class_process" */
export type ArgoMaterialClassProcessSetInput = {
  /** Boolean representation of the status of a process in relation to the material model. Being set to false denotes the process will explicitly be avoided on material creation only. Being set to true will automatically link the process to the material on creation. */
  active?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_class_process" */
export type ArgoMaterialClassProcessStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialClassProcessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialClassProcessStreamCursorValueInput = {
  /** Boolean representation of the status of a process in relation to the material model. Being set to false denotes the process will explicitly be avoided on material creation only. Being set to true will automatically link the process to the material on creation. */
  active?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialClassProcessUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialClassProcessAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialClassProcessDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialClassProcessDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialClassProcessDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialClassProcessPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialClassProcessSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialClassProcessBoolExp;
};

/** select columns of table "argo.material_class" */
export enum ArgoMaterialClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialQuantityType = 'material_quantity_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_class" */
export type ArgoMaterialClassSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['jsonb']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  material_quantity_type?: Maybe<ArgoMaterialQuantityKindEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['argo_material_class_meta']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoMaterialClassStddevFields = {
  __typename?: 'argo_material_class_stddev_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoMaterialClassStddevPopFields = {
  __typename?: 'argo_material_class_stddev_pop_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoMaterialClassStddevSampFields = {
  __typename?: 'argo_material_class_stddev_samp_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_material_class" */
export type ArgoMaterialClassStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialClassStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialClassStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  /** Json array of media links to storage for this material model */
  linked_media?: Maybe<Scalars['jsonb']>;
  /** Json object of profile picture link to storage for this material model */
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  material_quantity_type?: Maybe<ArgoMaterialQuantityKindEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoMaterialClassSumFields = {
  __typename?: 'argo_material_class_sum_fields';
  sn_format_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "argo.material_class" */
export enum ArgoMaterialClassUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialQuantityType = 'material_quantity_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialClassUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialClassAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialClassDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialClassDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialClassDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMaterialClassIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialClassPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialClassSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialClassBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMaterialClassVarPopFields = {
  __typename?: 'argo_material_class_var_pop_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoMaterialClassVarSampFields = {
  __typename?: 'argo_material_class_var_samp_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoMaterialClassVarianceFields = {
  __typename?: 'argo_material_class_variance_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "argo.material" */
export enum ArgoMaterialConstraint {
  /** unique or primary key constraint on columns "material_id" */
  MaterialPkey = 'material_pkey',
  /** unique or primary key constraint on columns "context_id", "serial_number", "material_model_id" */
  MaterialSerialNumberInactiveModelUnique = 'material_serial_number_inactive_model_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material" */
export type ArgoMaterialInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_attributes?: Maybe<ArgoMaterialAttributeArrRelInsertInput>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  /** The model that this material is related to */
  material_model_id?: Maybe<Scalars['uuid']>;
  material_status?: Maybe<ArgoMaterialStatusObjRelInsertInput>;
  material_udf_data?: Maybe<ArgoMaterialUdfDataArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  process_material_states?: Maybe<ProcessMaterialStateArrRelInsertInput>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<Scalars['String']>;
  /** The property setting this material as the only material with this serial number that is active within this context */
  serial_number_active?: Maybe<Scalars['Boolean']>;
  /** The status of the material */
  status?: Maybe<ArgoMaterialStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_order_material?: Maybe<ArgoWorkOrderMaterialObjRelInsertInput>;
};

/** columns and relationships of "argo.material_marriage" */
export type ArgoMaterialMarriage = {
  __typename?: 'argo_material_marriage';
  /** An object relationship */
  assembly_material: ArgoMaterial;
  assembly_material_id: Scalars['uuid'];
  /** An object relationship */
  collection_data?: Maybe<ProcessCollectionData>;
  collection_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  component_material: ArgoMaterial;
  component_material_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  status: ArgoMaterialMarriageStatusEnum;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.material_marriage" */
export type ArgoMaterialMarriageMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_marriage" */
export type ArgoMaterialMarriageAggregate = {
  __typename?: 'argo_material_marriage_aggregate';
  aggregate?: Maybe<ArgoMaterialMarriageAggregateFields>;
  nodes: Array<ArgoMaterialMarriage>;
};

/** aggregate fields of "argo.material_marriage" */
export type ArgoMaterialMarriageAggregateFields = {
  __typename?: 'argo_material_marriage_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialMarriageMaxFields>;
  min?: Maybe<ArgoMaterialMarriageMinFields>;
};


/** aggregate fields of "argo.material_marriage" */
export type ArgoMaterialMarriageAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialMarriageSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialMarriageAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.material_marriage". All fields are combined with a logical 'AND'. */
export type ArgoMaterialMarriageBoolExp = {
  _and?: Maybe<Array<ArgoMaterialMarriageBoolExp>>;
  _not?: Maybe<ArgoMaterialMarriageBoolExp>;
  _or?: Maybe<Array<ArgoMaterialMarriageBoolExp>>;
  assembly_material?: Maybe<ArgoMaterialBoolExp>;
  assembly_material_id?: Maybe<UuidComparisonExp>;
  collection_data?: Maybe<ProcessCollectionDataBoolExp>;
  collection_id?: Maybe<UuidComparisonExp>;
  component_material?: Maybe<ArgoMaterialBoolExp>;
  component_material_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_element_id?: Maybe<UuidComparisonExp>;
  material_marriage_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  status?: Maybe<ArgoMaterialMarriageStatusEnumComparisonExp>;
  status_note?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_marriage" */
export enum ArgoMaterialMarriageConstraint {
  /** unique or primary key constraint on columns "material_marriage_id" */
  MaterialMarriagePkey = 'material_marriage_pkey',
  /** unique or primary key constraint on columns "context_id", "data_element_id", "component_material_id", "assembly_material_id", "collection_id" */
  MaterialMarriageUnq = 'material_marriage_unq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialMarriageDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialMarriageDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialMarriageDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_marriage" */
export type ArgoMaterialMarriageInsertInput = {
  assembly_material?: Maybe<ArgoMaterialObjRelInsertInput>;
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_data?: Maybe<ProcessCollectionDataObjRelInsertInput>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material?: Maybe<ArgoMaterialObjRelInsertInput>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialMarriageMaxFields = {
  __typename?: 'argo_material_marriage_max_fields';
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoMaterialMarriageMinFields = {
  __typename?: 'argo_material_marriage_min_fields';
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.material_marriage" */
export type ArgoMaterialMarriageMutationResponse = {
  __typename?: 'argo_material_marriage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialMarriage>;
};

/** input type for inserting object relation for remote table "argo.material_marriage" */
export type ArgoMaterialMarriageObjRelInsertInput = {
  data: ArgoMaterialMarriageInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialMarriageOnConflict>;
};

/** on_conflict condition type for table "argo.material_marriage" */
export type ArgoMaterialMarriageOnConflict = {
  constraint: ArgoMaterialMarriageConstraint;
  update_columns?: Array<ArgoMaterialMarriageUpdateColumn>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};

/** Ordering options when selecting data from "argo.material_marriage". */
export type ArgoMaterialMarriageOrderBy = {
  assembly_material?: Maybe<ArgoMaterialOrderBy>;
  assembly_material_id?: Maybe<OrderBy>;
  collection_data?: Maybe<ProcessCollectionDataOrderBy>;
  collection_id?: Maybe<OrderBy>;
  component_material?: Maybe<ArgoMaterialOrderBy>;
  component_material_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_element_id?: Maybe<OrderBy>;
  material_marriage_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_note?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_marriage */
export type ArgoMaterialMarriagePkColumnsInput = {
  material_marriage_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialMarriagePrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_marriage" */
export enum ArgoMaterialMarriageSelectColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_marriage" */
export type ArgoMaterialMarriageSetInput = {
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatus = {
  __typename?: 'argo_material_marriage_status';
  description: Scalars['String'];
  id: Scalars['String'];
};

/** aggregated selection of "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusAggregate = {
  __typename?: 'argo_material_marriage_status_aggregate';
  aggregate?: Maybe<ArgoMaterialMarriageStatusAggregateFields>;
  nodes: Array<ArgoMaterialMarriageStatus>;
};

/** aggregate fields of "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusAggregateFields = {
  __typename?: 'argo_material_marriage_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialMarriageStatusMaxFields>;
  min?: Maybe<ArgoMaterialMarriageStatusMinFields>;
};


/** aggregate fields of "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialMarriageStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.material_marriage_status". All fields are combined with a logical 'AND'. */
export type ArgoMaterialMarriageStatusBoolExp = {
  _and?: Maybe<Array<ArgoMaterialMarriageStatusBoolExp>>;
  _not?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
  _or?: Maybe<Array<ArgoMaterialMarriageStatusBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  MaterialMarriageStatusPkey = 'material_marriage_status_pkey'
}

export enum ArgoMaterialMarriageStatusEnum {
  /** The marriage is invalid or problematic */
  Bad = 'bad',
  /** The marriage is valid and in good standing */
  Good = 'good',
  /** The marriage has been removed or undone */
  Removed = 'removed'
}

/** Boolean expression to compare columns of type "argo_material_marriage_status_enum". All fields are combined with logical 'AND'. */
export type ArgoMaterialMarriageStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoMaterialMarriageStatusEnum>;
  _in?: Maybe<Array<ArgoMaterialMarriageStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoMaterialMarriageStatusEnum>;
  _nin?: Maybe<Array<ArgoMaterialMarriageStatusEnum>>;
};

/** input type for inserting data into table "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusInsertInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMaterialMarriageStatusMaxFields = {
  __typename?: 'argo_material_marriage_status_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialMarriageStatusMinFields = {
  __typename?: 'argo_material_marriage_status_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusMutationResponse = {
  __typename?: 'argo_material_marriage_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialMarriageStatus>;
};

/** on_conflict condition type for table "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusOnConflict = {
  constraint: ArgoMaterialMarriageStatusConstraint;
  update_columns?: Array<ArgoMaterialMarriageStatusUpdateColumn>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.material_marriage_status". */
export type ArgoMaterialMarriageStatusOrderBy = {
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_marriage_status */
export type ArgoMaterialMarriageStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "argo.material_marriage_status" */
export type ArgoMaterialMarriageStatusSetInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_material_marriage_status" */
export type ArgoMaterialMarriageStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialMarriageStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialMarriageStatusStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

export type ArgoMaterialMarriageStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialMarriageStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialMarriageStatusBoolExp;
};

/** Streaming cursor of the table "argo_material_marriage" */
export type ArgoMaterialMarriageStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialMarriageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialMarriageStreamCursorValueInput = {
  assembly_material_id?: Maybe<Scalars['uuid']>;
  collection_id?: Maybe<Scalars['uuid']>;
  component_material_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_id?: Maybe<Scalars['uuid']>;
  material_marriage_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  status?: Maybe<ArgoMaterialMarriageStatusEnum>;
  status_note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_marriage" */
export enum ArgoMaterialMarriageUpdateColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialMarriageUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialMarriageAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialMarriageDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialMarriageDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialMarriageDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialMarriagePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialMarriageSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialMarriageBoolExp;
};

/** aggregate max on columns */
export type ArgoMaterialMaxFields = {
  __typename?: 'argo_material_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The model that this material is related to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material" */
export type ArgoMaterialMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The location that this material was created at */
  created_location_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The model that this material is related to */
  material_model_id?: Maybe<OrderBy>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialMinFields = {
  __typename?: 'argo_material_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The model that this material is related to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material" */
export type ArgoMaterialMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The location that this material was created at */
  created_location_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The model that this material is related to */
  material_model_id?: Maybe<OrderBy>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModel = {
  __typename?: 'argo_material_model';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Description of this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_default?: Maybe<Scalars['Boolean']>;
  linked_media: Scalars['argo_material_class_model_linked_media'];
  linked_profile_picture: Scalars['argo_material_class_model_linked_profile_picture'];
  /** An object relationship */
  material_class: ArgoMaterialClass;
  /** The material classification that this model is related to */
  material_class_id: Scalars['uuid'];
  /** An array relationship */
  material_class_udf_schemas: Array<ArgoMaterialUdfSchema>;
  /** An aggregate relationship */
  material_class_udf_schemas_aggregate: ArgoMaterialUdfSchemaAggregate;
  /** An array relationship */
  material_model_attribute_settings: Array<ArgoMaterialModelAttributeSetting>;
  /** An aggregate relationship */
  material_model_attribute_settings_aggregate: ArgoMaterialModelAttributeSettingAggregate;
  /** An array relationship */
  material_model_attributes: Array<ArgoMaterialModelAttribute>;
  /** An aggregate relationship */
  material_model_attributes_aggregate: ArgoMaterialModelAttributeAggregate;
  /** An array relationship */
  material_model_processes: Array<ArgoMaterialModelProcess>;
  /** An aggregate relationship */
  material_model_processes_aggregate: ArgoMaterialModelProcessAggregate;
  /** An array relationship */
  material_udf_default_data: Array<ArgoMaterialUdfDefaultData>;
  /** An aggregate relationship */
  material_udf_default_data_aggregate: ArgoMaterialUdfDefaultDataAggregate;
  /** An array relationship */
  materials: Array<ArgoMaterial>;
  /** An aggregate relationship */
  materials_aggregate: ArgoMaterialAggregate;
  /** A column for meta data */
  meta: Scalars['argo_material_model_meta'];
  /** A unqiue number to identify the model */
  model_number: Scalars['String'];
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  sn_format?: Maybe<ArgoSnFormat>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelLinkedMediaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelLinkedProfilePictureArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialClassUdfSchemasArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialClassUdfSchemasAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelAttributeSettingsArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelAttributeSettingsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelAttributesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelAttributesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelProcessesArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialModelProcessesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialsArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMaterialsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


/** Table to define tha Model for material which will contain a model number and name to identify which model material belongs to */
export type ArgoMaterialModelMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_model" */
export type ArgoMaterialModelAggregate = {
  __typename?: 'argo_material_model_aggregate';
  aggregate?: Maybe<ArgoMaterialModelAggregateFields>;
  nodes: Array<ArgoMaterialModel>;
};

export type ArgoMaterialModelAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialModelAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialModelAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialModelAggregateBoolExpCount>;
};

export type ArgoMaterialModelAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_model" */
export type ArgoMaterialModelAggregateFields = {
  __typename?: 'argo_material_model_aggregate_fields';
  avg?: Maybe<ArgoMaterialModelAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialModelMaxFields>;
  min?: Maybe<ArgoMaterialModelMinFields>;
  stddev?: Maybe<ArgoMaterialModelStddevFields>;
  stddev_pop?: Maybe<ArgoMaterialModelStddevPopFields>;
  stddev_samp?: Maybe<ArgoMaterialModelStddevSampFields>;
  sum?: Maybe<ArgoMaterialModelSumFields>;
  var_pop?: Maybe<ArgoMaterialModelVarPopFields>;
  var_samp?: Maybe<ArgoMaterialModelVarSampFields>;
  variance?: Maybe<ArgoMaterialModelVarianceFields>;
};


/** aggregate fields of "argo.material_model" */
export type ArgoMaterialModelAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_model" */
export type ArgoMaterialModelAggregateOrderBy = {
  avg?: Maybe<ArgoMaterialModelAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialModelMaxOrderBy>;
  min?: Maybe<ArgoMaterialModelMinOrderBy>;
  stddev?: Maybe<ArgoMaterialModelStddevOrderBy>;
  stddev_pop?: Maybe<ArgoMaterialModelStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoMaterialModelStddevSampOrderBy>;
  sum?: Maybe<ArgoMaterialModelSumOrderBy>;
  var_pop?: Maybe<ArgoMaterialModelVarPopOrderBy>;
  var_samp?: Maybe<ArgoMaterialModelVarSampOrderBy>;
  variance?: Maybe<ArgoMaterialModelVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelAppendInput = {
  linked_media?: Maybe<Scalars['jsonb']>;
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_model" */
export type ArgoMaterialModelArrRelInsertInput = {
  data: Array<ArgoMaterialModelInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialModelOnConflict>;
};

/** Link Table between Material Model and Attributes */
export type ArgoMaterialModelAttribute = {
  __typename?: 'argo_material_model_attribute';
  /** An object relationship */
  attribute: ArgoAttribute;
  attribute_id: Scalars['uuid'];
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_model: ArgoMaterialModel;
  material_model_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeAggregate = {
  __typename?: 'argo_material_model_attribute_aggregate';
  aggregate?: Maybe<ArgoMaterialModelAttributeAggregateFields>;
  nodes: Array<ArgoMaterialModelAttribute>;
};

export type ArgoMaterialModelAttributeAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialModelAttributeAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialModelAttributeAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialModelAttributeAggregateBoolExpCount>;
};

export type ArgoMaterialModelAttributeAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelAttributeAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelAttributeAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeAggregateFields = {
  __typename?: 'argo_material_model_attribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialModelAttributeMaxFields>;
  min?: Maybe<ArgoMaterialModelAttributeMinFields>;
};


/** aggregate fields of "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialModelAttributeMaxOrderBy>;
  min?: Maybe<ArgoMaterialModelAttributeMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeArrRelInsertInput = {
  data: Array<ArgoMaterialModelAttributeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialModelAttributeOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_model_attribute". All fields are combined with a logical 'AND'. */
export type ArgoMaterialModelAttributeBoolExp = {
  _and?: Maybe<Array<ArgoMaterialModelAttributeBoolExp>>;
  _not?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  _or?: Maybe<Array<ArgoMaterialModelAttributeBoolExp>>;
  attribute?: Maybe<ArgoAttributeBoolExp>;
  attribute_id?: Maybe<UuidComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_model_id" */
  MaterialModelAttributeAttributeIdMaterialModelIdKey = 'material_model_attribute_attribute_id_material_model_id_key',
  /** unique or primary key constraint on columns "material_model_attribute_id" */
  MaterialModelAttributePkey = 'material_model_attribute_pkey'
}

/** input type for inserting data into table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeInsertInput = {
  attribute?: Maybe<ArgoAttributeObjRelInsertInput>;
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  material_model_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialModelAttributeMaxFields = {
  __typename?: 'argo_material_model_attribute_max_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeMaxOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialModelAttributeMinFields = {
  __typename?: 'argo_material_model_attribute_min_fields';
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeMinOrderBy = {
  attribute_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeMutationResponse = {
  __typename?: 'argo_material_model_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialModelAttribute>;
};

/** on_conflict condition type for table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeOnConflict = {
  constraint: ArgoMaterialModelAttributeConstraint;
  update_columns?: Array<ArgoMaterialModelAttributeUpdateColumn>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};

/** Ordering options when selecting data from "argo.material_model_attribute". */
export type ArgoMaterialModelAttributeOrderBy = {
  attribute?: Maybe<ArgoAttributeOrderBy>;
  attribute_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_model_attribute */
export type ArgoMaterialModelAttributePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_model_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.material_model_attribute" */
export type ArgoMaterialModelAttributeSetInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Attribute setting */
export type ArgoMaterialModelAttributeSetting = {
  __typename?: 'argo_material_model_attribute_setting';
  /** An object relationship */
  attribute_schema: ArgoAttributeSchema;
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id: Scalars['uuid'];
  /** The attribute setting configuration */
  config: Scalars['argo_attribute_setting_config'];
  /** The context */
  context_id: Scalars['uuid'];
  /** The time the attribute setting was created */
  created_at: Scalars['timestamptz'];
  /** The user that created the attribute setting */
  created_by_id: Scalars['uuid'];
  /** The primary key */
  id: Scalars['uuid'];
  /** An object relationship */
  material_model: ArgoMaterialModel;
  /** The material model the attribute setting belongs to */
  material_model_id: Scalars['uuid'];
  /** The time the attribute setting was last updated */
  updated_at: Scalars['timestamptz'];
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Attribute setting */
export type ArgoMaterialModelAttributeSettingConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingAggregate = {
  __typename?: 'argo_material_model_attribute_setting_aggregate';
  aggregate?: Maybe<ArgoMaterialModelAttributeSettingAggregateFields>;
  nodes: Array<ArgoMaterialModelAttributeSetting>;
};

export type ArgoMaterialModelAttributeSettingAggregateBoolExp = {
  count?: Maybe<ArgoMaterialModelAttributeSettingAggregateBoolExpCount>;
};

export type ArgoMaterialModelAttributeSettingAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingAggregateFields = {
  __typename?: 'argo_material_model_attribute_setting_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialModelAttributeSettingMaxFields>;
  min?: Maybe<ArgoMaterialModelAttributeSettingMinFields>;
};


/** aggregate fields of "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialModelAttributeSettingMaxOrderBy>;
  min?: Maybe<ArgoMaterialModelAttributeSettingMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelAttributeSettingAppendInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingArrRelInsertInput = {
  data: Array<ArgoMaterialModelAttributeSettingInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialModelAttributeSettingOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_model_attribute_setting". All fields are combined with a logical 'AND'. */
export type ArgoMaterialModelAttributeSettingBoolExp = {
  _and?: Maybe<Array<ArgoMaterialModelAttributeSettingBoolExp>>;
  _not?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
  _or?: Maybe<Array<ArgoMaterialModelAttributeSettingBoolExp>>;
  attribute_schema?: Maybe<ArgoAttributeSchemaBoolExp>;
  attribute_schema_id?: Maybe<UuidComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingConstraint {
  /** unique or primary key constraint on columns "material_model_attribute_setting_id" */
  MaterialModelAttributeSettingPkey = 'material_model_attribute_setting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialModelAttributeSettingDeleteAtPathInput = {
  /** The attribute setting configuration */
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialModelAttributeSettingDeleteElemInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialModelAttributeSettingDeleteKeyInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingInsertInput = {
  attribute_schema?: Maybe<ArgoAttributeSchemaObjRelInsertInput>;
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialModelAttributeSettingMaxFields = {
  __typename?: 'argo_material_model_attribute_setting_max_fields';
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingMaxOrderBy = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context */
  context_id?: Maybe<OrderBy>;
  /** The time the attribute setting was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<OrderBy>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialModelAttributeSettingMinFields = {
  __typename?: 'argo_material_model_attribute_setting_min_fields';
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingMinOrderBy = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<OrderBy>;
  /** The context */
  context_id?: Maybe<OrderBy>;
  /** The time the attribute setting was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<OrderBy>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingMutationResponse = {
  __typename?: 'argo_material_model_attribute_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialModelAttributeSetting>;
};

/** on_conflict condition type for table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingOnConflict = {
  constraint: ArgoMaterialModelAttributeSettingConstraint;
  update_columns?: Array<ArgoMaterialModelAttributeSettingUpdateColumn>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};

/** Ordering options when selecting data from "argo.material_model_attribute_setting". */
export type ArgoMaterialModelAttributeSettingOrderBy = {
  attribute_schema?: Maybe<ArgoAttributeSchemaOrderBy>;
  attribute_schema_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_model_attribute_setting */
export type ArgoMaterialModelAttributeSettingPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelAttributeSettingPrependInput = {
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingSetInput = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_model_attribute_setting" */
export type ArgoMaterialModelAttributeSettingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialModelAttributeSettingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialModelAttributeSettingStreamCursorValueInput = {
  /** The attribute schema the attribute setting belongs to */
  attribute_schema_id?: Maybe<Scalars['uuid']>;
  /** The attribute setting configuration */
  config?: Maybe<Scalars['jsonb']>;
  /** The context */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created the attribute setting */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model the attribute setting belongs to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The time the attribute setting was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated the attribute setting */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialModelAttributeSettingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialModelAttributeSettingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialModelAttributeSettingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialModelAttributeSettingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialModelAttributeSettingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialModelAttributeSettingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialModelAttributeSettingSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialModelAttributeSettingBoolExp;
};

/** Streaming cursor of the table "argo_material_model_attribute" */
export type ArgoMaterialModelAttributeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialModelAttributeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialModelAttributeStreamCursorValueInput = {
  attribute_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialModelAttributeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialModelAttributeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialModelAttributeBoolExp;
};

/** aggregate avg on columns */
export type ArgoMaterialModelAvgFields = {
  __typename?: 'argo_material_model_avg_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.material_model" */
export type ArgoMaterialModelAvgOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.material_model". All fields are combined with a logical 'AND'. */
export type ArgoMaterialModelBoolExp = {
  _and?: Maybe<Array<ArgoMaterialModelBoolExp>>;
  _not?: Maybe<ArgoMaterialModelBoolExp>;
  _or?: Maybe<Array<ArgoMaterialModelBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_default?: Maybe<BooleanComparisonExp>;
  linked_media?: Maybe<JsonbComparisonExp>;
  linked_profile_picture?: Maybe<JsonbComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  material_class_udf_schemas?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  material_class_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExp>;
  material_model_attribute_settings?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
  material_model_attribute_settings_aggregate?: Maybe<ArgoMaterialModelAttributeSettingAggregateBoolExp>;
  material_model_attributes?: Maybe<ArgoMaterialModelAttributeBoolExp>;
  material_model_attributes_aggregate?: Maybe<ArgoMaterialModelAttributeAggregateBoolExp>;
  material_model_processes?: Maybe<ArgoMaterialModelProcessBoolExp>;
  material_model_processes_aggregate?: Maybe<ArgoMaterialModelProcessAggregateBoolExp>;
  material_udf_default_data?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
  material_udf_default_data_aggregate?: Maybe<ArgoMaterialUdfDefaultDataAggregateBoolExp>;
  materials?: Maybe<ArgoMaterialBoolExp>;
  materials_aggregate?: Maybe<ArgoMaterialAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  model_number?: Maybe<StringComparisonExp>;
  profile_file_id?: Maybe<UuidComparisonExp>;
  sn_format?: Maybe<ArgoSnFormatBoolExp>;
  sn_format_id?: Maybe<IntComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_model" */
export enum ArgoMaterialModelConstraint {
  /** unique or primary key constraint on columns "context_id", "is_default" */
  MaterialModelIsDefaultCnstrnt = 'material_model_is_default_cnstrnt',
  /** unique or primary key constraint on columns "material_model_id" */
  MaterialModelPkey = 'material_model_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialModelDeleteAtPathInput = {
  linked_media?: Maybe<Array<Scalars['String']>>;
  linked_profile_picture?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialModelDeleteElemInput = {
  linked_media?: Maybe<Scalars['Int']>;
  linked_profile_picture?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialModelDeleteKeyInput = {
  linked_media?: Maybe<Scalars['String']>;
  linked_profile_picture?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.material_model" */
export type ArgoMaterialModelIncInput = {
  sn_format_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.material_model" */
export type ArgoMaterialModelInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  linked_media?: Maybe<Scalars['jsonb']>;
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<Scalars['uuid']>;
  material_class_udf_schemas?: Maybe<ArgoMaterialUdfSchemaArrRelInsertInput>;
  material_model_attribute_settings?: Maybe<ArgoMaterialModelAttributeSettingArrRelInsertInput>;
  material_model_attributes?: Maybe<ArgoMaterialModelAttributeArrRelInsertInput>;
  material_model_processes?: Maybe<ArgoMaterialModelProcessArrRelInsertInput>;
  material_udf_default_data?: Maybe<ArgoMaterialUdfDefaultDataArrRelInsertInput>;
  materials?: Maybe<ArgoMaterialArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format?: Maybe<ArgoSnFormatObjRelInsertInput>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialModelMaxFields = {
  __typename?: 'argo_material_model_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_model" */
export type ArgoMaterialModelMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<OrderBy>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  sn_format_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};


/** aggregate min on columns */
export type ArgoMaterialModelMinFields = {
  __typename?: 'argo_material_model_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_model" */
export type ArgoMaterialModelMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<OrderBy>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  sn_format_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_model" */
export type ArgoMaterialModelMutationResponse = {
  __typename?: 'argo_material_model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialModel>;
};

/** input type for inserting object relation for remote table "argo.material_model" */
export type ArgoMaterialModelObjRelInsertInput = {
  data: ArgoMaterialModelInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialModelOnConflict>;
};

/** on_conflict condition type for table "argo.material_model" */
export type ArgoMaterialModelOnConflict = {
  constraint: ArgoMaterialModelConstraint;
  update_columns?: Array<ArgoMaterialModelUpdateColumn>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};

/** Ordering options when selecting data from "argo.material_model". */
export type ArgoMaterialModelOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_default?: Maybe<OrderBy>;
  linked_media?: Maybe<OrderBy>;
  linked_profile_picture?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_class_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateOrderBy>;
  material_model_attribute_settings_aggregate?: Maybe<ArgoMaterialModelAttributeSettingAggregateOrderBy>;
  material_model_attributes_aggregate?: Maybe<ArgoMaterialModelAttributeAggregateOrderBy>;
  material_model_processes_aggregate?: Maybe<ArgoMaterialModelProcessAggregateOrderBy>;
  material_udf_default_data_aggregate?: Maybe<ArgoMaterialUdfDefaultDataAggregateOrderBy>;
  materials_aggregate?: Maybe<ArgoMaterialAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  model_number?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  sn_format?: Maybe<ArgoSnFormatOrderBy>;
  sn_format_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_model */
export type ArgoMaterialModelPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelPrependInput = {
  linked_media?: Maybe<Scalars['jsonb']>;
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** The Process to be Linked to Material of this Model */
export type ArgoMaterialModelProcess = {
  __typename?: 'argo_material_model_process';
  active: Scalars['Boolean'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_model: ArgoMaterialModel;
  /** Material Model for this entry */
  material_model_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  process: ProcessProcess;
  /** Process for this entry */
  process_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The Process to be Linked to Material of this Model */
export type ArgoMaterialModelProcessMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_model_process" */
export type ArgoMaterialModelProcessAggregate = {
  __typename?: 'argo_material_model_process_aggregate';
  aggregate?: Maybe<ArgoMaterialModelProcessAggregateFields>;
  nodes: Array<ArgoMaterialModelProcess>;
};

export type ArgoMaterialModelProcessAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialModelProcessAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialModelProcessAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialModelProcessAggregateBoolExpCount>;
};

export type ArgoMaterialModelProcessAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelProcessBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelProcessAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelProcessBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialModelProcessAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialModelProcessBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_model_process" */
export type ArgoMaterialModelProcessAggregateFields = {
  __typename?: 'argo_material_model_process_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialModelProcessMaxFields>;
  min?: Maybe<ArgoMaterialModelProcessMinFields>;
};


/** aggregate fields of "argo.material_model_process" */
export type ArgoMaterialModelProcessAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_model_process" */
export type ArgoMaterialModelProcessAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialModelProcessMaxOrderBy>;
  min?: Maybe<ArgoMaterialModelProcessMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelProcessAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_model_process" */
export type ArgoMaterialModelProcessArrRelInsertInput = {
  data: Array<ArgoMaterialModelProcessInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialModelProcessOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_model_process". All fields are combined with a logical 'AND'. */
export type ArgoMaterialModelProcessBoolExp = {
  _and?: Maybe<Array<ArgoMaterialModelProcessBoolExp>>;
  _not?: Maybe<ArgoMaterialModelProcessBoolExp>;
  _or?: Maybe<Array<ArgoMaterialModelProcessBoolExp>>;
  active?: Maybe<BooleanComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_model_process" */
export enum ArgoMaterialModelProcessConstraint {
  /** unique or primary key constraint on columns "material_model_process_id" */
  MaterialModelProcessPkey = 'material_model_process_pkey',
  /** unique or primary key constraint on columns "process_id", "material_model_id" */
  MaterialModelProcessUnique = 'material_model_process_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialModelProcessDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialModelProcessDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialModelProcessDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_model_process" */
export type ArgoMaterialModelProcessInsertInput = {
  active?: Maybe<Scalars['Boolean']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  /** Material Model for this entry */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialModelProcessMaxFields = {
  __typename?: 'argo_material_model_process_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_model_process" */
export type ArgoMaterialModelProcessMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material Model for this entry */
  material_model_id?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialModelProcessMinFields = {
  __typename?: 'argo_material_model_process_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_model_process" */
export type ArgoMaterialModelProcessMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material Model for this entry */
  material_model_id?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_model_process" */
export type ArgoMaterialModelProcessMutationResponse = {
  __typename?: 'argo_material_model_process_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialModelProcess>;
};

/** on_conflict condition type for table "argo.material_model_process" */
export type ArgoMaterialModelProcessOnConflict = {
  constraint: ArgoMaterialModelProcessConstraint;
  update_columns?: Array<ArgoMaterialModelProcessUpdateColumn>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};

/** Ordering options when selecting data from "argo.material_model_process". */
export type ArgoMaterialModelProcessOrderBy = {
  active?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_model_process */
export type ArgoMaterialModelProcessPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialModelProcessPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_process_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "argo_material_model_process_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessSelectColumnArgoMaterialModelProcessAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "argo.material_model_process" */
export type ArgoMaterialModelProcessSetInput = {
  active?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_model_process" */
export type ArgoMaterialModelProcessStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialModelProcessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialModelProcessStreamCursorValueInput = {
  active?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material Model for this entry */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_model_process" */
export enum ArgoMaterialModelProcessUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialModelProcessUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialModelProcessAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialModelProcessDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialModelProcessDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialModelProcessDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialModelProcessPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialModelProcessSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialModelProcessBoolExp;
};

/** select columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ModelNumber = 'model_number',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** select "argo_material_model_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model" */
export enum ArgoMaterialModelSelectColumnArgoMaterialModelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "argo.material_model" */
export type ArgoMaterialModelSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  linked_media?: Maybe<Scalars['jsonb']>;
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoMaterialModelStddevFields = {
  __typename?: 'argo_material_model_stddev_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.material_model" */
export type ArgoMaterialModelStddevOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoMaterialModelStddevPopFields = {
  __typename?: 'argo_material_model_stddev_pop_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.material_model" */
export type ArgoMaterialModelStddevPopOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoMaterialModelStddevSampFields = {
  __typename?: 'argo_material_model_stddev_samp_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.material_model" */
export type ArgoMaterialModelStddevSampOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_material_model" */
export type ArgoMaterialModelStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialModelStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialModelStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  is_default?: Maybe<Scalars['Boolean']>;
  linked_media?: Maybe<Scalars['jsonb']>;
  linked_profile_picture?: Maybe<Scalars['jsonb']>;
  /** The material classification that this model is related to */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A unqiue number to identify the model */
  model_number?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoMaterialModelSumFields = {
  __typename?: 'argo_material_model_sum_fields';
  sn_format_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "argo.material_model" */
export type ArgoMaterialModelSumOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** update columns of table "argo.material_model" */
export enum ArgoMaterialModelUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ModelNumber = 'model_number',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialModelUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialModelAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialModelDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialModelDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialModelDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMaterialModelIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialModelPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialModelSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialModelBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMaterialModelVarPopFields = {
  __typename?: 'argo_material_model_var_pop_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.material_model" */
export type ArgoMaterialModelVarPopOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoMaterialModelVarSampFields = {
  __typename?: 'argo_material_model_var_samp_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.material_model" */
export type ArgoMaterialModelVarSampOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoMaterialModelVarianceFields = {
  __typename?: 'argo_material_model_variance_fields';
  sn_format_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.material_model" */
export type ArgoMaterialModelVarianceOrderBy = {
  sn_format_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material" */
export type ArgoMaterialMutationResponse = {
  __typename?: 'argo_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterial>;
};

/** input type for inserting object relation for remote table "argo.material" */
export type ArgoMaterialObjRelInsertInput = {
  data: ArgoMaterialInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialOnConflict>;
};

/** on_conflict condition type for table "argo.material" */
export type ArgoMaterialOnConflict = {
  constraint: ArgoMaterialConstraint;
  update_columns?: Array<ArgoMaterialUpdateColumn>;
  where?: Maybe<ArgoMaterialBoolExp>;
};

/** Ordering options when selecting data from "argo.material". */
export type ArgoMaterialOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  created_location?: Maybe<ArgoLocationOrderBy>;
  created_location_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_attributes_aggregate?: Maybe<ArgoMaterialAttributeAggregateOrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  material_status?: Maybe<ArgoMaterialStatusOrderBy>;
  material_udf_data_aggregate?: Maybe<ArgoMaterialUdfDataAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  process_material_states_aggregate?: Maybe<ProcessMaterialStateAggregateOrderBy>;
  serial_number?: Maybe<OrderBy>;
  serial_number_active?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_order_material?: Maybe<ArgoWorkOrderMaterialOrderBy>;
};

/** primary key columns input for table: argo.material */
export type ArgoMaterialPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKind = {
  __typename?: 'argo_material_quantity_kind';
  description: Scalars['String'];
  id: Scalars['String'];
};

/** aggregated selection of "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindAggregate = {
  __typename?: 'argo_material_quantity_kind_aggregate';
  aggregate?: Maybe<ArgoMaterialQuantityKindAggregateFields>;
  nodes: Array<ArgoMaterialQuantityKind>;
};

/** aggregate fields of "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindAggregateFields = {
  __typename?: 'argo_material_quantity_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialQuantityKindMaxFields>;
  min?: Maybe<ArgoMaterialQuantityKindMinFields>;
};


/** aggregate fields of "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialQuantityKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.material_quantity_kind". All fields are combined with a logical 'AND'. */
export type ArgoMaterialQuantityKindBoolExp = {
  _and?: Maybe<Array<ArgoMaterialQuantityKindBoolExp>>;
  _not?: Maybe<ArgoMaterialQuantityKindBoolExp>;
  _or?: Maybe<Array<ArgoMaterialQuantityKindBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindConstraint {
  /** unique or primary key constraint on columns "id" */
  MaterialQuantityKindPkey = 'material_quantity_kind_pkey'
}

export enum ArgoMaterialQuantityKindEnum {
  /** Bulk material (not individually tracked, can be married multiple times to any number of assemblies) */
  Bulk = 'bulk',
  /** Distinct material (individually tracked, can only be married to one assembly) */
  Distinct = 'distinct'
}

/** Boolean expression to compare columns of type "argo_material_quantity_kind_enum". All fields are combined with logical 'AND'. */
export type ArgoMaterialQuantityKindEnumComparisonExp = {
  _eq?: Maybe<ArgoMaterialQuantityKindEnum>;
  _in?: Maybe<Array<ArgoMaterialQuantityKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoMaterialQuantityKindEnum>;
  _nin?: Maybe<Array<ArgoMaterialQuantityKindEnum>>;
};

/** input type for inserting data into table "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindInsertInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMaterialQuantityKindMaxFields = {
  __typename?: 'argo_material_quantity_kind_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialQuantityKindMinFields = {
  __typename?: 'argo_material_quantity_kind_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindMutationResponse = {
  __typename?: 'argo_material_quantity_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialQuantityKind>;
};

/** on_conflict condition type for table "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindOnConflict = {
  constraint: ArgoMaterialQuantityKindConstraint;
  update_columns?: Array<ArgoMaterialQuantityKindUpdateColumn>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};

/** Ordering options when selecting data from "argo.material_quantity_kind". */
export type ArgoMaterialQuantityKindOrderBy = {
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_quantity_kind */
export type ArgoMaterialQuantityKindPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "argo.material_quantity_kind" */
export type ArgoMaterialQuantityKindSetInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_material_quantity_kind" */
export type ArgoMaterialQuantityKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialQuantityKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialQuantityKindStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.material_quantity_kind" */
export enum ArgoMaterialQuantityKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

export type ArgoMaterialQuantityKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialQuantityKindSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialQuantityKindBoolExp;
};

/** select columns of table "argo.material" */
export enum ArgoMaterialSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material" */
export enum ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** select "argo_material_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material" */
export enum ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** input type for updating data in table "argo.material" */
export type ArgoMaterialSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The model that this material is related to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<Scalars['String']>;
  /** The property setting this material as the only material with this serial number that is active within this context */
  serial_number_active?: Maybe<Scalars['Boolean']>;
  /** The status of the material */
  status?: Maybe<ArgoMaterialStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.material_status" */
export type ArgoMaterialStatus = {
  __typename?: 'argo_material_status';
  description: Scalars['String'];
  status: Scalars['String'];
};

/** aggregated selection of "argo.material_status" */
export type ArgoMaterialStatusAggregate = {
  __typename?: 'argo_material_status_aggregate';
  aggregate?: Maybe<ArgoMaterialStatusAggregateFields>;
  nodes: Array<ArgoMaterialStatus>;
};

/** aggregate fields of "argo.material_status" */
export type ArgoMaterialStatusAggregateFields = {
  __typename?: 'argo_material_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialStatusMaxFields>;
  min?: Maybe<ArgoMaterialStatusMinFields>;
};


/** aggregate fields of "argo.material_status" */
export type ArgoMaterialStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.material_status". All fields are combined with a logical 'AND'. */
export type ArgoMaterialStatusBoolExp = {
  _and?: Maybe<Array<ArgoMaterialStatusBoolExp>>;
  _not?: Maybe<ArgoMaterialStatusBoolExp>;
  _or?: Maybe<Array<ArgoMaterialStatusBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_status" */
export enum ArgoMaterialStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  MaterialStatusPkey = 'material_status_pkey'
}

export enum ArgoMaterialStatusEnum {
  /** Material has been completed */
  Completed = 'completed',
  /** Material has failed a validation check */
  Failed = 'failed',
  /** Material has been manually completed */
  ManuallyCompleted = 'manually_completed',
  /** Material has not been assigned a status */
  None = 'none',
  /** Material has passed a validation check */
  Passed = 'passed',
  /** Material has been quarantined */
  Quarantined = 'quarantined',
  /** Material has been scrapped */
  Scrapped = 'scrapped',
  /** Material has had work performed */
  Started = 'started'
}

/** Boolean expression to compare columns of type "argo_material_status_enum". All fields are combined with logical 'AND'. */
export type ArgoMaterialStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoMaterialStatusEnum>;
  _in?: Maybe<Array<ArgoMaterialStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoMaterialStatusEnum>;
  _nin?: Maybe<Array<ArgoMaterialStatusEnum>>;
};

/** input type for inserting data into table "argo.material_status" */
export type ArgoMaterialStatusInsertInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMaterialStatusMaxFields = {
  __typename?: 'argo_material_status_max_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMaterialStatusMinFields = {
  __typename?: 'argo_material_status_min_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.material_status" */
export type ArgoMaterialStatusMutationResponse = {
  __typename?: 'argo_material_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialStatus>;
};

/** input type for inserting object relation for remote table "argo.material_status" */
export type ArgoMaterialStatusObjRelInsertInput = {
  data: ArgoMaterialStatusInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialStatusOnConflict>;
};

/** on_conflict condition type for table "argo.material_status" */
export type ArgoMaterialStatusOnConflict = {
  constraint: ArgoMaterialStatusConstraint;
  update_columns?: Array<ArgoMaterialStatusUpdateColumn>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.material_status". */
export type ArgoMaterialStatusOrderBy = {
  description?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_status */
export type ArgoMaterialStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "argo.material_status" */
export enum ArgoMaterialStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.material_status" */
export type ArgoMaterialStatusSetInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_material_status" */
export type ArgoMaterialStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialStatusStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.material_status" */
export enum ArgoMaterialStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type ArgoMaterialStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialStatusBoolExp;
};

/** Streaming cursor of the table "argo_material" */
export type ArgoMaterialStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The location that this material was created at */
  created_location_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The model that this material is related to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The serial number identifying this piece of material */
  serial_number?: Maybe<Scalars['String']>;
  /** The property setting this material as the only material with this serial number that is active within this context */
  serial_number_active?: Maybe<Scalars['Boolean']>;
  /** The status of the material */
  status?: Maybe<ArgoMaterialStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** The UDF values assigned to material */
export type ArgoMaterialUdfData = {
  __typename?: 'argo_material_udf_data';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  material: ArgoMaterial;
  /** The Material this entry links to */
  material_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** An object relationship */
  udf_column: ArgoUdfColumn;
  /** The Material UDF Schema this entry links to */
  udf_column_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The UDF values assigned to material */
export type ArgoMaterialUdfDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_udf_data" */
export type ArgoMaterialUdfDataAggregate = {
  __typename?: 'argo_material_udf_data_aggregate';
  aggregate?: Maybe<ArgoMaterialUdfDataAggregateFields>;
  nodes: Array<ArgoMaterialUdfData>;
};

export type ArgoMaterialUdfDataAggregateBoolExp = {
  count?: Maybe<ArgoMaterialUdfDataAggregateBoolExpCount>;
};

export type ArgoMaterialUdfDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_udf_data" */
export type ArgoMaterialUdfDataAggregateFields = {
  __typename?: 'argo_material_udf_data_aggregate_fields';
  avg?: Maybe<ArgoMaterialUdfDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialUdfDataMaxFields>;
  min?: Maybe<ArgoMaterialUdfDataMinFields>;
  stddev?: Maybe<ArgoMaterialUdfDataStddevFields>;
  stddev_pop?: Maybe<ArgoMaterialUdfDataStddevPopFields>;
  stddev_samp?: Maybe<ArgoMaterialUdfDataStddevSampFields>;
  sum?: Maybe<ArgoMaterialUdfDataSumFields>;
  var_pop?: Maybe<ArgoMaterialUdfDataVarPopFields>;
  var_samp?: Maybe<ArgoMaterialUdfDataVarSampFields>;
  variance?: Maybe<ArgoMaterialUdfDataVarianceFields>;
};


/** aggregate fields of "argo.material_udf_data" */
export type ArgoMaterialUdfDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataAggregateOrderBy = {
  avg?: Maybe<ArgoMaterialUdfDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialUdfDataMaxOrderBy>;
  min?: Maybe<ArgoMaterialUdfDataMinOrderBy>;
  stddev?: Maybe<ArgoMaterialUdfDataStddevOrderBy>;
  stddev_pop?: Maybe<ArgoMaterialUdfDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoMaterialUdfDataStddevSampOrderBy>;
  sum?: Maybe<ArgoMaterialUdfDataSumOrderBy>;
  var_pop?: Maybe<ArgoMaterialUdfDataVarPopOrderBy>;
  var_samp?: Maybe<ArgoMaterialUdfDataVarSampOrderBy>;
  variance?: Maybe<ArgoMaterialUdfDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_udf_data" */
export type ArgoMaterialUdfDataArrRelInsertInput = {
  data: Array<ArgoMaterialUdfDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialUdfDataOnConflict>;
};

/** aggregate avg on columns */
export type ArgoMaterialUdfDataAvgFields = {
  __typename?: 'argo_material_udf_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.material_udf_data". All fields are combined with a logical 'AND'. */
export type ArgoMaterialUdfDataBoolExp = {
  _and?: Maybe<Array<ArgoMaterialUdfDataBoolExp>>;
  _not?: Maybe<ArgoMaterialUdfDataBoolExp>;
  _or?: Maybe<Array<ArgoMaterialUdfDataBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataConstraint {
  /** unique or primary key constraint on columns "material_udf_id" */
  MaterialUdfDataPkey = 'material_udf_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "material_id" */
  MaterialUdfUnique = 'material_udf_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialUdfDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialUdfDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialUdfDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.material_udf_data" */
export type ArgoMaterialUdfDataIncInput = {
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.material_udf_data" */
export type ArgoMaterialUdfDataInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  /** The Material this entry links to */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialUdfDataMaxFields = {
  __typename?: 'argo_material_udf_data_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material this entry links to */
  material_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialUdfDataMinFields = {
  __typename?: 'argo_material_udf_data_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material this entry links to */
  material_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_udf_data" */
export type ArgoMaterialUdfDataMutationResponse = {
  __typename?: 'argo_material_udf_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialUdfData>;
};

/** on_conflict condition type for table "argo.material_udf_data" */
export type ArgoMaterialUdfDataOnConflict = {
  constraint: ArgoMaterialUdfDataConstraint;
  update_columns?: Array<ArgoMaterialUdfDataUpdateColumn>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};

/** Ordering options when selecting data from "argo.material_udf_data". */
export type ArgoMaterialUdfDataOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_udf_data */
export type ArgoMaterialUdfDataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.material_udf_data" */
export type ArgoMaterialUdfDataSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoMaterialUdfDataStddevFields = {
  __typename?: 'argo_material_udf_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoMaterialUdfDataStddevPopFields = {
  __typename?: 'argo_material_udf_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoMaterialUdfDataStddevSampFields = {
  __typename?: 'argo_material_udf_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_material_udf_data" */
export type ArgoMaterialUdfDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialUdfDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialUdfDataStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Schema this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoMaterialUdfDataSumFields = {
  __typename?: 'argo_material_udf_data_sum_fields';
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialUdfDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialUdfDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialUdfDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialUdfDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialUdfDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMaterialUdfDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialUdfDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialUdfDataSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialUdfDataBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMaterialUdfDataVarPopFields = {
  __typename?: 'argo_material_udf_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoMaterialUdfDataVarSampFields = {
  __typename?: 'argo_material_udf_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoMaterialUdfDataVarianceFields = {
  __typename?: 'argo_material_udf_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.material_udf_data" */
export type ArgoMaterialUdfDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** The default UDF values assigned to material during material creation */
export type ArgoMaterialUdfDefaultData = {
  __typename?: 'argo_material_udf_default_data';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_model: ArgoMaterialModel;
  /** The Material this entry links to */
  material_model_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** An object relationship */
  udf_column: ArgoUdfColumn;
  /** The Material UDF Column this entry links to */
  udf_column_id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** The default UDF values assigned to material during material creation */
export type ArgoMaterialUdfDefaultDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataAggregate = {
  __typename?: 'argo_material_udf_default_data_aggregate';
  aggregate?: Maybe<ArgoMaterialUdfDefaultDataAggregateFields>;
  nodes: Array<ArgoMaterialUdfDefaultData>;
};

export type ArgoMaterialUdfDefaultDataAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialUdfDefaultDataAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialUdfDefaultDataAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialUdfDefaultDataAggregateBoolExpCount>;
};

export type ArgoMaterialUdfDefaultDataAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialUdfDefaultDataAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialUdfDefaultDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataAggregateFields = {
  __typename?: 'argo_material_udf_default_data_aggregate_fields';
  avg?: Maybe<ArgoMaterialUdfDefaultDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialUdfDefaultDataMaxFields>;
  min?: Maybe<ArgoMaterialUdfDefaultDataMinFields>;
  stddev?: Maybe<ArgoMaterialUdfDefaultDataStddevFields>;
  stddev_pop?: Maybe<ArgoMaterialUdfDefaultDataStddevPopFields>;
  stddev_samp?: Maybe<ArgoMaterialUdfDefaultDataStddevSampFields>;
  sum?: Maybe<ArgoMaterialUdfDefaultDataSumFields>;
  var_pop?: Maybe<ArgoMaterialUdfDefaultDataVarPopFields>;
  var_samp?: Maybe<ArgoMaterialUdfDefaultDataVarSampFields>;
  variance?: Maybe<ArgoMaterialUdfDefaultDataVarianceFields>;
};


/** aggregate fields of "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataAggregateOrderBy = {
  avg?: Maybe<ArgoMaterialUdfDefaultDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialUdfDefaultDataMaxOrderBy>;
  min?: Maybe<ArgoMaterialUdfDefaultDataMinOrderBy>;
  stddev?: Maybe<ArgoMaterialUdfDefaultDataStddevOrderBy>;
  stddev_pop?: Maybe<ArgoMaterialUdfDefaultDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoMaterialUdfDefaultDataStddevSampOrderBy>;
  sum?: Maybe<ArgoMaterialUdfDefaultDataSumOrderBy>;
  var_pop?: Maybe<ArgoMaterialUdfDefaultDataVarPopOrderBy>;
  var_samp?: Maybe<ArgoMaterialUdfDefaultDataVarSampOrderBy>;
  variance?: Maybe<ArgoMaterialUdfDefaultDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfDefaultDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataArrRelInsertInput = {
  data: Array<ArgoMaterialUdfDefaultDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialUdfDefaultDataOnConflict>;
};

/** aggregate avg on columns */
export type ArgoMaterialUdfDefaultDataAvgFields = {
  __typename?: 'argo_material_udf_default_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.material_udf_default_data". All fields are combined with a logical 'AND'. */
export type ArgoMaterialUdfDefaultDataBoolExp = {
  _and?: Maybe<Array<ArgoMaterialUdfDefaultDataBoolExp>>;
  _not?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
  _or?: Maybe<Array<ArgoMaterialUdfDefaultDataBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataConstraint {
  /** unique or primary key constraint on columns "material_udf_default_data_id" */
  MaterialUdfDefaultDataPkey = 'material_udf_default_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "material_model_id" */
  MaterialUdfDefaultDataUnique = 'material_udf_default_data_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialUdfDefaultDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialUdfDefaultDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialUdfDefaultDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataIncInput = {
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  /** The Material this entry links to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialUdfDefaultDataMaxFields = {
  __typename?: 'argo_material_udf_default_data_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_model_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material this entry links to */
  material_model_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialUdfDefaultDataMinFields = {
  __typename?: 'argo_material_udf_default_data_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_model_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material this entry links to */
  material_model_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataMutationResponse = {
  __typename?: 'argo_material_udf_default_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialUdfDefaultData>;
};

/** on_conflict condition type for table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataOnConflict = {
  constraint: ArgoMaterialUdfDefaultDataConstraint;
  update_columns?: Array<ArgoMaterialUdfDefaultDataUpdateColumn>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};

/** Ordering options when selecting data from "argo.material_udf_default_data". */
export type ArgoMaterialUdfDefaultDataOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_udf_default_data */
export type ArgoMaterialUdfDefaultDataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfDefaultDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_udf_default_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_udf_default_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoMaterialUdfDefaultDataStddevFields = {
  __typename?: 'argo_material_udf_default_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoMaterialUdfDefaultDataStddevPopFields = {
  __typename?: 'argo_material_udf_default_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoMaterialUdfDefaultDataStddevSampFields = {
  __typename?: 'argo_material_udf_default_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialUdfDefaultDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialUdfDefaultDataStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material this entry links to */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['numeric']>;
  str_val?: Maybe<Scalars['String']>;
  /** The Material UDF Column this entry links to */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoMaterialUdfDefaultDataSumFields = {
  __typename?: 'argo_material_udf_default_data_sum_fields';
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialUdfDefaultDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialUdfDefaultDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialUdfDefaultDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialUdfDefaultDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialUdfDefaultDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMaterialUdfDefaultDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialUdfDefaultDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialUdfDefaultDataSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialUdfDefaultDataBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMaterialUdfDefaultDataVarPopFields = {
  __typename?: 'argo_material_udf_default_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoMaterialUdfDefaultDataVarSampFields = {
  __typename?: 'argo_material_udf_default_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoMaterialUdfDefaultDataVarianceFields = {
  __typename?: 'argo_material_udf_default_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.material_udf_default_data" */
export type ArgoMaterialUdfDefaultDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Table to define the UDF columns linked to a Material Class */
export type ArgoMaterialUdfSchema = {
  __typename?: 'argo_material_udf_schema';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  material_class: ArgoMaterialClass;
  /** The Material Class linked to this entry */
  material_class_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  udf_column: ArgoUdfColumn;
  /** The UDF Column linked to this entry */
  udf_column_id: Scalars['uuid'];
  /** The UDF Column Type linked to this entry */
  udf_column_type: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to define the UDF columns linked to a Material Class */
export type ArgoMaterialUdfSchemaMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaAggregate = {
  __typename?: 'argo_material_udf_schema_aggregate';
  aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateFields>;
  nodes: Array<ArgoMaterialUdfSchema>;
};

export type ArgoMaterialUdfSchemaAggregateBoolExp = {
  bool_and?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExpCount>;
};

export type ArgoMaterialUdfSchemaAggregateBoolExpBoolAnd = {
  arguments: ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialUdfSchemaAggregateBoolExpBoolOr = {
  arguments: ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoMaterialUdfSchemaAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaAggregateFields = {
  __typename?: 'argo_material_udf_schema_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoMaterialUdfSchemaMaxFields>;
  min?: Maybe<ArgoMaterialUdfSchemaMinFields>;
};


/** aggregate fields of "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoMaterialUdfSchemaMaxOrderBy>;
  min?: Maybe<ArgoMaterialUdfSchemaMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfSchemaAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaArrRelInsertInput = {
  data: Array<ArgoMaterialUdfSchemaInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoMaterialUdfSchemaOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.material_udf_schema". All fields are combined with a logical 'AND'. */
export type ArgoMaterialUdfSchemaBoolExp = {
  _and?: Maybe<Array<ArgoMaterialUdfSchemaBoolExp>>;
  _not?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  _or?: Maybe<Array<ArgoMaterialUdfSchemaBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  udf_column?: Maybe<ArgoUdfColumnBoolExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  udf_column_type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "context_id" */
  MaterialUdfSchemaEnforceUnique = 'material_udf_schema_enforce_unique',
  /** unique or primary key constraint on columns "material_udf_schema_id" */
  MaterialUdfSchemaPkey = 'material_udf_schema_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMaterialUdfSchemaDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMaterialUdfSchemaDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMaterialUdfSchemaDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  udf_column?: Maybe<ArgoUdfColumnObjRelInsertInput>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoMaterialUdfSchemaMaxFields = {
  __typename?: 'argo_material_udf_schema_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<OrderBy>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<OrderBy>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoMaterialUdfSchemaMinFields = {
  __typename?: 'argo_material_udf_schema_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<OrderBy>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<OrderBy>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaMutationResponse = {
  __typename?: 'argo_material_udf_schema_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMaterialUdfSchema>;
};

/** on_conflict condition type for table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaOnConflict = {
  constraint: ArgoMaterialUdfSchemaConstraint;
  update_columns?: Array<ArgoMaterialUdfSchemaUpdateColumn>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};

/** Ordering options when selecting data from "argo.material_udf_schema". */
export type ArgoMaterialUdfSchemaOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  udf_column?: Maybe<ArgoUdfColumnOrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  udf_column_type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.material_udf_schema */
export type ArgoMaterialUdfSchemaPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMaterialUdfSchemaPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_udf_schema_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_udf_schema_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaSelectColumnArgoMaterialUdfSchemaAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.material_udf_schema" */
export type ArgoMaterialUdfSchemaSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_material_udf_schema" */
export type ArgoMaterialUdfSchemaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMaterialUdfSchemaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMaterialUdfSchemaStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Material Class linked to this entry */
  material_class_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The UDF Column linked to this entry */
  udf_column_id?: Maybe<Scalars['uuid']>;
  /** The UDF Column Type linked to this entry */
  udf_column_type?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.material_udf_schema" */
export enum ArgoMaterialUdfSchemaUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialUdfSchemaUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialUdfSchemaAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialUdfSchemaDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialUdfSchemaDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialUdfSchemaDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialUdfSchemaPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialUdfSchemaSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialUdfSchemaBoolExp;
};

/** update columns of table "argo.material" */
export enum ArgoMaterialUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoMaterialUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMaterialAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMaterialDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMaterialDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMaterialDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMaterialPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMaterialSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMaterialBoolExp;
};

/** Index table for all media located in the storage engine. This table is meant to help us keep track of whats been uploaded and to provide more robust searching */
export type ArgoMediaConfig = {
  __typename?: 'argo_media_config';
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  /** An object relationship */
  created_by_user: ArgoUser;
  display_name: Scalars['String'];
  /** What the media is keyed by in the storage engine */
  id: Scalars['uuid'];
  meta: Scalars['argo_media_meta'];
  mimetype: Scalars['String'];
  original_file_name: Scalars['String'];
  size_bytes: Scalars['Int'];
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url: Scalars['String'];
};


/** Index table for all media located in the storage engine. This table is meant to help us keep track of whats been uploaded and to provide more robust searching */
export type ArgoMediaConfigMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.media_config" */
export type ArgoMediaConfigAggregate = {
  __typename?: 'argo_media_config_aggregate';
  aggregate?: Maybe<ArgoMediaConfigAggregateFields>;
  nodes: Array<ArgoMediaConfig>;
};

/** aggregate fields of "argo.media_config" */
export type ArgoMediaConfigAggregateFields = {
  __typename?: 'argo_media_config_aggregate_fields';
  avg?: Maybe<ArgoMediaConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMediaConfigMaxFields>;
  min?: Maybe<ArgoMediaConfigMinFields>;
  stddev?: Maybe<ArgoMediaConfigStddevFields>;
  stddev_pop?: Maybe<ArgoMediaConfigStddevPopFields>;
  stddev_samp?: Maybe<ArgoMediaConfigStddevSampFields>;
  sum?: Maybe<ArgoMediaConfigSumFields>;
  var_pop?: Maybe<ArgoMediaConfigVarPopFields>;
  var_samp?: Maybe<ArgoMediaConfigVarSampFields>;
  variance?: Maybe<ArgoMediaConfigVarianceFields>;
};


/** aggregate fields of "argo.media_config" */
export type ArgoMediaConfigAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMediaConfigSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoMediaConfigAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoMediaConfigAvgFields = {
  __typename?: 'argo_media_config_avg_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.media_config". All fields are combined with a logical 'AND'. */
export type ArgoMediaConfigBoolExp = {
  _and?: Maybe<Array<ArgoMediaConfigBoolExp>>;
  _not?: Maybe<ArgoMediaConfigBoolExp>;
  _or?: Maybe<Array<ArgoMediaConfigBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<UuidComparisonExp>;
  created_by_user?: Maybe<ArgoUserBoolExp>;
  display_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  mimetype?: Maybe<StringComparisonExp>;
  original_file_name?: Maybe<StringComparisonExp>;
  size_bytes?: Maybe<IntComparisonExp>;
  url?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.media_config" */
export enum ArgoMediaConfigConstraint {
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey',
  /** unique or primary key constraint on columns "url" */
  MediaUrlKey = 'media_url_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoMediaConfigDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoMediaConfigDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoMediaConfigDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.media_config" */
export type ArgoMediaConfigIncInput = {
  size_bytes?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.media_config" */
export type ArgoMediaConfigInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<ArgoUserObjRelInsertInput>;
  display_name?: Maybe<Scalars['String']>;
  /** What the media is keyed by in the storage engine */
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  mimetype?: Maybe<Scalars['String']>;
  original_file_name?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['Int']>;
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMediaConfigMaxFields = {
  __typename?: 'argo_media_config_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  display_name?: Maybe<Scalars['String']>;
  /** What the media is keyed by in the storage engine */
  id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  original_file_name?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['Int']>;
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMediaConfigMinFields = {
  __typename?: 'argo_media_config_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  display_name?: Maybe<Scalars['String']>;
  /** What the media is keyed by in the storage engine */
  id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  original_file_name?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['Int']>;
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.media_config" */
export type ArgoMediaConfigMutationResponse = {
  __typename?: 'argo_media_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMediaConfig>;
};

/** on_conflict condition type for table "argo.media_config" */
export type ArgoMediaConfigOnConflict = {
  constraint: ArgoMediaConfigConstraint;
  update_columns?: Array<ArgoMediaConfigUpdateColumn>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};

/** Ordering options when selecting data from "argo.media_config". */
export type ArgoMediaConfigOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<OrderBy>;
  created_by_user?: Maybe<ArgoUserOrderBy>;
  display_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  mimetype?: Maybe<OrderBy>;
  original_file_name?: Maybe<OrderBy>;
  size_bytes?: Maybe<OrderBy>;
  url?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.media_config */
export type ArgoMediaConfigPkColumnsInput = {
  /** What the media is keyed by in the storage engine */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoMediaConfigPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.media_config" */
export enum ArgoMediaConfigSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  OriginalFileName = 'original_file_name',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "argo.media_config" */
export type ArgoMediaConfigSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  display_name?: Maybe<Scalars['String']>;
  /** What the media is keyed by in the storage engine */
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  mimetype?: Maybe<Scalars['String']>;
  original_file_name?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['Int']>;
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArgoMediaConfigStddevFields = {
  __typename?: 'argo_media_config_stddev_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoMediaConfigStddevPopFields = {
  __typename?: 'argo_media_config_stddev_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoMediaConfigStddevSampFields = {
  __typename?: 'argo_media_config_stddev_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_media_config" */
export type ArgoMediaConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMediaConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMediaConfigStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  display_name?: Maybe<Scalars['String']>;
  /** What the media is keyed by in the storage engine */
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  mimetype?: Maybe<Scalars['String']>;
  original_file_name?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['Int']>;
  /** Convenience field for the URL of the media. This is formated as <context_id>/<media_id> */
  url?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoMediaConfigSumFields = {
  __typename?: 'argo_media_config_sum_fields';
  size_bytes?: Maybe<Scalars['Int']>;
};

/** update columns of table "argo.media_config" */
export enum ArgoMediaConfigUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  OriginalFileName = 'original_file_name',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

export type ArgoMediaConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoMediaConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoMediaConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoMediaConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoMediaConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMediaConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoMediaConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMediaConfigSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMediaConfigBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMediaConfigVarPopFields = {
  __typename?: 'argo_media_config_var_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoMediaConfigVarSampFields = {
  __typename?: 'argo_media_config_var_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoMediaConfigVarianceFields = {
  __typename?: 'argo_media_config_variance_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "argo.media_instance" */
export type ArgoMediaInstance = {
  __typename?: 'argo_media_instance';
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  material_id: Scalars['uuid'];
  mimetype: Scalars['String'];
  size_bytes: Scalars['numeric'];
  url: Scalars['String'];
};

/** aggregated selection of "argo.media_instance" */
export type ArgoMediaInstanceAggregate = {
  __typename?: 'argo_media_instance_aggregate';
  aggregate?: Maybe<ArgoMediaInstanceAggregateFields>;
  nodes: Array<ArgoMediaInstance>;
};

/** aggregate fields of "argo.media_instance" */
export type ArgoMediaInstanceAggregateFields = {
  __typename?: 'argo_media_instance_aggregate_fields';
  avg?: Maybe<ArgoMediaInstanceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoMediaInstanceMaxFields>;
  min?: Maybe<ArgoMediaInstanceMinFields>;
  stddev?: Maybe<ArgoMediaInstanceStddevFields>;
  stddev_pop?: Maybe<ArgoMediaInstanceStddevPopFields>;
  stddev_samp?: Maybe<ArgoMediaInstanceStddevSampFields>;
  sum?: Maybe<ArgoMediaInstanceSumFields>;
  var_pop?: Maybe<ArgoMediaInstanceVarPopFields>;
  var_samp?: Maybe<ArgoMediaInstanceVarSampFields>;
  variance?: Maybe<ArgoMediaInstanceVarianceFields>;
};


/** aggregate fields of "argo.media_instance" */
export type ArgoMediaInstanceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoMediaInstanceSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ArgoMediaInstanceAvgFields = {
  __typename?: 'argo_media_instance_avg_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.media_instance". All fields are combined with a logical 'AND'. */
export type ArgoMediaInstanceBoolExp = {
  _and?: Maybe<Array<ArgoMediaInstanceBoolExp>>;
  _not?: Maybe<ArgoMediaInstanceBoolExp>;
  _or?: Maybe<Array<ArgoMediaInstanceBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  filename?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_id?: Maybe<UuidComparisonExp>;
  mimetype?: Maybe<StringComparisonExp>;
  size_bytes?: Maybe<NumericComparisonExp>;
  url?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.media_instance" */
export enum ArgoMediaInstanceConstraint {
  /** unique or primary key constraint on columns "id" */
  MediaInstancePkey = 'media_instance_pkey'
}

/** input type for incrementing numeric columns in table "argo.media_instance" */
export type ArgoMediaInstanceIncInput = {
  size_bytes?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "argo.media_instance" */
export type ArgoMediaInstanceInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoMediaInstanceMaxFields = {
  __typename?: 'argo_media_instance_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoMediaInstanceMinFields = {
  __typename?: 'argo_media_instance_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.media_instance" */
export type ArgoMediaInstanceMutationResponse = {
  __typename?: 'argo_media_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoMediaInstance>;
};

/** on_conflict condition type for table "argo.media_instance" */
export type ArgoMediaInstanceOnConflict = {
  constraint: ArgoMediaInstanceConstraint;
  update_columns?: Array<ArgoMediaInstanceUpdateColumn>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};

/** Ordering options when selecting data from "argo.media_instance". */
export type ArgoMediaInstanceOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  filename?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  mimetype?: Maybe<OrderBy>;
  size_bytes?: Maybe<OrderBy>;
  url?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.media_instance */
export type ArgoMediaInstancePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.media_instance" */
export enum ArgoMediaInstanceSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "argo.media_instance" */
export type ArgoMediaInstanceSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArgoMediaInstanceStddevFields = {
  __typename?: 'argo_media_instance_stddev_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoMediaInstanceStddevPopFields = {
  __typename?: 'argo_media_instance_stddev_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoMediaInstanceStddevSampFields = {
  __typename?: 'argo_media_instance_stddev_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_media_instance" */
export type ArgoMediaInstanceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoMediaInstanceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoMediaInstanceStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  mimetype?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoMediaInstanceSumFields = {
  __typename?: 'argo_media_instance_sum_fields';
  size_bytes?: Maybe<Scalars['numeric']>;
};

/** update columns of table "argo.media_instance" */
export enum ArgoMediaInstanceUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

export type ArgoMediaInstanceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoMediaInstanceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoMediaInstanceSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoMediaInstanceBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoMediaInstanceVarPopFields = {
  __typename?: 'argo_media_instance_var_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoMediaInstanceVarSampFields = {
  __typename?: 'argo_media_instance_var_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoMediaInstanceVarianceFields = {
  __typename?: 'argo_media_instance_variance_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};


/** columns and relationships of "argo.pg_timezone_names" */
export type ArgoPgTimezoneNames = {
  __typename?: 'argo_pg_timezone_names';
  abbrev?: Maybe<Scalars['String']>;
  is_dst?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  utc_offset?: Maybe<Scalars['interval']>;
};

/** aggregated selection of "argo.pg_timezone_names" */
export type ArgoPgTimezoneNamesAggregate = {
  __typename?: 'argo_pg_timezone_names_aggregate';
  aggregate?: Maybe<ArgoPgTimezoneNamesAggregateFields>;
  nodes: Array<ArgoPgTimezoneNames>;
};

/** aggregate fields of "argo.pg_timezone_names" */
export type ArgoPgTimezoneNamesAggregateFields = {
  __typename?: 'argo_pg_timezone_names_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoPgTimezoneNamesMaxFields>;
  min?: Maybe<ArgoPgTimezoneNamesMinFields>;
};


/** aggregate fields of "argo.pg_timezone_names" */
export type ArgoPgTimezoneNamesAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoPgTimezoneNamesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.pg_timezone_names". All fields are combined with a logical 'AND'. */
export type ArgoPgTimezoneNamesBoolExp = {
  _and?: Maybe<Array<ArgoPgTimezoneNamesBoolExp>>;
  _not?: Maybe<ArgoPgTimezoneNamesBoolExp>;
  _or?: Maybe<Array<ArgoPgTimezoneNamesBoolExp>>;
  abbrev?: Maybe<StringComparisonExp>;
  is_dst?: Maybe<BooleanComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  utc_offset?: Maybe<IntervalComparisonExp>;
};

/** aggregate max on columns */
export type ArgoPgTimezoneNamesMaxFields = {
  __typename?: 'argo_pg_timezone_names_max_fields';
  abbrev?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoPgTimezoneNamesMinFields = {
  __typename?: 'argo_pg_timezone_names_min_fields';
  abbrev?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "argo.pg_timezone_names". */
export type ArgoPgTimezoneNamesOrderBy = {
  abbrev?: Maybe<OrderBy>;
  is_dst?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  utc_offset?: Maybe<OrderBy>;
};

/** select columns of table "argo.pg_timezone_names" */
export enum ArgoPgTimezoneNamesSelectColumn {
  /** column name */
  Abbrev = 'abbrev',
  /** column name */
  IsDst = 'is_dst',
  /** column name */
  Name = 'name',
  /** column name */
  UtcOffset = 'utc_offset'
}

/** Streaming cursor of the table "argo_pg_timezone_names" */
export type ArgoPgTimezoneNamesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoPgTimezoneNamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoPgTimezoneNamesStreamCursorValueInput = {
  abbrev?: Maybe<Scalars['String']>;
  is_dst?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  utc_offset?: Maybe<Scalars['interval']>;
};

/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRole = {
  __typename?: 'argo_role';
  /** An array relationship */
  acls: Array<ArgoRoleAcl>;
  /** An aggregate relationship */
  acls_aggregate: ArgoRoleAclAggregate;
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The case-sensitive name for this entry */
  name: Scalars['String'];
  /** The case-insensitive name for this entry */
  name_unique: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  user_roles: Array<ArgoUserRole>;
  /** An aggregate relationship */
  user_roles_aggregate: ArgoUserRoleAggregate;
};


/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRoleAclsArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRoleAclsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRoleMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRoleUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


/** Argonaut Roles are custom groupings of ACLs */
export type ArgoRoleUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};

/** Defines which ACLs are assigned to which Roles */
export type ArgoRoleAcl = {
  __typename?: 'argo_role_acl';
  /** An object relationship */
  acl: ArgoAcl;
  /** The ACL this entry is referencing */
  acl_id: Scalars['String'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  role: ArgoRole;
  /** The role this entry is referencing */
  role_id: Scalars['uuid'];
};


/** Defines which ACLs are assigned to which Roles */
export type ArgoRoleAclMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.role_acl" */
export type ArgoRoleAclAggregate = {
  __typename?: 'argo_role_acl_aggregate';
  aggregate?: Maybe<ArgoRoleAclAggregateFields>;
  nodes: Array<ArgoRoleAcl>;
};

export type ArgoRoleAclAggregateBoolExp = {
  count?: Maybe<ArgoRoleAclAggregateBoolExpCount>;
};

export type ArgoRoleAclAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoRoleAclBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.role_acl" */
export type ArgoRoleAclAggregateFields = {
  __typename?: 'argo_role_acl_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoRoleAclMaxFields>;
  min?: Maybe<ArgoRoleAclMinFields>;
};


/** aggregate fields of "argo.role_acl" */
export type ArgoRoleAclAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.role_acl" */
export type ArgoRoleAclAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoRoleAclMaxOrderBy>;
  min?: Maybe<ArgoRoleAclMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoRoleAclAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.role_acl" */
export type ArgoRoleAclArrRelInsertInput = {
  data: Array<ArgoRoleAclInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoRoleAclOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.role_acl". All fields are combined with a logical 'AND'. */
export type ArgoRoleAclBoolExp = {
  _and?: Maybe<Array<ArgoRoleAclBoolExp>>;
  _not?: Maybe<ArgoRoleAclBoolExp>;
  _or?: Maybe<Array<ArgoRoleAclBoolExp>>;
  acl?: Maybe<ArgoAclBoolExp>;
  acl_id?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  role?: Maybe<ArgoRoleBoolExp>;
  role_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.role_acl" */
export enum ArgoRoleAclConstraint {
  /** unique or primary key constraint on columns "role_acl_id" */
  RoleAclPkey = 'role_acl_pkey',
  /** unique or primary key constraint on columns "role_id", "acl_id" */
  RoleAclRoleIdAclIdKey = 'role_acl_role_id_acl_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoRoleAclDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoRoleAclDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoRoleAclDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.role_acl" */
export type ArgoRoleAclInsertInput = {
  acl?: Maybe<ArgoAclObjRelInsertInput>;
  /** The ACL this entry is referencing */
  acl_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  role?: Maybe<ArgoRoleObjRelInsertInput>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoRoleAclMaxFields = {
  __typename?: 'argo_role_acl_max_fields';
  /** The ACL this entry is referencing */
  acl_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.role_acl" */
export type ArgoRoleAclMaxOrderBy = {
  /** The ACL this entry is referencing */
  acl_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The role this entry is referencing */
  role_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoRoleAclMinFields = {
  __typename?: 'argo_role_acl_min_fields';
  /** The ACL this entry is referencing */
  acl_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.role_acl" */
export type ArgoRoleAclMinOrderBy = {
  /** The ACL this entry is referencing */
  acl_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The role this entry is referencing */
  role_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.role_acl" */
export type ArgoRoleAclMutationResponse = {
  __typename?: 'argo_role_acl_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoRoleAcl>;
};

/** on_conflict condition type for table "argo.role_acl" */
export type ArgoRoleAclOnConflict = {
  constraint: ArgoRoleAclConstraint;
  update_columns?: Array<ArgoRoleAclUpdateColumn>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};

/** Ordering options when selecting data from "argo.role_acl". */
export type ArgoRoleAclOrderBy = {
  acl?: Maybe<ArgoAclOrderBy>;
  acl_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  role?: Maybe<ArgoRoleOrderBy>;
  role_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.role_acl */
export type ArgoRoleAclPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoRoleAclPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.role_acl" */
export enum ArgoRoleAclSelectColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id'
}

/** input type for updating data in table "argo.role_acl" */
export type ArgoRoleAclSetInput = {
  /** The ACL this entry is referencing */
  acl_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_role_acl" */
export type ArgoRoleAclStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoRoleAclStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoRoleAclStreamCursorValueInput = {
  /** The ACL this entry is referencing */
  acl_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.role_acl" */
export enum ArgoRoleAclUpdateColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id'
}

export type ArgoRoleAclUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoRoleAclAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoRoleAclDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoRoleAclDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoRoleAclDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoRoleAclPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoRoleAclSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoRoleAclBoolExp;
};

/** aggregated selection of "argo.role" */
export type ArgoRoleAggregate = {
  __typename?: 'argo_role_aggregate';
  aggregate?: Maybe<ArgoRoleAggregateFields>;
  nodes: Array<ArgoRole>;
};

export type ArgoRoleAggregateBoolExp = {
  bool_and?: Maybe<ArgoRoleAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoRoleAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoRoleAggregateBoolExpCount>;
};

export type ArgoRoleAggregateBoolExpBoolAnd = {
  arguments: ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoRoleBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoRoleAggregateBoolExpBoolOr = {
  arguments: ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoRoleBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoRoleAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoRoleBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.role" */
export type ArgoRoleAggregateFields = {
  __typename?: 'argo_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoRoleMaxFields>;
  min?: Maybe<ArgoRoleMinFields>;
};


/** aggregate fields of "argo.role" */
export type ArgoRoleAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.role" */
export type ArgoRoleAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoRoleMaxOrderBy>;
  min?: Maybe<ArgoRoleMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoRoleAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.role" */
export type ArgoRoleArrRelInsertInput = {
  data: Array<ArgoRoleInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoRoleOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.role". All fields are combined with a logical 'AND'. */
export type ArgoRoleBoolExp = {
  _and?: Maybe<Array<ArgoRoleBoolExp>>;
  _not?: Maybe<ArgoRoleBoolExp>;
  _or?: Maybe<Array<ArgoRoleBoolExp>>;
  acls?: Maybe<ArgoRoleAclBoolExp>;
  acls_aggregate?: Maybe<ArgoRoleAclAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  user_roles?: Maybe<ArgoUserRoleBoolExp>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.role" */
export enum ArgoRoleConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  RoleNameEnforceUnique = 'role_name_enforce_unique',
  /** unique or primary key constraint on columns "role_id" */
  RolePkey = 'role_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoRoleDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoRoleDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoRoleDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.role" */
export type ArgoRoleInsertInput = {
  acls?: Maybe<ArgoRoleAclArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The case-sensitive name for this entry */
  name?: Maybe<Scalars['String']>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_roles?: Maybe<ArgoUserRoleArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoRoleMaxFields = {
  __typename?: 'argo_role_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The case-sensitive name for this entry */
  name?: Maybe<Scalars['String']>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.role" */
export type ArgoRoleMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The case-sensitive name for this entry */
  name?: Maybe<OrderBy>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoRoleMinFields = {
  __typename?: 'argo_role_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The case-sensitive name for this entry */
  name?: Maybe<Scalars['String']>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.role" */
export type ArgoRoleMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The case-sensitive name for this entry */
  name?: Maybe<OrderBy>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.role" */
export type ArgoRoleMutationResponse = {
  __typename?: 'argo_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoRole>;
};

/** input type for inserting object relation for remote table "argo.role" */
export type ArgoRoleObjRelInsertInput = {
  data: ArgoRoleInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoRoleOnConflict>;
};

/** on_conflict condition type for table "argo.role" */
export type ArgoRoleOnConflict = {
  constraint: ArgoRoleConstraint;
  update_columns?: Array<ArgoRoleUpdateColumn>;
  where?: Maybe<ArgoRoleBoolExp>;
};

/** Ordering options when selecting data from "argo.role". */
export type ArgoRoleOrderBy = {
  acls_aggregate?: Maybe<ArgoRoleAclAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateOrderBy>;
};

/** primary key columns input for table: argo.role */
export type ArgoRolePkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoRolePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.role" */
export enum ArgoRoleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_role_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.role" */
export enum ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_role_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.role" */
export enum ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.role" */
export type ArgoRoleSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The case-sensitive name for this entry */
  name?: Maybe<Scalars['String']>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_role" */
export type ArgoRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoRoleStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The case-sensitive name for this entry */
  name?: Maybe<Scalars['String']>;
  /** The case-insensitive name for this entry */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.role" */
export enum ArgoRoleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoRoleUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoRoleAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoRoleDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoRoleDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoRoleDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoRolePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoRoleSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoRoleBoolExp;
};

/** Schedule to be active at a location during the active time range */
export type ArgoSchedule = {
  __typename?: 'argo_schedule';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  mode: ArgoScheduleModeEnum;
  name: Scalars['String'];
  name_unique: Scalars['String'];
  /** An array relationship */
  schedule_events: Array<ArgoScheduleEvent>;
  /** An aggregate relationship */
  schedule_events_aggregate: ArgoScheduleEventAggregate;
  /** An object relationship */
  schedule_mode: ArgoScheduleMode;
  /** An array relationship */
  schedules: Array<ArgoCalendar>;
  /** An aggregate relationship */
  schedules_aggregate: ArgoCalendarAggregate;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoScheduleMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoScheduleScheduleEventsArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoScheduleScheduleEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoScheduleSchedulesArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


/** Schedule to be active at a location during the active time range */
export type ArgoScheduleSchedulesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};

/** aggregated selection of "argo.schedule" */
export type ArgoScheduleAggregate = {
  __typename?: 'argo_schedule_aggregate';
  aggregate?: Maybe<ArgoScheduleAggregateFields>;
  nodes: Array<ArgoSchedule>;
};

export type ArgoScheduleAggregateBoolExp = {
  bool_and?: Maybe<ArgoScheduleAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoScheduleAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoScheduleAggregateBoolExpCount>;
};

export type ArgoScheduleAggregateBoolExpBoolAnd = {
  arguments: ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoScheduleBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoScheduleAggregateBoolExpBoolOr = {
  arguments: ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoScheduleBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoScheduleAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoScheduleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoScheduleBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.schedule" */
export type ArgoScheduleAggregateFields = {
  __typename?: 'argo_schedule_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoScheduleMaxFields>;
  min?: Maybe<ArgoScheduleMinFields>;
};


/** aggregate fields of "argo.schedule" */
export type ArgoScheduleAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoScheduleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.schedule" */
export type ArgoScheduleAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoScheduleMaxOrderBy>;
  min?: Maybe<ArgoScheduleMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoScheduleAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.schedule" */
export type ArgoScheduleArrRelInsertInput = {
  data: Array<ArgoScheduleInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.schedule". All fields are combined with a logical 'AND'. */
export type ArgoScheduleBoolExp = {
  _and?: Maybe<Array<ArgoScheduleBoolExp>>;
  _not?: Maybe<ArgoScheduleBoolExp>;
  _or?: Maybe<Array<ArgoScheduleBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  mode?: Maybe<ArgoScheduleModeEnumComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  schedule_events?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateBoolExp>;
  schedule_mode?: Maybe<ArgoScheduleModeBoolExp>;
  schedules?: Maybe<ArgoCalendarBoolExp>;
  schedules_aggregate?: Maybe<ArgoCalendarAggregateBoolExp>;
  start_time?: Maybe<TimestamptzComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.schedule" */
export enum ArgoScheduleConstraint {
  /** unique or primary key constraint on columns "schedule_id" */
  SchedulePkey = 'schedule_pkey'
}

/** Days of the week */
export type ArgoScheduleDay = {
  __typename?: 'argo_schedule_day';
  /** An array relationship */
  calendar_events: Array<ArgoCalendarEvent>;
  /** An aggregate relationship */
  calendar_events_aggregate: ArgoCalendarEventAggregate;
  day: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  schedule_events: Array<ArgoScheduleEvent>;
  /** An aggregate relationship */
  schedule_events_aggregate: ArgoScheduleEventAggregate;
};


/** Days of the week */
export type ArgoScheduleDayCalendarEventsArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Days of the week */
export type ArgoScheduleDayCalendarEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


/** Days of the week */
export type ArgoScheduleDayScheduleEventsArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


/** Days of the week */
export type ArgoScheduleDayScheduleEventsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};

/** aggregated selection of "argo.schedule_day" */
export type ArgoScheduleDayAggregate = {
  __typename?: 'argo_schedule_day_aggregate';
  aggregate?: Maybe<ArgoScheduleDayAggregateFields>;
  nodes: Array<ArgoScheduleDay>;
};

/** aggregate fields of "argo.schedule_day" */
export type ArgoScheduleDayAggregateFields = {
  __typename?: 'argo_schedule_day_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoScheduleDayMaxFields>;
  min?: Maybe<ArgoScheduleDayMinFields>;
};


/** aggregate fields of "argo.schedule_day" */
export type ArgoScheduleDayAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoScheduleDaySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.schedule_day". All fields are combined with a logical 'AND'. */
export type ArgoScheduleDayBoolExp = {
  _and?: Maybe<Array<ArgoScheduleDayBoolExp>>;
  _not?: Maybe<ArgoScheduleDayBoolExp>;
  _or?: Maybe<Array<ArgoScheduleDayBoolExp>>;
  calendar_events?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateBoolExp>;
  day?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  schedule_events?: Maybe<ArgoScheduleEventBoolExp>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.schedule_day" */
export enum ArgoScheduleDayConstraint {
  /** unique or primary key constraint on columns "day" */
  ScheduleDayPkey = 'schedule_day_pkey'
}

export enum ArgoScheduleDayEnum {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** Boolean expression to compare columns of type "argo_schedule_day_enum". All fields are combined with logical 'AND'. */
export type ArgoScheduleDayEnumComparisonExp = {
  _eq?: Maybe<ArgoScheduleDayEnum>;
  _in?: Maybe<Array<ArgoScheduleDayEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoScheduleDayEnum>;
  _nin?: Maybe<Array<ArgoScheduleDayEnum>>;
};

/** input type for inserting data into table "argo.schedule_day" */
export type ArgoScheduleDayInsertInput = {
  calendar_events?: Maybe<ArgoCalendarEventArrRelInsertInput>;
  day?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  schedule_events?: Maybe<ArgoScheduleEventArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoScheduleDayMaxFields = {
  __typename?: 'argo_schedule_day_max_fields';
  day?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoScheduleDayMinFields = {
  __typename?: 'argo_schedule_day_min_fields';
  day?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.schedule_day" */
export type ArgoScheduleDayMutationResponse = {
  __typename?: 'argo_schedule_day_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoScheduleDay>;
};

/** input type for inserting object relation for remote table "argo.schedule_day" */
export type ArgoScheduleDayObjRelInsertInput = {
  data: ArgoScheduleDayInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleDayOnConflict>;
};

/** on_conflict condition type for table "argo.schedule_day" */
export type ArgoScheduleDayOnConflict = {
  constraint: ArgoScheduleDayConstraint;
  update_columns?: Array<ArgoScheduleDayUpdateColumn>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};

/** Ordering options when selecting data from "argo.schedule_day". */
export type ArgoScheduleDayOrderBy = {
  calendar_events_aggregate?: Maybe<ArgoCalendarEventAggregateOrderBy>;
  day?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateOrderBy>;
};

/** primary key columns input for table: argo.schedule_day */
export type ArgoScheduleDayPkColumnsInput = {
  day: Scalars['String'];
};

/** select columns of table "argo.schedule_day" */
export enum ArgoScheduleDaySelectColumn {
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "argo.schedule_day" */
export type ArgoScheduleDaySetInput = {
  day?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_schedule_day" */
export type ArgoScheduleDayStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoScheduleDayStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoScheduleDayStreamCursorValueInput = {
  day?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.schedule_day" */
export enum ArgoScheduleDayUpdateColumn {
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description'
}

export type ArgoScheduleDayUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoScheduleDaySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoScheduleDayBoolExp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoScheduleDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoScheduleDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoScheduleDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** Events that make up the shape of a schedule */
export type ArgoScheduleEvent = {
  __typename?: 'argo_schedule_event';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  day: ArgoScheduleDayEnum;
  /** An object relationship */
  event?: Maybe<ArgoEvent>;
  event_id: Scalars['uuid'];
  event_type_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  range: Scalars['tsrange'];
  /** An object relationship */
  schedule: ArgoSchedule;
  /** An object relationship */
  schedule_day: ArgoScheduleDay;
  schedule_id: Scalars['uuid'];
  /** An array relationship */
  udf_default_data: Array<ArgoCalendarEventUdfDefaultData>;
  /** An aggregate relationship */
  udf_default_data_aggregate: ArgoCalendarEventUdfDefaultDataAggregate;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Events that make up the shape of a schedule */
export type ArgoScheduleEventMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Events that make up the shape of a schedule */
export type ArgoScheduleEventUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


/** Events that make up the shape of a schedule */
export type ArgoScheduleEventUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};

/** aggregated selection of "argo.schedule_event" */
export type ArgoScheduleEventAggregate = {
  __typename?: 'argo_schedule_event_aggregate';
  aggregate?: Maybe<ArgoScheduleEventAggregateFields>;
  nodes: Array<ArgoScheduleEvent>;
};

export type ArgoScheduleEventAggregateBoolExp = {
  count?: Maybe<ArgoScheduleEventAggregateBoolExpCount>;
};

export type ArgoScheduleEventAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoScheduleEventBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.schedule_event" */
export type ArgoScheduleEventAggregateFields = {
  __typename?: 'argo_schedule_event_aggregate_fields';
  avg?: Maybe<ArgoScheduleEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoScheduleEventMaxFields>;
  min?: Maybe<ArgoScheduleEventMinFields>;
  stddev?: Maybe<ArgoScheduleEventStddevFields>;
  stddev_pop?: Maybe<ArgoScheduleEventStddevPopFields>;
  stddev_samp?: Maybe<ArgoScheduleEventStddevSampFields>;
  sum?: Maybe<ArgoScheduleEventSumFields>;
  var_pop?: Maybe<ArgoScheduleEventVarPopFields>;
  var_samp?: Maybe<ArgoScheduleEventVarSampFields>;
  variance?: Maybe<ArgoScheduleEventVarianceFields>;
};


/** aggregate fields of "argo.schedule_event" */
export type ArgoScheduleEventAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.schedule_event" */
export type ArgoScheduleEventAggregateOrderBy = {
  avg?: Maybe<ArgoScheduleEventAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoScheduleEventMaxOrderBy>;
  min?: Maybe<ArgoScheduleEventMinOrderBy>;
  stddev?: Maybe<ArgoScheduleEventStddevOrderBy>;
  stddev_pop?: Maybe<ArgoScheduleEventStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoScheduleEventStddevSampOrderBy>;
  sum?: Maybe<ArgoScheduleEventSumOrderBy>;
  var_pop?: Maybe<ArgoScheduleEventVarPopOrderBy>;
  var_samp?: Maybe<ArgoScheduleEventVarSampOrderBy>;
  variance?: Maybe<ArgoScheduleEventVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoScheduleEventAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.schedule_event" */
export type ArgoScheduleEventArrRelInsertInput = {
  data: Array<ArgoScheduleEventInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleEventOnConflict>;
};

/** aggregate avg on columns */
export type ArgoScheduleEventAvgFields = {
  __typename?: 'argo_schedule_event_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventAvgOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.schedule_event". All fields are combined with a logical 'AND'. */
export type ArgoScheduleEventBoolExp = {
  _and?: Maybe<Array<ArgoScheduleEventBoolExp>>;
  _not?: Maybe<ArgoScheduleEventBoolExp>;
  _or?: Maybe<Array<ArgoScheduleEventBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  day?: Maybe<ArgoScheduleDayEnumComparisonExp>;
  event?: Maybe<ArgoEventBoolExp>;
  event_id?: Maybe<UuidComparisonExp>;
  event_type_id?: Maybe<BigintComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  range?: Maybe<TsrangeComparisonExp>;
  schedule?: Maybe<ArgoScheduleBoolExp>;
  schedule_day?: Maybe<ArgoScheduleDayBoolExp>;
  schedule_id?: Maybe<UuidComparisonExp>;
  udf_default_data?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
  udf_default_data_aggregate?: Maybe<ArgoCalendarEventUdfDefaultDataAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.schedule_event" */
export enum ArgoScheduleEventConstraint {
  /** unique or primary key constraint on columns "schedule_event_id" */
  ScheduleEventPkey = 'schedule_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoScheduleEventDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoScheduleEventDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoScheduleEventDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.schedule_event" */
export type ArgoScheduleEventIncInput = {
  event_type_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.schedule_event" */
export type ArgoScheduleEventInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<ArgoScheduleDayEnum>;
  event?: Maybe<ArgoEventObjRelInsertInput>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  range?: Maybe<Scalars['tsrange']>;
  schedule?: Maybe<ArgoScheduleObjRelInsertInput>;
  schedule_day?: Maybe<ArgoScheduleDayObjRelInsertInput>;
  schedule_id?: Maybe<Scalars['uuid']>;
  udf_default_data?: Maybe<ArgoCalendarEventUdfDefaultDataArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoScheduleEventMaxFields = {
  __typename?: 'argo_schedule_event_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  schedule_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoScheduleEventMinFields = {
  __typename?: 'argo_schedule_event_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  schedule_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.schedule_event" */
export type ArgoScheduleEventMutationResponse = {
  __typename?: 'argo_schedule_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoScheduleEvent>;
};

/** input type for inserting object relation for remote table "argo.schedule_event" */
export type ArgoScheduleEventObjRelInsertInput = {
  data: ArgoScheduleEventInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleEventOnConflict>;
};

/** on_conflict condition type for table "argo.schedule_event" */
export type ArgoScheduleEventOnConflict = {
  constraint: ArgoScheduleEventConstraint;
  update_columns?: Array<ArgoScheduleEventUpdateColumn>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};

/** Ordering options when selecting data from "argo.schedule_event". */
export type ArgoScheduleEventOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  day?: Maybe<OrderBy>;
  event?: Maybe<ArgoEventOrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  range?: Maybe<OrderBy>;
  schedule?: Maybe<ArgoScheduleOrderBy>;
  schedule_day?: Maybe<ArgoScheduleDayOrderBy>;
  schedule_id?: Maybe<OrderBy>;
  udf_default_data_aggregate?: Maybe<ArgoCalendarEventUdfDefaultDataAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.schedule_event */
export type ArgoScheduleEventPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoScheduleEventPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.schedule_event" */
export enum ArgoScheduleEventSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.schedule_event" */
export type ArgoScheduleEventSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<ArgoScheduleDayEnum>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  range?: Maybe<Scalars['tsrange']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoScheduleEventStddevFields = {
  __typename?: 'argo_schedule_event_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventStddevOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoScheduleEventStddevPopFields = {
  __typename?: 'argo_schedule_event_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventStddevPopOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoScheduleEventStddevSampFields = {
  __typename?: 'argo_schedule_event_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventStddevSampOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_schedule_event" */
export type ArgoScheduleEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoScheduleEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoScheduleEventStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  day?: Maybe<ArgoScheduleDayEnum>;
  event_id?: Maybe<Scalars['uuid']>;
  event_type_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  range?: Maybe<Scalars['tsrange']>;
  schedule_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoScheduleEventSumFields = {
  __typename?: 'argo_schedule_event_sum_fields';
  event_type_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventSumOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** update columns of table "argo.schedule_event" */
export enum ArgoScheduleEventUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoScheduleEventUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoScheduleEventAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoScheduleEventDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoScheduleEventDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoScheduleEventDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoScheduleEventIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoScheduleEventPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoScheduleEventSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoScheduleEventBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoScheduleEventVarPopFields = {
  __typename?: 'argo_schedule_event_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventVarPopOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoScheduleEventVarSampFields = {
  __typename?: 'argo_schedule_event_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventVarSampOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoScheduleEventVarianceFields = {
  __typename?: 'argo_schedule_event_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.schedule_event" */
export type ArgoScheduleEventVarianceOrderBy = {
  event_type_id?: Maybe<OrderBy>;
};

/** input type for inserting data into table "argo.schedule" */
export type ArgoScheduleInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  mode?: Maybe<ArgoScheduleModeEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  schedule_events?: Maybe<ArgoScheduleEventArrRelInsertInput>;
  schedule_mode?: Maybe<ArgoScheduleModeObjRelInsertInput>;
  schedules?: Maybe<ArgoCalendarArrRelInsertInput>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoScheduleMaxFields = {
  __typename?: 'argo_schedule_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.schedule" */
export type ArgoScheduleMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  start_time?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoScheduleMinFields = {
  __typename?: 'argo_schedule_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.schedule" */
export type ArgoScheduleMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  start_time?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** Mode to define the duration the Scheule will cover (Ex: Weekly/Bi-Weekly) */
export type ArgoScheduleMode = {
  __typename?: 'argo_schedule_mode';
  /** Description of the schedule mode */
  description: Scalars['String'];
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode: Scalars['String'];
  /** An array relationship */
  schedule_templates: Array<ArgoSchedule>;
  /** An aggregate relationship */
  schedule_templates_aggregate: ArgoScheduleAggregate;
};


/** Mode to define the duration the Scheule will cover (Ex: Weekly/Bi-Weekly) */
export type ArgoScheduleModeScheduleTemplatesArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


/** Mode to define the duration the Scheule will cover (Ex: Weekly/Bi-Weekly) */
export type ArgoScheduleModeScheduleTemplatesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};

/** aggregated selection of "argo.schedule_mode" */
export type ArgoScheduleModeAggregate = {
  __typename?: 'argo_schedule_mode_aggregate';
  aggregate?: Maybe<ArgoScheduleModeAggregateFields>;
  nodes: Array<ArgoScheduleMode>;
};

/** aggregate fields of "argo.schedule_mode" */
export type ArgoScheduleModeAggregateFields = {
  __typename?: 'argo_schedule_mode_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoScheduleModeMaxFields>;
  min?: Maybe<ArgoScheduleModeMinFields>;
};


/** aggregate fields of "argo.schedule_mode" */
export type ArgoScheduleModeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoScheduleModeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.schedule_mode". All fields are combined with a logical 'AND'. */
export type ArgoScheduleModeBoolExp = {
  _and?: Maybe<Array<ArgoScheduleModeBoolExp>>;
  _not?: Maybe<ArgoScheduleModeBoolExp>;
  _or?: Maybe<Array<ArgoScheduleModeBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  mode?: Maybe<StringComparisonExp>;
  schedule_templates?: Maybe<ArgoScheduleBoolExp>;
  schedule_templates_aggregate?: Maybe<ArgoScheduleAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.schedule_mode" */
export enum ArgoScheduleModeConstraint {
  /** unique or primary key constraint on columns "mode" */
  ScheduleModePkey = 'schedule_mode_pkey'
}

export enum ArgoScheduleModeEnum {
  /** covers two weeks of time */
  Biweekly = 'biweekly',
  /** covers one week of time */
  Weekly = 'weekly'
}

/** Boolean expression to compare columns of type "argo_schedule_mode_enum". All fields are combined with logical 'AND'. */
export type ArgoScheduleModeEnumComparisonExp = {
  _eq?: Maybe<ArgoScheduleModeEnum>;
  _in?: Maybe<Array<ArgoScheduleModeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoScheduleModeEnum>;
  _nin?: Maybe<Array<ArgoScheduleModeEnum>>;
};

/** input type for inserting data into table "argo.schedule_mode" */
export type ArgoScheduleModeInsertInput = {
  /** Description of the schedule mode */
  description?: Maybe<Scalars['String']>;
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode?: Maybe<Scalars['String']>;
  schedule_templates?: Maybe<ArgoScheduleArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoScheduleModeMaxFields = {
  __typename?: 'argo_schedule_mode_max_fields';
  /** Description of the schedule mode */
  description?: Maybe<Scalars['String']>;
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoScheduleModeMinFields = {
  __typename?: 'argo_schedule_mode_min_fields';
  /** Description of the schedule mode */
  description?: Maybe<Scalars['String']>;
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.schedule_mode" */
export type ArgoScheduleModeMutationResponse = {
  __typename?: 'argo_schedule_mode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoScheduleMode>;
};

/** input type for inserting object relation for remote table "argo.schedule_mode" */
export type ArgoScheduleModeObjRelInsertInput = {
  data: ArgoScheduleModeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleModeOnConflict>;
};

/** on_conflict condition type for table "argo.schedule_mode" */
export type ArgoScheduleModeOnConflict = {
  constraint: ArgoScheduleModeConstraint;
  update_columns?: Array<ArgoScheduleModeUpdateColumn>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};

/** Ordering options when selecting data from "argo.schedule_mode". */
export type ArgoScheduleModeOrderBy = {
  description?: Maybe<OrderBy>;
  mode?: Maybe<OrderBy>;
  schedule_templates_aggregate?: Maybe<ArgoScheduleAggregateOrderBy>;
};

/** primary key columns input for table: argo.schedule_mode */
export type ArgoScheduleModePkColumnsInput = {
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode: Scalars['String'];
};

/** select columns of table "argo.schedule_mode" */
export enum ArgoScheduleModeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Mode = 'mode'
}

/** input type for updating data in table "argo.schedule_mode" */
export type ArgoScheduleModeSetInput = {
  /** Description of the schedule mode */
  description?: Maybe<Scalars['String']>;
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_schedule_mode" */
export type ArgoScheduleModeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoScheduleModeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoScheduleModeStreamCursorValueInput = {
  /** Description of the schedule mode */
  description?: Maybe<Scalars['String']>;
  /** Mode (Ex: Weekly/Bi-Weekly) */
  mode?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.schedule_mode" */
export enum ArgoScheduleModeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Mode = 'mode'
}

export type ArgoScheduleModeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoScheduleModeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoScheduleModeBoolExp;
};

/** response of any mutation on the table "argo.schedule" */
export type ArgoScheduleMutationResponse = {
  __typename?: 'argo_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoSchedule>;
};

/** input type for inserting object relation for remote table "argo.schedule" */
export type ArgoScheduleObjRelInsertInput = {
  data: ArgoScheduleInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoScheduleOnConflict>;
};

/** on_conflict condition type for table "argo.schedule" */
export type ArgoScheduleOnConflict = {
  constraint: ArgoScheduleConstraint;
  update_columns?: Array<ArgoScheduleUpdateColumn>;
  where?: Maybe<ArgoScheduleBoolExp>;
};

/** Ordering options when selecting data from "argo.schedule". */
export type ArgoScheduleOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  mode?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  schedule_events_aggregate?: Maybe<ArgoScheduleEventAggregateOrderBy>;
  schedule_mode?: Maybe<ArgoScheduleModeOrderBy>;
  schedules_aggregate?: Maybe<ArgoCalendarAggregateOrderBy>;
  start_time?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.schedule */
export type ArgoSchedulePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoSchedulePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_schedule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_schedule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.schedule" */
export type ArgoScheduleSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  mode?: Maybe<ArgoScheduleModeEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_schedule" */
export type ArgoScheduleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoScheduleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoScheduleStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  mode?: Maybe<ArgoScheduleModeEnum>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.schedule" */
export enum ArgoScheduleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoScheduleUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoScheduleAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoScheduleDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoScheduleDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoScheduleDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoSchedulePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoScheduleSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoScheduleBoolExp;
};





/** Serial Number */
export type ArgoSn = {
  __typename?: 'argo_sn';
  /** The content of the Serial Number */
  content: Scalars['String'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  id: Scalars['bigint'];
  /** An object relationship */
  material?: Maybe<ArgoMaterial>;
  meta: Scalars['jsonb'];
  /** An object relationship */
  sn_format?: Maybe<ArgoSnFormat>;
  sn_format_id: Scalars['Int'];
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq: Scalars['String'];
};


/** Serial Number */
export type ArgoSnMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.sn" */
export type ArgoSnAggregate = {
  __typename?: 'argo_sn_aggregate';
  aggregate?: Maybe<ArgoSnAggregateFields>;
  nodes: Array<ArgoSn>;
};

/** aggregate fields of "argo.sn" */
export type ArgoSnAggregateFields = {
  __typename?: 'argo_sn_aggregate_fields';
  avg?: Maybe<ArgoSnAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoSnMaxFields>;
  min?: Maybe<ArgoSnMinFields>;
  stddev?: Maybe<ArgoSnStddevFields>;
  stddev_pop?: Maybe<ArgoSnStddevPopFields>;
  stddev_samp?: Maybe<ArgoSnStddevSampFields>;
  sum?: Maybe<ArgoSnSumFields>;
  var_pop?: Maybe<ArgoSnVarPopFields>;
  var_samp?: Maybe<ArgoSnVarSampFields>;
  variance?: Maybe<ArgoSnVarianceFields>;
};


/** aggregate fields of "argo.sn" */
export type ArgoSnAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoSnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoSnAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoSnAvgFields = {
  __typename?: 'argo_sn_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.sn". All fields are combined with a logical 'AND'. */
export type ArgoSnBoolExp = {
  _and?: Maybe<Array<ArgoSnBoolExp>>;
  _not?: Maybe<ArgoSnBoolExp>;
  _or?: Maybe<Array<ArgoSnBoolExp>>;
  content?: Maybe<StringComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  sn_format?: Maybe<ArgoSnFormatBoolExp>;
  sn_format_id?: Maybe<IntComparisonExp>;
  sn_seq_id?: Maybe<BigintComparisonExp>;
  unq?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.sn" */
export enum ArgoSnConstraint {
  /** unique or primary key constraint on columns "context_id", "content" */
  SnGlobalUniq = 'sn_global_uniq',
  /** unique or primary key constraint on columns "context_id", "sn_id" */
  SnPkey = 'sn_pkey',
  /** unique or primary key constraint on columns "context_id", "sn_format_id", "content" */
  SnUniq = 'sn_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoSnDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoSnDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoSnDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** Serial Number Format */
export type ArgoSnFormat = {
  __typename?: 'argo_sn_format';
  config: Scalars['argo_sn_format_config'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  material_class_id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  /** The name of the serial number format */
  name: Scalars['String'];
  name_unique: Scalars['String'];
  revision: Scalars['smallint'];
  seq_grouping: Array<Scalars['String']>;
  status: ArgoSnFormatStatusEnum;
  /** An object relationship */
  status_enum: ArgoSnFormatStatus;
  /** uniqueness behavior of the format, inherited by sn instances */
  unq: ArgoSnFormatUniquenessEnum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation: Scalars['String'];
};


/** Serial Number Format */
export type ArgoSnFormatConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Serial Number Format */
export type ArgoSnFormatMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.sn_format" */
export type ArgoSnFormatAggregate = {
  __typename?: 'argo_sn_format_aggregate';
  aggregate?: Maybe<ArgoSnFormatAggregateFields>;
  nodes: Array<ArgoSnFormat>;
};

export type ArgoSnFormatAggregateBoolExp = {
  bool_and?: Maybe<ArgoSnFormatAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoSnFormatAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoSnFormatAggregateBoolExpCount>;
};

export type ArgoSnFormatAggregateBoolExpBoolAnd = {
  arguments: ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoSnFormatBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoSnFormatAggregateBoolExpBoolOr = {
  arguments: ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoSnFormatBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoSnFormatAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoSnFormatBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.sn_format" */
export type ArgoSnFormatAggregateFields = {
  __typename?: 'argo_sn_format_aggregate_fields';
  avg?: Maybe<ArgoSnFormatAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoSnFormatMaxFields>;
  min?: Maybe<ArgoSnFormatMinFields>;
  stddev?: Maybe<ArgoSnFormatStddevFields>;
  stddev_pop?: Maybe<ArgoSnFormatStddevPopFields>;
  stddev_samp?: Maybe<ArgoSnFormatStddevSampFields>;
  sum?: Maybe<ArgoSnFormatSumFields>;
  var_pop?: Maybe<ArgoSnFormatVarPopFields>;
  var_samp?: Maybe<ArgoSnFormatVarSampFields>;
  variance?: Maybe<ArgoSnFormatVarianceFields>;
};


/** aggregate fields of "argo.sn_format" */
export type ArgoSnFormatAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.sn_format" */
export type ArgoSnFormatAggregateOrderBy = {
  avg?: Maybe<ArgoSnFormatAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoSnFormatMaxOrderBy>;
  min?: Maybe<ArgoSnFormatMinOrderBy>;
  stddev?: Maybe<ArgoSnFormatStddevOrderBy>;
  stddev_pop?: Maybe<ArgoSnFormatStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoSnFormatStddevSampOrderBy>;
  sum?: Maybe<ArgoSnFormatSumOrderBy>;
  var_pop?: Maybe<ArgoSnFormatVarPopOrderBy>;
  var_samp?: Maybe<ArgoSnFormatVarSampOrderBy>;
  variance?: Maybe<ArgoSnFormatVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoSnFormatAppendInput = {
  config?: Maybe<Scalars['jsonb']>;
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.sn_format" */
export type ArgoSnFormatArrRelInsertInput = {
  data: Array<ArgoSnFormatInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoSnFormatOnConflict>;
};

/** aggregate avg on columns */
export type ArgoSnFormatAvgFields = {
  __typename?: 'argo_sn_format_avg_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.sn_format" */
export type ArgoSnFormatAvgOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.sn_format". All fields are combined with a logical 'AND'. */
export type ArgoSnFormatBoolExp = {
  _and?: Maybe<Array<ArgoSnFormatBoolExp>>;
  _not?: Maybe<ArgoSnFormatBoolExp>;
  _or?: Maybe<Array<ArgoSnFormatBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  revision?: Maybe<SmallintComparisonExp>;
  seq_grouping?: Maybe<StringArrayComparisonExp>;
  status?: Maybe<ArgoSnFormatStatusEnumComparisonExp>;
  status_enum?: Maybe<ArgoSnFormatStatusBoolExp>;
  unq?: Maybe<ArgoSnFormatUniquenessEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  validation?: Maybe<StringComparisonExp>;
};


/** unique or primary key constraints on table "argo.sn_format" */
export enum ArgoSnFormatConstraint {
  /** unique or primary key constraint on columns "context_id", "sn_format_id" */
  SnFormatPkey = 'sn_format_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  SnFormatUniqueName = 'sn_format_unique_name',
  /** unique or primary key constraint on columns "context_id", "sn_format_id", "unq" */
  SnFormatUniqueUnq = 'sn_format_unique_unq'
}

export type ArgoSnFormatDatetimeTokenArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  serial_number_format_datetime_token_data?: Maybe<Scalars['argo_serial_number_format_datetime_token_data_args']>;
  serial_number_generate_datetime_token_data?: Maybe<Scalars['json']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoSnFormatDeleteAtPathInput = {
  config?: Maybe<Array<Scalars['String']>>;
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoSnFormatDeleteElemInput = {
  config?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoSnFormatDeleteKeyInput = {
  config?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.sn_format" */
export type ArgoSnFormatIncInput = {
  id?: Maybe<Scalars['Int']>;
  revision?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "argo.sn_format" */
export type ArgoSnFormatInsertInput = {
  config?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  /** The name of the serial number format */
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['smallint']>;
  seq_grouping?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<ArgoSnFormatStatusEnum>;
  status_enum?: Maybe<ArgoSnFormatStatusObjRelInsertInput>;
  /** uniqueness behavior of the format, inherited by sn instances */
  unq?: Maybe<ArgoSnFormatUniquenessEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoSnFormatMaxFields = {
  __typename?: 'argo_sn_format_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The name of the serial number format */
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['smallint']>;
  seq_grouping?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "argo.sn_format" */
export type ArgoSnFormatMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  /** The name of the serial number format */
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
  seq_grouping?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoSnFormatMinFields = {
  __typename?: 'argo_sn_format_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** The name of the serial number format */
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['smallint']>;
  seq_grouping?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "argo.sn_format" */
export type ArgoSnFormatMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  /** The name of the serial number format */
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
  seq_grouping?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.sn_format" */
export type ArgoSnFormatMutationResponse = {
  __typename?: 'argo_sn_format_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoSnFormat>;
};

/** input type for inserting object relation for remote table "argo.sn_format" */
export type ArgoSnFormatObjRelInsertInput = {
  data: ArgoSnFormatInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoSnFormatOnConflict>;
};

/** on_conflict condition type for table "argo.sn_format" */
export type ArgoSnFormatOnConflict = {
  constraint: ArgoSnFormatConstraint;
  update_columns?: Array<ArgoSnFormatUpdateColumn>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};

/** Ordering options when selecting data from "argo.sn_format". */
export type ArgoSnFormatOrderBy = {
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
  seq_grouping?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_enum?: Maybe<ArgoSnFormatStatusOrderBy>;
  unq?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  validation?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.sn_format */
export type ArgoSnFormatPkColumnsInput = {
  context_id: Scalars['uuid'];
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoSnFormatPrependInput = {
  config?: Maybe<Scalars['jsonb']>;
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeqGrouping = 'seq_grouping',
  /** column name */
  Status = 'status',
  /** column name */
  Unq = 'unq',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Validation = 'validation'
}

/** select "argo_sn_format_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_sn_format_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "argo.sn_format" */
export type ArgoSnFormatSetInput = {
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  /** The name of the serial number format */
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['smallint']>;
  seq_grouping?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<ArgoSnFormatStatusEnum>;
  /** uniqueness behavior of the format, inherited by sn instances */
  unq?: Maybe<ArgoSnFormatUniquenessEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<Scalars['String']>;
};

/** Status enum for a serial number format */
export type ArgoSnFormatStatus = {
  __typename?: 'argo_sn_format_status';
  text: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "argo.sn_format_status" */
export type ArgoSnFormatStatusAggregate = {
  __typename?: 'argo_sn_format_status_aggregate';
  aggregate?: Maybe<ArgoSnFormatStatusAggregateFields>;
  nodes: Array<ArgoSnFormatStatus>;
};

/** aggregate fields of "argo.sn_format_status" */
export type ArgoSnFormatStatusAggregateFields = {
  __typename?: 'argo_sn_format_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoSnFormatStatusMaxFields>;
  min?: Maybe<ArgoSnFormatStatusMinFields>;
};


/** aggregate fields of "argo.sn_format_status" */
export type ArgoSnFormatStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoSnFormatStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.sn_format_status". All fields are combined with a logical 'AND'. */
export type ArgoSnFormatStatusBoolExp = {
  _and?: Maybe<Array<ArgoSnFormatStatusBoolExp>>;
  _not?: Maybe<ArgoSnFormatStatusBoolExp>;
  _or?: Maybe<Array<ArgoSnFormatStatusBoolExp>>;
  text?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.sn_format_status" */
export enum ArgoSnFormatStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  SnFormatStatusPkey = 'sn_format_status_pkey'
}

export enum ArgoSnFormatStatusEnum {
  /** Activated */
  Activated = 'activated',
  /** Archived */
  Archived = 'archived',
  /** Editing */
  Editing = 'editing'
}

/** Boolean expression to compare columns of type "argo_sn_format_status_enum". All fields are combined with logical 'AND'. */
export type ArgoSnFormatStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoSnFormatStatusEnum>;
  _in?: Maybe<Array<ArgoSnFormatStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoSnFormatStatusEnum>;
  _nin?: Maybe<Array<ArgoSnFormatStatusEnum>>;
};

/** input type for inserting data into table "argo.sn_format_status" */
export type ArgoSnFormatStatusInsertInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoSnFormatStatusMaxFields = {
  __typename?: 'argo_sn_format_status_max_fields';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoSnFormatStatusMinFields = {
  __typename?: 'argo_sn_format_status_min_fields';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.sn_format_status" */
export type ArgoSnFormatStatusMutationResponse = {
  __typename?: 'argo_sn_format_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoSnFormatStatus>;
};

/** input type for inserting object relation for remote table "argo.sn_format_status" */
export type ArgoSnFormatStatusObjRelInsertInput = {
  data: ArgoSnFormatStatusInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoSnFormatStatusOnConflict>;
};

/** on_conflict condition type for table "argo.sn_format_status" */
export type ArgoSnFormatStatusOnConflict = {
  constraint: ArgoSnFormatStatusConstraint;
  update_columns?: Array<ArgoSnFormatStatusUpdateColumn>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.sn_format_status". */
export type ArgoSnFormatStatusOrderBy = {
  text?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.sn_format_status */
export type ArgoSnFormatStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "argo.sn_format_status" */
export enum ArgoSnFormatStatusSelectColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "argo.sn_format_status" */
export type ArgoSnFormatStatusSetInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_sn_format_status" */
export type ArgoSnFormatStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoSnFormatStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoSnFormatStatusStreamCursorValueInput = {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.sn_format_status" */
export enum ArgoSnFormatStatusUpdateColumn {
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

export type ArgoSnFormatStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoSnFormatStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoSnFormatStatusBoolExp;
};

/** aggregate stddev on columns */
export type ArgoSnFormatStddevFields = {
  __typename?: 'argo_sn_format_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.sn_format" */
export type ArgoSnFormatStddevOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoSnFormatStddevPopFields = {
  __typename?: 'argo_sn_format_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.sn_format" */
export type ArgoSnFormatStddevPopOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoSnFormatStddevSampFields = {
  __typename?: 'argo_sn_format_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.sn_format" */
export type ArgoSnFormatStddevSampOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_sn_format" */
export type ArgoSnFormatStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoSnFormatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoSnFormatStreamCursorValueInput = {
  config?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  /** The name of the serial number format */
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['smallint']>;
  seq_grouping?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<ArgoSnFormatStatusEnum>;
  /** uniqueness behavior of the format, inherited by sn instances */
  unq?: Maybe<ArgoSnFormatUniquenessEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** regex, with implied ^ and $ anchors */
  validation?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoSnFormatSumFields = {
  __typename?: 'argo_sn_format_sum_fields';
  id?: Maybe<Scalars['Int']>;
  revision?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "argo.sn_format" */
export type ArgoSnFormatSumOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** Uniqueness enum for a serial number format */
export type ArgoSnFormatUniqueness = {
  __typename?: 'argo_sn_format_uniqueness';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessAggregate = {
  __typename?: 'argo_sn_format_uniqueness_aggregate';
  aggregate?: Maybe<ArgoSnFormatUniquenessAggregateFields>;
  nodes: Array<ArgoSnFormatUniqueness>;
};

/** aggregate fields of "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessAggregateFields = {
  __typename?: 'argo_sn_format_uniqueness_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoSnFormatUniquenessMaxFields>;
  min?: Maybe<ArgoSnFormatUniquenessMinFields>;
};


/** aggregate fields of "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoSnFormatUniquenessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.sn_format_uniqueness". All fields are combined with a logical 'AND'. */
export type ArgoSnFormatUniquenessBoolExp = {
  _and?: Maybe<Array<ArgoSnFormatUniquenessBoolExp>>;
  _not?: Maybe<ArgoSnFormatUniquenessBoolExp>;
  _or?: Maybe<Array<ArgoSnFormatUniquenessBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessConstraint {
  /** unique or primary key constraint on columns "type" */
  SnFormatUniquenessPkey = 'sn_format_uniqueness_pkey'
}

export enum ArgoSnFormatUniquenessEnum {
  /** Globally unique */
  G = 'g',
  /** Non-Unique */
  N = 'n',
  /** Unique within this format */
  U = 'u'
}

/** Boolean expression to compare columns of type "argo_sn_format_uniqueness_enum". All fields are combined with logical 'AND'. */
export type ArgoSnFormatUniquenessEnumComparisonExp = {
  _eq?: Maybe<ArgoSnFormatUniquenessEnum>;
  _in?: Maybe<Array<ArgoSnFormatUniquenessEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoSnFormatUniquenessEnum>;
  _nin?: Maybe<Array<ArgoSnFormatUniquenessEnum>>;
};

/** input type for inserting data into table "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessInsertInput = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoSnFormatUniquenessMaxFields = {
  __typename?: 'argo_sn_format_uniqueness_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoSnFormatUniquenessMinFields = {
  __typename?: 'argo_sn_format_uniqueness_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessMutationResponse = {
  __typename?: 'argo_sn_format_uniqueness_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoSnFormatUniqueness>;
};

/** on_conflict condition type for table "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessOnConflict = {
  constraint: ArgoSnFormatUniquenessConstraint;
  update_columns?: Array<ArgoSnFormatUniquenessUpdateColumn>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};

/** Ordering options when selecting data from "argo.sn_format_uniqueness". */
export type ArgoSnFormatUniquenessOrderBy = {
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.sn_format_uniqueness */
export type ArgoSnFormatUniquenessPkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "argo.sn_format_uniqueness" */
export type ArgoSnFormatUniquenessSetInput = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_sn_format_uniqueness" */
export type ArgoSnFormatUniquenessStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoSnFormatUniquenessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoSnFormatUniquenessStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.sn_format_uniqueness" */
export enum ArgoSnFormatUniquenessUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type ArgoSnFormatUniquenessUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoSnFormatUniquenessSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoSnFormatUniquenessBoolExp;
};

/** update columns of table "argo.sn_format" */
export enum ArgoSnFormatUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeqGrouping = 'seq_grouping',
  /** column name */
  Status = 'status',
  /** column name */
  Unq = 'unq',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Validation = 'validation'
}

export type ArgoSnFormatUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoSnFormatAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoSnFormatDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoSnFormatDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoSnFormatDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoSnFormatIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoSnFormatPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoSnFormatSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoSnFormatBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoSnFormatVarPopFields = {
  __typename?: 'argo_sn_format_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.sn_format" */
export type ArgoSnFormatVarPopOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoSnFormatVarSampFields = {
  __typename?: 'argo_sn_format_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.sn_format" */
export type ArgoSnFormatVarSampOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoSnFormatVarianceFields = {
  __typename?: 'argo_sn_format_variance_fields';
  id?: Maybe<Scalars['Float']>;
  revision?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.sn_format" */
export type ArgoSnFormatVarianceOrderBy = {
  id?: Maybe<OrderBy>;
  revision?: Maybe<OrderBy>;
};

export type ArgoSnGenerateAlignContentArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  serial_number_generate_align_content_data?: Maybe<Scalars['argo_serial_number_generate_align_content_data_args']>;
};

export type ArgoSnGenerateArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  generate_serial_number_data?: Maybe<Scalars['argo_serial_number_generate_data']>;
};

export type ArgoSnGenerateSequenceArgs = {
  debug?: Maybe<Scalars['Boolean']>;
  serial_number_generate_sequence_data?: Maybe<Scalars['argo_serial_number_generate_sequence_data_args']>;
};

/** input type for incrementing numeric columns in table "argo.sn" */
export type ArgoSnIncInput = {
  id?: Maybe<Scalars['bigint']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.sn" */
export type ArgoSnInsertInput = {
  /** The content of the Serial Number */
  content?: Maybe<Scalars['String']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  meta?: Maybe<Scalars['jsonb']>;
  sn_format?: Maybe<ArgoSnFormatObjRelInsertInput>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoSnMaxFields = {
  __typename?: 'argo_sn_max_fields';
  /** The content of the Serial Number */
  content?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoSnMinFields = {
  __typename?: 'argo_sn_min_fields';
  /** The content of the Serial Number */
  content?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.sn" */
export type ArgoSnMutationResponse = {
  __typename?: 'argo_sn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoSn>;
};

/** on_conflict condition type for table "argo.sn" */
export type ArgoSnOnConflict = {
  constraint: ArgoSnConstraint;
  update_columns?: Array<ArgoSnUpdateColumn>;
  where?: Maybe<ArgoSnBoolExp>;
};

/** Ordering options when selecting data from "argo.sn". */
export type ArgoSnOrderBy = {
  content?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  meta?: Maybe<OrderBy>;
  sn_format?: Maybe<ArgoSnFormatOrderBy>;
  sn_format_id?: Maybe<OrderBy>;
  sn_seq_id?: Maybe<OrderBy>;
  unq?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.sn */
export type ArgoSnPkColumnsInput = {
  context_id: Scalars['uuid'];
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoSnPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.sn" */
export enum ArgoSnSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnSeqId = 'sn_seq_id',
  /** column name */
  Unq = 'unq'
}

/** input type for updating data in table "argo.sn" */
export type ArgoSnSetInput = {
  /** The content of the Serial Number */
  content?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  meta?: Maybe<Scalars['jsonb']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArgoSnStddevFields = {
  __typename?: 'argo_sn_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoSnStddevPopFields = {
  __typename?: 'argo_sn_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoSnStddevSampFields = {
  __typename?: 'argo_sn_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_sn" */
export type ArgoSnStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoSnStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoSnStreamCursorValueInput = {
  /** The content of the Serial Number */
  content?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  meta?: Maybe<Scalars['jsonb']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
  /** The uniqueness behavior, inherited from its format */
  unq?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoSnSumFields = {
  __typename?: 'argo_sn_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  sn_format_id?: Maybe<Scalars['Int']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "argo.sn" */
export enum ArgoSnUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnSeqId = 'sn_seq_id',
  /** column name */
  Unq = 'unq'
}

export type ArgoSnUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoSnAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoSnDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoSnDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoSnDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoSnIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoSnPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoSnSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoSnBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoSnVarPopFields = {
  __typename?: 'argo_sn_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoSnVarSampFields = {
  __typename?: 'argo_sn_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoSnVarianceFields = {
  __typename?: 'argo_sn_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sn_format_id?: Maybe<Scalars['Float']>;
  /** The sequence associated with this SN, if one exists. This allows linking to the grouping token values for the sequence */
  sn_seq_id?: Maybe<Scalars['Float']>;
};

export type ArgoTraverseAssembliesArgs = {
  opts: Scalars['argo_traverse_assemblies_opts'];
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumn = {
  __typename?: 'argo_udf_column';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** The data type for this entry */
  data_type: ArgoUdfColumnDataTypeEnum;
  /** Description of this entry */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** An object relationship */
  event_type?: Maybe<ArgoVwEventTypeUdfColumn>;
  id: Scalars['uuid'];
  /** An object relationship */
  material_class?: Maybe<ArgoVwMaterialClassUdfColumn>;
  /** An array relationship */
  material_udf_schemas: Array<ArgoMaterialUdfSchema>;
  /** An aggregate relationship */
  material_udf_schemas_aggregate: ArgoMaterialUdfSchemaAggregate;
  /** An array relationship */
  material_udfs: Array<ArgoMaterialUdfData>;
  /** An aggregate relationship */
  material_udfs_aggregate: ArgoMaterialUdfDataAggregate;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  /** The entity type for this entry */
  type: ArgoUdfColumnTypeEnum;
  /** An object relationship */
  udf_column_data_type: ArgoUdfColumnDataType;
  /** An object relationship */
  udf_column_type: ArgoUdfColumnType;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required: Scalars['Boolean'];
  /** The level of uniqueness for occurrence of a value */
  validation_unique: Scalars['smallint'];
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumnMaterialUdfSchemasArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumnMaterialUdfSchemasAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumnMaterialUdfsArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumnMaterialUdfsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


/** The UDF definitions linked to a material class */
export type ArgoUdfColumnMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.udf_column" */
export type ArgoUdfColumnAggregate = {
  __typename?: 'argo_udf_column_aggregate';
  aggregate?: Maybe<ArgoUdfColumnAggregateFields>;
  nodes: Array<ArgoUdfColumn>;
};

export type ArgoUdfColumnAggregateBoolExp = {
  bool_and?: Maybe<ArgoUdfColumnAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoUdfColumnAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoUdfColumnAggregateBoolExpCount>;
};

export type ArgoUdfColumnAggregateBoolExpBoolAnd = {
  arguments: ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUdfColumnBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoUdfColumnAggregateBoolExpBoolOr = {
  arguments: ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUdfColumnBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoUdfColumnAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUdfColumnBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.udf_column" */
export type ArgoUdfColumnAggregateFields = {
  __typename?: 'argo_udf_column_aggregate_fields';
  avg?: Maybe<ArgoUdfColumnAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoUdfColumnMaxFields>;
  min?: Maybe<ArgoUdfColumnMinFields>;
  stddev?: Maybe<ArgoUdfColumnStddevFields>;
  stddev_pop?: Maybe<ArgoUdfColumnStddevPopFields>;
  stddev_samp?: Maybe<ArgoUdfColumnStddevSampFields>;
  sum?: Maybe<ArgoUdfColumnSumFields>;
  var_pop?: Maybe<ArgoUdfColumnVarPopFields>;
  var_samp?: Maybe<ArgoUdfColumnVarSampFields>;
  variance?: Maybe<ArgoUdfColumnVarianceFields>;
};


/** aggregate fields of "argo.udf_column" */
export type ArgoUdfColumnAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.udf_column" */
export type ArgoUdfColumnAggregateOrderBy = {
  avg?: Maybe<ArgoUdfColumnAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoUdfColumnMaxOrderBy>;
  min?: Maybe<ArgoUdfColumnMinOrderBy>;
  stddev?: Maybe<ArgoUdfColumnStddevOrderBy>;
  stddev_pop?: Maybe<ArgoUdfColumnStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoUdfColumnStddevSampOrderBy>;
  sum?: Maybe<ArgoUdfColumnSumOrderBy>;
  var_pop?: Maybe<ArgoUdfColumnVarPopOrderBy>;
  var_samp?: Maybe<ArgoUdfColumnVarSampOrderBy>;
  variance?: Maybe<ArgoUdfColumnVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUdfColumnAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.udf_column" */
export type ArgoUdfColumnArrRelInsertInput = {
  data: Array<ArgoUdfColumnInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUdfColumnOnConflict>;
};

/** aggregate avg on columns */
export type ArgoUdfColumnAvgFields = {
  __typename?: 'argo_udf_column_avg_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.udf_column" */
export type ArgoUdfColumnAvgOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.udf_column". All fields are combined with a logical 'AND'. */
export type ArgoUdfColumnBoolExp = {
  _and?: Maybe<Array<ArgoUdfColumnBoolExp>>;
  _not?: Maybe<ArgoUdfColumnBoolExp>;
  _or?: Maybe<Array<ArgoUdfColumnBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_type?: Maybe<ArgoUdfColumnDataTypeEnumComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  event_type?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
  material_udf_schemas?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
  material_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateBoolExp>;
  material_udfs?: Maybe<ArgoMaterialUdfDataBoolExp>;
  material_udfs_aggregate?: Maybe<ArgoMaterialUdfDataAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  type?: Maybe<ArgoUdfColumnTypeEnumComparisonExp>;
  udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
  udf_column_type?: Maybe<ArgoUdfColumnTypeBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  validation_max?: Maybe<NumericComparisonExp>;
  validation_min?: Maybe<NumericComparisonExp>;
  validation_pattern?: Maybe<StringComparisonExp>;
  validation_required?: Maybe<BooleanComparisonExp>;
  validation_unique?: Maybe<SmallintComparisonExp>;
};

/** unique or primary key constraints on table "argo.udf_column" */
export enum ArgoUdfColumnConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "type" */
  UdfColumnEnforceUniqueFk = 'udf_column_enforce_unique_fk',
  /** unique or primary key constraint on columns "udf_column_id" */
  UdfColumnPkey = 'udf_column_pkey'
}

/** UDF Column Data Type ENUM */
export type ArgoUdfColumnDataType = {
  __typename?: 'argo_udf_column_data_type';
  /** The description of the data type */
  description: Scalars['String'];
  /** The data type */
  type: Scalars['String'];
  /** An array relationship */
  udf_columns: Array<ArgoUdfColumn>;
  /** An aggregate relationship */
  udf_columns_aggregate: ArgoUdfColumnAggregate;
};


/** UDF Column Data Type ENUM */
export type ArgoUdfColumnDataTypeUdfColumnsArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


/** UDF Column Data Type ENUM */
export type ArgoUdfColumnDataTypeUdfColumnsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};

/** aggregated selection of "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeAggregate = {
  __typename?: 'argo_udf_column_data_type_aggregate';
  aggregate?: Maybe<ArgoUdfColumnDataTypeAggregateFields>;
  nodes: Array<ArgoUdfColumnDataType>;
};

/** aggregate fields of "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeAggregateFields = {
  __typename?: 'argo_udf_column_data_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUdfColumnDataTypeMaxFields>;
  min?: Maybe<ArgoUdfColumnDataTypeMinFields>;
};


/** aggregate fields of "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUdfColumnDataTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.udf_column_data_type". All fields are combined with a logical 'AND'. */
export type ArgoUdfColumnDataTypeBoolExp = {
  _and?: Maybe<Array<ArgoUdfColumnDataTypeBoolExp>>;
  _not?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
  _or?: Maybe<Array<ArgoUdfColumnDataTypeBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  udf_columns?: Maybe<ArgoUdfColumnBoolExp>;
  udf_columns_aggregate?: Maybe<ArgoUdfColumnAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  UdfColumnDataTypePkey = 'udf_column_data_type_pkey'
}

export enum ArgoUdfColumnDataTypeEnum {
  /** Numeric data type */
  Number = 'number',
  /** String or Text data type */
  Text = 'text'
}

/** Boolean expression to compare columns of type "argo_udf_column_data_type_enum". All fields are combined with logical 'AND'. */
export type ArgoUdfColumnDataTypeEnumComparisonExp = {
  _eq?: Maybe<ArgoUdfColumnDataTypeEnum>;
  _in?: Maybe<Array<ArgoUdfColumnDataTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoUdfColumnDataTypeEnum>;
  _nin?: Maybe<Array<ArgoUdfColumnDataTypeEnum>>;
};

/** input type for inserting data into table "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeInsertInput = {
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
  udf_columns?: Maybe<ArgoUdfColumnArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoUdfColumnDataTypeMaxFields = {
  __typename?: 'argo_udf_column_data_type_max_fields';
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoUdfColumnDataTypeMinFields = {
  __typename?: 'argo_udf_column_data_type_min_fields';
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeMutationResponse = {
  __typename?: 'argo_udf_column_data_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUdfColumnDataType>;
};

/** input type for inserting object relation for remote table "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeObjRelInsertInput = {
  data: ArgoUdfColumnDataTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUdfColumnDataTypeOnConflict>;
};

/** on_conflict condition type for table "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeOnConflict = {
  constraint: ArgoUdfColumnDataTypeConstraint;
  update_columns?: Array<ArgoUdfColumnDataTypeUpdateColumn>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.udf_column_data_type". */
export type ArgoUdfColumnDataTypeOrderBy = {
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  udf_columns_aggregate?: Maybe<ArgoUdfColumnAggregateOrderBy>;
};

/** primary key columns input for table: argo.udf_column_data_type */
export type ArgoUdfColumnDataTypePkColumnsInput = {
  /** The data type */
  type: Scalars['String'];
};

/** select columns of table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "argo.udf_column_data_type" */
export type ArgoUdfColumnDataTypeSetInput = {
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_udf_column_data_type" */
export type ArgoUdfColumnDataTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUdfColumnDataTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUdfColumnDataTypeStreamCursorValueInput = {
  /** The description of the data type */
  description?: Maybe<Scalars['String']>;
  /** The data type */
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type ArgoUdfColumnDataTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUdfColumnDataTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUdfColumnDataTypeBoolExp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUdfColumnDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUdfColumnDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUdfColumnDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.udf_column" */
export type ArgoUdfColumnIncInput = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "argo.udf_column" */
export type ArgoUdfColumnInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data type for this entry */
  data_type?: Maybe<ArgoUdfColumnDataTypeEnum>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  event_type?: Maybe<ArgoVwEventTypeUdfColumnObjRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoVwMaterialClassUdfColumnObjRelInsertInput>;
  material_udf_schemas?: Maybe<ArgoMaterialUdfSchemaArrRelInsertInput>;
  material_udfs?: Maybe<ArgoMaterialUdfDataArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The entity type for this entry */
  type?: Maybe<ArgoUdfColumnTypeEnum>;
  udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeObjRelInsertInput>;
  udf_column_type?: Maybe<ArgoUdfColumnTypeObjRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type ArgoUdfColumnMaxFields = {
  __typename?: 'argo_udf_column_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "argo.udf_column" */
export type ArgoUdfColumnMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoUdfColumnMinFields = {
  __typename?: 'argo_udf_column_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "argo.udf_column" */
export type ArgoUdfColumnMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.udf_column" */
export type ArgoUdfColumnMutationResponse = {
  __typename?: 'argo_udf_column_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUdfColumn>;
};

/** input type for inserting object relation for remote table "argo.udf_column" */
export type ArgoUdfColumnObjRelInsertInput = {
  data: ArgoUdfColumnInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUdfColumnOnConflict>;
};

/** on_conflict condition type for table "argo.udf_column" */
export type ArgoUdfColumnOnConflict = {
  constraint: ArgoUdfColumnConstraint;
  update_columns?: Array<ArgoUdfColumnUpdateColumn>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};

/** Ordering options when selecting data from "argo.udf_column". */
export type ArgoUdfColumnOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_type?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  event_type?: Maybe<ArgoVwEventTypeUdfColumnOrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoVwMaterialClassUdfColumnOrderBy>;
  material_udf_schemas_aggregate?: Maybe<ArgoMaterialUdfSchemaAggregateOrderBy>;
  material_udfs_aggregate?: Maybe<ArgoMaterialUdfDataAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeOrderBy>;
  udf_column_type?: Maybe<ArgoUdfColumnTypeOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  validation_max?: Maybe<OrderBy>;
  validation_min?: Maybe<OrderBy>;
  validation_pattern?: Maybe<OrderBy>;
  validation_required?: Maybe<OrderBy>;
  validation_unique?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.udf_column */
export type ArgoUdfColumnPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUdfColumnPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required',
  /** column name */
  ValidationUnique = 'validation_unique'
}

/** select "argo_udf_column_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_udf_column_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** input type for updating data in table "argo.udf_column" */
export type ArgoUdfColumnSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data type for this entry */
  data_type?: Maybe<ArgoUdfColumnDataTypeEnum>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The entity type for this entry */
  type?: Maybe<ArgoUdfColumnTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type ArgoUdfColumnStddevFields = {
  __typename?: 'argo_udf_column_stddev_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.udf_column" */
export type ArgoUdfColumnStddevOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoUdfColumnStddevPopFields = {
  __typename?: 'argo_udf_column_stddev_pop_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.udf_column" */
export type ArgoUdfColumnStddevPopOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoUdfColumnStddevSampFields = {
  __typename?: 'argo_udf_column_stddev_samp_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.udf_column" */
export type ArgoUdfColumnStddevSampOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_udf_column" */
export type ArgoUdfColumnStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUdfColumnStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUdfColumnStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data type for this entry */
  data_type?: Maybe<ArgoUdfColumnDataTypeEnum>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** The entity type for this entry */
  type?: Maybe<ArgoUdfColumnTypeEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** A Regular Expression test for a text value */
  validation_pattern?: Maybe<Scalars['String']>;
  /** Whether or not the value can be NULL */
  validation_required?: Maybe<Scalars['Boolean']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type ArgoUdfColumnSumFields = {
  __typename?: 'argo_udf_column_sum_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['numeric']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['numeric']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "argo.udf_column" */
export type ArgoUdfColumnSumOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** UDF Column Type ENUM */
export type ArgoUdfColumnType = {
  __typename?: 'argo_udf_column_type';
  /** The description of the udf type */
  description: Scalars['String'];
  /** The type of entity this entry can be linked to */
  type: Scalars['String'];
};

/** aggregated selection of "argo.udf_column_type" */
export type ArgoUdfColumnTypeAggregate = {
  __typename?: 'argo_udf_column_type_aggregate';
  aggregate?: Maybe<ArgoUdfColumnTypeAggregateFields>;
  nodes: Array<ArgoUdfColumnType>;
};

/** aggregate fields of "argo.udf_column_type" */
export type ArgoUdfColumnTypeAggregateFields = {
  __typename?: 'argo_udf_column_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUdfColumnTypeMaxFields>;
  min?: Maybe<ArgoUdfColumnTypeMinFields>;
};


/** aggregate fields of "argo.udf_column_type" */
export type ArgoUdfColumnTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUdfColumnTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.udf_column_type". All fields are combined with a logical 'AND'. */
export type ArgoUdfColumnTypeBoolExp = {
  _and?: Maybe<Array<ArgoUdfColumnTypeBoolExp>>;
  _not?: Maybe<ArgoUdfColumnTypeBoolExp>;
  _or?: Maybe<Array<ArgoUdfColumnTypeBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  UdfColumnTypePkey = 'udf_column_type_pkey'
}

export enum ArgoUdfColumnTypeEnum {
  /** Event */
  Event = 'event',
  /** Material */
  Material = 'material'
}

/** Boolean expression to compare columns of type "argo_udf_column_type_enum". All fields are combined with logical 'AND'. */
export type ArgoUdfColumnTypeEnumComparisonExp = {
  _eq?: Maybe<ArgoUdfColumnTypeEnum>;
  _in?: Maybe<Array<ArgoUdfColumnTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoUdfColumnTypeEnum>;
  _nin?: Maybe<Array<ArgoUdfColumnTypeEnum>>;
};

/** input type for inserting data into table "argo.udf_column_type" */
export type ArgoUdfColumnTypeInsertInput = {
  /** The description of the udf type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity this entry can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoUdfColumnTypeMaxFields = {
  __typename?: 'argo_udf_column_type_max_fields';
  /** The description of the udf type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity this entry can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoUdfColumnTypeMinFields = {
  __typename?: 'argo_udf_column_type_min_fields';
  /** The description of the udf type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity this entry can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.udf_column_type" */
export type ArgoUdfColumnTypeMutationResponse = {
  __typename?: 'argo_udf_column_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUdfColumnType>;
};

/** input type for inserting object relation for remote table "argo.udf_column_type" */
export type ArgoUdfColumnTypeObjRelInsertInput = {
  data: ArgoUdfColumnTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUdfColumnTypeOnConflict>;
};

/** on_conflict condition type for table "argo.udf_column_type" */
export type ArgoUdfColumnTypeOnConflict = {
  constraint: ArgoUdfColumnTypeConstraint;
  update_columns?: Array<ArgoUdfColumnTypeUpdateColumn>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};

/** Ordering options when selecting data from "argo.udf_column_type". */
export type ArgoUdfColumnTypeOrderBy = {
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.udf_column_type */
export type ArgoUdfColumnTypePkColumnsInput = {
  /** The type of entity this entry can be linked to */
  type: Scalars['String'];
};

/** select columns of table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "argo.udf_column_type" */
export type ArgoUdfColumnTypeSetInput = {
  /** The description of the udf type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity this entry can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_udf_column_type" */
export type ArgoUdfColumnTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUdfColumnTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUdfColumnTypeStreamCursorValueInput = {
  /** The description of the udf type */
  description?: Maybe<Scalars['String']>;
  /** The type of entity this entry can be linked to */
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type ArgoUdfColumnTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUdfColumnTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUdfColumnTypeBoolExp;
};

/** update columns of table "argo.udf_column" */
export enum ArgoUdfColumnUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required',
  /** column name */
  ValidationUnique = 'validation_unique'
}

export type ArgoUdfColumnUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUdfColumnAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUdfColumnDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUdfColumnDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUdfColumnDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoUdfColumnIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUdfColumnPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUdfColumnSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUdfColumnBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoUdfColumnVarPopFields = {
  __typename?: 'argo_udf_column_var_pop_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.udf_column" */
export type ArgoUdfColumnVarPopOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoUdfColumnVarSampFields = {
  __typename?: 'argo_udf_column_var_samp_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.udf_column" */
export type ArgoUdfColumnVarSampOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoUdfColumnVarianceFields = {
  __typename?: 'argo_udf_column_variance_fields';
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<Scalars['Float']>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<Scalars['Float']>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.udf_column" */
export type ArgoUdfColumnVarianceOrderBy = {
  /** The highest limit expected for a numeric value */
  validation_max?: Maybe<OrderBy>;
  /** The lowest limit expected for a numeric value */
  validation_min?: Maybe<OrderBy>;
  /** The level of uniqueness for occurrence of a value */
  validation_unique?: Maybe<OrderBy>;
};

/** Table to list out all available Unit of Measurements */
export type ArgoUom = {
  __typename?: 'argo_uom';
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['bigint'];
  iso_code?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Table to list out all available Unit of Measurements */
export type ArgoUomMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.uom" */
export type ArgoUomAggregate = {
  __typename?: 'argo_uom_aggregate';
  aggregate?: Maybe<ArgoUomAggregateFields>;
  nodes: Array<ArgoUom>;
};

/** aggregate fields of "argo.uom" */
export type ArgoUomAggregateFields = {
  __typename?: 'argo_uom_aggregate_fields';
  avg?: Maybe<ArgoUomAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoUomMaxFields>;
  min?: Maybe<ArgoUomMinFields>;
  stddev?: Maybe<ArgoUomStddevFields>;
  stddev_pop?: Maybe<ArgoUomStddevPopFields>;
  stddev_samp?: Maybe<ArgoUomStddevSampFields>;
  sum?: Maybe<ArgoUomSumFields>;
  var_pop?: Maybe<ArgoUomVarPopFields>;
  var_samp?: Maybe<ArgoUomVarSampFields>;
  variance?: Maybe<ArgoUomVarianceFields>;
};


/** aggregate fields of "argo.uom" */
export type ArgoUomAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUomSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUomAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoUomAvgFields = {
  __typename?: 'argo_uom_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.uom". All fields are combined with a logical 'AND'. */
export type ArgoUomBoolExp = {
  _and?: Maybe<Array<ArgoUomBoolExp>>;
  _not?: Maybe<ArgoUomBoolExp>;
  _or?: Maybe<Array<ArgoUomBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  dimension?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<BigintComparisonExp>;
  iso_code?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.uom" */
export enum ArgoUomConstraint {
  /** unique or primary key constraint on columns "name_unique" */
  UomEnforceUnique = 'uom_enforce_unique',
  /** unique or primary key constraint on columns "uom_id" */
  UomPkey = 'uom_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUomDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUomDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUomDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.uom" */
export type ArgoUomIncInput = {
  id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "argo.uom" */
export type ArgoUomInsertInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['bigint']>;
  iso_code?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoUomMaxFields = {
  __typename?: 'argo_uom_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  iso_code?: Maybe<Scalars['String']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoUomMinFields = {
  __typename?: 'argo_uom_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  iso_code?: Maybe<Scalars['String']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.uom" */
export type ArgoUomMutationResponse = {
  __typename?: 'argo_uom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUom>;
};

/** input type for inserting object relation for remote table "argo.uom" */
export type ArgoUomObjRelInsertInput = {
  data: ArgoUomInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUomOnConflict>;
};

/** on_conflict condition type for table "argo.uom" */
export type ArgoUomOnConflict = {
  constraint: ArgoUomConstraint;
  update_columns?: Array<ArgoUomUpdateColumn>;
  where?: Maybe<ArgoUomBoolExp>;
};

/** Ordering options when selecting data from "argo.uom". */
export type ArgoUomOrderBy = {
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  dimension?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  iso_code?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.uom */
export type ArgoUomPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUomPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.uom" */
export enum ArgoUomSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.uom" */
export type ArgoUomSetInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['bigint']>;
  iso_code?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoUomStddevFields = {
  __typename?: 'argo_uom_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoUomStddevPopFields = {
  __typename?: 'argo_uom_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoUomStddevSampFields = {
  __typename?: 'argo_uom_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_uom" */
export type ArgoUomStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUomStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUomStreamCursorValueInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['bigint']>;
  iso_code?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoUomSumFields = {
  __typename?: 'argo_uom_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "argo.uom" */
export enum ArgoUomUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoUomUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUomAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUomDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUomDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUomDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoUomIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUomPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUomSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUomBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoUomVarPopFields = {
  __typename?: 'argo_uom_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoUomVarSampFields = {
  __typename?: 'argo_uom_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoUomVarianceFields = {
  __typename?: 'argo_uom_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Argonaut Users */
export type ArgoUser = {
  __typename?: 'argo_user';
  /** An array relationship */
  acls_all_contexts: Array<ArgoVwUserContextAcl>;
  /** An aggregate relationship */
  acls_all_contexts_aggregate: ArgoVwUserContextAclAggregate;
  /** An object relationship */
  auth_provider_local?: Maybe<ArgoAuthProviderLocal>;
  /** An array relationship */
  auth_provider_locals: Array<ArgoAuthProviderLocal>;
  /** An aggregate relationship */
  auth_provider_locals_aggregate: ArgoAuthProviderLocalAggregate;
  /** An array relationship */
  auth_refresh_tokens: Array<ArgoAuthRefreshToken>;
  /** An aggregate relationship */
  auth_refresh_tokens_aggregate: ArgoAuthRefreshTokenAggregate;
  /** An object relationship */
  badge?: Maybe<ArgoUserBadge>;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id: Scalars['uuid'];
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  roles: Array<ArgoVwUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: ArgoVwUserRolesAggregate;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  user_access_tokens: Array<ArgoUserAccessToken>;
  /** An aggregate relationship */
  user_access_tokens_aggregate: ArgoUserAccessTokenAggregate;
  /** An array relationship */
  user_contexts: Array<ArgoUserContext>;
  /** An aggregate relationship */
  user_contexts_aggregate: ArgoUserContextAggregate;
  /** An array relationship */
  user_roles: Array<ArgoUserRole>;
  /** An aggregate relationship */
  user_roles_aggregate: ArgoUserRoleAggregate;
  /** A lowercase unique identifier */
  username: Scalars['String'];
};


/** Argonaut Users */
export type ArgoUserAclsAllContextsArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


/** Argonaut Users */
export type ArgoUserAclsAllContextsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


/** Argonaut Users */
export type ArgoUserAuthProviderLocalsArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


/** Argonaut Users */
export type ArgoUserAuthProviderLocalsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


/** Argonaut Users */
export type ArgoUserAuthRefreshTokensArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Argonaut Users */
export type ArgoUserAuthRefreshTokensAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


/** Argonaut Users */
export type ArgoUserMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Argonaut Users */
export type ArgoUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


/** Argonaut Users */
export type ArgoUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserAccessTokensArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserAccessTokensAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserContextsArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserContextsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


/** Argonaut Users */
export type ArgoUserUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};

/** User Access Token */
export type ArgoUserAccessToken = {
  __typename?: 'argo_user_access_token';
  /** The acls associated with this token */
  acls: Scalars['jsonb'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The human readable token identifier */
  name: Scalars['String'];
  /** An object relationship */
  user: ArgoUser;
  /** The user */
  user_id: Scalars['uuid'];
};


/** User Access Token */
export type ArgoUserAccessTokenAclsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** User Access Token */
export type ArgoUserAccessTokenMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.user_access_token" */
export type ArgoUserAccessTokenAggregate = {
  __typename?: 'argo_user_access_token_aggregate';
  aggregate?: Maybe<ArgoUserAccessTokenAggregateFields>;
  nodes: Array<ArgoUserAccessToken>;
};

export type ArgoUserAccessTokenAggregateBoolExp = {
  count?: Maybe<ArgoUserAccessTokenAggregateBoolExpCount>;
};

export type ArgoUserAccessTokenAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUserAccessTokenBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.user_access_token" */
export type ArgoUserAccessTokenAggregateFields = {
  __typename?: 'argo_user_access_token_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUserAccessTokenMaxFields>;
  min?: Maybe<ArgoUserAccessTokenMinFields>;
};


/** aggregate fields of "argo.user_access_token" */
export type ArgoUserAccessTokenAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.user_access_token" */
export type ArgoUserAccessTokenAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoUserAccessTokenMaxOrderBy>;
  min?: Maybe<ArgoUserAccessTokenMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserAccessTokenAppendInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.user_access_token" */
export type ArgoUserAccessTokenArrRelInsertInput = {
  data: Array<ArgoUserAccessTokenInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUserAccessTokenOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.user_access_token". All fields are combined with a logical 'AND'. */
export type ArgoUserAccessTokenBoolExp = {
  _and?: Maybe<Array<ArgoUserAccessTokenBoolExp>>;
  _not?: Maybe<ArgoUserAccessTokenBoolExp>;
  _or?: Maybe<Array<ArgoUserAccessTokenBoolExp>>;
  acls?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.user_access_token" */
export enum ArgoUserAccessTokenConstraint {
  /** unique or primary key constraint on columns "user_access_token_id" */
  UserAccessTokenPkey = 'user_access_token_pkey',
  /** unique or primary key constraint on columns "context_id", "user_id", "name" */
  UserAccessTokenUserIdNameKey = 'user_access_token_user_id_name_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUserAccessTokenDeleteAtPathInput = {
  /** The acls associated with this token */
  acls?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUserAccessTokenDeleteElemInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUserAccessTokenDeleteKeyInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.user_access_token" */
export type ArgoUserAccessTokenInsertInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The human readable token identifier */
  name?: Maybe<Scalars['String']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoUserAccessTokenMaxFields = {
  __typename?: 'argo_user_access_token_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The human readable token identifier */
  name?: Maybe<Scalars['String']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.user_access_token" */
export type ArgoUserAccessTokenMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The human readable token identifier */
  name?: Maybe<OrderBy>;
  /** The user */
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoUserAccessTokenMinFields = {
  __typename?: 'argo_user_access_token_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The human readable token identifier */
  name?: Maybe<Scalars['String']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.user_access_token" */
export type ArgoUserAccessTokenMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The human readable token identifier */
  name?: Maybe<OrderBy>;
  /** The user */
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.user_access_token" */
export type ArgoUserAccessTokenMutationResponse = {
  __typename?: 'argo_user_access_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUserAccessToken>;
};

/** on_conflict condition type for table "argo.user_access_token" */
export type ArgoUserAccessTokenOnConflict = {
  constraint: ArgoUserAccessTokenConstraint;
  update_columns?: Array<ArgoUserAccessTokenUpdateColumn>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};

/** Ordering options when selecting data from "argo.user_access_token". */
export type ArgoUserAccessTokenOrderBy = {
  acls?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.user_access_token */
export type ArgoUserAccessTokenPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserAccessTokenPrependInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.user_access_token" */
export enum ArgoUserAccessTokenSelectColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.user_access_token" */
export type ArgoUserAccessTokenSetInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The human readable token identifier */
  name?: Maybe<Scalars['String']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_user_access_token" */
export type ArgoUserAccessTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUserAccessTokenStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUserAccessTokenStreamCursorValueInput = {
  /** The acls associated with this token */
  acls?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The human readable token identifier */
  name?: Maybe<Scalars['String']>;
  /** The user */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.user_access_token" */
export enum ArgoUserAccessTokenUpdateColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

export type ArgoUserAccessTokenUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUserAccessTokenAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUserAccessTokenDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUserAccessTokenDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUserAccessTokenDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUserAccessTokenPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUserAccessTokenSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUserAccessTokenBoolExp;
};

/** aggregated selection of "argo.user" */
export type ArgoUserAggregate = {
  __typename?: 'argo_user_aggregate';
  aggregate?: Maybe<ArgoUserAggregateFields>;
  nodes: Array<ArgoUser>;
};

/** aggregate fields of "argo.user" */
export type ArgoUserAggregateFields = {
  __typename?: 'argo_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUserMaxFields>;
  min?: Maybe<ArgoUserMinFields>;
};


/** aggregate fields of "argo.user" */
export type ArgoUserAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** User Badge for active operator authentication */
export type ArgoUserBadge = {
  __typename?: 'argo_user_badge';
  /** The badge identifier scanned by USB HID or similar */
  badge_id: Scalars['String'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** The primary key */
  id: Scalars['uuid'];
  /** When this entry was last updated */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: ArgoUser;
  /** The user this badge belongs to */
  user_id: Scalars['uuid'];
};

/** aggregated selection of "argo.user_badge" */
export type ArgoUserBadgeAggregate = {
  __typename?: 'argo_user_badge_aggregate';
  aggregate?: Maybe<ArgoUserBadgeAggregateFields>;
  nodes: Array<ArgoUserBadge>;
};

/** aggregate fields of "argo.user_badge" */
export type ArgoUserBadgeAggregateFields = {
  __typename?: 'argo_user_badge_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUserBadgeMaxFields>;
  min?: Maybe<ArgoUserBadgeMinFields>;
};


/** aggregate fields of "argo.user_badge" */
export type ArgoUserBadgeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUserBadgeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.user_badge". All fields are combined with a logical 'AND'. */
export type ArgoUserBadgeBoolExp = {
  _and?: Maybe<Array<ArgoUserBadgeBoolExp>>;
  _not?: Maybe<ArgoUserBadgeBoolExp>;
  _or?: Maybe<Array<ArgoUserBadgeBoolExp>>;
  badge_id?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.user_badge" */
export enum ArgoUserBadgeConstraint {
  /** unique or primary key constraint on columns "user_badge_id" */
  UserBadgePkey = 'user_badge_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserBadgeUserIdKey = 'user_badge_user_id_key'
}

/** input type for inserting data into table "argo.user_badge" */
export type ArgoUserBadgeInsertInput = {
  /** The badge identifier scanned by USB HID or similar */
  badge_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user this badge belongs to */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoUserBadgeMaxFields = {
  __typename?: 'argo_user_badge_max_fields';
  /** The badge identifier scanned by USB HID or similar */
  badge_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user this badge belongs to */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoUserBadgeMinFields = {
  __typename?: 'argo_user_badge_min_fields';
  /** The badge identifier scanned by USB HID or similar */
  badge_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user this badge belongs to */
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.user_badge" */
export type ArgoUserBadgeMutationResponse = {
  __typename?: 'argo_user_badge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUserBadge>;
};

/** input type for inserting object relation for remote table "argo.user_badge" */
export type ArgoUserBadgeObjRelInsertInput = {
  data: ArgoUserBadgeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUserBadgeOnConflict>;
};

/** on_conflict condition type for table "argo.user_badge" */
export type ArgoUserBadgeOnConflict = {
  constraint: ArgoUserBadgeConstraint;
  update_columns?: Array<ArgoUserBadgeUpdateColumn>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};

/** Ordering options when selecting data from "argo.user_badge". */
export type ArgoUserBadgeOrderBy = {
  badge_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.user_badge */
export type ArgoUserBadgePkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** select columns of table "argo.user_badge" */
export enum ArgoUserBadgeSelectColumn {
  /** column name */
  BadgeId = 'badge_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.user_badge" */
export type ArgoUserBadgeSetInput = {
  /** The badge identifier scanned by USB HID or similar */
  badge_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user this badge belongs to */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_user_badge" */
export type ArgoUserBadgeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUserBadgeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUserBadgeStreamCursorValueInput = {
  /** The badge identifier scanned by USB HID or similar */
  badge_id?: Maybe<Scalars['String']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user this badge belongs to */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.user_badge" */
export enum ArgoUserBadgeUpdateColumn {
  /** column name */
  BadgeId = 'badge_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type ArgoUserBadgeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUserBadgeSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUserBadgeBoolExp;
};

/** Boolean expression to filter rows from the table "argo.user". All fields are combined with a logical 'AND'. */
export type ArgoUserBoolExp = {
  _and?: Maybe<Array<ArgoUserBoolExp>>;
  _not?: Maybe<ArgoUserBoolExp>;
  _or?: Maybe<Array<ArgoUserBoolExp>>;
  acls_all_contexts?: Maybe<ArgoVwUserContextAclBoolExp>;
  acls_all_contexts_aggregate?: Maybe<ArgoVwUserContextAclAggregateBoolExp>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalBoolExp>;
  auth_provider_locals?: Maybe<ArgoAuthProviderLocalBoolExp>;
  auth_provider_locals_aggregate?: Maybe<ArgoAuthProviderLocalAggregateBoolExp>;
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenBoolExp>;
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateBoolExp>;
  badge?: Maybe<ArgoUserBadgeBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  first_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  last_name?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  profile_file_id?: Maybe<UuidComparisonExp>;
  roles?: Maybe<ArgoVwUserRolesBoolExp>;
  roles_aggregate?: Maybe<ArgoVwUserRolesAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  user_access_tokens?: Maybe<ArgoUserAccessTokenBoolExp>;
  user_access_tokens_aggregate?: Maybe<ArgoUserAccessTokenAggregateBoolExp>;
  user_contexts?: Maybe<ArgoUserContextBoolExp>;
  user_contexts_aggregate?: Maybe<ArgoUserContextAggregateBoolExp>;
  user_roles?: Maybe<ArgoUserRoleBoolExp>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateBoolExp>;
  username?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.user" */
export enum ArgoUserConstraint {
  /** unique or primary key constraint on columns "user_id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "username" */
  UserUsernameKey = 'user_username_key'
}

/** Argonaut User Contexts define the contexts for which a user is a memeber */
export type ArgoUserContext = {
  __typename?: 'argo_user_context';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  user: ArgoUser;
  /** The user for this entry */
  user_id: Scalars['uuid'];
};


/** Argonaut User Contexts define the contexts for which a user is a memeber */
export type ArgoUserContextMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.user_context" */
export type ArgoUserContextAggregate = {
  __typename?: 'argo_user_context_aggregate';
  aggregate?: Maybe<ArgoUserContextAggregateFields>;
  nodes: Array<ArgoUserContext>;
};

export type ArgoUserContextAggregateBoolExp = {
  count?: Maybe<ArgoUserContextAggregateBoolExpCount>;
};

export type ArgoUserContextAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoUserContextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUserContextBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.user_context" */
export type ArgoUserContextAggregateFields = {
  __typename?: 'argo_user_context_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUserContextMaxFields>;
  min?: Maybe<ArgoUserContextMinFields>;
};


/** aggregate fields of "argo.user_context" */
export type ArgoUserContextAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUserContextSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.user_context" */
export type ArgoUserContextAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoUserContextMaxOrderBy>;
  min?: Maybe<ArgoUserContextMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserContextAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.user_context" */
export type ArgoUserContextArrRelInsertInput = {
  data: Array<ArgoUserContextInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUserContextOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.user_context". All fields are combined with a logical 'AND'. */
export type ArgoUserContextBoolExp = {
  _and?: Maybe<Array<ArgoUserContextBoolExp>>;
  _not?: Maybe<ArgoUserContextBoolExp>;
  _or?: Maybe<Array<ArgoUserContextBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.user_context" */
export enum ArgoUserContextConstraint {
  /** unique or primary key constraint on columns "user_context_id" */
  UserContextPkey = 'user_context_pkey',
  /** unique or primary key constraint on columns "context_id", "user_id" */
  UserContextUserIdContextIdKey = 'user_context_user_id_context_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUserContextDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUserContextDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUserContextDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.user_context" */
export type ArgoUserContextInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user for this entry */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoUserContextMaxFields = {
  __typename?: 'argo_user_context_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The user for this entry */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.user_context" */
export type ArgoUserContextMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The user for this entry */
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoUserContextMinFields = {
  __typename?: 'argo_user_context_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The user for this entry */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.user_context" */
export type ArgoUserContextMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The user for this entry */
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.user_context" */
export type ArgoUserContextMutationResponse = {
  __typename?: 'argo_user_context_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUserContext>;
};

/** on_conflict condition type for table "argo.user_context" */
export type ArgoUserContextOnConflict = {
  constraint: ArgoUserContextConstraint;
  update_columns?: Array<ArgoUserContextUpdateColumn>;
  where?: Maybe<ArgoUserContextBoolExp>;
};

/** Ordering options when selecting data from "argo.user_context". */
export type ArgoUserContextOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.user_context */
export type ArgoUserContextPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserContextPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.user_context" */
export enum ArgoUserContextSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.user_context" */
export type ArgoUserContextSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The user for this entry */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_user_context" */
export type ArgoUserContextStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUserContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUserContextStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The user for this entry */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.user_context" */
export enum ArgoUserContextUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UserId = 'user_id'
}

export type ArgoUserContextUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUserContextAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUserContextDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUserContextDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUserContextDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUserContextPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUserContextSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUserContextBoolExp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUserDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUserDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUserDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.user" */
export type ArgoUserInsertInput = {
  acls_all_contexts?: Maybe<ArgoVwUserContextAclArrRelInsertInput>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalObjRelInsertInput>;
  auth_provider_locals?: Maybe<ArgoAuthProviderLocalArrRelInsertInput>;
  auth_refresh_tokens?: Maybe<ArgoAuthRefreshTokenArrRelInsertInput>;
  badge?: Maybe<ArgoUserBadgeObjRelInsertInput>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  roles?: Maybe<ArgoVwUserRolesArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_access_tokens?: Maybe<ArgoUserAccessTokenArrRelInsertInput>;
  user_contexts?: Maybe<ArgoUserContextArrRelInsertInput>;
  user_roles?: Maybe<ArgoUserRoleArrRelInsertInput>;
  /** A lowercase unique identifier */
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoUserMaxFields = {
  __typename?: 'argo_user_max_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** A lowercase unique identifier */
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoUserMinFields = {
  __typename?: 'argo_user_min_fields';
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** A lowercase unique identifier */
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.user" */
export type ArgoUserMutationResponse = {
  __typename?: 'argo_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUser>;
};

/** input type for inserting object relation for remote table "argo.user" */
export type ArgoUserObjRelInsertInput = {
  data: ArgoUserInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUserOnConflict>;
};

/** on_conflict condition type for table "argo.user" */
export type ArgoUserOnConflict = {
  constraint: ArgoUserConstraint;
  update_columns?: Array<ArgoUserUpdateColumn>;
  where?: Maybe<ArgoUserBoolExp>;
};

/** Ordering options when selecting data from "argo.user". */
export type ArgoUserOrderBy = {
  acls_all_contexts_aggregate?: Maybe<ArgoVwUserContextAclAggregateOrderBy>;
  auth_provider_local?: Maybe<ArgoAuthProviderLocalOrderBy>;
  auth_provider_locals_aggregate?: Maybe<ArgoAuthProviderLocalAggregateOrderBy>;
  auth_refresh_tokens_aggregate?: Maybe<ArgoAuthRefreshTokenAggregateOrderBy>;
  badge?: Maybe<ArgoUserBadgeOrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  first_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_name?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  profile_file_id?: Maybe<OrderBy>;
  roles_aggregate?: Maybe<ArgoVwUserRolesAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user_access_tokens_aggregate?: Maybe<ArgoUserAccessTokenAggregateOrderBy>;
  user_contexts_aggregate?: Maybe<ArgoUserContextAggregateOrderBy>;
  user_roles_aggregate?: Maybe<ArgoUserRoleAggregateOrderBy>;
  username?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.user */
export type ArgoUserPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Defines which users are assigned to which Roles */
export type ArgoUserRole = {
  __typename?: 'argo_user_role';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An object relationship */
  role: ArgoRole;
  /** The role this entry is referencing */
  role_id: Scalars['uuid'];
  /** An object relationship */
  user: ArgoUser;
  /** The user this entry is referencing */
  user_id: Scalars['uuid'];
};


/** Defines which users are assigned to which Roles */
export type ArgoUserRoleMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.user_role" */
export type ArgoUserRoleAggregate = {
  __typename?: 'argo_user_role_aggregate';
  aggregate?: Maybe<ArgoUserRoleAggregateFields>;
  nodes: Array<ArgoUserRole>;
};

export type ArgoUserRoleAggregateBoolExp = {
  count?: Maybe<ArgoUserRoleAggregateBoolExpCount>;
};

export type ArgoUserRoleAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoUserRoleBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.user_role" */
export type ArgoUserRoleAggregateFields = {
  __typename?: 'argo_user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoUserRoleMaxFields>;
  min?: Maybe<ArgoUserRoleMinFields>;
};


/** aggregate fields of "argo.user_role" */
export type ArgoUserRoleAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.user_role" */
export type ArgoUserRoleAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoUserRoleMaxOrderBy>;
  min?: Maybe<ArgoUserRoleMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserRoleAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.user_role" */
export type ArgoUserRoleArrRelInsertInput = {
  data: Array<ArgoUserRoleInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoUserRoleOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.user_role". All fields are combined with a logical 'AND'. */
export type ArgoUserRoleBoolExp = {
  _and?: Maybe<Array<ArgoUserRoleBoolExp>>;
  _not?: Maybe<ArgoUserRoleBoolExp>;
  _or?: Maybe<Array<ArgoUserRoleBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  role?: Maybe<ArgoRoleBoolExp>;
  role_id?: Maybe<UuidComparisonExp>;
  user?: Maybe<ArgoUserBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.user_role" */
export enum ArgoUserRoleConstraint {
  /** unique or primary key constraint on columns "role_id", "context_id", "user_id" */
  UserRoleContextIdUserIdRoleIdKey = 'user_role_context_id_user_id_role_id_key',
  /** unique or primary key constraint on columns "user_role_id" */
  UserRolePkey = 'user_role_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoUserRoleDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoUserRoleDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoUserRoleDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.user_role" */
export type ArgoUserRoleInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  role?: Maybe<ArgoRoleObjRelInsertInput>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
  user?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user this entry is referencing */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoUserRoleMaxFields = {
  __typename?: 'argo_user_role_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
  /** The user this entry is referencing */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.user_role" */
export type ArgoUserRoleMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The role this entry is referencing */
  role_id?: Maybe<OrderBy>;
  /** The user this entry is referencing */
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoUserRoleMinFields = {
  __typename?: 'argo_user_role_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
  /** The user this entry is referencing */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.user_role" */
export type ArgoUserRoleMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The role this entry is referencing */
  role_id?: Maybe<OrderBy>;
  /** The user this entry is referencing */
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.user_role" */
export type ArgoUserRoleMutationResponse = {
  __typename?: 'argo_user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoUserRole>;
};

/** on_conflict condition type for table "argo.user_role" */
export type ArgoUserRoleOnConflict = {
  constraint: ArgoUserRoleConstraint;
  update_columns?: Array<ArgoUserRoleUpdateColumn>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};

/** Ordering options when selecting data from "argo.user_role". */
export type ArgoUserRoleOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  role?: Maybe<ArgoRoleOrderBy>;
  role_id?: Maybe<OrderBy>;
  user?: Maybe<ArgoUserOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.user_role */
export type ArgoUserRolePkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoUserRolePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.user_role" */
export enum ArgoUserRoleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "argo.user_role" */
export type ArgoUserRoleSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
  /** The user this entry is referencing */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_user_role" */
export type ArgoUserRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUserRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUserRoleStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The role this entry is referencing */
  role_id?: Maybe<Scalars['uuid']>;
  /** The user this entry is referencing */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.user_role" */
export enum ArgoUserRoleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

export type ArgoUserRoleUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUserRoleAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUserRoleDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUserRoleDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUserRoleDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUserRolePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUserRoleSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUserRoleBoolExp;
};

/** select columns of table "argo.user" */
export enum ArgoUserSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "argo.user" */
export type ArgoUserSetInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** A lowercase unique identifier */
  username?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_user" */
export type ArgoUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoUserStreamCursorValueInput = {
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** A description */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The first name */
  first_name?: Maybe<Scalars['String']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The last name */
  last_name?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  profile_file_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user that last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** A lowercase unique identifier */
  username?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.user" */
export enum ArgoUserUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

export type ArgoUserUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoUserAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoUserDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoUserDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoUserDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoUserPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoUserSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoUserBoolExp;
};

/** columns and relationships of "argo.vw_acl_role" */
export type ArgoVwAclRole = {
  __typename?: 'argo_vw_acl_role';
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_acl_role" */
export type ArgoVwAclRoleMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_acl_role" */
export type ArgoVwAclRoleAggregate = {
  __typename?: 'argo_vw_acl_role_aggregate';
  aggregate?: Maybe<ArgoVwAclRoleAggregateFields>;
  nodes: Array<ArgoVwAclRole>;
};

/** aggregate fields of "argo.vw_acl_role" */
export type ArgoVwAclRoleAggregateFields = {
  __typename?: 'argo_vw_acl_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwAclRoleMaxFields>;
  min?: Maybe<ArgoVwAclRoleMinFields>;
};


/** aggregate fields of "argo.vw_acl_role" */
export type ArgoVwAclRoleAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwAclRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_acl_role". All fields are combined with a logical 'AND'. */
export type ArgoVwAclRoleBoolExp = {
  _and?: Maybe<Array<ArgoVwAclRoleBoolExp>>;
  _not?: Maybe<ArgoVwAclRoleBoolExp>;
  _or?: Maybe<Array<ArgoVwAclRoleBoolExp>>;
  acl_id?: Maybe<StringComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type ArgoVwAclRoleMaxFields = {
  __typename?: 'argo_vw_acl_role_max_fields';
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoVwAclRoleMinFields = {
  __typename?: 'argo_vw_acl_role_min_fields';
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "argo.vw_acl_role". */
export type ArgoVwAclRoleOrderBy = {
  acl_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_acl_role" */
export enum ArgoVwAclRoleSelectColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** Streaming cursor of the table "argo_vw_acl_role" */
export type ArgoVwAclRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwAclRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwAclRoleStreamCursorValueInput = {
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_active_location_calendar" */
export type ArgoVwActiveLocationCalendar = {
  __typename?: 'argo_vw_active_location_calendar';
  /** An object relationship */
  active_calendar?: Maybe<ArgoCalendar>;
  active_calendar_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  context_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  default_calendar?: Maybe<ArgoCalendar>;
  default_calendar_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  location?: Maybe<ArgoLocation>;
  location_id?: Maybe<Scalars['uuid']>;
  query_time?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "argo.vw_active_location_calendar" */
export type ArgoVwActiveLocationCalendarAggregate = {
  __typename?: 'argo_vw_active_location_calendar_aggregate';
  aggregate?: Maybe<ArgoVwActiveLocationCalendarAggregateFields>;
  nodes: Array<ArgoVwActiveLocationCalendar>;
};

/** aggregate fields of "argo.vw_active_location_calendar" */
export type ArgoVwActiveLocationCalendarAggregateFields = {
  __typename?: 'argo_vw_active_location_calendar_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwActiveLocationCalendarMaxFields>;
  min?: Maybe<ArgoVwActiveLocationCalendarMinFields>;
};


/** aggregate fields of "argo.vw_active_location_calendar" */
export type ArgoVwActiveLocationCalendarAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwActiveLocationCalendarSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_active_location_calendar". All fields are combined with a logical 'AND'. */
export type ArgoVwActiveLocationCalendarBoolExp = {
  _and?: Maybe<Array<ArgoVwActiveLocationCalendarBoolExp>>;
  _not?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
  _or?: Maybe<Array<ArgoVwActiveLocationCalendarBoolExp>>;
  active_calendar?: Maybe<ArgoCalendarBoolExp>;
  active_calendar_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  default_calendar?: Maybe<ArgoCalendarBoolExp>;
  default_calendar_id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  query_time?: Maybe<TimestampComparisonExp>;
};

/** aggregate max on columns */
export type ArgoVwActiveLocationCalendarMaxFields = {
  __typename?: 'argo_vw_active_location_calendar_max_fields';
  active_calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  default_calendar_id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  query_time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type ArgoVwActiveLocationCalendarMinFields = {
  __typename?: 'argo_vw_active_location_calendar_min_fields';
  active_calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  default_calendar_id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  query_time?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "argo.vw_active_location_calendar". */
export type ArgoVwActiveLocationCalendarOrderBy = {
  active_calendar?: Maybe<ArgoCalendarOrderBy>;
  active_calendar_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  default_calendar?: Maybe<ArgoCalendarOrderBy>;
  default_calendar_id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  query_time?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_active_location_calendar" */
export enum ArgoVwActiveLocationCalendarSelectColumn {
  /** column name */
  ActiveCalendarId = 'active_calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultCalendarId = 'default_calendar_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  QueryTime = 'query_time'
}

/** Streaming cursor of the table "argo_vw_active_location_calendar" */
export type ArgoVwActiveLocationCalendarStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwActiveLocationCalendarStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwActiveLocationCalendarStreamCursorValueInput = {
  active_calendar_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  default_calendar_id?: Maybe<Scalars['uuid']>;
  location_id?: Maybe<Scalars['uuid']>;
  query_time?: Maybe<Scalars['timestamp']>;
};

/** columns and relationships of "argo.vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessToken = {
  __typename?: 'argo_vw_auth_user_access_token';
  acls?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  user_access_token_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessTokenAclsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessTokenAggregate = {
  __typename?: 'argo_vw_auth_user_access_token_aggregate';
  aggregate?: Maybe<ArgoVwAuthUserAccessTokenAggregateFields>;
  nodes: Array<ArgoVwAuthUserAccessToken>;
};

/** aggregate fields of "argo.vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessTokenAggregateFields = {
  __typename?: 'argo_vw_auth_user_access_token_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwAuthUserAccessTokenMaxFields>;
  min?: Maybe<ArgoVwAuthUserAccessTokenMinFields>;
};


/** aggregate fields of "argo.vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessTokenAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwAuthUserAccessTokenSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_auth_user_access_token". All fields are combined with a logical 'AND'. */
export type ArgoVwAuthUserAccessTokenBoolExp = {
  _and?: Maybe<Array<ArgoVwAuthUserAccessTokenBoolExp>>;
  _not?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
  _or?: Maybe<Array<ArgoVwAuthUserAccessTokenBoolExp>>;
  acls?: Maybe<JsonbComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  user_access_token_id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type ArgoVwAuthUserAccessTokenMaxFields = {
  __typename?: 'argo_vw_auth_user_access_token_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  user_access_token_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoVwAuthUserAccessTokenMinFields = {
  __typename?: 'argo_vw_auth_user_access_token_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  user_access_token_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "argo.vw_auth_user_access_token". */
export type ArgoVwAuthUserAccessTokenOrderBy = {
  acls?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  user_access_token_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_auth_user_access_token" */
export enum ArgoVwAuthUserAccessTokenSelectColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  UserAccessTokenId = 'user_access_token_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "argo_vw_auth_user_access_token" */
export type ArgoVwAuthUserAccessTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwAuthUserAccessTokenStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwAuthUserAccessTokenStreamCursorValueInput = {
  acls?: Maybe<Scalars['jsonb']>;
  context_id?: Maybe<Scalars['uuid']>;
  user_access_token_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumn = {
  __typename?: 'argo_vw_event_type_udf_column';
  event_type_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnAggregate = {
  __typename?: 'argo_vw_event_type_udf_column_aggregate';
  aggregate?: Maybe<ArgoVwEventTypeUdfColumnAggregateFields>;
  nodes: Array<ArgoVwEventTypeUdfColumn>;
};

/** aggregate fields of "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnAggregateFields = {
  __typename?: 'argo_vw_event_type_udf_column_aggregate_fields';
  avg?: Maybe<ArgoVwEventTypeUdfColumnAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoVwEventTypeUdfColumnMaxFields>;
  min?: Maybe<ArgoVwEventTypeUdfColumnMinFields>;
  stddev?: Maybe<ArgoVwEventTypeUdfColumnStddevFields>;
  stddev_pop?: Maybe<ArgoVwEventTypeUdfColumnStddevPopFields>;
  stddev_samp?: Maybe<ArgoVwEventTypeUdfColumnStddevSampFields>;
  sum?: Maybe<ArgoVwEventTypeUdfColumnSumFields>;
  var_pop?: Maybe<ArgoVwEventTypeUdfColumnVarPopFields>;
  var_samp?: Maybe<ArgoVwEventTypeUdfColumnVarSampFields>;
  variance?: Maybe<ArgoVwEventTypeUdfColumnVarianceFields>;
};


/** aggregate fields of "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwEventTypeUdfColumnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ArgoVwEventTypeUdfColumnAvgFields = {
  __typename?: 'argo_vw_event_type_udf_column_avg_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.vw_event_type_udf_column". All fields are combined with a logical 'AND'. */
export type ArgoVwEventTypeUdfColumnBoolExp = {
  _and?: Maybe<Array<ArgoVwEventTypeUdfColumnBoolExp>>;
  _not?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
  _or?: Maybe<Array<ArgoVwEventTypeUdfColumnBoolExp>>;
  event_type_id?: Maybe<BigintComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnInsertInput = {
  event_type_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwEventTypeUdfColumnMaxFields = {
  __typename?: 'argo_vw_event_type_udf_column_max_fields';
  event_type_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoVwEventTypeUdfColumnMinFields = {
  __typename?: 'argo_vw_event_type_udf_column_min_fields';
  event_type_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "argo.vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnObjRelInsertInput = {
  data: ArgoVwEventTypeUdfColumnInsertInput;
};

/** Ordering options when selecting data from "argo.vw_event_type_udf_column". */
export type ArgoVwEventTypeUdfColumnOrderBy = {
  event_type_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  udf_column_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_event_type_udf_column" */
export enum ArgoVwEventTypeUdfColumnSelectColumn {
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UdfColumnId = 'udf_column_id'
}

/** aggregate stddev on columns */
export type ArgoVwEventTypeUdfColumnStddevFields = {
  __typename?: 'argo_vw_event_type_udf_column_stddev_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoVwEventTypeUdfColumnStddevPopFields = {
  __typename?: 'argo_vw_event_type_udf_column_stddev_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoVwEventTypeUdfColumnStddevSampFields = {
  __typename?: 'argo_vw_event_type_udf_column_stddev_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_vw_event_type_udf_column" */
export type ArgoVwEventTypeUdfColumnStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwEventTypeUdfColumnStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwEventTypeUdfColumnStreamCursorValueInput = {
  event_type_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoVwEventTypeUdfColumnSumFields = {
  __typename?: 'argo_vw_event_type_udf_column_sum_fields';
  event_type_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ArgoVwEventTypeUdfColumnVarPopFields = {
  __typename?: 'argo_vw_event_type_udf_column_var_pop_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoVwEventTypeUdfColumnVarSampFields = {
  __typename?: 'argo_vw_event_type_udf_column_var_samp_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoVwEventTypeUdfColumnVarianceFields = {
  __typename?: 'argo_vw_event_type_udf_column_variance_fields';
  event_type_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchy = {
  __typename?: 'argo_vw_location_hierarchy';
  /** An object relationship */
  child_location?: Maybe<ArgoLocation>;
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  parentName?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_location?: Maybe<ArgoLocation>;
};

/** aggregated selection of "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyAggregate = {
  __typename?: 'argo_vw_location_hierarchy_aggregate';
  aggregate?: Maybe<ArgoVwLocationHierarchyAggregateFields>;
  nodes: Array<ArgoVwLocationHierarchy>;
};

export type ArgoVwLocationHierarchyAggregateBoolExp = {
  count?: Maybe<ArgoVwLocationHierarchyAggregateBoolExpCount>;
};

export type ArgoVwLocationHierarchyAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwLocationHierarchyBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyAggregateFields = {
  __typename?: 'argo_vw_location_hierarchy_aggregate_fields';
  avg?: Maybe<ArgoVwLocationHierarchyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoVwLocationHierarchyMaxFields>;
  min?: Maybe<ArgoVwLocationHierarchyMinFields>;
  stddev?: Maybe<ArgoVwLocationHierarchyStddevFields>;
  stddev_pop?: Maybe<ArgoVwLocationHierarchyStddevPopFields>;
  stddev_samp?: Maybe<ArgoVwLocationHierarchyStddevSampFields>;
  sum?: Maybe<ArgoVwLocationHierarchySumFields>;
  var_pop?: Maybe<ArgoVwLocationHierarchyVarPopFields>;
  var_samp?: Maybe<ArgoVwLocationHierarchyVarSampFields>;
  variance?: Maybe<ArgoVwLocationHierarchyVarianceFields>;
};


/** aggregate fields of "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyAggregateOrderBy = {
  avg?: Maybe<ArgoVwLocationHierarchyAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoVwLocationHierarchyMaxOrderBy>;
  min?: Maybe<ArgoVwLocationHierarchyMinOrderBy>;
  stddev?: Maybe<ArgoVwLocationHierarchyStddevOrderBy>;
  stddev_pop?: Maybe<ArgoVwLocationHierarchyStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoVwLocationHierarchyStddevSampOrderBy>;
  sum?: Maybe<ArgoVwLocationHierarchySumOrderBy>;
  var_pop?: Maybe<ArgoVwLocationHierarchyVarPopOrderBy>;
  var_samp?: Maybe<ArgoVwLocationHierarchyVarSampOrderBy>;
  variance?: Maybe<ArgoVwLocationHierarchyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyArrRelInsertInput = {
  data: Array<ArgoVwLocationHierarchyInsertInput>;
};

/** aggregate avg on columns */
export type ArgoVwLocationHierarchyAvgFields = {
  __typename?: 'argo_vw_location_hierarchy_avg_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyAvgOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.vw_location_hierarchy". All fields are combined with a logical 'AND'. */
export type ArgoVwLocationHierarchyBoolExp = {
  _and?: Maybe<Array<ArgoVwLocationHierarchyBoolExp>>;
  _not?: Maybe<ArgoVwLocationHierarchyBoolExp>;
  _or?: Maybe<Array<ArgoVwLocationHierarchyBoolExp>>;
  child_location?: Maybe<ArgoLocationBoolExp>;
  depth?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  parentId?: Maybe<UuidComparisonExp>;
  parentName?: Maybe<StringComparisonExp>;
  parent_location?: Maybe<ArgoLocationBoolExp>;
};

/** input type for inserting data into table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyInsertInput = {
  child_location?: Maybe<ArgoLocationObjRelInsertInput>;
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  parentName?: Maybe<Scalars['String']>;
  parent_location?: Maybe<ArgoLocationObjRelInsertInput>;
};

/** aggregate max on columns */
export type ArgoVwLocationHierarchyMaxFields = {
  __typename?: 'argo_vw_location_hierarchy_max_fields';
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  parentName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyMaxOrderBy = {
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parentId?: Maybe<OrderBy>;
  parentName?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoVwLocationHierarchyMinFields = {
  __typename?: 'argo_vw_location_hierarchy_min_fields';
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  parentName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyMinOrderBy = {
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parentId?: Maybe<OrderBy>;
  parentName?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "argo.vw_location_hierarchy". */
export type ArgoVwLocationHierarchyOrderBy = {
  child_location?: Maybe<ArgoLocationOrderBy>;
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  parentId?: Maybe<OrderBy>;
  parentName?: Maybe<OrderBy>;
  parent_location?: Maybe<ArgoLocationOrderBy>;
};

/** select columns of table "argo.vw_location_hierarchy" */
export enum ArgoVwLocationHierarchySelectColumn {
  /** column name */
  Depth = 'depth',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ParentName = 'parentName'
}

/** aggregate stddev on columns */
export type ArgoVwLocationHierarchyStddevFields = {
  __typename?: 'argo_vw_location_hierarchy_stddev_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyStddevOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoVwLocationHierarchyStddevPopFields = {
  __typename?: 'argo_vw_location_hierarchy_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyStddevPopOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoVwLocationHierarchyStddevSampFields = {
  __typename?: 'argo_vw_location_hierarchy_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyStddevSampOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_vw_location_hierarchy" */
export type ArgoVwLocationHierarchyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwLocationHierarchyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwLocationHierarchyStreamCursorValueInput = {
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  parentName?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ArgoVwLocationHierarchySumFields = {
  __typename?: 'argo_vw_location_hierarchy_sum_fields';
  depth?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchySumOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ArgoVwLocationHierarchyVarPopFields = {
  __typename?: 'argo_vw_location_hierarchy_var_pop_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyVarPopOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoVwLocationHierarchyVarSampFields = {
  __typename?: 'argo_vw_location_hierarchy_var_samp_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyVarSampOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoVwLocationHierarchyVarianceFields = {
  __typename?: 'argo_vw_location_hierarchy_variance_fields';
  depth?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.vw_location_hierarchy" */
export type ArgoVwLocationHierarchyVarianceOrderBy = {
  depth?: Maybe<OrderBy>;
};

/** columns and relationships of "argo.vw_material_by_class" */
export type ArgoVwMaterialByClass = {
  __typename?: 'argo_vw_material_by_class';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  serial_number?: Maybe<Scalars['String']>;
  serial_number_active?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassAggregate = {
  __typename?: 'argo_vw_material_by_class_aggregate';
  aggregate?: Maybe<ArgoVwMaterialByClassAggregateFields>;
  nodes: Array<ArgoVwMaterialByClass>;
};

export type ArgoVwMaterialByClassAggregateBoolExp = {
  bool_and?: Maybe<ArgoVwMaterialByClassAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoVwMaterialByClassAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoVwMaterialByClassAggregateBoolExpCount>;
};

export type ArgoVwMaterialByClassAggregateBoolExpBoolAnd = {
  arguments: ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwMaterialByClassBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoVwMaterialByClassAggregateBoolExpBoolOr = {
  arguments: ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwMaterialByClassBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoVwMaterialByClassAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwMaterialByClassBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassAggregateFields = {
  __typename?: 'argo_vw_material_by_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwMaterialByClassMaxFields>;
  min?: Maybe<ArgoVwMaterialByClassMinFields>;
};


/** aggregate fields of "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoVwMaterialByClassMaxOrderBy>;
  min?: Maybe<ArgoVwMaterialByClassMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassArrRelInsertInput = {
  data: Array<ArgoVwMaterialByClassInsertInput>;
};

/** Boolean expression to filter rows from the table "argo.vw_material_by_class". All fields are combined with a logical 'AND'. */
export type ArgoVwMaterialByClassBoolExp = {
  _and?: Maybe<Array<ArgoVwMaterialByClassBoolExp>>;
  _not?: Maybe<ArgoVwMaterialByClassBoolExp>;
  _or?: Maybe<Array<ArgoVwMaterialByClassBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  created_location_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  material_id?: Maybe<UuidComparisonExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  serial_number?: Maybe<StringComparisonExp>;
  serial_number_active?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  serial_number?: Maybe<Scalars['String']>;
  serial_number_active?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwMaterialByClassMaxFields = {
  __typename?: 'argo_vw_material_by_class_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location_id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  created_location_id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  serial_number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoVwMaterialByClassMinFields = {
  __typename?: 'argo_vw_material_by_class_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location_id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.vw_material_by_class" */
export type ArgoVwMaterialByClassMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  created_location_id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  serial_number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "argo.vw_material_by_class". */
export type ArgoVwMaterialByClassOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  created_location_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  serial_number?: Maybe<OrderBy>;
  serial_number_active?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_vw_material_by_class_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** select "argo_vw_material_by_class_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.vw_material_by_class" */
export enum ArgoVwMaterialByClassSelectColumnArgoVwMaterialByClassAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** Streaming cursor of the table "argo_vw_material_by_class" */
export type ArgoVwMaterialByClassStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwMaterialByClassStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwMaterialByClassStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  created_location_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  serial_number?: Maybe<Scalars['String']>;
  serial_number_active?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumn = {
  __typename?: 'argo_vw_material_class_udf_column';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnAggregate = {
  __typename?: 'argo_vw_material_class_udf_column_aggregate';
  aggregate?: Maybe<ArgoVwMaterialClassUdfColumnAggregateFields>;
  nodes: Array<ArgoVwMaterialClassUdfColumn>;
};

/** aggregate fields of "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnAggregateFields = {
  __typename?: 'argo_vw_material_class_udf_column_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwMaterialClassUdfColumnMaxFields>;
  min?: Maybe<ArgoVwMaterialClassUdfColumnMinFields>;
};


/** aggregate fields of "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwMaterialClassUdfColumnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_material_class_udf_column". All fields are combined with a logical 'AND'. */
export type ArgoVwMaterialClassUdfColumnBoolExp = {
  _and?: Maybe<Array<ArgoVwMaterialClassUdfColumnBoolExp>>;
  _not?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
  _or?: Maybe<Array<ArgoVwMaterialClassUdfColumnBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  udf_column_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwMaterialClassUdfColumnMaxFields = {
  __typename?: 'argo_vw_material_class_udf_column_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoVwMaterialClassUdfColumnMinFields = {
  __typename?: 'argo_vw_material_class_udf_column_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "argo.vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnObjRelInsertInput = {
  data: ArgoVwMaterialClassUdfColumnInsertInput;
};

/** Ordering options when selecting data from "argo.vw_material_class_udf_column". */
export type ArgoVwMaterialClassUdfColumnOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  udf_column_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_material_class_udf_column" */
export enum ArgoVwMaterialClassUdfColumnSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** Streaming cursor of the table "argo_vw_material_class_udf_column" */
export type ArgoVwMaterialClassUdfColumnStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwMaterialClassUdfColumnStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwMaterialClassUdfColumnStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  udf_column_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClass = {
  __typename?: 'argo_vw_material_model_processes_by_class';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  material_class?: Maybe<ArgoMaterialClass>;
  material_class_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  material_model?: Maybe<ArgoMaterialModel>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  process?: Maybe<ProcessProcess>;
  process_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassAggregate = {
  __typename?: 'argo_vw_material_model_processes_by_class_aggregate';
  aggregate?: Maybe<ArgoVwMaterialModelProcessesByClassAggregateFields>;
  nodes: Array<ArgoVwMaterialModelProcessesByClass>;
};

export type ArgoVwMaterialModelProcessesByClassAggregateBoolExp = {
  count?: Maybe<ArgoVwMaterialModelProcessesByClassAggregateBoolExpCount>;
};

export type ArgoVwMaterialModelProcessesByClassAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassAggregateFields = {
  __typename?: 'argo_vw_material_model_processes_by_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwMaterialModelProcessesByClassMaxFields>;
  min?: Maybe<ArgoVwMaterialModelProcessesByClassMinFields>;
};


/** aggregate fields of "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoVwMaterialModelProcessesByClassMaxOrderBy>;
  min?: Maybe<ArgoVwMaterialModelProcessesByClassMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassArrRelInsertInput = {
  data: Array<ArgoVwMaterialModelProcessesByClassInsertInput>;
};

/** Boolean expression to filter rows from the table "argo.vw_material_model_processes_by_class". All fields are combined with a logical 'AND'. */
export type ArgoVwMaterialModelProcessesByClassBoolExp = {
  _and?: Maybe<Array<ArgoVwMaterialModelProcessesByClassBoolExp>>;
  _not?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
  _or?: Maybe<Array<ArgoVwMaterialModelProcessesByClassBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_class?: Maybe<ArgoMaterialClassBoolExp>;
  material_class_id?: Maybe<UuidComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class?: Maybe<ArgoMaterialClassObjRelInsertInput>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  process_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwMaterialModelProcessesByClassMaxFields = {
  __typename?: 'argo_vw_material_model_processes_by_class_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  process_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  process_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoVwMaterialModelProcessesByClassMinFields = {
  __typename?: 'argo_vw_material_model_processes_by_class_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  process_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_model_id?: Maybe<OrderBy>;
  process_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "argo.vw_material_model_processes_by_class". */
export type ArgoVwMaterialModelProcessesByClassOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_class?: Maybe<ArgoMaterialClassOrderBy>;
  material_class_id?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_material_model_processes_by_class" */
export enum ArgoVwMaterialModelProcessesByClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** Streaming cursor of the table "argo_vw_material_model_processes_by_class" */
export type ArgoVwMaterialModelProcessesByClassStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwMaterialModelProcessesByClassStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwMaterialModelProcessesByClassStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_class_id?: Maybe<Scalars['uuid']>;
  material_model_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  process_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_role_acl" */
export type ArgoVwRoleAcl = {
  __typename?: 'argo_vw_role_acl';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_role_acl" */
export type ArgoVwRoleAclMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_role_acl" */
export type ArgoVwRoleAclAggregate = {
  __typename?: 'argo_vw_role_acl_aggregate';
  aggregate?: Maybe<ArgoVwRoleAclAggregateFields>;
  nodes: Array<ArgoVwRoleAcl>;
};

/** aggregate fields of "argo.vw_role_acl" */
export type ArgoVwRoleAclAggregateFields = {
  __typename?: 'argo_vw_role_acl_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwRoleAclMaxFields>;
  min?: Maybe<ArgoVwRoleAclMinFields>;
};


/** aggregate fields of "argo.vw_role_acl" */
export type ArgoVwRoleAclAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwRoleAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_role_acl". All fields are combined with a logical 'AND'. */
export type ArgoVwRoleAclBoolExp = {
  _and?: Maybe<Array<ArgoVwRoleAclBoolExp>>;
  _not?: Maybe<ArgoVwRoleAclBoolExp>;
  _or?: Maybe<Array<ArgoVwRoleAclBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  role_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type ArgoVwRoleAclMaxFields = {
  __typename?: 'argo_vw_role_acl_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoVwRoleAclMinFields = {
  __typename?: 'argo_vw_role_acl_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "argo.vw_role_acl". */
export type ArgoVwRoleAclOrderBy = {
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  role_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_role_acl" */
export enum ArgoVwRoleAclSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** Streaming cursor of the table "argo_vw_role_acl" */
export type ArgoVwRoleAclStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwRoleAclStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwRoleAclStreamCursorValueInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_timestamptz" */
export type ArgoVwTimestamptz = {
  __typename?: 'argo_vw_timestamptz';
  current_timestamp?: Maybe<Scalars['timestamptz']>;
  date_trunc_century?: Maybe<Scalars['timestamptz']>;
  date_trunc_day?: Maybe<Scalars['timestamptz']>;
  date_trunc_decade?: Maybe<Scalars['timestamptz']>;
  date_trunc_hour?: Maybe<Scalars['timestamptz']>;
  date_trunc_microseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_millennium?: Maybe<Scalars['timestamptz']>;
  date_trunc_milliseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_minute?: Maybe<Scalars['timestamptz']>;
  date_trunc_month?: Maybe<Scalars['timestamptz']>;
  date_trunc_quarter?: Maybe<Scalars['timestamptz']>;
  date_trunc_second?: Maybe<Scalars['timestamptz']>;
  date_trunc_week?: Maybe<Scalars['timestamptz']>;
  date_trunc_year?: Maybe<Scalars['timestamptz']>;
  now?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "argo.vw_timestamptz" */
export type ArgoVwTimestamptzAggregate = {
  __typename?: 'argo_vw_timestamptz_aggregate';
  aggregate?: Maybe<ArgoVwTimestamptzAggregateFields>;
  nodes: Array<ArgoVwTimestamptz>;
};

/** aggregate fields of "argo.vw_timestamptz" */
export type ArgoVwTimestamptzAggregateFields = {
  __typename?: 'argo_vw_timestamptz_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwTimestamptzMaxFields>;
  min?: Maybe<ArgoVwTimestamptzMinFields>;
};


/** aggregate fields of "argo.vw_timestamptz" */
export type ArgoVwTimestamptzAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwTimestamptzSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.vw_timestamptz". All fields are combined with a logical 'AND'. */
export type ArgoVwTimestamptzBoolExp = {
  _and?: Maybe<Array<ArgoVwTimestamptzBoolExp>>;
  _not?: Maybe<ArgoVwTimestamptzBoolExp>;
  _or?: Maybe<Array<ArgoVwTimestamptzBoolExp>>;
  current_timestamp?: Maybe<TimestamptzComparisonExp>;
  date_trunc_century?: Maybe<TimestamptzComparisonExp>;
  date_trunc_day?: Maybe<TimestamptzComparisonExp>;
  date_trunc_decade?: Maybe<TimestamptzComparisonExp>;
  date_trunc_hour?: Maybe<TimestamptzComparisonExp>;
  date_trunc_microseconds?: Maybe<TimestamptzComparisonExp>;
  date_trunc_millennium?: Maybe<TimestamptzComparisonExp>;
  date_trunc_milliseconds?: Maybe<TimestamptzComparisonExp>;
  date_trunc_minute?: Maybe<TimestamptzComparisonExp>;
  date_trunc_month?: Maybe<TimestamptzComparisonExp>;
  date_trunc_quarter?: Maybe<TimestamptzComparisonExp>;
  date_trunc_second?: Maybe<TimestamptzComparisonExp>;
  date_trunc_week?: Maybe<TimestamptzComparisonExp>;
  date_trunc_year?: Maybe<TimestamptzComparisonExp>;
  now?: Maybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type ArgoVwTimestamptzMaxFields = {
  __typename?: 'argo_vw_timestamptz_max_fields';
  current_timestamp?: Maybe<Scalars['timestamptz']>;
  date_trunc_century?: Maybe<Scalars['timestamptz']>;
  date_trunc_day?: Maybe<Scalars['timestamptz']>;
  date_trunc_decade?: Maybe<Scalars['timestamptz']>;
  date_trunc_hour?: Maybe<Scalars['timestamptz']>;
  date_trunc_microseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_millennium?: Maybe<Scalars['timestamptz']>;
  date_trunc_milliseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_minute?: Maybe<Scalars['timestamptz']>;
  date_trunc_month?: Maybe<Scalars['timestamptz']>;
  date_trunc_quarter?: Maybe<Scalars['timestamptz']>;
  date_trunc_second?: Maybe<Scalars['timestamptz']>;
  date_trunc_week?: Maybe<Scalars['timestamptz']>;
  date_trunc_year?: Maybe<Scalars['timestamptz']>;
  now?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ArgoVwTimestamptzMinFields = {
  __typename?: 'argo_vw_timestamptz_min_fields';
  current_timestamp?: Maybe<Scalars['timestamptz']>;
  date_trunc_century?: Maybe<Scalars['timestamptz']>;
  date_trunc_day?: Maybe<Scalars['timestamptz']>;
  date_trunc_decade?: Maybe<Scalars['timestamptz']>;
  date_trunc_hour?: Maybe<Scalars['timestamptz']>;
  date_trunc_microseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_millennium?: Maybe<Scalars['timestamptz']>;
  date_trunc_milliseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_minute?: Maybe<Scalars['timestamptz']>;
  date_trunc_month?: Maybe<Scalars['timestamptz']>;
  date_trunc_quarter?: Maybe<Scalars['timestamptz']>;
  date_trunc_second?: Maybe<Scalars['timestamptz']>;
  date_trunc_week?: Maybe<Scalars['timestamptz']>;
  date_trunc_year?: Maybe<Scalars['timestamptz']>;
  now?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "argo.vw_timestamptz". */
export type ArgoVwTimestamptzOrderBy = {
  current_timestamp?: Maybe<OrderBy>;
  date_trunc_century?: Maybe<OrderBy>;
  date_trunc_day?: Maybe<OrderBy>;
  date_trunc_decade?: Maybe<OrderBy>;
  date_trunc_hour?: Maybe<OrderBy>;
  date_trunc_microseconds?: Maybe<OrderBy>;
  date_trunc_millennium?: Maybe<OrderBy>;
  date_trunc_milliseconds?: Maybe<OrderBy>;
  date_trunc_minute?: Maybe<OrderBy>;
  date_trunc_month?: Maybe<OrderBy>;
  date_trunc_quarter?: Maybe<OrderBy>;
  date_trunc_second?: Maybe<OrderBy>;
  date_trunc_week?: Maybe<OrderBy>;
  date_trunc_year?: Maybe<OrderBy>;
  now?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_timestamptz" */
export enum ArgoVwTimestamptzSelectColumn {
  /** column name */
  CurrentTimestamp = 'current_timestamp',
  /** column name */
  DateTruncCentury = 'date_trunc_century',
  /** column name */
  DateTruncDay = 'date_trunc_day',
  /** column name */
  DateTruncDecade = 'date_trunc_decade',
  /** column name */
  DateTruncHour = 'date_trunc_hour',
  /** column name */
  DateTruncMicroseconds = 'date_trunc_microseconds',
  /** column name */
  DateTruncMillennium = 'date_trunc_millennium',
  /** column name */
  DateTruncMilliseconds = 'date_trunc_milliseconds',
  /** column name */
  DateTruncMinute = 'date_trunc_minute',
  /** column name */
  DateTruncMonth = 'date_trunc_month',
  /** column name */
  DateTruncQuarter = 'date_trunc_quarter',
  /** column name */
  DateTruncSecond = 'date_trunc_second',
  /** column name */
  DateTruncWeek = 'date_trunc_week',
  /** column name */
  DateTruncYear = 'date_trunc_year',
  /** column name */
  Now = 'now'
}

/** Streaming cursor of the table "argo_vw_timestamptz" */
export type ArgoVwTimestamptzStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwTimestamptzStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwTimestamptzStreamCursorValueInput = {
  current_timestamp?: Maybe<Scalars['timestamptz']>;
  date_trunc_century?: Maybe<Scalars['timestamptz']>;
  date_trunc_day?: Maybe<Scalars['timestamptz']>;
  date_trunc_decade?: Maybe<Scalars['timestamptz']>;
  date_trunc_hour?: Maybe<Scalars['timestamptz']>;
  date_trunc_microseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_millennium?: Maybe<Scalars['timestamptz']>;
  date_trunc_milliseconds?: Maybe<Scalars['timestamptz']>;
  date_trunc_minute?: Maybe<Scalars['timestamptz']>;
  date_trunc_month?: Maybe<Scalars['timestamptz']>;
  date_trunc_quarter?: Maybe<Scalars['timestamptz']>;
  date_trunc_second?: Maybe<Scalars['timestamptz']>;
  date_trunc_week?: Maybe<Scalars['timestamptz']>;
  date_trunc_year?: Maybe<Scalars['timestamptz']>;
  now?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "argo.vw_user_acls" */
export type ArgoVwUserAcls = {
  __typename?: 'argo_vw_user_acls';
  /** An array relationship */
  acls: Array<ArgoVwUserContextAcl>;
  /** An aggregate relationship */
  acls_aggregate: ArgoVwUserContextAclAggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};


/** columns and relationships of "argo.vw_user_acls" */
export type ArgoVwUserAclsAclsArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


/** columns and relationships of "argo.vw_user_acls" */
export type ArgoVwUserAclsAclsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


/** columns and relationships of "argo.vw_user_acls" */
export type ArgoVwUserAclsMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_user_acls" */
export type ArgoVwUserAclsAggregate = {
  __typename?: 'argo_vw_user_acls_aggregate';
  aggregate?: Maybe<ArgoVwUserAclsAggregateFields>;
  nodes: Array<ArgoVwUserAcls>;
};

/** aggregate fields of "argo.vw_user_acls" */
export type ArgoVwUserAclsAggregateFields = {
  __typename?: 'argo_vw_user_acls_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwUserAclsMaxFields>;
  min?: Maybe<ArgoVwUserAclsMinFields>;
};


/** aggregate fields of "argo.vw_user_acls" */
export type ArgoVwUserAclsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwUserAclsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoVwUserAclsAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.vw_user_acls". All fields are combined with a logical 'AND'. */
export type ArgoVwUserAclsBoolExp = {
  _and?: Maybe<Array<ArgoVwUserAclsBoolExp>>;
  _not?: Maybe<ArgoVwUserAclsBoolExp>;
  _or?: Maybe<Array<ArgoVwUserAclsBoolExp>>;
  acls?: Maybe<ArgoVwUserContextAclBoolExp>;
  acls_aggregate?: Maybe<ArgoVwUserContextAclAggregateBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  first_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  last_name?: Maybe<StringComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  username?: Maybe<StringComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoVwUserAclsDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoVwUserAclsDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoVwUserAclsDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.vw_user_acls" */
export type ArgoVwUserAclsInsertInput = {
  acls?: Maybe<ArgoVwUserContextAclArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoVwUserAclsMaxFields = {
  __typename?: 'argo_vw_user_acls_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoVwUserAclsMinFields = {
  __typename?: 'argo_vw_user_acls_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.vw_user_acls" */
export type ArgoVwUserAclsMutationResponse = {
  __typename?: 'argo_vw_user_acls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoVwUserAcls>;
};

/** Ordering options when selecting data from "argo.vw_user_acls". */
export type ArgoVwUserAclsOrderBy = {
  acls_aggregate?: Maybe<ArgoVwUserContextAclAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  first_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  last_name?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  username?: Maybe<OrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoVwUserAclsPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.vw_user_acls" */
export enum ArgoVwUserAclsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "argo.vw_user_acls" */
export type ArgoVwUserAclsSetInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_vw_user_acls" */
export type ArgoVwUserAclsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwUserAclsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwUserAclsStreamCursorValueInput = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

export type ArgoVwUserAclsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoVwUserAclsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoVwUserAclsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoVwUserAclsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoVwUserAclsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoVwUserAclsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoVwUserAclsSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoVwUserAclsBoolExp;
};

/** columns and relationships of "argo.vw_user_context_acl" */
export type ArgoVwUserContextAcl = {
  __typename?: 'argo_vw_user_context_acl';
  acl_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  context_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclAggregate = {
  __typename?: 'argo_vw_user_context_acl_aggregate';
  aggregate?: Maybe<ArgoVwUserContextAclAggregateFields>;
  nodes: Array<ArgoVwUserContextAcl>;
};

export type ArgoVwUserContextAclAggregateBoolExp = {
  count?: Maybe<ArgoVwUserContextAclAggregateBoolExpCount>;
};

export type ArgoVwUserContextAclAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwUserContextAclBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclAggregateFields = {
  __typename?: 'argo_vw_user_context_acl_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwUserContextAclMaxFields>;
  min?: Maybe<ArgoVwUserContextAclMinFields>;
};


/** aggregate fields of "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoVwUserContextAclMaxOrderBy>;
  min?: Maybe<ArgoVwUserContextAclMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclArrRelInsertInput = {
  data: Array<ArgoVwUserContextAclInsertInput>;
};

/** Boolean expression to filter rows from the table "argo.vw_user_context_acl". All fields are combined with a logical 'AND'. */
export type ArgoVwUserContextAclBoolExp = {
  _and?: Maybe<Array<ArgoVwUserContextAclBoolExp>>;
  _not?: Maybe<ArgoVwUserContextAclBoolExp>;
  _or?: Maybe<Array<ArgoVwUserContextAclBoolExp>>;
  acl_id?: Maybe<StringComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclInsertInput = {
  acl_id?: Maybe<Scalars['String']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwUserContextAclMaxFields = {
  __typename?: 'argo_vw_user_context_acl_max_fields';
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclMaxOrderBy = {
  acl_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoVwUserContextAclMinFields = {
  __typename?: 'argo_vw_user_context_acl_min_fields';
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.vw_user_context_acl" */
export type ArgoVwUserContextAclMinOrderBy = {
  acl_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "argo.vw_user_context_acl". */
export type ArgoVwUserContextAclOrderBy = {
  acl_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_user_context_acl" */
export enum ArgoVwUserContextAclSelectColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "argo_vw_user_context_acl" */
export type ArgoVwUserContextAclStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwUserContextAclStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwUserContextAclStreamCursorValueInput = {
  acl_id?: Maybe<Scalars['String']>;
  context_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.vw_user_roles" */
export type ArgoVwUserRoles = {
  __typename?: 'argo_vw_user_roles';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "argo.vw_user_roles" */
export type ArgoVwUserRolesMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.vw_user_roles" */
export type ArgoVwUserRolesAggregate = {
  __typename?: 'argo_vw_user_roles_aggregate';
  aggregate?: Maybe<ArgoVwUserRolesAggregateFields>;
  nodes: Array<ArgoVwUserRoles>;
};

export type ArgoVwUserRolesAggregateBoolExp = {
  bool_and?: Maybe<ArgoVwUserRolesAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ArgoVwUserRolesAggregateBoolExpBoolOr>;
  count?: Maybe<ArgoVwUserRolesAggregateBoolExpCount>;
};

export type ArgoVwUserRolesAggregateBoolExpBoolAnd = {
  arguments: ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwUserRolesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoVwUserRolesAggregateBoolExpBoolOr = {
  arguments: ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwUserRolesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ArgoVwUserRolesAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoVwUserRolesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.vw_user_roles" */
export type ArgoVwUserRolesAggregateFields = {
  __typename?: 'argo_vw_user_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoVwUserRolesMaxFields>;
  min?: Maybe<ArgoVwUserRolesMinFields>;
};


/** aggregate fields of "argo.vw_user_roles" */
export type ArgoVwUserRolesAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.vw_user_roles" */
export type ArgoVwUserRolesAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoVwUserRolesMaxOrderBy>;
  min?: Maybe<ArgoVwUserRolesMinOrderBy>;
};

/** input type for inserting array relation for remote table "argo.vw_user_roles" */
export type ArgoVwUserRolesArrRelInsertInput = {
  data: Array<ArgoVwUserRolesInsertInput>;
};

/** Boolean expression to filter rows from the table "argo.vw_user_roles". All fields are combined with a logical 'AND'. */
export type ArgoVwUserRolesBoolExp = {
  _and?: Maybe<Array<ArgoVwUserRolesBoolExp>>;
  _not?: Maybe<ArgoVwUserRolesBoolExp>;
  _or?: Maybe<Array<ArgoVwUserRolesBoolExp>>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
};

/** input type for inserting data into table "argo.vw_user_roles" */
export type ArgoVwUserRolesInsertInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoVwUserRolesMaxFields = {
  __typename?: 'argo_vw_user_roles_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.vw_user_roles" */
export type ArgoVwUserRolesMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoVwUserRolesMinFields = {
  __typename?: 'argo_vw_user_roles_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.vw_user_roles" */
export type ArgoVwUserRolesMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** Ordering options when selecting data from "argo.vw_user_roles". */
export type ArgoVwUserRolesOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** select columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** select "argo_vw_user_roles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_vw_user_roles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** Streaming cursor of the table "argo_vw_user_roles" */
export type ArgoVwUserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoVwUserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoVwUserRolesStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** A work instruction is a collection of steps that can batch and sequence processes, markdown instructions, and media */
export type ArgoWorkInstruction = {
  __typename?: 'argo_work_instruction';
  /** An object relationship */
  context: ArgoContext;
  /** The context this work instruction is associated with */
  context_id: Scalars['uuid'];
  /** The time this work instruction was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The user that created this work instruction */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** The name of the work instruction. This is what the user will see in the UI */
  name: Scalars['String'];
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique: Scalars['String'];
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  work_instruction_versions: Array<ArgoWorkInstructionVersion>;
  /** An aggregate relationship */
  work_instruction_versions_aggregate: ArgoWorkInstructionVersionAggregate;
};


/** A work instruction is a collection of steps that can batch and sequence processes, markdown instructions, and media */
export type ArgoWorkInstructionWorkInstructionVersionsArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


/** A work instruction is a collection of steps that can batch and sequence processes, markdown instructions, and media */
export type ArgoWorkInstructionWorkInstructionVersionsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};

/** aggregated selection of "argo.work_instruction" */
export type ArgoWorkInstructionAggregate = {
  __typename?: 'argo_work_instruction_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionAggregateFields>;
  nodes: Array<ArgoWorkInstruction>;
};

/** aggregate fields of "argo.work_instruction" */
export type ArgoWorkInstructionAggregateFields = {
  __typename?: 'argo_work_instruction_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionMaxFields>;
  min?: Maybe<ArgoWorkInstructionMinFields>;
};


/** aggregate fields of "argo.work_instruction" */
export type ArgoWorkInstructionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_instruction_versions?: Maybe<ArgoWorkInstructionVersionBoolExp>;
  work_instruction_versions_aggregate?: Maybe<ArgoWorkInstructionVersionAggregateBoolExp>;
};

/** unique or primary key constraints on table "argo.work_instruction" */
export enum ArgoWorkInstructionConstraint {
  /** unique or primary key constraint on columns "work_instruction_id" */
  ArgoWorkInstructionPkey = 'argo_work_instruction_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ArgoWorkInstructionUniqueName = 'argo_work_instruction_unique_name'
}

/** input type for inserting data into table "argo.work_instruction" */
export type ArgoWorkInstructionInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context this work instruction is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that created this work instruction */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name of the work instruction. This is what the user will see in the UI */
  name?: Maybe<Scalars['String']>;
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique?: Maybe<Scalars['String']>;
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_instruction_versions?: Maybe<ArgoWorkInstructionVersionArrRelInsertInput>;
};

/** A work instruction instance is a record of a work instruction being executed with data optionally being collected to a material or asset */
export type ArgoWorkInstructionInstance = {
  __typename?: 'argo_work_instruction_instance';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  context: ArgoContext;
  /** The context this work instruction instance is associated with */
  context_id: Scalars['uuid'];
  /** The time this work instruction instance was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The user that created this work instruction instance */
  created_by_id: Scalars['uuid'];
  end_time?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  material?: Maybe<ArgoMaterial>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance */
  status: ArgoWorkInstructionInstanceStatusEnum;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  work_instruction_instance_steps: Array<ArgoWorkInstructionInstanceStep>;
  /** An aggregate relationship */
  work_instruction_instance_steps_aggregate: ArgoWorkInstructionInstanceStepAggregate;
  /** An object relationship */
  work_instruction_version: ArgoWorkInstructionVersion;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id: Scalars['uuid'];
};


/** A work instruction instance is a record of a work instruction being executed with data optionally being collected to a material or asset */
export type ArgoWorkInstructionInstanceWorkInstructionInstanceStepsArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


/** A work instruction instance is a record of a work instruction being executed with data optionally being collected to a material or asset */
export type ArgoWorkInstructionInstanceWorkInstructionInstanceStepsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};

/** aggregated selection of "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceAggregate = {
  __typename?: 'argo_work_instruction_instance_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionInstanceAggregateFields>;
  nodes: Array<ArgoWorkInstructionInstance>;
};

/** aggregate fields of "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceAggregateFields = {
  __typename?: 'argo_work_instruction_instance_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionInstanceMaxFields>;
  min?: Maybe<ArgoWorkInstructionInstanceMinFields>;
};


/** aggregate fields of "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionInstanceSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction_instance". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionInstanceBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionInstanceBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionInstanceBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  end_time?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  start_time?: Maybe<TimestamptzComparisonExp>;
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_instruction_instance_steps?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
  work_instruction_instance_steps_aggregate?: Maybe<ArgoWorkInstructionInstanceStepAggregateBoolExp>;
  work_instruction_version?: Maybe<ArgoWorkInstructionVersionBoolExp>;
  work_instruction_version_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_id" */
  WorkInstructionInstancePkey = 'work_instruction_instance_pkey'
}

/** input type for inserting data into table "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context this work instruction instance is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that created this work instruction instance */
  created_by_id?: Maybe<Scalars['uuid']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_instruction_instance_steps?: Maybe<ArgoWorkInstructionInstanceStepArrRelInsertInput>;
  work_instruction_version?: Maybe<ArgoWorkInstructionVersionObjRelInsertInput>;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoWorkInstructionInstanceMaxFields = {
  __typename?: 'argo_work_instruction_instance_max_fields';
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction instance is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance */
  created_by_id?: Maybe<Scalars['uuid']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionInstanceMinFields = {
  __typename?: 'argo_work_instruction_instance_min_fields';
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction instance is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance */
  created_by_id?: Maybe<Scalars['uuid']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceMutationResponse = {
  __typename?: 'argo_work_instruction_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstructionInstance>;
};

/** input type for inserting object relation for remote table "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceObjRelInsertInput = {
  data: ArgoWorkInstructionInstanceInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkInstructionInstanceOnConflict>;
};

/** on_conflict condition type for table "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceOnConflict = {
  constraint: ArgoWorkInstructionInstanceConstraint;
  update_columns?: Array<ArgoWorkInstructionInstanceUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction_instance". */
export type ArgoWorkInstructionInstanceOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  end_time?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  start_time?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_instruction_instance_steps_aggregate?: Maybe<ArgoWorkInstructionInstanceStepAggregateOrderBy>;
  work_instruction_version?: Maybe<ArgoWorkInstructionVersionOrderBy>;
  work_instruction_version_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_instruction_instance */
export type ArgoWorkInstructionInstancePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionVersionId = 'work_instruction_version_id'
}

/** input type for updating data in table "argo.work_instruction_instance" */
export type ArgoWorkInstructionInstanceSetInput = {
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction instance is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance */
  created_by_id?: Maybe<Scalars['uuid']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id?: Maybe<Scalars['uuid']>;
};

/** Status enum for work instruction instances and steps linked to that instance */
export type ArgoWorkInstructionInstanceStatus = {
  __typename?: 'argo_work_instruction_instance_status';
  status: Scalars['String'];
};

/** aggregated selection of "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusAggregate = {
  __typename?: 'argo_work_instruction_instance_status_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionInstanceStatusAggregateFields>;
  nodes: Array<ArgoWorkInstructionInstanceStatus>;
};

/** aggregate fields of "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusAggregateFields = {
  __typename?: 'argo_work_instruction_instance_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionInstanceStatusMaxFields>;
  min?: Maybe<ArgoWorkInstructionInstanceStatusMinFields>;
};


/** aggregate fields of "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionInstanceStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction_instance_status". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionInstanceStatusBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionInstanceStatusBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionInstanceStatusBoolExp>>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoWorkInstructionInstanceStatusPkey = 'argo_work_instruction_instance_status_pkey'
}

export enum ArgoWorkInstructionInstanceStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Skipped = 'skipped'
}

/** Boolean expression to compare columns of type "argo_work_instruction_instance_status_enum". All fields are combined with logical 'AND'. */
export type ArgoWorkInstructionInstanceStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  _in?: Maybe<Array<ArgoWorkInstructionInstanceStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  _nin?: Maybe<Array<ArgoWorkInstructionInstanceStatusEnum>>;
};

/** input type for inserting data into table "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusInsertInput = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoWorkInstructionInstanceStatusMaxFields = {
  __typename?: 'argo_work_instruction_instance_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionInstanceStatusMinFields = {
  __typename?: 'argo_work_instruction_instance_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusMutationResponse = {
  __typename?: 'argo_work_instruction_instance_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstructionInstanceStatus>;
};

/** on_conflict condition type for table "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusOnConflict = {
  constraint: ArgoWorkInstructionInstanceStatusConstraint;
  update_columns?: Array<ArgoWorkInstructionInstanceStatusUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction_instance_status". */
export type ArgoWorkInstructionInstanceStatusOrderBy = {
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_instruction_instance_status */
export type ArgoWorkInstructionInstanceStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusSetInput = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_work_instruction_instance_status" */
export type ArgoWorkInstructionInstanceStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionInstanceStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionInstanceStatusStreamCursorValueInput = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

export type ArgoWorkInstructionInstanceStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionInstanceStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionInstanceStatusBoolExp;
};

/** A step in a work instruction instance is a record of a step being executed in a work instruction instance with data optionally being collected to a material or asset */
export type ArgoWorkInstructionInstanceStep = {
  __typename?: 'argo_work_instruction_instance_step';
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress: Scalars['argo_work_instruction_instance_step_completion_progress'];
  /** An object relationship */
  context: ArgoContext;
  /** The context this work instruction instance step is associated with */
  context_id: Scalars['uuid'];
  /** The time this work instruction instance step was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The user that created this work instruction instance step */
  created_by_id: Scalars['uuid'];
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance step */
  status: ArgoWorkInstructionInstanceStatusEnum;
  /** The step this work instruction instance step is associated with */
  step_id: Scalars['uuid'];
  /** The step number of this work instruction instance step */
  step_number: Scalars['Int'];
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  work_instruction_instance: ArgoWorkInstructionInstance;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id: Scalars['uuid'];
};


/** A step in a work instruction instance is a record of a step being executed in a work instruction instance with data optionally being collected to a material or asset */
export type ArgoWorkInstructionInstanceStepCompletionProgressArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepAggregate = {
  __typename?: 'argo_work_instruction_instance_step_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionInstanceStepAggregateFields>;
  nodes: Array<ArgoWorkInstructionInstanceStep>;
};

export type ArgoWorkInstructionInstanceStepAggregateBoolExp = {
  count?: Maybe<ArgoWorkInstructionInstanceStepAggregateBoolExpCount>;
};

export type ArgoWorkInstructionInstanceStepAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepAggregateFields = {
  __typename?: 'argo_work_instruction_instance_step_aggregate_fields';
  avg?: Maybe<ArgoWorkInstructionInstanceStepAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionInstanceStepMaxFields>;
  min?: Maybe<ArgoWorkInstructionInstanceStepMinFields>;
  stddev?: Maybe<ArgoWorkInstructionInstanceStepStddevFields>;
  stddev_pop?: Maybe<ArgoWorkInstructionInstanceStepStddevPopFields>;
  stddev_samp?: Maybe<ArgoWorkInstructionInstanceStepStddevSampFields>;
  sum?: Maybe<ArgoWorkInstructionInstanceStepSumFields>;
  var_pop?: Maybe<ArgoWorkInstructionInstanceStepVarPopFields>;
  var_samp?: Maybe<ArgoWorkInstructionInstanceStepVarSampFields>;
  variance?: Maybe<ArgoWorkInstructionInstanceStepVarianceFields>;
};


/** aggregate fields of "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepAggregateOrderBy = {
  avg?: Maybe<ArgoWorkInstructionInstanceStepAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoWorkInstructionInstanceStepMaxOrderBy>;
  min?: Maybe<ArgoWorkInstructionInstanceStepMinOrderBy>;
  stddev?: Maybe<ArgoWorkInstructionInstanceStepStddevOrderBy>;
  stddev_pop?: Maybe<ArgoWorkInstructionInstanceStepStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoWorkInstructionInstanceStepStddevSampOrderBy>;
  sum?: Maybe<ArgoWorkInstructionInstanceStepSumOrderBy>;
  var_pop?: Maybe<ArgoWorkInstructionInstanceStepVarPopOrderBy>;
  var_samp?: Maybe<ArgoWorkInstructionInstanceStepVarSampOrderBy>;
  variance?: Maybe<ArgoWorkInstructionInstanceStepVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkInstructionInstanceStepAppendInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['argo_work_instruction_instance_step_completion_progress_partial']>;
};

/** input type for inserting array relation for remote table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepArrRelInsertInput = {
  data: Array<ArgoWorkInstructionInstanceStepInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkInstructionInstanceStepOnConflict>;
};

/** aggregate avg on columns */
export type ArgoWorkInstructionInstanceStepAvgFields = {
  __typename?: 'argo_work_instruction_instance_step_avg_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepAvgOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction_instance_step". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionInstanceStepBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionInstanceStepBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionInstanceStepBoolExp>>;
  completion_progress?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  end_time?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  start_time?: Maybe<TimestamptzComparisonExp>;
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnumComparisonExp>;
  step_id?: Maybe<UuidComparisonExp>;
  step_number?: Maybe<IntComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
  work_instruction_instance_id?: Maybe<UuidComparisonExp>;
};



/** unique or primary key constraints on table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_step_id" */
  WorkInstructionInstanceStepPkey = 'work_instruction_instance_step_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkInstructionInstanceStepDeleteAtPathInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkInstructionInstanceStepDeleteElemInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkInstructionInstanceStepDeleteKeyInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepIncInput = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepInsertInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['jsonb']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance step */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<Scalars['uuid']>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceObjRelInsertInput>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoWorkInstructionInstanceStepMaxFields = {
  __typename?: 'argo_work_instruction_instance_step_max_fields';
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<Scalars['uuid']>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepMaxOrderBy = {
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<OrderBy>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<OrderBy>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<OrderBy>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<OrderBy>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<OrderBy>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionInstanceStepMinFields = {
  __typename?: 'argo_work_instruction_instance_step_min_fields';
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<Scalars['uuid']>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepMinOrderBy = {
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<OrderBy>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<OrderBy>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<OrderBy>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<OrderBy>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<OrderBy>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepMutationResponse = {
  __typename?: 'argo_work_instruction_instance_step_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstructionInstanceStep>;
};

/** on_conflict condition type for table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepOnConflict = {
  constraint: ArgoWorkInstructionInstanceStepConstraint;
  update_columns?: Array<ArgoWorkInstructionInstanceStepUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction_instance_step". */
export type ArgoWorkInstructionInstanceStepOrderBy = {
  completion_progress?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  end_time?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  start_time?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  step_id?: Maybe<OrderBy>;
  step_number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceOrderBy>;
  work_instruction_instance_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_instruction_instance_step */
export type ArgoWorkInstructionInstanceStepPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkInstructionInstanceStepPrependInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepSelectColumn {
  /** column name */
  CompletionProgress = 'completion_progress',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  StepId = 'step_id',
  /** column name */
  StepNumber = 'step_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

/** input type for updating data in table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepSetInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['jsonb']>;
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance step */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<Scalars['uuid']>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArgoWorkInstructionInstanceStepStddevFields = {
  __typename?: 'argo_work_instruction_instance_step_stddev_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepStddevOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoWorkInstructionInstanceStepStddevPopFields = {
  __typename?: 'argo_work_instruction_instance_step_stddev_pop_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepStddevPopOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoWorkInstructionInstanceStepStddevSampFields = {
  __typename?: 'argo_work_instruction_instance_step_stddev_samp_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepStddevSampOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionInstanceStepStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionInstanceStepStreamCursorValueInput = {
  /** The completion progress of this work instruction instance step. This is a stateful representation of the data collected for this step. It is up to the client to determine how to use this data. */
  completion_progress?: Maybe<Scalars['jsonb']>;
  /** The context this work instruction instance step is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance step */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to completed */
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance step status was set to in_progress */
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance step */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The step this work instruction instance step is associated with */
  step_id?: Maybe<Scalars['uuid']>;
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
  /** The time this work instruction instance step was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance step */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction instance this step is associated with */
  work_instruction_instance_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoWorkInstructionInstanceStepSumFields = {
  __typename?: 'argo_work_instruction_instance_step_sum_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepSumOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** update columns of table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepUpdateColumn {
  /** column name */
  CompletionProgress = 'completion_progress',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  StepId = 'step_id',
  /** column name */
  StepNumber = 'step_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

export type ArgoWorkInstructionInstanceStepUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkInstructionInstanceStepAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkInstructionInstanceStepDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkInstructionInstanceStepDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkInstructionInstanceStepDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoWorkInstructionInstanceStepIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkInstructionInstanceStepPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionInstanceStepSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionInstanceStepBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoWorkInstructionInstanceStepVarPopFields = {
  __typename?: 'argo_work_instruction_instance_step_var_pop_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepVarPopOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoWorkInstructionInstanceStepVarSampFields = {
  __typename?: 'argo_work_instruction_instance_step_var_samp_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepVarSampOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoWorkInstructionInstanceStepVarianceFields = {
  __typename?: 'argo_work_instruction_instance_step_variance_fields';
  /** The step number of this work instruction instance step */
  step_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.work_instruction_instance_step" */
export type ArgoWorkInstructionInstanceStepVarianceOrderBy = {
  /** The step number of this work instruction instance step */
  step_number?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_work_instruction_instance" */
export type ArgoWorkInstructionInstanceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionInstanceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionInstanceStreamCursorValueInput = {
  /** The asset this work instruction instance is associated with, if any */
  asset_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction instance is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction instance was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction instance */
  created_by_id?: Maybe<Scalars['uuid']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The material this work instruction instance is associated with, if any */
  material_id?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** The status of this work instruction instance */
  status?: Maybe<ArgoWorkInstructionInstanceStatusEnum>;
  /** The time this work instruction instance was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction instance */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The work instruction version this instance is associated with */
  work_instruction_version_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionVersionId = 'work_instruction_version_id'
}

export type ArgoWorkInstructionInstanceUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionInstanceSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionInstanceBoolExp;
};

/** aggregate max on columns */
export type ArgoWorkInstructionMaxFields = {
  __typename?: 'argo_work_instruction_max_fields';
  /** The context this work instruction is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name of the work instruction. This is what the user will see in the UI */
  name?: Maybe<Scalars['String']>;
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique?: Maybe<Scalars['String']>;
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionMinFields = {
  __typename?: 'argo_work_instruction_min_fields';
  /** The context this work instruction is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name of the work instruction. This is what the user will see in the UI */
  name?: Maybe<Scalars['String']>;
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique?: Maybe<Scalars['String']>;
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.work_instruction" */
export type ArgoWorkInstructionMutationResponse = {
  __typename?: 'argo_work_instruction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstruction>;
};

/** input type for inserting object relation for remote table "argo.work_instruction" */
export type ArgoWorkInstructionObjRelInsertInput = {
  data: ArgoWorkInstructionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkInstructionOnConflict>;
};

/** on_conflict condition type for table "argo.work_instruction" */
export type ArgoWorkInstructionOnConflict = {
  constraint: ArgoWorkInstructionConstraint;
  update_columns?: Array<ArgoWorkInstructionUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction". */
export type ArgoWorkInstructionOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_instruction_versions_aggregate?: Maybe<ArgoWorkInstructionVersionAggregateOrderBy>;
};

/** primary key columns input for table: argo.work_instruction */
export type ArgoWorkInstructionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "argo.work_instruction" */
export enum ArgoWorkInstructionSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.work_instruction" */
export type ArgoWorkInstructionSetInput = {
  /** The context this work instruction is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name of the work instruction. This is what the user will see in the UI */
  name?: Maybe<Scalars['String']>;
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique?: Maybe<Scalars['String']>;
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_work_instruction" */
export type ArgoWorkInstructionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionStreamCursorValueInput = {
  /** The context this work instruction is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The name of the work instruction. This is what the user will see in the UI */
  name?: Maybe<Scalars['String']>;
  /** The unique name of the work instruction. This is what the user will see in the UI */
  name_unique?: Maybe<Scalars['String']>;
  /** The time this work instruction was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.work_instruction" */
export enum ArgoWorkInstructionUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoWorkInstructionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionBoolExp;
};

/** A version of a work instruction */
export type ArgoWorkInstructionVersion = {
  __typename?: 'argo_work_instruction_version';
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the work instruction */
  config: Scalars['jsonb'];
  /** An object relationship */
  context: ArgoContext;
  /** The context this work instruction version is associated with */
  context_id: Scalars['uuid'];
  /** The time this work instruction version was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** The user that created this work instruction version */
  created_by_id: Scalars['uuid'];
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** The status of this work instruction version */
  status: ArgoWorkInstructionVersionStatusEnum;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  /** An object relationship */
  work_instruction: ArgoWorkInstruction;
  /** The work instruction this version is associated with */
  work_instruction_id: Scalars['uuid'];
};


/** A version of a work instruction */
export type ArgoWorkInstructionVersionConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionAggregate = {
  __typename?: 'argo_work_instruction_version_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionVersionAggregateFields>;
  nodes: Array<ArgoWorkInstructionVersion>;
};

export type ArgoWorkInstructionVersionAggregateBoolExp = {
  count?: Maybe<ArgoWorkInstructionVersionAggregateBoolExpCount>;
};

export type ArgoWorkInstructionVersionAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoWorkInstructionVersionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionAggregateFields = {
  __typename?: 'argo_work_instruction_version_aggregate_fields';
  avg?: Maybe<ArgoWorkInstructionVersionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionVersionMaxFields>;
  min?: Maybe<ArgoWorkInstructionVersionMinFields>;
  stddev?: Maybe<ArgoWorkInstructionVersionStddevFields>;
  stddev_pop?: Maybe<ArgoWorkInstructionVersionStddevPopFields>;
  stddev_samp?: Maybe<ArgoWorkInstructionVersionStddevSampFields>;
  sum?: Maybe<ArgoWorkInstructionVersionSumFields>;
  var_pop?: Maybe<ArgoWorkInstructionVersionVarPopFields>;
  var_samp?: Maybe<ArgoWorkInstructionVersionVarSampFields>;
  variance?: Maybe<ArgoWorkInstructionVersionVarianceFields>;
};


/** aggregate fields of "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionAggregateOrderBy = {
  avg?: Maybe<ArgoWorkInstructionVersionAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoWorkInstructionVersionMaxOrderBy>;
  min?: Maybe<ArgoWorkInstructionVersionMinOrderBy>;
  stddev?: Maybe<ArgoWorkInstructionVersionStddevOrderBy>;
  stddev_pop?: Maybe<ArgoWorkInstructionVersionStddevPopOrderBy>;
  stddev_samp?: Maybe<ArgoWorkInstructionVersionStddevSampOrderBy>;
  sum?: Maybe<ArgoWorkInstructionVersionSumOrderBy>;
  var_pop?: Maybe<ArgoWorkInstructionVersionVarPopOrderBy>;
  var_samp?: Maybe<ArgoWorkInstructionVersionVarSampOrderBy>;
  variance?: Maybe<ArgoWorkInstructionVersionVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkInstructionVersionAppendInput = {
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionArrRelInsertInput = {
  data: Array<ArgoWorkInstructionVersionInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkInstructionVersionOnConflict>;
};

/** aggregate avg on columns */
export type ArgoWorkInstructionVersionAvgFields = {
  __typename?: 'argo_work_instruction_version_avg_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionAvgOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction_version". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionVersionBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionVersionBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionVersionBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionVersionBoolExp>>;
  approved_by_id?: Maybe<UuidComparisonExp>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  discontinue_after?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ArgoWorkInstructionVersionStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  version_number?: Maybe<SmallintComparisonExp>;
  work_instruction?: Maybe<ArgoWorkInstructionBoolExp>;
  work_instruction_id?: Maybe<UuidComparisonExp>;
};


/** unique or primary key constraints on table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionConstraint {
  /** unique or primary key constraint on columns "work_instruction_version_id" */
  ArgoWorkInstructionVersionPkey = 'argo_work_instruction_version_pkey',
  /** unique or primary key constraint on columns "work_instruction_id" */
  ArgoWorkInstructionVersionUniqueActiveVersion = 'argo_work_instruction_version_unique_active_version',
  /** unique or primary key constraint on columns "version_number", "work_instruction_id" */
  ArgoWorkInstructionVersionUniqueVersionNumber = 'argo_work_instruction_version_unique_version_number'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkInstructionVersionDeleteAtPathInput = {
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkInstructionVersionDeleteElemInput = {
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkInstructionVersionDeleteKeyInput = {
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionIncInput = {
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionInsertInput = {
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the work instruction */
  config: Scalars['argo_work_instruction_version_config'];
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The status of this work instruction version */
  status?: Maybe<ArgoWorkInstructionVersionStatusEnum>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  work_instruction?: Maybe<ArgoWorkInstructionObjRelInsertInput>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoWorkInstructionVersionMaxFields = {
  __typename?: 'argo_work_instruction_version_max_fields';
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionMaxOrderBy = {
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<OrderBy>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<OrderBy>;
  /** The time this work instruction version was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<OrderBy>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<OrderBy>;
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionVersionMinFields = {
  __typename?: 'argo_work_instruction_version_min_fields';
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionMinOrderBy = {
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<OrderBy>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<OrderBy>;
  /** The time this work instruction version was created */
  created_at?: Maybe<OrderBy>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<OrderBy>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<OrderBy>;
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionMutationResponse = {
  __typename?: 'argo_work_instruction_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstructionVersion>;
};

/** input type for inserting object relation for remote table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionObjRelInsertInput = {
  data: ArgoWorkInstructionVersionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkInstructionVersionOnConflict>;
};

/** on_conflict condition type for table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionOnConflict = {
  constraint: ArgoWorkInstructionVersionConstraint;
  update_columns?: Array<ArgoWorkInstructionVersionUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction_version". */
export type ArgoWorkInstructionVersionOrderBy = {
  approved_by_id?: Maybe<OrderBy>;
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  discontinue_after?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  version_number?: Maybe<OrderBy>;
  work_instruction?: Maybe<ArgoWorkInstructionOrderBy>;
  work_instruction_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_instruction_version */
export type ArgoWorkInstructionVersionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkInstructionVersionPrependInput = {
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionSelectColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscontinueAfter = 'discontinue_after',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number',
  /** column name */
  WorkInstructionId = 'work_instruction_id'
}

/** input type for updating data in table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionSetInput = {
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['argo_work_instruction_version_config']>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The status of this work instruction version */
  status?: Maybe<ArgoWorkInstructionVersionStatusEnum>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<Scalars['uuid']>;
};

/** Status enum for work instruction versions */
export type ArgoWorkInstructionVersionStatus = {
  __typename?: 'argo_work_instruction_version_status';
  status: Scalars['String'];
};

/** aggregated selection of "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusAggregate = {
  __typename?: 'argo_work_instruction_version_status_aggregate';
  aggregate?: Maybe<ArgoWorkInstructionVersionStatusAggregateFields>;
  nodes: Array<ArgoWorkInstructionVersionStatus>;
};

/** aggregate fields of "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusAggregateFields = {
  __typename?: 'argo_work_instruction_version_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkInstructionVersionStatusMaxFields>;
  min?: Maybe<ArgoWorkInstructionVersionStatusMinFields>;
};


/** aggregate fields of "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkInstructionVersionStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_instruction_version_status". All fields are combined with a logical 'AND'. */
export type ArgoWorkInstructionVersionStatusBoolExp = {
  _and?: Maybe<Array<ArgoWorkInstructionVersionStatusBoolExp>>;
  _not?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
  _or?: Maybe<Array<ArgoWorkInstructionVersionStatusBoolExp>>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoWorkInstructionVersionStatusPkey = 'argo_work_instruction_version_status_pkey'
}

export enum ArgoWorkInstructionVersionStatusEnum {
  Released = 'released',
  Retired = 'retired',
  Staged = 'staged'
}

/** Boolean expression to compare columns of type "argo_work_instruction_version_status_enum". All fields are combined with logical 'AND'. */
export type ArgoWorkInstructionVersionStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoWorkInstructionVersionStatusEnum>;
  _in?: Maybe<Array<ArgoWorkInstructionVersionStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoWorkInstructionVersionStatusEnum>;
  _nin?: Maybe<Array<ArgoWorkInstructionVersionStatusEnum>>;
};

/** input type for inserting data into table "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusInsertInput = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoWorkInstructionVersionStatusMaxFields = {
  __typename?: 'argo_work_instruction_version_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoWorkInstructionVersionStatusMinFields = {
  __typename?: 'argo_work_instruction_version_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusMutationResponse = {
  __typename?: 'argo_work_instruction_version_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkInstructionVersionStatus>;
};

/** on_conflict condition type for table "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusOnConflict = {
  constraint: ArgoWorkInstructionVersionStatusConstraint;
  update_columns?: Array<ArgoWorkInstructionVersionStatusUpdateColumn>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.work_instruction_version_status". */
export type ArgoWorkInstructionVersionStatusOrderBy = {
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_instruction_version_status */
export type ArgoWorkInstructionVersionStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusSetInput = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_work_instruction_version_status" */
export type ArgoWorkInstructionVersionStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionVersionStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionVersionStatusStreamCursorValueInput = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

export type ArgoWorkInstructionVersionStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionVersionStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionVersionStatusBoolExp;
};

/** aggregate stddev on columns */
export type ArgoWorkInstructionVersionStddevFields = {
  __typename?: 'argo_work_instruction_version_stddev_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionStddevOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArgoWorkInstructionVersionStddevPopFields = {
  __typename?: 'argo_work_instruction_version_stddev_pop_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionStddevPopOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArgoWorkInstructionVersionStddevSampFields = {
  __typename?: 'argo_work_instruction_version_stddev_samp_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionStddevSampOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "argo_work_instruction_version" */
export type ArgoWorkInstructionVersionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkInstructionVersionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkInstructionVersionStreamCursorValueInput = {
  /** The user that approved this work instruction version */
  approved_by_id?: Maybe<Scalars['uuid']>;
  /** The blueprint for this version of the work instruction */
  config?: Maybe<Scalars['jsonb']>;
  /** The context this work instruction version is associated with */
  context_id?: Maybe<Scalars['uuid']>;
  /** The time this work instruction version was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The user that created this work instruction version */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The time after which this work instruction version should be considered discontinued. Work instructions that are retired can still be started as long as it is before the discontinue date */
  discontinue_after?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The status of this work instruction version */
  status?: Maybe<ArgoWorkInstructionVersionStatusEnum>;
  /** The time this work instruction version was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The user that last updated this work instruction version */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
  /** The work instruction this version is associated with */
  work_instruction_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoWorkInstructionVersionSumFields = {
  __typename?: 'argo_work_instruction_version_sum_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionSumOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** update columns of table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionUpdateColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscontinueAfter = 'discontinue_after',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number',
  /** column name */
  WorkInstructionId = 'work_instruction_id'
}

export type ArgoWorkInstructionVersionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkInstructionVersionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkInstructionVersionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkInstructionVersionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkInstructionVersionDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoWorkInstructionVersionIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkInstructionVersionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkInstructionVersionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkInstructionVersionBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoWorkInstructionVersionVarPopFields = {
  __typename?: 'argo_work_instruction_version_var_pop_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionVarPopOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArgoWorkInstructionVersionVarSampFields = {
  __typename?: 'argo_work_instruction_version_var_samp_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionVarSampOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArgoWorkInstructionVersionVarianceFields = {
  __typename?: 'argo_work_instruction_version_variance_fields';
  /** The version number of this work instruction version */
  version_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "argo.work_instruction_version" */
export type ArgoWorkInstructionVersionVarianceOrderBy = {
  /** The version number of this work instruction version */
  version_number?: Maybe<OrderBy>;
};

/** Material Work Orders */
export type ArgoWorkOrder = {
  __typename?: 'argo_work_order';
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** The primary key */
  id: Scalars['uuid'];
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** An object relationship */
  material_model: ArgoMaterialModel;
  /** The material model for this work order */
  material_model_id: Scalars['uuid'];
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** The work order number */
  order_number: Scalars['String'];
  /** When the work order is planned to start */
  planned_start: Scalars['timestamptz'];
  /** The restriction method used to complete this work order */
  restriction: ArgoWorkOrderRestrictionEnum;
  /** The status of this work order */
  status: ArgoWorkOrderStatusEnum;
  /** The note for the status of this work order */
  status_note: Scalars['String'];
  /** The target quantity of material expected */
  target_quantity: Scalars['Int'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  work_order_locations: Array<ArgoWorkOrderLocation>;
  /** An aggregate relationship */
  work_order_locations_aggregate: ArgoWorkOrderLocationAggregate;
  /** An array relationship */
  work_order_materials: Array<ArgoWorkOrderMaterial>;
  /** An aggregate relationship */
  work_order_materials_aggregate: ArgoWorkOrderMaterialAggregate;
  /** An object relationship */
  work_order_restriction: ArgoWorkOrderRestriction;
  /** An object relationship */
  work_order_status: ArgoWorkOrderStatus;
};


/** Material Work Orders */
export type ArgoWorkOrderMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Material Work Orders */
export type ArgoWorkOrderWorkOrderLocationsArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


/** Material Work Orders */
export type ArgoWorkOrderWorkOrderLocationsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


/** Material Work Orders */
export type ArgoWorkOrderWorkOrderMaterialsArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


/** Material Work Orders */
export type ArgoWorkOrderWorkOrderMaterialsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};

/** columns and relationships of "argo.work_order_activity" */
export type ArgoWorkOrderActivity = {
  __typename?: 'argo_work_order_activity';
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  kind: ArgoWorkOrderActivityKindEnum;
  /** An object relationship */
  material?: Maybe<ArgoMaterial>;
  material_id?: Maybe<Scalars['uuid']>;
  meta: Scalars['jsonb'];
  note: Scalars['String'];
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  /** An object relationship */
  work_order: ArgoWorkOrder;
  work_order_id: Scalars['uuid'];
};


/** columns and relationships of "argo.work_order_activity" */
export type ArgoWorkOrderActivityMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.work_order_activity" */
export type ArgoWorkOrderActivityAggregate = {
  __typename?: 'argo_work_order_activity_aggregate';
  aggregate?: Maybe<ArgoWorkOrderActivityAggregateFields>;
  nodes: Array<ArgoWorkOrderActivity>;
};

/** aggregate fields of "argo.work_order_activity" */
export type ArgoWorkOrderActivityAggregateFields = {
  __typename?: 'argo_work_order_activity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderActivityMaxFields>;
  min?: Maybe<ArgoWorkOrderActivityMinFields>;
};


/** aggregate fields of "argo.work_order_activity" */
export type ArgoWorkOrderActivityAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderActivitySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderActivityAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "argo.work_order_activity". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderActivityBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderActivityBoolExp>>;
  _not?: Maybe<ArgoWorkOrderActivityBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderActivityBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  kind?: Maybe<ArgoWorkOrderActivityKindEnumComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  note?: Maybe<StringComparisonExp>;
  status?: Maybe<ArgoWorkOrderStatusEnumComparisonExp>;
  work_order?: Maybe<ArgoWorkOrderBoolExp>;
  work_order_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_activity" */
export enum ArgoWorkOrderActivityConstraint {
  /** unique or primary key constraint on columns "work_order_activity_id" */
  WorkOrderActivityPkey = 'work_order_activity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkOrderActivityDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkOrderActivityDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkOrderActivityDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.work_order_activity" */
export type ArgoWorkOrderActivityInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoWorkOrderActivityKindEnum>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  work_order?: Maybe<ArgoWorkOrderObjRelInsertInput>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKind = {
  __typename?: 'argo_work_order_activity_kind';
  description: Scalars['String'];
  kind: Scalars['String'];
};

/** aggregated selection of "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindAggregate = {
  __typename?: 'argo_work_order_activity_kind_aggregate';
  aggregate?: Maybe<ArgoWorkOrderActivityKindAggregateFields>;
  nodes: Array<ArgoWorkOrderActivityKind>;
};

/** aggregate fields of "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindAggregateFields = {
  __typename?: 'argo_work_order_activity_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderActivityKindMaxFields>;
  min?: Maybe<ArgoWorkOrderActivityKindMinFields>;
};


/** aggregate fields of "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderActivityKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_order_activity_kind". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderActivityKindBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderActivityKindBoolExp>>;
  _not?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderActivityKindBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  kind?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  WorkOrderActivityKindPkey = 'work_order_activity_kind_pkey'
}

export enum ArgoWorkOrderActivityKindEnum {
  /** Work Order was changed */
  Config = 'config',
  /** Work Order material was changed */
  Material = 'material',
  /** Work Order status was changed */
  Status = 'status'
}

/** Boolean expression to compare columns of type "argo_work_order_activity_kind_enum". All fields are combined with logical 'AND'. */
export type ArgoWorkOrderActivityKindEnumComparisonExp = {
  _eq?: Maybe<ArgoWorkOrderActivityKindEnum>;
  _in?: Maybe<Array<ArgoWorkOrderActivityKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoWorkOrderActivityKindEnum>;
  _nin?: Maybe<Array<ArgoWorkOrderActivityKindEnum>>;
};

/** input type for inserting data into table "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindInsertInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoWorkOrderActivityKindMaxFields = {
  __typename?: 'argo_work_order_activity_kind_max_fields';
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoWorkOrderActivityKindMinFields = {
  __typename?: 'argo_work_order_activity_kind_min_fields';
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindMutationResponse = {
  __typename?: 'argo_work_order_activity_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderActivityKind>;
};

/** on_conflict condition type for table "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindOnConflict = {
  constraint: ArgoWorkOrderActivityKindConstraint;
  update_columns?: Array<ArgoWorkOrderActivityKindUpdateColumn>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_activity_kind". */
export type ArgoWorkOrderActivityKindOrderBy = {
  description?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_activity_kind */
export type ArgoWorkOrderActivityKindPkColumnsInput = {
  kind: Scalars['String'];
};

/** select columns of table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "argo.work_order_activity_kind" */
export type ArgoWorkOrderActivityKindSetInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_work_order_activity_kind" */
export type ArgoWorkOrderActivityKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderActivityKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderActivityKindStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.work_order_activity_kind" */
export enum ArgoWorkOrderActivityKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

export type ArgoWorkOrderActivityKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderActivityKindSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderActivityKindBoolExp;
};

/** aggregate max on columns */
export type ArgoWorkOrderActivityMaxFields = {
  __typename?: 'argo_work_order_activity_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoWorkOrderActivityMinFields = {
  __typename?: 'argo_work_order_activity_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.work_order_activity" */
export type ArgoWorkOrderActivityMutationResponse = {
  __typename?: 'argo_work_order_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderActivity>;
};

/** on_conflict condition type for table "argo.work_order_activity" */
export type ArgoWorkOrderActivityOnConflict = {
  constraint: ArgoWorkOrderActivityConstraint;
  update_columns?: Array<ArgoWorkOrderActivityUpdateColumn>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_activity". */
export type ArgoWorkOrderActivityOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  note?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  work_order?: Maybe<ArgoWorkOrderOrderBy>;
  work_order_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_activity */
export type ArgoWorkOrderActivityPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderActivityPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.work_order_activity" */
export enum ArgoWorkOrderActivitySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "argo.work_order_activity" */
export type ArgoWorkOrderActivitySetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoWorkOrderActivityKindEnum>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_work_order_activity" */
export type ArgoWorkOrderActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderActivityStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<ArgoWorkOrderActivityKindEnum>;
  material_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.work_order_activity" */
export enum ArgoWorkOrderActivityUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type ArgoWorkOrderActivityUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkOrderActivityAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkOrderActivityDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkOrderActivityDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkOrderActivityDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkOrderActivityPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderActivitySetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderActivityBoolExp;
};

/** aggregated selection of "argo.work_order" */
export type ArgoWorkOrderAggregate = {
  __typename?: 'argo_work_order_aggregate';
  aggregate?: Maybe<ArgoWorkOrderAggregateFields>;
  nodes: Array<ArgoWorkOrder>;
};

/** aggregate fields of "argo.work_order" */
export type ArgoWorkOrderAggregateFields = {
  __typename?: 'argo_work_order_aggregate_fields';
  avg?: Maybe<ArgoWorkOrderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderMaxFields>;
  min?: Maybe<ArgoWorkOrderMinFields>;
  stddev?: Maybe<ArgoWorkOrderStddevFields>;
  stddev_pop?: Maybe<ArgoWorkOrderStddevPopFields>;
  stddev_samp?: Maybe<ArgoWorkOrderStddevSampFields>;
  sum?: Maybe<ArgoWorkOrderSumFields>;
  var_pop?: Maybe<ArgoWorkOrderVarPopFields>;
  var_samp?: Maybe<ArgoWorkOrderVarSampFields>;
  variance?: Maybe<ArgoWorkOrderVarianceFields>;
};


/** aggregate fields of "argo.work_order" */
export type ArgoWorkOrderAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ArgoWorkOrderAvgFields = {
  __typename?: 'argo_work_order_avg_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "argo.work_order". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderBoolExp>>;
  _not?: Maybe<ArgoWorkOrderBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderBoolExp>>;
  actual_start?: Maybe<TimestamptzComparisonExp>;
  completed?: Maybe<TimestamptzComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material_completed_count?: Maybe<IntComparisonExp>;
  material_model?: Maybe<ArgoMaterialModelBoolExp>;
  material_model_id?: Maybe<UuidComparisonExp>;
  material_other_count?: Maybe<IntComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  order_number?: Maybe<StringComparisonExp>;
  planned_start?: Maybe<TimestamptzComparisonExp>;
  restriction?: Maybe<ArgoWorkOrderRestrictionEnumComparisonExp>;
  status?: Maybe<ArgoWorkOrderStatusEnumComparisonExp>;
  status_note?: Maybe<StringComparisonExp>;
  target_quantity?: Maybe<IntComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_order_locations?: Maybe<ArgoWorkOrderLocationBoolExp>;
  work_order_locations_aggregate?: Maybe<ArgoWorkOrderLocationAggregateBoolExp>;
  work_order_materials?: Maybe<ArgoWorkOrderMaterialBoolExp>;
  work_order_materials_aggregate?: Maybe<ArgoWorkOrderMaterialAggregateBoolExp>;
  work_order_restriction?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
  work_order_status?: Maybe<ArgoWorkOrderStatusBoolExp>;
};

/** unique or primary key constraints on table "argo.work_order" */
export enum ArgoWorkOrderConstraint {
  /** unique or primary key constraint on columns "work_order_id" */
  WorkOrderPkey = 'work_order_pkey',
  /** unique or primary key constraint on columns "context_id", "order_number" */
  WorkOrderUniqueOrderNumber = 'work_order_unique_order_number'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkOrderDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkOrderDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkOrderDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "argo.work_order" */
export type ArgoWorkOrderIncInput = {
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "argo.work_order" */
export type ArgoWorkOrderInsertInput = {
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  material_model?: Maybe<ArgoMaterialModelObjRelInsertInput>;
  /** The material model for this work order */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The work order number */
  order_number?: Maybe<Scalars['String']>;
  /** When the work order is planned to start */
  planned_start?: Maybe<Scalars['timestamptz']>;
  /** The restriction method used to complete this work order */
  restriction?: Maybe<ArgoWorkOrderRestrictionEnum>;
  /** The status of this work order */
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  /** The note for the status of this work order */
  status_note?: Maybe<Scalars['String']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_order_locations?: Maybe<ArgoWorkOrderLocationArrRelInsertInput>;
  work_order_materials?: Maybe<ArgoWorkOrderMaterialArrRelInsertInput>;
  work_order_restriction?: Maybe<ArgoWorkOrderRestrictionObjRelInsertInput>;
  work_order_status?: Maybe<ArgoWorkOrderStatusObjRelInsertInput>;
};

/** Assignments of locations to work orders */
export type ArgoWorkOrderLocation = {
  __typename?: 'argo_work_order_location';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** The primary key */
  id: Scalars['uuid'];
  /** An object relationship */
  location: ArgoLocation;
  /** The ID of the location */
  location_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  work_order: ArgoWorkOrder;
  /** The ID of the work order */
  work_order_id: Scalars['uuid'];
};


/** Assignments of locations to work orders */
export type ArgoWorkOrderLocationMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.work_order_location" */
export type ArgoWorkOrderLocationAggregate = {
  __typename?: 'argo_work_order_location_aggregate';
  aggregate?: Maybe<ArgoWorkOrderLocationAggregateFields>;
  nodes: Array<ArgoWorkOrderLocation>;
};

export type ArgoWorkOrderLocationAggregateBoolExp = {
  count?: Maybe<ArgoWorkOrderLocationAggregateBoolExpCount>;
};

export type ArgoWorkOrderLocationAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoWorkOrderLocationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.work_order_location" */
export type ArgoWorkOrderLocationAggregateFields = {
  __typename?: 'argo_work_order_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderLocationMaxFields>;
  min?: Maybe<ArgoWorkOrderLocationMinFields>;
};


/** aggregate fields of "argo.work_order_location" */
export type ArgoWorkOrderLocationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.work_order_location" */
export type ArgoWorkOrderLocationAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoWorkOrderLocationMaxOrderBy>;
  min?: Maybe<ArgoWorkOrderLocationMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderLocationAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.work_order_location" */
export type ArgoWorkOrderLocationArrRelInsertInput = {
  data: Array<ArgoWorkOrderLocationInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderLocationOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.work_order_location". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderLocationBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderLocationBoolExp>>;
  _not?: Maybe<ArgoWorkOrderLocationBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderLocationBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_order?: Maybe<ArgoWorkOrderBoolExp>;
  work_order_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_location" */
export enum ArgoWorkOrderLocationConstraint {
  /** unique or primary key constraint on columns "work_order_location_id" */
  WorkOrderLocationPkey = 'work_order_location_pkey',
  /** unique or primary key constraint on columns "location_id", "work_order_id" */
  WorkOrderLocationUnique = 'work_order_location_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkOrderLocationDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkOrderLocationDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkOrderLocationDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.work_order_location" */
export type ArgoWorkOrderLocationInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** The ID of the location */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_order?: Maybe<ArgoWorkOrderObjRelInsertInput>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoWorkOrderLocationMaxFields = {
  __typename?: 'argo_work_order_location_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The ID of the location */
  location_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.work_order_location" */
export type ArgoWorkOrderLocationMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The ID of the location */
  location_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The ID of the work order */
  work_order_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoWorkOrderLocationMinFields = {
  __typename?: 'argo_work_order_location_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The ID of the location */
  location_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.work_order_location" */
export type ArgoWorkOrderLocationMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** The ID of the location */
  location_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The ID of the work order */
  work_order_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.work_order_location" */
export type ArgoWorkOrderLocationMutationResponse = {
  __typename?: 'argo_work_order_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderLocation>;
};

/** on_conflict condition type for table "argo.work_order_location" */
export type ArgoWorkOrderLocationOnConflict = {
  constraint: ArgoWorkOrderLocationConstraint;
  update_columns?: Array<ArgoWorkOrderLocationUpdateColumn>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_location". */
export type ArgoWorkOrderLocationOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_order?: Maybe<ArgoWorkOrderOrderBy>;
  work_order_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_location */
export type ArgoWorkOrderLocationPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderLocationPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.work_order_location" */
export enum ArgoWorkOrderLocationSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "argo.work_order_location" */
export type ArgoWorkOrderLocationSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The ID of the location */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_work_order_location" */
export type ArgoWorkOrderLocationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderLocationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderLocationStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The ID of the location */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.work_order_location" */
export enum ArgoWorkOrderLocationUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type ArgoWorkOrderLocationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkOrderLocationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkOrderLocationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkOrderLocationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkOrderLocationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkOrderLocationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderLocationSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderLocationBoolExp;
};

/** Material assignments for work orders */
export type ArgoWorkOrderMaterial = {
  __typename?: 'argo_work_order_material';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** The primary key */
  id: Scalars['uuid'];
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  material: ArgoMaterial;
  /** The ID of the material */
  material_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  work_order: ArgoWorkOrder;
  /** The ID of the work order */
  work_order_id: Scalars['uuid'];
};


/** Material assignments for work orders */
export type ArgoWorkOrderMaterialMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "argo.work_order_material" */
export type ArgoWorkOrderMaterialAggregate = {
  __typename?: 'argo_work_order_material_aggregate';
  aggregate?: Maybe<ArgoWorkOrderMaterialAggregateFields>;
  nodes: Array<ArgoWorkOrderMaterial>;
};

export type ArgoWorkOrderMaterialAggregateBoolExp = {
  count?: Maybe<ArgoWorkOrderMaterialAggregateBoolExpCount>;
};

export type ArgoWorkOrderMaterialAggregateBoolExpCount = {
  arguments?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ArgoWorkOrderMaterialBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "argo.work_order_material" */
export type ArgoWorkOrderMaterialAggregateFields = {
  __typename?: 'argo_work_order_material_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderMaterialMaxFields>;
  min?: Maybe<ArgoWorkOrderMaterialMinFields>;
};


/** aggregate fields of "argo.work_order_material" */
export type ArgoWorkOrderMaterialAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "argo.work_order_material" */
export type ArgoWorkOrderMaterialAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ArgoWorkOrderMaterialMaxOrderBy>;
  min?: Maybe<ArgoWorkOrderMaterialMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderMaterialAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "argo.work_order_material" */
export type ArgoWorkOrderMaterialArrRelInsertInput = {
  data: Array<ArgoWorkOrderMaterialInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderMaterialOnConflict>;
};

/** Boolean expression to filter rows from the table "argo.work_order_material". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderMaterialBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderMaterialBoolExp>>;
  _not?: Maybe<ArgoWorkOrderMaterialBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderMaterialBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location_id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
  work_order?: Maybe<ArgoWorkOrderBoolExp>;
  work_order_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialConstraint {
  /** unique or primary key constraint on columns "material_id" */
  WorkOrderMaterialOne = 'work_order_material_one',
  /** unique or primary key constraint on columns "work_order_material_id" */
  WorkOrderMaterialPkey = 'work_order_material_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ArgoWorkOrderMaterialDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ArgoWorkOrderMaterialDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ArgoWorkOrderMaterialDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "argo.work_order_material" */
export type ArgoWorkOrderMaterialInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  /** The ID of the material */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  work_order?: Maybe<ArgoWorkOrderObjRelInsertInput>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArgoWorkOrderMaterialMaxFields = {
  __typename?: 'argo_work_order_material_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  /** The ID of the material */
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "argo.work_order_material" */
export type ArgoWorkOrderMaterialMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<OrderBy>;
  /** The ID of the material */
  material_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The ID of the work order */
  work_order_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ArgoWorkOrderMaterialMinFields = {
  __typename?: 'argo_work_order_material_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  /** The ID of the material */
  material_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "argo.work_order_material" */
export type ArgoWorkOrderMaterialMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The primary key */
  id?: Maybe<OrderBy>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<OrderBy>;
  /** The ID of the material */
  material_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
  /** The ID of the work order */
  work_order_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "argo.work_order_material" */
export type ArgoWorkOrderMaterialMutationResponse = {
  __typename?: 'argo_work_order_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderMaterial>;
};

/** input type for inserting object relation for remote table "argo.work_order_material" */
export type ArgoWorkOrderMaterialObjRelInsertInput = {
  data: ArgoWorkOrderMaterialInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderMaterialOnConflict>;
};

/** on_conflict condition type for table "argo.work_order_material" */
export type ArgoWorkOrderMaterialOnConflict = {
  constraint: ArgoWorkOrderMaterialConstraint;
  update_columns?: Array<ArgoWorkOrderMaterialUpdateColumn>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_material". */
export type ArgoWorkOrderMaterialOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location_id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_order?: Maybe<ArgoWorkOrderOrderBy>;
  work_order_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_material */
export type ArgoWorkOrderMaterialPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderMaterialPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** input type for updating data in table "argo.work_order_material" */
export type ArgoWorkOrderMaterialSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  /** The ID of the material */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "argo_work_order_material" */
export type ArgoWorkOrderMaterialStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderMaterialStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderMaterialStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** Where the material was linked to the work order */
  location_id?: Maybe<Scalars['uuid']>;
  /** The ID of the material */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
  /** The ID of the work order */
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "argo.work_order_material" */
export enum ArgoWorkOrderMaterialUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

export type ArgoWorkOrderMaterialUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkOrderMaterialAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkOrderMaterialDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkOrderMaterialDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkOrderMaterialDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkOrderMaterialPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderMaterialSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderMaterialBoolExp;
};

/** aggregate max on columns */
export type ArgoWorkOrderMaxFields = {
  __typename?: 'argo_work_order_max_fields';
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The material model for this work order */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The work order number */
  order_number?: Maybe<Scalars['String']>;
  /** When the work order is planned to start */
  planned_start?: Maybe<Scalars['timestamptz']>;
  /** The note for the status of this work order */
  status_note?: Maybe<Scalars['String']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ArgoWorkOrderMinFields = {
  __typename?: 'argo_work_order_min_fields';
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The material model for this work order */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The work order number */
  order_number?: Maybe<Scalars['String']>;
  /** When the work order is planned to start */
  planned_start?: Maybe<Scalars['timestamptz']>;
  /** The note for the status of this work order */
  status_note?: Maybe<Scalars['String']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "argo.work_order" */
export type ArgoWorkOrderMutationResponse = {
  __typename?: 'argo_work_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrder>;
};

/** input type for inserting object relation for remote table "argo.work_order" */
export type ArgoWorkOrderObjRelInsertInput = {
  data: ArgoWorkOrderInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderOnConflict>;
};

/** on_conflict condition type for table "argo.work_order" */
export type ArgoWorkOrderOnConflict = {
  constraint: ArgoWorkOrderConstraint;
  update_columns?: Array<ArgoWorkOrderUpdateColumn>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order". */
export type ArgoWorkOrderOrderBy = {
  actual_start?: Maybe<OrderBy>;
  completed?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material_completed_count?: Maybe<OrderBy>;
  material_model?: Maybe<ArgoMaterialModelOrderBy>;
  material_model_id?: Maybe<OrderBy>;
  material_other_count?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  order_number?: Maybe<OrderBy>;
  planned_start?: Maybe<OrderBy>;
  restriction?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  status_note?: Maybe<OrderBy>;
  target_quantity?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
  work_order_locations_aggregate?: Maybe<ArgoWorkOrderLocationAggregateOrderBy>;
  work_order_materials_aggregate?: Maybe<ArgoWorkOrderMaterialAggregateOrderBy>;
  work_order_restriction?: Maybe<ArgoWorkOrderRestrictionOrderBy>;
  work_order_status?: Maybe<ArgoWorkOrderStatusOrderBy>;
};

/** primary key columns input for table: argo.work_order */
export type ArgoWorkOrderPkColumnsInput = {
  /** The primary key */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ArgoWorkOrderPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "argo.work_order_restriction" */
export type ArgoWorkOrderRestriction = {
  __typename?: 'argo_work_order_restriction';
  description: Scalars['String'];
  restriction: Scalars['String'];
};

/** aggregated selection of "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionAggregate = {
  __typename?: 'argo_work_order_restriction_aggregate';
  aggregate?: Maybe<ArgoWorkOrderRestrictionAggregateFields>;
  nodes: Array<ArgoWorkOrderRestriction>;
};

/** aggregate fields of "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionAggregateFields = {
  __typename?: 'argo_work_order_restriction_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderRestrictionMaxFields>;
  min?: Maybe<ArgoWorkOrderRestrictionMinFields>;
};


/** aggregate fields of "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderRestrictionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_order_restriction". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderRestrictionBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderRestrictionBoolExp>>;
  _not?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderRestrictionBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  restriction?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionConstraint {
  /** unique or primary key constraint on columns "restriction" */
  WorkOrderRestrictionPkey = 'work_order_restriction_pkey'
}

export enum ArgoWorkOrderRestrictionEnum {
  /** Can be completed at anytime */
  None = 'none',
  /** Only after the target quantity of associated material has been reached and completed, can the work order be completed */
  TargetQuantityCompleted = 'target_quantity_completed',
  /** Only after the target quantity of associated material has been reached, can the work order be completed */
  TargetQuantityCreated = 'target_quantity_created'
}

/** Boolean expression to compare columns of type "argo_work_order_restriction_enum". All fields are combined with logical 'AND'. */
export type ArgoWorkOrderRestrictionEnumComparisonExp = {
  _eq?: Maybe<ArgoWorkOrderRestrictionEnum>;
  _in?: Maybe<Array<ArgoWorkOrderRestrictionEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoWorkOrderRestrictionEnum>;
  _nin?: Maybe<Array<ArgoWorkOrderRestrictionEnum>>;
};

/** input type for inserting data into table "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionInsertInput = {
  description?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoWorkOrderRestrictionMaxFields = {
  __typename?: 'argo_work_order_restriction_max_fields';
  description?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoWorkOrderRestrictionMinFields = {
  __typename?: 'argo_work_order_restriction_min_fields';
  description?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionMutationResponse = {
  __typename?: 'argo_work_order_restriction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderRestriction>;
};

/** input type for inserting object relation for remote table "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionObjRelInsertInput = {
  data: ArgoWorkOrderRestrictionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderRestrictionOnConflict>;
};

/** on_conflict condition type for table "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionOnConflict = {
  constraint: ArgoWorkOrderRestrictionConstraint;
  update_columns?: Array<ArgoWorkOrderRestrictionUpdateColumn>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_restriction". */
export type ArgoWorkOrderRestrictionOrderBy = {
  description?: Maybe<OrderBy>;
  restriction?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_restriction */
export type ArgoWorkOrderRestrictionPkColumnsInput = {
  restriction: Scalars['String'];
};

/** select columns of table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Restriction = 'restriction'
}

/** input type for updating data in table "argo.work_order_restriction" */
export type ArgoWorkOrderRestrictionSetInput = {
  description?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_work_order_restriction" */
export type ArgoWorkOrderRestrictionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderRestrictionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderRestrictionStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Restriction = 'restriction'
}

export type ArgoWorkOrderRestrictionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderRestrictionSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderRestrictionBoolExp;
};

/** select columns of table "argo.work_order" */
export enum ArgoWorkOrderSelectColumn {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlannedStart = 'planned_start',
  /** column name */
  Restriction = 'restriction',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "argo.work_order" */
export type ArgoWorkOrderSetInput = {
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model for this work order */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The work order number */
  order_number?: Maybe<Scalars['String']>;
  /** When the work order is planned to start */
  planned_start?: Maybe<Scalars['timestamptz']>;
  /** The restriction method used to complete this work order */
  restriction?: Maybe<ArgoWorkOrderRestrictionEnum>;
  /** The status of this work order */
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  /** The note for the status of this work order */
  status_note?: Maybe<Scalars['String']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

export type ArgoWorkOrderSetStatusArgs = {
  status?: Maybe<Scalars['String']>;
  status_note?: Maybe<Scalars['String']>;
  work_order_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "argo.work_order_status" */
export type ArgoWorkOrderStatus = {
  __typename?: 'argo_work_order_status';
  description: Scalars['String'];
  status: Scalars['String'];
};

/** aggregated selection of "argo.work_order_status" */
export type ArgoWorkOrderStatusAggregate = {
  __typename?: 'argo_work_order_status_aggregate';
  aggregate?: Maybe<ArgoWorkOrderStatusAggregateFields>;
  nodes: Array<ArgoWorkOrderStatus>;
};

/** aggregate fields of "argo.work_order_status" */
export type ArgoWorkOrderStatusAggregateFields = {
  __typename?: 'argo_work_order_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ArgoWorkOrderStatusMaxFields>;
  min?: Maybe<ArgoWorkOrderStatusMinFields>;
};


/** aggregate fields of "argo.work_order_status" */
export type ArgoWorkOrderStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ArgoWorkOrderStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "argo.work_order_status". All fields are combined with a logical 'AND'. */
export type ArgoWorkOrderStatusBoolExp = {
  _and?: Maybe<Array<ArgoWorkOrderStatusBoolExp>>;
  _not?: Maybe<ArgoWorkOrderStatusBoolExp>;
  _or?: Maybe<Array<ArgoWorkOrderStatusBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "argo.work_order_status" */
export enum ArgoWorkOrderStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  WorkOrderStatusPkey = 'work_order_status_pkey'
}

export enum ArgoWorkOrderStatusEnum {
  /** The work order has been completed */
  Completed = 'completed',
  /** The work order has been manually completed */
  ManuallyCompleted = 'manually_completed',
  /** The work order ready for production */
  Released = 'released',
  /** The work order is not ready for production */
  Staged = 'staged'
}

/** Boolean expression to compare columns of type "argo_work_order_status_enum". All fields are combined with logical 'AND'. */
export type ArgoWorkOrderStatusEnumComparisonExp = {
  _eq?: Maybe<ArgoWorkOrderStatusEnum>;
  _in?: Maybe<Array<ArgoWorkOrderStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ArgoWorkOrderStatusEnum>;
  _nin?: Maybe<Array<ArgoWorkOrderStatusEnum>>;
};

/** input type for inserting data into table "argo.work_order_status" */
export type ArgoWorkOrderStatusInsertInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArgoWorkOrderStatusMaxFields = {
  __typename?: 'argo_work_order_status_max_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ArgoWorkOrderStatusMinFields = {
  __typename?: 'argo_work_order_status_min_fields';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "argo.work_order_status" */
export type ArgoWorkOrderStatusMutationResponse = {
  __typename?: 'argo_work_order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArgoWorkOrderStatus>;
};

/** input type for inserting object relation for remote table "argo.work_order_status" */
export type ArgoWorkOrderStatusObjRelInsertInput = {
  data: ArgoWorkOrderStatusInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ArgoWorkOrderStatusOnConflict>;
};

/** on_conflict condition type for table "argo.work_order_status" */
export type ArgoWorkOrderStatusOnConflict = {
  constraint: ArgoWorkOrderStatusConstraint;
  update_columns?: Array<ArgoWorkOrderStatusUpdateColumn>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};

/** Ordering options when selecting data from "argo.work_order_status". */
export type ArgoWorkOrderStatusOrderBy = {
  description?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: argo.work_order_status */
export type ArgoWorkOrderStatusPkColumnsInput = {
  status: Scalars['String'];
};

/** select columns of table "argo.work_order_status" */
export enum ArgoWorkOrderStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "argo.work_order_status" */
export type ArgoWorkOrderStatusSetInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "argo_work_order_status" */
export type ArgoWorkOrderStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderStatusStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "argo.work_order_status" */
export enum ArgoWorkOrderStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type ArgoWorkOrderStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderStatusBoolExp;
};

/** aggregate stddev on columns */
export type ArgoWorkOrderStddevFields = {
  __typename?: 'argo_work_order_stddev_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArgoWorkOrderStddevPopFields = {
  __typename?: 'argo_work_order_stddev_pop_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArgoWorkOrderStddevSampFields = {
  __typename?: 'argo_work_order_stddev_samp_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "argo_work_order" */
export type ArgoWorkOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArgoWorkOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArgoWorkOrderStreamCursorValueInput = {
  /** When the work order actually started */
  actual_start?: Maybe<Scalars['timestamptz']>;
  /** When the work order was completed */
  completed?: Maybe<Scalars['timestamptz']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The primary key */
  id?: Maybe<Scalars['uuid']>;
  /** The material model for this work order */
  material_model_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The work order number */
  order_number?: Maybe<Scalars['String']>;
  /** When the work order is planned to start */
  planned_start?: Maybe<Scalars['timestamptz']>;
  /** The restriction method used to complete this work order */
  restriction?: Maybe<ArgoWorkOrderRestrictionEnum>;
  /** The status of this work order */
  status?: Maybe<ArgoWorkOrderStatusEnum>;
  /** The note for the status of this work order */
  status_note?: Maybe<Scalars['String']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ArgoWorkOrderSumFields = {
  __typename?: 'argo_work_order_sum_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "argo.work_order" */
export enum ArgoWorkOrderUpdateColumn {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlannedStart = 'planned_start',
  /** column name */
  Restriction = 'restriction',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ArgoWorkOrderUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ArgoWorkOrderAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ArgoWorkOrderDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ArgoWorkOrderDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ArgoWorkOrderDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ArgoWorkOrderIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ArgoWorkOrderPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ArgoWorkOrderSetInput>;
  /** filter the rows which have to be updated */
  where: ArgoWorkOrderBoolExp;
};

/** aggregate var_pop on columns */
export type ArgoWorkOrderVarPopFields = {
  __typename?: 'argo_work_order_var_pop_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArgoWorkOrderVarSampFields = {
  __typename?: 'argo_work_order_var_samp_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArgoWorkOrderVarianceFields = {
  __typename?: 'argo_work_order_variance_fields';
  /** The count of material with a material-status of completed */
  material_completed_count?: Maybe<Scalars['Int']>;
  /** The count of material with a material-status that is not completed */
  material_other_count?: Maybe<Scalars['Int']>;
  /** The target quantity of material expected */
  target_quantity?: Maybe<Scalars['Float']>;
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Assets */
export type FisAsset = {
  __typename?: 'fis_asset';
  /** An array relationship */
  asset_tag_links: Array<FisAssetTagLink>;
  /** An aggregate relationship */
  asset_tag_links_aggregate: FisAssetTagLinkAggregate;
  /** An object relationship */
  asset_type?: Maybe<FisAssetType>;
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time: Scalars['Int'];
  /** A place to provide a more lengthy description than the name */
  description: Scalars['String'];
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  location: ArgoLocation;
  /** The location for this entry */
  location_id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name: Scalars['String'];
  /** A case-insensitive name */
  name_unique: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Assets */
export type FisAssetAssetTagLinksArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


/** Assets */
export type FisAssetAssetTagLinksAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


/** Assets */
export type FisAssetMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.asset" */
export type FisAssetAggregate = {
  __typename?: 'fis_asset_aggregate';
  aggregate?: Maybe<FisAssetAggregateFields>;
  nodes: Array<FisAsset>;
};

export type FisAssetAggregateBoolExp = {
  bool_and?: Maybe<FisAssetAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<FisAssetAggregateBoolExpBoolOr>;
  count?: Maybe<FisAssetAggregateBoolExpCount>;
};

export type FisAssetAggregateBoolExpBoolAnd = {
  arguments: FisAssetSelectColumnFisAssetAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisAssetBoolExp>;
  predicate: BooleanComparisonExp;
};

export type FisAssetAggregateBoolExpBoolOr = {
  arguments: FisAssetSelectColumnFisAssetAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisAssetBoolExp>;
  predicate: BooleanComparisonExp;
};

export type FisAssetAggregateBoolExpCount = {
  arguments?: Maybe<Array<FisAssetSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisAssetBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "fis.asset" */
export type FisAssetAggregateFields = {
  __typename?: 'fis_asset_aggregate_fields';
  avg?: Maybe<FisAssetAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisAssetMaxFields>;
  min?: Maybe<FisAssetMinFields>;
  stddev?: Maybe<FisAssetStddevFields>;
  stddev_pop?: Maybe<FisAssetStddevPopFields>;
  stddev_samp?: Maybe<FisAssetStddevSampFields>;
  sum?: Maybe<FisAssetSumFields>;
  var_pop?: Maybe<FisAssetVarPopFields>;
  var_samp?: Maybe<FisAssetVarSampFields>;
  variance?: Maybe<FisAssetVarianceFields>;
};


/** aggregate fields of "fis.asset" */
export type FisAssetAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisAssetSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fis.asset" */
export type FisAssetAggregateOrderBy = {
  avg?: Maybe<FisAssetAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<FisAssetMaxOrderBy>;
  min?: Maybe<FisAssetMinOrderBy>;
  stddev?: Maybe<FisAssetStddevOrderBy>;
  stddev_pop?: Maybe<FisAssetStddevPopOrderBy>;
  stddev_samp?: Maybe<FisAssetStddevSampOrderBy>;
  sum?: Maybe<FisAssetSumOrderBy>;
  var_pop?: Maybe<FisAssetVarPopOrderBy>;
  var_samp?: Maybe<FisAssetVarSampOrderBy>;
  variance?: Maybe<FisAssetVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisAssetAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "fis.asset" */
export type FisAssetArrRelInsertInput = {
  data: Array<FisAssetInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetOnConflict>;
};

/** aggregate avg on columns */
export type FisAssetAvgFields = {
  __typename?: 'fis_asset_avg_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fis.asset" */
export type FisAssetAvgOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "fis.asset". All fields are combined with a logical 'AND'. */
export type FisAssetBoolExp = {
  _and?: Maybe<Array<FisAssetBoolExp>>;
  _not?: Maybe<FisAssetBoolExp>;
  _or?: Maybe<Array<FisAssetBoolExp>>;
  asset_tag_links?: Maybe<FisAssetTagLinkBoolExp>;
  asset_tag_links_aggregate?: Maybe<FisAssetTagLinkAggregateBoolExp>;
  asset_type?: Maybe<FisAssetTypeBoolExp>;
  asset_type_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  cycle_time?: Maybe<IntComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** Asset Code Description */
export type FisAssetCode = {
  __typename?: 'fis_asset_code';
  /** An object relationship */
  asset_type: FisAssetType;
  /** The Asset Type for this code */
  asset_type_id: Scalars['uuid'];
  /** The machine code */
  code: Scalars['Int'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  core_state: FisCoreStateEnum;
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  data_label: FisDataLabel;
  /** The data label this code references */
  data_label_id: Scalars['uuid'];
  /** The description of the code */
  description: Scalars['String'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Asset Code Description */
export type FisAssetCodeMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.asset_code" */
export type FisAssetCodeAggregate = {
  __typename?: 'fis_asset_code_aggregate';
  aggregate?: Maybe<FisAssetCodeAggregateFields>;
  nodes: Array<FisAssetCode>;
};

export type FisAssetCodeAggregateBoolExp = {
  count?: Maybe<FisAssetCodeAggregateBoolExpCount>;
};

export type FisAssetCodeAggregateBoolExpCount = {
  arguments?: Maybe<Array<FisAssetCodeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisAssetCodeBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "fis.asset_code" */
export type FisAssetCodeAggregateFields = {
  __typename?: 'fis_asset_code_aggregate_fields';
  avg?: Maybe<FisAssetCodeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisAssetCodeMaxFields>;
  min?: Maybe<FisAssetCodeMinFields>;
  stddev?: Maybe<FisAssetCodeStddevFields>;
  stddev_pop?: Maybe<FisAssetCodeStddevPopFields>;
  stddev_samp?: Maybe<FisAssetCodeStddevSampFields>;
  sum?: Maybe<FisAssetCodeSumFields>;
  var_pop?: Maybe<FisAssetCodeVarPopFields>;
  var_samp?: Maybe<FisAssetCodeVarSampFields>;
  variance?: Maybe<FisAssetCodeVarianceFields>;
};


/** aggregate fields of "fis.asset_code" */
export type FisAssetCodeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisAssetCodeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fis.asset_code" */
export type FisAssetCodeAggregateOrderBy = {
  avg?: Maybe<FisAssetCodeAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<FisAssetCodeMaxOrderBy>;
  min?: Maybe<FisAssetCodeMinOrderBy>;
  stddev?: Maybe<FisAssetCodeStddevOrderBy>;
  stddev_pop?: Maybe<FisAssetCodeStddevPopOrderBy>;
  stddev_samp?: Maybe<FisAssetCodeStddevSampOrderBy>;
  sum?: Maybe<FisAssetCodeSumOrderBy>;
  var_pop?: Maybe<FisAssetCodeVarPopOrderBy>;
  var_samp?: Maybe<FisAssetCodeVarSampOrderBy>;
  variance?: Maybe<FisAssetCodeVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisAssetCodeAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "fis.asset_code" */
export type FisAssetCodeArrRelInsertInput = {
  data: Array<FisAssetCodeInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetCodeOnConflict>;
};

/** aggregate avg on columns */
export type FisAssetCodeAvgFields = {
  __typename?: 'fis_asset_code_avg_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fis.asset_code" */
export type FisAssetCodeAvgOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "fis.asset_code". All fields are combined with a logical 'AND'. */
export type FisAssetCodeBoolExp = {
  _and?: Maybe<Array<FisAssetCodeBoolExp>>;
  _not?: Maybe<FisAssetCodeBoolExp>;
  _or?: Maybe<Array<FisAssetCodeBoolExp>>;
  asset_type?: Maybe<FisAssetTypeBoolExp>;
  asset_type_id?: Maybe<UuidComparisonExp>;
  code?: Maybe<IntComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  core_state?: Maybe<FisCoreStateEnumComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "fis.asset_code" */
export enum FisAssetCodeConstraint {
  /** unique or primary key constraint on columns "asset_code_id" */
  AssetCodePkey = 'asset_code_pkey',
  /** unique or primary key constraint on columns "context_id", "data_label_id", "asset_type_id", "code" */
  AssetCodeUniqueCode = 'asset_code_unique_code'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisAssetCodeDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisAssetCodeDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisAssetCodeDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.asset_code" */
export type FisAssetCodeIncInput = {
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "fis.asset_code" */
export type FisAssetCodeInsertInput = {
  asset_type?: Maybe<FisAssetTypeObjRelInsertInput>;
  /** The Asset Type for this code */
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  core_state?: Maybe<FisCoreStateEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  data_label?: Maybe<FisDataLabelObjRelInsertInput>;
  /** The data label this code references */
  data_label_id?: Maybe<Scalars['uuid']>;
  /** The description of the code */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FisAssetCodeMaxFields = {
  __typename?: 'fis_asset_code_max_fields';
  /** The Asset Type for this code */
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data label this code references */
  data_label_id?: Maybe<Scalars['uuid']>;
  /** The description of the code */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "fis.asset_code" */
export type FisAssetCodeMaxOrderBy = {
  /** The Asset Type for this code */
  asset_type_id?: Maybe<OrderBy>;
  /** The machine code */
  code?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The data label this code references */
  data_label_id?: Maybe<OrderBy>;
  /** The description of the code */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type FisAssetCodeMinFields = {
  __typename?: 'fis_asset_code_min_fields';
  /** The Asset Type for this code */
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data label this code references */
  data_label_id?: Maybe<Scalars['uuid']>;
  /** The description of the code */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "fis.asset_code" */
export type FisAssetCodeMinOrderBy = {
  /** The Asset Type for this code */
  asset_type_id?: Maybe<OrderBy>;
  /** The machine code */
  code?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The data label this code references */
  data_label_id?: Maybe<OrderBy>;
  /** The description of the code */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "fis.asset_code" */
export type FisAssetCodeMutationResponse = {
  __typename?: 'fis_asset_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisAssetCode>;
};

/** on_conflict condition type for table "fis.asset_code" */
export type FisAssetCodeOnConflict = {
  constraint: FisAssetCodeConstraint;
  update_columns?: Array<FisAssetCodeUpdateColumn>;
  where?: Maybe<FisAssetCodeBoolExp>;
};

/** Ordering options when selecting data from "fis.asset_code". */
export type FisAssetCodeOrderBy = {
  asset_type?: Maybe<FisAssetTypeOrderBy>;
  asset_type_id?: Maybe<OrderBy>;
  code?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  core_state?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.asset_code */
export type FisAssetCodePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisAssetCodePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.asset_code" */
export enum FisAssetCodeSelectColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CoreState = 'core_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "fis.asset_code" */
export type FisAssetCodeSetInput = {
  /** The Asset Type for this code */
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  core_state?: Maybe<FisCoreStateEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data label this code references */
  data_label_id?: Maybe<Scalars['uuid']>;
  /** The description of the code */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type FisAssetCodeStddevFields = {
  __typename?: 'fis_asset_code_stddev_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fis.asset_code" */
export type FisAssetCodeStddevOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type FisAssetCodeStddevPopFields = {
  __typename?: 'fis_asset_code_stddev_pop_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fis.asset_code" */
export type FisAssetCodeStddevPopOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type FisAssetCodeStddevSampFields = {
  __typename?: 'fis_asset_code_stddev_samp_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fis.asset_code" */
export type FisAssetCodeStddevSampOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "fis_asset_code" */
export type FisAssetCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisAssetCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisAssetCodeStreamCursorValueInput = {
  /** The Asset Type for this code */
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  core_state?: Maybe<FisCoreStateEnum>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The data label this code references */
  data_label_id?: Maybe<Scalars['uuid']>;
  /** The description of the code */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type FisAssetCodeSumFields = {
  __typename?: 'fis_asset_code_sum_fields';
  /** The machine code */
  code?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "fis.asset_code" */
export type FisAssetCodeSumOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** update columns of table "fis.asset_code" */
export enum FisAssetCodeUpdateColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CoreState = 'core_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type FisAssetCodeUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisAssetCodeAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisAssetCodeDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisAssetCodeDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisAssetCodeDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisAssetCodeIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisAssetCodePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisAssetCodeSetInput>;
  /** filter the rows which have to be updated */
  where: FisAssetCodeBoolExp;
};

/** aggregate var_pop on columns */
export type FisAssetCodeVarPopFields = {
  __typename?: 'fis_asset_code_var_pop_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fis.asset_code" */
export type FisAssetCodeVarPopOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type FisAssetCodeVarSampFields = {
  __typename?: 'fis_asset_code_var_samp_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fis.asset_code" */
export type FisAssetCodeVarSampOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type FisAssetCodeVarianceFields = {
  __typename?: 'fis_asset_code_variance_fields';
  /** The machine code */
  code?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fis.asset_code" */
export type FisAssetCodeVarianceOrderBy = {
  /** The machine code */
  code?: Maybe<OrderBy>;
};

/** unique or primary key constraints on table "fis.asset" */
export enum FisAssetConstraint {
  /** unique or primary key constraint on columns "asset_id", "asset_type_id" */
  AssetAssetIdAssetTypeIdFkey = 'asset_asset_id_asset_type_id_fkey',
  /** unique or primary key constraint on columns "context_id", "name_unique", "location_id" */
  AssetNameKey = 'asset_name_key',
  /** unique or primary key constraint on columns "asset_id" */
  AssetPkey = 'asset_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisAssetDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisAssetDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisAssetDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.asset" */
export type FisAssetIncInput = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "fis.asset" */
export type FisAssetInsertInput = {
  asset_tag_links?: Maybe<FisAssetTagLinkArrRelInsertInput>;
  asset_type?: Maybe<FisAssetTypeObjRelInsertInput>;
  asset_type_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FisAssetMaxFields = {
  __typename?: 'fis_asset_max_fields';
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "fis.asset" */
export type FisAssetMaxOrderBy = {
  asset_type_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The location for this entry */
  location_id?: Maybe<OrderBy>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<OrderBy>;
  /** A case-insensitive name */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type FisAssetMinFields = {
  __typename?: 'fis_asset_min_fields';
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "fis.asset" */
export type FisAssetMinOrderBy = {
  asset_type_id?: Maybe<OrderBy>;
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The location for this entry */
  location_id?: Maybe<OrderBy>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<OrderBy>;
  /** A case-insensitive name */
  name_unique?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "fis.asset" */
export type FisAssetMutationResponse = {
  __typename?: 'fis_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisAsset>;
};

/** input type for inserting object relation for remote table "fis.asset" */
export type FisAssetObjRelInsertInput = {
  data: FisAssetInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetOnConflict>;
};

/** on_conflict condition type for table "fis.asset" */
export type FisAssetOnConflict = {
  constraint: FisAssetConstraint;
  update_columns?: Array<FisAssetUpdateColumn>;
  where?: Maybe<FisAssetBoolExp>;
};

/** Ordering options when selecting data from "fis.asset". */
export type FisAssetOrderBy = {
  asset_tag_links_aggregate?: Maybe<FisAssetTagLinkAggregateOrderBy>;
  asset_type?: Maybe<FisAssetTypeOrderBy>;
  asset_type_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  cycle_time?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.asset */
export type FisAssetPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisAssetPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.asset" */
export enum FisAssetSelectColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "fis_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fis.asset" */
export enum FisAssetSelectColumnFisAssetAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "fis_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fis.asset" */
export enum FisAssetSelectColumnFisAssetAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "fis.asset" */
export type FisAssetSetInput = {
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type FisAssetStddevFields = {
  __typename?: 'fis_asset_stddev_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fis.asset" */
export type FisAssetStddevOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type FisAssetStddevPopFields = {
  __typename?: 'fis_asset_stddev_pop_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fis.asset" */
export type FisAssetStddevPopOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type FisAssetStddevSampFields = {
  __typename?: 'fis_asset_stddev_samp_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fis.asset" */
export type FisAssetStddevSampOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "fis_asset" */
export type FisAssetStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisAssetStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisAssetStreamCursorValueInput = {
  asset_type_id?: Maybe<Scalars['uuid']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
  /** A place to provide a more lengthy description than the name */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A an auto-generated case-sensitive name, usually unique per context_id */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive name */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** The Argonaut user who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type FisAssetSumFields = {
  __typename?: 'fis_asset_sum_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "fis.asset" */
export type FisAssetSumOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** Asset Tags */
export type FisAssetTag = {
  __typename?: 'fis_asset_tag';
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  context_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  name: Scalars['String'];
};


/** Asset Tags */
export type FisAssetTagMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.asset_tag" */
export type FisAssetTagAggregate = {
  __typename?: 'fis_asset_tag_aggregate';
  aggregate?: Maybe<FisAssetTagAggregateFields>;
  nodes: Array<FisAssetTag>;
};

/** aggregate fields of "fis.asset_tag" */
export type FisAssetTagAggregateFields = {
  __typename?: 'fis_asset_tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisAssetTagMaxFields>;
  min?: Maybe<FisAssetTagMinFields>;
};


/** aggregate fields of "fis.asset_tag" */
export type FisAssetTagAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisAssetTagSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisAssetTagAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "fis.asset_tag". All fields are combined with a logical 'AND'. */
export type FisAssetTagBoolExp = {
  _and?: Maybe<Array<FisAssetTagBoolExp>>;
  _not?: Maybe<FisAssetTagBoolExp>;
  _or?: Maybe<Array<FisAssetTagBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "fis.asset_tag" */
export enum FisAssetTagConstraint {
  /** unique or primary key constraint on columns "asset_tag_id" */
  AssetTagPkey = 'asset_tag_pkey',
  /** unique or primary key constraint on columns "context_id", "name" */
  AssetTagUniqueName = 'asset_tag_unique_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisAssetTagDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisAssetTagDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisAssetTagDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "fis.asset_tag" */
export type FisAssetTagInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
};

/** Asset Tag Links */
export type FisAssetTagLink = {
  __typename?: 'fis_asset_tag_link';
  /** An object relationship */
  asset: FisAsset;
  asset_id: Scalars['uuid'];
  /** An object relationship */
  asset_tag: FisAssetTag;
  asset_tag_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "fis.asset_tag_link" */
export type FisAssetTagLinkAggregate = {
  __typename?: 'fis_asset_tag_link_aggregate';
  aggregate?: Maybe<FisAssetTagLinkAggregateFields>;
  nodes: Array<FisAssetTagLink>;
};

export type FisAssetTagLinkAggregateBoolExp = {
  count?: Maybe<FisAssetTagLinkAggregateBoolExpCount>;
};

export type FisAssetTagLinkAggregateBoolExpCount = {
  arguments?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisAssetTagLinkBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "fis.asset_tag_link" */
export type FisAssetTagLinkAggregateFields = {
  __typename?: 'fis_asset_tag_link_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisAssetTagLinkMaxFields>;
  min?: Maybe<FisAssetTagLinkMinFields>;
};


/** aggregate fields of "fis.asset_tag_link" */
export type FisAssetTagLinkAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fis.asset_tag_link" */
export type FisAssetTagLinkAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<FisAssetTagLinkMaxOrderBy>;
  min?: Maybe<FisAssetTagLinkMinOrderBy>;
};

/** input type for inserting array relation for remote table "fis.asset_tag_link" */
export type FisAssetTagLinkArrRelInsertInput = {
  data: Array<FisAssetTagLinkInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetTagLinkOnConflict>;
};

/** Boolean expression to filter rows from the table "fis.asset_tag_link". All fields are combined with a logical 'AND'. */
export type FisAssetTagLinkBoolExp = {
  _and?: Maybe<Array<FisAssetTagLinkBoolExp>>;
  _not?: Maybe<FisAssetTagLinkBoolExp>;
  _or?: Maybe<Array<FisAssetTagLinkBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  asset_tag?: Maybe<FisAssetTagBoolExp>;
  asset_tag_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "fis.asset_tag_link" */
export enum FisAssetTagLinkConstraint {
  /** unique or primary key constraint on columns "asset_tag_link_id" */
  AssetTagLinkPkey = 'asset_tag_link_pkey',
  /** unique or primary key constraint on columns "asset_id", "asset_tag_id" */
  AssetTagLinkUnique = 'asset_tag_link_unique'
}

/** input type for inserting data into table "fis.asset_tag_link" */
export type FisAssetTagLinkInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  asset_id?: Maybe<Scalars['uuid']>;
  asset_tag?: Maybe<FisAssetTagObjRelInsertInput>;
  asset_tag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FisAssetTagLinkMaxFields = {
  __typename?: 'fis_asset_tag_link_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  asset_tag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "fis.asset_tag_link" */
export type FisAssetTagLinkMaxOrderBy = {
  asset_id?: Maybe<OrderBy>;
  asset_tag_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type FisAssetTagLinkMinFields = {
  __typename?: 'fis_asset_tag_link_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  asset_tag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "fis.asset_tag_link" */
export type FisAssetTagLinkMinOrderBy = {
  asset_id?: Maybe<OrderBy>;
  asset_tag_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "fis.asset_tag_link" */
export type FisAssetTagLinkMutationResponse = {
  __typename?: 'fis_asset_tag_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisAssetTagLink>;
};

/** on_conflict condition type for table "fis.asset_tag_link" */
export type FisAssetTagLinkOnConflict = {
  constraint: FisAssetTagLinkConstraint;
  update_columns?: Array<FisAssetTagLinkUpdateColumn>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};

/** Ordering options when selecting data from "fis.asset_tag_link". */
export type FisAssetTagLinkOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  asset_tag?: Maybe<FisAssetTagOrderBy>;
  asset_tag_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.asset_tag_link */
export type FisAssetTagLinkPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "fis.asset_tag_link" */
export enum FisAssetTagLinkSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AssetTagId = 'asset_tag_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "fis.asset_tag_link" */
export type FisAssetTagLinkSetInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  asset_tag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fis_asset_tag_link" */
export type FisAssetTagLinkStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisAssetTagLinkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisAssetTagLinkStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  asset_tag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "fis.asset_tag_link" */
export enum FisAssetTagLinkUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AssetTagId = 'asset_tag_id',
  /** column name */
  Id = 'id'
}

export type FisAssetTagLinkUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisAssetTagLinkSetInput>;
  /** filter the rows which have to be updated */
  where: FisAssetTagLinkBoolExp;
};

/** aggregate max on columns */
export type FisAssetTagMaxFields = {
  __typename?: 'fis_asset_tag_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FisAssetTagMinFields = {
  __typename?: 'fis_asset_tag_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fis.asset_tag" */
export type FisAssetTagMutationResponse = {
  __typename?: 'fis_asset_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisAssetTag>;
};

/** input type for inserting object relation for remote table "fis.asset_tag" */
export type FisAssetTagObjRelInsertInput = {
  data: FisAssetTagInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetTagOnConflict>;
};

/** on_conflict condition type for table "fis.asset_tag" */
export type FisAssetTagOnConflict = {
  constraint: FisAssetTagConstraint;
  update_columns?: Array<FisAssetTagUpdateColumn>;
  where?: Maybe<FisAssetTagBoolExp>;
};

/** Ordering options when selecting data from "fis.asset_tag". */
export type FisAssetTagOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.asset_tag */
export type FisAssetTagPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisAssetTagPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.asset_tag" */
export enum FisAssetTagSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "fis.asset_tag" */
export type FisAssetTagSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "fis_asset_tag" */
export type FisAssetTagStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisAssetTagStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisAssetTagStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "fis.asset_tag" */
export enum FisAssetTagUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

export type FisAssetTagUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisAssetTagAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisAssetTagDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisAssetTagDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisAssetTagDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisAssetTagPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisAssetTagSetInput>;
  /** filter the rows which have to be updated */
  where: FisAssetTagBoolExp;
};

/** Vendor Entry */
export type FisAssetType = {
  __typename?: 'fis_asset_type';
  /** An array relationship */
  asset_codes: Array<FisAssetCode>;
  /** An aggregate relationship */
  asset_codes_aggregate: FisAssetCodeAggregate;
  /** An array relationship */
  assets: Array<FisAsset>;
  /** An aggregate relationship */
  assets_aggregate: FisAssetAggregate;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Vendor Entry */
export type FisAssetTypeAssetCodesArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


/** Vendor Entry */
export type FisAssetTypeAssetCodesAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


/** Vendor Entry */
export type FisAssetTypeAssetsArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


/** Vendor Entry */
export type FisAssetTypeAssetsAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


/** Vendor Entry */
export type FisAssetTypeMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.asset_type" */
export type FisAssetTypeAggregate = {
  __typename?: 'fis_asset_type_aggregate';
  aggregate?: Maybe<FisAssetTypeAggregateFields>;
  nodes: Array<FisAssetType>;
};

/** aggregate fields of "fis.asset_type" */
export type FisAssetTypeAggregateFields = {
  __typename?: 'fis_asset_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisAssetTypeMaxFields>;
  min?: Maybe<FisAssetTypeMinFields>;
};


/** aggregate fields of "fis.asset_type" */
export type FisAssetTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisAssetTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisAssetTypeAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "fis.asset_type". All fields are combined with a logical 'AND'. */
export type FisAssetTypeBoolExp = {
  _and?: Maybe<Array<FisAssetTypeBoolExp>>;
  _not?: Maybe<FisAssetTypeBoolExp>;
  _or?: Maybe<Array<FisAssetTypeBoolExp>>;
  asset_codes?: Maybe<FisAssetCodeBoolExp>;
  asset_codes_aggregate?: Maybe<FisAssetCodeAggregateBoolExp>;
  assets?: Maybe<FisAssetBoolExp>;
  assets_aggregate?: Maybe<FisAssetAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "fis.asset_type" */
export enum FisAssetTypeConstraint {
  /** unique or primary key constraint on columns "asset_type_id" */
  AssetTypePkey = 'asset_type_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AssetTypeUniqueName = 'asset_type_unique_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisAssetTypeDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisAssetTypeDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisAssetTypeDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "fis.asset_type" */
export type FisAssetTypeInsertInput = {
  asset_codes?: Maybe<FisAssetCodeArrRelInsertInput>;
  assets?: Maybe<FisAssetArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FisAssetTypeMaxFields = {
  __typename?: 'fis_asset_type_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type FisAssetTypeMinFields = {
  __typename?: 'fis_asset_type_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fis.asset_type" */
export type FisAssetTypeMutationResponse = {
  __typename?: 'fis_asset_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisAssetType>;
};

/** input type for inserting object relation for remote table "fis.asset_type" */
export type FisAssetTypeObjRelInsertInput = {
  data: FisAssetTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisAssetTypeOnConflict>;
};

/** on_conflict condition type for table "fis.asset_type" */
export type FisAssetTypeOnConflict = {
  constraint: FisAssetTypeConstraint;
  update_columns?: Array<FisAssetTypeUpdateColumn>;
  where?: Maybe<FisAssetTypeBoolExp>;
};

/** Ordering options when selecting data from "fis.asset_type". */
export type FisAssetTypeOrderBy = {
  asset_codes_aggregate?: Maybe<FisAssetCodeAggregateOrderBy>;
  assets_aggregate?: Maybe<FisAssetAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.asset_type */
export type FisAssetTypePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisAssetTypePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.asset_type" */
export enum FisAssetTypeSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "fis.asset_type" */
export type FisAssetTypeSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fis_asset_type" */
export type FisAssetTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisAssetTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisAssetTypeStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "fis.asset_type" */
export enum FisAssetTypeUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type FisAssetTypeUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisAssetTypeAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisAssetTypeDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisAssetTypeDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisAssetTypeDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisAssetTypePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisAssetTypeSetInput>;
  /** filter the rows which have to be updated */
  where: FisAssetTypeBoolExp;
};

/** update columns of table "fis.asset" */
export enum FisAssetUpdateColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type FisAssetUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisAssetAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisAssetDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisAssetDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisAssetDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisAssetIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisAssetPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisAssetSetInput>;
  /** filter the rows which have to be updated */
  where: FisAssetBoolExp;
};

/** aggregate var_pop on columns */
export type FisAssetVarPopFields = {
  __typename?: 'fis_asset_var_pop_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fis.asset" */
export type FisAssetVarPopOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type FisAssetVarSampFields = {
  __typename?: 'fis_asset_var_samp_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fis.asset" */
export type FisAssetVarSampOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type FisAssetVarianceFields = {
  __typename?: 'fis_asset_variance_fields';
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fis.asset" */
export type FisAssetVarianceOrderBy = {
  /** The expected time to produce 1 part for this asset */
  cycle_time?: Maybe<OrderBy>;
};

/** columns and relationships of "fis.core_state" */
export type FisCoreState = {
  __typename?: 'fis_core_state';
  description?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

/** aggregated selection of "fis.core_state" */
export type FisCoreStateAggregate = {
  __typename?: 'fis_core_state_aggregate';
  aggregate?: Maybe<FisCoreStateAggregateFields>;
  nodes: Array<FisCoreState>;
};

/** aggregate fields of "fis.core_state" */
export type FisCoreStateAggregateFields = {
  __typename?: 'fis_core_state_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisCoreStateMaxFields>;
  min?: Maybe<FisCoreStateMinFields>;
};


/** aggregate fields of "fis.core_state" */
export type FisCoreStateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisCoreStateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fis.core_state". All fields are combined with a logical 'AND'. */
export type FisCoreStateBoolExp = {
  _and?: Maybe<Array<FisCoreStateBoolExp>>;
  _not?: Maybe<FisCoreStateBoolExp>;
  _or?: Maybe<Array<FisCoreStateBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  state?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "fis.core_state" */
export enum FisCoreStateConstraint {
  /** unique or primary key constraint on columns "state" */
  CoreStatePkey = 'core_state_pkey'
}

export enum FisCoreStateEnum {
  /** Blocked */
  Blocked = 'blocked',
  /** Blocked Secondary */
  BlockedSecondary = 'blocked_secondary',
  /** Bypassed */
  Bypassed = 'bypassed',
  /** Cycling */
  Cycling = 'cycling',
  /** Down External */
  DownExternal = 'down_external',
  /** Fault */
  Fault = 'fault',
  /** Manual Intervention */
  ManualIntervention = 'manual_intervention',
  /** No Comm */
  NoComm = 'no_comm',
  /** None */
  None = 'none',
  /** Starved */
  Starved = 'starved',
  /** Starved Secondary */
  StarvedSecondary = 'starved_secondary'
}

/** Boolean expression to compare columns of type "fis_core_state_enum". All fields are combined with logical 'AND'. */
export type FisCoreStateEnumComparisonExp = {
  _eq?: Maybe<FisCoreStateEnum>;
  _in?: Maybe<Array<FisCoreStateEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<FisCoreStateEnum>;
  _nin?: Maybe<Array<FisCoreStateEnum>>;
};

/** input type for inserting data into table "fis.core_state" */
export type FisCoreStateInsertInput = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FisCoreStateMaxFields = {
  __typename?: 'fis_core_state_max_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FisCoreStateMinFields = {
  __typename?: 'fis_core_state_min_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fis.core_state" */
export type FisCoreStateMutationResponse = {
  __typename?: 'fis_core_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisCoreState>;
};

/** on_conflict condition type for table "fis.core_state" */
export type FisCoreStateOnConflict = {
  constraint: FisCoreStateConstraint;
  update_columns?: Array<FisCoreStateUpdateColumn>;
  where?: Maybe<FisCoreStateBoolExp>;
};

/** Ordering options when selecting data from "fis.core_state". */
export type FisCoreStateOrderBy = {
  description?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.core_state */
export type FisCoreStatePkColumnsInput = {
  state: Scalars['String'];
};

/** select columns of table "fis.core_state" */
export enum FisCoreStateSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "fis.core_state" */
export type FisCoreStateSetInput = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "fis_core_state" */
export type FisCoreStateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisCoreStateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisCoreStateStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "fis.core_state" */
export enum FisCoreStateUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

export type FisCoreStateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisCoreStateSetInput>;
  /** filter the rows which have to be updated */
  where: FisCoreStateBoolExp;
};

/** columns and relationships of "fis.data" */
export type FisData = {
  __typename?: 'fis_data';
  /** An object relationship */
  asset: FisAsset;
  asset_id: Scalars['uuid'];
  /** An object relationship */
  context: ArgoContext;
  context_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id: Scalars['uuid'];
  /** An object relationship */
  data_label: FisDataLabel;
  data_label_id: Scalars['uuid'];
  /** An object relationship */
  data_timing: FisDataTiming;
  meta: Scalars['jsonb'];
  num_val: Scalars['float8'];
  time: Scalars['timestamp'];
  timing: FisDataTimingEnum;
};


/** columns and relationships of "fis.data" */
export type FisDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.data" */
export type FisDataAggregate = {
  __typename?: 'fis_data_aggregate';
  aggregate?: Maybe<FisDataAggregateFields>;
  nodes: Array<FisData>;
};

export type FisDataAggregateBoolExp = {
  avg?: Maybe<FisDataAggregateBoolExpAvg>;
  corr?: Maybe<FisDataAggregateBoolExpCorr>;
  count?: Maybe<FisDataAggregateBoolExpCount>;
  covar_samp?: Maybe<FisDataAggregateBoolExpCovarSamp>;
  max?: Maybe<FisDataAggregateBoolExpMax>;
  min?: Maybe<FisDataAggregateBoolExpMin>;
  stddev_samp?: Maybe<FisDataAggregateBoolExpStddevSamp>;
  sum?: Maybe<FisDataAggregateBoolExpSum>;
  var_samp?: Maybe<FisDataAggregateBoolExpVarSamp>;
};

export type FisDataAggregateBoolExpAvg = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpAvgArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpCorr = {
  arguments: FisDataAggregateBoolExpCorrArguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpCorrArguments = {
  X: FisDataSelectColumnFisDataAggregateBoolExpCorrArgumentsColumns;
  Y: FisDataSelectColumnFisDataAggregateBoolExpCorrArgumentsColumns;
};

export type FisDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<FisDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: IntComparisonExp;
};

export type FisDataAggregateBoolExpCovarSamp = {
  arguments: FisDataAggregateBoolExpCovarSampArguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpCovarSampArguments = {
  X: FisDataSelectColumnFisDataAggregateBoolExpCovarSampArgumentsColumns;
  Y: FisDataSelectColumnFisDataAggregateBoolExpCovarSampArgumentsColumns;
};

export type FisDataAggregateBoolExpMax = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpMaxArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpMin = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpMinArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpStddevSamp = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpSum = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpSumArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

export type FisDataAggregateBoolExpVarSamp = {
  arguments: FisDataSelectColumnFisDataAggregateBoolExpVarSampArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "fis.data" */
export type FisDataAggregateFields = {
  __typename?: 'fis_data_aggregate_fields';
  avg?: Maybe<FisDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisDataMaxFields>;
  min?: Maybe<FisDataMinFields>;
  stddev?: Maybe<FisDataStddevFields>;
  stddev_pop?: Maybe<FisDataStddevPopFields>;
  stddev_samp?: Maybe<FisDataStddevSampFields>;
  sum?: Maybe<FisDataSumFields>;
  var_pop?: Maybe<FisDataVarPopFields>;
  var_samp?: Maybe<FisDataVarSampFields>;
  variance?: Maybe<FisDataVarianceFields>;
};


/** aggregate fields of "fis.data" */
export type FisDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fis.data" */
export type FisDataAggregateOrderBy = {
  avg?: Maybe<FisDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<FisDataMaxOrderBy>;
  min?: Maybe<FisDataMinOrderBy>;
  stddev?: Maybe<FisDataStddevOrderBy>;
  stddev_pop?: Maybe<FisDataStddevPopOrderBy>;
  stddev_samp?: Maybe<FisDataStddevSampOrderBy>;
  sum?: Maybe<FisDataSumOrderBy>;
  var_pop?: Maybe<FisDataVarPopOrderBy>;
  var_samp?: Maybe<FisDataVarSampOrderBy>;
  variance?: Maybe<FisDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisDataAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "fis.data" */
export type FisDataArrRelInsertInput = {
  data: Array<FisDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<FisDataOnConflict>;
};

/** aggregate avg on columns */
export type FisDataAvgFields = {
  __typename?: 'fis_data_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fis.data" */
export type FisDataAvgOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "fis.data". All fields are combined with a logical 'AND'. */
export type FisDataBoolExp = {
  _and?: Maybe<Array<FisDataBoolExp>>;
  _not?: Maybe<FisDataBoolExp>;
  _or?: Maybe<Array<FisDataBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_id?: Maybe<UuidComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  data_timing?: Maybe<FisDataTimingBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  timing?: Maybe<FisDataTimingEnumComparisonExp>;
};

/** unique or primary key constraints on table "fis.data" */
export enum FisDataConstraint {
  /** unique or primary key constraint on columns "time", "data_id" */
  DataPkey = 'data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisDataDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisDataDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisDataDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.data" */
export type FisDataIncInput = {
  num_val?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "fis.data" */
export type FisDataInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  asset_id?: Maybe<Scalars['uuid']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label?: Maybe<FisDataLabelObjRelInsertInput>;
  data_label_id?: Maybe<Scalars['uuid']>;
  data_timing?: Maybe<FisDataTimingObjRelInsertInput>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<FisDataTimingEnum>;
};

/** columns and relationships of "fis.data_label" */
export type FisDataLabel = {
  __typename?: 'fis_data_label';
  /** An array relationship */
  asset_codes: Array<FisAssetCode>;
  /** An aggregate relationship */
  asset_codes_aggregate: FisAssetCodeAggregate;
  /** An object relationship */
  context?: Maybe<ArgoContext>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<ArgoUser>;
  created_by_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  data: Array<FisData>;
  /** An aggregate relationship */
  data_aggregate: FisDataAggregate;
  /** An object relationship */
  data_type: FisDataType;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  name_unique: Scalars['String'];
  type: FisDataTypeEnum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "fis.data_label" */
export type FisDataLabelAssetCodesArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


/** columns and relationships of "fis.data_label" */
export type FisDataLabelAssetCodesAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


/** columns and relationships of "fis.data_label" */
export type FisDataLabelDataArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


/** columns and relationships of "fis.data_label" */
export type FisDataLabelDataAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


/** columns and relationships of "fis.data_label" */
export type FisDataLabelMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.data_label" */
export type FisDataLabelAggregate = {
  __typename?: 'fis_data_label_aggregate';
  aggregate?: Maybe<FisDataLabelAggregateFields>;
  nodes: Array<FisDataLabel>;
};

export type FisDataLabelAggregateBoolExp = {
  bool_and?: Maybe<FisDataLabelAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<FisDataLabelAggregateBoolExpBoolOr>;
  count?: Maybe<FisDataLabelAggregateBoolExpCount>;
};

export type FisDataLabelAggregateBoolExpBoolAnd = {
  arguments: FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataLabelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type FisDataLabelAggregateBoolExpBoolOr = {
  arguments: FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataLabelBoolExp>;
  predicate: BooleanComparisonExp;
};

export type FisDataLabelAggregateBoolExpCount = {
  arguments?: Maybe<Array<FisDataLabelSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<FisDataLabelBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "fis.data_label" */
export type FisDataLabelAggregateFields = {
  __typename?: 'fis_data_label_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisDataLabelMaxFields>;
  min?: Maybe<FisDataLabelMinFields>;
};


/** aggregate fields of "fis.data_label" */
export type FisDataLabelAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataLabelSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fis.data_label" */
export type FisDataLabelAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<FisDataLabelMaxOrderBy>;
  min?: Maybe<FisDataLabelMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisDataLabelAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "fis.data_label" */
export type FisDataLabelArrRelInsertInput = {
  data: Array<FisDataLabelInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<FisDataLabelOnConflict>;
};

/** Boolean expression to filter rows from the table "fis.data_label". All fields are combined with a logical 'AND'. */
export type FisDataLabelBoolExp = {
  _and?: Maybe<Array<FisDataLabelBoolExp>>;
  _not?: Maybe<FisDataLabelBoolExp>;
  _or?: Maybe<Array<FisDataLabelBoolExp>>;
  asset_codes?: Maybe<FisAssetCodeBoolExp>;
  asset_codes_aggregate?: Maybe<FisAssetCodeAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data?: Maybe<FisDataBoolExp>;
  data_aggregate?: Maybe<FisDataAggregateBoolExp>;
  data_type?: Maybe<FisDataTypeBoolExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  type?: Maybe<FisDataTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_label" */
export enum FisDataLabelConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  DataLabelEnforceUnique = 'data_label_enforce_unique',
  /** unique or primary key constraint on columns "data_label_id" */
  DataLabelPkey = 'data_label_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisDataLabelDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisDataLabelDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisDataLabelDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "fis.data_label" */
export type FisDataLabelInsertInput = {
  asset_codes?: Maybe<FisAssetCodeArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data?: Maybe<FisDataArrRelInsertInput>;
  data_type?: Maybe<FisDataTypeObjRelInsertInput>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<FisDataTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FisDataLabelMaxFields = {
  __typename?: 'fis_data_label_max_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "fis.data_label" */
export type FisDataLabelMaxOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type FisDataLabelMinFields = {
  __typename?: 'fis_data_label_min_fields';
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "fis.data_label" */
export type FisDataLabelMinOrderBy = {
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "fis.data_label" */
export type FisDataLabelMutationResponse = {
  __typename?: 'fis_data_label_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataLabel>;
};

/** input type for inserting object relation for remote table "fis.data_label" */
export type FisDataLabelObjRelInsertInput = {
  data: FisDataLabelInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisDataLabelOnConflict>;
};

/** on_conflict condition type for table "fis.data_label" */
export type FisDataLabelOnConflict = {
  constraint: FisDataLabelConstraint;
  update_columns?: Array<FisDataLabelUpdateColumn>;
  where?: Maybe<FisDataLabelBoolExp>;
};

/** Ordering options when selecting data from "fis.data_label". */
export type FisDataLabelOrderBy = {
  asset_codes_aggregate?: Maybe<FisAssetCodeAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_aggregate?: Maybe<FisDataAggregateOrderBy>;
  data_type?: Maybe<FisDataTypeOrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_label */
export type FisDataLabelPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisDataLabelPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.data_label" */
export enum FisDataLabelSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "fis_data_label_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fis.data_label" */
export enum FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "fis_data_label_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fis.data_label" */
export enum FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "fis.data_label" */
export type FisDataLabelSetInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<FisDataTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fis_data_label" */
export type FisDataLabelStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataLabelStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataLabelStreamCursorValueInput = {
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  name_unique?: Maybe<Scalars['String']>;
  type?: Maybe<FisDataTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "fis.data_label" */
export enum FisDataLabelUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type FisDataLabelUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisDataLabelAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisDataLabelDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisDataLabelDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisDataLabelDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisDataLabelPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataLabelSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataLabelBoolExp;
};

/** aggregate max on columns */
export type FisDataMaxFields = {
  __typename?: 'fis_data_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "fis.data" */
export type FisDataMaxOrderBy = {
  asset_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_id?: Maybe<OrderBy>;
  data_label_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type FisDataMinFields = {
  __typename?: 'fis_data_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "fis.data" */
export type FisDataMinOrderBy = {
  asset_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_id?: Maybe<OrderBy>;
  data_label_id?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
};

/** response of any mutation on the table "fis.data" */
export type FisDataMutationResponse = {
  __typename?: 'fis_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisData>;
};

/** on_conflict condition type for table "fis.data" */
export type FisDataOnConflict = {
  constraint: FisDataConstraint;
  update_columns?: Array<FisDataUpdateColumn>;
  where?: Maybe<FisDataBoolExp>;
};

/** Ordering options when selecting data from "fis.data". */
export type FisDataOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_id?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  data_timing?: Maybe<FisDataTimingOrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  timing?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data */
export type FisDataPkColumnsInput = {
  data_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisDataPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.data" */
export enum FisDataSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

/** select "fis_data_aggregate_bool_exp_avg_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_corr_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_max_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_min_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpMinArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_sum_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpSumArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** input type for updating data in table "fis.data" */
export type FisDataSetInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<FisDataTimingEnum>;
};

/** aggregate stddev on columns */
export type FisDataStddevFields = {
  __typename?: 'fis_data_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fis.data" */
export type FisDataStddevOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type FisDataStddevPopFields = {
  __typename?: 'fis_data_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fis.data" */
export type FisDataStddevPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type FisDataStddevSampFields = {
  __typename?: 'fis_data_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fis.data" */
export type FisDataStddevSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "fis_data" */
export type FisDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<FisDataTimingEnum>;
};

/** aggregate sum on columns */
export type FisDataSumFields = {
  __typename?: 'fis_data_sum_fields';
  num_val?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "fis.data" */
export type FisDataSumOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** columns and relationships of "fis.data_timing" */
export type FisDataTiming = {
  __typename?: 'fis_data_timing';
  /** An array relationship */
  data: Array<FisData>;
  /** An aggregate relationship */
  data_aggregate: FisDataAggregate;
  description?: Maybe<Scalars['String']>;
  timing: Scalars['String'];
};


/** columns and relationships of "fis.data_timing" */
export type FisDataTimingDataArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


/** columns and relationships of "fis.data_timing" */
export type FisDataTimingDataAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};

/** aggregated selection of "fis.data_timing" */
export type FisDataTimingAggregate = {
  __typename?: 'fis_data_timing_aggregate';
  aggregate?: Maybe<FisDataTimingAggregateFields>;
  nodes: Array<FisDataTiming>;
};

/** aggregate fields of "fis.data_timing" */
export type FisDataTimingAggregateFields = {
  __typename?: 'fis_data_timing_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisDataTimingMaxFields>;
  min?: Maybe<FisDataTimingMinFields>;
};


/** aggregate fields of "fis.data_timing" */
export type FisDataTimingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataTimingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fis.data_timing". All fields are combined with a logical 'AND'. */
export type FisDataTimingBoolExp = {
  _and?: Maybe<Array<FisDataTimingBoolExp>>;
  _not?: Maybe<FisDataTimingBoolExp>;
  _or?: Maybe<Array<FisDataTimingBoolExp>>;
  data?: Maybe<FisDataBoolExp>;
  data_aggregate?: Maybe<FisDataAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  timing?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_timing" */
export enum FisDataTimingConstraint {
  /** unique or primary key constraint on columns "timing" */
  DataTimingPkey = 'data_timing_pkey'
}

export enum FisDataTimingEnum {
  /** When the data represents what occured over a period of time */
  End = 'end',
  /** When the data represents the start of the event */
  Start = 'start'
}

/** Boolean expression to compare columns of type "fis_data_timing_enum". All fields are combined with logical 'AND'. */
export type FisDataTimingEnumComparisonExp = {
  _eq?: Maybe<FisDataTimingEnum>;
  _in?: Maybe<Array<FisDataTimingEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<FisDataTimingEnum>;
  _nin?: Maybe<Array<FisDataTimingEnum>>;
};

/** input type for inserting data into table "fis.data_timing" */
export type FisDataTimingInsertInput = {
  data?: Maybe<FisDataArrRelInsertInput>;
  description?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FisDataTimingMaxFields = {
  __typename?: 'fis_data_timing_max_fields';
  description?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FisDataTimingMinFields = {
  __typename?: 'fis_data_timing_min_fields';
  description?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fis.data_timing" */
export type FisDataTimingMutationResponse = {
  __typename?: 'fis_data_timing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataTiming>;
};

/** input type for inserting object relation for remote table "fis.data_timing" */
export type FisDataTimingObjRelInsertInput = {
  data: FisDataTimingInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisDataTimingOnConflict>;
};

/** on_conflict condition type for table "fis.data_timing" */
export type FisDataTimingOnConflict = {
  constraint: FisDataTimingConstraint;
  update_columns?: Array<FisDataTimingUpdateColumn>;
  where?: Maybe<FisDataTimingBoolExp>;
};

/** Ordering options when selecting data from "fis.data_timing". */
export type FisDataTimingOrderBy = {
  data_aggregate?: Maybe<FisDataAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  timing?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_timing */
export type FisDataTimingPkColumnsInput = {
  timing: Scalars['String'];
};

/** select columns of table "fis.data_timing" */
export enum FisDataTimingSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Timing = 'timing'
}

/** input type for updating data in table "fis.data_timing" */
export type FisDataTimingSetInput = {
  description?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "fis_data_timing" */
export type FisDataTimingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataTimingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataTimingStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  timing?: Maybe<Scalars['String']>;
};

/** update columns of table "fis.data_timing" */
export enum FisDataTimingUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Timing = 'timing'
}

export type FisDataTimingUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataTimingSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataTimingBoolExp;
};

/** columns and relationships of "fis.data_track_count" */
export type FisDataTrackCount = {
  __typename?: 'fis_data_track_count';
  /** An object relationship */
  asset: FisAsset;
  asset_id: Scalars['uuid'];
  /** An object relationship */
  calendar_event: ArgoCalendarEvent;
  calendar_event_id: Scalars['uuid'];
  count: Scalars['float8'];
  /** An object relationship */
  data_label: FisDataLabel;
  data_label_id: Scalars['uuid'];
  event_duration?: Maybe<Scalars['float8']>;
  is_productive: Scalars['Boolean'];
  meta: Scalars['jsonb'];
  /** An object relationship */
  shift_calendar_event: ArgoCalendarEvent;
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
  time_range: Scalars['tsrange'];
};


/** columns and relationships of "fis.data_track_count" */
export type FisDataTrackCountMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.data_track_count" */
export type FisDataTrackCountAggregate = {
  __typename?: 'fis_data_track_count_aggregate';
  aggregate?: Maybe<FisDataTrackCountAggregateFields>;
  nodes: Array<FisDataTrackCount>;
};

/** aggregate fields of "fis.data_track_count" */
export type FisDataTrackCountAggregateFields = {
  __typename?: 'fis_data_track_count_aggregate_fields';
  avg?: Maybe<FisDataTrackCountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisDataTrackCountMaxFields>;
  min?: Maybe<FisDataTrackCountMinFields>;
  stddev?: Maybe<FisDataTrackCountStddevFields>;
  stddev_pop?: Maybe<FisDataTrackCountStddevPopFields>;
  stddev_samp?: Maybe<FisDataTrackCountStddevSampFields>;
  sum?: Maybe<FisDataTrackCountSumFields>;
  var_pop?: Maybe<FisDataTrackCountVarPopFields>;
  var_samp?: Maybe<FisDataTrackCountVarSampFields>;
  variance?: Maybe<FisDataTrackCountVarianceFields>;
};


/** aggregate fields of "fis.data_track_count" */
export type FisDataTrackCountAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataTrackCountSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackCountAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type FisDataTrackCountAvgFields = {
  __typename?: 'fis_data_track_count_avg_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.data_track_count". All fields are combined with a logical 'AND'. */
export type FisDataTrackCountBoolExp = {
  _and?: Maybe<Array<FisDataTrackCountBoolExp>>;
  _not?: Maybe<FisDataTrackCountBoolExp>;
  _or?: Maybe<Array<FisDataTrackCountBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  count?: Maybe<Float8ComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  event_duration?: Maybe<Float8ComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  time_range?: Maybe<TsrangeComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_track_count" */
export enum FisDataTrackCountConstraint {
  /** unique or primary key constraint on columns "calendar_event_id", "data_label_id", "time", "asset_id", "shift_calendar_event_id" */
  DataTrackCountPkey = 'data_track_count_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisDataTrackCountDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisDataTrackCountDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisDataTrackCountDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.data_track_count" */
export type FisDataTrackCountIncInput = {
  count?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "fis.data_track_count" */
export type FisDataTrackCountInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['float8']>;
  data_label?: Maybe<FisDataLabelObjRelInsertInput>;
  data_label_id?: Maybe<Scalars['uuid']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  shift_calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate max on columns */
export type FisDataTrackCountMaxFields = {
  __typename?: 'fis_data_track_count_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  event_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisDataTrackCountMinFields = {
  __typename?: 'fis_data_track_count_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  event_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "fis.data_track_count" */
export type FisDataTrackCountMutationResponse = {
  __typename?: 'fis_data_track_count_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataTrackCount>;
};

/** on_conflict condition type for table "fis.data_track_count" */
export type FisDataTrackCountOnConflict = {
  constraint: FisDataTrackCountConstraint;
  update_columns?: Array<FisDataTrackCountUpdateColumn>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};

/** Ordering options when selecting data from "fis.data_track_count". */
export type FisDataTrackCountOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  event_duration?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  time_range?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_track_count */
export type FisDataTrackCountPkColumnsInput = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackCountPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.data_track_count" */
export enum FisDataTrackCountSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  Count = 'count',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** input type for updating data in table "fis.data_track_count" */
export type FisDataTrackCountSetInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate stddev on columns */
export type FisDataTrackCountStddevFields = {
  __typename?: 'fis_data_track_count_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisDataTrackCountStddevPopFields = {
  __typename?: 'fis_data_track_count_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisDataTrackCountStddevSampFields = {
  __typename?: 'fis_data_track_count_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_data_track_count" */
export type FisDataTrackCountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataTrackCountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataTrackCountStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate sum on columns */
export type FisDataTrackCountSumFields = {
  __typename?: 'fis_data_track_count_sum_fields';
  count?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
};

/** update columns of table "fis.data_track_count" */
export enum FisDataTrackCountUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  Count = 'count',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

export type FisDataTrackCountUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisDataTrackCountAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisDataTrackCountDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisDataTrackCountDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisDataTrackCountDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisDataTrackCountIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisDataTrackCountPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataTrackCountSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataTrackCountBoolExp;
};

/** aggregate var_pop on columns */
export type FisDataTrackCountVarPopFields = {
  __typename?: 'fis_data_track_count_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisDataTrackCountVarSampFields = {
  __typename?: 'fis_data_track_count_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisDataTrackCountVarianceFields = {
  __typename?: 'fis_data_track_count_variance_fields';
  count?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.data_track_duration" */
export type FisDataTrackDuration = {
  __typename?: 'fis_data_track_duration';
  /** An object relationship */
  asset: FisAsset;
  asset_id: Scalars['uuid'];
  /** An object relationship */
  calendar_event: ArgoCalendarEvent;
  calendar_event_id: Scalars['uuid'];
  /** An object relationship */
  data_label: FisDataLabel;
  data_label_id: Scalars['uuid'];
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive: Scalars['Boolean'];
  meta: Scalars['jsonb'];
  num_val: Scalars['float8'];
  occurrence?: Maybe<Scalars['Int']>;
  /** An object relationship */
  shift_calendar_event: ArgoCalendarEvent;
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
  time_range: Scalars['tsrange'];
};


/** columns and relationships of "fis.data_track_duration" */
export type FisDataTrackDurationMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.data_track_duration" */
export type FisDataTrackDurationAggregate = {
  __typename?: 'fis_data_track_duration_aggregate';
  aggregate?: Maybe<FisDataTrackDurationAggregateFields>;
  nodes: Array<FisDataTrackDuration>;
};

/** aggregate fields of "fis.data_track_duration" */
export type FisDataTrackDurationAggregateFields = {
  __typename?: 'fis_data_track_duration_aggregate_fields';
  avg?: Maybe<FisDataTrackDurationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisDataTrackDurationMaxFields>;
  min?: Maybe<FisDataTrackDurationMinFields>;
  stddev?: Maybe<FisDataTrackDurationStddevFields>;
  stddev_pop?: Maybe<FisDataTrackDurationStddevPopFields>;
  stddev_samp?: Maybe<FisDataTrackDurationStddevSampFields>;
  sum?: Maybe<FisDataTrackDurationSumFields>;
  var_pop?: Maybe<FisDataTrackDurationVarPopFields>;
  var_samp?: Maybe<FisDataTrackDurationVarSampFields>;
  variance?: Maybe<FisDataTrackDurationVarianceFields>;
};


/** aggregate fields of "fis.data_track_duration" */
export type FisDataTrackDurationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataTrackDurationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackDurationAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type FisDataTrackDurationAvgFields = {
  __typename?: 'fis_data_track_duration_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.data_track_duration". All fields are combined with a logical 'AND'. */
export type FisDataTrackDurationBoolExp = {
  _and?: Maybe<Array<FisDataTrackDurationBoolExp>>;
  _not?: Maybe<FisDataTrackDurationBoolExp>;
  _or?: Maybe<Array<FisDataTrackDurationBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  event_duration?: Maybe<Float8ComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
  occurrence?: Maybe<IntComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  time_range?: Maybe<TsrangeComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_track_duration" */
export enum FisDataTrackDurationConstraint {
  /** unique or primary key constraint on columns "calendar_event_id", "data_label_id", "time", "asset_id", "shift_calendar_event_id", "num_val" */
  DataTrackDurationPkey = 'data_track_duration_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisDataTrackDurationDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisDataTrackDurationDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisDataTrackDurationDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.data_track_duration" */
export type FisDataTrackDurationIncInput = {
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "fis.data_track_duration" */
export type FisDataTrackDurationInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label?: Maybe<FisDataLabelObjRelInsertInput>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event?: Maybe<ArgoCalendarEventObjRelInsertInput>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate max on columns */
export type FisDataTrackDurationMaxFields = {
  __typename?: 'fis_data_track_duration_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisDataTrackDurationMinFields = {
  __typename?: 'fis_data_track_duration_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "fis.data_track_duration" */
export type FisDataTrackDurationMutationResponse = {
  __typename?: 'fis_data_track_duration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataTrackDuration>;
};

/** on_conflict condition type for table "fis.data_track_duration" */
export type FisDataTrackDurationOnConflict = {
  constraint: FisDataTrackDurationConstraint;
  update_columns?: Array<FisDataTrackDurationUpdateColumn>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};

/** Ordering options when selecting data from "fis.data_track_duration". */
export type FisDataTrackDurationOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  event_duration?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  occurrence?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  time_range?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_track_duration */
export type FisDataTrackDurationPkColumnsInput = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  num_val: Scalars['float8'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackDurationPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.data_track_duration" */
export enum FisDataTrackDurationSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** input type for updating data in table "fis.data_track_duration" */
export type FisDataTrackDurationSetInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate stddev on columns */
export type FisDataTrackDurationStddevFields = {
  __typename?: 'fis_data_track_duration_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisDataTrackDurationStddevPopFields = {
  __typename?: 'fis_data_track_duration_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisDataTrackDurationStddevSampFields = {
  __typename?: 'fis_data_track_duration_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_data_track_duration" */
export type FisDataTrackDurationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataTrackDurationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataTrackDurationStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate sum on columns */
export type FisDataTrackDurationSumFields = {
  __typename?: 'fis_data_track_duration_sum_fields';
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
};

/** update columns of table "fis.data_track_duration" */
export enum FisDataTrackDurationUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

export type FisDataTrackDurationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisDataTrackDurationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisDataTrackDurationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisDataTrackDurationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisDataTrackDurationDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisDataTrackDurationIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisDataTrackDurationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataTrackDurationSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataTrackDurationBoolExp;
};

/** aggregate var_pop on columns */
export type FisDataTrackDurationVarPopFields = {
  __typename?: 'fis_data_track_duration_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisDataTrackDurationVarSampFields = {
  __typename?: 'fis_data_track_duration_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisDataTrackDurationVarianceFields = {
  __typename?: 'fis_data_track_duration_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.data_track_scalar" */
export type FisDataTrackScalar = {
  __typename?: 'fis_data_track_scalar';
  /** An object relationship */
  asset: FisAsset;
  asset_id: Scalars['uuid'];
  avg_val: Scalars['float8'];
  /** An object relationship */
  data_label: FisDataLabel;
  data_label_id: Scalars['uuid'];
  max_val: Scalars['float8'];
  meta: Scalars['jsonb'];
  min_val: Scalars['float8'];
  occurrence?: Maybe<Scalars['Int']>;
  sum_val: Scalars['float8'];
  time: Scalars['timestamp'];
  time_range: Scalars['tsrange'];
};


/** columns and relationships of "fis.data_track_scalar" */
export type FisDataTrackScalarMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.data_track_scalar" */
export type FisDataTrackScalarAggregate = {
  __typename?: 'fis_data_track_scalar_aggregate';
  aggregate?: Maybe<FisDataTrackScalarAggregateFields>;
  nodes: Array<FisDataTrackScalar>;
};

/** aggregate fields of "fis.data_track_scalar" */
export type FisDataTrackScalarAggregateFields = {
  __typename?: 'fis_data_track_scalar_aggregate_fields';
  avg?: Maybe<FisDataTrackScalarAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisDataTrackScalarMaxFields>;
  min?: Maybe<FisDataTrackScalarMinFields>;
  stddev?: Maybe<FisDataTrackScalarStddevFields>;
  stddev_pop?: Maybe<FisDataTrackScalarStddevPopFields>;
  stddev_samp?: Maybe<FisDataTrackScalarStddevSampFields>;
  sum?: Maybe<FisDataTrackScalarSumFields>;
  var_pop?: Maybe<FisDataTrackScalarVarPopFields>;
  var_samp?: Maybe<FisDataTrackScalarVarSampFields>;
  variance?: Maybe<FisDataTrackScalarVarianceFields>;
};


/** aggregate fields of "fis.data_track_scalar" */
export type FisDataTrackScalarAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataTrackScalarSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackScalarAppendInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type FisDataTrackScalarAvgFields = {
  __typename?: 'fis_data_track_scalar_avg_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.data_track_scalar". All fields are combined with a logical 'AND'. */
export type FisDataTrackScalarBoolExp = {
  _and?: Maybe<Array<FisDataTrackScalarBoolExp>>;
  _not?: Maybe<FisDataTrackScalarBoolExp>;
  _or?: Maybe<Array<FisDataTrackScalarBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  avg_val?: Maybe<Float8ComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  max_val?: Maybe<Float8ComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  min_val?: Maybe<Float8ComparisonExp>;
  occurrence?: Maybe<IntComparisonExp>;
  sum_val?: Maybe<Float8ComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  time_range?: Maybe<TsrangeComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_track_scalar" */
export enum FisDataTrackScalarConstraint {
  /** unique or primary key constraint on columns "data_label_id", "time", "asset_id" */
  DataTrackScalarPkey = 'data_track_scalar_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FisDataTrackScalarDeleteAtPathInput = {
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FisDataTrackScalarDeleteElemInput = {
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FisDataTrackScalarDeleteKeyInput = {
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "fis.data_track_scalar" */
export type FisDataTrackScalarIncInput = {
  avg_val?: Maybe<Scalars['float8']>;
  max_val?: Maybe<Scalars['float8']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "fis.data_track_scalar" */
export type FisDataTrackScalarInsertInput = {
  asset?: Maybe<FisAssetObjRelInsertInput>;
  asset_id?: Maybe<Scalars['uuid']>;
  avg_val?: Maybe<Scalars['float8']>;
  data_label?: Maybe<FisDataLabelObjRelInsertInput>;
  data_label_id?: Maybe<Scalars['uuid']>;
  max_val?: Maybe<Scalars['float8']>;
  meta?: Maybe<Scalars['jsonb']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate max on columns */
export type FisDataTrackScalarMaxFields = {
  __typename?: 'fis_data_track_scalar_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  avg_val?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  max_val?: Maybe<Scalars['float8']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisDataTrackScalarMinFields = {
  __typename?: 'fis_data_track_scalar_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  avg_val?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  max_val?: Maybe<Scalars['float8']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "fis.data_track_scalar" */
export type FisDataTrackScalarMutationResponse = {
  __typename?: 'fis_data_track_scalar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataTrackScalar>;
};

/** on_conflict condition type for table "fis.data_track_scalar" */
export type FisDataTrackScalarOnConflict = {
  constraint: FisDataTrackScalarConstraint;
  update_columns?: Array<FisDataTrackScalarUpdateColumn>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};

/** Ordering options when selecting data from "fis.data_track_scalar". */
export type FisDataTrackScalarOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  avg_val?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  max_val?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  min_val?: Maybe<OrderBy>;
  occurrence?: Maybe<OrderBy>;
  sum_val?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  time_range?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_track_scalar */
export type FisDataTrackScalarPkColumnsInput = {
  asset_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FisDataTrackScalarPrependInput = {
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "fis.data_track_scalar" */
export enum FisDataTrackScalarSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AvgVal = 'avg_val',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  MaxVal = 'max_val',
  /** column name */
  Meta = 'meta',
  /** column name */
  MinVal = 'min_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  SumVal = 'sum_val',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** input type for updating data in table "fis.data_track_scalar" */
export type FisDataTrackScalarSetInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  avg_val?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  max_val?: Maybe<Scalars['float8']>;
  meta?: Maybe<Scalars['jsonb']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate stddev on columns */
export type FisDataTrackScalarStddevFields = {
  __typename?: 'fis_data_track_scalar_stddev_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisDataTrackScalarStddevPopFields = {
  __typename?: 'fis_data_track_scalar_stddev_pop_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisDataTrackScalarStddevSampFields = {
  __typename?: 'fis_data_track_scalar_stddev_samp_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_data_track_scalar" */
export type FisDataTrackScalarStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataTrackScalarStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataTrackScalarStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  avg_val?: Maybe<Scalars['float8']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  max_val?: Maybe<Scalars['float8']>;
  meta?: Maybe<Scalars['jsonb']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate sum on columns */
export type FisDataTrackScalarSumFields = {
  __typename?: 'fis_data_track_scalar_sum_fields';
  avg_val?: Maybe<Scalars['float8']>;
  max_val?: Maybe<Scalars['float8']>;
  min_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  sum_val?: Maybe<Scalars['float8']>;
};

/** update columns of table "fis.data_track_scalar" */
export enum FisDataTrackScalarUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AvgVal = 'avg_val',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  MaxVal = 'max_val',
  /** column name */
  Meta = 'meta',
  /** column name */
  MinVal = 'min_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  SumVal = 'sum_val',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

export type FisDataTrackScalarUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisDataTrackScalarAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisDataTrackScalarDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisDataTrackScalarDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisDataTrackScalarDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisDataTrackScalarIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisDataTrackScalarPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataTrackScalarSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataTrackScalarBoolExp;
};

/** aggregate var_pop on columns */
export type FisDataTrackScalarVarPopFields = {
  __typename?: 'fis_data_track_scalar_var_pop_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisDataTrackScalarVarSampFields = {
  __typename?: 'fis_data_track_scalar_var_samp_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisDataTrackScalarVarianceFields = {
  __typename?: 'fis_data_track_scalar_variance_fields';
  avg_val?: Maybe<Scalars['Float']>;
  max_val?: Maybe<Scalars['Float']>;
  min_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
  sum_val?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.data_type" */
export type FisDataType = {
  __typename?: 'fis_data_type';
  /** An array relationship */
  data_labels: Array<FisDataLabel>;
  /** An aggregate relationship */
  data_labels_aggregate: FisDataLabelAggregate;
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


/** columns and relationships of "fis.data_type" */
export type FisDataTypeDataLabelsArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


/** columns and relationships of "fis.data_type" */
export type FisDataTypeDataLabelsAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};

/** aggregated selection of "fis.data_type" */
export type FisDataTypeAggregate = {
  __typename?: 'fis_data_type_aggregate';
  aggregate?: Maybe<FisDataTypeAggregateFields>;
  nodes: Array<FisDataType>;
};

/** aggregate fields of "fis.data_type" */
export type FisDataTypeAggregateFields = {
  __typename?: 'fis_data_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FisDataTypeMaxFields>;
  min?: Maybe<FisDataTypeMinFields>;
};


/** aggregate fields of "fis.data_type" */
export type FisDataTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisDataTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fis.data_type". All fields are combined with a logical 'AND'. */
export type FisDataTypeBoolExp = {
  _and?: Maybe<Array<FisDataTypeBoolExp>>;
  _not?: Maybe<FisDataTypeBoolExp>;
  _or?: Maybe<Array<FisDataTypeBoolExp>>;
  data_labels?: Maybe<FisDataLabelBoolExp>;
  data_labels_aggregate?: Maybe<FisDataLabelAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "fis.data_type" */
export enum FisDataTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  DataTypePkey = 'data_type_pkey'
}

export enum FisDataTypeEnum {
  /** Code */
  Code = 'code',
  /** Counter */
  Counter = 'counter',
  /** Scalar */
  Scalar = 'scalar',
  /** State */
  State = 'state',
  /** Timer */
  Timer = 'timer'
}

/** Boolean expression to compare columns of type "fis_data_type_enum". All fields are combined with logical 'AND'. */
export type FisDataTypeEnumComparisonExp = {
  _eq?: Maybe<FisDataTypeEnum>;
  _in?: Maybe<Array<FisDataTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<FisDataTypeEnum>;
  _nin?: Maybe<Array<FisDataTypeEnum>>;
};

/** input type for inserting data into table "fis.data_type" */
export type FisDataTypeInsertInput = {
  data_labels?: Maybe<FisDataLabelArrRelInsertInput>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FisDataTypeMaxFields = {
  __typename?: 'fis_data_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FisDataTypeMinFields = {
  __typename?: 'fis_data_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fis.data_type" */
export type FisDataTypeMutationResponse = {
  __typename?: 'fis_data_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FisDataType>;
};

/** input type for inserting object relation for remote table "fis.data_type" */
export type FisDataTypeObjRelInsertInput = {
  data: FisDataTypeInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<FisDataTypeOnConflict>;
};

/** on_conflict condition type for table "fis.data_type" */
export type FisDataTypeOnConflict = {
  constraint: FisDataTypeConstraint;
  update_columns?: Array<FisDataTypeUpdateColumn>;
  where?: Maybe<FisDataTypeBoolExp>;
};

/** Ordering options when selecting data from "fis.data_type". */
export type FisDataTypeOrderBy = {
  data_labels_aggregate?: Maybe<FisDataLabelAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
};

/** primary key columns input for table: fis.data_type */
export type FisDataTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "fis.data_type" */
export enum FisDataTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "fis.data_type" */
export type FisDataTypeSetInput = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "fis_data_type" */
export type FisDataTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisDataTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisDataTypeStreamCursorValueInput = {
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "fis.data_type" */
export enum FisDataTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type FisDataTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataTypeSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataTypeBoolExp;
};

/** update columns of table "fis.data" */
export enum FisDataUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

export type FisDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<FisDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<FisDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<FisDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<FisDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<FisDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<FisDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<FisDataSetInput>;
  /** filter the rows which have to be updated */
  where: FisDataBoolExp;
};

/** aggregate var_pop on columns */
export type FisDataVarPopFields = {
  __typename?: 'fis_data_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fis.data" */
export type FisDataVarPopOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type FisDataVarSampFields = {
  __typename?: 'fis_data_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fis.data" */
export type FisDataVarSampOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type FisDataVarianceFields = {
  __typename?: 'fis_data_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fis.data" */
export type FisDataVarianceOrderBy = {
  num_val?: Maybe<OrderBy>;
};

/** columns and relationships of "fis.report_constraint" */
export type FisReportConstraint = {
  __typename?: 'fis_report_constraint';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  /** An object relationship */
  calendar_event?: Maybe<ArgoCalendarEvent>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  /** An object relationship */
  shift_calendar_event?: Maybe<ArgoCalendarEvent>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "fis.report_constraint" */
export type FisReportConstraintAggregate = {
  __typename?: 'fis_report_constraint_aggregate';
  aggregate?: Maybe<FisReportConstraintAggregateFields>;
  nodes: Array<FisReportConstraint>;
};

/** aggregate fields of "fis.report_constraint" */
export type FisReportConstraintAggregateFields = {
  __typename?: 'fis_report_constraint_aggregate_fields';
  avg?: Maybe<FisReportConstraintAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportConstraintMaxFields>;
  min?: Maybe<FisReportConstraintMinFields>;
  stddev?: Maybe<FisReportConstraintStddevFields>;
  stddev_pop?: Maybe<FisReportConstraintStddevPopFields>;
  stddev_samp?: Maybe<FisReportConstraintStddevSampFields>;
  sum?: Maybe<FisReportConstraintSumFields>;
  var_pop?: Maybe<FisReportConstraintVarPopFields>;
  var_samp?: Maybe<FisReportConstraintVarSampFields>;
  variance?: Maybe<FisReportConstraintVarianceFields>;
};


/** aggregate fields of "fis.report_constraint" */
export type FisReportConstraintAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportConstraintSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportConstraintAvgFields = {
  __typename?: 'fis_report_constraint_avg_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_constraint". All fields are combined with a logical 'AND'. */
export type FisReportConstraintBoolExp = {
  _and?: Maybe<Array<FisReportConstraintBoolExp>>;
  _not?: Maybe<FisReportConstraintBoolExp>;
  _or?: Maybe<Array<FisReportConstraintBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  bad_count?: Maybe<IntComparisonExp>;
  blocked?: Maybe<Float8ComparisonExp>;
  blocked_secondary?: Maybe<Float8ComparisonExp>;
  bypassed?: Maybe<Float8ComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  cycle_time?: Maybe<Float8ComparisonExp>;
  cycling?: Maybe<Float8ComparisonExp>;
  down_external?: Maybe<Float8ComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  fault?: Maybe<Float8ComparisonExp>;
  good_count?: Maybe<IntComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  manual_intervention?: Maybe<Float8ComparisonExp>;
  no_comm?: Maybe<Float8ComparisonExp>;
  productive_duration?: Maybe<Float8ComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  starved?: Maybe<Float8ComparisonExp>;
  starved_secondary?: Maybe<Float8ComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
};

/** aggregate max on columns */
export type FisReportConstraintMaxFields = {
  __typename?: 'fis_report_constraint_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisReportConstraintMinFields = {
  __typename?: 'fis_report_constraint_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "fis.report_constraint". */
export type FisReportConstraintOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  bad_count?: Maybe<OrderBy>;
  blocked?: Maybe<OrderBy>;
  blocked_secondary?: Maybe<OrderBy>;
  bypassed?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  cycle_time?: Maybe<OrderBy>;
  cycling?: Maybe<OrderBy>;
  down_external?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  fault?: Maybe<OrderBy>;
  good_count?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  manual_intervention?: Maybe<OrderBy>;
  no_comm?: Maybe<OrderBy>;
  productive_duration?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  starved?: Maybe<OrderBy>;
  starved_secondary?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_constraint" */
export enum FisReportConstraintSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BadCount = 'bad_count',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedSecondary = 'blocked_secondary',
  /** column name */
  Bypassed = 'bypassed',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Cycling = 'cycling',
  /** column name */
  DownExternal = 'down_external',
  /** column name */
  Duration = 'duration',
  /** column name */
  Fault = 'fault',
  /** column name */
  GoodCount = 'good_count',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  ManualIntervention = 'manual_intervention',
  /** column name */
  NoComm = 'no_comm',
  /** column name */
  ProductiveDuration = 'productive_duration',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Starved = 'starved',
  /** column name */
  StarvedSecondary = 'starved_secondary',
  /** column name */
  Time = 'time'
}

/** aggregate stddev on columns */
export type FisReportConstraintStddevFields = {
  __typename?: 'fis_report_constraint_stddev_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportConstraintStddevPopFields = {
  __typename?: 'fis_report_constraint_stddev_pop_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportConstraintStddevSampFields = {
  __typename?: 'fis_report_constraint_stddev_samp_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_constraint" */
export type FisReportConstraintStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportConstraintStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportConstraintStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type FisReportConstraintSumFields = {
  __typename?: 'fis_report_constraint_sum_fields';
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type FisReportConstraintVarPopFields = {
  __typename?: 'fis_report_constraint_var_pop_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportConstraintVarSampFields = {
  __typename?: 'fis_report_constraint_var_samp_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportConstraintVarianceFields = {
  __typename?: 'fis_report_constraint_variance_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.report_detail" */
export type FisReportDetail = {
  __typename?: 'fis_report_detail';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  /** An object relationship */
  asset_code?: Maybe<FisAssetCode>;
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  data_label?: Maybe<FisDataLabel>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<Scalars['String']>;
};


/** columns and relationships of "fis.report_detail" */
export type FisReportDetailMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.report_detail" */
export type FisReportDetailAggregate = {
  __typename?: 'fis_report_detail_aggregate';
  aggregate?: Maybe<FisReportDetailAggregateFields>;
  nodes: Array<FisReportDetail>;
};

/** aggregate fields of "fis.report_detail" */
export type FisReportDetailAggregateFields = {
  __typename?: 'fis_report_detail_aggregate_fields';
  avg?: Maybe<FisReportDetailAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportDetailMaxFields>;
  min?: Maybe<FisReportDetailMinFields>;
  stddev?: Maybe<FisReportDetailStddevFields>;
  stddev_pop?: Maybe<FisReportDetailStddevPopFields>;
  stddev_samp?: Maybe<FisReportDetailStddevSampFields>;
  sum?: Maybe<FisReportDetailSumFields>;
  var_pop?: Maybe<FisReportDetailVarPopFields>;
  var_samp?: Maybe<FisReportDetailVarSampFields>;
  variance?: Maybe<FisReportDetailVarianceFields>;
};


/** aggregate fields of "fis.report_detail" */
export type FisReportDetailAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportDetailSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportDetailAvgFields = {
  __typename?: 'fis_report_detail_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_detail". All fields are combined with a logical 'AND'. */
export type FisReportDetailBoolExp = {
  _and?: Maybe<Array<FisReportDetailBoolExp>>;
  _not?: Maybe<FisReportDetailBoolExp>;
  _or?: Maybe<Array<FisReportDetailBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_code?: Maybe<FisAssetCodeBoolExp>;
  asset_code_id?: Maybe<UuidComparisonExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_id?: Maybe<UuidComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  timing?: Maybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type FisReportDetailMaxFields = {
  __typename?: 'fis_report_detail_max_fields';
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FisReportDetailMinFields = {
  __typename?: 'fis_report_detail_min_fields';
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fis.report_detail". */
export type FisReportDetailOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_code?: Maybe<FisAssetCodeOrderBy>;
  asset_code_id?: Maybe<OrderBy>;
  asset_id?: Maybe<OrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_id?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  timing?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_detail" */
export enum FisReportDetailSelectColumn {
  /** column name */
  AssetCodeId = 'asset_code_id',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

/** aggregate stddev on columns */
export type FisReportDetailStddevFields = {
  __typename?: 'fis_report_detail_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportDetailStddevPopFields = {
  __typename?: 'fis_report_detail_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportDetailStddevSampFields = {
  __typename?: 'fis_report_detail_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_detail" */
export type FisReportDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportDetailStreamCursorValueInput = {
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  context_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  data_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
  timing?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FisReportDetailSumFields = {
  __typename?: 'fis_report_detail_sum_fields';
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type FisReportDetailVarPopFields = {
  __typename?: 'fis_report_detail_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportDetailVarSampFields = {
  __typename?: 'fis_report_detail_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportDetailVarianceFields = {
  __typename?: 'fis_report_detail_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.report_mtbf" */
export type FisReportMtbf = {
  __typename?: 'fis_report_mtbf';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  asset_id?: Maybe<Scalars['uuid']>;
  ext_duration?: Maybe<Scalars['float8']>;
  ext_occurrence?: Maybe<Scalars['Int']>;
  mf_duration?: Maybe<Scalars['float8']>;
  mf_occurrence?: Maybe<Scalars['Int']>;
  mi_duration?: Maybe<Scalars['float8']>;
  mi_occurrence?: Maybe<Scalars['Int']>;
  productive_time?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "fis.report_mtbf" */
export type FisReportMtbfAggregate = {
  __typename?: 'fis_report_mtbf_aggregate';
  aggregate?: Maybe<FisReportMtbfAggregateFields>;
  nodes: Array<FisReportMtbf>;
};

/** aggregate fields of "fis.report_mtbf" */
export type FisReportMtbfAggregateFields = {
  __typename?: 'fis_report_mtbf_aggregate_fields';
  avg?: Maybe<FisReportMtbfAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportMtbfMaxFields>;
  min?: Maybe<FisReportMtbfMinFields>;
  stddev?: Maybe<FisReportMtbfStddevFields>;
  stddev_pop?: Maybe<FisReportMtbfStddevPopFields>;
  stddev_samp?: Maybe<FisReportMtbfStddevSampFields>;
  sum?: Maybe<FisReportMtbfSumFields>;
  var_pop?: Maybe<FisReportMtbfVarPopFields>;
  var_samp?: Maybe<FisReportMtbfVarSampFields>;
  variance?: Maybe<FisReportMtbfVarianceFields>;
};


/** aggregate fields of "fis.report_mtbf" */
export type FisReportMtbfAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportMtbfSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportMtbfAvgFields = {
  __typename?: 'fis_report_mtbf_avg_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_mtbf". All fields are combined with a logical 'AND'. */
export type FisReportMtbfBoolExp = {
  _and?: Maybe<Array<FisReportMtbfBoolExp>>;
  _not?: Maybe<FisReportMtbfBoolExp>;
  _or?: Maybe<Array<FisReportMtbfBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  ext_duration?: Maybe<Float8ComparisonExp>;
  ext_occurrence?: Maybe<IntComparisonExp>;
  mf_duration?: Maybe<Float8ComparisonExp>;
  mf_occurrence?: Maybe<IntComparisonExp>;
  mi_duration?: Maybe<Float8ComparisonExp>;
  mi_occurrence?: Maybe<IntComparisonExp>;
  productive_time?: Maybe<Float8ComparisonExp>;
};

/** aggregate max on columns */
export type FisReportMtbfMaxFields = {
  __typename?: 'fis_report_mtbf_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  ext_duration?: Maybe<Scalars['float8']>;
  ext_occurrence?: Maybe<Scalars['Int']>;
  mf_duration?: Maybe<Scalars['float8']>;
  mf_occurrence?: Maybe<Scalars['Int']>;
  mi_duration?: Maybe<Scalars['float8']>;
  mi_occurrence?: Maybe<Scalars['Int']>;
  productive_time?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type FisReportMtbfMinFields = {
  __typename?: 'fis_report_mtbf_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  ext_duration?: Maybe<Scalars['float8']>;
  ext_occurrence?: Maybe<Scalars['Int']>;
  mf_duration?: Maybe<Scalars['float8']>;
  mf_occurrence?: Maybe<Scalars['Int']>;
  mi_duration?: Maybe<Scalars['float8']>;
  mi_occurrence?: Maybe<Scalars['Int']>;
  productive_time?: Maybe<Scalars['float8']>;
};

/** Ordering options when selecting data from "fis.report_mtbf". */
export type FisReportMtbfOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  ext_duration?: Maybe<OrderBy>;
  ext_occurrence?: Maybe<OrderBy>;
  mf_duration?: Maybe<OrderBy>;
  mf_occurrence?: Maybe<OrderBy>;
  mi_duration?: Maybe<OrderBy>;
  mi_occurrence?: Maybe<OrderBy>;
  productive_time?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_mtbf" */
export enum FisReportMtbfSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ExtDuration = 'ext_duration',
  /** column name */
  ExtOccurrence = 'ext_occurrence',
  /** column name */
  MfDuration = 'mf_duration',
  /** column name */
  MfOccurrence = 'mf_occurrence',
  /** column name */
  MiDuration = 'mi_duration',
  /** column name */
  MiOccurrence = 'mi_occurrence',
  /** column name */
  ProductiveTime = 'productive_time'
}

/** aggregate stddev on columns */
export type FisReportMtbfStddevFields = {
  __typename?: 'fis_report_mtbf_stddev_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportMtbfStddevPopFields = {
  __typename?: 'fis_report_mtbf_stddev_pop_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportMtbfStddevSampFields = {
  __typename?: 'fis_report_mtbf_stddev_samp_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_mtbf" */
export type FisReportMtbfStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportMtbfStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportMtbfStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  ext_duration?: Maybe<Scalars['float8']>;
  ext_occurrence?: Maybe<Scalars['Int']>;
  mf_duration?: Maybe<Scalars['float8']>;
  mf_occurrence?: Maybe<Scalars['Int']>;
  mi_duration?: Maybe<Scalars['float8']>;
  mi_occurrence?: Maybe<Scalars['Int']>;
  productive_time?: Maybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type FisReportMtbfSumFields = {
  __typename?: 'fis_report_mtbf_sum_fields';
  ext_duration?: Maybe<Scalars['float8']>;
  ext_occurrence?: Maybe<Scalars['Int']>;
  mf_duration?: Maybe<Scalars['float8']>;
  mf_occurrence?: Maybe<Scalars['Int']>;
  mi_duration?: Maybe<Scalars['float8']>;
  mi_occurrence?: Maybe<Scalars['Int']>;
  productive_time?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type FisReportMtbfVarPopFields = {
  __typename?: 'fis_report_mtbf_var_pop_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportMtbfVarSampFields = {
  __typename?: 'fis_report_mtbf_var_samp_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportMtbfVarianceFields = {
  __typename?: 'fis_report_mtbf_variance_fields';
  ext_duration?: Maybe<Scalars['Float']>;
  ext_occurrence?: Maybe<Scalars['Float']>;
  mf_duration?: Maybe<Scalars['Float']>;
  mf_occurrence?: Maybe<Scalars['Float']>;
  mi_duration?: Maybe<Scalars['Float']>;
  mi_occurrence?: Maybe<Scalars['Float']>;
  productive_time?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.report_oee" */
export type FisReportOee = {
  __typename?: 'fis_report_oee';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  /** An object relationship */
  calendar_event?: Maybe<ArgoCalendarEvent>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  /** An object relationship */
  shift_calendar_event?: Maybe<ArgoCalendarEvent>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "fis.report_oee" */
export type FisReportOeeAggregate = {
  __typename?: 'fis_report_oee_aggregate';
  aggregate?: Maybe<FisReportOeeAggregateFields>;
  nodes: Array<FisReportOee>;
};

/** aggregate fields of "fis.report_oee" */
export type FisReportOeeAggregateFields = {
  __typename?: 'fis_report_oee_aggregate_fields';
  avg?: Maybe<FisReportOeeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportOeeMaxFields>;
  min?: Maybe<FisReportOeeMinFields>;
  stddev?: Maybe<FisReportOeeStddevFields>;
  stddev_pop?: Maybe<FisReportOeeStddevPopFields>;
  stddev_samp?: Maybe<FisReportOeeStddevSampFields>;
  sum?: Maybe<FisReportOeeSumFields>;
  var_pop?: Maybe<FisReportOeeVarPopFields>;
  var_samp?: Maybe<FisReportOeeVarSampFields>;
  variance?: Maybe<FisReportOeeVarianceFields>;
};


/** aggregate fields of "fis.report_oee" */
export type FisReportOeeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportOeeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportOeeAvgFields = {
  __typename?: 'fis_report_oee_avg_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_oee". All fields are combined with a logical 'AND'. */
export type FisReportOeeBoolExp = {
  _and?: Maybe<Array<FisReportOeeBoolExp>>;
  _not?: Maybe<FisReportOeeBoolExp>;
  _or?: Maybe<Array<FisReportOeeBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  bad_count?: Maybe<IntComparisonExp>;
  blocked?: Maybe<Float8ComparisonExp>;
  blocked_secondary?: Maybe<Float8ComparisonExp>;
  bypassed?: Maybe<Float8ComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  cycle_time?: Maybe<Float8ComparisonExp>;
  cycling?: Maybe<Float8ComparisonExp>;
  down_external?: Maybe<Float8ComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  fault?: Maybe<Float8ComparisonExp>;
  good_count?: Maybe<IntComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  manual_intervention?: Maybe<Float8ComparisonExp>;
  no_comm?: Maybe<Float8ComparisonExp>;
  productive_duration?: Maybe<Float8ComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  starved?: Maybe<Float8ComparisonExp>;
  starved_secondary?: Maybe<Float8ComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
};

/** aggregate max on columns */
export type FisReportOeeMaxFields = {
  __typename?: 'fis_report_oee_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisReportOeeMinFields = {
  __typename?: 'fis_report_oee_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "fis.report_oee". */
export type FisReportOeeOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  bad_count?: Maybe<OrderBy>;
  blocked?: Maybe<OrderBy>;
  blocked_secondary?: Maybe<OrderBy>;
  bypassed?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  cycle_time?: Maybe<OrderBy>;
  cycling?: Maybe<OrderBy>;
  down_external?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  fault?: Maybe<OrderBy>;
  good_count?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  manual_intervention?: Maybe<OrderBy>;
  no_comm?: Maybe<OrderBy>;
  productive_duration?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  starved?: Maybe<OrderBy>;
  starved_secondary?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_oee" */
export enum FisReportOeeSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BadCount = 'bad_count',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedSecondary = 'blocked_secondary',
  /** column name */
  Bypassed = 'bypassed',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Cycling = 'cycling',
  /** column name */
  DownExternal = 'down_external',
  /** column name */
  Duration = 'duration',
  /** column name */
  Fault = 'fault',
  /** column name */
  GoodCount = 'good_count',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  ManualIntervention = 'manual_intervention',
  /** column name */
  NoComm = 'no_comm',
  /** column name */
  ProductiveDuration = 'productive_duration',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Starved = 'starved',
  /** column name */
  StarvedSecondary = 'starved_secondary',
  /** column name */
  Time = 'time'
}

/** aggregate stddev on columns */
export type FisReportOeeStddevFields = {
  __typename?: 'fis_report_oee_stddev_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportOeeStddevPopFields = {
  __typename?: 'fis_report_oee_stddev_pop_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportOeeStddevSampFields = {
  __typename?: 'fis_report_oee_stddev_samp_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_oee" */
export type FisReportOeeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportOeeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportOeeStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type FisReportOeeSumFields = {
  __typename?: 'fis_report_oee_sum_fields';
  bad_count?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['float8']>;
  blocked_secondary?: Maybe<Scalars['float8']>;
  bypassed?: Maybe<Scalars['float8']>;
  cycle_time?: Maybe<Scalars['float8']>;
  cycling?: Maybe<Scalars['float8']>;
  down_external?: Maybe<Scalars['float8']>;
  duration?: Maybe<Scalars['float8']>;
  fault?: Maybe<Scalars['float8']>;
  good_count?: Maybe<Scalars['Int']>;
  manual_intervention?: Maybe<Scalars['float8']>;
  no_comm?: Maybe<Scalars['float8']>;
  productive_duration?: Maybe<Scalars['float8']>;
  starved?: Maybe<Scalars['float8']>;
  starved_secondary?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type FisReportOeeVarPopFields = {
  __typename?: 'fis_report_oee_var_pop_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportOeeVarSampFields = {
  __typename?: 'fis_report_oee_var_samp_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportOeeVarianceFields = {
  __typename?: 'fis_report_oee_variance_fields';
  bad_count?: Maybe<Scalars['Float']>;
  blocked?: Maybe<Scalars['Float']>;
  blocked_secondary?: Maybe<Scalars['Float']>;
  bypassed?: Maybe<Scalars['Float']>;
  cycle_time?: Maybe<Scalars['Float']>;
  cycling?: Maybe<Scalars['Float']>;
  down_external?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fault?: Maybe<Scalars['Float']>;
  good_count?: Maybe<Scalars['Float']>;
  manual_intervention?: Maybe<Scalars['Float']>;
  no_comm?: Maybe<Scalars['Float']>;
  productive_duration?: Maybe<Scalars['Float']>;
  starved?: Maybe<Scalars['Float']>;
  starved_secondary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.report_state" */
export type FisReportState = {
  __typename?: 'fis_report_state';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  /** An object relationship */
  asset_code?: Maybe<FisAssetCode>;
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  calendar_event?: Maybe<ArgoCalendarEvent>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  /** An object relationship */
  shift_calendar_event?: Maybe<ArgoCalendarEvent>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};


/** columns and relationships of "fis.report_state" */
export type FisReportStateMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.report_state" */
export type FisReportStateAggregate = {
  __typename?: 'fis_report_state_aggregate';
  aggregate?: Maybe<FisReportStateAggregateFields>;
  nodes: Array<FisReportState>;
};

/** aggregate fields of "fis.report_state" */
export type FisReportStateAggregateFields = {
  __typename?: 'fis_report_state_aggregate_fields';
  avg?: Maybe<FisReportStateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportStateMaxFields>;
  min?: Maybe<FisReportStateMinFields>;
  stddev?: Maybe<FisReportStateStddevFields>;
  stddev_pop?: Maybe<FisReportStateStddevPopFields>;
  stddev_samp?: Maybe<FisReportStateStddevSampFields>;
  sum?: Maybe<FisReportStateSumFields>;
  var_pop?: Maybe<FisReportStateVarPopFields>;
  var_samp?: Maybe<FisReportStateVarSampFields>;
  variance?: Maybe<FisReportStateVarianceFields>;
};


/** aggregate fields of "fis.report_state" */
export type FisReportStateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportStateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportStateAvgFields = {
  __typename?: 'fis_report_state_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_state". All fields are combined with a logical 'AND'. */
export type FisReportStateBoolExp = {
  _and?: Maybe<Array<FisReportStateBoolExp>>;
  _not?: Maybe<FisReportStateBoolExp>;
  _or?: Maybe<Array<FisReportStateBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_code?: Maybe<FisAssetCodeBoolExp>;
  asset_code_id?: Maybe<UuidComparisonExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
  occurrence?: Maybe<IntComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  time_range?: Maybe<TsrangeComparisonExp>;
};

/** columns and relationships of "fis.report_state_column" */
export type FisReportStateColumn = {
  __typename?: 'fis_report_state_column';
  data_label_id?: Maybe<Scalars['uuid']>;
  data_label_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  num_val?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "fis.report_state_column" */
export type FisReportStateColumnAggregate = {
  __typename?: 'fis_report_state_column_aggregate';
  aggregate?: Maybe<FisReportStateColumnAggregateFields>;
  nodes: Array<FisReportStateColumn>;
};

/** aggregate fields of "fis.report_state_column" */
export type FisReportStateColumnAggregateFields = {
  __typename?: 'fis_report_state_column_aggregate_fields';
  avg?: Maybe<FisReportStateColumnAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportStateColumnMaxFields>;
  min?: Maybe<FisReportStateColumnMinFields>;
  stddev?: Maybe<FisReportStateColumnStddevFields>;
  stddev_pop?: Maybe<FisReportStateColumnStddevPopFields>;
  stddev_samp?: Maybe<FisReportStateColumnStddevSampFields>;
  sum?: Maybe<FisReportStateColumnSumFields>;
  var_pop?: Maybe<FisReportStateColumnVarPopFields>;
  var_samp?: Maybe<FisReportStateColumnVarSampFields>;
  variance?: Maybe<FisReportStateColumnVarianceFields>;
};


/** aggregate fields of "fis.report_state_column" */
export type FisReportStateColumnAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportStateColumnAvgFields = {
  __typename?: 'fis_report_state_column_avg_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_state_column". All fields are combined with a logical 'AND'. */
export type FisReportStateColumnBoolExp = {
  _and?: Maybe<Array<FisReportStateColumnBoolExp>>;
  _not?: Maybe<FisReportStateColumnBoolExp>;
  _or?: Maybe<Array<FisReportStateColumnBoolExp>>;
  data_label_id?: Maybe<UuidComparisonExp>;
  data_label_name?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
};

/** aggregate max on columns */
export type FisReportStateColumnMaxFields = {
  __typename?: 'fis_report_state_column_max_fields';
  data_label_id?: Maybe<Scalars['uuid']>;
  data_label_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  num_val?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type FisReportStateColumnMinFields = {
  __typename?: 'fis_report_state_column_min_fields';
  data_label_id?: Maybe<Scalars['uuid']>;
  data_label_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  num_val?: Maybe<Scalars['float8']>;
};

/** Ordering options when selecting data from "fis.report_state_column". */
export type FisReportStateColumnOrderBy = {
  data_label_id?: Maybe<OrderBy>;
  data_label_name?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_state_column" */
export enum FisReportStateColumnSelectColumn {
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  DataLabelName = 'data_label_name',
  /** column name */
  Description = 'description',
  /** column name */
  NumVal = 'num_val'
}

/** aggregate stddev on columns */
export type FisReportStateColumnStddevFields = {
  __typename?: 'fis_report_state_column_stddev_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportStateColumnStddevPopFields = {
  __typename?: 'fis_report_state_column_stddev_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportStateColumnStddevSampFields = {
  __typename?: 'fis_report_state_column_stddev_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_state_column" */
export type FisReportStateColumnStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportStateColumnStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportStateColumnStreamCursorValueInput = {
  data_label_id?: Maybe<Scalars['uuid']>;
  data_label_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  num_val?: Maybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type FisReportStateColumnSumFields = {
  __typename?: 'fis_report_state_column_sum_fields';
  num_val?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type FisReportStateColumnVarPopFields = {
  __typename?: 'fis_report_state_column_var_pop_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportStateColumnVarSampFields = {
  __typename?: 'fis_report_state_column_var_samp_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportStateColumnVarianceFields = {
  __typename?: 'fis_report_state_column_variance_fields';
  num_val?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type FisReportStateMaxFields = {
  __typename?: 'fis_report_state_max_fields';
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisReportStateMinFields = {
  __typename?: 'fis_report_state_min_fields';
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "fis.report_state". */
export type FisReportStateOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_code?: Maybe<FisAssetCodeOrderBy>;
  asset_code_id?: Maybe<OrderBy>;
  asset_id?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  data_label_id?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  occurrence?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  time_range?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_state" */
export enum FisReportStateSelectColumn {
  /** column name */
  AssetCodeId = 'asset_code_id',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** aggregate stddev on columns */
export type FisReportStateStddevFields = {
  __typename?: 'fis_report_state_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportStateStddevPopFields = {
  __typename?: 'fis_report_state_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportStateStddevSampFields = {
  __typename?: 'fis_report_state_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_state" */
export type FisReportStateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportStateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportStateStreamCursorValueInput = {
  asset_code_id?: Maybe<Scalars['uuid']>;
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate sum on columns */
export type FisReportStateSumFields = {
  __typename?: 'fis_report_state_sum_fields';
  duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type FisReportStateVarPopFields = {
  __typename?: 'fis_report_state_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportStateVarSampFields = {
  __typename?: 'fis_report_state_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportStateVarianceFields = {
  __typename?: 'fis_report_state_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fis.report_top_fault" */
export type FisReportTopFault = {
  __typename?: 'fis_report_top_fault';
  /** An object relationship */
  asset?: Maybe<FisAsset>;
  asset_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  calendar_event?: Maybe<ArgoCalendarEvent>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  data_label?: Maybe<FisDataLabel>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  /** An object relationship */
  shift_calendar_event?: Maybe<ArgoCalendarEvent>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};


/** columns and relationships of "fis.report_top_fault" */
export type FisReportTopFaultMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fis.report_top_fault" */
export type FisReportTopFaultAggregate = {
  __typename?: 'fis_report_top_fault_aggregate';
  aggregate?: Maybe<FisReportTopFaultAggregateFields>;
  nodes: Array<FisReportTopFault>;
};

/** aggregate fields of "fis.report_top_fault" */
export type FisReportTopFaultAggregateFields = {
  __typename?: 'fis_report_top_fault_aggregate_fields';
  avg?: Maybe<FisReportTopFaultAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FisReportTopFaultMaxFields>;
  min?: Maybe<FisReportTopFaultMinFields>;
  stddev?: Maybe<FisReportTopFaultStddevFields>;
  stddev_pop?: Maybe<FisReportTopFaultStddevPopFields>;
  stddev_samp?: Maybe<FisReportTopFaultStddevSampFields>;
  sum?: Maybe<FisReportTopFaultSumFields>;
  var_pop?: Maybe<FisReportTopFaultVarPopFields>;
  var_samp?: Maybe<FisReportTopFaultVarSampFields>;
  variance?: Maybe<FisReportTopFaultVarianceFields>;
};


/** aggregate fields of "fis.report_top_fault" */
export type FisReportTopFaultAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FisReportTopFaultAvgFields = {
  __typename?: 'fis_report_top_fault_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fis.report_top_fault". All fields are combined with a logical 'AND'. */
export type FisReportTopFaultBoolExp = {
  _and?: Maybe<Array<FisReportTopFaultBoolExp>>;
  _not?: Maybe<FisReportTopFaultBoolExp>;
  _or?: Maybe<Array<FisReportTopFaultBoolExp>>;
  asset?: Maybe<FisAssetBoolExp>;
  asset_id?: Maybe<UuidComparisonExp>;
  calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  calendar_event_id?: Maybe<UuidComparisonExp>;
  data_label?: Maybe<FisDataLabelBoolExp>;
  data_label_id?: Maybe<UuidComparisonExp>;
  duration?: Maybe<Float8ComparisonExp>;
  event_duration?: Maybe<Float8ComparisonExp>;
  is_productive?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<Float8ComparisonExp>;
  occurrence?: Maybe<IntComparisonExp>;
  shift_calendar_event?: Maybe<ArgoCalendarEventBoolExp>;
  shift_calendar_event_id?: Maybe<UuidComparisonExp>;
  time?: Maybe<TimestampComparisonExp>;
  time_range?: Maybe<TsrangeComparisonExp>;
};

/** aggregate max on columns */
export type FisReportTopFaultMaxFields = {
  __typename?: 'fis_report_top_fault_max_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type FisReportTopFaultMinFields = {
  __typename?: 'fis_report_top_fault_min_fields';
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
};

/** Ordering options when selecting data from "fis.report_top_fault". */
export type FisReportTopFaultOrderBy = {
  asset?: Maybe<FisAssetOrderBy>;
  asset_id?: Maybe<OrderBy>;
  calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  calendar_event_id?: Maybe<OrderBy>;
  data_label?: Maybe<FisDataLabelOrderBy>;
  data_label_id?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  event_duration?: Maybe<OrderBy>;
  is_productive?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  occurrence?: Maybe<OrderBy>;
  shift_calendar_event?: Maybe<ArgoCalendarEventOrderBy>;
  shift_calendar_event_id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  time_range?: Maybe<OrderBy>;
};

/** select columns of table "fis.report_top_fault" */
export enum FisReportTopFaultSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** aggregate stddev on columns */
export type FisReportTopFaultStddevFields = {
  __typename?: 'fis_report_top_fault_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FisReportTopFaultStddevPopFields = {
  __typename?: 'fis_report_top_fault_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FisReportTopFaultStddevSampFields = {
  __typename?: 'fis_report_top_fault_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fis_report_top_fault" */
export type FisReportTopFaultStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FisReportTopFaultStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FisReportTopFaultStreamCursorValueInput = {
  asset_id?: Maybe<Scalars['uuid']>;
  calendar_event_id?: Maybe<Scalars['uuid']>;
  data_label_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  is_productive?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['jsonb']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
  shift_calendar_event_id?: Maybe<Scalars['uuid']>;
  time?: Maybe<Scalars['timestamp']>;
  time_range?: Maybe<Scalars['tsrange']>;
};

/** aggregate sum on columns */
export type FisReportTopFaultSumFields = {
  __typename?: 'fis_report_top_fault_sum_fields';
  duration?: Maybe<Scalars['float8']>;
  event_duration?: Maybe<Scalars['float8']>;
  num_val?: Maybe<Scalars['float8']>;
  occurrence?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type FisReportTopFaultVarPopFields = {
  __typename?: 'fis_report_top_fault_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FisReportTopFaultVarSampFields = {
  __typename?: 'fis_report_top_fault_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FisReportTopFaultVarianceFields = {
  __typename?: 'fis_report_top_fault_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  event_duration?: Maybe<Scalars['Float']>;
  num_val?: Maybe<Scalars['Float']>;
  occurrence?: Maybe<Scalars['Float']>;
};

export type FisRunReportConstraintArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  event_days?: Maybe<Scalars['_text']>;
  event_ids?: Maybe<Scalars['_uuid']>;
  include_non_productive?: Maybe<Scalars['Boolean']>;
  start_time?: Maybe<Scalars['timestamp']>;
};

export type FisRunReportMtbfArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  start_time?: Maybe<Scalars['timestamp']>;
};

export type FisRunReportOeeArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  event_days?: Maybe<Scalars['_text']>;
  event_ids?: Maybe<Scalars['_uuid']>;
  include_non_productive?: Maybe<Scalars['Boolean']>;
  start_time?: Maybe<Scalars['timestamp']>;
};

export type FisRunReportStateArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  data_label_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  event_days?: Maybe<Scalars['_text']>;
  event_ids?: Maybe<Scalars['_uuid']>;
  include_non_productive?: Maybe<Scalars['Boolean']>;
  start_time?: Maybe<Scalars['timestamp']>;
};

export type FisRunReportStateColumnArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  data_label_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  event_days?: Maybe<Scalars['_text']>;
  event_ids?: Maybe<Scalars['_uuid']>;
  include_non_productive?: Maybe<Scalars['Boolean']>;
  start_time?: Maybe<Scalars['timestamp']>;
};

export type FisRunReportTopFaultArgs = {
  asset_ids?: Maybe<Scalars['_uuid']>;
  data_label_ids?: Maybe<Scalars['_uuid']>;
  end_time?: Maybe<Scalars['timestamp']>;
  include_non_productive?: Maybe<Scalars['Boolean']>;
  start_time?: Maybe<Scalars['timestamp']>;
  top_count?: Maybe<Scalars['Int']>;
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};


/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type IntervalComparisonExp = {
  _eq?: Maybe<Scalars['interval']>;
  _gt?: Maybe<Scalars['interval']>;
  _gte?: Maybe<Scalars['interval']>;
  _in?: Maybe<Array<Scalars['interval']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['interval']>;
  _lte?: Maybe<Scalars['interval']>;
  _neq?: Maybe<Scalars['interval']>;
  _nin?: Maybe<Array<Scalars['interval']>>;
};


/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};


export type JsonbCastExp = {
  String?: Maybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: Maybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** execute VOLATILE function "argo.create_material" which returns "plv8_response" */
  argo_create_material?: Maybe<Plv8Response>;
  /** execute VOLATILE function "argo.create_materials" which returns "argo.material" */
  argo_create_materials: Array<ArgoMaterial>;
  /** execute VOLATILE function "argo.create_work_instruction_instance" which returns "plv8_response" */
  argo_create_work_instruction_instance?: Maybe<Plv8Response>;
  /** execute VOLATILE function "argo.hasura_cron" which returns "argo.cron_task" */
  argo_hasura_cron: Array<ArgoCronTask>;
  /** execute VOLATILE function "argo.marry_material" which returns "plv8_response" */
  argo_marry_material?: Maybe<Plv8Response>;
  /** execute VOLATILE function "argo.sn_format_datetime_token" which returns "plv8_value_response" */
  argo_sn_format_datetime_token?: Maybe<Plv8ValueResponse>;
  /** execute VOLATILE function "argo.sn_generate" which returns "plv8_value_response" */
  argo_sn_generate?: Maybe<Plv8ValueResponse>;
  /** execute VOLATILE function "argo.sn_generate_align_content" which returns "plv8_value_response" */
  argo_sn_generate_align_content?: Maybe<Plv8ValueResponse>;
  /** execute VOLATILE function "argo.sn_generate_sequence" which returns "plv8_value_response" */
  argo_sn_generate_sequence?: Maybe<Plv8ValueResponse>;
  /** execute VOLATILE function "argo.work_order_set_status" which returns "argo.work_order" */
  argo_work_order_set_status: Array<ArgoWorkOrder>;
  /** delete data from the table: "applet.deployment" */
  delete_applet_deployment?: Maybe<AppletDeploymentMutationResponse>;
  /** delete single row from the table: "applet.deployment" */
  delete_applet_deployment_by_pk?: Maybe<AppletDeployment>;
  /** delete data from the table: "applet.deployment_linked_design_version" */
  delete_applet_deployment_linked_design_version?: Maybe<AppletDeploymentLinkedDesignVersionMutationResponse>;
  /** delete single row from the table: "applet.deployment_linked_design_version" */
  delete_applet_deployment_linked_design_version_by_pk?: Maybe<AppletDeploymentLinkedDesignVersion>;
  /** delete data from the table: "applet.design" */
  delete_applet_design?: Maybe<AppletDesignMutationResponse>;
  /** delete single row from the table: "applet.design" */
  delete_applet_design_by_pk?: Maybe<AppletDesign>;
  /** delete data from the table: "applet.design_version" */
  delete_applet_design_version?: Maybe<AppletDesignVersionMutationResponse>;
  /** delete single row from the table: "applet.design_version" */
  delete_applet_design_version_by_pk?: Maybe<AppletDesignVersion>;
  /** delete data from the table: "applet.design_version_status" */
  delete_applet_design_version_status?: Maybe<AppletDesignVersionStatusMutationResponse>;
  /** delete single row from the table: "applet.design_version_status" */
  delete_applet_design_version_status_by_pk?: Maybe<AppletDesignVersionStatus>;
  /** delete data from the table: "applet.registration_code" */
  delete_applet_registration_code?: Maybe<AppletRegistrationCodeMutationResponse>;
  /** delete single row from the table: "applet.registration_code" */
  delete_applet_registration_code_by_pk?: Maybe<AppletRegistrationCode>;
  /** delete data from the table: "applet.runner" */
  delete_applet_runner?: Maybe<AppletRunnerMutationResponse>;
  /** delete single row from the table: "applet.runner" */
  delete_applet_runner_by_pk?: Maybe<AppletRunner>;
  /** delete data from the table: "applet.runner_context" */
  delete_applet_runner_context?: Maybe<AppletRunnerContextMutationResponse>;
  /** delete single row from the table: "applet.runner_context" */
  delete_applet_runner_context_by_pk?: Maybe<AppletRunnerContext>;
  /** delete data from the table: "argo.acl" */
  delete_argo_acl?: Maybe<ArgoAclMutationResponse>;
  /** delete single row from the table: "argo.acl" */
  delete_argo_acl_by_pk?: Maybe<ArgoAcl>;
  /** delete data from the table: "argo.attribute" */
  delete_argo_attribute?: Maybe<ArgoAttributeMutationResponse>;
  /** delete single row from the table: "argo.attribute" */
  delete_argo_attribute_by_pk?: Maybe<ArgoAttribute>;
  /** delete data from the table: "argo.attribute_data" */
  delete_argo_attribute_data?: Maybe<ArgoAttributeDataMutationResponse>;
  /** delete single row from the table: "argo.attribute_data" */
  delete_argo_attribute_data_by_pk?: Maybe<ArgoAttributeData>;
  /** delete data from the table: "argo.attribute_history_status_type" */
  delete_argo_attribute_history_status_type?: Maybe<ArgoAttributeHistoryStatusTypeMutationResponse>;
  /** delete single row from the table: "argo.attribute_history_status_type" */
  delete_argo_attribute_history_status_type_by_pk?: Maybe<ArgoAttributeHistoryStatusType>;
  /** delete data from the table: "argo.attribute_schema" */
  delete_argo_attribute_schema?: Maybe<ArgoAttributeSchemaMutationResponse>;
  /** delete single row from the table: "argo.attribute_schema" */
  delete_argo_attribute_schema_by_pk?: Maybe<ArgoAttributeSchema>;
  /** delete data from the table: "argo.attribute_schema_definition" */
  delete_argo_attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionMutationResponse>;
  /** delete single row from the table: "argo.attribute_schema_definition" */
  delete_argo_attribute_schema_definition_by_pk?: Maybe<ArgoAttributeSchemaDefinition>;
  /** delete data from the table: "argo.attribute_schema_definition_type" */
  delete_argo_attribute_schema_definition_type?: Maybe<ArgoAttributeSchemaDefinitionTypeMutationResponse>;
  /** delete single row from the table: "argo.attribute_schema_definition_type" */
  delete_argo_attribute_schema_definition_type_by_pk?: Maybe<ArgoAttributeSchemaDefinitionType>;
  /** delete data from the table: "argo.attribute_schema_type" */
  delete_argo_attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeMutationResponse>;
  /** delete single row from the table: "argo.attribute_schema_type" */
  delete_argo_attribute_schema_type_by_pk?: Maybe<ArgoAttributeSchemaType>;
  /** delete data from the table: "argo.audit" */
  delete_argo_audit?: Maybe<ArgoAuditMutationResponse>;
  /** delete single row from the table: "argo.audit" */
  delete_argo_audit_by_pk?: Maybe<ArgoAudit>;
  /** delete data from the table: "argo.auth_provider" */
  delete_argo_auth_provider?: Maybe<ArgoAuthProviderMutationResponse>;
  /** delete single row from the table: "argo.auth_provider" */
  delete_argo_auth_provider_by_pk?: Maybe<ArgoAuthProvider>;
  /** delete data from the table: "argo.auth_provider_local" */
  delete_argo_auth_provider_local?: Maybe<ArgoAuthProviderLocalMutationResponse>;
  /** delete single row from the table: "argo.auth_provider_local" */
  delete_argo_auth_provider_local_by_pk?: Maybe<ArgoAuthProviderLocal>;
  /** delete data from the table: "argo.auth_provider_local_setting" */
  delete_argo_auth_provider_local_setting?: Maybe<ArgoAuthProviderLocalSettingMutationResponse>;
  /** delete single row from the table: "argo.auth_provider_local_setting" */
  delete_argo_auth_provider_local_setting_by_pk?: Maybe<ArgoAuthProviderLocalSetting>;
  /** delete data from the table: "argo.auth_provider_msal" */
  delete_argo_auth_provider_msal?: Maybe<ArgoAuthProviderMsalMutationResponse>;
  /** delete single row from the table: "argo.auth_provider_msal" */
  delete_argo_auth_provider_msal_by_pk?: Maybe<ArgoAuthProviderMsal>;
  /** delete data from the table: "argo.auth_provider_msal_setting" */
  delete_argo_auth_provider_msal_setting?: Maybe<ArgoAuthProviderMsalSettingMutationResponse>;
  /** delete single row from the table: "argo.auth_provider_msal_setting" */
  delete_argo_auth_provider_msal_setting_by_pk?: Maybe<ArgoAuthProviderMsalSetting>;
  /** delete data from the table: "argo.auth_provider_record" */
  delete_argo_auth_provider_record?: Maybe<ArgoAuthProviderRecordMutationResponse>;
  /** delete single row from the table: "argo.auth_provider_record" */
  delete_argo_auth_provider_record_by_pk?: Maybe<ArgoAuthProviderRecord>;
  /** delete data from the table: "argo.auth_refresh_token" */
  delete_argo_auth_refresh_token?: Maybe<ArgoAuthRefreshTokenMutationResponse>;
  /** delete single row from the table: "argo.auth_refresh_token" */
  delete_argo_auth_refresh_token_by_pk?: Maybe<ArgoAuthRefreshToken>;
  /** delete data from the table: "argo.calendar" */
  delete_argo_calendar?: Maybe<ArgoCalendarMutationResponse>;
  /** delete single row from the table: "argo.calendar" */
  delete_argo_calendar_by_pk?: Maybe<ArgoCalendar>;
  /** delete data from the table: "argo.calendar_event" */
  delete_argo_calendar_event?: Maybe<ArgoCalendarEventMutationResponse>;
  /** delete single row from the table: "argo.calendar_event" */
  delete_argo_calendar_event_by_pk?: Maybe<ArgoCalendarEvent>;
  /** delete data from the table: "argo.calendar_event_sequence" */
  delete_argo_calendar_event_sequence?: Maybe<ArgoCalendarEventSequenceMutationResponse>;
  /** delete data from the table: "argo.calendar_event_udf_data" */
  delete_argo_calendar_event_udf_data?: Maybe<ArgoCalendarEventUdfDataMutationResponse>;
  /** delete single row from the table: "argo.calendar_event_udf_data" */
  delete_argo_calendar_event_udf_data_by_pk?: Maybe<ArgoCalendarEventUdfData>;
  /** delete data from the table: "argo.calendar_event_udf_default_data" */
  delete_argo_calendar_event_udf_default_data?: Maybe<ArgoCalendarEventUdfDefaultDataMutationResponse>;
  /** delete single row from the table: "argo.calendar_event_udf_default_data" */
  delete_argo_calendar_event_udf_default_data_by_pk?: Maybe<ArgoCalendarEventUdfDefaultData>;
  /** delete data from the table: "argo.calendar_event_udf_schema" */
  delete_argo_calendar_event_udf_schema?: Maybe<ArgoCalendarEventUdfSchemaMutationResponse>;
  /** delete single row from the table: "argo.calendar_event_udf_schema" */
  delete_argo_calendar_event_udf_schema_by_pk?: Maybe<ArgoCalendarEventUdfSchema>;
  /** delete data from the table: "argo.calendar_location" */
  delete_argo_calendar_location?: Maybe<ArgoCalendarLocationMutationResponse>;
  /** delete single row from the table: "argo.calendar_location" */
  delete_argo_calendar_location_by_pk?: Maybe<ArgoCalendarLocation>;
  /** delete data from the table: "argo.connection" */
  delete_argo_connection?: Maybe<ArgoConnectionMutationResponse>;
  /** delete single row from the table: "argo.connection" */
  delete_argo_connection_by_pk?: Maybe<ArgoConnection>;
  /** delete data from the table: "argo.connection_config" */
  delete_argo_connection_config?: Maybe<ArgoConnectionConfigMutationResponse>;
  /** delete single row from the table: "argo.connection_config" */
  delete_argo_connection_config_by_pk?: Maybe<ArgoConnectionConfig>;
  /** delete data from the table: "argo.connection_config_status" */
  delete_argo_connection_config_status?: Maybe<ArgoConnectionConfigStatusMutationResponse>;
  /** delete single row from the table: "argo.connection_config_status" */
  delete_argo_connection_config_status_by_pk?: Maybe<ArgoConnectionConfigStatus>;
  /** delete data from the table: "argo.connection_kind" */
  delete_argo_connection_kind?: Maybe<ArgoConnectionKindMutationResponse>;
  /** delete single row from the table: "argo.connection_kind" */
  delete_argo_connection_kind_by_pk?: Maybe<ArgoConnectionKind>;
  /** delete data from the table: "argo.context" */
  delete_argo_context?: Maybe<ArgoContextMutationResponse>;
  /** delete single row from the table: "argo.context" */
  delete_argo_context_by_pk?: Maybe<ArgoContext>;
  /** delete data from the table: "argo.cron_task" */
  delete_argo_cron_task?: Maybe<ArgoCronTaskMutationResponse>;
  /** delete single row from the table: "argo.cron_task" */
  delete_argo_cron_task_by_pk?: Maybe<ArgoCronTask>;
  /** delete data from the table: "argo.event" */
  delete_argo_event?: Maybe<ArgoEventMutationResponse>;
  /** delete single row from the table: "argo.event" */
  delete_argo_event_by_pk?: Maybe<ArgoEvent>;
  /** delete data from the table: "argo.event_type" */
  delete_argo_event_type?: Maybe<ArgoEventTypeMutationResponse>;
  /** delete single row from the table: "argo.event_type" */
  delete_argo_event_type_by_pk?: Maybe<ArgoEventType>;
  /** delete data from the table: "argo.hasura_permission" */
  delete_argo_hasura_permission?: Maybe<ArgoHasuraPermissionMutationResponse>;
  /** delete single row from the table: "argo.hasura_permission" */
  delete_argo_hasura_permission_by_pk?: Maybe<ArgoHasuraPermission>;
  /** delete data from the table: "argo.link" */
  delete_argo_link?: Maybe<ArgoLinkMutationResponse>;
  /** delete single row from the table: "argo.link" */
  delete_argo_link_by_pk?: Maybe<ArgoLink>;
  /** delete data from the table: "argo.location" */
  delete_argo_location?: Maybe<ArgoLocationMutationResponse>;
  /** delete data from the table: "argo.location_attribute" */
  delete_argo_location_attribute?: Maybe<ArgoLocationAttributeMutationResponse>;
  /** delete single row from the table: "argo.location_attribute" */
  delete_argo_location_attribute_by_pk?: Maybe<ArgoLocationAttribute>;
  /** delete data from the table: "argo.location_attribute_history" */
  delete_argo_location_attribute_history?: Maybe<ArgoLocationAttributeHistoryMutationResponse>;
  /** delete single row from the table: "argo.location_attribute_history" */
  delete_argo_location_attribute_history_by_pk?: Maybe<ArgoLocationAttributeHistory>;
  /** delete single row from the table: "argo.location" */
  delete_argo_location_by_pk?: Maybe<ArgoLocation>;
  /** delete data from the table: "argo.location_class" */
  delete_argo_location_class?: Maybe<ArgoLocationClassMutationResponse>;
  /** delete single row from the table: "argo.location_class" */
  delete_argo_location_class_by_pk?: Maybe<ArgoLocationClass>;
  /** delete data from the table: "argo.log" */
  delete_argo_log?: Maybe<ArgoLogMutationResponse>;
  /** delete single row from the table: "argo.log" */
  delete_argo_log_by_pk?: Maybe<ArgoLog>;
  /** delete data from the table: "argo.log_category" */
  delete_argo_log_category?: Maybe<ArgoLogCategoryMutationResponse>;
  /** delete single row from the table: "argo.log_category" */
  delete_argo_log_category_by_pk?: Maybe<ArgoLogCategory>;
  /** delete data from the table: "argo.log_duration" */
  delete_argo_log_duration?: Maybe<ArgoLogDurationMutationResponse>;
  /** delete data from the table: "argo.log_level" */
  delete_argo_log_level?: Maybe<ArgoLogLevelMutationResponse>;
  /** delete single row from the table: "argo.log_level" */
  delete_argo_log_level_by_pk?: Maybe<ArgoLogLevel>;
  /** delete data from the table: "argo.material" */
  delete_argo_material?: Maybe<ArgoMaterialMutationResponse>;
  /** delete data from the table: "argo.material_activity" */
  delete_argo_material_activity?: Maybe<ArgoMaterialActivityMutationResponse>;
  /** delete single row from the table: "argo.material_activity" */
  delete_argo_material_activity_by_pk?: Maybe<ArgoMaterialActivity>;
  /** delete data from the table: "argo.material_activity_kind" */
  delete_argo_material_activity_kind?: Maybe<ArgoMaterialActivityKindMutationResponse>;
  /** delete single row from the table: "argo.material_activity_kind" */
  delete_argo_material_activity_kind_by_pk?: Maybe<ArgoMaterialActivityKind>;
  /** delete data from the table: "argo.material_assembly" */
  delete_argo_material_assembly?: Maybe<ArgoMaterialAssemblyMutationResponse>;
  /** delete data from the table: "argo.material_attribute" */
  delete_argo_material_attribute?: Maybe<ArgoMaterialAttributeMutationResponse>;
  /** delete single row from the table: "argo.material_attribute" */
  delete_argo_material_attribute_by_pk?: Maybe<ArgoMaterialAttribute>;
  /** delete data from the table: "argo.material_attribute_history" */
  delete_argo_material_attribute_history?: Maybe<ArgoMaterialAttributeHistoryMutationResponse>;
  /** delete single row from the table: "argo.material_attribute_history" */
  delete_argo_material_attribute_history_by_pk?: Maybe<ArgoMaterialAttributeHistory>;
  /** delete single row from the table: "argo.material" */
  delete_argo_material_by_pk?: Maybe<ArgoMaterial>;
  /** delete data from the table: "argo.material_class" */
  delete_argo_material_class?: Maybe<ArgoMaterialClassMutationResponse>;
  /** delete data from the table: "argo.material_class_attribute" */
  delete_argo_material_class_attribute?: Maybe<ArgoMaterialClassAttributeMutationResponse>;
  /** delete single row from the table: "argo.material_class_attribute" */
  delete_argo_material_class_attribute_by_pk?: Maybe<ArgoMaterialClassAttribute>;
  /** delete data from the table: "argo.material_class_attribute_setting" */
  delete_argo_material_class_attribute_setting?: Maybe<ArgoMaterialClassAttributeSettingMutationResponse>;
  /** delete single row from the table: "argo.material_class_attribute_setting" */
  delete_argo_material_class_attribute_setting_by_pk?: Maybe<ArgoMaterialClassAttributeSetting>;
  /** delete single row from the table: "argo.material_class" */
  delete_argo_material_class_by_pk?: Maybe<ArgoMaterialClass>;
  /** delete data from the table: "argo.material_class_process" */
  delete_argo_material_class_process?: Maybe<ArgoMaterialClassProcessMutationResponse>;
  /** delete single row from the table: "argo.material_class_process" */
  delete_argo_material_class_process_by_pk?: Maybe<ArgoMaterialClassProcess>;
  /** delete data from the table: "argo.material_marriage" */
  delete_argo_material_marriage?: Maybe<ArgoMaterialMarriageMutationResponse>;
  /** delete single row from the table: "argo.material_marriage" */
  delete_argo_material_marriage_by_pk?: Maybe<ArgoMaterialMarriage>;
  /** delete data from the table: "argo.material_marriage_status" */
  delete_argo_material_marriage_status?: Maybe<ArgoMaterialMarriageStatusMutationResponse>;
  /** delete single row from the table: "argo.material_marriage_status" */
  delete_argo_material_marriage_status_by_pk?: Maybe<ArgoMaterialMarriageStatus>;
  /** delete data from the table: "argo.material_model" */
  delete_argo_material_model?: Maybe<ArgoMaterialModelMutationResponse>;
  /** delete data from the table: "argo.material_model_attribute" */
  delete_argo_material_model_attribute?: Maybe<ArgoMaterialModelAttributeMutationResponse>;
  /** delete single row from the table: "argo.material_model_attribute" */
  delete_argo_material_model_attribute_by_pk?: Maybe<ArgoMaterialModelAttribute>;
  /** delete data from the table: "argo.material_model_attribute_setting" */
  delete_argo_material_model_attribute_setting?: Maybe<ArgoMaterialModelAttributeSettingMutationResponse>;
  /** delete single row from the table: "argo.material_model_attribute_setting" */
  delete_argo_material_model_attribute_setting_by_pk?: Maybe<ArgoMaterialModelAttributeSetting>;
  /** delete single row from the table: "argo.material_model" */
  delete_argo_material_model_by_pk?: Maybe<ArgoMaterialModel>;
  /** delete data from the table: "argo.material_model_process" */
  delete_argo_material_model_process?: Maybe<ArgoMaterialModelProcessMutationResponse>;
  /** delete single row from the table: "argo.material_model_process" */
  delete_argo_material_model_process_by_pk?: Maybe<ArgoMaterialModelProcess>;
  /** delete data from the table: "argo.material_quantity_kind" */
  delete_argo_material_quantity_kind?: Maybe<ArgoMaterialQuantityKindMutationResponse>;
  /** delete single row from the table: "argo.material_quantity_kind" */
  delete_argo_material_quantity_kind_by_pk?: Maybe<ArgoMaterialQuantityKind>;
  /** delete data from the table: "argo.material_status" */
  delete_argo_material_status?: Maybe<ArgoMaterialStatusMutationResponse>;
  /** delete single row from the table: "argo.material_status" */
  delete_argo_material_status_by_pk?: Maybe<ArgoMaterialStatus>;
  /** delete data from the table: "argo.material_udf_data" */
  delete_argo_material_udf_data?: Maybe<ArgoMaterialUdfDataMutationResponse>;
  /** delete single row from the table: "argo.material_udf_data" */
  delete_argo_material_udf_data_by_pk?: Maybe<ArgoMaterialUdfData>;
  /** delete data from the table: "argo.material_udf_default_data" */
  delete_argo_material_udf_default_data?: Maybe<ArgoMaterialUdfDefaultDataMutationResponse>;
  /** delete single row from the table: "argo.material_udf_default_data" */
  delete_argo_material_udf_default_data_by_pk?: Maybe<ArgoMaterialUdfDefaultData>;
  /** delete data from the table: "argo.material_udf_schema" */
  delete_argo_material_udf_schema?: Maybe<ArgoMaterialUdfSchemaMutationResponse>;
  /** delete single row from the table: "argo.material_udf_schema" */
  delete_argo_material_udf_schema_by_pk?: Maybe<ArgoMaterialUdfSchema>;
  /** delete data from the table: "argo.media_config" */
  delete_argo_media_config?: Maybe<ArgoMediaConfigMutationResponse>;
  /** delete single row from the table: "argo.media_config" */
  delete_argo_media_config_by_pk?: Maybe<ArgoMediaConfig>;
  /** delete data from the table: "argo.media_instance" */
  delete_argo_media_instance?: Maybe<ArgoMediaInstanceMutationResponse>;
  /** delete single row from the table: "argo.media_instance" */
  delete_argo_media_instance_by_pk?: Maybe<ArgoMediaInstance>;
  /** delete data from the table: "argo.role" */
  delete_argo_role?: Maybe<ArgoRoleMutationResponse>;
  /** delete data from the table: "argo.role_acl" */
  delete_argo_role_acl?: Maybe<ArgoRoleAclMutationResponse>;
  /** delete single row from the table: "argo.role_acl" */
  delete_argo_role_acl_by_pk?: Maybe<ArgoRoleAcl>;
  /** delete single row from the table: "argo.role" */
  delete_argo_role_by_pk?: Maybe<ArgoRole>;
  /** delete data from the table: "argo.schedule" */
  delete_argo_schedule?: Maybe<ArgoScheduleMutationResponse>;
  /** delete single row from the table: "argo.schedule" */
  delete_argo_schedule_by_pk?: Maybe<ArgoSchedule>;
  /** delete data from the table: "argo.schedule_day" */
  delete_argo_schedule_day?: Maybe<ArgoScheduleDayMutationResponse>;
  /** delete single row from the table: "argo.schedule_day" */
  delete_argo_schedule_day_by_pk?: Maybe<ArgoScheduleDay>;
  /** delete data from the table: "argo.schedule_event" */
  delete_argo_schedule_event?: Maybe<ArgoScheduleEventMutationResponse>;
  /** delete single row from the table: "argo.schedule_event" */
  delete_argo_schedule_event_by_pk?: Maybe<ArgoScheduleEvent>;
  /** delete data from the table: "argo.schedule_mode" */
  delete_argo_schedule_mode?: Maybe<ArgoScheduleModeMutationResponse>;
  /** delete single row from the table: "argo.schedule_mode" */
  delete_argo_schedule_mode_by_pk?: Maybe<ArgoScheduleMode>;
  /** delete data from the table: "argo.sn" */
  delete_argo_sn?: Maybe<ArgoSnMutationResponse>;
  /** delete single row from the table: "argo.sn" */
  delete_argo_sn_by_pk?: Maybe<ArgoSn>;
  /** delete data from the table: "argo.sn_format" */
  delete_argo_sn_format?: Maybe<ArgoSnFormatMutationResponse>;
  /** delete single row from the table: "argo.sn_format" */
  delete_argo_sn_format_by_pk?: Maybe<ArgoSnFormat>;
  /** delete data from the table: "argo.sn_format_status" */
  delete_argo_sn_format_status?: Maybe<ArgoSnFormatStatusMutationResponse>;
  /** delete single row from the table: "argo.sn_format_status" */
  delete_argo_sn_format_status_by_pk?: Maybe<ArgoSnFormatStatus>;
  /** delete data from the table: "argo.sn_format_uniqueness" */
  delete_argo_sn_format_uniqueness?: Maybe<ArgoSnFormatUniquenessMutationResponse>;
  /** delete single row from the table: "argo.sn_format_uniqueness" */
  delete_argo_sn_format_uniqueness_by_pk?: Maybe<ArgoSnFormatUniqueness>;
  /** delete data from the table: "argo.udf_column" */
  delete_argo_udf_column?: Maybe<ArgoUdfColumnMutationResponse>;
  /** delete single row from the table: "argo.udf_column" */
  delete_argo_udf_column_by_pk?: Maybe<ArgoUdfColumn>;
  /** delete data from the table: "argo.udf_column_data_type" */
  delete_argo_udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeMutationResponse>;
  /** delete single row from the table: "argo.udf_column_data_type" */
  delete_argo_udf_column_data_type_by_pk?: Maybe<ArgoUdfColumnDataType>;
  /** delete data from the table: "argo.udf_column_type" */
  delete_argo_udf_column_type?: Maybe<ArgoUdfColumnTypeMutationResponse>;
  /** delete single row from the table: "argo.udf_column_type" */
  delete_argo_udf_column_type_by_pk?: Maybe<ArgoUdfColumnType>;
  /** delete data from the table: "argo.uom" */
  delete_argo_uom?: Maybe<ArgoUomMutationResponse>;
  /** delete single row from the table: "argo.uom" */
  delete_argo_uom_by_pk?: Maybe<ArgoUom>;
  /** delete data from the table: "argo.user" */
  delete_argo_user?: Maybe<ArgoUserMutationResponse>;
  /** delete data from the table: "argo.user_access_token" */
  delete_argo_user_access_token?: Maybe<ArgoUserAccessTokenMutationResponse>;
  /** delete single row from the table: "argo.user_access_token" */
  delete_argo_user_access_token_by_pk?: Maybe<ArgoUserAccessToken>;
  /** delete data from the table: "argo.user_badge" */
  delete_argo_user_badge?: Maybe<ArgoUserBadgeMutationResponse>;
  /** delete single row from the table: "argo.user_badge" */
  delete_argo_user_badge_by_pk?: Maybe<ArgoUserBadge>;
  /** delete single row from the table: "argo.user" */
  delete_argo_user_by_pk?: Maybe<ArgoUser>;
  /** delete data from the table: "argo.user_context" */
  delete_argo_user_context?: Maybe<ArgoUserContextMutationResponse>;
  /** delete single row from the table: "argo.user_context" */
  delete_argo_user_context_by_pk?: Maybe<ArgoUserContext>;
  /** delete data from the table: "argo.user_role" */
  delete_argo_user_role?: Maybe<ArgoUserRoleMutationResponse>;
  /** delete single row from the table: "argo.user_role" */
  delete_argo_user_role_by_pk?: Maybe<ArgoUserRole>;
  /** delete data from the table: "argo.vw_user_acls" */
  delete_argo_vw_user_acls?: Maybe<ArgoVwUserAclsMutationResponse>;
  /** delete data from the table: "argo.work_instruction" */
  delete_argo_work_instruction?: Maybe<ArgoWorkInstructionMutationResponse>;
  /** delete single row from the table: "argo.work_instruction" */
  delete_argo_work_instruction_by_pk?: Maybe<ArgoWorkInstruction>;
  /** delete data from the table: "argo.work_instruction_instance" */
  delete_argo_work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceMutationResponse>;
  /** delete single row from the table: "argo.work_instruction_instance" */
  delete_argo_work_instruction_instance_by_pk?: Maybe<ArgoWorkInstructionInstance>;
  /** delete data from the table: "argo.work_instruction_instance_status" */
  delete_argo_work_instruction_instance_status?: Maybe<ArgoWorkInstructionInstanceStatusMutationResponse>;
  /** delete single row from the table: "argo.work_instruction_instance_status" */
  delete_argo_work_instruction_instance_status_by_pk?: Maybe<ArgoWorkInstructionInstanceStatus>;
  /** delete data from the table: "argo.work_instruction_instance_step" */
  delete_argo_work_instruction_instance_step?: Maybe<ArgoWorkInstructionInstanceStepMutationResponse>;
  /** delete single row from the table: "argo.work_instruction_instance_step" */
  delete_argo_work_instruction_instance_step_by_pk?: Maybe<ArgoWorkInstructionInstanceStep>;
  /** delete data from the table: "argo.work_instruction_version" */
  delete_argo_work_instruction_version?: Maybe<ArgoWorkInstructionVersionMutationResponse>;
  /** delete single row from the table: "argo.work_instruction_version" */
  delete_argo_work_instruction_version_by_pk?: Maybe<ArgoWorkInstructionVersion>;
  /** delete data from the table: "argo.work_instruction_version_status" */
  delete_argo_work_instruction_version_status?: Maybe<ArgoWorkInstructionVersionStatusMutationResponse>;
  /** delete single row from the table: "argo.work_instruction_version_status" */
  delete_argo_work_instruction_version_status_by_pk?: Maybe<ArgoWorkInstructionVersionStatus>;
  /** delete data from the table: "argo.work_order" */
  delete_argo_work_order?: Maybe<ArgoWorkOrderMutationResponse>;
  /** delete data from the table: "argo.work_order_activity" */
  delete_argo_work_order_activity?: Maybe<ArgoWorkOrderActivityMutationResponse>;
  /** delete single row from the table: "argo.work_order_activity" */
  delete_argo_work_order_activity_by_pk?: Maybe<ArgoWorkOrderActivity>;
  /** delete data from the table: "argo.work_order_activity_kind" */
  delete_argo_work_order_activity_kind?: Maybe<ArgoWorkOrderActivityKindMutationResponse>;
  /** delete single row from the table: "argo.work_order_activity_kind" */
  delete_argo_work_order_activity_kind_by_pk?: Maybe<ArgoWorkOrderActivityKind>;
  /** delete single row from the table: "argo.work_order" */
  delete_argo_work_order_by_pk?: Maybe<ArgoWorkOrder>;
  /** delete data from the table: "argo.work_order_location" */
  delete_argo_work_order_location?: Maybe<ArgoWorkOrderLocationMutationResponse>;
  /** delete single row from the table: "argo.work_order_location" */
  delete_argo_work_order_location_by_pk?: Maybe<ArgoWorkOrderLocation>;
  /** delete data from the table: "argo.work_order_material" */
  delete_argo_work_order_material?: Maybe<ArgoWorkOrderMaterialMutationResponse>;
  /** delete single row from the table: "argo.work_order_material" */
  delete_argo_work_order_material_by_pk?: Maybe<ArgoWorkOrderMaterial>;
  /** delete data from the table: "argo.work_order_restriction" */
  delete_argo_work_order_restriction?: Maybe<ArgoWorkOrderRestrictionMutationResponse>;
  /** delete single row from the table: "argo.work_order_restriction" */
  delete_argo_work_order_restriction_by_pk?: Maybe<ArgoWorkOrderRestriction>;
  /** delete data from the table: "argo.work_order_status" */
  delete_argo_work_order_status?: Maybe<ArgoWorkOrderStatusMutationResponse>;
  /** delete single row from the table: "argo.work_order_status" */
  delete_argo_work_order_status_by_pk?: Maybe<ArgoWorkOrderStatus>;
  /** delete data from the table: "fis.asset" */
  delete_fis_asset?: Maybe<FisAssetMutationResponse>;
  /** delete single row from the table: "fis.asset" */
  delete_fis_asset_by_pk?: Maybe<FisAsset>;
  /** delete data from the table: "fis.asset_code" */
  delete_fis_asset_code?: Maybe<FisAssetCodeMutationResponse>;
  /** delete single row from the table: "fis.asset_code" */
  delete_fis_asset_code_by_pk?: Maybe<FisAssetCode>;
  /** delete data from the table: "fis.asset_tag" */
  delete_fis_asset_tag?: Maybe<FisAssetTagMutationResponse>;
  /** delete single row from the table: "fis.asset_tag" */
  delete_fis_asset_tag_by_pk?: Maybe<FisAssetTag>;
  /** delete data from the table: "fis.asset_tag_link" */
  delete_fis_asset_tag_link?: Maybe<FisAssetTagLinkMutationResponse>;
  /** delete single row from the table: "fis.asset_tag_link" */
  delete_fis_asset_tag_link_by_pk?: Maybe<FisAssetTagLink>;
  /** delete data from the table: "fis.asset_type" */
  delete_fis_asset_type?: Maybe<FisAssetTypeMutationResponse>;
  /** delete single row from the table: "fis.asset_type" */
  delete_fis_asset_type_by_pk?: Maybe<FisAssetType>;
  /** delete data from the table: "fis.core_state" */
  delete_fis_core_state?: Maybe<FisCoreStateMutationResponse>;
  /** delete single row from the table: "fis.core_state" */
  delete_fis_core_state_by_pk?: Maybe<FisCoreState>;
  /** delete data from the table: "fis.data" */
  delete_fis_data?: Maybe<FisDataMutationResponse>;
  /** delete single row from the table: "fis.data" */
  delete_fis_data_by_pk?: Maybe<FisData>;
  /** delete data from the table: "fis.data_label" */
  delete_fis_data_label?: Maybe<FisDataLabelMutationResponse>;
  /** delete single row from the table: "fis.data_label" */
  delete_fis_data_label_by_pk?: Maybe<FisDataLabel>;
  /** delete data from the table: "fis.data_timing" */
  delete_fis_data_timing?: Maybe<FisDataTimingMutationResponse>;
  /** delete single row from the table: "fis.data_timing" */
  delete_fis_data_timing_by_pk?: Maybe<FisDataTiming>;
  /** delete data from the table: "fis.data_track_count" */
  delete_fis_data_track_count?: Maybe<FisDataTrackCountMutationResponse>;
  /** delete single row from the table: "fis.data_track_count" */
  delete_fis_data_track_count_by_pk?: Maybe<FisDataTrackCount>;
  /** delete data from the table: "fis.data_track_duration" */
  delete_fis_data_track_duration?: Maybe<FisDataTrackDurationMutationResponse>;
  /** delete single row from the table: "fis.data_track_duration" */
  delete_fis_data_track_duration_by_pk?: Maybe<FisDataTrackDuration>;
  /** delete data from the table: "fis.data_track_scalar" */
  delete_fis_data_track_scalar?: Maybe<FisDataTrackScalarMutationResponse>;
  /** delete single row from the table: "fis.data_track_scalar" */
  delete_fis_data_track_scalar_by_pk?: Maybe<FisDataTrackScalar>;
  /** delete data from the table: "fis.data_type" */
  delete_fis_data_type?: Maybe<FisDataTypeMutationResponse>;
  /** delete single row from the table: "fis.data_type" */
  delete_fis_data_type_by_pk?: Maybe<FisDataType>;
  /** delete data from the table: "process.collection" */
  delete_process_collection?: Maybe<ProcessCollectionMutationResponse>;
  /** delete single row from the table: "process.collection" */
  delete_process_collection_by_pk?: Maybe<ProcessCollection>;
  /** delete data from the table: "process.collection_data" */
  delete_process_collection_data?: Maybe<ProcessCollectionDataMutationResponse>;
  /** delete single row from the table: "process.collection_data" */
  delete_process_collection_data_by_pk?: Maybe<ProcessCollectionData>;
  /** delete data from the table: "process.collection_kind" */
  delete_process_collection_kind?: Maybe<ProcessCollectionKindMutationResponse>;
  /** delete single row from the table: "process.collection_kind" */
  delete_process_collection_kind_by_pk?: Maybe<ProcessCollectionKind>;
  /** delete data from the table: "process.data_element" */
  delete_process_data_element?: Maybe<ProcessDataElementMutationResponse>;
  /** delete single row from the table: "process.data_element" */
  delete_process_data_element_by_pk?: Maybe<ProcessDataElement>;
  /** delete data from the table: "process.data_element_collection_kind" */
  delete_process_data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindMutationResponse>;
  /** delete single row from the table: "process.data_element_collection_kind" */
  delete_process_data_element_collection_kind_by_pk?: Maybe<ProcessDataElementCollectionKind>;
  /** delete data from the table: "process.data_element_kind" */
  delete_process_data_element_kind?: Maybe<ProcessDataElementKindMutationResponse>;
  /** delete single row from the table: "process.data_element_kind" */
  delete_process_data_element_kind_by_pk?: Maybe<ProcessDataElementKind>;
  /** delete data from the table: "process.material_state" */
  delete_process_material_state?: Maybe<ProcessMaterialStateMutationResponse>;
  /** delete single row from the table: "process.material_state" */
  delete_process_material_state_by_pk?: Maybe<ProcessMaterialState>;
  /** delete data from the table: "process.material_state_history" */
  delete_process_material_state_history?: Maybe<ProcessMaterialStateHistoryMutationResponse>;
  /** delete single row from the table: "process.material_state_history" */
  delete_process_material_state_history_by_pk?: Maybe<ProcessMaterialStateHistory>;
  /** delete data from the table: "process.process" */
  delete_process_process?: Maybe<ProcessProcessMutationResponse>;
  /** delete single row from the table: "process.process" */
  delete_process_process_by_pk?: Maybe<ProcessProcess>;
  /** delete data from the table: "process.process_status" */
  delete_process_process_status?: Maybe<ProcessProcessStatusMutationResponse>;
  /** delete single row from the table: "process.process_status" */
  delete_process_process_status_by_pk?: Maybe<ProcessProcessStatus>;
  /** delete data from the table: "process.spec" */
  delete_process_spec?: Maybe<ProcessSpecMutationResponse>;
  /** delete single row from the table: "process.spec" */
  delete_process_spec_by_pk?: Maybe<ProcessSpec>;
  /** delete data from the table: "process.spec_order" */
  delete_process_spec_order?: Maybe<ProcessSpecOrderMutationResponse>;
  /** delete single row from the table: "process.spec_order" */
  delete_process_spec_order_by_pk?: Maybe<ProcessSpecOrder>;
  /** insert data into the table: "applet.deployment" */
  insert_applet_deployment?: Maybe<AppletDeploymentMutationResponse>;
  /** insert data into the table: "applet.deployment_linked_design_version" */
  insert_applet_deployment_linked_design_version?: Maybe<AppletDeploymentLinkedDesignVersionMutationResponse>;
  /** insert a single row into the table: "applet.deployment_linked_design_version" */
  insert_applet_deployment_linked_design_version_one?: Maybe<AppletDeploymentLinkedDesignVersion>;
  /** insert a single row into the table: "applet.deployment" */
  insert_applet_deployment_one?: Maybe<AppletDeployment>;
  /** insert data into the table: "applet.design" */
  insert_applet_design?: Maybe<AppletDesignMutationResponse>;
  /** insert a single row into the table: "applet.design" */
  insert_applet_design_one?: Maybe<AppletDesign>;
  /** insert data into the table: "applet.design_version" */
  insert_applet_design_version?: Maybe<AppletDesignVersionMutationResponse>;
  /** insert a single row into the table: "applet.design_version" */
  insert_applet_design_version_one?: Maybe<AppletDesignVersion>;
  /** insert data into the table: "applet.design_version_status" */
  insert_applet_design_version_status?: Maybe<AppletDesignVersionStatusMutationResponse>;
  /** insert a single row into the table: "applet.design_version_status" */
  insert_applet_design_version_status_one?: Maybe<AppletDesignVersionStatus>;
  /** insert data into the table: "applet.registration_code" */
  insert_applet_registration_code?: Maybe<AppletRegistrationCodeMutationResponse>;
  /** insert a single row into the table: "applet.registration_code" */
  insert_applet_registration_code_one?: Maybe<AppletRegistrationCode>;
  /** insert data into the table: "applet.runner" */
  insert_applet_runner?: Maybe<AppletRunnerMutationResponse>;
  /** insert data into the table: "applet.runner_context" */
  insert_applet_runner_context?: Maybe<AppletRunnerContextMutationResponse>;
  /** insert a single row into the table: "applet.runner_context" */
  insert_applet_runner_context_one?: Maybe<AppletRunnerContext>;
  /** insert a single row into the table: "applet.runner" */
  insert_applet_runner_one?: Maybe<AppletRunner>;
  /** insert data into the table: "argo.acl" */
  insert_argo_acl?: Maybe<ArgoAclMutationResponse>;
  /** insert a single row into the table: "argo.acl" */
  insert_argo_acl_one?: Maybe<ArgoAcl>;
  /** insert data into the table: "argo.attribute" */
  insert_argo_attribute?: Maybe<ArgoAttributeMutationResponse>;
  /** insert data into the table: "argo.attribute_data" */
  insert_argo_attribute_data?: Maybe<ArgoAttributeDataMutationResponse>;
  /** insert a single row into the table: "argo.attribute_data" */
  insert_argo_attribute_data_one?: Maybe<ArgoAttributeData>;
  /** insert data into the table: "argo.attribute_history_status_type" */
  insert_argo_attribute_history_status_type?: Maybe<ArgoAttributeHistoryStatusTypeMutationResponse>;
  /** insert a single row into the table: "argo.attribute_history_status_type" */
  insert_argo_attribute_history_status_type_one?: Maybe<ArgoAttributeHistoryStatusType>;
  /** insert a single row into the table: "argo.attribute" */
  insert_argo_attribute_one?: Maybe<ArgoAttribute>;
  /** insert data into the table: "argo.attribute_schema" */
  insert_argo_attribute_schema?: Maybe<ArgoAttributeSchemaMutationResponse>;
  /** insert data into the table: "argo.attribute_schema_definition" */
  insert_argo_attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionMutationResponse>;
  /** insert a single row into the table: "argo.attribute_schema_definition" */
  insert_argo_attribute_schema_definition_one?: Maybe<ArgoAttributeSchemaDefinition>;
  /** insert data into the table: "argo.attribute_schema_definition_type" */
  insert_argo_attribute_schema_definition_type?: Maybe<ArgoAttributeSchemaDefinitionTypeMutationResponse>;
  /** insert a single row into the table: "argo.attribute_schema_definition_type" */
  insert_argo_attribute_schema_definition_type_one?: Maybe<ArgoAttributeSchemaDefinitionType>;
  /** insert a single row into the table: "argo.attribute_schema" */
  insert_argo_attribute_schema_one?: Maybe<ArgoAttributeSchema>;
  /** insert data into the table: "argo.attribute_schema_type" */
  insert_argo_attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeMutationResponse>;
  /** insert a single row into the table: "argo.attribute_schema_type" */
  insert_argo_attribute_schema_type_one?: Maybe<ArgoAttributeSchemaType>;
  /** insert data into the table: "argo.audit" */
  insert_argo_audit?: Maybe<ArgoAuditMutationResponse>;
  /** insert a single row into the table: "argo.audit" */
  insert_argo_audit_one?: Maybe<ArgoAudit>;
  /** insert data into the table: "argo.auth_provider" */
  insert_argo_auth_provider?: Maybe<ArgoAuthProviderMutationResponse>;
  /** insert data into the table: "argo.auth_provider_local" */
  insert_argo_auth_provider_local?: Maybe<ArgoAuthProviderLocalMutationResponse>;
  /** insert a single row into the table: "argo.auth_provider_local" */
  insert_argo_auth_provider_local_one?: Maybe<ArgoAuthProviderLocal>;
  /** insert data into the table: "argo.auth_provider_local_setting" */
  insert_argo_auth_provider_local_setting?: Maybe<ArgoAuthProviderLocalSettingMutationResponse>;
  /** insert a single row into the table: "argo.auth_provider_local_setting" */
  insert_argo_auth_provider_local_setting_one?: Maybe<ArgoAuthProviderLocalSetting>;
  /** insert data into the table: "argo.auth_provider_msal" */
  insert_argo_auth_provider_msal?: Maybe<ArgoAuthProviderMsalMutationResponse>;
  /** insert a single row into the table: "argo.auth_provider_msal" */
  insert_argo_auth_provider_msal_one?: Maybe<ArgoAuthProviderMsal>;
  /** insert data into the table: "argo.auth_provider_msal_setting" */
  insert_argo_auth_provider_msal_setting?: Maybe<ArgoAuthProviderMsalSettingMutationResponse>;
  /** insert a single row into the table: "argo.auth_provider_msal_setting" */
  insert_argo_auth_provider_msal_setting_one?: Maybe<ArgoAuthProviderMsalSetting>;
  /** insert a single row into the table: "argo.auth_provider" */
  insert_argo_auth_provider_one?: Maybe<ArgoAuthProvider>;
  /** insert data into the table: "argo.auth_provider_record" */
  insert_argo_auth_provider_record?: Maybe<ArgoAuthProviderRecordMutationResponse>;
  /** insert a single row into the table: "argo.auth_provider_record" */
  insert_argo_auth_provider_record_one?: Maybe<ArgoAuthProviderRecord>;
  /** insert data into the table: "argo.auth_refresh_token" */
  insert_argo_auth_refresh_token?: Maybe<ArgoAuthRefreshTokenMutationResponse>;
  /** insert a single row into the table: "argo.auth_refresh_token" */
  insert_argo_auth_refresh_token_one?: Maybe<ArgoAuthRefreshToken>;
  /** insert data into the table: "argo.calendar" */
  insert_argo_calendar?: Maybe<ArgoCalendarMutationResponse>;
  /** insert data into the table: "argo.calendar_event" */
  insert_argo_calendar_event?: Maybe<ArgoCalendarEventMutationResponse>;
  /** insert a single row into the table: "argo.calendar_event" */
  insert_argo_calendar_event_one?: Maybe<ArgoCalendarEvent>;
  /** insert data into the table: "argo.calendar_event_sequence" */
  insert_argo_calendar_event_sequence?: Maybe<ArgoCalendarEventSequenceMutationResponse>;
  /** insert a single row into the table: "argo.calendar_event_sequence" */
  insert_argo_calendar_event_sequence_one?: Maybe<ArgoCalendarEventSequence>;
  /** insert data into the table: "argo.calendar_event_udf_data" */
  insert_argo_calendar_event_udf_data?: Maybe<ArgoCalendarEventUdfDataMutationResponse>;
  /** insert a single row into the table: "argo.calendar_event_udf_data" */
  insert_argo_calendar_event_udf_data_one?: Maybe<ArgoCalendarEventUdfData>;
  /** insert data into the table: "argo.calendar_event_udf_default_data" */
  insert_argo_calendar_event_udf_default_data?: Maybe<ArgoCalendarEventUdfDefaultDataMutationResponse>;
  /** insert a single row into the table: "argo.calendar_event_udf_default_data" */
  insert_argo_calendar_event_udf_default_data_one?: Maybe<ArgoCalendarEventUdfDefaultData>;
  /** insert data into the table: "argo.calendar_event_udf_schema" */
  insert_argo_calendar_event_udf_schema?: Maybe<ArgoCalendarEventUdfSchemaMutationResponse>;
  /** insert a single row into the table: "argo.calendar_event_udf_schema" */
  insert_argo_calendar_event_udf_schema_one?: Maybe<ArgoCalendarEventUdfSchema>;
  /** insert data into the table: "argo.calendar_location" */
  insert_argo_calendar_location?: Maybe<ArgoCalendarLocationMutationResponse>;
  /** insert a single row into the table: "argo.calendar_location" */
  insert_argo_calendar_location_one?: Maybe<ArgoCalendarLocation>;
  /** insert a single row into the table: "argo.calendar" */
  insert_argo_calendar_one?: Maybe<ArgoCalendar>;
  /** insert data into the table: "argo.connection" */
  insert_argo_connection?: Maybe<ArgoConnectionMutationResponse>;
  /** insert data into the table: "argo.connection_config" */
  insert_argo_connection_config?: Maybe<ArgoConnectionConfigMutationResponse>;
  /** insert a single row into the table: "argo.connection_config" */
  insert_argo_connection_config_one?: Maybe<ArgoConnectionConfig>;
  /** insert data into the table: "argo.connection_config_status" */
  insert_argo_connection_config_status?: Maybe<ArgoConnectionConfigStatusMutationResponse>;
  /** insert a single row into the table: "argo.connection_config_status" */
  insert_argo_connection_config_status_one?: Maybe<ArgoConnectionConfigStatus>;
  /** insert data into the table: "argo.connection_kind" */
  insert_argo_connection_kind?: Maybe<ArgoConnectionKindMutationResponse>;
  /** insert a single row into the table: "argo.connection_kind" */
  insert_argo_connection_kind_one?: Maybe<ArgoConnectionKind>;
  /** insert a single row into the table: "argo.connection" */
  insert_argo_connection_one?: Maybe<ArgoConnection>;
  /** insert data into the table: "argo.context" */
  insert_argo_context?: Maybe<ArgoContextMutationResponse>;
  /** insert a single row into the table: "argo.context" */
  insert_argo_context_one?: Maybe<ArgoContext>;
  /** insert data into the table: "argo.cron_task" */
  insert_argo_cron_task?: Maybe<ArgoCronTaskMutationResponse>;
  /** insert a single row into the table: "argo.cron_task" */
  insert_argo_cron_task_one?: Maybe<ArgoCronTask>;
  /** insert data into the table: "argo.event" */
  insert_argo_event?: Maybe<ArgoEventMutationResponse>;
  /** insert a single row into the table: "argo.event" */
  insert_argo_event_one?: Maybe<ArgoEvent>;
  /** insert data into the table: "argo.event_type" */
  insert_argo_event_type?: Maybe<ArgoEventTypeMutationResponse>;
  /** insert a single row into the table: "argo.event_type" */
  insert_argo_event_type_one?: Maybe<ArgoEventType>;
  /** insert data into the table: "argo.hasura_permission" */
  insert_argo_hasura_permission?: Maybe<ArgoHasuraPermissionMutationResponse>;
  /** insert a single row into the table: "argo.hasura_permission" */
  insert_argo_hasura_permission_one?: Maybe<ArgoHasuraPermission>;
  /** insert data into the table: "argo.link" */
  insert_argo_link?: Maybe<ArgoLinkMutationResponse>;
  /** insert a single row into the table: "argo.link" */
  insert_argo_link_one?: Maybe<ArgoLink>;
  /** insert data into the table: "argo.location" */
  insert_argo_location?: Maybe<ArgoLocationMutationResponse>;
  /** insert data into the table: "argo.location_attribute" */
  insert_argo_location_attribute?: Maybe<ArgoLocationAttributeMutationResponse>;
  /** insert data into the table: "argo.location_attribute_history" */
  insert_argo_location_attribute_history?: Maybe<ArgoLocationAttributeHistoryMutationResponse>;
  /** insert a single row into the table: "argo.location_attribute_history" */
  insert_argo_location_attribute_history_one?: Maybe<ArgoLocationAttributeHistory>;
  /** insert a single row into the table: "argo.location_attribute" */
  insert_argo_location_attribute_one?: Maybe<ArgoLocationAttribute>;
  /** insert data into the table: "argo.location_class" */
  insert_argo_location_class?: Maybe<ArgoLocationClassMutationResponse>;
  /** insert a single row into the table: "argo.location_class" */
  insert_argo_location_class_one?: Maybe<ArgoLocationClass>;
  /** insert a single row into the table: "argo.location" */
  insert_argo_location_one?: Maybe<ArgoLocation>;
  /** insert data into the table: "argo.log" */
  insert_argo_log?: Maybe<ArgoLogMutationResponse>;
  /** insert data into the table: "argo.log_category" */
  insert_argo_log_category?: Maybe<ArgoLogCategoryMutationResponse>;
  /** insert a single row into the table: "argo.log_category" */
  insert_argo_log_category_one?: Maybe<ArgoLogCategory>;
  /** insert data into the table: "argo.log_duration" */
  insert_argo_log_duration?: Maybe<ArgoLogDurationMutationResponse>;
  /** insert a single row into the table: "argo.log_duration" */
  insert_argo_log_duration_one?: Maybe<ArgoLogDuration>;
  /** insert data into the table: "argo.log_level" */
  insert_argo_log_level?: Maybe<ArgoLogLevelMutationResponse>;
  /** insert a single row into the table: "argo.log_level" */
  insert_argo_log_level_one?: Maybe<ArgoLogLevel>;
  /** insert a single row into the table: "argo.log" */
  insert_argo_log_one?: Maybe<ArgoLog>;
  /** insert data into the table: "argo.material" */
  insert_argo_material?: Maybe<ArgoMaterialMutationResponse>;
  /** insert data into the table: "argo.material_activity" */
  insert_argo_material_activity?: Maybe<ArgoMaterialActivityMutationResponse>;
  /** insert data into the table: "argo.material_activity_kind" */
  insert_argo_material_activity_kind?: Maybe<ArgoMaterialActivityKindMutationResponse>;
  /** insert a single row into the table: "argo.material_activity_kind" */
  insert_argo_material_activity_kind_one?: Maybe<ArgoMaterialActivityKind>;
  /** insert a single row into the table: "argo.material_activity" */
  insert_argo_material_activity_one?: Maybe<ArgoMaterialActivity>;
  /** insert data into the table: "argo.material_assembly" */
  insert_argo_material_assembly?: Maybe<ArgoMaterialAssemblyMutationResponse>;
  /** insert a single row into the table: "argo.material_assembly" */
  insert_argo_material_assembly_one?: Maybe<ArgoMaterialAssembly>;
  /** insert data into the table: "argo.material_attribute" */
  insert_argo_material_attribute?: Maybe<ArgoMaterialAttributeMutationResponse>;
  /** insert data into the table: "argo.material_attribute_history" */
  insert_argo_material_attribute_history?: Maybe<ArgoMaterialAttributeHistoryMutationResponse>;
  /** insert a single row into the table: "argo.material_attribute_history" */
  insert_argo_material_attribute_history_one?: Maybe<ArgoMaterialAttributeHistory>;
  /** insert a single row into the table: "argo.material_attribute" */
  insert_argo_material_attribute_one?: Maybe<ArgoMaterialAttribute>;
  /** insert data into the table: "argo.material_class" */
  insert_argo_material_class?: Maybe<ArgoMaterialClassMutationResponse>;
  /** insert data into the table: "argo.material_class_attribute" */
  insert_argo_material_class_attribute?: Maybe<ArgoMaterialClassAttributeMutationResponse>;
  /** insert a single row into the table: "argo.material_class_attribute" */
  insert_argo_material_class_attribute_one?: Maybe<ArgoMaterialClassAttribute>;
  /** insert data into the table: "argo.material_class_attribute_setting" */
  insert_argo_material_class_attribute_setting?: Maybe<ArgoMaterialClassAttributeSettingMutationResponse>;
  /** insert a single row into the table: "argo.material_class_attribute_setting" */
  insert_argo_material_class_attribute_setting_one?: Maybe<ArgoMaterialClassAttributeSetting>;
  /** insert a single row into the table: "argo.material_class" */
  insert_argo_material_class_one?: Maybe<ArgoMaterialClass>;
  /** insert data into the table: "argo.material_class_process" */
  insert_argo_material_class_process?: Maybe<ArgoMaterialClassProcessMutationResponse>;
  /** insert a single row into the table: "argo.material_class_process" */
  insert_argo_material_class_process_one?: Maybe<ArgoMaterialClassProcess>;
  /** insert data into the table: "argo.material_marriage" */
  insert_argo_material_marriage?: Maybe<ArgoMaterialMarriageMutationResponse>;
  /** insert a single row into the table: "argo.material_marriage" */
  insert_argo_material_marriage_one?: Maybe<ArgoMaterialMarriage>;
  /** insert data into the table: "argo.material_marriage_status" */
  insert_argo_material_marriage_status?: Maybe<ArgoMaterialMarriageStatusMutationResponse>;
  /** insert a single row into the table: "argo.material_marriage_status" */
  insert_argo_material_marriage_status_one?: Maybe<ArgoMaterialMarriageStatus>;
  /** insert data into the table: "argo.material_model" */
  insert_argo_material_model?: Maybe<ArgoMaterialModelMutationResponse>;
  /** insert data into the table: "argo.material_model_attribute" */
  insert_argo_material_model_attribute?: Maybe<ArgoMaterialModelAttributeMutationResponse>;
  /** insert a single row into the table: "argo.material_model_attribute" */
  insert_argo_material_model_attribute_one?: Maybe<ArgoMaterialModelAttribute>;
  /** insert data into the table: "argo.material_model_attribute_setting" */
  insert_argo_material_model_attribute_setting?: Maybe<ArgoMaterialModelAttributeSettingMutationResponse>;
  /** insert a single row into the table: "argo.material_model_attribute_setting" */
  insert_argo_material_model_attribute_setting_one?: Maybe<ArgoMaterialModelAttributeSetting>;
  /** insert a single row into the table: "argo.material_model" */
  insert_argo_material_model_one?: Maybe<ArgoMaterialModel>;
  /** insert data into the table: "argo.material_model_process" */
  insert_argo_material_model_process?: Maybe<ArgoMaterialModelProcessMutationResponse>;
  /** insert a single row into the table: "argo.material_model_process" */
  insert_argo_material_model_process_one?: Maybe<ArgoMaterialModelProcess>;
  /** insert a single row into the table: "argo.material" */
  insert_argo_material_one?: Maybe<ArgoMaterial>;
  /** insert data into the table: "argo.material_quantity_kind" */
  insert_argo_material_quantity_kind?: Maybe<ArgoMaterialQuantityKindMutationResponse>;
  /** insert a single row into the table: "argo.material_quantity_kind" */
  insert_argo_material_quantity_kind_one?: Maybe<ArgoMaterialQuantityKind>;
  /** insert data into the table: "argo.material_status" */
  insert_argo_material_status?: Maybe<ArgoMaterialStatusMutationResponse>;
  /** insert a single row into the table: "argo.material_status" */
  insert_argo_material_status_one?: Maybe<ArgoMaterialStatus>;
  /** insert data into the table: "argo.material_udf_data" */
  insert_argo_material_udf_data?: Maybe<ArgoMaterialUdfDataMutationResponse>;
  /** insert a single row into the table: "argo.material_udf_data" */
  insert_argo_material_udf_data_one?: Maybe<ArgoMaterialUdfData>;
  /** insert data into the table: "argo.material_udf_default_data" */
  insert_argo_material_udf_default_data?: Maybe<ArgoMaterialUdfDefaultDataMutationResponse>;
  /** insert a single row into the table: "argo.material_udf_default_data" */
  insert_argo_material_udf_default_data_one?: Maybe<ArgoMaterialUdfDefaultData>;
  /** insert data into the table: "argo.material_udf_schema" */
  insert_argo_material_udf_schema?: Maybe<ArgoMaterialUdfSchemaMutationResponse>;
  /** insert a single row into the table: "argo.material_udf_schema" */
  insert_argo_material_udf_schema_one?: Maybe<ArgoMaterialUdfSchema>;
  /** insert data into the table: "argo.media_config" */
  insert_argo_media_config?: Maybe<ArgoMediaConfigMutationResponse>;
  /** insert a single row into the table: "argo.media_config" */
  insert_argo_media_config_one?: Maybe<ArgoMediaConfig>;
  /** insert data into the table: "argo.media_instance" */
  insert_argo_media_instance?: Maybe<ArgoMediaInstanceMutationResponse>;
  /** insert a single row into the table: "argo.media_instance" */
  insert_argo_media_instance_one?: Maybe<ArgoMediaInstance>;
  /** insert data into the table: "argo.role" */
  insert_argo_role?: Maybe<ArgoRoleMutationResponse>;
  /** insert data into the table: "argo.role_acl" */
  insert_argo_role_acl?: Maybe<ArgoRoleAclMutationResponse>;
  /** insert a single row into the table: "argo.role_acl" */
  insert_argo_role_acl_one?: Maybe<ArgoRoleAcl>;
  /** insert a single row into the table: "argo.role" */
  insert_argo_role_one?: Maybe<ArgoRole>;
  /** insert data into the table: "argo.schedule" */
  insert_argo_schedule?: Maybe<ArgoScheduleMutationResponse>;
  /** insert data into the table: "argo.schedule_day" */
  insert_argo_schedule_day?: Maybe<ArgoScheduleDayMutationResponse>;
  /** insert a single row into the table: "argo.schedule_day" */
  insert_argo_schedule_day_one?: Maybe<ArgoScheduleDay>;
  /** insert data into the table: "argo.schedule_event" */
  insert_argo_schedule_event?: Maybe<ArgoScheduleEventMutationResponse>;
  /** insert a single row into the table: "argo.schedule_event" */
  insert_argo_schedule_event_one?: Maybe<ArgoScheduleEvent>;
  /** insert data into the table: "argo.schedule_mode" */
  insert_argo_schedule_mode?: Maybe<ArgoScheduleModeMutationResponse>;
  /** insert a single row into the table: "argo.schedule_mode" */
  insert_argo_schedule_mode_one?: Maybe<ArgoScheduleMode>;
  /** insert a single row into the table: "argo.schedule" */
  insert_argo_schedule_one?: Maybe<ArgoSchedule>;
  /** insert data into the table: "argo.sn" */
  insert_argo_sn?: Maybe<ArgoSnMutationResponse>;
  /** insert data into the table: "argo.sn_format" */
  insert_argo_sn_format?: Maybe<ArgoSnFormatMutationResponse>;
  /** insert a single row into the table: "argo.sn_format" */
  insert_argo_sn_format_one?: Maybe<ArgoSnFormat>;
  /** insert data into the table: "argo.sn_format_status" */
  insert_argo_sn_format_status?: Maybe<ArgoSnFormatStatusMutationResponse>;
  /** insert a single row into the table: "argo.sn_format_status" */
  insert_argo_sn_format_status_one?: Maybe<ArgoSnFormatStatus>;
  /** insert data into the table: "argo.sn_format_uniqueness" */
  insert_argo_sn_format_uniqueness?: Maybe<ArgoSnFormatUniquenessMutationResponse>;
  /** insert a single row into the table: "argo.sn_format_uniqueness" */
  insert_argo_sn_format_uniqueness_one?: Maybe<ArgoSnFormatUniqueness>;
  /** insert a single row into the table: "argo.sn" */
  insert_argo_sn_one?: Maybe<ArgoSn>;
  /** insert data into the table: "argo.udf_column" */
  insert_argo_udf_column?: Maybe<ArgoUdfColumnMutationResponse>;
  /** insert data into the table: "argo.udf_column_data_type" */
  insert_argo_udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeMutationResponse>;
  /** insert a single row into the table: "argo.udf_column_data_type" */
  insert_argo_udf_column_data_type_one?: Maybe<ArgoUdfColumnDataType>;
  /** insert a single row into the table: "argo.udf_column" */
  insert_argo_udf_column_one?: Maybe<ArgoUdfColumn>;
  /** insert data into the table: "argo.udf_column_type" */
  insert_argo_udf_column_type?: Maybe<ArgoUdfColumnTypeMutationResponse>;
  /** insert a single row into the table: "argo.udf_column_type" */
  insert_argo_udf_column_type_one?: Maybe<ArgoUdfColumnType>;
  /** insert data into the table: "argo.uom" */
  insert_argo_uom?: Maybe<ArgoUomMutationResponse>;
  /** insert a single row into the table: "argo.uom" */
  insert_argo_uom_one?: Maybe<ArgoUom>;
  /** insert data into the table: "argo.user" */
  insert_argo_user?: Maybe<ArgoUserMutationResponse>;
  /** insert data into the table: "argo.user_access_token" */
  insert_argo_user_access_token?: Maybe<ArgoUserAccessTokenMutationResponse>;
  /** insert a single row into the table: "argo.user_access_token" */
  insert_argo_user_access_token_one?: Maybe<ArgoUserAccessToken>;
  /** insert data into the table: "argo.user_badge" */
  insert_argo_user_badge?: Maybe<ArgoUserBadgeMutationResponse>;
  /** insert a single row into the table: "argo.user_badge" */
  insert_argo_user_badge_one?: Maybe<ArgoUserBadge>;
  /** insert data into the table: "argo.user_context" */
  insert_argo_user_context?: Maybe<ArgoUserContextMutationResponse>;
  /** insert a single row into the table: "argo.user_context" */
  insert_argo_user_context_one?: Maybe<ArgoUserContext>;
  /** insert a single row into the table: "argo.user" */
  insert_argo_user_one?: Maybe<ArgoUser>;
  /** insert data into the table: "argo.user_role" */
  insert_argo_user_role?: Maybe<ArgoUserRoleMutationResponse>;
  /** insert a single row into the table: "argo.user_role" */
  insert_argo_user_role_one?: Maybe<ArgoUserRole>;
  /** insert data into the table: "argo.vw_user_acls" */
  insert_argo_vw_user_acls?: Maybe<ArgoVwUserAclsMutationResponse>;
  /** insert a single row into the table: "argo.vw_user_acls" */
  insert_argo_vw_user_acls_one?: Maybe<ArgoVwUserAcls>;
  /** insert data into the table: "argo.work_instruction" */
  insert_argo_work_instruction?: Maybe<ArgoWorkInstructionMutationResponse>;
  /** insert data into the table: "argo.work_instruction_instance" */
  insert_argo_work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceMutationResponse>;
  /** insert a single row into the table: "argo.work_instruction_instance" */
  insert_argo_work_instruction_instance_one?: Maybe<ArgoWorkInstructionInstance>;
  /** insert data into the table: "argo.work_instruction_instance_status" */
  insert_argo_work_instruction_instance_status?: Maybe<ArgoWorkInstructionInstanceStatusMutationResponse>;
  /** insert a single row into the table: "argo.work_instruction_instance_status" */
  insert_argo_work_instruction_instance_status_one?: Maybe<ArgoWorkInstructionInstanceStatus>;
  /** insert data into the table: "argo.work_instruction_instance_step" */
  insert_argo_work_instruction_instance_step?: Maybe<ArgoWorkInstructionInstanceStepMutationResponse>;
  /** insert a single row into the table: "argo.work_instruction_instance_step" */
  insert_argo_work_instruction_instance_step_one?: Maybe<ArgoWorkInstructionInstanceStep>;
  /** insert a single row into the table: "argo.work_instruction" */
  insert_argo_work_instruction_one?: Maybe<ArgoWorkInstruction>;
  /** insert data into the table: "argo.work_instruction_version" */
  insert_argo_work_instruction_version?: Maybe<ArgoWorkInstructionVersionMutationResponse>;
  /** insert a single row into the table: "argo.work_instruction_version" */
  insert_argo_work_instruction_version_one?: Maybe<ArgoWorkInstructionVersion>;
  /** insert data into the table: "argo.work_instruction_version_status" */
  insert_argo_work_instruction_version_status?: Maybe<ArgoWorkInstructionVersionStatusMutationResponse>;
  /** insert a single row into the table: "argo.work_instruction_version_status" */
  insert_argo_work_instruction_version_status_one?: Maybe<ArgoWorkInstructionVersionStatus>;
  /** insert data into the table: "argo.work_order" */
  insert_argo_work_order?: Maybe<ArgoWorkOrderMutationResponse>;
  /** insert data into the table: "argo.work_order_activity" */
  insert_argo_work_order_activity?: Maybe<ArgoWorkOrderActivityMutationResponse>;
  /** insert data into the table: "argo.work_order_activity_kind" */
  insert_argo_work_order_activity_kind?: Maybe<ArgoWorkOrderActivityKindMutationResponse>;
  /** insert a single row into the table: "argo.work_order_activity_kind" */
  insert_argo_work_order_activity_kind_one?: Maybe<ArgoWorkOrderActivityKind>;
  /** insert a single row into the table: "argo.work_order_activity" */
  insert_argo_work_order_activity_one?: Maybe<ArgoWorkOrderActivity>;
  /** insert data into the table: "argo.work_order_location" */
  insert_argo_work_order_location?: Maybe<ArgoWorkOrderLocationMutationResponse>;
  /** insert a single row into the table: "argo.work_order_location" */
  insert_argo_work_order_location_one?: Maybe<ArgoWorkOrderLocation>;
  /** insert data into the table: "argo.work_order_material" */
  insert_argo_work_order_material?: Maybe<ArgoWorkOrderMaterialMutationResponse>;
  /** insert a single row into the table: "argo.work_order_material" */
  insert_argo_work_order_material_one?: Maybe<ArgoWorkOrderMaterial>;
  /** insert a single row into the table: "argo.work_order" */
  insert_argo_work_order_one?: Maybe<ArgoWorkOrder>;
  /** insert data into the table: "argo.work_order_restriction" */
  insert_argo_work_order_restriction?: Maybe<ArgoWorkOrderRestrictionMutationResponse>;
  /** insert a single row into the table: "argo.work_order_restriction" */
  insert_argo_work_order_restriction_one?: Maybe<ArgoWorkOrderRestriction>;
  /** insert data into the table: "argo.work_order_status" */
  insert_argo_work_order_status?: Maybe<ArgoWorkOrderStatusMutationResponse>;
  /** insert a single row into the table: "argo.work_order_status" */
  insert_argo_work_order_status_one?: Maybe<ArgoWorkOrderStatus>;
  /** insert data into the table: "fis.asset" */
  insert_fis_asset?: Maybe<FisAssetMutationResponse>;
  /** insert data into the table: "fis.asset_code" */
  insert_fis_asset_code?: Maybe<FisAssetCodeMutationResponse>;
  /** insert a single row into the table: "fis.asset_code" */
  insert_fis_asset_code_one?: Maybe<FisAssetCode>;
  /** insert a single row into the table: "fis.asset" */
  insert_fis_asset_one?: Maybe<FisAsset>;
  /** insert data into the table: "fis.asset_tag" */
  insert_fis_asset_tag?: Maybe<FisAssetTagMutationResponse>;
  /** insert data into the table: "fis.asset_tag_link" */
  insert_fis_asset_tag_link?: Maybe<FisAssetTagLinkMutationResponse>;
  /** insert a single row into the table: "fis.asset_tag_link" */
  insert_fis_asset_tag_link_one?: Maybe<FisAssetTagLink>;
  /** insert a single row into the table: "fis.asset_tag" */
  insert_fis_asset_tag_one?: Maybe<FisAssetTag>;
  /** insert data into the table: "fis.asset_type" */
  insert_fis_asset_type?: Maybe<FisAssetTypeMutationResponse>;
  /** insert a single row into the table: "fis.asset_type" */
  insert_fis_asset_type_one?: Maybe<FisAssetType>;
  /** insert data into the table: "fis.core_state" */
  insert_fis_core_state?: Maybe<FisCoreStateMutationResponse>;
  /** insert a single row into the table: "fis.core_state" */
  insert_fis_core_state_one?: Maybe<FisCoreState>;
  /** insert data into the table: "fis.data" */
  insert_fis_data?: Maybe<FisDataMutationResponse>;
  /** insert data into the table: "fis.data_label" */
  insert_fis_data_label?: Maybe<FisDataLabelMutationResponse>;
  /** insert a single row into the table: "fis.data_label" */
  insert_fis_data_label_one?: Maybe<FisDataLabel>;
  /** insert a single row into the table: "fis.data" */
  insert_fis_data_one?: Maybe<FisData>;
  /** insert data into the table: "fis.data_timing" */
  insert_fis_data_timing?: Maybe<FisDataTimingMutationResponse>;
  /** insert a single row into the table: "fis.data_timing" */
  insert_fis_data_timing_one?: Maybe<FisDataTiming>;
  /** insert data into the table: "fis.data_track_count" */
  insert_fis_data_track_count?: Maybe<FisDataTrackCountMutationResponse>;
  /** insert a single row into the table: "fis.data_track_count" */
  insert_fis_data_track_count_one?: Maybe<FisDataTrackCount>;
  /** insert data into the table: "fis.data_track_duration" */
  insert_fis_data_track_duration?: Maybe<FisDataTrackDurationMutationResponse>;
  /** insert a single row into the table: "fis.data_track_duration" */
  insert_fis_data_track_duration_one?: Maybe<FisDataTrackDuration>;
  /** insert data into the table: "fis.data_track_scalar" */
  insert_fis_data_track_scalar?: Maybe<FisDataTrackScalarMutationResponse>;
  /** insert a single row into the table: "fis.data_track_scalar" */
  insert_fis_data_track_scalar_one?: Maybe<FisDataTrackScalar>;
  /** insert data into the table: "fis.data_type" */
  insert_fis_data_type?: Maybe<FisDataTypeMutationResponse>;
  /** insert a single row into the table: "fis.data_type" */
  insert_fis_data_type_one?: Maybe<FisDataType>;
  /** insert data into the table: "process.collection" */
  insert_process_collection?: Maybe<ProcessCollectionMutationResponse>;
  /** insert data into the table: "process.collection_data" */
  insert_process_collection_data?: Maybe<ProcessCollectionDataMutationResponse>;
  /** insert a single row into the table: "process.collection_data" */
  insert_process_collection_data_one?: Maybe<ProcessCollectionData>;
  /** insert data into the table: "process.collection_kind" */
  insert_process_collection_kind?: Maybe<ProcessCollectionKindMutationResponse>;
  /** insert a single row into the table: "process.collection_kind" */
  insert_process_collection_kind_one?: Maybe<ProcessCollectionKind>;
  /** insert a single row into the table: "process.collection" */
  insert_process_collection_one?: Maybe<ProcessCollection>;
  /** insert data into the table: "process.data_element" */
  insert_process_data_element?: Maybe<ProcessDataElementMutationResponse>;
  /** insert data into the table: "process.data_element_collection_kind" */
  insert_process_data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindMutationResponse>;
  /** insert a single row into the table: "process.data_element_collection_kind" */
  insert_process_data_element_collection_kind_one?: Maybe<ProcessDataElementCollectionKind>;
  /** insert data into the table: "process.data_element_kind" */
  insert_process_data_element_kind?: Maybe<ProcessDataElementKindMutationResponse>;
  /** insert a single row into the table: "process.data_element_kind" */
  insert_process_data_element_kind_one?: Maybe<ProcessDataElementKind>;
  /** insert a single row into the table: "process.data_element" */
  insert_process_data_element_one?: Maybe<ProcessDataElement>;
  /** insert data into the table: "process.material_state" */
  insert_process_material_state?: Maybe<ProcessMaterialStateMutationResponse>;
  /** insert data into the table: "process.material_state_history" */
  insert_process_material_state_history?: Maybe<ProcessMaterialStateHistoryMutationResponse>;
  /** insert a single row into the table: "process.material_state_history" */
  insert_process_material_state_history_one?: Maybe<ProcessMaterialStateHistory>;
  /** insert a single row into the table: "process.material_state" */
  insert_process_material_state_one?: Maybe<ProcessMaterialState>;
  /** insert data into the table: "process.process" */
  insert_process_process?: Maybe<ProcessProcessMutationResponse>;
  /** insert a single row into the table: "process.process" */
  insert_process_process_one?: Maybe<ProcessProcess>;
  /** insert data into the table: "process.process_status" */
  insert_process_process_status?: Maybe<ProcessProcessStatusMutationResponse>;
  /** insert a single row into the table: "process.process_status" */
  insert_process_process_status_one?: Maybe<ProcessProcessStatus>;
  /** insert data into the table: "process.spec" */
  insert_process_spec?: Maybe<ProcessSpecMutationResponse>;
  /** insert a single row into the table: "process.spec" */
  insert_process_spec_one?: Maybe<ProcessSpec>;
  /** insert data into the table: "process.spec_order" */
  insert_process_spec_order?: Maybe<ProcessSpecOrderMutationResponse>;
  /** insert a single row into the table: "process.spec_order" */
  insert_process_spec_order_one?: Maybe<ProcessSpecOrder>;
  /** execute VOLATILE function "process.collect" which returns "plv8_response" */
  process_collect?: Maybe<Plv8Response>;
  /** execute VOLATILE function "process.get_or_solve_material_state" which returns "plv8_response" */
  process_get_or_solve_material_state?: Maybe<Plv8Response>;
  /** execute VOLATILE function "process.material_state_set_status" which returns "plv8_response" */
  process_material_state_set_status?: Maybe<Plv8Response>;
  /** update data of the table: "applet.deployment" */
  update_applet_deployment?: Maybe<AppletDeploymentMutationResponse>;
  /** update single row of the table: "applet.deployment" */
  update_applet_deployment_by_pk?: Maybe<AppletDeployment>;
  /** update data of the table: "applet.deployment_linked_design_version" */
  update_applet_deployment_linked_design_version?: Maybe<AppletDeploymentLinkedDesignVersionMutationResponse>;
  /** update single row of the table: "applet.deployment_linked_design_version" */
  update_applet_deployment_linked_design_version_by_pk?: Maybe<AppletDeploymentLinkedDesignVersion>;
  /** update multiples rows of table: "applet.deployment_linked_design_version" */
  update_applet_deployment_linked_design_version_many?: Maybe<Array<Maybe<AppletDeploymentLinkedDesignVersionMutationResponse>>>;
  /** update multiples rows of table: "applet.deployment" */
  update_applet_deployment_many?: Maybe<Array<Maybe<AppletDeploymentMutationResponse>>>;
  /** update data of the table: "applet.design" */
  update_applet_design?: Maybe<AppletDesignMutationResponse>;
  /** update single row of the table: "applet.design" */
  update_applet_design_by_pk?: Maybe<AppletDesign>;
  /** update multiples rows of table: "applet.design" */
  update_applet_design_many?: Maybe<Array<Maybe<AppletDesignMutationResponse>>>;
  /** update data of the table: "applet.design_version" */
  update_applet_design_version?: Maybe<AppletDesignVersionMutationResponse>;
  /** update single row of the table: "applet.design_version" */
  update_applet_design_version_by_pk?: Maybe<AppletDesignVersion>;
  /** update multiples rows of table: "applet.design_version" */
  update_applet_design_version_many?: Maybe<Array<Maybe<AppletDesignVersionMutationResponse>>>;
  /** update data of the table: "applet.design_version_status" */
  update_applet_design_version_status?: Maybe<AppletDesignVersionStatusMutationResponse>;
  /** update single row of the table: "applet.design_version_status" */
  update_applet_design_version_status_by_pk?: Maybe<AppletDesignVersionStatus>;
  /** update multiples rows of table: "applet.design_version_status" */
  update_applet_design_version_status_many?: Maybe<Array<Maybe<AppletDesignVersionStatusMutationResponse>>>;
  /** update data of the table: "applet.registration_code" */
  update_applet_registration_code?: Maybe<AppletRegistrationCodeMutationResponse>;
  /** update single row of the table: "applet.registration_code" */
  update_applet_registration_code_by_pk?: Maybe<AppletRegistrationCode>;
  /** update multiples rows of table: "applet.registration_code" */
  update_applet_registration_code_many?: Maybe<Array<Maybe<AppletRegistrationCodeMutationResponse>>>;
  /** update data of the table: "applet.runner" */
  update_applet_runner?: Maybe<AppletRunnerMutationResponse>;
  /** update single row of the table: "applet.runner" */
  update_applet_runner_by_pk?: Maybe<AppletRunner>;
  /** update data of the table: "applet.runner_context" */
  update_applet_runner_context?: Maybe<AppletRunnerContextMutationResponse>;
  /** update single row of the table: "applet.runner_context" */
  update_applet_runner_context_by_pk?: Maybe<AppletRunnerContext>;
  /** update multiples rows of table: "applet.runner_context" */
  update_applet_runner_context_many?: Maybe<Array<Maybe<AppletRunnerContextMutationResponse>>>;
  /** update multiples rows of table: "applet.runner" */
  update_applet_runner_many?: Maybe<Array<Maybe<AppletRunnerMutationResponse>>>;
  /** update data of the table: "argo.acl" */
  update_argo_acl?: Maybe<ArgoAclMutationResponse>;
  /** update single row of the table: "argo.acl" */
  update_argo_acl_by_pk?: Maybe<ArgoAcl>;
  /** update multiples rows of table: "argo.acl" */
  update_argo_acl_many?: Maybe<Array<Maybe<ArgoAclMutationResponse>>>;
  /** update data of the table: "argo.attribute" */
  update_argo_attribute?: Maybe<ArgoAttributeMutationResponse>;
  /** update single row of the table: "argo.attribute" */
  update_argo_attribute_by_pk?: Maybe<ArgoAttribute>;
  /** update data of the table: "argo.attribute_data" */
  update_argo_attribute_data?: Maybe<ArgoAttributeDataMutationResponse>;
  /** update single row of the table: "argo.attribute_data" */
  update_argo_attribute_data_by_pk?: Maybe<ArgoAttributeData>;
  /** update multiples rows of table: "argo.attribute_data" */
  update_argo_attribute_data_many?: Maybe<Array<Maybe<ArgoAttributeDataMutationResponse>>>;
  /** update data of the table: "argo.attribute_history_status_type" */
  update_argo_attribute_history_status_type?: Maybe<ArgoAttributeHistoryStatusTypeMutationResponse>;
  /** update single row of the table: "argo.attribute_history_status_type" */
  update_argo_attribute_history_status_type_by_pk?: Maybe<ArgoAttributeHistoryStatusType>;
  /** update multiples rows of table: "argo.attribute_history_status_type" */
  update_argo_attribute_history_status_type_many?: Maybe<Array<Maybe<ArgoAttributeHistoryStatusTypeMutationResponse>>>;
  /** update multiples rows of table: "argo.attribute" */
  update_argo_attribute_many?: Maybe<Array<Maybe<ArgoAttributeMutationResponse>>>;
  /** update data of the table: "argo.attribute_schema" */
  update_argo_attribute_schema?: Maybe<ArgoAttributeSchemaMutationResponse>;
  /** update single row of the table: "argo.attribute_schema" */
  update_argo_attribute_schema_by_pk?: Maybe<ArgoAttributeSchema>;
  /** update data of the table: "argo.attribute_schema_definition" */
  update_argo_attribute_schema_definition?: Maybe<ArgoAttributeSchemaDefinitionMutationResponse>;
  /** update single row of the table: "argo.attribute_schema_definition" */
  update_argo_attribute_schema_definition_by_pk?: Maybe<ArgoAttributeSchemaDefinition>;
  /** update multiples rows of table: "argo.attribute_schema_definition" */
  update_argo_attribute_schema_definition_many?: Maybe<Array<Maybe<ArgoAttributeSchemaDefinitionMutationResponse>>>;
  /** update data of the table: "argo.attribute_schema_definition_type" */
  update_argo_attribute_schema_definition_type?: Maybe<ArgoAttributeSchemaDefinitionTypeMutationResponse>;
  /** update single row of the table: "argo.attribute_schema_definition_type" */
  update_argo_attribute_schema_definition_type_by_pk?: Maybe<ArgoAttributeSchemaDefinitionType>;
  /** update multiples rows of table: "argo.attribute_schema_definition_type" */
  update_argo_attribute_schema_definition_type_many?: Maybe<Array<Maybe<ArgoAttributeSchemaDefinitionTypeMutationResponse>>>;
  /** update multiples rows of table: "argo.attribute_schema" */
  update_argo_attribute_schema_many?: Maybe<Array<Maybe<ArgoAttributeSchemaMutationResponse>>>;
  /** update data of the table: "argo.attribute_schema_type" */
  update_argo_attribute_schema_type?: Maybe<ArgoAttributeSchemaTypeMutationResponse>;
  /** update single row of the table: "argo.attribute_schema_type" */
  update_argo_attribute_schema_type_by_pk?: Maybe<ArgoAttributeSchemaType>;
  /** update multiples rows of table: "argo.attribute_schema_type" */
  update_argo_attribute_schema_type_many?: Maybe<Array<Maybe<ArgoAttributeSchemaTypeMutationResponse>>>;
  /** update data of the table: "argo.audit" */
  update_argo_audit?: Maybe<ArgoAuditMutationResponse>;
  /** update single row of the table: "argo.audit" */
  update_argo_audit_by_pk?: Maybe<ArgoAudit>;
  /** update multiples rows of table: "argo.audit" */
  update_argo_audit_many?: Maybe<Array<Maybe<ArgoAuditMutationResponse>>>;
  /** update data of the table: "argo.auth_provider" */
  update_argo_auth_provider?: Maybe<ArgoAuthProviderMutationResponse>;
  /** update single row of the table: "argo.auth_provider" */
  update_argo_auth_provider_by_pk?: Maybe<ArgoAuthProvider>;
  /** update data of the table: "argo.auth_provider_local" */
  update_argo_auth_provider_local?: Maybe<ArgoAuthProviderLocalMutationResponse>;
  /** update single row of the table: "argo.auth_provider_local" */
  update_argo_auth_provider_local_by_pk?: Maybe<ArgoAuthProviderLocal>;
  /** update multiples rows of table: "argo.auth_provider_local" */
  update_argo_auth_provider_local_many?: Maybe<Array<Maybe<ArgoAuthProviderLocalMutationResponse>>>;
  /** update data of the table: "argo.auth_provider_local_setting" */
  update_argo_auth_provider_local_setting?: Maybe<ArgoAuthProviderLocalSettingMutationResponse>;
  /** update single row of the table: "argo.auth_provider_local_setting" */
  update_argo_auth_provider_local_setting_by_pk?: Maybe<ArgoAuthProviderLocalSetting>;
  /** update multiples rows of table: "argo.auth_provider_local_setting" */
  update_argo_auth_provider_local_setting_many?: Maybe<Array<Maybe<ArgoAuthProviderLocalSettingMutationResponse>>>;
  /** update multiples rows of table: "argo.auth_provider" */
  update_argo_auth_provider_many?: Maybe<Array<Maybe<ArgoAuthProviderMutationResponse>>>;
  /** update data of the table: "argo.auth_provider_msal" */
  update_argo_auth_provider_msal?: Maybe<ArgoAuthProviderMsalMutationResponse>;
  /** update single row of the table: "argo.auth_provider_msal" */
  update_argo_auth_provider_msal_by_pk?: Maybe<ArgoAuthProviderMsal>;
  /** update multiples rows of table: "argo.auth_provider_msal" */
  update_argo_auth_provider_msal_many?: Maybe<Array<Maybe<ArgoAuthProviderMsalMutationResponse>>>;
  /** update data of the table: "argo.auth_provider_msal_setting" */
  update_argo_auth_provider_msal_setting?: Maybe<ArgoAuthProviderMsalSettingMutationResponse>;
  /** update single row of the table: "argo.auth_provider_msal_setting" */
  update_argo_auth_provider_msal_setting_by_pk?: Maybe<ArgoAuthProviderMsalSetting>;
  /** update multiples rows of table: "argo.auth_provider_msal_setting" */
  update_argo_auth_provider_msal_setting_many?: Maybe<Array<Maybe<ArgoAuthProviderMsalSettingMutationResponse>>>;
  /** update data of the table: "argo.auth_provider_record" */
  update_argo_auth_provider_record?: Maybe<ArgoAuthProviderRecordMutationResponse>;
  /** update single row of the table: "argo.auth_provider_record" */
  update_argo_auth_provider_record_by_pk?: Maybe<ArgoAuthProviderRecord>;
  /** update multiples rows of table: "argo.auth_provider_record" */
  update_argo_auth_provider_record_many?: Maybe<Array<Maybe<ArgoAuthProviderRecordMutationResponse>>>;
  /** update data of the table: "argo.auth_refresh_token" */
  update_argo_auth_refresh_token?: Maybe<ArgoAuthRefreshTokenMutationResponse>;
  /** update single row of the table: "argo.auth_refresh_token" */
  update_argo_auth_refresh_token_by_pk?: Maybe<ArgoAuthRefreshToken>;
  /** update multiples rows of table: "argo.auth_refresh_token" */
  update_argo_auth_refresh_token_many?: Maybe<Array<Maybe<ArgoAuthRefreshTokenMutationResponse>>>;
  /** update data of the table: "argo.calendar" */
  update_argo_calendar?: Maybe<ArgoCalendarMutationResponse>;
  /** update single row of the table: "argo.calendar" */
  update_argo_calendar_by_pk?: Maybe<ArgoCalendar>;
  /** update data of the table: "argo.calendar_event" */
  update_argo_calendar_event?: Maybe<ArgoCalendarEventMutationResponse>;
  /** update single row of the table: "argo.calendar_event" */
  update_argo_calendar_event_by_pk?: Maybe<ArgoCalendarEvent>;
  /** update multiples rows of table: "argo.calendar_event" */
  update_argo_calendar_event_many?: Maybe<Array<Maybe<ArgoCalendarEventMutationResponse>>>;
  /** update data of the table: "argo.calendar_event_sequence" */
  update_argo_calendar_event_sequence?: Maybe<ArgoCalendarEventSequenceMutationResponse>;
  /** update multiples rows of table: "argo.calendar_event_sequence" */
  update_argo_calendar_event_sequence_many?: Maybe<Array<Maybe<ArgoCalendarEventSequenceMutationResponse>>>;
  /** update data of the table: "argo.calendar_event_udf_data" */
  update_argo_calendar_event_udf_data?: Maybe<ArgoCalendarEventUdfDataMutationResponse>;
  /** update single row of the table: "argo.calendar_event_udf_data" */
  update_argo_calendar_event_udf_data_by_pk?: Maybe<ArgoCalendarEventUdfData>;
  /** update multiples rows of table: "argo.calendar_event_udf_data" */
  update_argo_calendar_event_udf_data_many?: Maybe<Array<Maybe<ArgoCalendarEventUdfDataMutationResponse>>>;
  /** update data of the table: "argo.calendar_event_udf_default_data" */
  update_argo_calendar_event_udf_default_data?: Maybe<ArgoCalendarEventUdfDefaultDataMutationResponse>;
  /** update single row of the table: "argo.calendar_event_udf_default_data" */
  update_argo_calendar_event_udf_default_data_by_pk?: Maybe<ArgoCalendarEventUdfDefaultData>;
  /** update multiples rows of table: "argo.calendar_event_udf_default_data" */
  update_argo_calendar_event_udf_default_data_many?: Maybe<Array<Maybe<ArgoCalendarEventUdfDefaultDataMutationResponse>>>;
  /** update data of the table: "argo.calendar_event_udf_schema" */
  update_argo_calendar_event_udf_schema?: Maybe<ArgoCalendarEventUdfSchemaMutationResponse>;
  /** update single row of the table: "argo.calendar_event_udf_schema" */
  update_argo_calendar_event_udf_schema_by_pk?: Maybe<ArgoCalendarEventUdfSchema>;
  /** update multiples rows of table: "argo.calendar_event_udf_schema" */
  update_argo_calendar_event_udf_schema_many?: Maybe<Array<Maybe<ArgoCalendarEventUdfSchemaMutationResponse>>>;
  /** update data of the table: "argo.calendar_location" */
  update_argo_calendar_location?: Maybe<ArgoCalendarLocationMutationResponse>;
  /** update single row of the table: "argo.calendar_location" */
  update_argo_calendar_location_by_pk?: Maybe<ArgoCalendarLocation>;
  /** update multiples rows of table: "argo.calendar_location" */
  update_argo_calendar_location_many?: Maybe<Array<Maybe<ArgoCalendarLocationMutationResponse>>>;
  /** update multiples rows of table: "argo.calendar" */
  update_argo_calendar_many?: Maybe<Array<Maybe<ArgoCalendarMutationResponse>>>;
  /** update data of the table: "argo.connection" */
  update_argo_connection?: Maybe<ArgoConnectionMutationResponse>;
  /** update single row of the table: "argo.connection" */
  update_argo_connection_by_pk?: Maybe<ArgoConnection>;
  /** update data of the table: "argo.connection_config" */
  update_argo_connection_config?: Maybe<ArgoConnectionConfigMutationResponse>;
  /** update single row of the table: "argo.connection_config" */
  update_argo_connection_config_by_pk?: Maybe<ArgoConnectionConfig>;
  /** update multiples rows of table: "argo.connection_config" */
  update_argo_connection_config_many?: Maybe<Array<Maybe<ArgoConnectionConfigMutationResponse>>>;
  /** update data of the table: "argo.connection_config_status" */
  update_argo_connection_config_status?: Maybe<ArgoConnectionConfigStatusMutationResponse>;
  /** update single row of the table: "argo.connection_config_status" */
  update_argo_connection_config_status_by_pk?: Maybe<ArgoConnectionConfigStatus>;
  /** update multiples rows of table: "argo.connection_config_status" */
  update_argo_connection_config_status_many?: Maybe<Array<Maybe<ArgoConnectionConfigStatusMutationResponse>>>;
  /** update data of the table: "argo.connection_kind" */
  update_argo_connection_kind?: Maybe<ArgoConnectionKindMutationResponse>;
  /** update single row of the table: "argo.connection_kind" */
  update_argo_connection_kind_by_pk?: Maybe<ArgoConnectionKind>;
  /** update multiples rows of table: "argo.connection_kind" */
  update_argo_connection_kind_many?: Maybe<Array<Maybe<ArgoConnectionKindMutationResponse>>>;
  /** update multiples rows of table: "argo.connection" */
  update_argo_connection_many?: Maybe<Array<Maybe<ArgoConnectionMutationResponse>>>;
  /** update data of the table: "argo.context" */
  update_argo_context?: Maybe<ArgoContextMutationResponse>;
  /** update single row of the table: "argo.context" */
  update_argo_context_by_pk?: Maybe<ArgoContext>;
  /** update multiples rows of table: "argo.context" */
  update_argo_context_many?: Maybe<Array<Maybe<ArgoContextMutationResponse>>>;
  /** update data of the table: "argo.cron_task" */
  update_argo_cron_task?: Maybe<ArgoCronTaskMutationResponse>;
  /** update single row of the table: "argo.cron_task" */
  update_argo_cron_task_by_pk?: Maybe<ArgoCronTask>;
  /** update multiples rows of table: "argo.cron_task" */
  update_argo_cron_task_many?: Maybe<Array<Maybe<ArgoCronTaskMutationResponse>>>;
  /** update data of the table: "argo.event" */
  update_argo_event?: Maybe<ArgoEventMutationResponse>;
  /** update single row of the table: "argo.event" */
  update_argo_event_by_pk?: Maybe<ArgoEvent>;
  /** update multiples rows of table: "argo.event" */
  update_argo_event_many?: Maybe<Array<Maybe<ArgoEventMutationResponse>>>;
  /** update data of the table: "argo.event_type" */
  update_argo_event_type?: Maybe<ArgoEventTypeMutationResponse>;
  /** update single row of the table: "argo.event_type" */
  update_argo_event_type_by_pk?: Maybe<ArgoEventType>;
  /** update multiples rows of table: "argo.event_type" */
  update_argo_event_type_many?: Maybe<Array<Maybe<ArgoEventTypeMutationResponse>>>;
  /** update data of the table: "argo.hasura_permission" */
  update_argo_hasura_permission?: Maybe<ArgoHasuraPermissionMutationResponse>;
  /** update single row of the table: "argo.hasura_permission" */
  update_argo_hasura_permission_by_pk?: Maybe<ArgoHasuraPermission>;
  /** update multiples rows of table: "argo.hasura_permission" */
  update_argo_hasura_permission_many?: Maybe<Array<Maybe<ArgoHasuraPermissionMutationResponse>>>;
  /** update data of the table: "argo.link" */
  update_argo_link?: Maybe<ArgoLinkMutationResponse>;
  /** update single row of the table: "argo.link" */
  update_argo_link_by_pk?: Maybe<ArgoLink>;
  /** update multiples rows of table: "argo.link" */
  update_argo_link_many?: Maybe<Array<Maybe<ArgoLinkMutationResponse>>>;
  /** update data of the table: "argo.location" */
  update_argo_location?: Maybe<ArgoLocationMutationResponse>;
  /** update data of the table: "argo.location_attribute" */
  update_argo_location_attribute?: Maybe<ArgoLocationAttributeMutationResponse>;
  /** update single row of the table: "argo.location_attribute" */
  update_argo_location_attribute_by_pk?: Maybe<ArgoLocationAttribute>;
  /** update data of the table: "argo.location_attribute_history" */
  update_argo_location_attribute_history?: Maybe<ArgoLocationAttributeHistoryMutationResponse>;
  /** update single row of the table: "argo.location_attribute_history" */
  update_argo_location_attribute_history_by_pk?: Maybe<ArgoLocationAttributeHistory>;
  /** update multiples rows of table: "argo.location_attribute_history" */
  update_argo_location_attribute_history_many?: Maybe<Array<Maybe<ArgoLocationAttributeHistoryMutationResponse>>>;
  /** update multiples rows of table: "argo.location_attribute" */
  update_argo_location_attribute_many?: Maybe<Array<Maybe<ArgoLocationAttributeMutationResponse>>>;
  /** update single row of the table: "argo.location" */
  update_argo_location_by_pk?: Maybe<ArgoLocation>;
  /** update data of the table: "argo.location_class" */
  update_argo_location_class?: Maybe<ArgoLocationClassMutationResponse>;
  /** update single row of the table: "argo.location_class" */
  update_argo_location_class_by_pk?: Maybe<ArgoLocationClass>;
  /** update multiples rows of table: "argo.location_class" */
  update_argo_location_class_many?: Maybe<Array<Maybe<ArgoLocationClassMutationResponse>>>;
  /** update multiples rows of table: "argo.location" */
  update_argo_location_many?: Maybe<Array<Maybe<ArgoLocationMutationResponse>>>;
  /** update data of the table: "argo.log" */
  update_argo_log?: Maybe<ArgoLogMutationResponse>;
  /** update single row of the table: "argo.log" */
  update_argo_log_by_pk?: Maybe<ArgoLog>;
  /** update data of the table: "argo.log_category" */
  update_argo_log_category?: Maybe<ArgoLogCategoryMutationResponse>;
  /** update single row of the table: "argo.log_category" */
  update_argo_log_category_by_pk?: Maybe<ArgoLogCategory>;
  /** update multiples rows of table: "argo.log_category" */
  update_argo_log_category_many?: Maybe<Array<Maybe<ArgoLogCategoryMutationResponse>>>;
  /** update data of the table: "argo.log_duration" */
  update_argo_log_duration?: Maybe<ArgoLogDurationMutationResponse>;
  /** update multiples rows of table: "argo.log_duration" */
  update_argo_log_duration_many?: Maybe<Array<Maybe<ArgoLogDurationMutationResponse>>>;
  /** update data of the table: "argo.log_level" */
  update_argo_log_level?: Maybe<ArgoLogLevelMutationResponse>;
  /** update single row of the table: "argo.log_level" */
  update_argo_log_level_by_pk?: Maybe<ArgoLogLevel>;
  /** update multiples rows of table: "argo.log_level" */
  update_argo_log_level_many?: Maybe<Array<Maybe<ArgoLogLevelMutationResponse>>>;
  /** update multiples rows of table: "argo.log" */
  update_argo_log_many?: Maybe<Array<Maybe<ArgoLogMutationResponse>>>;
  /** update data of the table: "argo.material" */
  update_argo_material?: Maybe<ArgoMaterialMutationResponse>;
  /** update data of the table: "argo.material_activity" */
  update_argo_material_activity?: Maybe<ArgoMaterialActivityMutationResponse>;
  /** update single row of the table: "argo.material_activity" */
  update_argo_material_activity_by_pk?: Maybe<ArgoMaterialActivity>;
  /** update data of the table: "argo.material_activity_kind" */
  update_argo_material_activity_kind?: Maybe<ArgoMaterialActivityKindMutationResponse>;
  /** update single row of the table: "argo.material_activity_kind" */
  update_argo_material_activity_kind_by_pk?: Maybe<ArgoMaterialActivityKind>;
  /** update multiples rows of table: "argo.material_activity_kind" */
  update_argo_material_activity_kind_many?: Maybe<Array<Maybe<ArgoMaterialActivityKindMutationResponse>>>;
  /** update multiples rows of table: "argo.material_activity" */
  update_argo_material_activity_many?: Maybe<Array<Maybe<ArgoMaterialActivityMutationResponse>>>;
  /** update data of the table: "argo.material_assembly" */
  update_argo_material_assembly?: Maybe<ArgoMaterialAssemblyMutationResponse>;
  /** update multiples rows of table: "argo.material_assembly" */
  update_argo_material_assembly_many?: Maybe<Array<Maybe<ArgoMaterialAssemblyMutationResponse>>>;
  /** update data of the table: "argo.material_attribute" */
  update_argo_material_attribute?: Maybe<ArgoMaterialAttributeMutationResponse>;
  /** update single row of the table: "argo.material_attribute" */
  update_argo_material_attribute_by_pk?: Maybe<ArgoMaterialAttribute>;
  /** update data of the table: "argo.material_attribute_history" */
  update_argo_material_attribute_history?: Maybe<ArgoMaterialAttributeHistoryMutationResponse>;
  /** update single row of the table: "argo.material_attribute_history" */
  update_argo_material_attribute_history_by_pk?: Maybe<ArgoMaterialAttributeHistory>;
  /** update multiples rows of table: "argo.material_attribute_history" */
  update_argo_material_attribute_history_many?: Maybe<Array<Maybe<ArgoMaterialAttributeHistoryMutationResponse>>>;
  /** update multiples rows of table: "argo.material_attribute" */
  update_argo_material_attribute_many?: Maybe<Array<Maybe<ArgoMaterialAttributeMutationResponse>>>;
  /** update single row of the table: "argo.material" */
  update_argo_material_by_pk?: Maybe<ArgoMaterial>;
  /** update data of the table: "argo.material_class" */
  update_argo_material_class?: Maybe<ArgoMaterialClassMutationResponse>;
  /** update data of the table: "argo.material_class_attribute" */
  update_argo_material_class_attribute?: Maybe<ArgoMaterialClassAttributeMutationResponse>;
  /** update single row of the table: "argo.material_class_attribute" */
  update_argo_material_class_attribute_by_pk?: Maybe<ArgoMaterialClassAttribute>;
  /** update multiples rows of table: "argo.material_class_attribute" */
  update_argo_material_class_attribute_many?: Maybe<Array<Maybe<ArgoMaterialClassAttributeMutationResponse>>>;
  /** update data of the table: "argo.material_class_attribute_setting" */
  update_argo_material_class_attribute_setting?: Maybe<ArgoMaterialClassAttributeSettingMutationResponse>;
  /** update single row of the table: "argo.material_class_attribute_setting" */
  update_argo_material_class_attribute_setting_by_pk?: Maybe<ArgoMaterialClassAttributeSetting>;
  /** update multiples rows of table: "argo.material_class_attribute_setting" */
  update_argo_material_class_attribute_setting_many?: Maybe<Array<Maybe<ArgoMaterialClassAttributeSettingMutationResponse>>>;
  /** update single row of the table: "argo.material_class" */
  update_argo_material_class_by_pk?: Maybe<ArgoMaterialClass>;
  /** update multiples rows of table: "argo.material_class" */
  update_argo_material_class_many?: Maybe<Array<Maybe<ArgoMaterialClassMutationResponse>>>;
  /** update data of the table: "argo.material_class_process" */
  update_argo_material_class_process?: Maybe<ArgoMaterialClassProcessMutationResponse>;
  /** update single row of the table: "argo.material_class_process" */
  update_argo_material_class_process_by_pk?: Maybe<ArgoMaterialClassProcess>;
  /** update multiples rows of table: "argo.material_class_process" */
  update_argo_material_class_process_many?: Maybe<Array<Maybe<ArgoMaterialClassProcessMutationResponse>>>;
  /** update multiples rows of table: "argo.material" */
  update_argo_material_many?: Maybe<Array<Maybe<ArgoMaterialMutationResponse>>>;
  /** update data of the table: "argo.material_marriage" */
  update_argo_material_marriage?: Maybe<ArgoMaterialMarriageMutationResponse>;
  /** update single row of the table: "argo.material_marriage" */
  update_argo_material_marriage_by_pk?: Maybe<ArgoMaterialMarriage>;
  /** update multiples rows of table: "argo.material_marriage" */
  update_argo_material_marriage_many?: Maybe<Array<Maybe<ArgoMaterialMarriageMutationResponse>>>;
  /** update data of the table: "argo.material_marriage_status" */
  update_argo_material_marriage_status?: Maybe<ArgoMaterialMarriageStatusMutationResponse>;
  /** update single row of the table: "argo.material_marriage_status" */
  update_argo_material_marriage_status_by_pk?: Maybe<ArgoMaterialMarriageStatus>;
  /** update multiples rows of table: "argo.material_marriage_status" */
  update_argo_material_marriage_status_many?: Maybe<Array<Maybe<ArgoMaterialMarriageStatusMutationResponse>>>;
  /** update data of the table: "argo.material_model" */
  update_argo_material_model?: Maybe<ArgoMaterialModelMutationResponse>;
  /** update data of the table: "argo.material_model_attribute" */
  update_argo_material_model_attribute?: Maybe<ArgoMaterialModelAttributeMutationResponse>;
  /** update single row of the table: "argo.material_model_attribute" */
  update_argo_material_model_attribute_by_pk?: Maybe<ArgoMaterialModelAttribute>;
  /** update multiples rows of table: "argo.material_model_attribute" */
  update_argo_material_model_attribute_many?: Maybe<Array<Maybe<ArgoMaterialModelAttributeMutationResponse>>>;
  /** update data of the table: "argo.material_model_attribute_setting" */
  update_argo_material_model_attribute_setting?: Maybe<ArgoMaterialModelAttributeSettingMutationResponse>;
  /** update single row of the table: "argo.material_model_attribute_setting" */
  update_argo_material_model_attribute_setting_by_pk?: Maybe<ArgoMaterialModelAttributeSetting>;
  /** update multiples rows of table: "argo.material_model_attribute_setting" */
  update_argo_material_model_attribute_setting_many?: Maybe<Array<Maybe<ArgoMaterialModelAttributeSettingMutationResponse>>>;
  /** update single row of the table: "argo.material_model" */
  update_argo_material_model_by_pk?: Maybe<ArgoMaterialModel>;
  /** update multiples rows of table: "argo.material_model" */
  update_argo_material_model_many?: Maybe<Array<Maybe<ArgoMaterialModelMutationResponse>>>;
  /** update data of the table: "argo.material_model_process" */
  update_argo_material_model_process?: Maybe<ArgoMaterialModelProcessMutationResponse>;
  /** update single row of the table: "argo.material_model_process" */
  update_argo_material_model_process_by_pk?: Maybe<ArgoMaterialModelProcess>;
  /** update multiples rows of table: "argo.material_model_process" */
  update_argo_material_model_process_many?: Maybe<Array<Maybe<ArgoMaterialModelProcessMutationResponse>>>;
  /** update data of the table: "argo.material_quantity_kind" */
  update_argo_material_quantity_kind?: Maybe<ArgoMaterialQuantityKindMutationResponse>;
  /** update single row of the table: "argo.material_quantity_kind" */
  update_argo_material_quantity_kind_by_pk?: Maybe<ArgoMaterialQuantityKind>;
  /** update multiples rows of table: "argo.material_quantity_kind" */
  update_argo_material_quantity_kind_many?: Maybe<Array<Maybe<ArgoMaterialQuantityKindMutationResponse>>>;
  /** update data of the table: "argo.material_status" */
  update_argo_material_status?: Maybe<ArgoMaterialStatusMutationResponse>;
  /** update single row of the table: "argo.material_status" */
  update_argo_material_status_by_pk?: Maybe<ArgoMaterialStatus>;
  /** update multiples rows of table: "argo.material_status" */
  update_argo_material_status_many?: Maybe<Array<Maybe<ArgoMaterialStatusMutationResponse>>>;
  /** update data of the table: "argo.material_udf_data" */
  update_argo_material_udf_data?: Maybe<ArgoMaterialUdfDataMutationResponse>;
  /** update single row of the table: "argo.material_udf_data" */
  update_argo_material_udf_data_by_pk?: Maybe<ArgoMaterialUdfData>;
  /** update multiples rows of table: "argo.material_udf_data" */
  update_argo_material_udf_data_many?: Maybe<Array<Maybe<ArgoMaterialUdfDataMutationResponse>>>;
  /** update data of the table: "argo.material_udf_default_data" */
  update_argo_material_udf_default_data?: Maybe<ArgoMaterialUdfDefaultDataMutationResponse>;
  /** update single row of the table: "argo.material_udf_default_data" */
  update_argo_material_udf_default_data_by_pk?: Maybe<ArgoMaterialUdfDefaultData>;
  /** update multiples rows of table: "argo.material_udf_default_data" */
  update_argo_material_udf_default_data_many?: Maybe<Array<Maybe<ArgoMaterialUdfDefaultDataMutationResponse>>>;
  /** update data of the table: "argo.material_udf_schema" */
  update_argo_material_udf_schema?: Maybe<ArgoMaterialUdfSchemaMutationResponse>;
  /** update single row of the table: "argo.material_udf_schema" */
  update_argo_material_udf_schema_by_pk?: Maybe<ArgoMaterialUdfSchema>;
  /** update multiples rows of table: "argo.material_udf_schema" */
  update_argo_material_udf_schema_many?: Maybe<Array<Maybe<ArgoMaterialUdfSchemaMutationResponse>>>;
  /** update data of the table: "argo.media_config" */
  update_argo_media_config?: Maybe<ArgoMediaConfigMutationResponse>;
  /** update single row of the table: "argo.media_config" */
  update_argo_media_config_by_pk?: Maybe<ArgoMediaConfig>;
  /** update multiples rows of table: "argo.media_config" */
  update_argo_media_config_many?: Maybe<Array<Maybe<ArgoMediaConfigMutationResponse>>>;
  /** update data of the table: "argo.media_instance" */
  update_argo_media_instance?: Maybe<ArgoMediaInstanceMutationResponse>;
  /** update single row of the table: "argo.media_instance" */
  update_argo_media_instance_by_pk?: Maybe<ArgoMediaInstance>;
  /** update multiples rows of table: "argo.media_instance" */
  update_argo_media_instance_many?: Maybe<Array<Maybe<ArgoMediaInstanceMutationResponse>>>;
  /** update data of the table: "argo.role" */
  update_argo_role?: Maybe<ArgoRoleMutationResponse>;
  /** update data of the table: "argo.role_acl" */
  update_argo_role_acl?: Maybe<ArgoRoleAclMutationResponse>;
  /** update single row of the table: "argo.role_acl" */
  update_argo_role_acl_by_pk?: Maybe<ArgoRoleAcl>;
  /** update multiples rows of table: "argo.role_acl" */
  update_argo_role_acl_many?: Maybe<Array<Maybe<ArgoRoleAclMutationResponse>>>;
  /** update single row of the table: "argo.role" */
  update_argo_role_by_pk?: Maybe<ArgoRole>;
  /** update multiples rows of table: "argo.role" */
  update_argo_role_many?: Maybe<Array<Maybe<ArgoRoleMutationResponse>>>;
  /** update data of the table: "argo.schedule" */
  update_argo_schedule?: Maybe<ArgoScheduleMutationResponse>;
  /** update single row of the table: "argo.schedule" */
  update_argo_schedule_by_pk?: Maybe<ArgoSchedule>;
  /** update data of the table: "argo.schedule_day" */
  update_argo_schedule_day?: Maybe<ArgoScheduleDayMutationResponse>;
  /** update single row of the table: "argo.schedule_day" */
  update_argo_schedule_day_by_pk?: Maybe<ArgoScheduleDay>;
  /** update multiples rows of table: "argo.schedule_day" */
  update_argo_schedule_day_many?: Maybe<Array<Maybe<ArgoScheduleDayMutationResponse>>>;
  /** update data of the table: "argo.schedule_event" */
  update_argo_schedule_event?: Maybe<ArgoScheduleEventMutationResponse>;
  /** update single row of the table: "argo.schedule_event" */
  update_argo_schedule_event_by_pk?: Maybe<ArgoScheduleEvent>;
  /** update multiples rows of table: "argo.schedule_event" */
  update_argo_schedule_event_many?: Maybe<Array<Maybe<ArgoScheduleEventMutationResponse>>>;
  /** update multiples rows of table: "argo.schedule" */
  update_argo_schedule_many?: Maybe<Array<Maybe<ArgoScheduleMutationResponse>>>;
  /** update data of the table: "argo.schedule_mode" */
  update_argo_schedule_mode?: Maybe<ArgoScheduleModeMutationResponse>;
  /** update single row of the table: "argo.schedule_mode" */
  update_argo_schedule_mode_by_pk?: Maybe<ArgoScheduleMode>;
  /** update multiples rows of table: "argo.schedule_mode" */
  update_argo_schedule_mode_many?: Maybe<Array<Maybe<ArgoScheduleModeMutationResponse>>>;
  /** update data of the table: "argo.sn" */
  update_argo_sn?: Maybe<ArgoSnMutationResponse>;
  /** update single row of the table: "argo.sn" */
  update_argo_sn_by_pk?: Maybe<ArgoSn>;
  /** update data of the table: "argo.sn_format" */
  update_argo_sn_format?: Maybe<ArgoSnFormatMutationResponse>;
  /** update single row of the table: "argo.sn_format" */
  update_argo_sn_format_by_pk?: Maybe<ArgoSnFormat>;
  /** update multiples rows of table: "argo.sn_format" */
  update_argo_sn_format_many?: Maybe<Array<Maybe<ArgoSnFormatMutationResponse>>>;
  /** update data of the table: "argo.sn_format_status" */
  update_argo_sn_format_status?: Maybe<ArgoSnFormatStatusMutationResponse>;
  /** update single row of the table: "argo.sn_format_status" */
  update_argo_sn_format_status_by_pk?: Maybe<ArgoSnFormatStatus>;
  /** update multiples rows of table: "argo.sn_format_status" */
  update_argo_sn_format_status_many?: Maybe<Array<Maybe<ArgoSnFormatStatusMutationResponse>>>;
  /** update data of the table: "argo.sn_format_uniqueness" */
  update_argo_sn_format_uniqueness?: Maybe<ArgoSnFormatUniquenessMutationResponse>;
  /** update single row of the table: "argo.sn_format_uniqueness" */
  update_argo_sn_format_uniqueness_by_pk?: Maybe<ArgoSnFormatUniqueness>;
  /** update multiples rows of table: "argo.sn_format_uniqueness" */
  update_argo_sn_format_uniqueness_many?: Maybe<Array<Maybe<ArgoSnFormatUniquenessMutationResponse>>>;
  /** update multiples rows of table: "argo.sn" */
  update_argo_sn_many?: Maybe<Array<Maybe<ArgoSnMutationResponse>>>;
  /** update data of the table: "argo.udf_column" */
  update_argo_udf_column?: Maybe<ArgoUdfColumnMutationResponse>;
  /** update single row of the table: "argo.udf_column" */
  update_argo_udf_column_by_pk?: Maybe<ArgoUdfColumn>;
  /** update data of the table: "argo.udf_column_data_type" */
  update_argo_udf_column_data_type?: Maybe<ArgoUdfColumnDataTypeMutationResponse>;
  /** update single row of the table: "argo.udf_column_data_type" */
  update_argo_udf_column_data_type_by_pk?: Maybe<ArgoUdfColumnDataType>;
  /** update multiples rows of table: "argo.udf_column_data_type" */
  update_argo_udf_column_data_type_many?: Maybe<Array<Maybe<ArgoUdfColumnDataTypeMutationResponse>>>;
  /** update multiples rows of table: "argo.udf_column" */
  update_argo_udf_column_many?: Maybe<Array<Maybe<ArgoUdfColumnMutationResponse>>>;
  /** update data of the table: "argo.udf_column_type" */
  update_argo_udf_column_type?: Maybe<ArgoUdfColumnTypeMutationResponse>;
  /** update single row of the table: "argo.udf_column_type" */
  update_argo_udf_column_type_by_pk?: Maybe<ArgoUdfColumnType>;
  /** update multiples rows of table: "argo.udf_column_type" */
  update_argo_udf_column_type_many?: Maybe<Array<Maybe<ArgoUdfColumnTypeMutationResponse>>>;
  /** update data of the table: "argo.uom" */
  update_argo_uom?: Maybe<ArgoUomMutationResponse>;
  /** update single row of the table: "argo.uom" */
  update_argo_uom_by_pk?: Maybe<ArgoUom>;
  /** update multiples rows of table: "argo.uom" */
  update_argo_uom_many?: Maybe<Array<Maybe<ArgoUomMutationResponse>>>;
  /** update data of the table: "argo.user" */
  update_argo_user?: Maybe<ArgoUserMutationResponse>;
  /** update data of the table: "argo.user_access_token" */
  update_argo_user_access_token?: Maybe<ArgoUserAccessTokenMutationResponse>;
  /** update single row of the table: "argo.user_access_token" */
  update_argo_user_access_token_by_pk?: Maybe<ArgoUserAccessToken>;
  /** update multiples rows of table: "argo.user_access_token" */
  update_argo_user_access_token_many?: Maybe<Array<Maybe<ArgoUserAccessTokenMutationResponse>>>;
  /** update data of the table: "argo.user_badge" */
  update_argo_user_badge?: Maybe<ArgoUserBadgeMutationResponse>;
  /** update single row of the table: "argo.user_badge" */
  update_argo_user_badge_by_pk?: Maybe<ArgoUserBadge>;
  /** update multiples rows of table: "argo.user_badge" */
  update_argo_user_badge_many?: Maybe<Array<Maybe<ArgoUserBadgeMutationResponse>>>;
  /** update single row of the table: "argo.user" */
  update_argo_user_by_pk?: Maybe<ArgoUser>;
  /** update data of the table: "argo.user_context" */
  update_argo_user_context?: Maybe<ArgoUserContextMutationResponse>;
  /** update single row of the table: "argo.user_context" */
  update_argo_user_context_by_pk?: Maybe<ArgoUserContext>;
  /** update multiples rows of table: "argo.user_context" */
  update_argo_user_context_many?: Maybe<Array<Maybe<ArgoUserContextMutationResponse>>>;
  /** update multiples rows of table: "argo.user" */
  update_argo_user_many?: Maybe<Array<Maybe<ArgoUserMutationResponse>>>;
  /** update data of the table: "argo.user_role" */
  update_argo_user_role?: Maybe<ArgoUserRoleMutationResponse>;
  /** update single row of the table: "argo.user_role" */
  update_argo_user_role_by_pk?: Maybe<ArgoUserRole>;
  /** update multiples rows of table: "argo.user_role" */
  update_argo_user_role_many?: Maybe<Array<Maybe<ArgoUserRoleMutationResponse>>>;
  /** update data of the table: "argo.vw_user_acls" */
  update_argo_vw_user_acls?: Maybe<ArgoVwUserAclsMutationResponse>;
  /** update multiples rows of table: "argo.vw_user_acls" */
  update_argo_vw_user_acls_many?: Maybe<Array<Maybe<ArgoVwUserAclsMutationResponse>>>;
  /** update data of the table: "argo.work_instruction" */
  update_argo_work_instruction?: Maybe<ArgoWorkInstructionMutationResponse>;
  /** update single row of the table: "argo.work_instruction" */
  update_argo_work_instruction_by_pk?: Maybe<ArgoWorkInstruction>;
  /** update data of the table: "argo.work_instruction_instance" */
  update_argo_work_instruction_instance?: Maybe<ArgoWorkInstructionInstanceMutationResponse>;
  /** update single row of the table: "argo.work_instruction_instance" */
  update_argo_work_instruction_instance_by_pk?: Maybe<ArgoWorkInstructionInstance>;
  /** update multiples rows of table: "argo.work_instruction_instance" */
  update_argo_work_instruction_instance_many?: Maybe<Array<Maybe<ArgoWorkInstructionInstanceMutationResponse>>>;
  /** update data of the table: "argo.work_instruction_instance_status" */
  update_argo_work_instruction_instance_status?: Maybe<ArgoWorkInstructionInstanceStatusMutationResponse>;
  /** update single row of the table: "argo.work_instruction_instance_status" */
  update_argo_work_instruction_instance_status_by_pk?: Maybe<ArgoWorkInstructionInstanceStatus>;
  /** update multiples rows of table: "argo.work_instruction_instance_status" */
  update_argo_work_instruction_instance_status_many?: Maybe<Array<Maybe<ArgoWorkInstructionInstanceStatusMutationResponse>>>;
  /** update data of the table: "argo.work_instruction_instance_step" */
  update_argo_work_instruction_instance_step?: Maybe<ArgoWorkInstructionInstanceStepMutationResponse>;
  /** update single row of the table: "argo.work_instruction_instance_step" */
  update_argo_work_instruction_instance_step_by_pk?: Maybe<ArgoWorkInstructionInstanceStep>;
  /** update multiples rows of table: "argo.work_instruction_instance_step" */
  update_argo_work_instruction_instance_step_many?: Maybe<Array<Maybe<ArgoWorkInstructionInstanceStepMutationResponse>>>;
  /** update multiples rows of table: "argo.work_instruction" */
  update_argo_work_instruction_many?: Maybe<Array<Maybe<ArgoWorkInstructionMutationResponse>>>;
  /** update data of the table: "argo.work_instruction_version" */
  update_argo_work_instruction_version?: Maybe<ArgoWorkInstructionVersionMutationResponse>;
  /** update single row of the table: "argo.work_instruction_version" */
  update_argo_work_instruction_version_by_pk?: Maybe<ArgoWorkInstructionVersion>;
  /** update multiples rows of table: "argo.work_instruction_version" */
  update_argo_work_instruction_version_many?: Maybe<Array<Maybe<ArgoWorkInstructionVersionMutationResponse>>>;
  /** update data of the table: "argo.work_instruction_version_status" */
  update_argo_work_instruction_version_status?: Maybe<ArgoWorkInstructionVersionStatusMutationResponse>;
  /** update single row of the table: "argo.work_instruction_version_status" */
  update_argo_work_instruction_version_status_by_pk?: Maybe<ArgoWorkInstructionVersionStatus>;
  /** update multiples rows of table: "argo.work_instruction_version_status" */
  update_argo_work_instruction_version_status_many?: Maybe<Array<Maybe<ArgoWorkInstructionVersionStatusMutationResponse>>>;
  /** update data of the table: "argo.work_order" */
  update_argo_work_order?: Maybe<ArgoWorkOrderMutationResponse>;
  /** update data of the table: "argo.work_order_activity" */
  update_argo_work_order_activity?: Maybe<ArgoWorkOrderActivityMutationResponse>;
  /** update single row of the table: "argo.work_order_activity" */
  update_argo_work_order_activity_by_pk?: Maybe<ArgoWorkOrderActivity>;
  /** update data of the table: "argo.work_order_activity_kind" */
  update_argo_work_order_activity_kind?: Maybe<ArgoWorkOrderActivityKindMutationResponse>;
  /** update single row of the table: "argo.work_order_activity_kind" */
  update_argo_work_order_activity_kind_by_pk?: Maybe<ArgoWorkOrderActivityKind>;
  /** update multiples rows of table: "argo.work_order_activity_kind" */
  update_argo_work_order_activity_kind_many?: Maybe<Array<Maybe<ArgoWorkOrderActivityKindMutationResponse>>>;
  /** update multiples rows of table: "argo.work_order_activity" */
  update_argo_work_order_activity_many?: Maybe<Array<Maybe<ArgoWorkOrderActivityMutationResponse>>>;
  /** update single row of the table: "argo.work_order" */
  update_argo_work_order_by_pk?: Maybe<ArgoWorkOrder>;
  /** update data of the table: "argo.work_order_location" */
  update_argo_work_order_location?: Maybe<ArgoWorkOrderLocationMutationResponse>;
  /** update single row of the table: "argo.work_order_location" */
  update_argo_work_order_location_by_pk?: Maybe<ArgoWorkOrderLocation>;
  /** update multiples rows of table: "argo.work_order_location" */
  update_argo_work_order_location_many?: Maybe<Array<Maybe<ArgoWorkOrderLocationMutationResponse>>>;
  /** update multiples rows of table: "argo.work_order" */
  update_argo_work_order_many?: Maybe<Array<Maybe<ArgoWorkOrderMutationResponse>>>;
  /** update data of the table: "argo.work_order_material" */
  update_argo_work_order_material?: Maybe<ArgoWorkOrderMaterialMutationResponse>;
  /** update single row of the table: "argo.work_order_material" */
  update_argo_work_order_material_by_pk?: Maybe<ArgoWorkOrderMaterial>;
  /** update multiples rows of table: "argo.work_order_material" */
  update_argo_work_order_material_many?: Maybe<Array<Maybe<ArgoWorkOrderMaterialMutationResponse>>>;
  /** update data of the table: "argo.work_order_restriction" */
  update_argo_work_order_restriction?: Maybe<ArgoWorkOrderRestrictionMutationResponse>;
  /** update single row of the table: "argo.work_order_restriction" */
  update_argo_work_order_restriction_by_pk?: Maybe<ArgoWorkOrderRestriction>;
  /** update multiples rows of table: "argo.work_order_restriction" */
  update_argo_work_order_restriction_many?: Maybe<Array<Maybe<ArgoWorkOrderRestrictionMutationResponse>>>;
  /** update data of the table: "argo.work_order_status" */
  update_argo_work_order_status?: Maybe<ArgoWorkOrderStatusMutationResponse>;
  /** update single row of the table: "argo.work_order_status" */
  update_argo_work_order_status_by_pk?: Maybe<ArgoWorkOrderStatus>;
  /** update multiples rows of table: "argo.work_order_status" */
  update_argo_work_order_status_many?: Maybe<Array<Maybe<ArgoWorkOrderStatusMutationResponse>>>;
  /** update data of the table: "fis.asset" */
  update_fis_asset?: Maybe<FisAssetMutationResponse>;
  /** update single row of the table: "fis.asset" */
  update_fis_asset_by_pk?: Maybe<FisAsset>;
  /** update data of the table: "fis.asset_code" */
  update_fis_asset_code?: Maybe<FisAssetCodeMutationResponse>;
  /** update single row of the table: "fis.asset_code" */
  update_fis_asset_code_by_pk?: Maybe<FisAssetCode>;
  /** update multiples rows of table: "fis.asset_code" */
  update_fis_asset_code_many?: Maybe<Array<Maybe<FisAssetCodeMutationResponse>>>;
  /** update multiples rows of table: "fis.asset" */
  update_fis_asset_many?: Maybe<Array<Maybe<FisAssetMutationResponse>>>;
  /** update data of the table: "fis.asset_tag" */
  update_fis_asset_tag?: Maybe<FisAssetTagMutationResponse>;
  /** update single row of the table: "fis.asset_tag" */
  update_fis_asset_tag_by_pk?: Maybe<FisAssetTag>;
  /** update data of the table: "fis.asset_tag_link" */
  update_fis_asset_tag_link?: Maybe<FisAssetTagLinkMutationResponse>;
  /** update single row of the table: "fis.asset_tag_link" */
  update_fis_asset_tag_link_by_pk?: Maybe<FisAssetTagLink>;
  /** update multiples rows of table: "fis.asset_tag_link" */
  update_fis_asset_tag_link_many?: Maybe<Array<Maybe<FisAssetTagLinkMutationResponse>>>;
  /** update multiples rows of table: "fis.asset_tag" */
  update_fis_asset_tag_many?: Maybe<Array<Maybe<FisAssetTagMutationResponse>>>;
  /** update data of the table: "fis.asset_type" */
  update_fis_asset_type?: Maybe<FisAssetTypeMutationResponse>;
  /** update single row of the table: "fis.asset_type" */
  update_fis_asset_type_by_pk?: Maybe<FisAssetType>;
  /** update multiples rows of table: "fis.asset_type" */
  update_fis_asset_type_many?: Maybe<Array<Maybe<FisAssetTypeMutationResponse>>>;
  /** update data of the table: "fis.core_state" */
  update_fis_core_state?: Maybe<FisCoreStateMutationResponse>;
  /** update single row of the table: "fis.core_state" */
  update_fis_core_state_by_pk?: Maybe<FisCoreState>;
  /** update multiples rows of table: "fis.core_state" */
  update_fis_core_state_many?: Maybe<Array<Maybe<FisCoreStateMutationResponse>>>;
  /** update data of the table: "fis.data" */
  update_fis_data?: Maybe<FisDataMutationResponse>;
  /** update single row of the table: "fis.data" */
  update_fis_data_by_pk?: Maybe<FisData>;
  /** update data of the table: "fis.data_label" */
  update_fis_data_label?: Maybe<FisDataLabelMutationResponse>;
  /** update single row of the table: "fis.data_label" */
  update_fis_data_label_by_pk?: Maybe<FisDataLabel>;
  /** update multiples rows of table: "fis.data_label" */
  update_fis_data_label_many?: Maybe<Array<Maybe<FisDataLabelMutationResponse>>>;
  /** update multiples rows of table: "fis.data" */
  update_fis_data_many?: Maybe<Array<Maybe<FisDataMutationResponse>>>;
  /** update data of the table: "fis.data_timing" */
  update_fis_data_timing?: Maybe<FisDataTimingMutationResponse>;
  /** update single row of the table: "fis.data_timing" */
  update_fis_data_timing_by_pk?: Maybe<FisDataTiming>;
  /** update multiples rows of table: "fis.data_timing" */
  update_fis_data_timing_many?: Maybe<Array<Maybe<FisDataTimingMutationResponse>>>;
  /** update data of the table: "fis.data_track_count" */
  update_fis_data_track_count?: Maybe<FisDataTrackCountMutationResponse>;
  /** update single row of the table: "fis.data_track_count" */
  update_fis_data_track_count_by_pk?: Maybe<FisDataTrackCount>;
  /** update multiples rows of table: "fis.data_track_count" */
  update_fis_data_track_count_many?: Maybe<Array<Maybe<FisDataTrackCountMutationResponse>>>;
  /** update data of the table: "fis.data_track_duration" */
  update_fis_data_track_duration?: Maybe<FisDataTrackDurationMutationResponse>;
  /** update single row of the table: "fis.data_track_duration" */
  update_fis_data_track_duration_by_pk?: Maybe<FisDataTrackDuration>;
  /** update multiples rows of table: "fis.data_track_duration" */
  update_fis_data_track_duration_many?: Maybe<Array<Maybe<FisDataTrackDurationMutationResponse>>>;
  /** update data of the table: "fis.data_track_scalar" */
  update_fis_data_track_scalar?: Maybe<FisDataTrackScalarMutationResponse>;
  /** update single row of the table: "fis.data_track_scalar" */
  update_fis_data_track_scalar_by_pk?: Maybe<FisDataTrackScalar>;
  /** update multiples rows of table: "fis.data_track_scalar" */
  update_fis_data_track_scalar_many?: Maybe<Array<Maybe<FisDataTrackScalarMutationResponse>>>;
  /** update data of the table: "fis.data_type" */
  update_fis_data_type?: Maybe<FisDataTypeMutationResponse>;
  /** update single row of the table: "fis.data_type" */
  update_fis_data_type_by_pk?: Maybe<FisDataType>;
  /** update multiples rows of table: "fis.data_type" */
  update_fis_data_type_many?: Maybe<Array<Maybe<FisDataTypeMutationResponse>>>;
  /** update data of the table: "process.collection" */
  update_process_collection?: Maybe<ProcessCollectionMutationResponse>;
  /** update single row of the table: "process.collection" */
  update_process_collection_by_pk?: Maybe<ProcessCollection>;
  /** update data of the table: "process.collection_data" */
  update_process_collection_data?: Maybe<ProcessCollectionDataMutationResponse>;
  /** update single row of the table: "process.collection_data" */
  update_process_collection_data_by_pk?: Maybe<ProcessCollectionData>;
  /** update multiples rows of table: "process.collection_data" */
  update_process_collection_data_many?: Maybe<Array<Maybe<ProcessCollectionDataMutationResponse>>>;
  /** update data of the table: "process.collection_kind" */
  update_process_collection_kind?: Maybe<ProcessCollectionKindMutationResponse>;
  /** update single row of the table: "process.collection_kind" */
  update_process_collection_kind_by_pk?: Maybe<ProcessCollectionKind>;
  /** update multiples rows of table: "process.collection_kind" */
  update_process_collection_kind_many?: Maybe<Array<Maybe<ProcessCollectionKindMutationResponse>>>;
  /** update multiples rows of table: "process.collection" */
  update_process_collection_many?: Maybe<Array<Maybe<ProcessCollectionMutationResponse>>>;
  /** update data of the table: "process.data_element" */
  update_process_data_element?: Maybe<ProcessDataElementMutationResponse>;
  /** update single row of the table: "process.data_element" */
  update_process_data_element_by_pk?: Maybe<ProcessDataElement>;
  /** update data of the table: "process.data_element_collection_kind" */
  update_process_data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindMutationResponse>;
  /** update single row of the table: "process.data_element_collection_kind" */
  update_process_data_element_collection_kind_by_pk?: Maybe<ProcessDataElementCollectionKind>;
  /** update multiples rows of table: "process.data_element_collection_kind" */
  update_process_data_element_collection_kind_many?: Maybe<Array<Maybe<ProcessDataElementCollectionKindMutationResponse>>>;
  /** update data of the table: "process.data_element_kind" */
  update_process_data_element_kind?: Maybe<ProcessDataElementKindMutationResponse>;
  /** update single row of the table: "process.data_element_kind" */
  update_process_data_element_kind_by_pk?: Maybe<ProcessDataElementKind>;
  /** update multiples rows of table: "process.data_element_kind" */
  update_process_data_element_kind_many?: Maybe<Array<Maybe<ProcessDataElementKindMutationResponse>>>;
  /** update multiples rows of table: "process.data_element" */
  update_process_data_element_many?: Maybe<Array<Maybe<ProcessDataElementMutationResponse>>>;
  /** update data of the table: "process.material_state" */
  update_process_material_state?: Maybe<ProcessMaterialStateMutationResponse>;
  /** update single row of the table: "process.material_state" */
  update_process_material_state_by_pk?: Maybe<ProcessMaterialState>;
  /** update data of the table: "process.material_state_history" */
  update_process_material_state_history?: Maybe<ProcessMaterialStateHistoryMutationResponse>;
  /** update single row of the table: "process.material_state_history" */
  update_process_material_state_history_by_pk?: Maybe<ProcessMaterialStateHistory>;
  /** update multiples rows of table: "process.material_state_history" */
  update_process_material_state_history_many?: Maybe<Array<Maybe<ProcessMaterialStateHistoryMutationResponse>>>;
  /** update multiples rows of table: "process.material_state" */
  update_process_material_state_many?: Maybe<Array<Maybe<ProcessMaterialStateMutationResponse>>>;
  /** update data of the table: "process.process" */
  update_process_process?: Maybe<ProcessProcessMutationResponse>;
  /** update single row of the table: "process.process" */
  update_process_process_by_pk?: Maybe<ProcessProcess>;
  /** update multiples rows of table: "process.process" */
  update_process_process_many?: Maybe<Array<Maybe<ProcessProcessMutationResponse>>>;
  /** update data of the table: "process.process_status" */
  update_process_process_status?: Maybe<ProcessProcessStatusMutationResponse>;
  /** update single row of the table: "process.process_status" */
  update_process_process_status_by_pk?: Maybe<ProcessProcessStatus>;
  /** update multiples rows of table: "process.process_status" */
  update_process_process_status_many?: Maybe<Array<Maybe<ProcessProcessStatusMutationResponse>>>;
  /** update data of the table: "process.spec" */
  update_process_spec?: Maybe<ProcessSpecMutationResponse>;
  /** update single row of the table: "process.spec" */
  update_process_spec_by_pk?: Maybe<ProcessSpec>;
  /** update multiples rows of table: "process.spec" */
  update_process_spec_many?: Maybe<Array<Maybe<ProcessSpecMutationResponse>>>;
  /** update data of the table: "process.spec_order" */
  update_process_spec_order?: Maybe<ProcessSpecOrderMutationResponse>;
  /** update single row of the table: "process.spec_order" */
  update_process_spec_order_by_pk?: Maybe<ProcessSpecOrder>;
  /** update multiples rows of table: "process.spec_order" */
  update_process_spec_order_many?: Maybe<Array<Maybe<ProcessSpecOrderMutationResponse>>>;
};


/** mutation root */
export type MutationRootArgoCreateMaterialArgs = {
  args: ArgoCreateMaterialArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoCreateMaterialsArgs = {
  args: ArgoCreateMaterialsArgs;
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


/** mutation root */
export type MutationRootArgoCreateWorkInstructionInstanceArgs = {
  args: ArgoCreateWorkInstructionInstanceArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoHasuraCronArgs = {
  args?: Maybe<ArgoHasuraCronArgs>;
  distinct_on?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCronTaskOrderBy>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


/** mutation root */
export type MutationRootArgoMarryMaterialArgs = {
  args: ArgoMarryMaterialArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoSnFormatDatetimeTokenArgs = {
  args: ArgoSnFormatDatetimeTokenArgs;
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoSnGenerateArgs = {
  args: ArgoSnGenerateArgs;
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoSnGenerateAlignContentArgs = {
  args: ArgoSnGenerateAlignContentArgs;
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoSnGenerateSequenceArgs = {
  args: ArgoSnGenerateSequenceArgs;
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


/** mutation root */
export type MutationRootArgoWorkOrderSetStatusArgs = {
  args: ArgoWorkOrderSetStatusArgs;
  distinct_on?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderOrderBy>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


/** mutation root */
export type MutationRootDeleteAppletDeploymentArgs = {
  where: AppletDeploymentBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletDeploymentByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteAppletDeploymentLinkedDesignVersionArgs = {
  where: AppletDeploymentLinkedDesignVersionBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletDeploymentLinkedDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteAppletDesignArgs = {
  where: AppletDesignBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletDesignByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteAppletDesignVersionArgs = {
  where: AppletDesignVersionBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteAppletDesignVersionStatusArgs = {
  where: AppletDesignVersionStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletDesignVersionStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAppletRegistrationCodeArgs = {
  where: AppletRegistrationCodeBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletRegistrationCodeByPkArgs = {
  context_id: Scalars['uuid'];
  created_by_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteAppletRunnerArgs = {
  where: AppletRunnerBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletRunnerByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAppletRunnerContextArgs = {
  where: AppletRunnerContextBoolExp;
};


/** mutation root */
export type MutationRootDeleteAppletRunnerContextByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAclArgs = {
  where: ArgoAclBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAclByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeArgs = {
  where: ArgoAttributeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeDataArgs = {
  where: ArgoAttributeDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeDataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeHistoryStatusTypeArgs = {
  where: ArgoAttributeHistoryStatusTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeHistoryStatusTypeByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaArgs = {
  where: ArgoAttributeSchemaBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaDefinitionArgs = {
  where: ArgoAttributeSchemaDefinitionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaDefinitionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaDefinitionTypeArgs = {
  where: ArgoAttributeSchemaDefinitionTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaDefinitionTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaTypeArgs = {
  where: ArgoAttributeSchemaTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAttributeSchemaTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoAuditArgs = {
  where: ArgoAuditBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuditByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderArgs = {
  where: ArgoAuthProviderBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderLocalArgs = {
  where: ArgoAuthProviderLocalBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderLocalByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderLocalSettingArgs = {
  where: ArgoAuthProviderLocalSettingBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderLocalSettingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderMsalArgs = {
  where: ArgoAuthProviderMsalBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderMsalByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderMsalSettingArgs = {
  where: ArgoAuthProviderMsalSettingBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderMsalSettingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderRecordArgs = {
  where: ArgoAuthProviderRecordBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthProviderRecordByPkArgs = {
  auth_provider_record_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoAuthRefreshTokenArgs = {
  where: ArgoAuthRefreshTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoAuthRefreshTokenByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarArgs = {
  where: ArgoCalendarBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventArgs = {
  where: ArgoCalendarEventBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventSequenceArgs = {
  where: ArgoCalendarEventSequenceBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfDataArgs = {
  where: ArgoCalendarEventUdfDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfDefaultDataArgs = {
  where: ArgoCalendarEventUdfDefaultDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfSchemaArgs = {
  where: ArgoCalendarEventUdfSchemaBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarEventUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCalendarLocationArgs = {
  where: ArgoCalendarLocationBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCalendarLocationByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoConnectionArgs = {
  where: ArgoConnectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoConnectionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoConnectionConfigArgs = {
  where: ArgoConnectionConfigBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoConnectionConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoConnectionConfigStatusArgs = {
  where: ArgoConnectionConfigStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoConnectionConfigStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoConnectionKindArgs = {
  where: ArgoConnectionKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoConnectionKindByPkArgs = {
  kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoContextArgs = {
  where: ArgoContextBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoContextByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoCronTaskArgs = {
  where: ArgoCronTaskBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoCronTaskByPkArgs = {
  cron_name: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoEventArgs = {
  where: ArgoEventBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoEventByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoEventTypeArgs = {
  where: ArgoEventTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoEventTypeByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteArgoHasuraPermissionArgs = {
  where: ArgoHasuraPermissionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoHasuraPermissionByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoLinkArgs = {
  where: ArgoLinkBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLinkByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoLocationArgs = {
  where: ArgoLocationBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLocationAttributeArgs = {
  where: ArgoLocationAttributeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLocationAttributeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoLocationAttributeHistoryArgs = {
  where: ArgoLocationAttributeHistoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLocationAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoLocationByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoLocationClassArgs = {
  where: ArgoLocationClassBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLocationClassByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoLogArgs = {
  where: ArgoLogBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLogByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteArgoLogCategoryArgs = {
  where: ArgoLogCategoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLogCategoryByPkArgs = {
  category: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoLogDurationArgs = {
  where: ArgoLogDurationBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLogLevelArgs = {
  where: ArgoLogLevelBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoLogLevelByPkArgs = {
  level: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialArgs = {
  where: ArgoMaterialBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialActivityArgs = {
  where: ArgoMaterialActivityBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialActivityByPkArgs = {
  material_activity_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialActivityKindArgs = {
  where: ArgoMaterialActivityKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialActivityKindByPkArgs = {
  kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialAssemblyArgs = {
  where: ArgoMaterialAssemblyBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialAttributeArgs = {
  where: ArgoMaterialAttributeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialAttributeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialAttributeHistoryArgs = {
  where: ArgoMaterialAttributeHistoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassArgs = {
  where: ArgoMaterialClassBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassAttributeArgs = {
  where: ArgoMaterialClassAttributeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassAttributeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassAttributeSettingArgs = {
  where: ArgoMaterialClassAttributeSettingBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassProcessArgs = {
  where: ArgoMaterialClassProcessBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialClassProcessByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialMarriageArgs = {
  where: ArgoMaterialMarriageBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialMarriageByPkArgs = {
  material_marriage_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialMarriageStatusArgs = {
  where: ArgoMaterialMarriageStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialMarriageStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelArgs = {
  where: ArgoMaterialModelBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelAttributeArgs = {
  where: ArgoMaterialModelAttributeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelAttributeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelAttributeSettingArgs = {
  where: ArgoMaterialModelAttributeSettingBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelProcessArgs = {
  where: ArgoMaterialModelProcessBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialModelProcessByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialQuantityKindArgs = {
  where: ArgoMaterialQuantityKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialQuantityKindByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialStatusArgs = {
  where: ArgoMaterialStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfDataArgs = {
  where: ArgoMaterialUdfDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfDefaultDataArgs = {
  where: ArgoMaterialUdfDefaultDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfSchemaArgs = {
  where: ArgoMaterialUdfSchemaBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMaterialUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMediaConfigArgs = {
  where: ArgoMediaConfigBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMediaConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoMediaInstanceArgs = {
  where: ArgoMediaInstanceBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoMediaInstanceByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoRoleArgs = {
  where: ArgoRoleBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoRoleAclArgs = {
  where: ArgoRoleAclBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoRoleAclByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoRoleByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoScheduleArgs = {
  where: ArgoScheduleBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoScheduleByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoScheduleDayArgs = {
  where: ArgoScheduleDayBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoScheduleDayByPkArgs = {
  day: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoScheduleEventArgs = {
  where: ArgoScheduleEventBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoScheduleEventByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoScheduleModeArgs = {
  where: ArgoScheduleModeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoScheduleModeByPkArgs = {
  mode: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoSnArgs = {
  where: ArgoSnBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoSnByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatArgs = {
  where: ArgoSnFormatBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatStatusArgs = {
  where: ArgoSnFormatStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatUniquenessArgs = {
  where: ArgoSnFormatUniquenessBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoSnFormatUniquenessByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnArgs = {
  where: ArgoUdfColumnBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnDataTypeArgs = {
  where: ArgoUdfColumnDataTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnDataTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnTypeArgs = {
  where: ArgoUdfColumnTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUdfColumnTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoUomArgs = {
  where: ArgoUomBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUomByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteArgoUserArgs = {
  where: ArgoUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUserAccessTokenArgs = {
  where: ArgoUserAccessTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUserAccessTokenByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoUserBadgeArgs = {
  where: ArgoUserBadgeBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUserBadgeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoUserByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoUserContextArgs = {
  where: ArgoUserContextBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUserContextByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoUserRoleArgs = {
  where: ArgoUserRoleBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoUserRoleByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoVwUserAclsArgs = {
  where: ArgoVwUserAclsBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionArgs = {
  where: ArgoWorkInstructionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceArgs = {
  where: ArgoWorkInstructionInstanceBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceStatusArgs = {
  where: ArgoWorkInstructionInstanceStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceStepArgs = {
  where: ArgoWorkInstructionInstanceStepBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionInstanceStepByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionVersionArgs = {
  where: ArgoWorkInstructionVersionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionVersionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionVersionStatusArgs = {
  where: ArgoWorkInstructionVersionStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkInstructionVersionStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderArgs = {
  where: ArgoWorkOrderBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderActivityArgs = {
  where: ArgoWorkOrderActivityBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderActivityByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderActivityKindArgs = {
  where: ArgoWorkOrderActivityKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderActivityKindByPkArgs = {
  kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderLocationArgs = {
  where: ArgoWorkOrderLocationBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderLocationByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderMaterialArgs = {
  where: ArgoWorkOrderMaterialBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderMaterialByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderRestrictionArgs = {
  where: ArgoWorkOrderRestrictionBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderRestrictionByPkArgs = {
  restriction: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderStatusArgs = {
  where: ArgoWorkOrderStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteArgoWorkOrderStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteFisAssetArgs = {
  where: FisAssetBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisAssetByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisAssetCodeArgs = {
  where: FisAssetCodeBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisAssetCodeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisAssetTagArgs = {
  where: FisAssetTagBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisAssetTagByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisAssetTagLinkArgs = {
  where: FisAssetTagLinkBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisAssetTagLinkByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisAssetTypeArgs = {
  where: FisAssetTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisAssetTypeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisCoreStateArgs = {
  where: FisCoreStateBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisCoreStateByPkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteFisDataArgs = {
  where: FisDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataByPkArgs = {
  data_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


/** mutation root */
export type MutationRootDeleteFisDataLabelArgs = {
  where: FisDataLabelBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataLabelByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteFisDataTimingArgs = {
  where: FisDataTimingBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataTimingByPkArgs = {
  timing: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteFisDataTrackCountArgs = {
  where: FisDataTrackCountBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataTrackCountByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


/** mutation root */
export type MutationRootDeleteFisDataTrackDurationArgs = {
  where: FisDataTrackDurationBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataTrackDurationByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  num_val: Scalars['float8'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


/** mutation root */
export type MutationRootDeleteFisDataTrackScalarArgs = {
  where: FisDataTrackScalarBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataTrackScalarByPkArgs = {
  asset_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


/** mutation root */
export type MutationRootDeleteFisDataTypeArgs = {
  where: FisDataTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteFisDataTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProcessCollectionArgs = {
  where: ProcessCollectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessCollectionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessCollectionDataArgs = {
  where: ProcessCollectionDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessCollectionDataByPkArgs = {
  collection_id: Scalars['uuid'];
  data_element_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessCollectionKindArgs = {
  where: ProcessCollectionKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessCollectionKindByPkArgs = {
  kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProcessDataElementArgs = {
  where: ProcessDataElementBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessDataElementByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessDataElementCollectionKindArgs = {
  where: ProcessDataElementCollectionKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessDataElementCollectionKindByPkArgs = {
  collection_kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProcessDataElementKindArgs = {
  where: ProcessDataElementKindBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessDataElementKindByPkArgs = {
  kind: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProcessMaterialStateArgs = {
  where: ProcessMaterialStateBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessMaterialStateByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessMaterialStateHistoryArgs = {
  where: ProcessMaterialStateHistoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessMaterialStateHistoryByPkArgs = {
  material_state_history_id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessProcessArgs = {
  where: ProcessProcessBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessProcessByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessProcessStatusArgs = {
  where: ProcessProcessStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessProcessStatusByPkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProcessSpecArgs = {
  where: ProcessSpecBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessSpecByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteProcessSpecOrderArgs = {
  where: ProcessSpecOrderBoolExp;
};


/** mutation root */
export type MutationRootDeleteProcessSpecOrderByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootInsertAppletDeploymentArgs = {
  objects: Array<AppletDeploymentInsertInput>;
  on_conflict?: Maybe<AppletDeploymentOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDeploymentLinkedDesignVersionArgs = {
  objects: Array<AppletDeploymentLinkedDesignVersionInsertInput>;
  on_conflict?: Maybe<AppletDeploymentLinkedDesignVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDeploymentLinkedDesignVersionOneArgs = {
  object: AppletDeploymentLinkedDesignVersionInsertInput;
  on_conflict?: Maybe<AppletDeploymentLinkedDesignVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDeploymentOneArgs = {
  object: AppletDeploymentInsertInput;
  on_conflict?: Maybe<AppletDeploymentOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignArgs = {
  objects: Array<AppletDesignInsertInput>;
  on_conflict?: Maybe<AppletDesignOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignOneArgs = {
  object: AppletDesignInsertInput;
  on_conflict?: Maybe<AppletDesignOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignVersionArgs = {
  objects: Array<AppletDesignVersionInsertInput>;
  on_conflict?: Maybe<AppletDesignVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignVersionOneArgs = {
  object: AppletDesignVersionInsertInput;
  on_conflict?: Maybe<AppletDesignVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignVersionStatusArgs = {
  objects: Array<AppletDesignVersionStatusInsertInput>;
  on_conflict?: Maybe<AppletDesignVersionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletDesignVersionStatusOneArgs = {
  object: AppletDesignVersionStatusInsertInput;
  on_conflict?: Maybe<AppletDesignVersionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRegistrationCodeArgs = {
  objects: Array<AppletRegistrationCodeInsertInput>;
  on_conflict?: Maybe<AppletRegistrationCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRegistrationCodeOneArgs = {
  object: AppletRegistrationCodeInsertInput;
  on_conflict?: Maybe<AppletRegistrationCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRunnerArgs = {
  objects: Array<AppletRunnerInsertInput>;
  on_conflict?: Maybe<AppletRunnerOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRunnerContextArgs = {
  objects: Array<AppletRunnerContextInsertInput>;
  on_conflict?: Maybe<AppletRunnerContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRunnerContextOneArgs = {
  object: AppletRunnerContextInsertInput;
  on_conflict?: Maybe<AppletRunnerContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertAppletRunnerOneArgs = {
  object: AppletRunnerInsertInput;
  on_conflict?: Maybe<AppletRunnerOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAclArgs = {
  objects: Array<ArgoAclInsertInput>;
  on_conflict?: Maybe<ArgoAclOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAclOneArgs = {
  object: ArgoAclInsertInput;
  on_conflict?: Maybe<ArgoAclOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeArgs = {
  objects: Array<ArgoAttributeInsertInput>;
  on_conflict?: Maybe<ArgoAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeDataArgs = {
  objects: Array<ArgoAttributeDataInsertInput>;
  on_conflict?: Maybe<ArgoAttributeDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeDataOneArgs = {
  object: ArgoAttributeDataInsertInput;
  on_conflict?: Maybe<ArgoAttributeDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeHistoryStatusTypeArgs = {
  objects: Array<ArgoAttributeHistoryStatusTypeInsertInput>;
  on_conflict?: Maybe<ArgoAttributeHistoryStatusTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeHistoryStatusTypeOneArgs = {
  object: ArgoAttributeHistoryStatusTypeInsertInput;
  on_conflict?: Maybe<ArgoAttributeHistoryStatusTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeOneArgs = {
  object: ArgoAttributeInsertInput;
  on_conflict?: Maybe<ArgoAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaArgs = {
  objects: Array<ArgoAttributeSchemaInsertInput>;
  on_conflict?: Maybe<ArgoAttributeSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaDefinitionArgs = {
  objects: Array<ArgoAttributeSchemaDefinitionInsertInput>;
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaDefinitionOneArgs = {
  object: ArgoAttributeSchemaDefinitionInsertInput;
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaDefinitionTypeArgs = {
  objects: Array<ArgoAttributeSchemaDefinitionTypeInsertInput>;
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaDefinitionTypeOneArgs = {
  object: ArgoAttributeSchemaDefinitionTypeInsertInput;
  on_conflict?: Maybe<ArgoAttributeSchemaDefinitionTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaOneArgs = {
  object: ArgoAttributeSchemaInsertInput;
  on_conflict?: Maybe<ArgoAttributeSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaTypeArgs = {
  objects: Array<ArgoAttributeSchemaTypeInsertInput>;
  on_conflict?: Maybe<ArgoAttributeSchemaTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAttributeSchemaTypeOneArgs = {
  object: ArgoAttributeSchemaTypeInsertInput;
  on_conflict?: Maybe<ArgoAttributeSchemaTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuditArgs = {
  objects: Array<ArgoAuditInsertInput>;
  on_conflict?: Maybe<ArgoAuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuditOneArgs = {
  object: ArgoAuditInsertInput;
  on_conflict?: Maybe<ArgoAuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderArgs = {
  objects: Array<ArgoAuthProviderInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderLocalArgs = {
  objects: Array<ArgoAuthProviderLocalInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderLocalOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderLocalOneArgs = {
  object: ArgoAuthProviderLocalInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderLocalOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderLocalSettingArgs = {
  objects: Array<ArgoAuthProviderLocalSettingInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderLocalSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderLocalSettingOneArgs = {
  object: ArgoAuthProviderLocalSettingInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderLocalSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderMsalArgs = {
  objects: Array<ArgoAuthProviderMsalInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderMsalOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderMsalOneArgs = {
  object: ArgoAuthProviderMsalInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderMsalOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderMsalSettingArgs = {
  objects: Array<ArgoAuthProviderMsalSettingInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderMsalSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderMsalSettingOneArgs = {
  object: ArgoAuthProviderMsalSettingInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderMsalSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderOneArgs = {
  object: ArgoAuthProviderInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderRecordArgs = {
  objects: Array<ArgoAuthProviderRecordInsertInput>;
  on_conflict?: Maybe<ArgoAuthProviderRecordOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthProviderRecordOneArgs = {
  object: ArgoAuthProviderRecordInsertInput;
  on_conflict?: Maybe<ArgoAuthProviderRecordOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthRefreshTokenArgs = {
  objects: Array<ArgoAuthRefreshTokenInsertInput>;
  on_conflict?: Maybe<ArgoAuthRefreshTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoAuthRefreshTokenOneArgs = {
  object: ArgoAuthRefreshTokenInsertInput;
  on_conflict?: Maybe<ArgoAuthRefreshTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarArgs = {
  objects: Array<ArgoCalendarInsertInput>;
  on_conflict?: Maybe<ArgoCalendarOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventArgs = {
  objects: Array<ArgoCalendarEventInsertInput>;
  on_conflict?: Maybe<ArgoCalendarEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventOneArgs = {
  object: ArgoCalendarEventInsertInput;
  on_conflict?: Maybe<ArgoCalendarEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventSequenceArgs = {
  objects: Array<ArgoCalendarEventSequenceInsertInput>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventSequenceOneArgs = {
  object: ArgoCalendarEventSequenceInsertInput;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfDataArgs = {
  objects: Array<ArgoCalendarEventUdfDataInsertInput>;
  on_conflict?: Maybe<ArgoCalendarEventUdfDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfDataOneArgs = {
  object: ArgoCalendarEventUdfDataInsertInput;
  on_conflict?: Maybe<ArgoCalendarEventUdfDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfDefaultDataArgs = {
  objects: Array<ArgoCalendarEventUdfDefaultDataInsertInput>;
  on_conflict?: Maybe<ArgoCalendarEventUdfDefaultDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfDefaultDataOneArgs = {
  object: ArgoCalendarEventUdfDefaultDataInsertInput;
  on_conflict?: Maybe<ArgoCalendarEventUdfDefaultDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfSchemaArgs = {
  objects: Array<ArgoCalendarEventUdfSchemaInsertInput>;
  on_conflict?: Maybe<ArgoCalendarEventUdfSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarEventUdfSchemaOneArgs = {
  object: ArgoCalendarEventUdfSchemaInsertInput;
  on_conflict?: Maybe<ArgoCalendarEventUdfSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarLocationArgs = {
  objects: Array<ArgoCalendarLocationInsertInput>;
  on_conflict?: Maybe<ArgoCalendarLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarLocationOneArgs = {
  object: ArgoCalendarLocationInsertInput;
  on_conflict?: Maybe<ArgoCalendarLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCalendarOneArgs = {
  object: ArgoCalendarInsertInput;
  on_conflict?: Maybe<ArgoCalendarOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionArgs = {
  objects: Array<ArgoConnectionInsertInput>;
  on_conflict?: Maybe<ArgoConnectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionConfigArgs = {
  objects: Array<ArgoConnectionConfigInsertInput>;
  on_conflict?: Maybe<ArgoConnectionConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionConfigOneArgs = {
  object: ArgoConnectionConfigInsertInput;
  on_conflict?: Maybe<ArgoConnectionConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionConfigStatusArgs = {
  objects: Array<ArgoConnectionConfigStatusInsertInput>;
  on_conflict?: Maybe<ArgoConnectionConfigStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionConfigStatusOneArgs = {
  object: ArgoConnectionConfigStatusInsertInput;
  on_conflict?: Maybe<ArgoConnectionConfigStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionKindArgs = {
  objects: Array<ArgoConnectionKindInsertInput>;
  on_conflict?: Maybe<ArgoConnectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionKindOneArgs = {
  object: ArgoConnectionKindInsertInput;
  on_conflict?: Maybe<ArgoConnectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoConnectionOneArgs = {
  object: ArgoConnectionInsertInput;
  on_conflict?: Maybe<ArgoConnectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoContextArgs = {
  objects: Array<ArgoContextInsertInput>;
  on_conflict?: Maybe<ArgoContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoContextOneArgs = {
  object: ArgoContextInsertInput;
  on_conflict?: Maybe<ArgoContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCronTaskArgs = {
  objects: Array<ArgoCronTaskInsertInput>;
  on_conflict?: Maybe<ArgoCronTaskOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoCronTaskOneArgs = {
  object: ArgoCronTaskInsertInput;
  on_conflict?: Maybe<ArgoCronTaskOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoEventArgs = {
  objects: Array<ArgoEventInsertInput>;
  on_conflict?: Maybe<ArgoEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoEventOneArgs = {
  object: ArgoEventInsertInput;
  on_conflict?: Maybe<ArgoEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoEventTypeArgs = {
  objects: Array<ArgoEventTypeInsertInput>;
  on_conflict?: Maybe<ArgoEventTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoEventTypeOneArgs = {
  object: ArgoEventTypeInsertInput;
  on_conflict?: Maybe<ArgoEventTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoHasuraPermissionArgs = {
  objects: Array<ArgoHasuraPermissionInsertInput>;
  on_conflict?: Maybe<ArgoHasuraPermissionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoHasuraPermissionOneArgs = {
  object: ArgoHasuraPermissionInsertInput;
  on_conflict?: Maybe<ArgoHasuraPermissionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLinkArgs = {
  objects: Array<ArgoLinkInsertInput>;
  on_conflict?: Maybe<ArgoLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLinkOneArgs = {
  object: ArgoLinkInsertInput;
  on_conflict?: Maybe<ArgoLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationArgs = {
  objects: Array<ArgoLocationInsertInput>;
  on_conflict?: Maybe<ArgoLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationAttributeArgs = {
  objects: Array<ArgoLocationAttributeInsertInput>;
  on_conflict?: Maybe<ArgoLocationAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationAttributeHistoryArgs = {
  objects: Array<ArgoLocationAttributeHistoryInsertInput>;
  on_conflict?: Maybe<ArgoLocationAttributeHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationAttributeHistoryOneArgs = {
  object: ArgoLocationAttributeHistoryInsertInput;
  on_conflict?: Maybe<ArgoLocationAttributeHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationAttributeOneArgs = {
  object: ArgoLocationAttributeInsertInput;
  on_conflict?: Maybe<ArgoLocationAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationClassArgs = {
  objects: Array<ArgoLocationClassInsertInput>;
  on_conflict?: Maybe<ArgoLocationClassOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationClassOneArgs = {
  object: ArgoLocationClassInsertInput;
  on_conflict?: Maybe<ArgoLocationClassOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLocationOneArgs = {
  object: ArgoLocationInsertInput;
  on_conflict?: Maybe<ArgoLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogArgs = {
  objects: Array<ArgoLogInsertInput>;
  on_conflict?: Maybe<ArgoLogOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogCategoryArgs = {
  objects: Array<ArgoLogCategoryInsertInput>;
  on_conflict?: Maybe<ArgoLogCategoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogCategoryOneArgs = {
  object: ArgoLogCategoryInsertInput;
  on_conflict?: Maybe<ArgoLogCategoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogDurationArgs = {
  objects: Array<ArgoLogDurationInsertInput>;
  on_conflict?: Maybe<ArgoLogDurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogDurationOneArgs = {
  object: ArgoLogDurationInsertInput;
  on_conflict?: Maybe<ArgoLogDurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogLevelArgs = {
  objects: Array<ArgoLogLevelInsertInput>;
  on_conflict?: Maybe<ArgoLogLevelOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogLevelOneArgs = {
  object: ArgoLogLevelInsertInput;
  on_conflict?: Maybe<ArgoLogLevelOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoLogOneArgs = {
  object: ArgoLogInsertInput;
  on_conflict?: Maybe<ArgoLogOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialArgs = {
  objects: Array<ArgoMaterialInsertInput>;
  on_conflict?: Maybe<ArgoMaterialOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialActivityArgs = {
  objects: Array<ArgoMaterialActivityInsertInput>;
  on_conflict?: Maybe<ArgoMaterialActivityOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialActivityKindArgs = {
  objects: Array<ArgoMaterialActivityKindInsertInput>;
  on_conflict?: Maybe<ArgoMaterialActivityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialActivityKindOneArgs = {
  object: ArgoMaterialActivityKindInsertInput;
  on_conflict?: Maybe<ArgoMaterialActivityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialActivityOneArgs = {
  object: ArgoMaterialActivityInsertInput;
  on_conflict?: Maybe<ArgoMaterialActivityOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAssemblyArgs = {
  objects: Array<ArgoMaterialAssemblyInsertInput>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAssemblyOneArgs = {
  object: ArgoMaterialAssemblyInsertInput;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAttributeArgs = {
  objects: Array<ArgoMaterialAttributeInsertInput>;
  on_conflict?: Maybe<ArgoMaterialAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAttributeHistoryArgs = {
  objects: Array<ArgoMaterialAttributeHistoryInsertInput>;
  on_conflict?: Maybe<ArgoMaterialAttributeHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAttributeHistoryOneArgs = {
  object: ArgoMaterialAttributeHistoryInsertInput;
  on_conflict?: Maybe<ArgoMaterialAttributeHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialAttributeOneArgs = {
  object: ArgoMaterialAttributeInsertInput;
  on_conflict?: Maybe<ArgoMaterialAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassArgs = {
  objects: Array<ArgoMaterialClassInsertInput>;
  on_conflict?: Maybe<ArgoMaterialClassOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassAttributeArgs = {
  objects: Array<ArgoMaterialClassAttributeInsertInput>;
  on_conflict?: Maybe<ArgoMaterialClassAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassAttributeOneArgs = {
  object: ArgoMaterialClassAttributeInsertInput;
  on_conflict?: Maybe<ArgoMaterialClassAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassAttributeSettingArgs = {
  objects: Array<ArgoMaterialClassAttributeSettingInsertInput>;
  on_conflict?: Maybe<ArgoMaterialClassAttributeSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassAttributeSettingOneArgs = {
  object: ArgoMaterialClassAttributeSettingInsertInput;
  on_conflict?: Maybe<ArgoMaterialClassAttributeSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassOneArgs = {
  object: ArgoMaterialClassInsertInput;
  on_conflict?: Maybe<ArgoMaterialClassOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassProcessArgs = {
  objects: Array<ArgoMaterialClassProcessInsertInput>;
  on_conflict?: Maybe<ArgoMaterialClassProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialClassProcessOneArgs = {
  object: ArgoMaterialClassProcessInsertInput;
  on_conflict?: Maybe<ArgoMaterialClassProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialMarriageArgs = {
  objects: Array<ArgoMaterialMarriageInsertInput>;
  on_conflict?: Maybe<ArgoMaterialMarriageOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialMarriageOneArgs = {
  object: ArgoMaterialMarriageInsertInput;
  on_conflict?: Maybe<ArgoMaterialMarriageOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialMarriageStatusArgs = {
  objects: Array<ArgoMaterialMarriageStatusInsertInput>;
  on_conflict?: Maybe<ArgoMaterialMarriageStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialMarriageStatusOneArgs = {
  object: ArgoMaterialMarriageStatusInsertInput;
  on_conflict?: Maybe<ArgoMaterialMarriageStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelArgs = {
  objects: Array<ArgoMaterialModelInsertInput>;
  on_conflict?: Maybe<ArgoMaterialModelOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelAttributeArgs = {
  objects: Array<ArgoMaterialModelAttributeInsertInput>;
  on_conflict?: Maybe<ArgoMaterialModelAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelAttributeOneArgs = {
  object: ArgoMaterialModelAttributeInsertInput;
  on_conflict?: Maybe<ArgoMaterialModelAttributeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelAttributeSettingArgs = {
  objects: Array<ArgoMaterialModelAttributeSettingInsertInput>;
  on_conflict?: Maybe<ArgoMaterialModelAttributeSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelAttributeSettingOneArgs = {
  object: ArgoMaterialModelAttributeSettingInsertInput;
  on_conflict?: Maybe<ArgoMaterialModelAttributeSettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelOneArgs = {
  object: ArgoMaterialModelInsertInput;
  on_conflict?: Maybe<ArgoMaterialModelOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelProcessArgs = {
  objects: Array<ArgoMaterialModelProcessInsertInput>;
  on_conflict?: Maybe<ArgoMaterialModelProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialModelProcessOneArgs = {
  object: ArgoMaterialModelProcessInsertInput;
  on_conflict?: Maybe<ArgoMaterialModelProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialOneArgs = {
  object: ArgoMaterialInsertInput;
  on_conflict?: Maybe<ArgoMaterialOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialQuantityKindArgs = {
  objects: Array<ArgoMaterialQuantityKindInsertInput>;
  on_conflict?: Maybe<ArgoMaterialQuantityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialQuantityKindOneArgs = {
  object: ArgoMaterialQuantityKindInsertInput;
  on_conflict?: Maybe<ArgoMaterialQuantityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialStatusArgs = {
  objects: Array<ArgoMaterialStatusInsertInput>;
  on_conflict?: Maybe<ArgoMaterialStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialStatusOneArgs = {
  object: ArgoMaterialStatusInsertInput;
  on_conflict?: Maybe<ArgoMaterialStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfDataArgs = {
  objects: Array<ArgoMaterialUdfDataInsertInput>;
  on_conflict?: Maybe<ArgoMaterialUdfDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfDataOneArgs = {
  object: ArgoMaterialUdfDataInsertInput;
  on_conflict?: Maybe<ArgoMaterialUdfDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfDefaultDataArgs = {
  objects: Array<ArgoMaterialUdfDefaultDataInsertInput>;
  on_conflict?: Maybe<ArgoMaterialUdfDefaultDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfDefaultDataOneArgs = {
  object: ArgoMaterialUdfDefaultDataInsertInput;
  on_conflict?: Maybe<ArgoMaterialUdfDefaultDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfSchemaArgs = {
  objects: Array<ArgoMaterialUdfSchemaInsertInput>;
  on_conflict?: Maybe<ArgoMaterialUdfSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMaterialUdfSchemaOneArgs = {
  object: ArgoMaterialUdfSchemaInsertInput;
  on_conflict?: Maybe<ArgoMaterialUdfSchemaOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMediaConfigArgs = {
  objects: Array<ArgoMediaConfigInsertInput>;
  on_conflict?: Maybe<ArgoMediaConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMediaConfigOneArgs = {
  object: ArgoMediaConfigInsertInput;
  on_conflict?: Maybe<ArgoMediaConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMediaInstanceArgs = {
  objects: Array<ArgoMediaInstanceInsertInput>;
  on_conflict?: Maybe<ArgoMediaInstanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoMediaInstanceOneArgs = {
  object: ArgoMediaInstanceInsertInput;
  on_conflict?: Maybe<ArgoMediaInstanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoRoleArgs = {
  objects: Array<ArgoRoleInsertInput>;
  on_conflict?: Maybe<ArgoRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoRoleAclArgs = {
  objects: Array<ArgoRoleAclInsertInput>;
  on_conflict?: Maybe<ArgoRoleAclOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoRoleAclOneArgs = {
  object: ArgoRoleAclInsertInput;
  on_conflict?: Maybe<ArgoRoleAclOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoRoleOneArgs = {
  object: ArgoRoleInsertInput;
  on_conflict?: Maybe<ArgoRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleArgs = {
  objects: Array<ArgoScheduleInsertInput>;
  on_conflict?: Maybe<ArgoScheduleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleDayArgs = {
  objects: Array<ArgoScheduleDayInsertInput>;
  on_conflict?: Maybe<ArgoScheduleDayOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleDayOneArgs = {
  object: ArgoScheduleDayInsertInput;
  on_conflict?: Maybe<ArgoScheduleDayOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleEventArgs = {
  objects: Array<ArgoScheduleEventInsertInput>;
  on_conflict?: Maybe<ArgoScheduleEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleEventOneArgs = {
  object: ArgoScheduleEventInsertInput;
  on_conflict?: Maybe<ArgoScheduleEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleModeArgs = {
  objects: Array<ArgoScheduleModeInsertInput>;
  on_conflict?: Maybe<ArgoScheduleModeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleModeOneArgs = {
  object: ArgoScheduleModeInsertInput;
  on_conflict?: Maybe<ArgoScheduleModeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoScheduleOneArgs = {
  object: ArgoScheduleInsertInput;
  on_conflict?: Maybe<ArgoScheduleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnArgs = {
  objects: Array<ArgoSnInsertInput>;
  on_conflict?: Maybe<ArgoSnOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatArgs = {
  objects: Array<ArgoSnFormatInsertInput>;
  on_conflict?: Maybe<ArgoSnFormatOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatOneArgs = {
  object: ArgoSnFormatInsertInput;
  on_conflict?: Maybe<ArgoSnFormatOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatStatusArgs = {
  objects: Array<ArgoSnFormatStatusInsertInput>;
  on_conflict?: Maybe<ArgoSnFormatStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatStatusOneArgs = {
  object: ArgoSnFormatStatusInsertInput;
  on_conflict?: Maybe<ArgoSnFormatStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatUniquenessArgs = {
  objects: Array<ArgoSnFormatUniquenessInsertInput>;
  on_conflict?: Maybe<ArgoSnFormatUniquenessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnFormatUniquenessOneArgs = {
  object: ArgoSnFormatUniquenessInsertInput;
  on_conflict?: Maybe<ArgoSnFormatUniquenessOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoSnOneArgs = {
  object: ArgoSnInsertInput;
  on_conflict?: Maybe<ArgoSnOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnArgs = {
  objects: Array<ArgoUdfColumnInsertInput>;
  on_conflict?: Maybe<ArgoUdfColumnOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnDataTypeArgs = {
  objects: Array<ArgoUdfColumnDataTypeInsertInput>;
  on_conflict?: Maybe<ArgoUdfColumnDataTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnDataTypeOneArgs = {
  object: ArgoUdfColumnDataTypeInsertInput;
  on_conflict?: Maybe<ArgoUdfColumnDataTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnOneArgs = {
  object: ArgoUdfColumnInsertInput;
  on_conflict?: Maybe<ArgoUdfColumnOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnTypeArgs = {
  objects: Array<ArgoUdfColumnTypeInsertInput>;
  on_conflict?: Maybe<ArgoUdfColumnTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUdfColumnTypeOneArgs = {
  object: ArgoUdfColumnTypeInsertInput;
  on_conflict?: Maybe<ArgoUdfColumnTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUomArgs = {
  objects: Array<ArgoUomInsertInput>;
  on_conflict?: Maybe<ArgoUomOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUomOneArgs = {
  object: ArgoUomInsertInput;
  on_conflict?: Maybe<ArgoUomOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserArgs = {
  objects: Array<ArgoUserInsertInput>;
  on_conflict?: Maybe<ArgoUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserAccessTokenArgs = {
  objects: Array<ArgoUserAccessTokenInsertInput>;
  on_conflict?: Maybe<ArgoUserAccessTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserAccessTokenOneArgs = {
  object: ArgoUserAccessTokenInsertInput;
  on_conflict?: Maybe<ArgoUserAccessTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserBadgeArgs = {
  objects: Array<ArgoUserBadgeInsertInput>;
  on_conflict?: Maybe<ArgoUserBadgeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserBadgeOneArgs = {
  object: ArgoUserBadgeInsertInput;
  on_conflict?: Maybe<ArgoUserBadgeOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserContextArgs = {
  objects: Array<ArgoUserContextInsertInput>;
  on_conflict?: Maybe<ArgoUserContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserContextOneArgs = {
  object: ArgoUserContextInsertInput;
  on_conflict?: Maybe<ArgoUserContextOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserOneArgs = {
  object: ArgoUserInsertInput;
  on_conflict?: Maybe<ArgoUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserRoleArgs = {
  objects: Array<ArgoUserRoleInsertInput>;
  on_conflict?: Maybe<ArgoUserRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoUserRoleOneArgs = {
  object: ArgoUserRoleInsertInput;
  on_conflict?: Maybe<ArgoUserRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoVwUserAclsArgs = {
  objects: Array<ArgoVwUserAclsInsertInput>;
};


/** mutation root */
export type MutationRootInsertArgoVwUserAclsOneArgs = {
  object: ArgoVwUserAclsInsertInput;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionArgs = {
  objects: Array<ArgoWorkInstructionInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceArgs = {
  objects: Array<ArgoWorkInstructionInstanceInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceOneArgs = {
  object: ArgoWorkInstructionInstanceInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceStatusArgs = {
  objects: Array<ArgoWorkInstructionInstanceStatusInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceStatusOneArgs = {
  object: ArgoWorkInstructionInstanceStatusInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceStepArgs = {
  objects: Array<ArgoWorkInstructionInstanceStepInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceStepOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionInstanceStepOneArgs = {
  object: ArgoWorkInstructionInstanceStepInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionInstanceStepOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionOneArgs = {
  object: ArgoWorkInstructionInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionVersionArgs = {
  objects: Array<ArgoWorkInstructionVersionInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionVersionOneArgs = {
  object: ArgoWorkInstructionVersionInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionVersionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionVersionStatusArgs = {
  objects: Array<ArgoWorkInstructionVersionStatusInsertInput>;
  on_conflict?: Maybe<ArgoWorkInstructionVersionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkInstructionVersionStatusOneArgs = {
  object: ArgoWorkInstructionVersionStatusInsertInput;
  on_conflict?: Maybe<ArgoWorkInstructionVersionStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderArgs = {
  objects: Array<ArgoWorkOrderInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderActivityArgs = {
  objects: Array<ArgoWorkOrderActivityInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderActivityOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderActivityKindArgs = {
  objects: Array<ArgoWorkOrderActivityKindInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderActivityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderActivityKindOneArgs = {
  object: ArgoWorkOrderActivityKindInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderActivityKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderActivityOneArgs = {
  object: ArgoWorkOrderActivityInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderActivityOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderLocationArgs = {
  objects: Array<ArgoWorkOrderLocationInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderLocationOneArgs = {
  object: ArgoWorkOrderLocationInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderLocationOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderMaterialArgs = {
  objects: Array<ArgoWorkOrderMaterialInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderMaterialOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderMaterialOneArgs = {
  object: ArgoWorkOrderMaterialInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderMaterialOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderOneArgs = {
  object: ArgoWorkOrderInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderRestrictionArgs = {
  objects: Array<ArgoWorkOrderRestrictionInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderRestrictionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderRestrictionOneArgs = {
  object: ArgoWorkOrderRestrictionInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderRestrictionOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderStatusArgs = {
  objects: Array<ArgoWorkOrderStatusInsertInput>;
  on_conflict?: Maybe<ArgoWorkOrderStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertArgoWorkOrderStatusOneArgs = {
  object: ArgoWorkOrderStatusInsertInput;
  on_conflict?: Maybe<ArgoWorkOrderStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetArgs = {
  objects: Array<FisAssetInsertInput>;
  on_conflict?: Maybe<FisAssetOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetCodeArgs = {
  objects: Array<FisAssetCodeInsertInput>;
  on_conflict?: Maybe<FisAssetCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetCodeOneArgs = {
  object: FisAssetCodeInsertInput;
  on_conflict?: Maybe<FisAssetCodeOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetOneArgs = {
  object: FisAssetInsertInput;
  on_conflict?: Maybe<FisAssetOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTagArgs = {
  objects: Array<FisAssetTagInsertInput>;
  on_conflict?: Maybe<FisAssetTagOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTagLinkArgs = {
  objects: Array<FisAssetTagLinkInsertInput>;
  on_conflict?: Maybe<FisAssetTagLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTagLinkOneArgs = {
  object: FisAssetTagLinkInsertInput;
  on_conflict?: Maybe<FisAssetTagLinkOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTagOneArgs = {
  object: FisAssetTagInsertInput;
  on_conflict?: Maybe<FisAssetTagOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTypeArgs = {
  objects: Array<FisAssetTypeInsertInput>;
  on_conflict?: Maybe<FisAssetTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisAssetTypeOneArgs = {
  object: FisAssetTypeInsertInput;
  on_conflict?: Maybe<FisAssetTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisCoreStateArgs = {
  objects: Array<FisCoreStateInsertInput>;
  on_conflict?: Maybe<FisCoreStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisCoreStateOneArgs = {
  object: FisCoreStateInsertInput;
  on_conflict?: Maybe<FisCoreStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataArgs = {
  objects: Array<FisDataInsertInput>;
  on_conflict?: Maybe<FisDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataLabelArgs = {
  objects: Array<FisDataLabelInsertInput>;
  on_conflict?: Maybe<FisDataLabelOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataLabelOneArgs = {
  object: FisDataLabelInsertInput;
  on_conflict?: Maybe<FisDataLabelOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataOneArgs = {
  object: FisDataInsertInput;
  on_conflict?: Maybe<FisDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTimingArgs = {
  objects: Array<FisDataTimingInsertInput>;
  on_conflict?: Maybe<FisDataTimingOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTimingOneArgs = {
  object: FisDataTimingInsertInput;
  on_conflict?: Maybe<FisDataTimingOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackCountArgs = {
  objects: Array<FisDataTrackCountInsertInput>;
  on_conflict?: Maybe<FisDataTrackCountOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackCountOneArgs = {
  object: FisDataTrackCountInsertInput;
  on_conflict?: Maybe<FisDataTrackCountOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackDurationArgs = {
  objects: Array<FisDataTrackDurationInsertInput>;
  on_conflict?: Maybe<FisDataTrackDurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackDurationOneArgs = {
  object: FisDataTrackDurationInsertInput;
  on_conflict?: Maybe<FisDataTrackDurationOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackScalarArgs = {
  objects: Array<FisDataTrackScalarInsertInput>;
  on_conflict?: Maybe<FisDataTrackScalarOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTrackScalarOneArgs = {
  object: FisDataTrackScalarInsertInput;
  on_conflict?: Maybe<FisDataTrackScalarOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTypeArgs = {
  objects: Array<FisDataTypeInsertInput>;
  on_conflict?: Maybe<FisDataTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertFisDataTypeOneArgs = {
  object: FisDataTypeInsertInput;
  on_conflict?: Maybe<FisDataTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionArgs = {
  objects: Array<ProcessCollectionInsertInput>;
  on_conflict?: Maybe<ProcessCollectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionDataArgs = {
  objects: Array<ProcessCollectionDataInsertInput>;
  on_conflict?: Maybe<ProcessCollectionDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionDataOneArgs = {
  object: ProcessCollectionDataInsertInput;
  on_conflict?: Maybe<ProcessCollectionDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionKindArgs = {
  objects: Array<ProcessCollectionKindInsertInput>;
  on_conflict?: Maybe<ProcessCollectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionKindOneArgs = {
  object: ProcessCollectionKindInsertInput;
  on_conflict?: Maybe<ProcessCollectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessCollectionOneArgs = {
  object: ProcessCollectionInsertInput;
  on_conflict?: Maybe<ProcessCollectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementArgs = {
  objects: Array<ProcessDataElementInsertInput>;
  on_conflict?: Maybe<ProcessDataElementOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementCollectionKindArgs = {
  objects: Array<ProcessDataElementCollectionKindInsertInput>;
  on_conflict?: Maybe<ProcessDataElementCollectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementCollectionKindOneArgs = {
  object: ProcessDataElementCollectionKindInsertInput;
  on_conflict?: Maybe<ProcessDataElementCollectionKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementKindArgs = {
  objects: Array<ProcessDataElementKindInsertInput>;
  on_conflict?: Maybe<ProcessDataElementKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementKindOneArgs = {
  object: ProcessDataElementKindInsertInput;
  on_conflict?: Maybe<ProcessDataElementKindOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessDataElementOneArgs = {
  object: ProcessDataElementInsertInput;
  on_conflict?: Maybe<ProcessDataElementOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessMaterialStateArgs = {
  objects: Array<ProcessMaterialStateInsertInput>;
  on_conflict?: Maybe<ProcessMaterialStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessMaterialStateHistoryArgs = {
  objects: Array<ProcessMaterialStateHistoryInsertInput>;
  on_conflict?: Maybe<ProcessMaterialStateHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessMaterialStateHistoryOneArgs = {
  object: ProcessMaterialStateHistoryInsertInput;
  on_conflict?: Maybe<ProcessMaterialStateHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessMaterialStateOneArgs = {
  object: ProcessMaterialStateInsertInput;
  on_conflict?: Maybe<ProcessMaterialStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessProcessArgs = {
  objects: Array<ProcessProcessInsertInput>;
  on_conflict?: Maybe<ProcessProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessProcessOneArgs = {
  object: ProcessProcessInsertInput;
  on_conflict?: Maybe<ProcessProcessOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessProcessStatusArgs = {
  objects: Array<ProcessProcessStatusInsertInput>;
  on_conflict?: Maybe<ProcessProcessStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessProcessStatusOneArgs = {
  object: ProcessProcessStatusInsertInput;
  on_conflict?: Maybe<ProcessProcessStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessSpecArgs = {
  objects: Array<ProcessSpecInsertInput>;
  on_conflict?: Maybe<ProcessSpecOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessSpecOneArgs = {
  object: ProcessSpecInsertInput;
  on_conflict?: Maybe<ProcessSpecOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessSpecOrderArgs = {
  objects: Array<ProcessSpecOrderInsertInput>;
  on_conflict?: Maybe<ProcessSpecOrderOnConflict>;
};


/** mutation root */
export type MutationRootInsertProcessSpecOrderOneArgs = {
  object: ProcessSpecOrderInsertInput;
  on_conflict?: Maybe<ProcessSpecOrderOnConflict>;
};


/** mutation root */
export type MutationRootProcessCollectArgs = {
  args: ProcessCollectArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootProcessGetOrSolveMaterialStateArgs = {
  args: ProcessGetOrSolveMaterialStateArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootProcessMaterialStateSetStatusArgs = {
  args: ProcessMaterialStateSetStatusArgs;
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentArgs = {
  _append?: Maybe<AppletDeploymentAppendInput>;
  _delete_at_path?: Maybe<AppletDeploymentDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDeploymentDeleteElemInput>;
  _delete_key?: Maybe<AppletDeploymentDeleteKeyInput>;
  _inc?: Maybe<AppletDeploymentIncInput>;
  _prepend?: Maybe<AppletDeploymentPrependInput>;
  _set?: Maybe<AppletDeploymentSetInput>;
  where: AppletDeploymentBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentByPkArgs = {
  _append?: Maybe<AppletDeploymentAppendInput>;
  _delete_at_path?: Maybe<AppletDeploymentDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDeploymentDeleteElemInput>;
  _delete_key?: Maybe<AppletDeploymentDeleteKeyInput>;
  _inc?: Maybe<AppletDeploymentIncInput>;
  _prepend?: Maybe<AppletDeploymentPrependInput>;
  _set?: Maybe<AppletDeploymentSetInput>;
  pk_columns: AppletDeploymentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentLinkedDesignVersionArgs = {
  _append?: Maybe<AppletDeploymentLinkedDesignVersionAppendInput>;
  _delete_at_path?: Maybe<AppletDeploymentLinkedDesignVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDeploymentLinkedDesignVersionDeleteElemInput>;
  _delete_key?: Maybe<AppletDeploymentLinkedDesignVersionDeleteKeyInput>;
  _prepend?: Maybe<AppletDeploymentLinkedDesignVersionPrependInput>;
  _set?: Maybe<AppletDeploymentLinkedDesignVersionSetInput>;
  where: AppletDeploymentLinkedDesignVersionBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentLinkedDesignVersionByPkArgs = {
  _append?: Maybe<AppletDeploymentLinkedDesignVersionAppendInput>;
  _delete_at_path?: Maybe<AppletDeploymentLinkedDesignVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDeploymentLinkedDesignVersionDeleteElemInput>;
  _delete_key?: Maybe<AppletDeploymentLinkedDesignVersionDeleteKeyInput>;
  _prepend?: Maybe<AppletDeploymentLinkedDesignVersionPrependInput>;
  _set?: Maybe<AppletDeploymentLinkedDesignVersionSetInput>;
  pk_columns: AppletDeploymentLinkedDesignVersionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentLinkedDesignVersionManyArgs = {
  updates: Array<AppletDeploymentLinkedDesignVersionUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletDeploymentManyArgs = {
  updates: Array<AppletDeploymentUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletDesignArgs = {
  _set?: Maybe<AppletDesignSetInput>;
  where: AppletDesignBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletDesignByPkArgs = {
  _set?: Maybe<AppletDesignSetInput>;
  pk_columns: AppletDesignPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletDesignManyArgs = {
  updates: Array<AppletDesignUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionArgs = {
  _append?: Maybe<AppletDesignVersionAppendInput>;
  _delete_at_path?: Maybe<AppletDesignVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDesignVersionDeleteElemInput>;
  _delete_key?: Maybe<AppletDesignVersionDeleteKeyInput>;
  _inc?: Maybe<AppletDesignVersionIncInput>;
  _prepend?: Maybe<AppletDesignVersionPrependInput>;
  _set?: Maybe<AppletDesignVersionSetInput>;
  where: AppletDesignVersionBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionByPkArgs = {
  _append?: Maybe<AppletDesignVersionAppendInput>;
  _delete_at_path?: Maybe<AppletDesignVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletDesignVersionDeleteElemInput>;
  _delete_key?: Maybe<AppletDesignVersionDeleteKeyInput>;
  _inc?: Maybe<AppletDesignVersionIncInput>;
  _prepend?: Maybe<AppletDesignVersionPrependInput>;
  _set?: Maybe<AppletDesignVersionSetInput>;
  pk_columns: AppletDesignVersionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionManyArgs = {
  updates: Array<AppletDesignVersionUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionStatusArgs = {
  _set?: Maybe<AppletDesignVersionStatusSetInput>;
  where: AppletDesignVersionStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionStatusByPkArgs = {
  _set?: Maybe<AppletDesignVersionStatusSetInput>;
  pk_columns: AppletDesignVersionStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletDesignVersionStatusManyArgs = {
  updates: Array<AppletDesignVersionStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletRegistrationCodeArgs = {
  _inc?: Maybe<AppletRegistrationCodeIncInput>;
  _set?: Maybe<AppletRegistrationCodeSetInput>;
  where: AppletRegistrationCodeBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletRegistrationCodeByPkArgs = {
  _inc?: Maybe<AppletRegistrationCodeIncInput>;
  _set?: Maybe<AppletRegistrationCodeSetInput>;
  pk_columns: AppletRegistrationCodePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletRegistrationCodeManyArgs = {
  updates: Array<AppletRegistrationCodeUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerArgs = {
  _append?: Maybe<AppletRunnerAppendInput>;
  _delete_at_path?: Maybe<AppletRunnerDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletRunnerDeleteElemInput>;
  _delete_key?: Maybe<AppletRunnerDeleteKeyInput>;
  _prepend?: Maybe<AppletRunnerPrependInput>;
  _set?: Maybe<AppletRunnerSetInput>;
  where: AppletRunnerBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerByPkArgs = {
  _append?: Maybe<AppletRunnerAppendInput>;
  _delete_at_path?: Maybe<AppletRunnerDeleteAtPathInput>;
  _delete_elem?: Maybe<AppletRunnerDeleteElemInput>;
  _delete_key?: Maybe<AppletRunnerDeleteKeyInput>;
  _prepend?: Maybe<AppletRunnerPrependInput>;
  _set?: Maybe<AppletRunnerSetInput>;
  pk_columns: AppletRunnerPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerContextArgs = {
  _set?: Maybe<AppletRunnerContextSetInput>;
  where: AppletRunnerContextBoolExp;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerContextByPkArgs = {
  _set?: Maybe<AppletRunnerContextSetInput>;
  pk_columns: AppletRunnerContextPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerContextManyArgs = {
  updates: Array<AppletRunnerContextUpdates>;
};


/** mutation root */
export type MutationRootUpdateAppletRunnerManyArgs = {
  updates: Array<AppletRunnerUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAclArgs = {
  _append?: Maybe<ArgoAclAppendInput>;
  _delete_at_path?: Maybe<ArgoAclDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAclDeleteElemInput>;
  _delete_key?: Maybe<ArgoAclDeleteKeyInput>;
  _prepend?: Maybe<ArgoAclPrependInput>;
  _set?: Maybe<ArgoAclSetInput>;
  where: ArgoAclBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAclByPkArgs = {
  _append?: Maybe<ArgoAclAppendInput>;
  _delete_at_path?: Maybe<ArgoAclDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAclDeleteElemInput>;
  _delete_key?: Maybe<ArgoAclDeleteKeyInput>;
  _prepend?: Maybe<ArgoAclPrependInput>;
  _set?: Maybe<ArgoAclSetInput>;
  pk_columns: ArgoAclPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAclManyArgs = {
  updates: Array<ArgoAclUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeArgs = {
  _append?: Maybe<ArgoAttributeAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeDeleteKeyInput>;
  _prepend?: Maybe<ArgoAttributePrependInput>;
  _set?: Maybe<ArgoAttributeSetInput>;
  where: ArgoAttributeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeByPkArgs = {
  _append?: Maybe<ArgoAttributeAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeDeleteKeyInput>;
  _prepend?: Maybe<ArgoAttributePrependInput>;
  _set?: Maybe<ArgoAttributeSetInput>;
  pk_columns: ArgoAttributePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeDataArgs = {
  _append?: Maybe<ArgoAttributeDataAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeDataDeleteKeyInput>;
  _inc?: Maybe<ArgoAttributeDataIncInput>;
  _prepend?: Maybe<ArgoAttributeDataPrependInput>;
  _set?: Maybe<ArgoAttributeDataSetInput>;
  where: ArgoAttributeDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeDataByPkArgs = {
  _append?: Maybe<ArgoAttributeDataAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeDataDeleteKeyInput>;
  _inc?: Maybe<ArgoAttributeDataIncInput>;
  _prepend?: Maybe<ArgoAttributeDataPrependInput>;
  _set?: Maybe<ArgoAttributeDataSetInput>;
  pk_columns: ArgoAttributeDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeDataManyArgs = {
  updates: Array<ArgoAttributeDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeHistoryStatusTypeArgs = {
  _set?: Maybe<ArgoAttributeHistoryStatusTypeSetInput>;
  where: ArgoAttributeHistoryStatusTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeHistoryStatusTypeByPkArgs = {
  _set?: Maybe<ArgoAttributeHistoryStatusTypeSetInput>;
  pk_columns: ArgoAttributeHistoryStatusTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeHistoryStatusTypeManyArgs = {
  updates: Array<ArgoAttributeHistoryStatusTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeManyArgs = {
  updates: Array<ArgoAttributeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaArgs = {
  _append?: Maybe<ArgoAttributeSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeSchemaDeleteKeyInput>;
  _prepend?: Maybe<ArgoAttributeSchemaPrependInput>;
  _set?: Maybe<ArgoAttributeSchemaSetInput>;
  where: ArgoAttributeSchemaBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaByPkArgs = {
  _append?: Maybe<ArgoAttributeSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeSchemaDeleteKeyInput>;
  _prepend?: Maybe<ArgoAttributeSchemaPrependInput>;
  _set?: Maybe<ArgoAttributeSchemaSetInput>;
  pk_columns: ArgoAttributeSchemaPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionArgs = {
  _append?: Maybe<ArgoAttributeSchemaDefinitionAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeSchemaDefinitionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeSchemaDefinitionDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeSchemaDefinitionDeleteKeyInput>;
  _inc?: Maybe<ArgoAttributeSchemaDefinitionIncInput>;
  _prepend?: Maybe<ArgoAttributeSchemaDefinitionPrependInput>;
  _set?: Maybe<ArgoAttributeSchemaDefinitionSetInput>;
  where: ArgoAttributeSchemaDefinitionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionByPkArgs = {
  _append?: Maybe<ArgoAttributeSchemaDefinitionAppendInput>;
  _delete_at_path?: Maybe<ArgoAttributeSchemaDefinitionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAttributeSchemaDefinitionDeleteElemInput>;
  _delete_key?: Maybe<ArgoAttributeSchemaDefinitionDeleteKeyInput>;
  _inc?: Maybe<ArgoAttributeSchemaDefinitionIncInput>;
  _prepend?: Maybe<ArgoAttributeSchemaDefinitionPrependInput>;
  _set?: Maybe<ArgoAttributeSchemaDefinitionSetInput>;
  pk_columns: ArgoAttributeSchemaDefinitionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionManyArgs = {
  updates: Array<ArgoAttributeSchemaDefinitionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionTypeArgs = {
  _set?: Maybe<ArgoAttributeSchemaDefinitionTypeSetInput>;
  where: ArgoAttributeSchemaDefinitionTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionTypeByPkArgs = {
  _set?: Maybe<ArgoAttributeSchemaDefinitionTypeSetInput>;
  pk_columns: ArgoAttributeSchemaDefinitionTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaDefinitionTypeManyArgs = {
  updates: Array<ArgoAttributeSchemaDefinitionTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaManyArgs = {
  updates: Array<ArgoAttributeSchemaUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaTypeArgs = {
  _set?: Maybe<ArgoAttributeSchemaTypeSetInput>;
  where: ArgoAttributeSchemaTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaTypeByPkArgs = {
  _set?: Maybe<ArgoAttributeSchemaTypeSetInput>;
  pk_columns: ArgoAttributeSchemaTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAttributeSchemaTypeManyArgs = {
  updates: Array<ArgoAttributeSchemaTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuditArgs = {
  _append?: Maybe<ArgoAuditAppendInput>;
  _delete_at_path?: Maybe<ArgoAuditDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuditDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuditDeleteKeyInput>;
  _inc?: Maybe<ArgoAuditIncInput>;
  _prepend?: Maybe<ArgoAuditPrependInput>;
  _set?: Maybe<ArgoAuditSetInput>;
  where: ArgoAuditBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuditByPkArgs = {
  _append?: Maybe<ArgoAuditAppendInput>;
  _delete_at_path?: Maybe<ArgoAuditDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuditDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuditDeleteKeyInput>;
  _inc?: Maybe<ArgoAuditIncInput>;
  _prepend?: Maybe<ArgoAuditPrependInput>;
  _set?: Maybe<ArgoAuditSetInput>;
  pk_columns: ArgoAuditPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuditManyArgs = {
  updates: Array<ArgoAuditUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderArgs = {
  _append?: Maybe<ArgoAuthProviderAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderPrependInput>;
  _set?: Maybe<ArgoAuthProviderSetInput>;
  where: ArgoAuthProviderBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderByPkArgs = {
  _append?: Maybe<ArgoAuthProviderAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderPrependInput>;
  _set?: Maybe<ArgoAuthProviderSetInput>;
  pk_columns: ArgoAuthProviderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalArgs = {
  _append?: Maybe<ArgoAuthProviderLocalAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderLocalDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderLocalDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderLocalDeleteKeyInput>;
  _inc?: Maybe<ArgoAuthProviderLocalIncInput>;
  _prepend?: Maybe<ArgoAuthProviderLocalPrependInput>;
  _set?: Maybe<ArgoAuthProviderLocalSetInput>;
  where: ArgoAuthProviderLocalBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalByPkArgs = {
  _append?: Maybe<ArgoAuthProviderLocalAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderLocalDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderLocalDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderLocalDeleteKeyInput>;
  _inc?: Maybe<ArgoAuthProviderLocalIncInput>;
  _prepend?: Maybe<ArgoAuthProviderLocalPrependInput>;
  _set?: Maybe<ArgoAuthProviderLocalSetInput>;
  pk_columns: ArgoAuthProviderLocalPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalManyArgs = {
  updates: Array<ArgoAuthProviderLocalUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalSettingArgs = {
  _append?: Maybe<ArgoAuthProviderLocalSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderLocalSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderLocalSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderLocalSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderLocalSettingPrependInput>;
  _set?: Maybe<ArgoAuthProviderLocalSettingSetInput>;
  where: ArgoAuthProviderLocalSettingBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalSettingByPkArgs = {
  _append?: Maybe<ArgoAuthProviderLocalSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderLocalSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderLocalSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderLocalSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderLocalSettingPrependInput>;
  _set?: Maybe<ArgoAuthProviderLocalSettingSetInput>;
  pk_columns: ArgoAuthProviderLocalSettingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderLocalSettingManyArgs = {
  updates: Array<ArgoAuthProviderLocalSettingUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderManyArgs = {
  updates: Array<ArgoAuthProviderUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalArgs = {
  _append?: Maybe<ArgoAuthProviderMsalAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderMsalDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderMsalDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderMsalDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderMsalPrependInput>;
  _set?: Maybe<ArgoAuthProviderMsalSetInput>;
  where: ArgoAuthProviderMsalBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalByPkArgs = {
  _append?: Maybe<ArgoAuthProviderMsalAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderMsalDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderMsalDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderMsalDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderMsalPrependInput>;
  _set?: Maybe<ArgoAuthProviderMsalSetInput>;
  pk_columns: ArgoAuthProviderMsalPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalManyArgs = {
  updates: Array<ArgoAuthProviderMsalUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalSettingArgs = {
  _append?: Maybe<ArgoAuthProviderMsalSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderMsalSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderMsalSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderMsalSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderMsalSettingPrependInput>;
  _set?: Maybe<ArgoAuthProviderMsalSettingSetInput>;
  where: ArgoAuthProviderMsalSettingBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalSettingByPkArgs = {
  _append?: Maybe<ArgoAuthProviderMsalSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderMsalSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderMsalSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderMsalSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderMsalSettingPrependInput>;
  _set?: Maybe<ArgoAuthProviderMsalSettingSetInput>;
  pk_columns: ArgoAuthProviderMsalSettingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderMsalSettingManyArgs = {
  updates: Array<ArgoAuthProviderMsalSettingUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderRecordArgs = {
  _append?: Maybe<ArgoAuthProviderRecordAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderRecordDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderRecordDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderRecordDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderRecordPrependInput>;
  _set?: Maybe<ArgoAuthProviderRecordSetInput>;
  where: ArgoAuthProviderRecordBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderRecordByPkArgs = {
  _append?: Maybe<ArgoAuthProviderRecordAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthProviderRecordDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthProviderRecordDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthProviderRecordDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthProviderRecordPrependInput>;
  _set?: Maybe<ArgoAuthProviderRecordSetInput>;
  pk_columns: ArgoAuthProviderRecordPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthProviderRecordManyArgs = {
  updates: Array<ArgoAuthProviderRecordUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoAuthRefreshTokenArgs = {
  _append?: Maybe<ArgoAuthRefreshTokenAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthRefreshTokenDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthRefreshTokenDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthRefreshTokenDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthRefreshTokenPrependInput>;
  _set?: Maybe<ArgoAuthRefreshTokenSetInput>;
  where: ArgoAuthRefreshTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoAuthRefreshTokenByPkArgs = {
  _append?: Maybe<ArgoAuthRefreshTokenAppendInput>;
  _delete_at_path?: Maybe<ArgoAuthRefreshTokenDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoAuthRefreshTokenDeleteElemInput>;
  _delete_key?: Maybe<ArgoAuthRefreshTokenDeleteKeyInput>;
  _prepend?: Maybe<ArgoAuthRefreshTokenPrependInput>;
  _set?: Maybe<ArgoAuthRefreshTokenSetInput>;
  pk_columns: ArgoAuthRefreshTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoAuthRefreshTokenManyArgs = {
  updates: Array<ArgoAuthRefreshTokenUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarArgs = {
  _append?: Maybe<ArgoCalendarAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarDeleteKeyInput>;
  _prepend?: Maybe<ArgoCalendarPrependInput>;
  _set?: Maybe<ArgoCalendarSetInput>;
  where: ArgoCalendarBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarByPkArgs = {
  _append?: Maybe<ArgoCalendarAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarDeleteKeyInput>;
  _prepend?: Maybe<ArgoCalendarPrependInput>;
  _set?: Maybe<ArgoCalendarSetInput>;
  pk_columns: ArgoCalendarPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventArgs = {
  _append?: Maybe<ArgoCalendarEventAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventIncInput>;
  _prepend?: Maybe<ArgoCalendarEventPrependInput>;
  _set?: Maybe<ArgoCalendarEventSetInput>;
  where: ArgoCalendarEventBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventByPkArgs = {
  _append?: Maybe<ArgoCalendarEventAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventIncInput>;
  _prepend?: Maybe<ArgoCalendarEventPrependInput>;
  _set?: Maybe<ArgoCalendarEventSetInput>;
  pk_columns: ArgoCalendarEventPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventManyArgs = {
  updates: Array<ArgoCalendarEventUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventSequenceArgs = {
  _append?: Maybe<ArgoCalendarEventSequenceAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventSequenceDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventSequenceDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventSequenceDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventSequenceIncInput>;
  _prepend?: Maybe<ArgoCalendarEventSequencePrependInput>;
  _set?: Maybe<ArgoCalendarEventSequenceSetInput>;
  where: ArgoCalendarEventSequenceBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventSequenceManyArgs = {
  updates: Array<ArgoCalendarEventSequenceUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDataArgs = {
  _append?: Maybe<ArgoCalendarEventUdfDataAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfDataDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfDataIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfDataPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfDataSetInput>;
  where: ArgoCalendarEventUdfDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDataByPkArgs = {
  _append?: Maybe<ArgoCalendarEventUdfDataAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfDataDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfDataIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfDataPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfDataSetInput>;
  pk_columns: ArgoCalendarEventUdfDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDataManyArgs = {
  updates: Array<ArgoCalendarEventUdfDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDefaultDataArgs = {
  _append?: Maybe<ArgoCalendarEventUdfDefaultDataAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfDefaultDataIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfDefaultDataPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfDefaultDataSetInput>;
  where: ArgoCalendarEventUdfDefaultDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDefaultDataByPkArgs = {
  _append?: Maybe<ArgoCalendarEventUdfDefaultDataAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfDefaultDataDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfDefaultDataIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfDefaultDataPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfDefaultDataSetInput>;
  pk_columns: ArgoCalendarEventUdfDefaultDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfDefaultDataManyArgs = {
  updates: Array<ArgoCalendarEventUdfDefaultDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfSchemaArgs = {
  _append?: Maybe<ArgoCalendarEventUdfSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfSchemaDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfSchemaIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfSchemaPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfSchemaSetInput>;
  where: ArgoCalendarEventUdfSchemaBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfSchemaByPkArgs = {
  _append?: Maybe<ArgoCalendarEventUdfSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarEventUdfSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarEventUdfSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarEventUdfSchemaDeleteKeyInput>;
  _inc?: Maybe<ArgoCalendarEventUdfSchemaIncInput>;
  _prepend?: Maybe<ArgoCalendarEventUdfSchemaPrependInput>;
  _set?: Maybe<ArgoCalendarEventUdfSchemaSetInput>;
  pk_columns: ArgoCalendarEventUdfSchemaPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarEventUdfSchemaManyArgs = {
  updates: Array<ArgoCalendarEventUdfSchemaUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarLocationArgs = {
  _append?: Maybe<ArgoCalendarLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoCalendarLocationPrependInput>;
  _set?: Maybe<ArgoCalendarLocationSetInput>;
  where: ArgoCalendarLocationBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarLocationByPkArgs = {
  _append?: Maybe<ArgoCalendarLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoCalendarLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoCalendarLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoCalendarLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoCalendarLocationPrependInput>;
  _set?: Maybe<ArgoCalendarLocationSetInput>;
  pk_columns: ArgoCalendarLocationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarLocationManyArgs = {
  updates: Array<ArgoCalendarLocationUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCalendarManyArgs = {
  updates: Array<ArgoCalendarUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionArgs = {
  _set?: Maybe<ArgoConnectionSetInput>;
  where: ArgoConnectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionByPkArgs = {
  _set?: Maybe<ArgoConnectionSetInput>;
  pk_columns: ArgoConnectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigArgs = {
  _append?: Maybe<ArgoConnectionConfigAppendInput>;
  _delete_at_path?: Maybe<ArgoConnectionConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoConnectionConfigDeleteElemInput>;
  _delete_key?: Maybe<ArgoConnectionConfigDeleteKeyInput>;
  _inc?: Maybe<ArgoConnectionConfigIncInput>;
  _prepend?: Maybe<ArgoConnectionConfigPrependInput>;
  _set?: Maybe<ArgoConnectionConfigSetInput>;
  where: ArgoConnectionConfigBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigByPkArgs = {
  _append?: Maybe<ArgoConnectionConfigAppendInput>;
  _delete_at_path?: Maybe<ArgoConnectionConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoConnectionConfigDeleteElemInput>;
  _delete_key?: Maybe<ArgoConnectionConfigDeleteKeyInput>;
  _inc?: Maybe<ArgoConnectionConfigIncInput>;
  _prepend?: Maybe<ArgoConnectionConfigPrependInput>;
  _set?: Maybe<ArgoConnectionConfigSetInput>;
  pk_columns: ArgoConnectionConfigPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigManyArgs = {
  updates: Array<ArgoConnectionConfigUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigStatusArgs = {
  _set?: Maybe<ArgoConnectionConfigStatusSetInput>;
  where: ArgoConnectionConfigStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigStatusByPkArgs = {
  _set?: Maybe<ArgoConnectionConfigStatusSetInput>;
  pk_columns: ArgoConnectionConfigStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionConfigStatusManyArgs = {
  updates: Array<ArgoConnectionConfigStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionKindArgs = {
  _set?: Maybe<ArgoConnectionKindSetInput>;
  where: ArgoConnectionKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionKindByPkArgs = {
  _set?: Maybe<ArgoConnectionKindSetInput>;
  pk_columns: ArgoConnectionKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionKindManyArgs = {
  updates: Array<ArgoConnectionKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoConnectionManyArgs = {
  updates: Array<ArgoConnectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoContextArgs = {
  _append?: Maybe<ArgoContextAppendInput>;
  _delete_at_path?: Maybe<ArgoContextDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoContextDeleteElemInput>;
  _delete_key?: Maybe<ArgoContextDeleteKeyInput>;
  _prepend?: Maybe<ArgoContextPrependInput>;
  _set?: Maybe<ArgoContextSetInput>;
  where: ArgoContextBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoContextByPkArgs = {
  _append?: Maybe<ArgoContextAppendInput>;
  _delete_at_path?: Maybe<ArgoContextDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoContextDeleteElemInput>;
  _delete_key?: Maybe<ArgoContextDeleteKeyInput>;
  _prepend?: Maybe<ArgoContextPrependInput>;
  _set?: Maybe<ArgoContextSetInput>;
  pk_columns: ArgoContextPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoContextManyArgs = {
  updates: Array<ArgoContextUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoCronTaskArgs = {
  _set?: Maybe<ArgoCronTaskSetInput>;
  where: ArgoCronTaskBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoCronTaskByPkArgs = {
  _set?: Maybe<ArgoCronTaskSetInput>;
  pk_columns: ArgoCronTaskPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoCronTaskManyArgs = {
  updates: Array<ArgoCronTaskUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoEventArgs = {
  _append?: Maybe<ArgoEventAppendInput>;
  _delete_at_path?: Maybe<ArgoEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoEventDeleteKeyInput>;
  _inc?: Maybe<ArgoEventIncInput>;
  _prepend?: Maybe<ArgoEventPrependInput>;
  _set?: Maybe<ArgoEventSetInput>;
  where: ArgoEventBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoEventByPkArgs = {
  _append?: Maybe<ArgoEventAppendInput>;
  _delete_at_path?: Maybe<ArgoEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoEventDeleteKeyInput>;
  _inc?: Maybe<ArgoEventIncInput>;
  _prepend?: Maybe<ArgoEventPrependInput>;
  _set?: Maybe<ArgoEventSetInput>;
  pk_columns: ArgoEventPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoEventManyArgs = {
  updates: Array<ArgoEventUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoEventTypeArgs = {
  _inc?: Maybe<ArgoEventTypeIncInput>;
  _set?: Maybe<ArgoEventTypeSetInput>;
  where: ArgoEventTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoEventTypeByPkArgs = {
  _inc?: Maybe<ArgoEventTypeIncInput>;
  _set?: Maybe<ArgoEventTypeSetInput>;
  pk_columns: ArgoEventTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoEventTypeManyArgs = {
  updates: Array<ArgoEventTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoHasuraPermissionArgs = {
  _append?: Maybe<ArgoHasuraPermissionAppendInput>;
  _delete_at_path?: Maybe<ArgoHasuraPermissionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoHasuraPermissionDeleteElemInput>;
  _delete_key?: Maybe<ArgoHasuraPermissionDeleteKeyInput>;
  _prepend?: Maybe<ArgoHasuraPermissionPrependInput>;
  _set?: Maybe<ArgoHasuraPermissionSetInput>;
  where: ArgoHasuraPermissionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoHasuraPermissionByPkArgs = {
  _append?: Maybe<ArgoHasuraPermissionAppendInput>;
  _delete_at_path?: Maybe<ArgoHasuraPermissionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoHasuraPermissionDeleteElemInput>;
  _delete_key?: Maybe<ArgoHasuraPermissionDeleteKeyInput>;
  _prepend?: Maybe<ArgoHasuraPermissionPrependInput>;
  _set?: Maybe<ArgoHasuraPermissionSetInput>;
  pk_columns: ArgoHasuraPermissionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoHasuraPermissionManyArgs = {
  updates: Array<ArgoHasuraPermissionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLinkArgs = {
  _append?: Maybe<ArgoLinkAppendInput>;
  _delete_at_path?: Maybe<ArgoLinkDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLinkDeleteElemInput>;
  _delete_key?: Maybe<ArgoLinkDeleteKeyInput>;
  _prepend?: Maybe<ArgoLinkPrependInput>;
  _set?: Maybe<ArgoLinkSetInput>;
  where: ArgoLinkBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLinkByPkArgs = {
  _append?: Maybe<ArgoLinkAppendInput>;
  _delete_at_path?: Maybe<ArgoLinkDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLinkDeleteElemInput>;
  _delete_key?: Maybe<ArgoLinkDeleteKeyInput>;
  _prepend?: Maybe<ArgoLinkPrependInput>;
  _set?: Maybe<ArgoLinkSetInput>;
  pk_columns: ArgoLinkPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLinkManyArgs = {
  updates: Array<ArgoLinkUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLocationArgs = {
  _append?: Maybe<ArgoLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoLocationPrependInput>;
  _set?: Maybe<ArgoLocationSetInput>;
  where: ArgoLocationBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeArgs = {
  _set?: Maybe<ArgoLocationAttributeSetInput>;
  where: ArgoLocationAttributeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeByPkArgs = {
  _set?: Maybe<ArgoLocationAttributeSetInput>;
  pk_columns: ArgoLocationAttributePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeHistoryArgs = {
  _set?: Maybe<ArgoLocationAttributeHistorySetInput>;
  where: ArgoLocationAttributeHistoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeHistoryByPkArgs = {
  _set?: Maybe<ArgoLocationAttributeHistorySetInput>;
  pk_columns: ArgoLocationAttributeHistoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeHistoryManyArgs = {
  updates: Array<ArgoLocationAttributeHistoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLocationAttributeManyArgs = {
  updates: Array<ArgoLocationAttributeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLocationByPkArgs = {
  _append?: Maybe<ArgoLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoLocationPrependInput>;
  _set?: Maybe<ArgoLocationSetInput>;
  pk_columns: ArgoLocationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLocationClassArgs = {
  _append?: Maybe<ArgoLocationClassAppendInput>;
  _delete_at_path?: Maybe<ArgoLocationClassDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLocationClassDeleteElemInput>;
  _delete_key?: Maybe<ArgoLocationClassDeleteKeyInput>;
  _prepend?: Maybe<ArgoLocationClassPrependInput>;
  _set?: Maybe<ArgoLocationClassSetInput>;
  where: ArgoLocationClassBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLocationClassByPkArgs = {
  _append?: Maybe<ArgoLocationClassAppendInput>;
  _delete_at_path?: Maybe<ArgoLocationClassDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLocationClassDeleteElemInput>;
  _delete_key?: Maybe<ArgoLocationClassDeleteKeyInput>;
  _prepend?: Maybe<ArgoLocationClassPrependInput>;
  _set?: Maybe<ArgoLocationClassSetInput>;
  pk_columns: ArgoLocationClassPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLocationClassManyArgs = {
  updates: Array<ArgoLocationClassUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLocationManyArgs = {
  updates: Array<ArgoLocationUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLogArgs = {
  _append?: Maybe<ArgoLogAppendInput>;
  _delete_at_path?: Maybe<ArgoLogDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLogDeleteElemInput>;
  _delete_key?: Maybe<ArgoLogDeleteKeyInput>;
  _inc?: Maybe<ArgoLogIncInput>;
  _prepend?: Maybe<ArgoLogPrependInput>;
  _set?: Maybe<ArgoLogSetInput>;
  where: ArgoLogBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLogByPkArgs = {
  _append?: Maybe<ArgoLogAppendInput>;
  _delete_at_path?: Maybe<ArgoLogDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLogDeleteElemInput>;
  _delete_key?: Maybe<ArgoLogDeleteKeyInput>;
  _inc?: Maybe<ArgoLogIncInput>;
  _prepend?: Maybe<ArgoLogPrependInput>;
  _set?: Maybe<ArgoLogSetInput>;
  pk_columns: ArgoLogPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLogCategoryArgs = {
  _set?: Maybe<ArgoLogCategorySetInput>;
  where: ArgoLogCategoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLogCategoryByPkArgs = {
  _set?: Maybe<ArgoLogCategorySetInput>;
  pk_columns: ArgoLogCategoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLogCategoryManyArgs = {
  updates: Array<ArgoLogCategoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLogDurationArgs = {
  _append?: Maybe<ArgoLogDurationAppendInput>;
  _delete_at_path?: Maybe<ArgoLogDurationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoLogDurationDeleteElemInput>;
  _delete_key?: Maybe<ArgoLogDurationDeleteKeyInput>;
  _prepend?: Maybe<ArgoLogDurationPrependInput>;
  _set?: Maybe<ArgoLogDurationSetInput>;
  where: ArgoLogDurationBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLogDurationManyArgs = {
  updates: Array<ArgoLogDurationUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLogLevelArgs = {
  _set?: Maybe<ArgoLogLevelSetInput>;
  where: ArgoLogLevelBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoLogLevelByPkArgs = {
  _set?: Maybe<ArgoLogLevelSetInput>;
  pk_columns: ArgoLogLevelPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoLogLevelManyArgs = {
  updates: Array<ArgoLogLevelUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoLogManyArgs = {
  updates: Array<ArgoLogUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialArgs = {
  _append?: Maybe<ArgoMaterialAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialPrependInput>;
  _set?: Maybe<ArgoMaterialSetInput>;
  where: ArgoMaterialBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityArgs = {
  _append?: Maybe<ArgoMaterialActivityAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialActivityDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialActivityDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialActivityDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialActivityPrependInput>;
  _set?: Maybe<ArgoMaterialActivitySetInput>;
  where: ArgoMaterialActivityBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityByPkArgs = {
  _append?: Maybe<ArgoMaterialActivityAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialActivityDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialActivityDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialActivityDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialActivityPrependInput>;
  _set?: Maybe<ArgoMaterialActivitySetInput>;
  pk_columns: ArgoMaterialActivityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityKindArgs = {
  _set?: Maybe<ArgoMaterialActivityKindSetInput>;
  where: ArgoMaterialActivityKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityKindByPkArgs = {
  _set?: Maybe<ArgoMaterialActivityKindSetInput>;
  pk_columns: ArgoMaterialActivityKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityKindManyArgs = {
  updates: Array<ArgoMaterialActivityKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialActivityManyArgs = {
  updates: Array<ArgoMaterialActivityUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAssemblyArgs = {
  _append?: Maybe<ArgoMaterialAssemblyAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialAssemblyDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialAssemblyDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialAssemblyDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialAssemblyPrependInput>;
  _set?: Maybe<ArgoMaterialAssemblySetInput>;
  where: ArgoMaterialAssemblyBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAssemblyManyArgs = {
  updates: Array<ArgoMaterialAssemblyUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeArgs = {
  _set?: Maybe<ArgoMaterialAttributeSetInput>;
  where: ArgoMaterialAttributeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeByPkArgs = {
  _set?: Maybe<ArgoMaterialAttributeSetInput>;
  pk_columns: ArgoMaterialAttributePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeHistoryArgs = {
  _set?: Maybe<ArgoMaterialAttributeHistorySetInput>;
  where: ArgoMaterialAttributeHistoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeHistoryByPkArgs = {
  _set?: Maybe<ArgoMaterialAttributeHistorySetInput>;
  pk_columns: ArgoMaterialAttributeHistoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeHistoryManyArgs = {
  updates: Array<ArgoMaterialAttributeHistoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialAttributeManyArgs = {
  updates: Array<ArgoMaterialAttributeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialByPkArgs = {
  _append?: Maybe<ArgoMaterialAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialPrependInput>;
  _set?: Maybe<ArgoMaterialSetInput>;
  pk_columns: ArgoMaterialPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassArgs = {
  _append?: Maybe<ArgoMaterialClassAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialClassIncInput>;
  _prepend?: Maybe<ArgoMaterialClassPrependInput>;
  _set?: Maybe<ArgoMaterialClassSetInput>;
  where: ArgoMaterialClassBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeArgs = {
  _set?: Maybe<ArgoMaterialClassAttributeSetInput>;
  where: ArgoMaterialClassAttributeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeByPkArgs = {
  _set?: Maybe<ArgoMaterialClassAttributeSetInput>;
  pk_columns: ArgoMaterialClassAttributePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeManyArgs = {
  updates: Array<ArgoMaterialClassAttributeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeSettingArgs = {
  _append?: Maybe<ArgoMaterialClassAttributeSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassAttributeSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassAttributeSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassAttributeSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialClassAttributeSettingPrependInput>;
  _set?: Maybe<ArgoMaterialClassAttributeSettingSetInput>;
  where: ArgoMaterialClassAttributeSettingBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeSettingByPkArgs = {
  _append?: Maybe<ArgoMaterialClassAttributeSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassAttributeSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassAttributeSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassAttributeSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialClassAttributeSettingPrependInput>;
  _set?: Maybe<ArgoMaterialClassAttributeSettingSetInput>;
  pk_columns: ArgoMaterialClassAttributeSettingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassAttributeSettingManyArgs = {
  updates: Array<ArgoMaterialClassAttributeSettingUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassByPkArgs = {
  _append?: Maybe<ArgoMaterialClassAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialClassIncInput>;
  _prepend?: Maybe<ArgoMaterialClassPrependInput>;
  _set?: Maybe<ArgoMaterialClassSetInput>;
  pk_columns: ArgoMaterialClassPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassManyArgs = {
  updates: Array<ArgoMaterialClassUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassProcessArgs = {
  _append?: Maybe<ArgoMaterialClassProcessAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassProcessDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassProcessDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialClassProcessPrependInput>;
  _set?: Maybe<ArgoMaterialClassProcessSetInput>;
  where: ArgoMaterialClassProcessBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassProcessByPkArgs = {
  _append?: Maybe<ArgoMaterialClassProcessAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialClassProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialClassProcessDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialClassProcessDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialClassProcessPrependInput>;
  _set?: Maybe<ArgoMaterialClassProcessSetInput>;
  pk_columns: ArgoMaterialClassProcessPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialClassProcessManyArgs = {
  updates: Array<ArgoMaterialClassProcessUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialManyArgs = {
  updates: Array<ArgoMaterialUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageArgs = {
  _append?: Maybe<ArgoMaterialMarriageAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialMarriageDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialMarriageDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialMarriageDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialMarriagePrependInput>;
  _set?: Maybe<ArgoMaterialMarriageSetInput>;
  where: ArgoMaterialMarriageBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageByPkArgs = {
  _append?: Maybe<ArgoMaterialMarriageAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialMarriageDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialMarriageDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialMarriageDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialMarriagePrependInput>;
  _set?: Maybe<ArgoMaterialMarriageSetInput>;
  pk_columns: ArgoMaterialMarriagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageManyArgs = {
  updates: Array<ArgoMaterialMarriageUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageStatusArgs = {
  _set?: Maybe<ArgoMaterialMarriageStatusSetInput>;
  where: ArgoMaterialMarriageStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageStatusByPkArgs = {
  _set?: Maybe<ArgoMaterialMarriageStatusSetInput>;
  pk_columns: ArgoMaterialMarriageStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialMarriageStatusManyArgs = {
  updates: Array<ArgoMaterialMarriageStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelArgs = {
  _append?: Maybe<ArgoMaterialModelAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialModelIncInput>;
  _prepend?: Maybe<ArgoMaterialModelPrependInput>;
  _set?: Maybe<ArgoMaterialModelSetInput>;
  where: ArgoMaterialModelBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeArgs = {
  _set?: Maybe<ArgoMaterialModelAttributeSetInput>;
  where: ArgoMaterialModelAttributeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeByPkArgs = {
  _set?: Maybe<ArgoMaterialModelAttributeSetInput>;
  pk_columns: ArgoMaterialModelAttributePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeManyArgs = {
  updates: Array<ArgoMaterialModelAttributeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeSettingArgs = {
  _append?: Maybe<ArgoMaterialModelAttributeSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelAttributeSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelAttributeSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelAttributeSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialModelAttributeSettingPrependInput>;
  _set?: Maybe<ArgoMaterialModelAttributeSettingSetInput>;
  where: ArgoMaterialModelAttributeSettingBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeSettingByPkArgs = {
  _append?: Maybe<ArgoMaterialModelAttributeSettingAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelAttributeSettingDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelAttributeSettingDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelAttributeSettingDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialModelAttributeSettingPrependInput>;
  _set?: Maybe<ArgoMaterialModelAttributeSettingSetInput>;
  pk_columns: ArgoMaterialModelAttributeSettingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelAttributeSettingManyArgs = {
  updates: Array<ArgoMaterialModelAttributeSettingUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelByPkArgs = {
  _append?: Maybe<ArgoMaterialModelAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialModelIncInput>;
  _prepend?: Maybe<ArgoMaterialModelPrependInput>;
  _set?: Maybe<ArgoMaterialModelSetInput>;
  pk_columns: ArgoMaterialModelPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelManyArgs = {
  updates: Array<ArgoMaterialModelUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelProcessArgs = {
  _append?: Maybe<ArgoMaterialModelProcessAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelProcessDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelProcessDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialModelProcessPrependInput>;
  _set?: Maybe<ArgoMaterialModelProcessSetInput>;
  where: ArgoMaterialModelProcessBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelProcessByPkArgs = {
  _append?: Maybe<ArgoMaterialModelProcessAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialModelProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialModelProcessDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialModelProcessDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialModelProcessPrependInput>;
  _set?: Maybe<ArgoMaterialModelProcessSetInput>;
  pk_columns: ArgoMaterialModelProcessPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialModelProcessManyArgs = {
  updates: Array<ArgoMaterialModelProcessUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialQuantityKindArgs = {
  _set?: Maybe<ArgoMaterialQuantityKindSetInput>;
  where: ArgoMaterialQuantityKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialQuantityKindByPkArgs = {
  _set?: Maybe<ArgoMaterialQuantityKindSetInput>;
  pk_columns: ArgoMaterialQuantityKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialQuantityKindManyArgs = {
  updates: Array<ArgoMaterialQuantityKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialStatusArgs = {
  _set?: Maybe<ArgoMaterialStatusSetInput>;
  where: ArgoMaterialStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialStatusByPkArgs = {
  _set?: Maybe<ArgoMaterialStatusSetInput>;
  pk_columns: ArgoMaterialStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialStatusManyArgs = {
  updates: Array<ArgoMaterialStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDataArgs = {
  _append?: Maybe<ArgoMaterialUdfDataAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfDataDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialUdfDataIncInput>;
  _prepend?: Maybe<ArgoMaterialUdfDataPrependInput>;
  _set?: Maybe<ArgoMaterialUdfDataSetInput>;
  where: ArgoMaterialUdfDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDataByPkArgs = {
  _append?: Maybe<ArgoMaterialUdfDataAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfDataDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialUdfDataIncInput>;
  _prepend?: Maybe<ArgoMaterialUdfDataPrependInput>;
  _set?: Maybe<ArgoMaterialUdfDataSetInput>;
  pk_columns: ArgoMaterialUdfDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDataManyArgs = {
  updates: Array<ArgoMaterialUdfDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDefaultDataArgs = {
  _append?: Maybe<ArgoMaterialUdfDefaultDataAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfDefaultDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfDefaultDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfDefaultDataDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialUdfDefaultDataIncInput>;
  _prepend?: Maybe<ArgoMaterialUdfDefaultDataPrependInput>;
  _set?: Maybe<ArgoMaterialUdfDefaultDataSetInput>;
  where: ArgoMaterialUdfDefaultDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDefaultDataByPkArgs = {
  _append?: Maybe<ArgoMaterialUdfDefaultDataAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfDefaultDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfDefaultDataDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfDefaultDataDeleteKeyInput>;
  _inc?: Maybe<ArgoMaterialUdfDefaultDataIncInput>;
  _prepend?: Maybe<ArgoMaterialUdfDefaultDataPrependInput>;
  _set?: Maybe<ArgoMaterialUdfDefaultDataSetInput>;
  pk_columns: ArgoMaterialUdfDefaultDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfDefaultDataManyArgs = {
  updates: Array<ArgoMaterialUdfDefaultDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfSchemaArgs = {
  _append?: Maybe<ArgoMaterialUdfSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfSchemaDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialUdfSchemaPrependInput>;
  _set?: Maybe<ArgoMaterialUdfSchemaSetInput>;
  where: ArgoMaterialUdfSchemaBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfSchemaByPkArgs = {
  _append?: Maybe<ArgoMaterialUdfSchemaAppendInput>;
  _delete_at_path?: Maybe<ArgoMaterialUdfSchemaDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMaterialUdfSchemaDeleteElemInput>;
  _delete_key?: Maybe<ArgoMaterialUdfSchemaDeleteKeyInput>;
  _prepend?: Maybe<ArgoMaterialUdfSchemaPrependInput>;
  _set?: Maybe<ArgoMaterialUdfSchemaSetInput>;
  pk_columns: ArgoMaterialUdfSchemaPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMaterialUdfSchemaManyArgs = {
  updates: Array<ArgoMaterialUdfSchemaUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMediaConfigArgs = {
  _append?: Maybe<ArgoMediaConfigAppendInput>;
  _delete_at_path?: Maybe<ArgoMediaConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMediaConfigDeleteElemInput>;
  _delete_key?: Maybe<ArgoMediaConfigDeleteKeyInput>;
  _inc?: Maybe<ArgoMediaConfigIncInput>;
  _prepend?: Maybe<ArgoMediaConfigPrependInput>;
  _set?: Maybe<ArgoMediaConfigSetInput>;
  where: ArgoMediaConfigBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMediaConfigByPkArgs = {
  _append?: Maybe<ArgoMediaConfigAppendInput>;
  _delete_at_path?: Maybe<ArgoMediaConfigDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoMediaConfigDeleteElemInput>;
  _delete_key?: Maybe<ArgoMediaConfigDeleteKeyInput>;
  _inc?: Maybe<ArgoMediaConfigIncInput>;
  _prepend?: Maybe<ArgoMediaConfigPrependInput>;
  _set?: Maybe<ArgoMediaConfigSetInput>;
  pk_columns: ArgoMediaConfigPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMediaConfigManyArgs = {
  updates: Array<ArgoMediaConfigUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoMediaInstanceArgs = {
  _inc?: Maybe<ArgoMediaInstanceIncInput>;
  _set?: Maybe<ArgoMediaInstanceSetInput>;
  where: ArgoMediaInstanceBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoMediaInstanceByPkArgs = {
  _inc?: Maybe<ArgoMediaInstanceIncInput>;
  _set?: Maybe<ArgoMediaInstanceSetInput>;
  pk_columns: ArgoMediaInstancePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoMediaInstanceManyArgs = {
  updates: Array<ArgoMediaInstanceUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoRoleArgs = {
  _append?: Maybe<ArgoRoleAppendInput>;
  _delete_at_path?: Maybe<ArgoRoleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoRoleDeleteElemInput>;
  _delete_key?: Maybe<ArgoRoleDeleteKeyInput>;
  _prepend?: Maybe<ArgoRolePrependInput>;
  _set?: Maybe<ArgoRoleSetInput>;
  where: ArgoRoleBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoRoleAclArgs = {
  _append?: Maybe<ArgoRoleAclAppendInput>;
  _delete_at_path?: Maybe<ArgoRoleAclDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoRoleAclDeleteElemInput>;
  _delete_key?: Maybe<ArgoRoleAclDeleteKeyInput>;
  _prepend?: Maybe<ArgoRoleAclPrependInput>;
  _set?: Maybe<ArgoRoleAclSetInput>;
  where: ArgoRoleAclBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoRoleAclByPkArgs = {
  _append?: Maybe<ArgoRoleAclAppendInput>;
  _delete_at_path?: Maybe<ArgoRoleAclDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoRoleAclDeleteElemInput>;
  _delete_key?: Maybe<ArgoRoleAclDeleteKeyInput>;
  _prepend?: Maybe<ArgoRoleAclPrependInput>;
  _set?: Maybe<ArgoRoleAclSetInput>;
  pk_columns: ArgoRoleAclPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoRoleAclManyArgs = {
  updates: Array<ArgoRoleAclUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoRoleByPkArgs = {
  _append?: Maybe<ArgoRoleAppendInput>;
  _delete_at_path?: Maybe<ArgoRoleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoRoleDeleteElemInput>;
  _delete_key?: Maybe<ArgoRoleDeleteKeyInput>;
  _prepend?: Maybe<ArgoRolePrependInput>;
  _set?: Maybe<ArgoRoleSetInput>;
  pk_columns: ArgoRolePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoRoleManyArgs = {
  updates: Array<ArgoRoleUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleArgs = {
  _append?: Maybe<ArgoScheduleAppendInput>;
  _delete_at_path?: Maybe<ArgoScheduleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoScheduleDeleteElemInput>;
  _delete_key?: Maybe<ArgoScheduleDeleteKeyInput>;
  _prepend?: Maybe<ArgoSchedulePrependInput>;
  _set?: Maybe<ArgoScheduleSetInput>;
  where: ArgoScheduleBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleByPkArgs = {
  _append?: Maybe<ArgoScheduleAppendInput>;
  _delete_at_path?: Maybe<ArgoScheduleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoScheduleDeleteElemInput>;
  _delete_key?: Maybe<ArgoScheduleDeleteKeyInput>;
  _prepend?: Maybe<ArgoSchedulePrependInput>;
  _set?: Maybe<ArgoScheduleSetInput>;
  pk_columns: ArgoSchedulePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleDayArgs = {
  _set?: Maybe<ArgoScheduleDaySetInput>;
  where: ArgoScheduleDayBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleDayByPkArgs = {
  _set?: Maybe<ArgoScheduleDaySetInput>;
  pk_columns: ArgoScheduleDayPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleDayManyArgs = {
  updates: Array<ArgoScheduleDayUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleEventArgs = {
  _append?: Maybe<ArgoScheduleEventAppendInput>;
  _delete_at_path?: Maybe<ArgoScheduleEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoScheduleEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoScheduleEventDeleteKeyInput>;
  _inc?: Maybe<ArgoScheduleEventIncInput>;
  _prepend?: Maybe<ArgoScheduleEventPrependInput>;
  _set?: Maybe<ArgoScheduleEventSetInput>;
  where: ArgoScheduleEventBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleEventByPkArgs = {
  _append?: Maybe<ArgoScheduleEventAppendInput>;
  _delete_at_path?: Maybe<ArgoScheduleEventDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoScheduleEventDeleteElemInput>;
  _delete_key?: Maybe<ArgoScheduleEventDeleteKeyInput>;
  _inc?: Maybe<ArgoScheduleEventIncInput>;
  _prepend?: Maybe<ArgoScheduleEventPrependInput>;
  _set?: Maybe<ArgoScheduleEventSetInput>;
  pk_columns: ArgoScheduleEventPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleEventManyArgs = {
  updates: Array<ArgoScheduleEventUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleManyArgs = {
  updates: Array<ArgoScheduleUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleModeArgs = {
  _set?: Maybe<ArgoScheduleModeSetInput>;
  where: ArgoScheduleModeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleModeByPkArgs = {
  _set?: Maybe<ArgoScheduleModeSetInput>;
  pk_columns: ArgoScheduleModePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoScheduleModeManyArgs = {
  updates: Array<ArgoScheduleModeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoSnArgs = {
  _append?: Maybe<ArgoSnAppendInput>;
  _delete_at_path?: Maybe<ArgoSnDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoSnDeleteElemInput>;
  _delete_key?: Maybe<ArgoSnDeleteKeyInput>;
  _inc?: Maybe<ArgoSnIncInput>;
  _prepend?: Maybe<ArgoSnPrependInput>;
  _set?: Maybe<ArgoSnSetInput>;
  where: ArgoSnBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoSnByPkArgs = {
  _append?: Maybe<ArgoSnAppendInput>;
  _delete_at_path?: Maybe<ArgoSnDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoSnDeleteElemInput>;
  _delete_key?: Maybe<ArgoSnDeleteKeyInput>;
  _inc?: Maybe<ArgoSnIncInput>;
  _prepend?: Maybe<ArgoSnPrependInput>;
  _set?: Maybe<ArgoSnSetInput>;
  pk_columns: ArgoSnPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatArgs = {
  _append?: Maybe<ArgoSnFormatAppendInput>;
  _delete_at_path?: Maybe<ArgoSnFormatDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoSnFormatDeleteElemInput>;
  _delete_key?: Maybe<ArgoSnFormatDeleteKeyInput>;
  _inc?: Maybe<ArgoSnFormatIncInput>;
  _prepend?: Maybe<ArgoSnFormatPrependInput>;
  _set?: Maybe<ArgoSnFormatSetInput>;
  where: ArgoSnFormatBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatByPkArgs = {
  _append?: Maybe<ArgoSnFormatAppendInput>;
  _delete_at_path?: Maybe<ArgoSnFormatDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoSnFormatDeleteElemInput>;
  _delete_key?: Maybe<ArgoSnFormatDeleteKeyInput>;
  _inc?: Maybe<ArgoSnFormatIncInput>;
  _prepend?: Maybe<ArgoSnFormatPrependInput>;
  _set?: Maybe<ArgoSnFormatSetInput>;
  pk_columns: ArgoSnFormatPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatManyArgs = {
  updates: Array<ArgoSnFormatUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatStatusArgs = {
  _set?: Maybe<ArgoSnFormatStatusSetInput>;
  where: ArgoSnFormatStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatStatusByPkArgs = {
  _set?: Maybe<ArgoSnFormatStatusSetInput>;
  pk_columns: ArgoSnFormatStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatStatusManyArgs = {
  updates: Array<ArgoSnFormatStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatUniquenessArgs = {
  _set?: Maybe<ArgoSnFormatUniquenessSetInput>;
  where: ArgoSnFormatUniquenessBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatUniquenessByPkArgs = {
  _set?: Maybe<ArgoSnFormatUniquenessSetInput>;
  pk_columns: ArgoSnFormatUniquenessPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoSnFormatUniquenessManyArgs = {
  updates: Array<ArgoSnFormatUniquenessUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoSnManyArgs = {
  updates: Array<ArgoSnUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnArgs = {
  _append?: Maybe<ArgoUdfColumnAppendInput>;
  _delete_at_path?: Maybe<ArgoUdfColumnDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUdfColumnDeleteElemInput>;
  _delete_key?: Maybe<ArgoUdfColumnDeleteKeyInput>;
  _inc?: Maybe<ArgoUdfColumnIncInput>;
  _prepend?: Maybe<ArgoUdfColumnPrependInput>;
  _set?: Maybe<ArgoUdfColumnSetInput>;
  where: ArgoUdfColumnBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnByPkArgs = {
  _append?: Maybe<ArgoUdfColumnAppendInput>;
  _delete_at_path?: Maybe<ArgoUdfColumnDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUdfColumnDeleteElemInput>;
  _delete_key?: Maybe<ArgoUdfColumnDeleteKeyInput>;
  _inc?: Maybe<ArgoUdfColumnIncInput>;
  _prepend?: Maybe<ArgoUdfColumnPrependInput>;
  _set?: Maybe<ArgoUdfColumnSetInput>;
  pk_columns: ArgoUdfColumnPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnDataTypeArgs = {
  _set?: Maybe<ArgoUdfColumnDataTypeSetInput>;
  where: ArgoUdfColumnDataTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnDataTypeByPkArgs = {
  _set?: Maybe<ArgoUdfColumnDataTypeSetInput>;
  pk_columns: ArgoUdfColumnDataTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnDataTypeManyArgs = {
  updates: Array<ArgoUdfColumnDataTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnManyArgs = {
  updates: Array<ArgoUdfColumnUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnTypeArgs = {
  _set?: Maybe<ArgoUdfColumnTypeSetInput>;
  where: ArgoUdfColumnTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnTypeByPkArgs = {
  _set?: Maybe<ArgoUdfColumnTypeSetInput>;
  pk_columns: ArgoUdfColumnTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUdfColumnTypeManyArgs = {
  updates: Array<ArgoUdfColumnTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUomArgs = {
  _append?: Maybe<ArgoUomAppendInput>;
  _delete_at_path?: Maybe<ArgoUomDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUomDeleteElemInput>;
  _delete_key?: Maybe<ArgoUomDeleteKeyInput>;
  _inc?: Maybe<ArgoUomIncInput>;
  _prepend?: Maybe<ArgoUomPrependInput>;
  _set?: Maybe<ArgoUomSetInput>;
  where: ArgoUomBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUomByPkArgs = {
  _append?: Maybe<ArgoUomAppendInput>;
  _delete_at_path?: Maybe<ArgoUomDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUomDeleteElemInput>;
  _delete_key?: Maybe<ArgoUomDeleteKeyInput>;
  _inc?: Maybe<ArgoUomIncInput>;
  _prepend?: Maybe<ArgoUomPrependInput>;
  _set?: Maybe<ArgoUomSetInput>;
  pk_columns: ArgoUomPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUomManyArgs = {
  updates: Array<ArgoUomUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUserArgs = {
  _append?: Maybe<ArgoUserAppendInput>;
  _delete_at_path?: Maybe<ArgoUserDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserPrependInput>;
  _set?: Maybe<ArgoUserSetInput>;
  where: ArgoUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUserAccessTokenArgs = {
  _append?: Maybe<ArgoUserAccessTokenAppendInput>;
  _delete_at_path?: Maybe<ArgoUserAccessTokenDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserAccessTokenDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserAccessTokenDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserAccessTokenPrependInput>;
  _set?: Maybe<ArgoUserAccessTokenSetInput>;
  where: ArgoUserAccessTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUserAccessTokenByPkArgs = {
  _append?: Maybe<ArgoUserAccessTokenAppendInput>;
  _delete_at_path?: Maybe<ArgoUserAccessTokenDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserAccessTokenDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserAccessTokenDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserAccessTokenPrependInput>;
  _set?: Maybe<ArgoUserAccessTokenSetInput>;
  pk_columns: ArgoUserAccessTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUserAccessTokenManyArgs = {
  updates: Array<ArgoUserAccessTokenUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUserBadgeArgs = {
  _set?: Maybe<ArgoUserBadgeSetInput>;
  where: ArgoUserBadgeBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUserBadgeByPkArgs = {
  _set?: Maybe<ArgoUserBadgeSetInput>;
  pk_columns: ArgoUserBadgePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUserBadgeManyArgs = {
  updates: Array<ArgoUserBadgeUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUserByPkArgs = {
  _append?: Maybe<ArgoUserAppendInput>;
  _delete_at_path?: Maybe<ArgoUserDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserPrependInput>;
  _set?: Maybe<ArgoUserSetInput>;
  pk_columns: ArgoUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUserContextArgs = {
  _append?: Maybe<ArgoUserContextAppendInput>;
  _delete_at_path?: Maybe<ArgoUserContextDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserContextDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserContextDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserContextPrependInput>;
  _set?: Maybe<ArgoUserContextSetInput>;
  where: ArgoUserContextBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUserContextByPkArgs = {
  _append?: Maybe<ArgoUserContextAppendInput>;
  _delete_at_path?: Maybe<ArgoUserContextDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserContextDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserContextDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserContextPrependInput>;
  _set?: Maybe<ArgoUserContextSetInput>;
  pk_columns: ArgoUserContextPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUserContextManyArgs = {
  updates: Array<ArgoUserContextUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUserManyArgs = {
  updates: Array<ArgoUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoUserRoleArgs = {
  _append?: Maybe<ArgoUserRoleAppendInput>;
  _delete_at_path?: Maybe<ArgoUserRoleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserRoleDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserRoleDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserRolePrependInput>;
  _set?: Maybe<ArgoUserRoleSetInput>;
  where: ArgoUserRoleBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoUserRoleByPkArgs = {
  _append?: Maybe<ArgoUserRoleAppendInput>;
  _delete_at_path?: Maybe<ArgoUserRoleDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoUserRoleDeleteElemInput>;
  _delete_key?: Maybe<ArgoUserRoleDeleteKeyInput>;
  _prepend?: Maybe<ArgoUserRolePrependInput>;
  _set?: Maybe<ArgoUserRoleSetInput>;
  pk_columns: ArgoUserRolePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoUserRoleManyArgs = {
  updates: Array<ArgoUserRoleUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoVwUserAclsArgs = {
  _append?: Maybe<ArgoVwUserAclsAppendInput>;
  _delete_at_path?: Maybe<ArgoVwUserAclsDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoVwUserAclsDeleteElemInput>;
  _delete_key?: Maybe<ArgoVwUserAclsDeleteKeyInput>;
  _prepend?: Maybe<ArgoVwUserAclsPrependInput>;
  _set?: Maybe<ArgoVwUserAclsSetInput>;
  where: ArgoVwUserAclsBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoVwUserAclsManyArgs = {
  updates: Array<ArgoVwUserAclsUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionArgs = {
  _set?: Maybe<ArgoWorkInstructionSetInput>;
  where: ArgoWorkInstructionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionByPkArgs = {
  _set?: Maybe<ArgoWorkInstructionSetInput>;
  pk_columns: ArgoWorkInstructionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceArgs = {
  _set?: Maybe<ArgoWorkInstructionInstanceSetInput>;
  where: ArgoWorkInstructionInstanceBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceByPkArgs = {
  _set?: Maybe<ArgoWorkInstructionInstanceSetInput>;
  pk_columns: ArgoWorkInstructionInstancePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceManyArgs = {
  updates: Array<ArgoWorkInstructionInstanceUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStatusArgs = {
  _set?: Maybe<ArgoWorkInstructionInstanceStatusSetInput>;
  where: ArgoWorkInstructionInstanceStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStatusByPkArgs = {
  _set?: Maybe<ArgoWorkInstructionInstanceStatusSetInput>;
  pk_columns: ArgoWorkInstructionInstanceStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStatusManyArgs = {
  updates: Array<ArgoWorkInstructionInstanceStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStepArgs = {
  _append?: Maybe<ArgoWorkInstructionInstanceStepAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkInstructionInstanceStepDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkInstructionInstanceStepDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkInstructionInstanceStepDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkInstructionInstanceStepIncInput>;
  _prepend?: Maybe<ArgoWorkInstructionInstanceStepPrependInput>;
  _set?: Maybe<ArgoWorkInstructionInstanceStepSetInput>;
  where: ArgoWorkInstructionInstanceStepBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStepByPkArgs = {
  _append?: Maybe<ArgoWorkInstructionInstanceStepAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkInstructionInstanceStepDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkInstructionInstanceStepDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkInstructionInstanceStepDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkInstructionInstanceStepIncInput>;
  _prepend?: Maybe<ArgoWorkInstructionInstanceStepPrependInput>;
  _set?: Maybe<ArgoWorkInstructionInstanceStepSetInput>;
  pk_columns: ArgoWorkInstructionInstanceStepPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionInstanceStepManyArgs = {
  updates: Array<ArgoWorkInstructionInstanceStepUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionManyArgs = {
  updates: Array<ArgoWorkInstructionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionArgs = {
  _append?: Maybe<ArgoWorkInstructionVersionAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkInstructionVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkInstructionVersionDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkInstructionVersionDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkInstructionVersionIncInput>;
  _prepend?: Maybe<ArgoWorkInstructionVersionPrependInput>;
  _set?: Maybe<ArgoWorkInstructionVersionSetInput>;
  where: ArgoWorkInstructionVersionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionByPkArgs = {
  _append?: Maybe<ArgoWorkInstructionVersionAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkInstructionVersionDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkInstructionVersionDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkInstructionVersionDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkInstructionVersionIncInput>;
  _prepend?: Maybe<ArgoWorkInstructionVersionPrependInput>;
  _set?: Maybe<ArgoWorkInstructionVersionSetInput>;
  pk_columns: ArgoWorkInstructionVersionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionManyArgs = {
  updates: Array<ArgoWorkInstructionVersionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionStatusArgs = {
  _set?: Maybe<ArgoWorkInstructionVersionStatusSetInput>;
  where: ArgoWorkInstructionVersionStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionStatusByPkArgs = {
  _set?: Maybe<ArgoWorkInstructionVersionStatusSetInput>;
  pk_columns: ArgoWorkInstructionVersionStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkInstructionVersionStatusManyArgs = {
  updates: Array<ArgoWorkInstructionVersionStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderArgs = {
  _append?: Maybe<ArgoWorkOrderAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkOrderIncInput>;
  _prepend?: Maybe<ArgoWorkOrderPrependInput>;
  _set?: Maybe<ArgoWorkOrderSetInput>;
  where: ArgoWorkOrderBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityArgs = {
  _append?: Maybe<ArgoWorkOrderActivityAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderActivityDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderActivityDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderActivityDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderActivityPrependInput>;
  _set?: Maybe<ArgoWorkOrderActivitySetInput>;
  where: ArgoWorkOrderActivityBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityByPkArgs = {
  _append?: Maybe<ArgoWorkOrderActivityAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderActivityDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderActivityDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderActivityDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderActivityPrependInput>;
  _set?: Maybe<ArgoWorkOrderActivitySetInput>;
  pk_columns: ArgoWorkOrderActivityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityKindArgs = {
  _set?: Maybe<ArgoWorkOrderActivityKindSetInput>;
  where: ArgoWorkOrderActivityKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityKindByPkArgs = {
  _set?: Maybe<ArgoWorkOrderActivityKindSetInput>;
  pk_columns: ArgoWorkOrderActivityKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityKindManyArgs = {
  updates: Array<ArgoWorkOrderActivityKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderActivityManyArgs = {
  updates: Array<ArgoWorkOrderActivityUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderByPkArgs = {
  _append?: Maybe<ArgoWorkOrderAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderDeleteKeyInput>;
  _inc?: Maybe<ArgoWorkOrderIncInput>;
  _prepend?: Maybe<ArgoWorkOrderPrependInput>;
  _set?: Maybe<ArgoWorkOrderSetInput>;
  pk_columns: ArgoWorkOrderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderLocationArgs = {
  _append?: Maybe<ArgoWorkOrderLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderLocationPrependInput>;
  _set?: Maybe<ArgoWorkOrderLocationSetInput>;
  where: ArgoWorkOrderLocationBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderLocationByPkArgs = {
  _append?: Maybe<ArgoWorkOrderLocationAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderLocationDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderLocationDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderLocationDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderLocationPrependInput>;
  _set?: Maybe<ArgoWorkOrderLocationSetInput>;
  pk_columns: ArgoWorkOrderLocationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderLocationManyArgs = {
  updates: Array<ArgoWorkOrderLocationUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderManyArgs = {
  updates: Array<ArgoWorkOrderUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderMaterialArgs = {
  _append?: Maybe<ArgoWorkOrderMaterialAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderMaterialDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderMaterialDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderMaterialDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderMaterialPrependInput>;
  _set?: Maybe<ArgoWorkOrderMaterialSetInput>;
  where: ArgoWorkOrderMaterialBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderMaterialByPkArgs = {
  _append?: Maybe<ArgoWorkOrderMaterialAppendInput>;
  _delete_at_path?: Maybe<ArgoWorkOrderMaterialDeleteAtPathInput>;
  _delete_elem?: Maybe<ArgoWorkOrderMaterialDeleteElemInput>;
  _delete_key?: Maybe<ArgoWorkOrderMaterialDeleteKeyInput>;
  _prepend?: Maybe<ArgoWorkOrderMaterialPrependInput>;
  _set?: Maybe<ArgoWorkOrderMaterialSetInput>;
  pk_columns: ArgoWorkOrderMaterialPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderMaterialManyArgs = {
  updates: Array<ArgoWorkOrderMaterialUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderRestrictionArgs = {
  _set?: Maybe<ArgoWorkOrderRestrictionSetInput>;
  where: ArgoWorkOrderRestrictionBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderRestrictionByPkArgs = {
  _set?: Maybe<ArgoWorkOrderRestrictionSetInput>;
  pk_columns: ArgoWorkOrderRestrictionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderRestrictionManyArgs = {
  updates: Array<ArgoWorkOrderRestrictionUpdates>;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderStatusArgs = {
  _set?: Maybe<ArgoWorkOrderStatusSetInput>;
  where: ArgoWorkOrderStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderStatusByPkArgs = {
  _set?: Maybe<ArgoWorkOrderStatusSetInput>;
  pk_columns: ArgoWorkOrderStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateArgoWorkOrderStatusManyArgs = {
  updates: Array<ArgoWorkOrderStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisAssetArgs = {
  _append?: Maybe<FisAssetAppendInput>;
  _delete_at_path?: Maybe<FisAssetDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetDeleteElemInput>;
  _delete_key?: Maybe<FisAssetDeleteKeyInput>;
  _inc?: Maybe<FisAssetIncInput>;
  _prepend?: Maybe<FisAssetPrependInput>;
  _set?: Maybe<FisAssetSetInput>;
  where: FisAssetBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisAssetByPkArgs = {
  _append?: Maybe<FisAssetAppendInput>;
  _delete_at_path?: Maybe<FisAssetDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetDeleteElemInput>;
  _delete_key?: Maybe<FisAssetDeleteKeyInput>;
  _inc?: Maybe<FisAssetIncInput>;
  _prepend?: Maybe<FisAssetPrependInput>;
  _set?: Maybe<FisAssetSetInput>;
  pk_columns: FisAssetPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisAssetCodeArgs = {
  _append?: Maybe<FisAssetCodeAppendInput>;
  _delete_at_path?: Maybe<FisAssetCodeDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetCodeDeleteElemInput>;
  _delete_key?: Maybe<FisAssetCodeDeleteKeyInput>;
  _inc?: Maybe<FisAssetCodeIncInput>;
  _prepend?: Maybe<FisAssetCodePrependInput>;
  _set?: Maybe<FisAssetCodeSetInput>;
  where: FisAssetCodeBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisAssetCodeByPkArgs = {
  _append?: Maybe<FisAssetCodeAppendInput>;
  _delete_at_path?: Maybe<FisAssetCodeDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetCodeDeleteElemInput>;
  _delete_key?: Maybe<FisAssetCodeDeleteKeyInput>;
  _inc?: Maybe<FisAssetCodeIncInput>;
  _prepend?: Maybe<FisAssetCodePrependInput>;
  _set?: Maybe<FisAssetCodeSetInput>;
  pk_columns: FisAssetCodePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisAssetCodeManyArgs = {
  updates: Array<FisAssetCodeUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisAssetManyArgs = {
  updates: Array<FisAssetUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagArgs = {
  _append?: Maybe<FisAssetTagAppendInput>;
  _delete_at_path?: Maybe<FisAssetTagDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetTagDeleteElemInput>;
  _delete_key?: Maybe<FisAssetTagDeleteKeyInput>;
  _prepend?: Maybe<FisAssetTagPrependInput>;
  _set?: Maybe<FisAssetTagSetInput>;
  where: FisAssetTagBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagByPkArgs = {
  _append?: Maybe<FisAssetTagAppendInput>;
  _delete_at_path?: Maybe<FisAssetTagDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetTagDeleteElemInput>;
  _delete_key?: Maybe<FisAssetTagDeleteKeyInput>;
  _prepend?: Maybe<FisAssetTagPrependInput>;
  _set?: Maybe<FisAssetTagSetInput>;
  pk_columns: FisAssetTagPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagLinkArgs = {
  _set?: Maybe<FisAssetTagLinkSetInput>;
  where: FisAssetTagLinkBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagLinkByPkArgs = {
  _set?: Maybe<FisAssetTagLinkSetInput>;
  pk_columns: FisAssetTagLinkPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagLinkManyArgs = {
  updates: Array<FisAssetTagLinkUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisAssetTagManyArgs = {
  updates: Array<FisAssetTagUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisAssetTypeArgs = {
  _append?: Maybe<FisAssetTypeAppendInput>;
  _delete_at_path?: Maybe<FisAssetTypeDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetTypeDeleteElemInput>;
  _delete_key?: Maybe<FisAssetTypeDeleteKeyInput>;
  _prepend?: Maybe<FisAssetTypePrependInput>;
  _set?: Maybe<FisAssetTypeSetInput>;
  where: FisAssetTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisAssetTypeByPkArgs = {
  _append?: Maybe<FisAssetTypeAppendInput>;
  _delete_at_path?: Maybe<FisAssetTypeDeleteAtPathInput>;
  _delete_elem?: Maybe<FisAssetTypeDeleteElemInput>;
  _delete_key?: Maybe<FisAssetTypeDeleteKeyInput>;
  _prepend?: Maybe<FisAssetTypePrependInput>;
  _set?: Maybe<FisAssetTypeSetInput>;
  pk_columns: FisAssetTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisAssetTypeManyArgs = {
  updates: Array<FisAssetTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisCoreStateArgs = {
  _set?: Maybe<FisCoreStateSetInput>;
  where: FisCoreStateBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisCoreStateByPkArgs = {
  _set?: Maybe<FisCoreStateSetInput>;
  pk_columns: FisCoreStatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisCoreStateManyArgs = {
  updates: Array<FisCoreStateUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataArgs = {
  _append?: Maybe<FisDataAppendInput>;
  _delete_at_path?: Maybe<FisDataDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataDeleteElemInput>;
  _delete_key?: Maybe<FisDataDeleteKeyInput>;
  _inc?: Maybe<FisDataIncInput>;
  _prepend?: Maybe<FisDataPrependInput>;
  _set?: Maybe<FisDataSetInput>;
  where: FisDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataByPkArgs = {
  _append?: Maybe<FisDataAppendInput>;
  _delete_at_path?: Maybe<FisDataDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataDeleteElemInput>;
  _delete_key?: Maybe<FisDataDeleteKeyInput>;
  _inc?: Maybe<FisDataIncInput>;
  _prepend?: Maybe<FisDataPrependInput>;
  _set?: Maybe<FisDataSetInput>;
  pk_columns: FisDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataLabelArgs = {
  _append?: Maybe<FisDataLabelAppendInput>;
  _delete_at_path?: Maybe<FisDataLabelDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataLabelDeleteElemInput>;
  _delete_key?: Maybe<FisDataLabelDeleteKeyInput>;
  _prepend?: Maybe<FisDataLabelPrependInput>;
  _set?: Maybe<FisDataLabelSetInput>;
  where: FisDataLabelBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataLabelByPkArgs = {
  _append?: Maybe<FisDataLabelAppendInput>;
  _delete_at_path?: Maybe<FisDataLabelDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataLabelDeleteElemInput>;
  _delete_key?: Maybe<FisDataLabelDeleteKeyInput>;
  _prepend?: Maybe<FisDataLabelPrependInput>;
  _set?: Maybe<FisDataLabelSetInput>;
  pk_columns: FisDataLabelPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataLabelManyArgs = {
  updates: Array<FisDataLabelUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataManyArgs = {
  updates: Array<FisDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataTimingArgs = {
  _set?: Maybe<FisDataTimingSetInput>;
  where: FisDataTimingBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataTimingByPkArgs = {
  _set?: Maybe<FisDataTimingSetInput>;
  pk_columns: FisDataTimingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataTimingManyArgs = {
  updates: Array<FisDataTimingUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackCountArgs = {
  _append?: Maybe<FisDataTrackCountAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackCountDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackCountDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackCountDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackCountIncInput>;
  _prepend?: Maybe<FisDataTrackCountPrependInput>;
  _set?: Maybe<FisDataTrackCountSetInput>;
  where: FisDataTrackCountBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackCountByPkArgs = {
  _append?: Maybe<FisDataTrackCountAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackCountDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackCountDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackCountDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackCountIncInput>;
  _prepend?: Maybe<FisDataTrackCountPrependInput>;
  _set?: Maybe<FisDataTrackCountSetInput>;
  pk_columns: FisDataTrackCountPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackCountManyArgs = {
  updates: Array<FisDataTrackCountUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackDurationArgs = {
  _append?: Maybe<FisDataTrackDurationAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackDurationDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackDurationDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackDurationDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackDurationIncInput>;
  _prepend?: Maybe<FisDataTrackDurationPrependInput>;
  _set?: Maybe<FisDataTrackDurationSetInput>;
  where: FisDataTrackDurationBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackDurationByPkArgs = {
  _append?: Maybe<FisDataTrackDurationAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackDurationDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackDurationDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackDurationDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackDurationIncInput>;
  _prepend?: Maybe<FisDataTrackDurationPrependInput>;
  _set?: Maybe<FisDataTrackDurationSetInput>;
  pk_columns: FisDataTrackDurationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackDurationManyArgs = {
  updates: Array<FisDataTrackDurationUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackScalarArgs = {
  _append?: Maybe<FisDataTrackScalarAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackScalarDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackScalarDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackScalarDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackScalarIncInput>;
  _prepend?: Maybe<FisDataTrackScalarPrependInput>;
  _set?: Maybe<FisDataTrackScalarSetInput>;
  where: FisDataTrackScalarBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackScalarByPkArgs = {
  _append?: Maybe<FisDataTrackScalarAppendInput>;
  _delete_at_path?: Maybe<FisDataTrackScalarDeleteAtPathInput>;
  _delete_elem?: Maybe<FisDataTrackScalarDeleteElemInput>;
  _delete_key?: Maybe<FisDataTrackScalarDeleteKeyInput>;
  _inc?: Maybe<FisDataTrackScalarIncInput>;
  _prepend?: Maybe<FisDataTrackScalarPrependInput>;
  _set?: Maybe<FisDataTrackScalarSetInput>;
  pk_columns: FisDataTrackScalarPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataTrackScalarManyArgs = {
  updates: Array<FisDataTrackScalarUpdates>;
};


/** mutation root */
export type MutationRootUpdateFisDataTypeArgs = {
  _set?: Maybe<FisDataTypeSetInput>;
  where: FisDataTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateFisDataTypeByPkArgs = {
  _set?: Maybe<FisDataTypeSetInput>;
  pk_columns: FisDataTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFisDataTypeManyArgs = {
  updates: Array<FisDataTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionArgs = {
  _append?: Maybe<ProcessCollectionAppendInput>;
  _delete_at_path?: Maybe<ProcessCollectionDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessCollectionDeleteElemInput>;
  _delete_key?: Maybe<ProcessCollectionDeleteKeyInput>;
  _prepend?: Maybe<ProcessCollectionPrependInput>;
  _set?: Maybe<ProcessCollectionSetInput>;
  where: ProcessCollectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionByPkArgs = {
  _append?: Maybe<ProcessCollectionAppendInput>;
  _delete_at_path?: Maybe<ProcessCollectionDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessCollectionDeleteElemInput>;
  _delete_key?: Maybe<ProcessCollectionDeleteKeyInput>;
  _prepend?: Maybe<ProcessCollectionPrependInput>;
  _set?: Maybe<ProcessCollectionSetInput>;
  pk_columns: ProcessCollectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionDataArgs = {
  _append?: Maybe<ProcessCollectionDataAppendInput>;
  _delete_at_path?: Maybe<ProcessCollectionDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessCollectionDataDeleteElemInput>;
  _delete_key?: Maybe<ProcessCollectionDataDeleteKeyInput>;
  _inc?: Maybe<ProcessCollectionDataIncInput>;
  _prepend?: Maybe<ProcessCollectionDataPrependInput>;
  _set?: Maybe<ProcessCollectionDataSetInput>;
  where: ProcessCollectionDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionDataByPkArgs = {
  _append?: Maybe<ProcessCollectionDataAppendInput>;
  _delete_at_path?: Maybe<ProcessCollectionDataDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessCollectionDataDeleteElemInput>;
  _delete_key?: Maybe<ProcessCollectionDataDeleteKeyInput>;
  _inc?: Maybe<ProcessCollectionDataIncInput>;
  _prepend?: Maybe<ProcessCollectionDataPrependInput>;
  _set?: Maybe<ProcessCollectionDataSetInput>;
  pk_columns: ProcessCollectionDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionDataManyArgs = {
  updates: Array<ProcessCollectionDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionKindArgs = {
  _set?: Maybe<ProcessCollectionKindSetInput>;
  where: ProcessCollectionKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionKindByPkArgs = {
  _set?: Maybe<ProcessCollectionKindSetInput>;
  pk_columns: ProcessCollectionKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionKindManyArgs = {
  updates: Array<ProcessCollectionKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessCollectionManyArgs = {
  updates: Array<ProcessCollectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementArgs = {
  _append?: Maybe<ProcessDataElementAppendInput>;
  _delete_at_path?: Maybe<ProcessDataElementDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessDataElementDeleteElemInput>;
  _delete_key?: Maybe<ProcessDataElementDeleteKeyInput>;
  _inc?: Maybe<ProcessDataElementIncInput>;
  _prepend?: Maybe<ProcessDataElementPrependInput>;
  _set?: Maybe<ProcessDataElementSetInput>;
  where: ProcessDataElementBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementByPkArgs = {
  _append?: Maybe<ProcessDataElementAppendInput>;
  _delete_at_path?: Maybe<ProcessDataElementDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessDataElementDeleteElemInput>;
  _delete_key?: Maybe<ProcessDataElementDeleteKeyInput>;
  _inc?: Maybe<ProcessDataElementIncInput>;
  _prepend?: Maybe<ProcessDataElementPrependInput>;
  _set?: Maybe<ProcessDataElementSetInput>;
  pk_columns: ProcessDataElementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementCollectionKindArgs = {
  _set?: Maybe<ProcessDataElementCollectionKindSetInput>;
  where: ProcessDataElementCollectionKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementCollectionKindByPkArgs = {
  _set?: Maybe<ProcessDataElementCollectionKindSetInput>;
  pk_columns: ProcessDataElementCollectionKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementCollectionKindManyArgs = {
  updates: Array<ProcessDataElementCollectionKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementKindArgs = {
  _set?: Maybe<ProcessDataElementKindSetInput>;
  where: ProcessDataElementKindBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementKindByPkArgs = {
  _set?: Maybe<ProcessDataElementKindSetInput>;
  pk_columns: ProcessDataElementKindPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementKindManyArgs = {
  updates: Array<ProcessDataElementKindUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessDataElementManyArgs = {
  updates: Array<ProcessDataElementUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateArgs = {
  _append?: Maybe<ProcessMaterialStateAppendInput>;
  _delete_at_path?: Maybe<ProcessMaterialStateDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessMaterialStateDeleteElemInput>;
  _delete_key?: Maybe<ProcessMaterialStateDeleteKeyInput>;
  _inc?: Maybe<ProcessMaterialStateIncInput>;
  _prepend?: Maybe<ProcessMaterialStatePrependInput>;
  _set?: Maybe<ProcessMaterialStateSetInput>;
  where: ProcessMaterialStateBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateByPkArgs = {
  _append?: Maybe<ProcessMaterialStateAppendInput>;
  _delete_at_path?: Maybe<ProcessMaterialStateDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessMaterialStateDeleteElemInput>;
  _delete_key?: Maybe<ProcessMaterialStateDeleteKeyInput>;
  _inc?: Maybe<ProcessMaterialStateIncInput>;
  _prepend?: Maybe<ProcessMaterialStatePrependInput>;
  _set?: Maybe<ProcessMaterialStateSetInput>;
  pk_columns: ProcessMaterialStatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateHistoryArgs = {
  _append?: Maybe<ProcessMaterialStateHistoryAppendInput>;
  _delete_at_path?: Maybe<ProcessMaterialStateHistoryDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessMaterialStateHistoryDeleteElemInput>;
  _delete_key?: Maybe<ProcessMaterialStateHistoryDeleteKeyInput>;
  _inc?: Maybe<ProcessMaterialStateHistoryIncInput>;
  _prepend?: Maybe<ProcessMaterialStateHistoryPrependInput>;
  _set?: Maybe<ProcessMaterialStateHistorySetInput>;
  where: ProcessMaterialStateHistoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateHistoryByPkArgs = {
  _append?: Maybe<ProcessMaterialStateHistoryAppendInput>;
  _delete_at_path?: Maybe<ProcessMaterialStateHistoryDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessMaterialStateHistoryDeleteElemInput>;
  _delete_key?: Maybe<ProcessMaterialStateHistoryDeleteKeyInput>;
  _inc?: Maybe<ProcessMaterialStateHistoryIncInput>;
  _prepend?: Maybe<ProcessMaterialStateHistoryPrependInput>;
  _set?: Maybe<ProcessMaterialStateHistorySetInput>;
  pk_columns: ProcessMaterialStateHistoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateHistoryManyArgs = {
  updates: Array<ProcessMaterialStateHistoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessMaterialStateManyArgs = {
  updates: Array<ProcessMaterialStateUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessProcessArgs = {
  _append?: Maybe<ProcessProcessAppendInput>;
  _delete_at_path?: Maybe<ProcessProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessProcessDeleteElemInput>;
  _delete_key?: Maybe<ProcessProcessDeleteKeyInput>;
  _prepend?: Maybe<ProcessProcessPrependInput>;
  _set?: Maybe<ProcessProcessSetInput>;
  where: ProcessProcessBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessProcessByPkArgs = {
  _append?: Maybe<ProcessProcessAppendInput>;
  _delete_at_path?: Maybe<ProcessProcessDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessProcessDeleteElemInput>;
  _delete_key?: Maybe<ProcessProcessDeleteKeyInput>;
  _prepend?: Maybe<ProcessProcessPrependInput>;
  _set?: Maybe<ProcessProcessSetInput>;
  pk_columns: ProcessProcessPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessProcessManyArgs = {
  updates: Array<ProcessProcessUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessProcessStatusArgs = {
  _set?: Maybe<ProcessProcessStatusSetInput>;
  where: ProcessProcessStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessProcessStatusByPkArgs = {
  _set?: Maybe<ProcessProcessStatusSetInput>;
  pk_columns: ProcessProcessStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessProcessStatusManyArgs = {
  updates: Array<ProcessProcessStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessSpecArgs = {
  _append?: Maybe<ProcessSpecAppendInput>;
  _delete_at_path?: Maybe<ProcessSpecDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessSpecDeleteElemInput>;
  _delete_key?: Maybe<ProcessSpecDeleteKeyInput>;
  _prepend?: Maybe<ProcessSpecPrependInput>;
  _set?: Maybe<ProcessSpecSetInput>;
  where: ProcessSpecBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessSpecByPkArgs = {
  _append?: Maybe<ProcessSpecAppendInput>;
  _delete_at_path?: Maybe<ProcessSpecDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessSpecDeleteElemInput>;
  _delete_key?: Maybe<ProcessSpecDeleteKeyInput>;
  _prepend?: Maybe<ProcessSpecPrependInput>;
  _set?: Maybe<ProcessSpecSetInput>;
  pk_columns: ProcessSpecPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessSpecManyArgs = {
  updates: Array<ProcessSpecUpdates>;
};


/** mutation root */
export type MutationRootUpdateProcessSpecOrderArgs = {
  _append?: Maybe<ProcessSpecOrderAppendInput>;
  _delete_at_path?: Maybe<ProcessSpecOrderDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessSpecOrderDeleteElemInput>;
  _delete_key?: Maybe<ProcessSpecOrderDeleteKeyInput>;
  _prepend?: Maybe<ProcessSpecOrderPrependInput>;
  _set?: Maybe<ProcessSpecOrderSetInput>;
  where: ProcessSpecOrderBoolExp;
};


/** mutation root */
export type MutationRootUpdateProcessSpecOrderByPkArgs = {
  _append?: Maybe<ProcessSpecOrderAppendInput>;
  _delete_at_path?: Maybe<ProcessSpecOrderDeleteAtPathInput>;
  _delete_elem?: Maybe<ProcessSpecOrderDeleteElemInput>;
  _delete_key?: Maybe<ProcessSpecOrderDeleteKeyInput>;
  _prepend?: Maybe<ProcessSpecOrderPrependInput>;
  _set?: Maybe<ProcessSpecOrderSetInput>;
  pk_columns: ProcessSpecOrderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProcessSpecOrderManyArgs = {
  updates: Array<ProcessSpecOrderUpdates>;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "plv8_response" */
export type Plv8Response = {
  __typename?: 'plv8_response';
  id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "plv8_response" */
export type Plv8ResponseAggregate = {
  __typename?: 'plv8_response_aggregate';
  aggregate?: Maybe<Plv8ResponseAggregateFields>;
  nodes: Array<Plv8Response>;
};

/** aggregate fields of "plv8_response" */
export type Plv8ResponseAggregateFields = {
  __typename?: 'plv8_response_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Plv8ResponseMaxFields>;
  min?: Maybe<Plv8ResponseMinFields>;
};


/** aggregate fields of "plv8_response" */
export type Plv8ResponseAggregateFieldsCountArgs = {
  columns?: Maybe<Array<Plv8ResponseSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "plv8_response". All fields are combined with a logical 'AND'. */
export type Plv8ResponseBoolExp = {
  _and?: Maybe<Array<Plv8ResponseBoolExp>>;
  _not?: Maybe<Plv8ResponseBoolExp>;
  _or?: Maybe<Array<Plv8ResponseBoolExp>>;
  id?: Maybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type Plv8ResponseMaxFields = {
  __typename?: 'plv8_response_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Plv8ResponseMinFields = {
  __typename?: 'plv8_response_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "plv8_response". */
export type Plv8ResponseOrderBy = {
  id?: Maybe<OrderBy>;
};

/** select columns of table "plv8_response" */
export enum Plv8ResponseSelectColumn {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "plv8_response" */
export type Plv8ResponseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: Plv8ResponseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type Plv8ResponseStreamCursorValueInput = {
  id?: Maybe<Scalars['String']>;
};

/** columns and relationships of "plv8_value_response" */
export type Plv8ValueResponse = {
  __typename?: 'plv8_value_response';
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "plv8_value_response" */
export type Plv8ValueResponseAggregate = {
  __typename?: 'plv8_value_response_aggregate';
  aggregate?: Maybe<Plv8ValueResponseAggregateFields>;
  nodes: Array<Plv8ValueResponse>;
};

/** aggregate fields of "plv8_value_response" */
export type Plv8ValueResponseAggregateFields = {
  __typename?: 'plv8_value_response_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Plv8ValueResponseMaxFields>;
  min?: Maybe<Plv8ValueResponseMinFields>;
};


/** aggregate fields of "plv8_value_response" */
export type Plv8ValueResponseAggregateFieldsCountArgs = {
  columns?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "plv8_value_response". All fields are combined with a logical 'AND'. */
export type Plv8ValueResponseBoolExp = {
  _and?: Maybe<Array<Plv8ValueResponseBoolExp>>;
  _not?: Maybe<Plv8ValueResponseBoolExp>;
  _or?: Maybe<Array<Plv8ValueResponseBoolExp>>;
  value?: Maybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type Plv8ValueResponseMaxFields = {
  __typename?: 'plv8_value_response_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Plv8ValueResponseMinFields = {
  __typename?: 'plv8_value_response_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "plv8_value_response". */
export type Plv8ValueResponseOrderBy = {
  value?: Maybe<OrderBy>;
};

/** select columns of table "plv8_value_response" */
export enum Plv8ValueResponseSelectColumn {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "plv8_value_response" */
export type Plv8ValueResponseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: Plv8ValueResponseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type Plv8ValueResponseStreamCursorValueInput = {
  value?: Maybe<Scalars['String']>;
};

export type ProcessCollectArgs = {
  data?: Maybe<Scalars['process_collect_args_data']>;
  location_id?: Maybe<Scalars['uuid']>;
  material_state_id?: Maybe<Scalars['uuid']>;
};


/** Collection table */
export type ProcessCollection = {
  __typename?: 'process_collection';
  /** An array relationship */
  collection_data: Array<ProcessCollectionData>;
  /** An aggregate relationship */
  collection_data_aggregate: ProcessCollectionDataAggregate;
  /** An object relationship */
  collection_kind: ProcessCollectionKind;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** The kind of collection for this entry */
  kind: ProcessCollectionKindEnum;
  /** An object relationship */
  location: ArgoLocation;
  /** The location for this entry */
  location_id: Scalars['uuid'];
  /** An object relationship */
  material_state: ProcessMaterialState;
  /** The process material state for this entry */
  material_state_id: Scalars['uuid'];
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not this entry passed validation */
  pass: Scalars['Boolean'];
};


/** Collection table */
export type ProcessCollectionCollectionDataArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


/** Collection table */
export type ProcessCollectionCollectionDataAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


/** Collection table */
export type ProcessCollectionMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.collection" */
export type ProcessCollectionAggregate = {
  __typename?: 'process_collection_aggregate';
  aggregate?: Maybe<ProcessCollectionAggregateFields>;
  nodes: Array<ProcessCollection>;
};

export type ProcessCollectionAggregateBoolExp = {
  bool_and?: Maybe<ProcessCollectionAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ProcessCollectionAggregateBoolExpBoolOr>;
  count?: Maybe<ProcessCollectionAggregateBoolExpCount>;
};

export type ProcessCollectionAggregateBoolExpBoolAnd = {
  arguments: ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessCollectionBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessCollectionAggregateBoolExpBoolOr = {
  arguments: ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessCollectionBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessCollectionAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessCollectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessCollectionBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.collection" */
export type ProcessCollectionAggregateFields = {
  __typename?: 'process_collection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessCollectionMaxFields>;
  min?: Maybe<ProcessCollectionMinFields>;
};


/** aggregate fields of "process.collection" */
export type ProcessCollectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessCollectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.collection" */
export type ProcessCollectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessCollectionMaxOrderBy>;
  min?: Maybe<ProcessCollectionMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessCollectionAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.collection" */
export type ProcessCollectionArrRelInsertInput = {
  data: Array<ProcessCollectionInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessCollectionOnConflict>;
};

/** Boolean expression to filter rows from the table "process.collection". All fields are combined with a logical 'AND'. */
export type ProcessCollectionBoolExp = {
  _and?: Maybe<Array<ProcessCollectionBoolExp>>;
  _not?: Maybe<ProcessCollectionBoolExp>;
  _or?: Maybe<Array<ProcessCollectionBoolExp>>;
  collection_data?: Maybe<ProcessCollectionDataBoolExp>;
  collection_data_aggregate?: Maybe<ProcessCollectionDataAggregateBoolExp>;
  collection_kind?: Maybe<ProcessCollectionKindBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  failure_note?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  kind?: Maybe<ProcessCollectionKindEnumComparisonExp>;
  location?: Maybe<ArgoLocationBoolExp>;
  location_id?: Maybe<UuidComparisonExp>;
  material_state?: Maybe<ProcessMaterialStateBoolExp>;
  material_state_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  pass?: Maybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "process.collection" */
export enum ProcessCollectionConstraint {
  /** unique or primary key constraint on columns "collection_id" */
  CollectionPkey = 'collection_pkey'
}

/** Collection Data table */
export type ProcessCollectionData = {
  __typename?: 'process_collection_data';
  /** An object relationship */
  collection: ProcessCollection;
  /** The Collection for this entry */
  collection_id: Scalars['uuid'];
  /** An object relationship */
  data_element: ProcessDataElement;
  /** The Data Element for this entry */
  data_element_id: Scalars['uuid'];
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};


/** Collection Data table */
export type ProcessCollectionDataMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.collection_data" */
export type ProcessCollectionDataAggregate = {
  __typename?: 'process_collection_data_aggregate';
  aggregate?: Maybe<ProcessCollectionDataAggregateFields>;
  nodes: Array<ProcessCollectionData>;
};

export type ProcessCollectionDataAggregateBoolExp = {
  count?: Maybe<ProcessCollectionDataAggregateBoolExpCount>;
};

export type ProcessCollectionDataAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessCollectionDataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.collection_data" */
export type ProcessCollectionDataAggregateFields = {
  __typename?: 'process_collection_data_aggregate_fields';
  avg?: Maybe<ProcessCollectionDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProcessCollectionDataMaxFields>;
  min?: Maybe<ProcessCollectionDataMinFields>;
  stddev?: Maybe<ProcessCollectionDataStddevFields>;
  stddev_pop?: Maybe<ProcessCollectionDataStddevPopFields>;
  stddev_samp?: Maybe<ProcessCollectionDataStddevSampFields>;
  sum?: Maybe<ProcessCollectionDataSumFields>;
  var_pop?: Maybe<ProcessCollectionDataVarPopFields>;
  var_samp?: Maybe<ProcessCollectionDataVarSampFields>;
  variance?: Maybe<ProcessCollectionDataVarianceFields>;
};


/** aggregate fields of "process.collection_data" */
export type ProcessCollectionDataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.collection_data" */
export type ProcessCollectionDataAggregateOrderBy = {
  avg?: Maybe<ProcessCollectionDataAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessCollectionDataMaxOrderBy>;
  min?: Maybe<ProcessCollectionDataMinOrderBy>;
  stddev?: Maybe<ProcessCollectionDataStddevOrderBy>;
  stddev_pop?: Maybe<ProcessCollectionDataStddevPopOrderBy>;
  stddev_samp?: Maybe<ProcessCollectionDataStddevSampOrderBy>;
  sum?: Maybe<ProcessCollectionDataSumOrderBy>;
  var_pop?: Maybe<ProcessCollectionDataVarPopOrderBy>;
  var_samp?: Maybe<ProcessCollectionDataVarSampOrderBy>;
  variance?: Maybe<ProcessCollectionDataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessCollectionDataAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.collection_data" */
export type ProcessCollectionDataArrRelInsertInput = {
  data: Array<ProcessCollectionDataInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessCollectionDataOnConflict>;
};

/** aggregate avg on columns */
export type ProcessCollectionDataAvgFields = {
  __typename?: 'process_collection_data_avg_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "process.collection_data" */
export type ProcessCollectionDataAvgOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "process.collection_data". All fields are combined with a logical 'AND'. */
export type ProcessCollectionDataBoolExp = {
  _and?: Maybe<Array<ProcessCollectionDataBoolExp>>;
  _not?: Maybe<ProcessCollectionDataBoolExp>;
  _or?: Maybe<Array<ProcessCollectionDataBoolExp>>;
  collection?: Maybe<ProcessCollectionBoolExp>;
  collection_id?: Maybe<UuidComparisonExp>;
  data_element?: Maybe<ProcessDataElementBoolExp>;
  data_element_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  num_val?: Maybe<NumericComparisonExp>;
  str_val?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "process.collection_data" */
export enum ProcessCollectionDataConstraint {
  /** unique or primary key constraint on columns "data_element_id", "collection_id" */
  CollectionDataPkey = 'collection_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessCollectionDataDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessCollectionDataDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessCollectionDataDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "process.collection_data" */
export type ProcessCollectionDataIncInput = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "process.collection_data" */
export type ProcessCollectionDataInsertInput = {
  collection?: Maybe<ProcessCollectionObjRelInsertInput>;
  /** The Collection for this entry */
  collection_id?: Maybe<Scalars['uuid']>;
  data_element?: Maybe<ProcessDataElementObjRelInsertInput>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProcessCollectionDataMaxFields = {
  __typename?: 'process_collection_data_max_fields';
  /** The Collection for this entry */
  collection_id?: Maybe<Scalars['uuid']>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<Scalars['uuid']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "process.collection_data" */
export type ProcessCollectionDataMaxOrderBy = {
  /** The Collection for this entry */
  collection_id?: Maybe<OrderBy>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<OrderBy>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
  /** The Text Value for this entry */
  str_val?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessCollectionDataMinFields = {
  __typename?: 'process_collection_data_min_fields';
  /** The Collection for this entry */
  collection_id?: Maybe<Scalars['uuid']>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<Scalars['uuid']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "process.collection_data" */
export type ProcessCollectionDataMinOrderBy = {
  /** The Collection for this entry */
  collection_id?: Maybe<OrderBy>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<OrderBy>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
  /** The Text Value for this entry */
  str_val?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.collection_data" */
export type ProcessCollectionDataMutationResponse = {
  __typename?: 'process_collection_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessCollectionData>;
};

/** input type for inserting object relation for remote table "process.collection_data" */
export type ProcessCollectionDataObjRelInsertInput = {
  data: ProcessCollectionDataInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessCollectionDataOnConflict>;
};

/** on_conflict condition type for table "process.collection_data" */
export type ProcessCollectionDataOnConflict = {
  constraint: ProcessCollectionDataConstraint;
  update_columns?: Array<ProcessCollectionDataUpdateColumn>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};

/** Ordering options when selecting data from "process.collection_data". */
export type ProcessCollectionDataOrderBy = {
  collection?: Maybe<ProcessCollectionOrderBy>;
  collection_id?: Maybe<OrderBy>;
  data_element?: Maybe<ProcessDataElementOrderBy>;
  data_element_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  num_val?: Maybe<OrderBy>;
  str_val?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.collection_data */
export type ProcessCollectionDataPkColumnsInput = {
  /** The Collection for this entry */
  collection_id: Scalars['uuid'];
  /** The Data Element for this entry */
  data_element_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessCollectionDataPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.collection_data" */
export enum ProcessCollectionDataSelectColumn {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val'
}

/** input type for updating data in table "process.collection_data" */
export type ProcessCollectionDataSetInput = {
  /** The Collection for this entry */
  collection_id?: Maybe<Scalars['uuid']>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProcessCollectionDataStddevFields = {
  __typename?: 'process_collection_data_stddev_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "process.collection_data" */
export type ProcessCollectionDataStddevOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProcessCollectionDataStddevPopFields = {
  __typename?: 'process_collection_data_stddev_pop_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "process.collection_data" */
export type ProcessCollectionDataStddevPopOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProcessCollectionDataStddevSampFields = {
  __typename?: 'process_collection_data_stddev_samp_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "process.collection_data" */
export type ProcessCollectionDataStddevSampOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "process_collection_data" */
export type ProcessCollectionDataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessCollectionDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessCollectionDataStreamCursorValueInput = {
  /** The Collection for this entry */
  collection_id?: Maybe<Scalars['uuid']>;
  /** The Data Element for this entry */
  data_element_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
  /** The Text Value for this entry */
  str_val?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProcessCollectionDataSumFields = {
  __typename?: 'process_collection_data_sum_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "process.collection_data" */
export type ProcessCollectionDataSumOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** update columns of table "process.collection_data" */
export enum ProcessCollectionDataUpdateColumn {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val'
}

export type ProcessCollectionDataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessCollectionDataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessCollectionDataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessCollectionDataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessCollectionDataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ProcessCollectionDataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessCollectionDataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessCollectionDataSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessCollectionDataBoolExp;
};

/** aggregate var_pop on columns */
export type ProcessCollectionDataVarPopFields = {
  __typename?: 'process_collection_data_var_pop_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "process.collection_data" */
export type ProcessCollectionDataVarPopOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProcessCollectionDataVarSampFields = {
  __typename?: 'process_collection_data_var_samp_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "process.collection_data" */
export type ProcessCollectionDataVarSampOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProcessCollectionDataVarianceFields = {
  __typename?: 'process_collection_data_variance_fields';
  /** The Numeric Value for this entry */
  num_val?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "process.collection_data" */
export type ProcessCollectionDataVarianceOrderBy = {
  /** The Numeric Value for this entry */
  num_val?: Maybe<OrderBy>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessCollectionDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessCollectionDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessCollectionDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "process.collection" */
export type ProcessCollectionInsertInput = {
  collection_data?: Maybe<ProcessCollectionDataArrRelInsertInput>;
  collection_kind?: Maybe<ProcessCollectionKindObjRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The kind of collection for this entry */
  kind?: Maybe<ProcessCollectionKindEnum>;
  location?: Maybe<ArgoLocationObjRelInsertInput>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  material_state?: Maybe<ProcessMaterialStateObjRelInsertInput>;
  /** The process material state for this entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not this entry passed validation */
  pass?: Maybe<Scalars['Boolean']>;
};

/** collection kinds */
export type ProcessCollectionKind = {
  __typename?: 'process_collection_kind';
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind: Scalars['String'];
};

/** aggregated selection of "process.collection_kind" */
export type ProcessCollectionKindAggregate = {
  __typename?: 'process_collection_kind_aggregate';
  aggregate?: Maybe<ProcessCollectionKindAggregateFields>;
  nodes: Array<ProcessCollectionKind>;
};

/** aggregate fields of "process.collection_kind" */
export type ProcessCollectionKindAggregateFields = {
  __typename?: 'process_collection_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessCollectionKindMaxFields>;
  min?: Maybe<ProcessCollectionKindMinFields>;
};


/** aggregate fields of "process.collection_kind" */
export type ProcessCollectionKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessCollectionKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "process.collection_kind". All fields are combined with a logical 'AND'. */
export type ProcessCollectionKindBoolExp = {
  _and?: Maybe<Array<ProcessCollectionKindBoolExp>>;
  _not?: Maybe<ProcessCollectionKindBoolExp>;
  _or?: Maybe<Array<ProcessCollectionKindBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  kind?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "process.collection_kind" */
export enum ProcessCollectionKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  CollectionKindPkey = 'collection_kind_pkey'
}

export enum ProcessCollectionKindEnum {
  /** A value is provided during collection */
  Collect = 'collect',
  /** The value is provided by the process */
  SpecParam = 'spec_param'
}

/** Boolean expression to compare columns of type "process_collection_kind_enum". All fields are combined with logical 'AND'. */
export type ProcessCollectionKindEnumComparisonExp = {
  _eq?: Maybe<ProcessCollectionKindEnum>;
  _in?: Maybe<Array<ProcessCollectionKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ProcessCollectionKindEnum>;
  _nin?: Maybe<Array<ProcessCollectionKindEnum>>;
};

/** input type for inserting data into table "process.collection_kind" */
export type ProcessCollectionKindInsertInput = {
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProcessCollectionKindMaxFields = {
  __typename?: 'process_collection_kind_max_fields';
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProcessCollectionKindMinFields = {
  __typename?: 'process_collection_kind_min_fields';
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "process.collection_kind" */
export type ProcessCollectionKindMutationResponse = {
  __typename?: 'process_collection_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessCollectionKind>;
};

/** input type for inserting object relation for remote table "process.collection_kind" */
export type ProcessCollectionKindObjRelInsertInput = {
  data: ProcessCollectionKindInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessCollectionKindOnConflict>;
};

/** on_conflict condition type for table "process.collection_kind" */
export type ProcessCollectionKindOnConflict = {
  constraint: ProcessCollectionKindConstraint;
  update_columns?: Array<ProcessCollectionKindUpdateColumn>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};

/** Ordering options when selecting data from "process.collection_kind". */
export type ProcessCollectionKindOrderBy = {
  description?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.collection_kind */
export type ProcessCollectionKindPkColumnsInput = {
  /** a case-insensitive identifier */
  kind: Scalars['String'];
};

/** select columns of table "process.collection_kind" */
export enum ProcessCollectionKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "process.collection_kind" */
export type ProcessCollectionKindSetInput = {
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "process_collection_kind" */
export type ProcessCollectionKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessCollectionKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessCollectionKindStreamCursorValueInput = {
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** update columns of table "process.collection_kind" */
export enum ProcessCollectionKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

export type ProcessCollectionKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessCollectionKindSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessCollectionKindBoolExp;
};

/** aggregate max on columns */
export type ProcessCollectionMaxFields = {
  __typename?: 'process_collection_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** The process material state for this entry */
  material_state_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "process.collection" */
export type ProcessCollectionMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The location for this entry */
  location_id?: Maybe<OrderBy>;
  /** The process material state for this entry */
  material_state_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessCollectionMinFields = {
  __typename?: 'process_collection_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** The process material state for this entry */
  material_state_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "process.collection" */
export type ProcessCollectionMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The location for this entry */
  location_id?: Maybe<OrderBy>;
  /** The process material state for this entry */
  material_state_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.collection" */
export type ProcessCollectionMutationResponse = {
  __typename?: 'process_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessCollection>;
};

/** input type for inserting object relation for remote table "process.collection" */
export type ProcessCollectionObjRelInsertInput = {
  data: ProcessCollectionInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessCollectionOnConflict>;
};

/** on_conflict condition type for table "process.collection" */
export type ProcessCollectionOnConflict = {
  constraint: ProcessCollectionConstraint;
  update_columns?: Array<ProcessCollectionUpdateColumn>;
  where?: Maybe<ProcessCollectionBoolExp>;
};

/** Ordering options when selecting data from "process.collection". */
export type ProcessCollectionOrderBy = {
  collection_data_aggregate?: Maybe<ProcessCollectionDataAggregateOrderBy>;
  collection_kind?: Maybe<ProcessCollectionKindOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  failure_note?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
  location?: Maybe<ArgoLocationOrderBy>;
  location_id?: Maybe<OrderBy>;
  material_state?: Maybe<ProcessMaterialStateOrderBy>;
  material_state_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  pass?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.collection */
export type ProcessCollectionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessCollectionPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.collection" */
export enum ProcessCollectionSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailureNote = 'failure_note',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Pass = 'pass'
}

/** select "process_collection_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.collection" */
export enum ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Pass = 'pass'
}

/** select "process_collection_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.collection" */
export enum ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Pass = 'pass'
}

/** input type for updating data in table "process.collection" */
export type ProcessCollectionSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The kind of collection for this entry */
  kind?: Maybe<ProcessCollectionKindEnum>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** The process material state for this entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not this entry passed validation */
  pass?: Maybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "process_collection" */
export type ProcessCollectionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessCollectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessCollectionStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** If a collection validation failed, which one failed and why/how to fix */
  failure_note?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The kind of collection for this entry */
  kind?: Maybe<ProcessCollectionKindEnum>;
  /** The location for this entry */
  location_id?: Maybe<Scalars['uuid']>;
  /** The process material state for this entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Whether or not this entry passed validation */
  pass?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "process.collection" */
export enum ProcessCollectionUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailureNote = 'failure_note',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Pass = 'pass'
}

export type ProcessCollectionUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessCollectionAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessCollectionDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessCollectionDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessCollectionDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessCollectionPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessCollectionSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessCollectionBoolExp;
};


/** A data element to collect data against (Ex: Bearing Press, Oven Temp, etc..) */
export type ProcessDataElement = {
  __typename?: 'process_data_element';
  /** Link to the data element collection kind */
  collection_kind: ProcessDataElementCollectionKindEnum;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An object relationship */
  data_element_collection_kind: ProcessDataElementCollectionKind;
  /** An object relationship */
  data_element_kind: ProcessDataElementKind;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** Link to the data element kind */
  kind: ProcessDataElementKindEnum;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** An updatable case-sensitive identifier */
  name: Scalars['String'];
  /** An updatable case-insensitive identifier */
  name_unique: Scalars['String'];
  /** An object relationship */
  process: ProcessProcess;
  /** Link to the process */
  process_id: Scalars['uuid'];
  /** An object relationship */
  uom?: Maybe<ArgoUom>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** A data element to collect data against (Ex: Bearing Press, Oven Temp, etc..) */
export type ProcessDataElementMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.data_element" */
export type ProcessDataElementAggregate = {
  __typename?: 'process_data_element_aggregate';
  aggregate?: Maybe<ProcessDataElementAggregateFields>;
  nodes: Array<ProcessDataElement>;
};

export type ProcessDataElementAggregateBoolExp = {
  bool_and?: Maybe<ProcessDataElementAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ProcessDataElementAggregateBoolExpBoolOr>;
  count?: Maybe<ProcessDataElementAggregateBoolExpCount>;
};

export type ProcessDataElementAggregateBoolExpBoolAnd = {
  arguments: ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessDataElementBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessDataElementAggregateBoolExpBoolOr = {
  arguments: ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessDataElementBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessDataElementAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessDataElementSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessDataElementBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.data_element" */
export type ProcessDataElementAggregateFields = {
  __typename?: 'process_data_element_aggregate_fields';
  avg?: Maybe<ProcessDataElementAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProcessDataElementMaxFields>;
  min?: Maybe<ProcessDataElementMinFields>;
  stddev?: Maybe<ProcessDataElementStddevFields>;
  stddev_pop?: Maybe<ProcessDataElementStddevPopFields>;
  stddev_samp?: Maybe<ProcessDataElementStddevSampFields>;
  sum?: Maybe<ProcessDataElementSumFields>;
  var_pop?: Maybe<ProcessDataElementVarPopFields>;
  var_samp?: Maybe<ProcessDataElementVarSampFields>;
  variance?: Maybe<ProcessDataElementVarianceFields>;
};


/** aggregate fields of "process.data_element" */
export type ProcessDataElementAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessDataElementSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.data_element" */
export type ProcessDataElementAggregateOrderBy = {
  avg?: Maybe<ProcessDataElementAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessDataElementMaxOrderBy>;
  min?: Maybe<ProcessDataElementMinOrderBy>;
  stddev?: Maybe<ProcessDataElementStddevOrderBy>;
  stddev_pop?: Maybe<ProcessDataElementStddevPopOrderBy>;
  stddev_samp?: Maybe<ProcessDataElementStddevSampOrderBy>;
  sum?: Maybe<ProcessDataElementSumOrderBy>;
  var_pop?: Maybe<ProcessDataElementVarPopOrderBy>;
  var_samp?: Maybe<ProcessDataElementVarSampOrderBy>;
  variance?: Maybe<ProcessDataElementVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessDataElementAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.data_element" */
export type ProcessDataElementArrRelInsertInput = {
  data: Array<ProcessDataElementInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessDataElementOnConflict>;
};

/** aggregate avg on columns */
export type ProcessDataElementAvgFields = {
  __typename?: 'process_data_element_avg_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "process.data_element" */
export type ProcessDataElementAvgOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "process.data_element". All fields are combined with a logical 'AND'. */
export type ProcessDataElementBoolExp = {
  _and?: Maybe<Array<ProcessDataElementBoolExp>>;
  _not?: Maybe<ProcessDataElementBoolExp>;
  _or?: Maybe<Array<ProcessDataElementBoolExp>>;
  collection_kind?: Maybe<ProcessDataElementCollectionKindEnumComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindBoolExp>;
  data_element_kind?: Maybe<ProcessDataElementKindBoolExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  kind?: Maybe<ProcessDataElementKindEnumComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  uom?: Maybe<ArgoUomBoolExp>;
  uom_id?: Maybe<BigintComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** different kinds of collection kinds data elements */
export type ProcessDataElementCollectionKind = {
  __typename?: 'process_data_element_collection_kind';
  /** a case-insensitive identifier */
  collection_kind: Scalars['String'];
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindAggregate = {
  __typename?: 'process_data_element_collection_kind_aggregate';
  aggregate?: Maybe<ProcessDataElementCollectionKindAggregateFields>;
  nodes: Array<ProcessDataElementCollectionKind>;
};

/** aggregate fields of "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindAggregateFields = {
  __typename?: 'process_data_element_collection_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessDataElementCollectionKindMaxFields>;
  min?: Maybe<ProcessDataElementCollectionKindMinFields>;
};


/** aggregate fields of "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessDataElementCollectionKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "process.data_element_collection_kind". All fields are combined with a logical 'AND'. */
export type ProcessDataElementCollectionKindBoolExp = {
  _and?: Maybe<Array<ProcessDataElementCollectionKindBoolExp>>;
  _not?: Maybe<ProcessDataElementCollectionKindBoolExp>;
  _or?: Maybe<Array<ProcessDataElementCollectionKindBoolExp>>;
  collection_kind?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindConstraint {
  /** unique or primary key constraint on columns "collection_kind" */
  DataElementCollectionKindPkey = 'data_element_collection_kind_pkey'
}

export enum ProcessDataElementCollectionKindEnum {
  /** A value is provided after a collection */
  Calc = 'calc',
  /** A value is provided during collection */
  Collect = 'collect',
  /** The value is provided by the process */
  SpecParam = 'spec_param'
}

/** Boolean expression to compare columns of type "process_data_element_collection_kind_enum". All fields are combined with logical 'AND'. */
export type ProcessDataElementCollectionKindEnumComparisonExp = {
  _eq?: Maybe<ProcessDataElementCollectionKindEnum>;
  _in?: Maybe<Array<ProcessDataElementCollectionKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ProcessDataElementCollectionKindEnum>;
  _nin?: Maybe<Array<ProcessDataElementCollectionKindEnum>>;
};

/** input type for inserting data into table "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindInsertInput = {
  /** a case-insensitive identifier */
  collection_kind?: Maybe<Scalars['String']>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProcessDataElementCollectionKindMaxFields = {
  __typename?: 'process_data_element_collection_kind_max_fields';
  /** a case-insensitive identifier */
  collection_kind?: Maybe<Scalars['String']>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProcessDataElementCollectionKindMinFields = {
  __typename?: 'process_data_element_collection_kind_min_fields';
  /** a case-insensitive identifier */
  collection_kind?: Maybe<Scalars['String']>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindMutationResponse = {
  __typename?: 'process_data_element_collection_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessDataElementCollectionKind>;
};

/** input type for inserting object relation for remote table "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindObjRelInsertInput = {
  data: ProcessDataElementCollectionKindInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessDataElementCollectionKindOnConflict>;
};

/** on_conflict condition type for table "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindOnConflict = {
  constraint: ProcessDataElementCollectionKindConstraint;
  update_columns?: Array<ProcessDataElementCollectionKindUpdateColumn>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};

/** Ordering options when selecting data from "process.data_element_collection_kind". */
export type ProcessDataElementCollectionKindOrderBy = {
  collection_kind?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.data_element_collection_kind */
export type ProcessDataElementCollectionKindPkColumnsInput = {
  /** a case-insensitive identifier */
  collection_kind: Scalars['String'];
};

/** select columns of table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindSelectColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "process.data_element_collection_kind" */
export type ProcessDataElementCollectionKindSetInput = {
  /** a case-insensitive identifier */
  collection_kind?: Maybe<Scalars['String']>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "process_data_element_collection_kind" */
export type ProcessDataElementCollectionKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessDataElementCollectionKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessDataElementCollectionKindStreamCursorValueInput = {
  /** a case-insensitive identifier */
  collection_kind?: Maybe<Scalars['String']>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
};

/** update columns of table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindUpdateColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  Description = 'description'
}

export type ProcessDataElementCollectionKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessDataElementCollectionKindSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessDataElementCollectionKindBoolExp;
};

/** unique or primary key constraints on table "process.data_element" */
export enum ProcessDataElementConstraint {
  /** unique or primary key constraint on columns "data_element_id" */
  DataElementPkey = 'data_element_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessDataElementDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessDataElementDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessDataElementDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "process.data_element" */
export type ProcessDataElementIncInput = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "process.data_element" */
export type ProcessDataElementInsertInput = {
  /** Link to the data element collection kind */
  collection_kind?: Maybe<ProcessDataElementCollectionKindEnum>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindObjRelInsertInput>;
  data_element_kind?: Maybe<ProcessDataElementKindObjRelInsertInput>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Link to the data element kind */
  kind?: Maybe<ProcessDataElementKindEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** Link to the process */
  process_id?: Maybe<Scalars['uuid']>;
  uom?: Maybe<ArgoUomObjRelInsertInput>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** different kinds for data elements that are available */
export type ProcessDataElementKind = {
  __typename?: 'process_data_element_kind';
  /** An array relationship */
  data_elements: Array<ProcessDataElement>;
  /** An aggregate relationship */
  data_elements_aggregate: ProcessDataElementAggregate;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind: Scalars['String'];
};


/** different kinds for data elements that are available */
export type ProcessDataElementKindDataElementsArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


/** different kinds for data elements that are available */
export type ProcessDataElementKindDataElementsAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};

/** aggregated selection of "process.data_element_kind" */
export type ProcessDataElementKindAggregate = {
  __typename?: 'process_data_element_kind_aggregate';
  aggregate?: Maybe<ProcessDataElementKindAggregateFields>;
  nodes: Array<ProcessDataElementKind>;
};

/** aggregate fields of "process.data_element_kind" */
export type ProcessDataElementKindAggregateFields = {
  __typename?: 'process_data_element_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessDataElementKindMaxFields>;
  min?: Maybe<ProcessDataElementKindMinFields>;
};


/** aggregate fields of "process.data_element_kind" */
export type ProcessDataElementKindAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessDataElementKindSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "process.data_element_kind". All fields are combined with a logical 'AND'. */
export type ProcessDataElementKindBoolExp = {
  _and?: Maybe<Array<ProcessDataElementKindBoolExp>>;
  _not?: Maybe<ProcessDataElementKindBoolExp>;
  _or?: Maybe<Array<ProcessDataElementKindBoolExp>>;
  data_elements?: Maybe<ProcessDataElementBoolExp>;
  data_elements_aggregate?: Maybe<ProcessDataElementAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  kind?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "process.data_element_kind" */
export enum ProcessDataElementKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  DataElementKindPkey = 'data_element_kind_pkey'
}

export enum ProcessDataElementKindEnum {
  /** A Material */
  Material = 'material',
  /** A Material Class */
  MaterialClass = 'material_class',
  /** A Material Model */
  MaterialModel = 'material_model',
  /** A numeric representation of data */
  Number = 'number',
  /** A numeric representation of data */
  Pass = 'pass',
  /** A textual representation of data */
  String = 'string'
}

/** Boolean expression to compare columns of type "process_data_element_kind_enum". All fields are combined with logical 'AND'. */
export type ProcessDataElementKindEnumComparisonExp = {
  _eq?: Maybe<ProcessDataElementKindEnum>;
  _in?: Maybe<Array<ProcessDataElementKindEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ProcessDataElementKindEnum>;
  _nin?: Maybe<Array<ProcessDataElementKindEnum>>;
};

/** input type for inserting data into table "process.data_element_kind" */
export type ProcessDataElementKindInsertInput = {
  data_elements?: Maybe<ProcessDataElementArrRelInsertInput>;
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProcessDataElementKindMaxFields = {
  __typename?: 'process_data_element_kind_max_fields';
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProcessDataElementKindMinFields = {
  __typename?: 'process_data_element_kind_min_fields';
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "process.data_element_kind" */
export type ProcessDataElementKindMutationResponse = {
  __typename?: 'process_data_element_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessDataElementKind>;
};

/** input type for inserting object relation for remote table "process.data_element_kind" */
export type ProcessDataElementKindObjRelInsertInput = {
  data: ProcessDataElementKindInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessDataElementKindOnConflict>;
};

/** on_conflict condition type for table "process.data_element_kind" */
export type ProcessDataElementKindOnConflict = {
  constraint: ProcessDataElementKindConstraint;
  update_columns?: Array<ProcessDataElementKindUpdateColumn>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};

/** Ordering options when selecting data from "process.data_element_kind". */
export type ProcessDataElementKindOrderBy = {
  data_elements_aggregate?: Maybe<ProcessDataElementAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.data_element_kind */
export type ProcessDataElementKindPkColumnsInput = {
  /** a case-insensitive identifier */
  kind: Scalars['String'];
};

/** select columns of table "process.data_element_kind" */
export enum ProcessDataElementKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** input type for updating data in table "process.data_element_kind" */
export type ProcessDataElementKindSetInput = {
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "process_data_element_kind" */
export type ProcessDataElementKindStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessDataElementKindStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessDataElementKindStreamCursorValueInput = {
  /** description of this entry */
  description?: Maybe<Scalars['String']>;
  /** a case-insensitive identifier */
  kind?: Maybe<Scalars['String']>;
};

/** update columns of table "process.data_element_kind" */
export enum ProcessDataElementKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

export type ProcessDataElementKindUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessDataElementKindSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessDataElementKindBoolExp;
};

/** aggregate max on columns */
export type ProcessDataElementMaxFields = {
  __typename?: 'process_data_element_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** Link to the process */
  process_id?: Maybe<Scalars['uuid']>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "process.data_element" */
export type ProcessDataElementMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** Link to the process */
  process_id?: Maybe<OrderBy>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessDataElementMinFields = {
  __typename?: 'process_data_element_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** Link to the process */
  process_id?: Maybe<Scalars['uuid']>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "process.data_element" */
export type ProcessDataElementMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Description of this entry */
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** Link to the process */
  process_id?: Maybe<OrderBy>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.data_element" */
export type ProcessDataElementMutationResponse = {
  __typename?: 'process_data_element_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessDataElement>;
};

/** input type for inserting object relation for remote table "process.data_element" */
export type ProcessDataElementObjRelInsertInput = {
  data: ProcessDataElementInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessDataElementOnConflict>;
};

/** on_conflict condition type for table "process.data_element" */
export type ProcessDataElementOnConflict = {
  constraint: ProcessDataElementConstraint;
  update_columns?: Array<ProcessDataElementUpdateColumn>;
  where?: Maybe<ProcessDataElementBoolExp>;
};

/** Ordering options when selecting data from "process.data_element". */
export type ProcessDataElementOrderBy = {
  collection_kind?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_element_collection_kind?: Maybe<ProcessDataElementCollectionKindOrderBy>;
  data_element_kind?: Maybe<ProcessDataElementKindOrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  kind?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  uom?: Maybe<ArgoUomOrderBy>;
  uom_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.data_element */
export type ProcessDataElementPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessDataElementPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.data_element" */
export enum ProcessDataElementSelectColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UomId = 'uom_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "process_data_element_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.data_element" */
export enum ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "process_data_element_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.data_element" */
export enum ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "process.data_element" */
export type ProcessDataElementSetInput = {
  /** Link to the data element collection kind */
  collection_kind?: Maybe<ProcessDataElementCollectionKindEnum>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Link to the data element kind */
  kind?: Maybe<ProcessDataElementKindEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** Link to the process */
  process_id?: Maybe<Scalars['uuid']>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ProcessDataElementStddevFields = {
  __typename?: 'process_data_element_stddev_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "process.data_element" */
export type ProcessDataElementStddevOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProcessDataElementStddevPopFields = {
  __typename?: 'process_data_element_stddev_pop_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "process.data_element" */
export type ProcessDataElementStddevPopOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProcessDataElementStddevSampFields = {
  __typename?: 'process_data_element_stddev_samp_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "process.data_element" */
export type ProcessDataElementStddevSampOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "process_data_element" */
export type ProcessDataElementStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessDataElementStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessDataElementStreamCursorValueInput = {
  /** Link to the data element collection kind */
  collection_kind?: Maybe<ProcessDataElementCollectionKindEnum>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Description of this entry */
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  /** Link to the data element kind */
  kind?: Maybe<ProcessDataElementKindEnum>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** An updatable case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** An updatable case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** Link to the process */
  process_id?: Maybe<Scalars['uuid']>;
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ProcessDataElementSumFields = {
  __typename?: 'process_data_element_sum_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "process.data_element" */
export type ProcessDataElementSumOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** update columns of table "process.data_element" */
export enum ProcessDataElementUpdateColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UomId = 'uom_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ProcessDataElementUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessDataElementAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessDataElementDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessDataElementDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessDataElementDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ProcessDataElementIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessDataElementPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessDataElementSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessDataElementBoolExp;
};

/** aggregate var_pop on columns */
export type ProcessDataElementVarPopFields = {
  __typename?: 'process_data_element_var_pop_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "process.data_element" */
export type ProcessDataElementVarPopOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProcessDataElementVarSampFields = {
  __typename?: 'process_data_element_var_samp_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "process.data_element" */
export type ProcessDataElementVarSampOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProcessDataElementVarianceFields = {
  __typename?: 'process_data_element_variance_fields';
  /** The unit of measure for this data element */
  uom_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "process.data_element" */
export type ProcessDataElementVarianceOrderBy = {
  /** The unit of measure for this data element */
  uom_id?: Maybe<OrderBy>;
};

export type ProcessGetOrSolveMaterialStateArgs = {
  location_id?: Maybe<Scalars['uuid']>;
  material_id?: Maybe<Scalars['uuid']>;
  process_id?: Maybe<Scalars['uuid']>;
};

/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialState = {
  __typename?: 'process_material_state';
  /** An array relationship */
  collections: Array<ProcessCollection>;
  /** An aggregate relationship */
  collections_aggregate: ProcessCollectionAggregate;
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** Total count of failed collection validations */
  fail_count: Scalars['Int'];
  id: Scalars['uuid'];
  /** An object relationship */
  material: ArgoMaterial;
  /** Material for this entry */
  material_id: Scalars['uuid'];
  /** An array relationship */
  material_state_histories: Array<ProcessMaterialStateHistory>;
  /** An aggregate relationship */
  material_state_histories_aggregate: ProcessMaterialStateHistoryAggregate;
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** Total count of passed collection validations */
  pass_count: Scalars['Int'];
  /** An object relationship */
  process: ProcessProcess;
  /** Process for this entry */
  process_id: Scalars['uuid'];
  /** An object relationship */
  process_state: ProcessProcessStatus;
  /** A reason for the state */
  reason: Scalars['String'];
  /** An object relationship */
  spec?: Maybe<ProcessSpec>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['process_spec_config_inheritless']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status: ProcessProcessStatusEnum;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateCollectionsArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateCollectionsAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateMaterialStateHistoriesArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateMaterialStateHistoriesAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Tracks the State of Process Instances for a Material */
export type ProcessMaterialStateSpecConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.material_state" */
export type ProcessMaterialStateAggregate = {
  __typename?: 'process_material_state_aggregate';
  aggregate?: Maybe<ProcessMaterialStateAggregateFields>;
  nodes: Array<ProcessMaterialState>;
};

export type ProcessMaterialStateAggregateBoolExp = {
  count?: Maybe<ProcessMaterialStateAggregateBoolExpCount>;
};

export type ProcessMaterialStateAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessMaterialStateBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.material_state" */
export type ProcessMaterialStateAggregateFields = {
  __typename?: 'process_material_state_aggregate_fields';
  avg?: Maybe<ProcessMaterialStateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProcessMaterialStateMaxFields>;
  min?: Maybe<ProcessMaterialStateMinFields>;
  stddev?: Maybe<ProcessMaterialStateStddevFields>;
  stddev_pop?: Maybe<ProcessMaterialStateStddevPopFields>;
  stddev_samp?: Maybe<ProcessMaterialStateStddevSampFields>;
  sum?: Maybe<ProcessMaterialStateSumFields>;
  var_pop?: Maybe<ProcessMaterialStateVarPopFields>;
  var_samp?: Maybe<ProcessMaterialStateVarSampFields>;
  variance?: Maybe<ProcessMaterialStateVarianceFields>;
};


/** aggregate fields of "process.material_state" */
export type ProcessMaterialStateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.material_state" */
export type ProcessMaterialStateAggregateOrderBy = {
  avg?: Maybe<ProcessMaterialStateAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessMaterialStateMaxOrderBy>;
  min?: Maybe<ProcessMaterialStateMinOrderBy>;
  stddev?: Maybe<ProcessMaterialStateStddevOrderBy>;
  stddev_pop?: Maybe<ProcessMaterialStateStddevPopOrderBy>;
  stddev_samp?: Maybe<ProcessMaterialStateStddevSampOrderBy>;
  sum?: Maybe<ProcessMaterialStateSumOrderBy>;
  var_pop?: Maybe<ProcessMaterialStateVarPopOrderBy>;
  var_samp?: Maybe<ProcessMaterialStateVarSampOrderBy>;
  variance?: Maybe<ProcessMaterialStateVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessMaterialStateAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.material_state" */
export type ProcessMaterialStateArrRelInsertInput = {
  data: Array<ProcessMaterialStateInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessMaterialStateOnConflict>;
};

/** aggregate avg on columns */
export type ProcessMaterialStateAvgFields = {
  __typename?: 'process_material_state_avg_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "process.material_state" */
export type ProcessMaterialStateAvgOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "process.material_state". All fields are combined with a logical 'AND'. */
export type ProcessMaterialStateBoolExp = {
  _and?: Maybe<Array<ProcessMaterialStateBoolExp>>;
  _not?: Maybe<ProcessMaterialStateBoolExp>;
  _or?: Maybe<Array<ProcessMaterialStateBoolExp>>;
  collections?: Maybe<ProcessCollectionBoolExp>;
  collections_aggregate?: Maybe<ProcessCollectionAggregateBoolExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  fail_count?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  material?: Maybe<ArgoMaterialBoolExp>;
  material_id?: Maybe<UuidComparisonExp>;
  material_state_histories?: Maybe<ProcessMaterialStateHistoryBoolExp>;
  material_state_histories_aggregate?: Maybe<ProcessMaterialStateHistoryAggregateBoolExp>;
  meta?: Maybe<JsonbComparisonExp>;
  pass_count?: Maybe<IntComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  process_state?: Maybe<ProcessProcessStatusBoolExp>;
  reason?: Maybe<StringComparisonExp>;
  spec?: Maybe<ProcessSpecBoolExp>;
  spec_config?: Maybe<JsonbComparisonExp>;
  spec_id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ProcessProcessStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "process.material_state" */
export enum ProcessMaterialStateConstraint {
  /** unique or primary key constraint on columns "material_state_id" */
  MaterialStatePkey = 'material_state_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessMaterialStateDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessMaterialStateDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessMaterialStateDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['String']>;
};

/** History Material Process State instances */
export type ProcessMaterialStateHistory = {
  __typename?: 'process_material_state_history';
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** Total count of failed collection validations */
  fail_count: Scalars['Int'];
  /** An object relationship */
  material_state: ProcessMaterialState;
  material_state_history_id: Scalars['uuid'];
  /** The referenced entry */
  material_state_id: Scalars['uuid'];
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count: Scalars['Int'];
  /** A reason for the state */
  reason: Scalars['String'];
  /** An object relationship */
  spec?: Maybe<ProcessSpec>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status: ProcessProcessStatusEnum;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** History Material Process State instances */
export type ProcessMaterialStateHistoryMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.material_state_history" */
export type ProcessMaterialStateHistoryAggregate = {
  __typename?: 'process_material_state_history_aggregate';
  aggregate?: Maybe<ProcessMaterialStateHistoryAggregateFields>;
  nodes: Array<ProcessMaterialStateHistory>;
};

export type ProcessMaterialStateHistoryAggregateBoolExp = {
  count?: Maybe<ProcessMaterialStateHistoryAggregateBoolExpCount>;
};

export type ProcessMaterialStateHistoryAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessMaterialStateHistoryBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.material_state_history" */
export type ProcessMaterialStateHistoryAggregateFields = {
  __typename?: 'process_material_state_history_aggregate_fields';
  avg?: Maybe<ProcessMaterialStateHistoryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProcessMaterialStateHistoryMaxFields>;
  min?: Maybe<ProcessMaterialStateHistoryMinFields>;
  stddev?: Maybe<ProcessMaterialStateHistoryStddevFields>;
  stddev_pop?: Maybe<ProcessMaterialStateHistoryStddevPopFields>;
  stddev_samp?: Maybe<ProcessMaterialStateHistoryStddevSampFields>;
  sum?: Maybe<ProcessMaterialStateHistorySumFields>;
  var_pop?: Maybe<ProcessMaterialStateHistoryVarPopFields>;
  var_samp?: Maybe<ProcessMaterialStateHistoryVarSampFields>;
  variance?: Maybe<ProcessMaterialStateHistoryVarianceFields>;
};


/** aggregate fields of "process.material_state_history" */
export type ProcessMaterialStateHistoryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.material_state_history" */
export type ProcessMaterialStateHistoryAggregateOrderBy = {
  avg?: Maybe<ProcessMaterialStateHistoryAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessMaterialStateHistoryMaxOrderBy>;
  min?: Maybe<ProcessMaterialStateHistoryMinOrderBy>;
  stddev?: Maybe<ProcessMaterialStateHistoryStddevOrderBy>;
  stddev_pop?: Maybe<ProcessMaterialStateHistoryStddevPopOrderBy>;
  stddev_samp?: Maybe<ProcessMaterialStateHistoryStddevSampOrderBy>;
  sum?: Maybe<ProcessMaterialStateHistorySumOrderBy>;
  var_pop?: Maybe<ProcessMaterialStateHistoryVarPopOrderBy>;
  var_samp?: Maybe<ProcessMaterialStateHistoryVarSampOrderBy>;
  variance?: Maybe<ProcessMaterialStateHistoryVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessMaterialStateHistoryAppendInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.material_state_history" */
export type ProcessMaterialStateHistoryArrRelInsertInput = {
  data: Array<ProcessMaterialStateHistoryInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessMaterialStateHistoryOnConflict>;
};

/** aggregate avg on columns */
export type ProcessMaterialStateHistoryAvgFields = {
  __typename?: 'process_material_state_history_avg_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryAvgOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "process.material_state_history". All fields are combined with a logical 'AND'. */
export type ProcessMaterialStateHistoryBoolExp = {
  _and?: Maybe<Array<ProcessMaterialStateHistoryBoolExp>>;
  _not?: Maybe<ProcessMaterialStateHistoryBoolExp>;
  _or?: Maybe<Array<ProcessMaterialStateHistoryBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  fail_count?: Maybe<IntComparisonExp>;
  material_state?: Maybe<ProcessMaterialStateBoolExp>;
  material_state_history_id?: Maybe<UuidComparisonExp>;
  material_state_id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  pass_count?: Maybe<IntComparisonExp>;
  reason?: Maybe<StringComparisonExp>;
  spec?: Maybe<ProcessSpecBoolExp>;
  spec_id?: Maybe<UuidComparisonExp>;
  status?: Maybe<ProcessProcessStatusEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "process.material_state_history" */
export enum ProcessMaterialStateHistoryConstraint {
  /** unique or primary key constraint on columns "material_state_history_id" */
  MaterialStateHistoryPkey = 'material_state_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessMaterialStateHistoryDeleteAtPathInput = {
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessMaterialStateHistoryDeleteElemInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessMaterialStateHistoryDeleteKeyInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "process.material_state_history" */
export type ProcessMaterialStateHistoryIncInput = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "process.material_state_history" */
export type ProcessMaterialStateHistoryInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  material_state?: Maybe<ProcessMaterialStateObjRelInsertInput>;
  material_state_history_id?: Maybe<Scalars['uuid']>;
  /** The referenced entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  spec?: Maybe<ProcessSpecObjRelInsertInput>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProcessMaterialStateHistoryMaxFields = {
  __typename?: 'process_material_state_history_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  material_state_history_id?: Maybe<Scalars['uuid']>;
  /** The referenced entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  material_state_history_id?: Maybe<OrderBy>;
  /** The referenced entry */
  material_state_id?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
  /** A reason for the state */
  reason?: Maybe<OrderBy>;
  /** Spec for this entry */
  spec_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessMaterialStateHistoryMinFields = {
  __typename?: 'process_material_state_history_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  material_state_history_id?: Maybe<Scalars['uuid']>;
  /** The referenced entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  material_state_history_id?: Maybe<OrderBy>;
  /** The referenced entry */
  material_state_id?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
  /** A reason for the state */
  reason?: Maybe<OrderBy>;
  /** Spec for this entry */
  spec_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.material_state_history" */
export type ProcessMaterialStateHistoryMutationResponse = {
  __typename?: 'process_material_state_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessMaterialStateHistory>;
};

/** on_conflict condition type for table "process.material_state_history" */
export type ProcessMaterialStateHistoryOnConflict = {
  constraint: ProcessMaterialStateHistoryConstraint;
  update_columns?: Array<ProcessMaterialStateHistoryUpdateColumn>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};

/** Ordering options when selecting data from "process.material_state_history". */
export type ProcessMaterialStateHistoryOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  fail_count?: Maybe<OrderBy>;
  material_state?: Maybe<ProcessMaterialStateOrderBy>;
  material_state_history_id?: Maybe<OrderBy>;
  material_state_id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  pass_count?: Maybe<OrderBy>;
  reason?: Maybe<OrderBy>;
  spec?: Maybe<ProcessSpecOrderBy>;
  spec_id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.material_state_history */
export type ProcessMaterialStateHistoryPkColumnsInput = {
  material_state_history_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessMaterialStateHistoryPrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.material_state_history" */
export enum ProcessMaterialStateHistorySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  MaterialStateHistoryId = 'material_state_history_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "process.material_state_history" */
export type ProcessMaterialStateHistorySetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  material_state_history_id?: Maybe<Scalars['uuid']>;
  /** The referenced entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ProcessMaterialStateHistoryStddevFields = {
  __typename?: 'process_material_state_history_stddev_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryStddevOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProcessMaterialStateHistoryStddevPopFields = {
  __typename?: 'process_material_state_history_stddev_pop_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryStddevPopOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProcessMaterialStateHistoryStddevSampFields = {
  __typename?: 'process_material_state_history_stddev_samp_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryStddevSampOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "process_material_state_history" */
export type ProcessMaterialStateHistoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessMaterialStateHistoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessMaterialStateHistoryStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  material_state_history_id?: Maybe<Scalars['uuid']>;
  /** The referenced entry */
  material_state_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ProcessMaterialStateHistorySumFields = {
  __typename?: 'process_material_state_history_sum_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistorySumOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** update columns of table "process.material_state_history" */
export enum ProcessMaterialStateHistoryUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  MaterialStateHistoryId = 'material_state_history_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ProcessMaterialStateHistoryUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessMaterialStateHistoryAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessMaterialStateHistoryDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessMaterialStateHistoryDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessMaterialStateHistoryDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ProcessMaterialStateHistoryIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessMaterialStateHistoryPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessMaterialStateHistorySetInput>;
  /** filter the rows which have to be updated */
  where: ProcessMaterialStateHistoryBoolExp;
};

/** aggregate var_pop on columns */
export type ProcessMaterialStateHistoryVarPopFields = {
  __typename?: 'process_material_state_history_var_pop_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryVarPopOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProcessMaterialStateHistoryVarSampFields = {
  __typename?: 'process_material_state_history_var_samp_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryVarSampOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProcessMaterialStateHistoryVarianceFields = {
  __typename?: 'process_material_state_history_variance_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "process.material_state_history" */
export type ProcessMaterialStateHistoryVarianceOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "process.material_state" */
export type ProcessMaterialStateIncInput = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "process.material_state" */
export type ProcessMaterialStateInsertInput = {
  collections?: Maybe<ProcessCollectionArrRelInsertInput>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  material?: Maybe<ArgoMaterialObjRelInsertInput>;
  /** Material for this entry */
  material_id?: Maybe<Scalars['uuid']>;
  material_state_histories?: Maybe<ProcessMaterialStateHistoryArrRelInsertInput>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  process_state?: Maybe<ProcessProcessStatusObjRelInsertInput>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  spec?: Maybe<ProcessSpecObjRelInsertInput>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['jsonb']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProcessMaterialStateMaxFields = {
  __typename?: 'process_material_state_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material for this entry */
  material_id?: Maybe<Scalars['uuid']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "process.material_state" */
export type ProcessMaterialStateMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material for this entry */
  material_id?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** A reason for the state */
  reason?: Maybe<OrderBy>;
  /** Spec for this entry */
  spec_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessMaterialStateMinFields = {
  __typename?: 'process_material_state_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material for this entry */
  material_id?: Maybe<Scalars['uuid']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "process.material_state" */
export type ProcessMaterialStateMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** Material for this entry */
  material_id?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
  /** Process for this entry */
  process_id?: Maybe<OrderBy>;
  /** A reason for the state */
  reason?: Maybe<OrderBy>;
  /** Spec for this entry */
  spec_id?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.material_state" */
export type ProcessMaterialStateMutationResponse = {
  __typename?: 'process_material_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessMaterialState>;
};

/** input type for inserting object relation for remote table "process.material_state" */
export type ProcessMaterialStateObjRelInsertInput = {
  data: ProcessMaterialStateInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessMaterialStateOnConflict>;
};

/** on_conflict condition type for table "process.material_state" */
export type ProcessMaterialStateOnConflict = {
  constraint: ProcessMaterialStateConstraint;
  update_columns?: Array<ProcessMaterialStateUpdateColumn>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};

/** Ordering options when selecting data from "process.material_state". */
export type ProcessMaterialStateOrderBy = {
  collections_aggregate?: Maybe<ProcessCollectionAggregateOrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  fail_count?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  material?: Maybe<ArgoMaterialOrderBy>;
  material_id?: Maybe<OrderBy>;
  material_state_histories_aggregate?: Maybe<ProcessMaterialStateHistoryAggregateOrderBy>;
  meta?: Maybe<OrderBy>;
  pass_count?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  process_state?: Maybe<ProcessProcessStatusOrderBy>;
  reason?: Maybe<OrderBy>;
  spec?: Maybe<ProcessSpecOrderBy>;
  spec_config?: Maybe<OrderBy>;
  spec_id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.material_state */
export type ProcessMaterialStatePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessMaterialStatePrependInput = {
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.material_state" */
export enum ProcessMaterialStateSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecConfig = 'spec_config',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "process.material_state" */
export type ProcessMaterialStateSetInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material for this entry */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['jsonb']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

export type ProcessMaterialStateSetStatusArgs = {
  material_state_id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<ProcessProcessStatusEnum>;
};

/** aggregate stddev on columns */
export type ProcessMaterialStateStddevFields = {
  __typename?: 'process_material_state_stddev_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "process.material_state" */
export type ProcessMaterialStateStddevOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProcessMaterialStateStddevPopFields = {
  __typename?: 'process_material_state_stddev_pop_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "process.material_state" */
export type ProcessMaterialStateStddevPopOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProcessMaterialStateStddevSampFields = {
  __typename?: 'process_material_state_stddev_samp_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "process.material_state" */
export type ProcessMaterialStateStddevSampOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** Streaming cursor of the table "process_material_state" */
export type ProcessMaterialStateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessMaterialStateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessMaterialStateStreamCursorValueInput = {
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** Material for this entry */
  material_id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
  /** Process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** A reason for the state */
  reason?: Maybe<Scalars['String']>;
  /** The resolved spec config for this entry */
  spec_config?: Maybe<Scalars['jsonb']>;
  /** Spec for this entry */
  spec_id?: Maybe<Scalars['uuid']>;
  /** Overall status of the process */
  status?: Maybe<ProcessProcessStatusEnum>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ProcessMaterialStateSumFields = {
  __typename?: 'process_material_state_sum_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Int']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "process.material_state" */
export type ProcessMaterialStateSumOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** update columns of table "process.material_state" */
export enum ProcessMaterialStateUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecConfig = 'spec_config',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ProcessMaterialStateUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessMaterialStateAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessMaterialStateDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessMaterialStateDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessMaterialStateDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ProcessMaterialStateIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessMaterialStatePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessMaterialStateSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessMaterialStateBoolExp;
};

/** aggregate var_pop on columns */
export type ProcessMaterialStateVarPopFields = {
  __typename?: 'process_material_state_var_pop_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "process.material_state" */
export type ProcessMaterialStateVarPopOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProcessMaterialStateVarSampFields = {
  __typename?: 'process_material_state_var_samp_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "process.material_state" */
export type ProcessMaterialStateVarSampOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProcessMaterialStateVarianceFields = {
  __typename?: 'process_material_state_variance_fields';
  /** Total count of failed collection validations */
  fail_count?: Maybe<Scalars['Float']>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "process.material_state" */
export type ProcessMaterialStateVarianceOrderBy = {
  /** Total count of failed collection validations */
  fail_count?: Maybe<OrderBy>;
  /** Total count of passed collection validations */
  pass_count?: Maybe<OrderBy>;
};

/** Process table */
export type ProcessProcess = {
  __typename?: 'process_process';
  /** The structured configuration for a process */
  config: Scalars['process_config'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** An array relationship */
  data_elements: Array<ProcessDataElement>;
  /** An aggregate relationship */
  data_elements_aggregate: ProcessDataElementAggregate;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled: Scalars['Boolean'];
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** A case-sensitive identifier */
  name: Scalars['String'];
  /** A case-insensitive identifier */
  name_unique: Scalars['String'];
  /** An array relationship */
  spec_orders: Array<ProcessSpecOrder>;
  /** An aggregate relationship */
  spec_orders_aggregate: ProcessSpecOrderAggregate;
  /** An array relationship */
  specs: Array<ProcessSpec>;
  /** An aggregate relationship */
  specs_aggregate: ProcessSpecAggregate;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Process table */
export type ProcessProcessConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Process table */
export type ProcessProcessDataElementsArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


/** Process table */
export type ProcessProcessDataElementsAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


/** Process table */
export type ProcessProcessHistoryArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Process table */
export type ProcessProcessMetaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Process table */
export type ProcessProcessSpecOrdersArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


/** Process table */
export type ProcessProcessSpecOrdersAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


/** Process table */
export type ProcessProcessSpecsArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


/** Process table */
export type ProcessProcessSpecsAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};

/** aggregated selection of "process.process" */
export type ProcessProcessAggregate = {
  __typename?: 'process_process_aggregate';
  aggregate?: Maybe<ProcessProcessAggregateFields>;
  nodes: Array<ProcessProcess>;
};

/** aggregate fields of "process.process" */
export type ProcessProcessAggregateFields = {
  __typename?: 'process_process_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessProcessMaxFields>;
  min?: Maybe<ProcessProcessMinFields>;
};


/** aggregate fields of "process.process" */
export type ProcessProcessAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessProcessSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessProcessAppendInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['jsonb']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "process.process". All fields are combined with a logical 'AND'. */
export type ProcessProcessBoolExp = {
  _and?: Maybe<Array<ProcessProcessBoolExp>>;
  _not?: Maybe<ProcessProcessBoolExp>;
  _or?: Maybe<Array<ProcessProcessBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  data_elements?: Maybe<ProcessDataElementBoolExp>;
  data_elements_aggregate?: Maybe<ProcessDataElementAggregateBoolExp>;
  description?: Maybe<StringComparisonExp>;
  enabled?: Maybe<BooleanComparisonExp>;
  history?: Maybe<JsonbComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  spec_orders?: Maybe<ProcessSpecOrderBoolExp>;
  spec_orders_aggregate?: Maybe<ProcessSpecOrderAggregateBoolExp>;
  specs?: Maybe<ProcessSpecBoolExp>;
  specs_aggregate?: Maybe<ProcessSpecAggregateBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "process.process" */
export enum ProcessProcessConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ProcessEnforceUniqueName = 'process_enforce_unique_name',
  /** unique or primary key constraint on columns "process_id" */
  ProcessPkey = 'process_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessProcessDeleteAtPathInput = {
  /** The structured configuration for a process */
  config?: Maybe<Array<Scalars['String']>>;
  /** The history of config changes */
  history?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessProcessDeleteElemInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['Int']>;
  /** The history of config changes */
  history?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessProcessDeleteKeyInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['String']>;
  /** The history of config changes */
  history?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "process.process" */
export type ProcessProcessInsertInput = {
  /** The structured configuration for a process */
  config: Scalars['process_config'];
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  data_elements?: Maybe<ProcessDataElementArrRelInsertInput>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  spec_orders?: Maybe<ProcessSpecOrderArrRelInsertInput>;
  specs?: Maybe<ProcessSpecArrRelInsertInput>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProcessProcessMaxFields = {
  __typename?: 'process_process_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ProcessProcessMinFields = {
  __typename?: 'process_process_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "process.process" */
export type ProcessProcessMutationResponse = {
  __typename?: 'process_process_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessProcess>;
};

/** input type for inserting object relation for remote table "process.process" */
export type ProcessProcessObjRelInsertInput = {
  data: ProcessProcessInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessProcessOnConflict>;
};

/** on_conflict condition type for table "process.process" */
export type ProcessProcessOnConflict = {
  constraint: ProcessProcessConstraint;
  update_columns?: Array<ProcessProcessUpdateColumn>;
  where?: Maybe<ProcessProcessBoolExp>;
};

/** Ordering options when selecting data from "process.process". */
export type ProcessProcessOrderBy = {
  config?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  data_elements_aggregate?: Maybe<ProcessDataElementAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  enabled?: Maybe<OrderBy>;
  history?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  spec_orders_aggregate?: Maybe<ProcessSpecOrderAggregateOrderBy>;
  specs_aggregate?: Maybe<ProcessSpecAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.process */
export type ProcessProcessPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessProcessPrependInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['jsonb']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.process" */
export enum ProcessProcessSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "process.process" */
export type ProcessProcessSetInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['jsonb']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Process Status ENUM */
export type ProcessProcessStatus = {
  __typename?: 'process_process_status';
  /** The description of the status */
  description: Scalars['String'];
  /** Process Status */
  status: Scalars['String'];
};

/** aggregated selection of "process.process_status" */
export type ProcessProcessStatusAggregate = {
  __typename?: 'process_process_status_aggregate';
  aggregate?: Maybe<ProcessProcessStatusAggregateFields>;
  nodes: Array<ProcessProcessStatus>;
};

/** aggregate fields of "process.process_status" */
export type ProcessProcessStatusAggregateFields = {
  __typename?: 'process_process_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessProcessStatusMaxFields>;
  min?: Maybe<ProcessProcessStatusMinFields>;
};


/** aggregate fields of "process.process_status" */
export type ProcessProcessStatusAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessProcessStatusSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "process.process_status". All fields are combined with a logical 'AND'. */
export type ProcessProcessStatusBoolExp = {
  _and?: Maybe<Array<ProcessProcessStatusBoolExp>>;
  _not?: Maybe<ProcessProcessStatusBoolExp>;
  _or?: Maybe<Array<ProcessProcessStatusBoolExp>>;
  description?: Maybe<StringComparisonExp>;
  status?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "process.process_status" */
export enum ProcessProcessStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ProcessStatusPkey = 'process_status_pkey'
}

export enum ProcessProcessStatusEnum {
  /** Completed */
  Completed = 'completed',
  /** Deleted */
  Deleted = 'deleted',
  /** Failed */
  Failed = 'failed',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Invalidated */
  Invalidated = 'invalidated',
  /** Manually Completed */
  ManuallyCompleted = 'manually_completed',
  /** Not Required */
  NotRequired = 'not_required',
  /** Pending */
  Pending = 'pending',
  /** Skipped */
  Skipped = 'skipped',
  /** Solve Failed */
  SolveFailed = 'solve_failed'
}

/** Boolean expression to compare columns of type "process_process_status_enum". All fields are combined with logical 'AND'. */
export type ProcessProcessStatusEnumComparisonExp = {
  _eq?: Maybe<ProcessProcessStatusEnum>;
  _in?: Maybe<Array<ProcessProcessStatusEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ProcessProcessStatusEnum>;
  _nin?: Maybe<Array<ProcessProcessStatusEnum>>;
};

/** input type for inserting data into table "process.process_status" */
export type ProcessProcessStatusInsertInput = {
  /** The description of the status */
  description?: Maybe<Scalars['String']>;
  /** Process Status */
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProcessProcessStatusMaxFields = {
  __typename?: 'process_process_status_max_fields';
  /** The description of the status */
  description?: Maybe<Scalars['String']>;
  /** Process Status */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProcessProcessStatusMinFields = {
  __typename?: 'process_process_status_min_fields';
  /** The description of the status */
  description?: Maybe<Scalars['String']>;
  /** Process Status */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "process.process_status" */
export type ProcessProcessStatusMutationResponse = {
  __typename?: 'process_process_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessProcessStatus>;
};

/** input type for inserting object relation for remote table "process.process_status" */
export type ProcessProcessStatusObjRelInsertInput = {
  data: ProcessProcessStatusInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessProcessStatusOnConflict>;
};

/** on_conflict condition type for table "process.process_status" */
export type ProcessProcessStatusOnConflict = {
  constraint: ProcessProcessStatusConstraint;
  update_columns?: Array<ProcessProcessStatusUpdateColumn>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};

/** Ordering options when selecting data from "process.process_status". */
export type ProcessProcessStatusOrderBy = {
  description?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.process_status */
export type ProcessProcessStatusPkColumnsInput = {
  /** Process Status */
  status: Scalars['String'];
};

/** select columns of table "process.process_status" */
export enum ProcessProcessStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "process.process_status" */
export type ProcessProcessStatusSetInput = {
  /** The description of the status */
  description?: Maybe<Scalars['String']>;
  /** Process Status */
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "process_process_status" */
export type ProcessProcessStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessProcessStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessProcessStatusStreamCursorValueInput = {
  /** The description of the status */
  description?: Maybe<Scalars['String']>;
  /** Process Status */
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "process.process_status" */
export enum ProcessProcessStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type ProcessProcessStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessProcessStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessProcessStatusBoolExp;
};

/** Streaming cursor of the table "process_process" */
export type ProcessProcessStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessProcessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessProcessStreamCursorValueInput = {
  /** The structured configuration for a process */
  config?: Maybe<Scalars['jsonb']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Whether or not this entry is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "process.process" */
export enum ProcessProcessUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ProcessProcessUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessProcessAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessProcessDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessProcessDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessProcessDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessProcessPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessProcessSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessProcessBoolExp;
};

/** Spec table */
export type ProcessSpec = {
  __typename?: 'process_spec';
  /** The structured configuration for a spec */
  config: Scalars['process_spec_config'];
  /** Indicates when a spec's config can be edited. Should be automatically updated to false after it gets a material solved to it */
  config_editable: Scalars['Boolean'];
  /** An object relationship */
  context: ArgoContext;
  /** The context for this entry */
  context_id: Scalars['uuid'];
  /** When this entry was created */
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: ArgoUser;
  /** Who created this entry */
  created_by_id: Scalars['uuid'];
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** Whether or not this spec is in use */
  locked: Scalars['Boolean'];
  /** A column for meta data */
  meta: Scalars['jsonb'];
  /** A case-sensitive identifier */
  name: Scalars['String'];
  /** A case-insensitive identifier */
  name_unique: Scalars['String'];
  /** An object relationship */
  parent_spec?: Maybe<ProcessSpec>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  process: ProcessProcess;
  /** The process for this entry */
  process_id: Scalars['uuid'];
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<ArgoUser>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** Spec table */
export type ProcessSpecConfigArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Spec table */
export type ProcessSpecHistoryArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Spec table */
export type ProcessSpecMetaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.spec" */
export type ProcessSpecAggregate = {
  __typename?: 'process_spec_aggregate';
  aggregate?: Maybe<ProcessSpecAggregateFields>;
  nodes: Array<ProcessSpec>;
};

export type ProcessSpecAggregateBoolExp = {
  bool_and?: Maybe<ProcessSpecAggregateBoolExpBoolAnd>;
  bool_or?: Maybe<ProcessSpecAggregateBoolExpBoolOr>;
  count?: Maybe<ProcessSpecAggregateBoolExpCount>;
};

export type ProcessSpecAggregateBoolExpBoolAnd = {
  arguments: ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessSpecBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessSpecAggregateBoolExpBoolOr = {
  arguments: ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessSpecBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ProcessSpecAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessSpecSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessSpecBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.spec" */
export type ProcessSpecAggregateFields = {
  __typename?: 'process_spec_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessSpecMaxFields>;
  min?: Maybe<ProcessSpecMinFields>;
};


/** aggregate fields of "process.spec" */
export type ProcessSpecAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessSpecSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.spec" */
export type ProcessSpecAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessSpecMaxOrderBy>;
  min?: Maybe<ProcessSpecMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessSpecAppendInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['jsonb']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.spec" */
export type ProcessSpecArrRelInsertInput = {
  data: Array<ProcessSpecInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessSpecOnConflict>;
};

/** Boolean expression to filter rows from the table "process.spec". All fields are combined with a logical 'AND'. */
export type ProcessSpecBoolExp = {
  _and?: Maybe<Array<ProcessSpecBoolExp>>;
  _not?: Maybe<ProcessSpecBoolExp>;
  _or?: Maybe<Array<ProcessSpecBoolExp>>;
  config?: Maybe<JsonbComparisonExp>;
  config_editable?: Maybe<BooleanComparisonExp>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  created_by?: Maybe<ArgoUserBoolExp>;
  created_by_id?: Maybe<UuidComparisonExp>;
  history?: Maybe<JsonbComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  locked?: Maybe<BooleanComparisonExp>;
  meta?: Maybe<JsonbComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  name_unique?: Maybe<StringComparisonExp>;
  parent_spec?: Maybe<ProcessSpecBoolExp>;
  parent_spec_id?: Maybe<UuidComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  time_end?: Maybe<TimestamptzComparisonExp>;
  time_start?: Maybe<TimestamptzComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  updated_by?: Maybe<ArgoUserBoolExp>;
  updated_by_id?: Maybe<UuidComparisonExp>;
};



/** unique or primary key constraints on table "process.spec" */
export enum ProcessSpecConstraint {
  /** unique or primary key constraint on columns "context_id", "process_id", "name_unique" */
  SpecEnforceUniqueName = 'spec_enforce_unique_name',
  /** unique or primary key constraint on columns "spec_id" */
  SpecPkey = 'spec_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessSpecDeleteAtPathInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Array<Scalars['String']>>;
  /** The history of config changes */
  history?: Maybe<Array<Scalars['String']>>;
  /** A column for meta data */
  meta?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessSpecDeleteElemInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['Int']>;
  /** The history of config changes */
  history?: Maybe<Scalars['Int']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessSpecDeleteKeyInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['String']>;
  /** The history of config changes */
  history?: Maybe<Scalars['String']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "process.spec" */
export type ProcessSpecInsertInput = {
  /** The structured configuration for a spec */
  config: Scalars['process_spec_config'];
  /** Indicates when a spec's config can be edited. Should be automatically updated to false after it gets a material solved to it */
  config_editable?: Maybe<Scalars['Boolean']>;
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** Whether or not this spec is in use */
  locked?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  parent_spec?: Maybe<ProcessSpecObjRelInsertInput>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** The process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<ArgoUserObjRelInsertInput>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProcessSpecMaxFields = {
  __typename?: 'process_spec_max_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  /** The process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "process.spec" */
export type ProcessSpecMaxOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** A case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<OrderBy>;
  /** The process for this entry */
  process_id?: Maybe<OrderBy>;
  time_end?: Maybe<OrderBy>;
  time_start?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessSpecMinFields = {
  __typename?: 'process_spec_min_fields';
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  /** The process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "process.spec" */
export type ProcessSpecMinOrderBy = {
  /** The context for this entry */
  context_id?: Maybe<OrderBy>;
  /** When this entry was created */
  created_at?: Maybe<OrderBy>;
  /** Who created this entry */
  created_by_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** A case-sensitive identifier */
  name?: Maybe<OrderBy>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<OrderBy>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<OrderBy>;
  /** The process for this entry */
  process_id?: Maybe<OrderBy>;
  time_end?: Maybe<OrderBy>;
  time_start?: Maybe<OrderBy>;
  /** When this entry was last updated */
  updated_at?: Maybe<OrderBy>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.spec" */
export type ProcessSpecMutationResponse = {
  __typename?: 'process_spec_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessSpec>;
};

/** input type for inserting object relation for remote table "process.spec" */
export type ProcessSpecObjRelInsertInput = {
  data: ProcessSpecInsertInput;
  /** upsert condition */
  on_conflict?: Maybe<ProcessSpecOnConflict>;
};

/** on_conflict condition type for table "process.spec" */
export type ProcessSpecOnConflict = {
  constraint: ProcessSpecConstraint;
  update_columns?: Array<ProcessSpecUpdateColumn>;
  where?: Maybe<ProcessSpecBoolExp>;
};

/** Spec Order */
export type ProcessSpecOrder = {
  __typename?: 'process_spec_order';
  /** An object relationship */
  context: ArgoContext;
  /** The Context for this entry */
  context_id: Scalars['uuid'];
  /** The solve order for default specs. Latest is first */
  default_spec_ids: Array<Scalars['String']>;
  id: Scalars['uuid'];
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids: Array<Scalars['String']>;
  /** An object relationship */
  process: ProcessProcess;
  /** The process_id for this entry */
  process_id: Scalars['uuid'];
  /** The time_start for this entry */
  time_start: Scalars['timestamptz'];
};


/** Spec Order */
export type ProcessSpecOrderDefaultSpecIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Spec Order */
export type ProcessSpecOrderNonDefaultSpecIdsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "process.spec_order" */
export type ProcessSpecOrderAggregate = {
  __typename?: 'process_spec_order_aggregate';
  aggregate?: Maybe<ProcessSpecOrderAggregateFields>;
  nodes: Array<ProcessSpecOrder>;
};

export type ProcessSpecOrderAggregateBoolExp = {
  count?: Maybe<ProcessSpecOrderAggregateBoolExpCount>;
};

export type ProcessSpecOrderAggregateBoolExpCount = {
  arguments?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ProcessSpecOrderBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "process.spec_order" */
export type ProcessSpecOrderAggregateFields = {
  __typename?: 'process_spec_order_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProcessSpecOrderMaxFields>;
  min?: Maybe<ProcessSpecOrderMinFields>;
};


/** aggregate fields of "process.spec_order" */
export type ProcessSpecOrderAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "process.spec_order" */
export type ProcessSpecOrderAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<ProcessSpecOrderMaxOrderBy>;
  min?: Maybe<ProcessSpecOrderMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ProcessSpecOrderAppendInput = {
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['jsonb']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "process.spec_order" */
export type ProcessSpecOrderArrRelInsertInput = {
  data: Array<ProcessSpecOrderInsertInput>;
  /** upsert condition */
  on_conflict?: Maybe<ProcessSpecOrderOnConflict>;
};

/** Boolean expression to filter rows from the table "process.spec_order". All fields are combined with a logical 'AND'. */
export type ProcessSpecOrderBoolExp = {
  _and?: Maybe<Array<ProcessSpecOrderBoolExp>>;
  _not?: Maybe<ProcessSpecOrderBoolExp>;
  _or?: Maybe<Array<ProcessSpecOrderBoolExp>>;
  context?: Maybe<ArgoContextBoolExp>;
  context_id?: Maybe<UuidComparisonExp>;
  default_spec_ids?: Maybe<JsonbComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  non_default_spec_ids?: Maybe<JsonbComparisonExp>;
  process?: Maybe<ProcessProcessBoolExp>;
  process_id?: Maybe<UuidComparisonExp>;
  time_start?: Maybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "process.spec". */
export type ProcessSpecOrderBy = {
  config?: Maybe<OrderBy>;
  config_editable?: Maybe<OrderBy>;
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  created_by?: Maybe<ArgoUserOrderBy>;
  created_by_id?: Maybe<OrderBy>;
  history?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  locked?: Maybe<OrderBy>;
  meta?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  name_unique?: Maybe<OrderBy>;
  parent_spec?: Maybe<ProcessSpecOrderBy>;
  parent_spec_id?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  time_end?: Maybe<OrderBy>;
  time_start?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  updated_by?: Maybe<ArgoUserOrderBy>;
  updated_by_id?: Maybe<OrderBy>;
};

/** unique or primary key constraints on table "process.spec_order" */
export enum ProcessSpecOrderConstraint {
  /** unique or primary key constraint on columns "spec_order_id" */
  SpecOrderPkey = 'spec_order_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ProcessSpecOrderDeleteAtPathInput = {
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Array<Scalars['String']>>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ProcessSpecOrderDeleteElemInput = {
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['Int']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ProcessSpecOrderDeleteKeyInput = {
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['String']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "process.spec_order" */
export type ProcessSpecOrderInsertInput = {
  context?: Maybe<ArgoContextObjRelInsertInput>;
  /** The Context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** The solve order for default specs. Latest is first */
  default_spec_ids: Array<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids: Array<Scalars['String']>;
  process?: Maybe<ProcessProcessObjRelInsertInput>;
  /** The process_id for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** The time_start for this entry */
  time_start?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProcessSpecOrderMaxFields = {
  __typename?: 'process_spec_order_max_fields';
  /** The Context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The process_id for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** The time_start for this entry */
  time_start?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "process.spec_order" */
export type ProcessSpecOrderMaxOrderBy = {
  /** The Context for this entry */
  context_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The process_id for this entry */
  process_id?: Maybe<OrderBy>;
  /** The time_start for this entry */
  time_start?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ProcessSpecOrderMinFields = {
  __typename?: 'process_spec_order_min_fields';
  /** The Context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The process_id for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** The time_start for this entry */
  time_start?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "process.spec_order" */
export type ProcessSpecOrderMinOrderBy = {
  /** The Context for this entry */
  context_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  /** The process_id for this entry */
  process_id?: Maybe<OrderBy>;
  /** The time_start for this entry */
  time_start?: Maybe<OrderBy>;
};

/** response of any mutation on the table "process.spec_order" */
export type ProcessSpecOrderMutationResponse = {
  __typename?: 'process_spec_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProcessSpecOrder>;
};

/** on_conflict condition type for table "process.spec_order" */
export type ProcessSpecOrderOnConflict = {
  constraint: ProcessSpecOrderConstraint;
  update_columns?: Array<ProcessSpecOrderUpdateColumn>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};

/** Ordering options when selecting data from "process.spec_order". */
export type ProcessSpecOrderOrderBy = {
  context?: Maybe<ArgoContextOrderBy>;
  context_id?: Maybe<OrderBy>;
  default_spec_ids?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  non_default_spec_ids?: Maybe<OrderBy>;
  process?: Maybe<ProcessProcessOrderBy>;
  process_id?: Maybe<OrderBy>;
  time_start?: Maybe<OrderBy>;
};

/** primary key columns input for table: process.spec_order */
export type ProcessSpecOrderPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessSpecOrderPrependInput = {
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['jsonb']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.spec_order" */
export enum ProcessSpecOrderSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultSpecIds = 'default_spec_ids',
  /** column name */
  Id = 'id',
  /** column name */
  NonDefaultSpecIds = 'non_default_spec_ids',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeStart = 'time_start'
}

/** input type for updating data in table "process.spec_order" */
export type ProcessSpecOrderSetInput = {
  /** The Context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['jsonb']>;
  /** The process_id for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** The time_start for this entry */
  time_start?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "process_spec_order" */
export type ProcessSpecOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessSpecOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessSpecOrderStreamCursorValueInput = {
  /** The Context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** The solve order for default specs. Latest is first */
  default_spec_ids?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** The solve order for non-default specs. Latest is first */
  non_default_spec_ids?: Maybe<Scalars['jsonb']>;
  /** The process_id for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  /** The time_start for this entry */
  time_start?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "process.spec_order" */
export enum ProcessSpecOrderUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultSpecIds = 'default_spec_ids',
  /** column name */
  Id = 'id',
  /** column name */
  NonDefaultSpecIds = 'non_default_spec_ids',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeStart = 'time_start'
}

export type ProcessSpecOrderUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessSpecOrderAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessSpecOrderDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessSpecOrderDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessSpecOrderDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessSpecOrderPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessSpecOrderSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessSpecOrderBoolExp;
};

/** primary key columns input for table: process.spec */
export type ProcessSpecPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ProcessSpecPrependInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['jsonb']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "process.spec" */
export enum ProcessSpecSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Locked = 'locked',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentSpecId = 'parent_spec_id',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "process_spec_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.spec" */
export enum ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  Locked = 'locked'
}

/** select "process_spec_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.spec" */
export enum ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  Locked = 'locked'
}

/** input type for updating data in table "process.spec" */
export type ProcessSpecSetInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['jsonb']>;
  /** Indicates when a spec's config can be edited. Should be automatically updated to false after it gets a material solved to it */
  config_editable?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** Whether or not this spec is in use */
  locked?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  /** The process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "process_spec" */
export type ProcessSpecStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProcessSpecStreamCursorValueInput;
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProcessSpecStreamCursorValueInput = {
  /** The structured configuration for a spec */
  config?: Maybe<Scalars['jsonb']>;
  /** Indicates when a spec's config can be edited. Should be automatically updated to false after it gets a material solved to it */
  config_editable?: Maybe<Scalars['Boolean']>;
  /** The context for this entry */
  context_id?: Maybe<Scalars['uuid']>;
  /** When this entry was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Who created this entry */
  created_by_id?: Maybe<Scalars['uuid']>;
  /** The history of config changes */
  history?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  /** Whether or not this spec is in use */
  locked?: Maybe<Scalars['Boolean']>;
  /** A column for meta data */
  meta?: Maybe<Scalars['jsonb']>;
  /** A case-sensitive identifier */
  name?: Maybe<Scalars['String']>;
  /** A case-insensitive identifier */
  name_unique?: Maybe<Scalars['String']>;
  /** To know where a Spec deviated from */
  parent_spec_id?: Maybe<Scalars['uuid']>;
  /** The process for this entry */
  process_id?: Maybe<Scalars['uuid']>;
  time_end?: Maybe<Scalars['timestamptz']>;
  time_start?: Maybe<Scalars['timestamptz']>;
  /** When this entry was last updated */
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Who last updated this entry */
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "process.spec" */
export enum ProcessSpecUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Locked = 'locked',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentSpecId = 'parent_spec_id',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type ProcessSpecUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<ProcessSpecAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<ProcessSpecDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<ProcessSpecDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<ProcessSpecDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<ProcessSpecPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ProcessSpecSetInput>;
  /** filter the rows which have to be updated */
  where: ProcessSpecBoolExp;
};

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "applet.deployment" */
  applet_deployment: Array<AppletDeployment>;
  /** fetch aggregated fields from the table: "applet.deployment" */
  applet_deployment_aggregate: AppletDeploymentAggregate;
  /** fetch data from the table: "applet.deployment" using primary key columns */
  applet_deployment_by_pk?: Maybe<AppletDeployment>;
  /** fetch data from the table: "applet.deployment_linked_design_version" */
  applet_deployment_linked_design_version: Array<AppletDeploymentLinkedDesignVersion>;
  /** fetch aggregated fields from the table: "applet.deployment_linked_design_version" */
  applet_deployment_linked_design_version_aggregate: AppletDeploymentLinkedDesignVersionAggregate;
  /** fetch data from the table: "applet.deployment_linked_design_version" using primary key columns */
  applet_deployment_linked_design_version_by_pk?: Maybe<AppletDeploymentLinkedDesignVersion>;
  /** fetch data from the table: "applet.design" */
  applet_design: Array<AppletDesign>;
  /** fetch aggregated fields from the table: "applet.design" */
  applet_design_aggregate: AppletDesignAggregate;
  /** fetch data from the table: "applet.design" using primary key columns */
  applet_design_by_pk?: Maybe<AppletDesign>;
  /** fetch data from the table: "applet.design_version" */
  applet_design_version: Array<AppletDesignVersion>;
  /** fetch aggregated fields from the table: "applet.design_version" */
  applet_design_version_aggregate: AppletDesignVersionAggregate;
  /** fetch data from the table: "applet.design_version" using primary key columns */
  applet_design_version_by_pk?: Maybe<AppletDesignVersion>;
  /** fetch data from the table: "applet.design_version_status" */
  applet_design_version_status: Array<AppletDesignVersionStatus>;
  /** fetch aggregated fields from the table: "applet.design_version_status" */
  applet_design_version_status_aggregate: AppletDesignVersionStatusAggregate;
  /** fetch data from the table: "applet.design_version_status" using primary key columns */
  applet_design_version_status_by_pk?: Maybe<AppletDesignVersionStatus>;
  /** fetch data from the table: "applet.registration_code" */
  applet_registration_code: Array<AppletRegistrationCode>;
  /** fetch aggregated fields from the table: "applet.registration_code" */
  applet_registration_code_aggregate: AppletRegistrationCodeAggregate;
  /** fetch data from the table: "applet.registration_code" using primary key columns */
  applet_registration_code_by_pk?: Maybe<AppletRegistrationCode>;
  /** fetch data from the table: "applet.runner" */
  applet_runner: Array<AppletRunner>;
  /** fetch aggregated fields from the table: "applet.runner" */
  applet_runner_aggregate: AppletRunnerAggregate;
  /** fetch data from the table: "applet.runner" using primary key columns */
  applet_runner_by_pk?: Maybe<AppletRunner>;
  /** fetch data from the table: "applet.runner_context" */
  applet_runner_context: Array<AppletRunnerContext>;
  /** fetch aggregated fields from the table: "applet.runner_context" */
  applet_runner_context_aggregate: AppletRunnerContextAggregate;
  /** fetch data from the table: "applet.runner_context" using primary key columns */
  applet_runner_context_by_pk?: Maybe<AppletRunnerContext>;
  /** fetch data from the table: "argo.acl" */
  argo_acl: Array<ArgoAcl>;
  /** fetch aggregated fields from the table: "argo.acl" */
  argo_acl_aggregate: ArgoAclAggregate;
  /** fetch data from the table: "argo.acl" using primary key columns */
  argo_acl_by_pk?: Maybe<ArgoAcl>;
  /** fetch data from the table: "argo.attribute" */
  argo_attribute: Array<ArgoAttribute>;
  /** fetch aggregated fields from the table: "argo.attribute" */
  argo_attribute_aggregate: ArgoAttributeAggregate;
  /** fetch data from the table: "argo.attribute" using primary key columns */
  argo_attribute_by_pk?: Maybe<ArgoAttribute>;
  /** fetch data from the table: "argo.attribute_data" */
  argo_attribute_data: Array<ArgoAttributeData>;
  /** fetch aggregated fields from the table: "argo.attribute_data" */
  argo_attribute_data_aggregate: ArgoAttributeDataAggregate;
  /** fetch data from the table: "argo.attribute_data" using primary key columns */
  argo_attribute_data_by_pk?: Maybe<ArgoAttributeData>;
  /** fetch data from the table: "argo.attribute_history_status_type" */
  argo_attribute_history_status_type: Array<ArgoAttributeHistoryStatusType>;
  /** fetch aggregated fields from the table: "argo.attribute_history_status_type" */
  argo_attribute_history_status_type_aggregate: ArgoAttributeHistoryStatusTypeAggregate;
  /** fetch data from the table: "argo.attribute_history_status_type" using primary key columns */
  argo_attribute_history_status_type_by_pk?: Maybe<ArgoAttributeHistoryStatusType>;
  /** fetch data from the table: "argo.attribute_schema" */
  argo_attribute_schema: Array<ArgoAttributeSchema>;
  /** fetch aggregated fields from the table: "argo.attribute_schema" */
  argo_attribute_schema_aggregate: ArgoAttributeSchemaAggregate;
  /** fetch data from the table: "argo.attribute_schema" using primary key columns */
  argo_attribute_schema_by_pk?: Maybe<ArgoAttributeSchema>;
  /** fetch data from the table: "argo.attribute_schema_definition" */
  argo_attribute_schema_definition: Array<ArgoAttributeSchemaDefinition>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_definition" */
  argo_attribute_schema_definition_aggregate: ArgoAttributeSchemaDefinitionAggregate;
  /** fetch data from the table: "argo.attribute_schema_definition" using primary key columns */
  argo_attribute_schema_definition_by_pk?: Maybe<ArgoAttributeSchemaDefinition>;
  /** fetch data from the table: "argo.attribute_schema_definition_type" */
  argo_attribute_schema_definition_type: Array<ArgoAttributeSchemaDefinitionType>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_definition_type" */
  argo_attribute_schema_definition_type_aggregate: ArgoAttributeSchemaDefinitionTypeAggregate;
  /** fetch data from the table: "argo.attribute_schema_definition_type" using primary key columns */
  argo_attribute_schema_definition_type_by_pk?: Maybe<ArgoAttributeSchemaDefinitionType>;
  /** fetch data from the table: "argo.attribute_schema_type" */
  argo_attribute_schema_type: Array<ArgoAttributeSchemaType>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_type" */
  argo_attribute_schema_type_aggregate: ArgoAttributeSchemaTypeAggregate;
  /** fetch data from the table: "argo.attribute_schema_type" using primary key columns */
  argo_attribute_schema_type_by_pk?: Maybe<ArgoAttributeSchemaType>;
  /** fetch data from the table: "argo.audit" */
  argo_audit: Array<ArgoAudit>;
  /** fetch aggregated fields from the table: "argo.audit" */
  argo_audit_aggregate: ArgoAuditAggregate;
  /** fetch data from the table: "argo.audit" using primary key columns */
  argo_audit_by_pk?: Maybe<ArgoAudit>;
  /** fetch data from the table: "argo.auth_provider" */
  argo_auth_provider: Array<ArgoAuthProvider>;
  /** fetch aggregated fields from the table: "argo.auth_provider" */
  argo_auth_provider_aggregate: ArgoAuthProviderAggregate;
  /** fetch data from the table: "argo.auth_provider" using primary key columns */
  argo_auth_provider_by_pk?: Maybe<ArgoAuthProvider>;
  /** fetch data from the table: "argo.auth_provider_local" */
  argo_auth_provider_local: Array<ArgoAuthProviderLocal>;
  /** fetch aggregated fields from the table: "argo.auth_provider_local" */
  argo_auth_provider_local_aggregate: ArgoAuthProviderLocalAggregate;
  /** fetch data from the table: "argo.auth_provider_local" using primary key columns */
  argo_auth_provider_local_by_pk?: Maybe<ArgoAuthProviderLocal>;
  /** fetch data from the table: "argo.auth_provider_local_setting" */
  argo_auth_provider_local_setting: Array<ArgoAuthProviderLocalSetting>;
  /** fetch aggregated fields from the table: "argo.auth_provider_local_setting" */
  argo_auth_provider_local_setting_aggregate: ArgoAuthProviderLocalSettingAggregate;
  /** fetch data from the table: "argo.auth_provider_local_setting" using primary key columns */
  argo_auth_provider_local_setting_by_pk?: Maybe<ArgoAuthProviderLocalSetting>;
  /** fetch data from the table: "argo.auth_provider_msal" */
  argo_auth_provider_msal: Array<ArgoAuthProviderMsal>;
  /** fetch aggregated fields from the table: "argo.auth_provider_msal" */
  argo_auth_provider_msal_aggregate: ArgoAuthProviderMsalAggregate;
  /** fetch data from the table: "argo.auth_provider_msal" using primary key columns */
  argo_auth_provider_msal_by_pk?: Maybe<ArgoAuthProviderMsal>;
  /** fetch data from the table: "argo.auth_provider_msal_setting" */
  argo_auth_provider_msal_setting: Array<ArgoAuthProviderMsalSetting>;
  /** fetch aggregated fields from the table: "argo.auth_provider_msal_setting" */
  argo_auth_provider_msal_setting_aggregate: ArgoAuthProviderMsalSettingAggregate;
  /** fetch data from the table: "argo.auth_provider_msal_setting" using primary key columns */
  argo_auth_provider_msal_setting_by_pk?: Maybe<ArgoAuthProviderMsalSetting>;
  /** fetch data from the table: "argo.auth_provider_record" */
  argo_auth_provider_record: Array<ArgoAuthProviderRecord>;
  /** fetch aggregated fields from the table: "argo.auth_provider_record" */
  argo_auth_provider_record_aggregate: ArgoAuthProviderRecordAggregate;
  /** fetch data from the table: "argo.auth_provider_record" using primary key columns */
  argo_auth_provider_record_by_pk?: Maybe<ArgoAuthProviderRecord>;
  /** fetch data from the table: "argo.auth_refresh_token" */
  argo_auth_refresh_token: Array<ArgoAuthRefreshToken>;
  /** fetch aggregated fields from the table: "argo.auth_refresh_token" */
  argo_auth_refresh_token_aggregate: ArgoAuthRefreshTokenAggregate;
  /** fetch data from the table: "argo.auth_refresh_token" using primary key columns */
  argo_auth_refresh_token_by_pk?: Maybe<ArgoAuthRefreshToken>;
  /** fetch data from the table: "argo.calendar" */
  argo_calendar: Array<ArgoCalendar>;
  /** fetch aggregated fields from the table: "argo.calendar" */
  argo_calendar_aggregate: ArgoCalendarAggregate;
  /** fetch data from the table: "argo.calendar" using primary key columns */
  argo_calendar_by_pk?: Maybe<ArgoCalendar>;
  /** fetch data from the table: "argo.calendar_current_and_next" */
  argo_calendar_current_and_next: Array<ArgoCalendarCurrentAndNext>;
  /** fetch aggregated fields from the table: "argo.calendar_current_and_next" */
  argo_calendar_current_and_next_aggregate: ArgoCalendarCurrentAndNextAggregate;
  /** fetch data from the table: "argo.calendar_event" */
  argo_calendar_event: Array<ArgoCalendarEvent>;
  /** fetch aggregated fields from the table: "argo.calendar_event" */
  argo_calendar_event_aggregate: ArgoCalendarEventAggregate;
  /** fetch data from the table: "argo.calendar_event" using primary key columns */
  argo_calendar_event_by_pk?: Maybe<ArgoCalendarEvent>;
  /** fetch data from the table: "argo.calendar_event_sequence" */
  argo_calendar_event_sequence: Array<ArgoCalendarEventSequence>;
  /** fetch aggregated fields from the table: "argo.calendar_event_sequence" */
  argo_calendar_event_sequence_aggregate: ArgoCalendarEventSequenceAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_data" */
  argo_calendar_event_udf_data: Array<ArgoCalendarEventUdfData>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_data" */
  argo_calendar_event_udf_data_aggregate: ArgoCalendarEventUdfDataAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_data" using primary key columns */
  argo_calendar_event_udf_data_by_pk?: Maybe<ArgoCalendarEventUdfData>;
  /** fetch data from the table: "argo.calendar_event_udf_default_data" */
  argo_calendar_event_udf_default_data: Array<ArgoCalendarEventUdfDefaultData>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_default_data" */
  argo_calendar_event_udf_default_data_aggregate: ArgoCalendarEventUdfDefaultDataAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_default_data" using primary key columns */
  argo_calendar_event_udf_default_data_by_pk?: Maybe<ArgoCalendarEventUdfDefaultData>;
  /** fetch data from the table: "argo.calendar_event_udf_schema" */
  argo_calendar_event_udf_schema: Array<ArgoCalendarEventUdfSchema>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_schema" */
  argo_calendar_event_udf_schema_aggregate: ArgoCalendarEventUdfSchemaAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_schema" using primary key columns */
  argo_calendar_event_udf_schema_by_pk?: Maybe<ArgoCalendarEventUdfSchema>;
  /** fetch data from the table: "argo.calendar_location" */
  argo_calendar_location: Array<ArgoCalendarLocation>;
  /** fetch aggregated fields from the table: "argo.calendar_location" */
  argo_calendar_location_aggregate: ArgoCalendarLocationAggregate;
  /** fetch data from the table: "argo.calendar_location" using primary key columns */
  argo_calendar_location_by_pk?: Maybe<ArgoCalendarLocation>;
  /** fetch data from the table: "argo.connection" */
  argo_connection: Array<ArgoConnection>;
  /** fetch aggregated fields from the table: "argo.connection" */
  argo_connection_aggregate: ArgoConnectionAggregate;
  /** fetch data from the table: "argo.connection" using primary key columns */
  argo_connection_by_pk?: Maybe<ArgoConnection>;
  /** fetch data from the table: "argo.connection_config" */
  argo_connection_config: Array<ArgoConnectionConfig>;
  /** fetch aggregated fields from the table: "argo.connection_config" */
  argo_connection_config_aggregate: ArgoConnectionConfigAggregate;
  /** fetch data from the table: "argo.connection_config" using primary key columns */
  argo_connection_config_by_pk?: Maybe<ArgoConnectionConfig>;
  /** fetch data from the table: "argo.connection_config_status" */
  argo_connection_config_status: Array<ArgoConnectionConfigStatus>;
  /** fetch aggregated fields from the table: "argo.connection_config_status" */
  argo_connection_config_status_aggregate: ArgoConnectionConfigStatusAggregate;
  /** fetch data from the table: "argo.connection_config_status" using primary key columns */
  argo_connection_config_status_by_pk?: Maybe<ArgoConnectionConfigStatus>;
  /** fetch data from the table: "argo.connection_kind" */
  argo_connection_kind: Array<ArgoConnectionKind>;
  /** fetch aggregated fields from the table: "argo.connection_kind" */
  argo_connection_kind_aggregate: ArgoConnectionKindAggregate;
  /** fetch data from the table: "argo.connection_kind" using primary key columns */
  argo_connection_kind_by_pk?: Maybe<ArgoConnectionKind>;
  /** fetch data from the table: "argo.context" */
  argo_context: Array<ArgoContext>;
  /** fetch aggregated fields from the table: "argo.context" */
  argo_context_aggregate: ArgoContextAggregate;
  /** fetch data from the table: "argo.context" using primary key columns */
  argo_context_by_pk?: Maybe<ArgoContext>;
  /** fetch data from the table: "argo.cron_task" */
  argo_cron_task: Array<ArgoCronTask>;
  /** fetch aggregated fields from the table: "argo.cron_task" */
  argo_cron_task_aggregate: ArgoCronTaskAggregate;
  /** fetch data from the table: "argo.cron_task" using primary key columns */
  argo_cron_task_by_pk?: Maybe<ArgoCronTask>;
  /** fetch data from the table: "argo.event" */
  argo_event: Array<ArgoEvent>;
  /** fetch aggregated fields from the table: "argo.event" */
  argo_event_aggregate: ArgoEventAggregate;
  /** fetch data from the table: "argo.event" using primary key columns */
  argo_event_by_pk?: Maybe<ArgoEvent>;
  /** fetch data from the table: "argo.event_type" */
  argo_event_type: Array<ArgoEventType>;
  /** fetch aggregated fields from the table: "argo.event_type" */
  argo_event_type_aggregate: ArgoEventTypeAggregate;
  /** fetch data from the table: "argo.event_type" using primary key columns */
  argo_event_type_by_pk?: Maybe<ArgoEventType>;
  /** fetch data from the table: "argo.hasura_permission" */
  argo_hasura_permission: Array<ArgoHasuraPermission>;
  /** fetch aggregated fields from the table: "argo.hasura_permission" */
  argo_hasura_permission_aggregate: ArgoHasuraPermissionAggregate;
  /** fetch data from the table: "argo.hasura_permission" using primary key columns */
  argo_hasura_permission_by_pk?: Maybe<ArgoHasuraPermission>;
  /** fetch data from the table: "argo.link" */
  argo_link: Array<ArgoLink>;
  /** fetch aggregated fields from the table: "argo.link" */
  argo_link_aggregate: ArgoLinkAggregate;
  /** fetch data from the table: "argo.link" using primary key columns */
  argo_link_by_pk?: Maybe<ArgoLink>;
  /** fetch data from the table: "argo.location" */
  argo_location: Array<ArgoLocation>;
  /** execute function "argo.location_active_calendar" which returns "argo.calendar" */
  argo_location_active_calendar: Array<ArgoCalendar>;
  /** execute function "argo.location_active_calendar" and query aggregates on result of table type "argo.calendar" */
  argo_location_active_calendar_aggregate: ArgoCalendarAggregate;
  /** fetch aggregated fields from the table: "argo.location" */
  argo_location_aggregate: ArgoLocationAggregate;
  /** fetch data from the table: "argo.location_attribute" */
  argo_location_attribute: Array<ArgoLocationAttribute>;
  /** fetch aggregated fields from the table: "argo.location_attribute" */
  argo_location_attribute_aggregate: ArgoLocationAttributeAggregate;
  /** fetch data from the table: "argo.location_attribute" using primary key columns */
  argo_location_attribute_by_pk?: Maybe<ArgoLocationAttribute>;
  /** fetch data from the table: "argo.location_attribute_history" */
  argo_location_attribute_history: Array<ArgoLocationAttributeHistory>;
  /** fetch aggregated fields from the table: "argo.location_attribute_history" */
  argo_location_attribute_history_aggregate: ArgoLocationAttributeHistoryAggregate;
  /** fetch data from the table: "argo.location_attribute_history" using primary key columns */
  argo_location_attribute_history_by_pk?: Maybe<ArgoLocationAttributeHistory>;
  /** fetch data from the table: "argo.location" using primary key columns */
  argo_location_by_pk?: Maybe<ArgoLocation>;
  /** fetch data from the table: "argo.location_class" */
  argo_location_class: Array<ArgoLocationClass>;
  /** fetch aggregated fields from the table: "argo.location_class" */
  argo_location_class_aggregate: ArgoLocationClassAggregate;
  /** fetch data from the table: "argo.location_class" using primary key columns */
  argo_location_class_by_pk?: Maybe<ArgoLocationClass>;
  /** fetch data from the table: "argo.log" */
  argo_log: Array<ArgoLog>;
  /** fetch aggregated fields from the table: "argo.log" */
  argo_log_aggregate: ArgoLogAggregate;
  /** fetch data from the table: "argo.log" using primary key columns */
  argo_log_by_pk?: Maybe<ArgoLog>;
  /** fetch data from the table: "argo.log_category" */
  argo_log_category: Array<ArgoLogCategory>;
  /** fetch aggregated fields from the table: "argo.log_category" */
  argo_log_category_aggregate: ArgoLogCategoryAggregate;
  /** fetch data from the table: "argo.log_category" using primary key columns */
  argo_log_category_by_pk?: Maybe<ArgoLogCategory>;
  /** fetch data from the table: "argo.log_duration" */
  argo_log_duration: Array<ArgoLogDuration>;
  /** fetch aggregated fields from the table: "argo.log_duration" */
  argo_log_duration_aggregate: ArgoLogDurationAggregate;
  /** fetch data from the table: "argo.log_level" */
  argo_log_level: Array<ArgoLogLevel>;
  /** fetch aggregated fields from the table: "argo.log_level" */
  argo_log_level_aggregate: ArgoLogLevelAggregate;
  /** fetch data from the table: "argo.log_level" using primary key columns */
  argo_log_level_by_pk?: Maybe<ArgoLogLevel>;
  /** fetch data from the table: "argo.material" */
  argo_material: Array<ArgoMaterial>;
  /** fetch data from the table: "argo.material_activity" */
  argo_material_activity: Array<ArgoMaterialActivity>;
  /** fetch aggregated fields from the table: "argo.material_activity" */
  argo_material_activity_aggregate: ArgoMaterialActivityAggregate;
  /** fetch data from the table: "argo.material_activity" using primary key columns */
  argo_material_activity_by_pk?: Maybe<ArgoMaterialActivity>;
  /** fetch data from the table: "argo.material_activity_kind" */
  argo_material_activity_kind: Array<ArgoMaterialActivityKind>;
  /** fetch aggregated fields from the table: "argo.material_activity_kind" */
  argo_material_activity_kind_aggregate: ArgoMaterialActivityKindAggregate;
  /** fetch data from the table: "argo.material_activity_kind" using primary key columns */
  argo_material_activity_kind_by_pk?: Maybe<ArgoMaterialActivityKind>;
  /** fetch aggregated fields from the table: "argo.material" */
  argo_material_aggregate: ArgoMaterialAggregate;
  /** fetch data from the table: "argo.material_assembly" */
  argo_material_assembly: Array<ArgoMaterialAssembly>;
  /** fetch aggregated fields from the table: "argo.material_assembly" */
  argo_material_assembly_aggregate: ArgoMaterialAssemblyAggregate;
  /** fetch data from the table: "argo.material_attribute" */
  argo_material_attribute: Array<ArgoMaterialAttribute>;
  /** fetch aggregated fields from the table: "argo.material_attribute" */
  argo_material_attribute_aggregate: ArgoMaterialAttributeAggregate;
  /** fetch data from the table: "argo.material_attribute" using primary key columns */
  argo_material_attribute_by_pk?: Maybe<ArgoMaterialAttribute>;
  /** fetch data from the table: "argo.material_attribute_history" */
  argo_material_attribute_history: Array<ArgoMaterialAttributeHistory>;
  /** fetch aggregated fields from the table: "argo.material_attribute_history" */
  argo_material_attribute_history_aggregate: ArgoMaterialAttributeHistoryAggregate;
  /** fetch data from the table: "argo.material_attribute_history" using primary key columns */
  argo_material_attribute_history_by_pk?: Maybe<ArgoMaterialAttributeHistory>;
  /** fetch data from the table: "argo.material" using primary key columns */
  argo_material_by_pk?: Maybe<ArgoMaterial>;
  /** fetch data from the table: "argo.material_class" */
  argo_material_class: Array<ArgoMaterialClass>;
  /** fetch aggregated fields from the table: "argo.material_class" */
  argo_material_class_aggregate: ArgoMaterialClassAggregate;
  /** fetch data from the table: "argo.material_class_attribute" */
  argo_material_class_attribute: Array<ArgoMaterialClassAttribute>;
  /** fetch aggregated fields from the table: "argo.material_class_attribute" */
  argo_material_class_attribute_aggregate: ArgoMaterialClassAttributeAggregate;
  /** fetch data from the table: "argo.material_class_attribute" using primary key columns */
  argo_material_class_attribute_by_pk?: Maybe<ArgoMaterialClassAttribute>;
  /** fetch data from the table: "argo.material_class_attribute_setting" */
  argo_material_class_attribute_setting: Array<ArgoMaterialClassAttributeSetting>;
  /** fetch aggregated fields from the table: "argo.material_class_attribute_setting" */
  argo_material_class_attribute_setting_aggregate: ArgoMaterialClassAttributeSettingAggregate;
  /** fetch data from the table: "argo.material_class_attribute_setting" using primary key columns */
  argo_material_class_attribute_setting_by_pk?: Maybe<ArgoMaterialClassAttributeSetting>;
  /** fetch data from the table: "argo.material_class" using primary key columns */
  argo_material_class_by_pk?: Maybe<ArgoMaterialClass>;
  /** fetch data from the table: "argo.material_class_process" */
  argo_material_class_process: Array<ArgoMaterialClassProcess>;
  /** fetch aggregated fields from the table: "argo.material_class_process" */
  argo_material_class_process_aggregate: ArgoMaterialClassProcessAggregate;
  /** fetch data from the table: "argo.material_class_process" using primary key columns */
  argo_material_class_process_by_pk?: Maybe<ArgoMaterialClassProcess>;
  /** fetch data from the table: "argo.material_marriage" */
  argo_material_marriage: Array<ArgoMaterialMarriage>;
  /** fetch aggregated fields from the table: "argo.material_marriage" */
  argo_material_marriage_aggregate: ArgoMaterialMarriageAggregate;
  /** fetch data from the table: "argo.material_marriage" using primary key columns */
  argo_material_marriage_by_pk?: Maybe<ArgoMaterialMarriage>;
  /** fetch data from the table: "argo.material_marriage_status" */
  argo_material_marriage_status: Array<ArgoMaterialMarriageStatus>;
  /** fetch aggregated fields from the table: "argo.material_marriage_status" */
  argo_material_marriage_status_aggregate: ArgoMaterialMarriageStatusAggregate;
  /** fetch data from the table: "argo.material_marriage_status" using primary key columns */
  argo_material_marriage_status_by_pk?: Maybe<ArgoMaterialMarriageStatus>;
  /** fetch data from the table: "argo.material_model" */
  argo_material_model: Array<ArgoMaterialModel>;
  /** fetch aggregated fields from the table: "argo.material_model" */
  argo_material_model_aggregate: ArgoMaterialModelAggregate;
  /** fetch data from the table: "argo.material_model_attribute" */
  argo_material_model_attribute: Array<ArgoMaterialModelAttribute>;
  /** fetch aggregated fields from the table: "argo.material_model_attribute" */
  argo_material_model_attribute_aggregate: ArgoMaterialModelAttributeAggregate;
  /** fetch data from the table: "argo.material_model_attribute" using primary key columns */
  argo_material_model_attribute_by_pk?: Maybe<ArgoMaterialModelAttribute>;
  /** fetch data from the table: "argo.material_model_attribute_setting" */
  argo_material_model_attribute_setting: Array<ArgoMaterialModelAttributeSetting>;
  /** fetch aggregated fields from the table: "argo.material_model_attribute_setting" */
  argo_material_model_attribute_setting_aggregate: ArgoMaterialModelAttributeSettingAggregate;
  /** fetch data from the table: "argo.material_model_attribute_setting" using primary key columns */
  argo_material_model_attribute_setting_by_pk?: Maybe<ArgoMaterialModelAttributeSetting>;
  /** fetch data from the table: "argo.material_model" using primary key columns */
  argo_material_model_by_pk?: Maybe<ArgoMaterialModel>;
  /** fetch data from the table: "argo.material_model_process" */
  argo_material_model_process: Array<ArgoMaterialModelProcess>;
  /** fetch aggregated fields from the table: "argo.material_model_process" */
  argo_material_model_process_aggregate: ArgoMaterialModelProcessAggregate;
  /** fetch data from the table: "argo.material_model_process" using primary key columns */
  argo_material_model_process_by_pk?: Maybe<ArgoMaterialModelProcess>;
  /** fetch data from the table: "argo.material_quantity_kind" */
  argo_material_quantity_kind: Array<ArgoMaterialQuantityKind>;
  /** fetch aggregated fields from the table: "argo.material_quantity_kind" */
  argo_material_quantity_kind_aggregate: ArgoMaterialQuantityKindAggregate;
  /** fetch data from the table: "argo.material_quantity_kind" using primary key columns */
  argo_material_quantity_kind_by_pk?: Maybe<ArgoMaterialQuantityKind>;
  /** fetch data from the table: "argo.material_status" */
  argo_material_status: Array<ArgoMaterialStatus>;
  /** fetch aggregated fields from the table: "argo.material_status" */
  argo_material_status_aggregate: ArgoMaterialStatusAggregate;
  /** fetch data from the table: "argo.material_status" using primary key columns */
  argo_material_status_by_pk?: Maybe<ArgoMaterialStatus>;
  /** fetch data from the table: "argo.material_udf_data" */
  argo_material_udf_data: Array<ArgoMaterialUdfData>;
  /** fetch aggregated fields from the table: "argo.material_udf_data" */
  argo_material_udf_data_aggregate: ArgoMaterialUdfDataAggregate;
  /** fetch data from the table: "argo.material_udf_data" using primary key columns */
  argo_material_udf_data_by_pk?: Maybe<ArgoMaterialUdfData>;
  /** fetch data from the table: "argo.material_udf_default_data" */
  argo_material_udf_default_data: Array<ArgoMaterialUdfDefaultData>;
  /** fetch aggregated fields from the table: "argo.material_udf_default_data" */
  argo_material_udf_default_data_aggregate: ArgoMaterialUdfDefaultDataAggregate;
  /** fetch data from the table: "argo.material_udf_default_data" using primary key columns */
  argo_material_udf_default_data_by_pk?: Maybe<ArgoMaterialUdfDefaultData>;
  /** fetch data from the table: "argo.material_udf_schema" */
  argo_material_udf_schema: Array<ArgoMaterialUdfSchema>;
  /** fetch aggregated fields from the table: "argo.material_udf_schema" */
  argo_material_udf_schema_aggregate: ArgoMaterialUdfSchemaAggregate;
  /** fetch data from the table: "argo.material_udf_schema" using primary key columns */
  argo_material_udf_schema_by_pk?: Maybe<ArgoMaterialUdfSchema>;
  /** fetch data from the table: "argo.media_config" */
  argo_media_config: Array<ArgoMediaConfig>;
  /** fetch aggregated fields from the table: "argo.media_config" */
  argo_media_config_aggregate: ArgoMediaConfigAggregate;
  /** fetch data from the table: "argo.media_config" using primary key columns */
  argo_media_config_by_pk?: Maybe<ArgoMediaConfig>;
  /** fetch data from the table: "argo.media_instance" */
  argo_media_instance: Array<ArgoMediaInstance>;
  /** fetch aggregated fields from the table: "argo.media_instance" */
  argo_media_instance_aggregate: ArgoMediaInstanceAggregate;
  /** fetch data from the table: "argo.media_instance" using primary key columns */
  argo_media_instance_by_pk?: Maybe<ArgoMediaInstance>;
  /** fetch data from the table: "argo.pg_timezone_names" */
  argo_pg_timezone_names: Array<ArgoPgTimezoneNames>;
  /** fetch aggregated fields from the table: "argo.pg_timezone_names" */
  argo_pg_timezone_names_aggregate: ArgoPgTimezoneNamesAggregate;
  /** fetch data from the table: "argo.role" */
  argo_role: Array<ArgoRole>;
  /** fetch data from the table: "argo.role_acl" */
  argo_role_acl: Array<ArgoRoleAcl>;
  /** fetch aggregated fields from the table: "argo.role_acl" */
  argo_role_acl_aggregate: ArgoRoleAclAggregate;
  /** fetch data from the table: "argo.role_acl" using primary key columns */
  argo_role_acl_by_pk?: Maybe<ArgoRoleAcl>;
  /** fetch aggregated fields from the table: "argo.role" */
  argo_role_aggregate: ArgoRoleAggregate;
  /** fetch data from the table: "argo.role" using primary key columns */
  argo_role_by_pk?: Maybe<ArgoRole>;
  /** fetch data from the table: "argo.schedule" */
  argo_schedule: Array<ArgoSchedule>;
  /** fetch aggregated fields from the table: "argo.schedule" */
  argo_schedule_aggregate: ArgoScheduleAggregate;
  /** fetch data from the table: "argo.schedule" using primary key columns */
  argo_schedule_by_pk?: Maybe<ArgoSchedule>;
  /** fetch data from the table: "argo.schedule_day" */
  argo_schedule_day: Array<ArgoScheduleDay>;
  /** fetch aggregated fields from the table: "argo.schedule_day" */
  argo_schedule_day_aggregate: ArgoScheduleDayAggregate;
  /** fetch data from the table: "argo.schedule_day" using primary key columns */
  argo_schedule_day_by_pk?: Maybe<ArgoScheduleDay>;
  /** fetch data from the table: "argo.schedule_event" */
  argo_schedule_event: Array<ArgoScheduleEvent>;
  /** fetch aggregated fields from the table: "argo.schedule_event" */
  argo_schedule_event_aggregate: ArgoScheduleEventAggregate;
  /** fetch data from the table: "argo.schedule_event" using primary key columns */
  argo_schedule_event_by_pk?: Maybe<ArgoScheduleEvent>;
  /** fetch data from the table: "argo.schedule_mode" */
  argo_schedule_mode: Array<ArgoScheduleMode>;
  /** fetch aggregated fields from the table: "argo.schedule_mode" */
  argo_schedule_mode_aggregate: ArgoScheduleModeAggregate;
  /** fetch data from the table: "argo.schedule_mode" using primary key columns */
  argo_schedule_mode_by_pk?: Maybe<ArgoScheduleMode>;
  /** fetch data from the table: "argo.sn" */
  argo_sn: Array<ArgoSn>;
  /** fetch aggregated fields from the table: "argo.sn" */
  argo_sn_aggregate: ArgoSnAggregate;
  /** fetch data from the table: "argo.sn" using primary key columns */
  argo_sn_by_pk?: Maybe<ArgoSn>;
  /** fetch data from the table: "argo.sn_format" */
  argo_sn_format: Array<ArgoSnFormat>;
  /** fetch aggregated fields from the table: "argo.sn_format" */
  argo_sn_format_aggregate: ArgoSnFormatAggregate;
  /** fetch data from the table: "argo.sn_format" using primary key columns */
  argo_sn_format_by_pk?: Maybe<ArgoSnFormat>;
  /** fetch data from the table: "argo.sn_format_status" */
  argo_sn_format_status: Array<ArgoSnFormatStatus>;
  /** fetch aggregated fields from the table: "argo.sn_format_status" */
  argo_sn_format_status_aggregate: ArgoSnFormatStatusAggregate;
  /** fetch data from the table: "argo.sn_format_status" using primary key columns */
  argo_sn_format_status_by_pk?: Maybe<ArgoSnFormatStatus>;
  /** fetch data from the table: "argo.sn_format_uniqueness" */
  argo_sn_format_uniqueness: Array<ArgoSnFormatUniqueness>;
  /** fetch aggregated fields from the table: "argo.sn_format_uniqueness" */
  argo_sn_format_uniqueness_aggregate: ArgoSnFormatUniquenessAggregate;
  /** fetch data from the table: "argo.sn_format_uniqueness" using primary key columns */
  argo_sn_format_uniqueness_by_pk?: Maybe<ArgoSnFormatUniqueness>;
  /** execute function "argo.traverse_assemblies" which returns "argo.material_assembly" */
  argo_traverse_assemblies: Array<ArgoMaterialAssembly>;
  /** execute function "argo.traverse_assemblies" and query aggregates on result of table type "argo.material_assembly" */
  argo_traverse_assemblies_aggregate: ArgoMaterialAssemblyAggregate;
  /** fetch data from the table: "argo.udf_column" */
  argo_udf_column: Array<ArgoUdfColumn>;
  /** fetch aggregated fields from the table: "argo.udf_column" */
  argo_udf_column_aggregate: ArgoUdfColumnAggregate;
  /** fetch data from the table: "argo.udf_column" using primary key columns */
  argo_udf_column_by_pk?: Maybe<ArgoUdfColumn>;
  /** fetch data from the table: "argo.udf_column_data_type" */
  argo_udf_column_data_type: Array<ArgoUdfColumnDataType>;
  /** fetch aggregated fields from the table: "argo.udf_column_data_type" */
  argo_udf_column_data_type_aggregate: ArgoUdfColumnDataTypeAggregate;
  /** fetch data from the table: "argo.udf_column_data_type" using primary key columns */
  argo_udf_column_data_type_by_pk?: Maybe<ArgoUdfColumnDataType>;
  /** fetch data from the table: "argo.udf_column_type" */
  argo_udf_column_type: Array<ArgoUdfColumnType>;
  /** fetch aggregated fields from the table: "argo.udf_column_type" */
  argo_udf_column_type_aggregate: ArgoUdfColumnTypeAggregate;
  /** fetch data from the table: "argo.udf_column_type" using primary key columns */
  argo_udf_column_type_by_pk?: Maybe<ArgoUdfColumnType>;
  /** fetch data from the table: "argo.uom" */
  argo_uom: Array<ArgoUom>;
  /** fetch aggregated fields from the table: "argo.uom" */
  argo_uom_aggregate: ArgoUomAggregate;
  /** fetch data from the table: "argo.uom" using primary key columns */
  argo_uom_by_pk?: Maybe<ArgoUom>;
  /** fetch data from the table: "argo.user" */
  argo_user: Array<ArgoUser>;
  /** fetch data from the table: "argo.user_access_token" */
  argo_user_access_token: Array<ArgoUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.user_access_token" */
  argo_user_access_token_aggregate: ArgoUserAccessTokenAggregate;
  /** fetch data from the table: "argo.user_access_token" using primary key columns */
  argo_user_access_token_by_pk?: Maybe<ArgoUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.user" */
  argo_user_aggregate: ArgoUserAggregate;
  /** fetch data from the table: "argo.user_badge" */
  argo_user_badge: Array<ArgoUserBadge>;
  /** fetch aggregated fields from the table: "argo.user_badge" */
  argo_user_badge_aggregate: ArgoUserBadgeAggregate;
  /** fetch data from the table: "argo.user_badge" using primary key columns */
  argo_user_badge_by_pk?: Maybe<ArgoUserBadge>;
  /** fetch data from the table: "argo.user" using primary key columns */
  argo_user_by_pk?: Maybe<ArgoUser>;
  /** fetch data from the table: "argo.user_context" */
  argo_user_context: Array<ArgoUserContext>;
  /** fetch aggregated fields from the table: "argo.user_context" */
  argo_user_context_aggregate: ArgoUserContextAggregate;
  /** fetch data from the table: "argo.user_context" using primary key columns */
  argo_user_context_by_pk?: Maybe<ArgoUserContext>;
  /** fetch data from the table: "argo.user_role" */
  argo_user_role: Array<ArgoUserRole>;
  /** fetch aggregated fields from the table: "argo.user_role" */
  argo_user_role_aggregate: ArgoUserRoleAggregate;
  /** fetch data from the table: "argo.user_role" using primary key columns */
  argo_user_role_by_pk?: Maybe<ArgoUserRole>;
  /** fetch data from the table: "argo.vw_acl_role" */
  argo_vw_acl_role: Array<ArgoVwAclRole>;
  /** fetch aggregated fields from the table: "argo.vw_acl_role" */
  argo_vw_acl_role_aggregate: ArgoVwAclRoleAggregate;
  /** fetch data from the table: "argo.vw_active_location_calendar" */
  argo_vw_active_location_calendar: Array<ArgoVwActiveLocationCalendar>;
  /** fetch aggregated fields from the table: "argo.vw_active_location_calendar" */
  argo_vw_active_location_calendar_aggregate: ArgoVwActiveLocationCalendarAggregate;
  /** fetch data from the table: "argo.vw_auth_user_access_token" */
  argo_vw_auth_user_access_token: Array<ArgoVwAuthUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.vw_auth_user_access_token" */
  argo_vw_auth_user_access_token_aggregate: ArgoVwAuthUserAccessTokenAggregate;
  /** fetch data from the table: "argo.vw_event_type_udf_column" */
  argo_vw_event_type_udf_column: Array<ArgoVwEventTypeUdfColumn>;
  /** fetch aggregated fields from the table: "argo.vw_event_type_udf_column" */
  argo_vw_event_type_udf_column_aggregate: ArgoVwEventTypeUdfColumnAggregate;
  /** fetch data from the table: "argo.vw_location_hierarchy" */
  argo_vw_location_hierarchy: Array<ArgoVwLocationHierarchy>;
  /** fetch aggregated fields from the table: "argo.vw_location_hierarchy" */
  argo_vw_location_hierarchy_aggregate: ArgoVwLocationHierarchyAggregate;
  /** fetch data from the table: "argo.vw_material_by_class" */
  argo_vw_material_by_class: Array<ArgoVwMaterialByClass>;
  /** fetch aggregated fields from the table: "argo.vw_material_by_class" */
  argo_vw_material_by_class_aggregate: ArgoVwMaterialByClassAggregate;
  /** fetch data from the table: "argo.vw_material_class_udf_column" */
  argo_vw_material_class_udf_column: Array<ArgoVwMaterialClassUdfColumn>;
  /** fetch aggregated fields from the table: "argo.vw_material_class_udf_column" */
  argo_vw_material_class_udf_column_aggregate: ArgoVwMaterialClassUdfColumnAggregate;
  /** fetch data from the table: "argo.vw_material_model_processes_by_class" */
  argo_vw_material_model_processes_by_class: Array<ArgoVwMaterialModelProcessesByClass>;
  /** fetch aggregated fields from the table: "argo.vw_material_model_processes_by_class" */
  argo_vw_material_model_processes_by_class_aggregate: ArgoVwMaterialModelProcessesByClassAggregate;
  /** fetch data from the table: "argo.vw_role_acl" */
  argo_vw_role_acl: Array<ArgoVwRoleAcl>;
  /** fetch aggregated fields from the table: "argo.vw_role_acl" */
  argo_vw_role_acl_aggregate: ArgoVwRoleAclAggregate;
  /** fetch data from the table: "argo.vw_timestamptz" */
  argo_vw_timestamptz: Array<ArgoVwTimestamptz>;
  /** fetch aggregated fields from the table: "argo.vw_timestamptz" */
  argo_vw_timestamptz_aggregate: ArgoVwTimestamptzAggregate;
  /** fetch data from the table: "argo.vw_user_acls" */
  argo_vw_user_acls: Array<ArgoVwUserAcls>;
  /** fetch aggregated fields from the table: "argo.vw_user_acls" */
  argo_vw_user_acls_aggregate: ArgoVwUserAclsAggregate;
  /** fetch data from the table: "argo.vw_user_context_acl" */
  argo_vw_user_context_acl: Array<ArgoVwUserContextAcl>;
  /** fetch aggregated fields from the table: "argo.vw_user_context_acl" */
  argo_vw_user_context_acl_aggregate: ArgoVwUserContextAclAggregate;
  /** fetch data from the table: "argo.vw_user_roles" */
  argo_vw_user_roles: Array<ArgoVwUserRoles>;
  /** fetch aggregated fields from the table: "argo.vw_user_roles" */
  argo_vw_user_roles_aggregate: ArgoVwUserRolesAggregate;
  /** fetch data from the table: "argo.work_instruction" */
  argo_work_instruction: Array<ArgoWorkInstruction>;
  /** fetch aggregated fields from the table: "argo.work_instruction" */
  argo_work_instruction_aggregate: ArgoWorkInstructionAggregate;
  /** fetch data from the table: "argo.work_instruction" using primary key columns */
  argo_work_instruction_by_pk?: Maybe<ArgoWorkInstruction>;
  /** fetch data from the table: "argo.work_instruction_instance" */
  argo_work_instruction_instance: Array<ArgoWorkInstructionInstance>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance" */
  argo_work_instruction_instance_aggregate: ArgoWorkInstructionInstanceAggregate;
  /** fetch data from the table: "argo.work_instruction_instance" using primary key columns */
  argo_work_instruction_instance_by_pk?: Maybe<ArgoWorkInstructionInstance>;
  /** fetch data from the table: "argo.work_instruction_instance_status" */
  argo_work_instruction_instance_status: Array<ArgoWorkInstructionInstanceStatus>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance_status" */
  argo_work_instruction_instance_status_aggregate: ArgoWorkInstructionInstanceStatusAggregate;
  /** fetch data from the table: "argo.work_instruction_instance_status" using primary key columns */
  argo_work_instruction_instance_status_by_pk?: Maybe<ArgoWorkInstructionInstanceStatus>;
  /** fetch data from the table: "argo.work_instruction_instance_step" */
  argo_work_instruction_instance_step: Array<ArgoWorkInstructionInstanceStep>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance_step" */
  argo_work_instruction_instance_step_aggregate: ArgoWorkInstructionInstanceStepAggregate;
  /** fetch data from the table: "argo.work_instruction_instance_step" using primary key columns */
  argo_work_instruction_instance_step_by_pk?: Maybe<ArgoWorkInstructionInstanceStep>;
  /** fetch data from the table: "argo.work_instruction_version" */
  argo_work_instruction_version: Array<ArgoWorkInstructionVersion>;
  /** fetch aggregated fields from the table: "argo.work_instruction_version" */
  argo_work_instruction_version_aggregate: ArgoWorkInstructionVersionAggregate;
  /** fetch data from the table: "argo.work_instruction_version" using primary key columns */
  argo_work_instruction_version_by_pk?: Maybe<ArgoWorkInstructionVersion>;
  /** fetch data from the table: "argo.work_instruction_version_status" */
  argo_work_instruction_version_status: Array<ArgoWorkInstructionVersionStatus>;
  /** fetch aggregated fields from the table: "argo.work_instruction_version_status" */
  argo_work_instruction_version_status_aggregate: ArgoWorkInstructionVersionStatusAggregate;
  /** fetch data from the table: "argo.work_instruction_version_status" using primary key columns */
  argo_work_instruction_version_status_by_pk?: Maybe<ArgoWorkInstructionVersionStatus>;
  /** fetch data from the table: "argo.work_order" */
  argo_work_order: Array<ArgoWorkOrder>;
  /** fetch data from the table: "argo.work_order_activity" */
  argo_work_order_activity: Array<ArgoWorkOrderActivity>;
  /** fetch aggregated fields from the table: "argo.work_order_activity" */
  argo_work_order_activity_aggregate: ArgoWorkOrderActivityAggregate;
  /** fetch data from the table: "argo.work_order_activity" using primary key columns */
  argo_work_order_activity_by_pk?: Maybe<ArgoWorkOrderActivity>;
  /** fetch data from the table: "argo.work_order_activity_kind" */
  argo_work_order_activity_kind: Array<ArgoWorkOrderActivityKind>;
  /** fetch aggregated fields from the table: "argo.work_order_activity_kind" */
  argo_work_order_activity_kind_aggregate: ArgoWorkOrderActivityKindAggregate;
  /** fetch data from the table: "argo.work_order_activity_kind" using primary key columns */
  argo_work_order_activity_kind_by_pk?: Maybe<ArgoWorkOrderActivityKind>;
  /** fetch aggregated fields from the table: "argo.work_order" */
  argo_work_order_aggregate: ArgoWorkOrderAggregate;
  /** fetch data from the table: "argo.work_order" using primary key columns */
  argo_work_order_by_pk?: Maybe<ArgoWorkOrder>;
  /** fetch data from the table: "argo.work_order_location" */
  argo_work_order_location: Array<ArgoWorkOrderLocation>;
  /** fetch aggregated fields from the table: "argo.work_order_location" */
  argo_work_order_location_aggregate: ArgoWorkOrderLocationAggregate;
  /** fetch data from the table: "argo.work_order_location" using primary key columns */
  argo_work_order_location_by_pk?: Maybe<ArgoWorkOrderLocation>;
  /** fetch data from the table: "argo.work_order_material" */
  argo_work_order_material: Array<ArgoWorkOrderMaterial>;
  /** fetch aggregated fields from the table: "argo.work_order_material" */
  argo_work_order_material_aggregate: ArgoWorkOrderMaterialAggregate;
  /** fetch data from the table: "argo.work_order_material" using primary key columns */
  argo_work_order_material_by_pk?: Maybe<ArgoWorkOrderMaterial>;
  /** fetch data from the table: "argo.work_order_restriction" */
  argo_work_order_restriction: Array<ArgoWorkOrderRestriction>;
  /** fetch aggregated fields from the table: "argo.work_order_restriction" */
  argo_work_order_restriction_aggregate: ArgoWorkOrderRestrictionAggregate;
  /** fetch data from the table: "argo.work_order_restriction" using primary key columns */
  argo_work_order_restriction_by_pk?: Maybe<ArgoWorkOrderRestriction>;
  /** fetch data from the table: "argo.work_order_status" */
  argo_work_order_status: Array<ArgoWorkOrderStatus>;
  /** fetch aggregated fields from the table: "argo.work_order_status" */
  argo_work_order_status_aggregate: ArgoWorkOrderStatusAggregate;
  /** fetch data from the table: "argo.work_order_status" using primary key columns */
  argo_work_order_status_by_pk?: Maybe<ArgoWorkOrderStatus>;
  /** fetch data from the table: "fis.asset" */
  fis_asset: Array<FisAsset>;
  /** fetch aggregated fields from the table: "fis.asset" */
  fis_asset_aggregate: FisAssetAggregate;
  /** fetch data from the table: "fis.asset" using primary key columns */
  fis_asset_by_pk?: Maybe<FisAsset>;
  /** fetch data from the table: "fis.asset_code" */
  fis_asset_code: Array<FisAssetCode>;
  /** fetch aggregated fields from the table: "fis.asset_code" */
  fis_asset_code_aggregate: FisAssetCodeAggregate;
  /** fetch data from the table: "fis.asset_code" using primary key columns */
  fis_asset_code_by_pk?: Maybe<FisAssetCode>;
  /** fetch data from the table: "fis.asset_tag" */
  fis_asset_tag: Array<FisAssetTag>;
  /** fetch aggregated fields from the table: "fis.asset_tag" */
  fis_asset_tag_aggregate: FisAssetTagAggregate;
  /** fetch data from the table: "fis.asset_tag" using primary key columns */
  fis_asset_tag_by_pk?: Maybe<FisAssetTag>;
  /** fetch data from the table: "fis.asset_tag_link" */
  fis_asset_tag_link: Array<FisAssetTagLink>;
  /** fetch aggregated fields from the table: "fis.asset_tag_link" */
  fis_asset_tag_link_aggregate: FisAssetTagLinkAggregate;
  /** fetch data from the table: "fis.asset_tag_link" using primary key columns */
  fis_asset_tag_link_by_pk?: Maybe<FisAssetTagLink>;
  /** fetch data from the table: "fis.asset_type" */
  fis_asset_type: Array<FisAssetType>;
  /** fetch aggregated fields from the table: "fis.asset_type" */
  fis_asset_type_aggregate: FisAssetTypeAggregate;
  /** fetch data from the table: "fis.asset_type" using primary key columns */
  fis_asset_type_by_pk?: Maybe<FisAssetType>;
  /** fetch data from the table: "fis.core_state" */
  fis_core_state: Array<FisCoreState>;
  /** fetch aggregated fields from the table: "fis.core_state" */
  fis_core_state_aggregate: FisCoreStateAggregate;
  /** fetch data from the table: "fis.core_state" using primary key columns */
  fis_core_state_by_pk?: Maybe<FisCoreState>;
  /** fetch data from the table: "fis.data" */
  fis_data: Array<FisData>;
  /** fetch aggregated fields from the table: "fis.data" */
  fis_data_aggregate: FisDataAggregate;
  /** fetch data from the table: "fis.data" using primary key columns */
  fis_data_by_pk?: Maybe<FisData>;
  /** fetch data from the table: "fis.data_label" */
  fis_data_label: Array<FisDataLabel>;
  /** fetch aggregated fields from the table: "fis.data_label" */
  fis_data_label_aggregate: FisDataLabelAggregate;
  /** fetch data from the table: "fis.data_label" using primary key columns */
  fis_data_label_by_pk?: Maybe<FisDataLabel>;
  /** fetch data from the table: "fis.data_timing" */
  fis_data_timing: Array<FisDataTiming>;
  /** fetch aggregated fields from the table: "fis.data_timing" */
  fis_data_timing_aggregate: FisDataTimingAggregate;
  /** fetch data from the table: "fis.data_timing" using primary key columns */
  fis_data_timing_by_pk?: Maybe<FisDataTiming>;
  /** fetch data from the table: "fis.data_track_count" */
  fis_data_track_count: Array<FisDataTrackCount>;
  /** fetch aggregated fields from the table: "fis.data_track_count" */
  fis_data_track_count_aggregate: FisDataTrackCountAggregate;
  /** fetch data from the table: "fis.data_track_count" using primary key columns */
  fis_data_track_count_by_pk?: Maybe<FisDataTrackCount>;
  /** fetch data from the table: "fis.data_track_duration" */
  fis_data_track_duration: Array<FisDataTrackDuration>;
  /** fetch aggregated fields from the table: "fis.data_track_duration" */
  fis_data_track_duration_aggregate: FisDataTrackDurationAggregate;
  /** fetch data from the table: "fis.data_track_duration" using primary key columns */
  fis_data_track_duration_by_pk?: Maybe<FisDataTrackDuration>;
  /** fetch data from the table: "fis.data_track_scalar" */
  fis_data_track_scalar: Array<FisDataTrackScalar>;
  /** fetch aggregated fields from the table: "fis.data_track_scalar" */
  fis_data_track_scalar_aggregate: FisDataTrackScalarAggregate;
  /** fetch data from the table: "fis.data_track_scalar" using primary key columns */
  fis_data_track_scalar_by_pk?: Maybe<FisDataTrackScalar>;
  /** fetch data from the table: "fis.data_type" */
  fis_data_type: Array<FisDataType>;
  /** fetch aggregated fields from the table: "fis.data_type" */
  fis_data_type_aggregate: FisDataTypeAggregate;
  /** fetch data from the table: "fis.data_type" using primary key columns */
  fis_data_type_by_pk?: Maybe<FisDataType>;
  /** fetch data from the table: "fis.report_constraint" */
  fis_report_constraint: Array<FisReportConstraint>;
  /** fetch aggregated fields from the table: "fis.report_constraint" */
  fis_report_constraint_aggregate: FisReportConstraintAggregate;
  /** fetch data from the table: "fis.report_detail" */
  fis_report_detail: Array<FisReportDetail>;
  /** fetch aggregated fields from the table: "fis.report_detail" */
  fis_report_detail_aggregate: FisReportDetailAggregate;
  /** fetch data from the table: "fis.report_mtbf" */
  fis_report_mtbf: Array<FisReportMtbf>;
  /** fetch aggregated fields from the table: "fis.report_mtbf" */
  fis_report_mtbf_aggregate: FisReportMtbfAggregate;
  /** fetch data from the table: "fis.report_oee" */
  fis_report_oee: Array<FisReportOee>;
  /** fetch aggregated fields from the table: "fis.report_oee" */
  fis_report_oee_aggregate: FisReportOeeAggregate;
  /** fetch data from the table: "fis.report_state" */
  fis_report_state: Array<FisReportState>;
  /** fetch aggregated fields from the table: "fis.report_state" */
  fis_report_state_aggregate: FisReportStateAggregate;
  /** fetch data from the table: "fis.report_state_column" */
  fis_report_state_column: Array<FisReportStateColumn>;
  /** fetch aggregated fields from the table: "fis.report_state_column" */
  fis_report_state_column_aggregate: FisReportStateColumnAggregate;
  /** fetch data from the table: "fis.report_top_fault" */
  fis_report_top_fault: Array<FisReportTopFault>;
  /** fetch aggregated fields from the table: "fis.report_top_fault" */
  fis_report_top_fault_aggregate: FisReportTopFaultAggregate;
  /** execute function "fis.run_report_constraint" which returns "fis.report_constraint" */
  fis_run_report_constraint: Array<FisReportConstraint>;
  /** execute function "fis.run_report_constraint" and query aggregates on result of table type "fis.report_constraint" */
  fis_run_report_constraint_aggregate: FisReportConstraintAggregate;
  /** execute function "fis.run_report_mtbf" which returns "fis.report_mtbf" */
  fis_run_report_mtbf: Array<FisReportMtbf>;
  /** execute function "fis.run_report_mtbf" and query aggregates on result of table type "fis.report_mtbf" */
  fis_run_report_mtbf_aggregate: FisReportMtbfAggregate;
  /** execute function "fis.run_report_oee" which returns "fis.report_oee" */
  fis_run_report_oee: Array<FisReportOee>;
  /** execute function "fis.run_report_oee" and query aggregates on result of table type "fis.report_oee" */
  fis_run_report_oee_aggregate: FisReportOeeAggregate;
  /** execute function "fis.run_report_state" which returns "fis.report_state" */
  fis_run_report_state: Array<FisReportState>;
  /** execute function "fis.run_report_state" and query aggregates on result of table type "fis.report_state" */
  fis_run_report_state_aggregate: FisReportStateAggregate;
  /** execute function "fis.run_report_state_column" which returns "fis.report_state_column" */
  fis_run_report_state_column: Array<FisReportStateColumn>;
  /** execute function "fis.run_report_state_column" and query aggregates on result of table type "fis.report_state_column" */
  fis_run_report_state_column_aggregate: FisReportStateColumnAggregate;
  /** execute function "fis.run_report_top_fault" which returns "fis.report_top_fault" */
  fis_run_report_top_fault: Array<FisReportTopFault>;
  /** execute function "fis.run_report_top_fault" and query aggregates on result of table type "fis.report_top_fault" */
  fis_run_report_top_fault_aggregate: FisReportTopFaultAggregate;
  /** fetch data from the table: "plv8_response" */
  plv8_response: Array<Plv8Response>;
  /** fetch aggregated fields from the table: "plv8_response" */
  plv8_response_aggregate: Plv8ResponseAggregate;
  /** fetch data from the table: "plv8_value_response" */
  plv8_value_response: Array<Plv8ValueResponse>;
  /** fetch aggregated fields from the table: "plv8_value_response" */
  plv8_value_response_aggregate: Plv8ValueResponseAggregate;
  /** fetch data from the table: "process.collection" */
  process_collection: Array<ProcessCollection>;
  /** fetch aggregated fields from the table: "process.collection" */
  process_collection_aggregate: ProcessCollectionAggregate;
  /** fetch data from the table: "process.collection" using primary key columns */
  process_collection_by_pk?: Maybe<ProcessCollection>;
  /** fetch data from the table: "process.collection_data" */
  process_collection_data: Array<ProcessCollectionData>;
  /** fetch aggregated fields from the table: "process.collection_data" */
  process_collection_data_aggregate: ProcessCollectionDataAggregate;
  /** fetch data from the table: "process.collection_data" using primary key columns */
  process_collection_data_by_pk?: Maybe<ProcessCollectionData>;
  /** fetch data from the table: "process.collection_kind" */
  process_collection_kind: Array<ProcessCollectionKind>;
  /** fetch aggregated fields from the table: "process.collection_kind" */
  process_collection_kind_aggregate: ProcessCollectionKindAggregate;
  /** fetch data from the table: "process.collection_kind" using primary key columns */
  process_collection_kind_by_pk?: Maybe<ProcessCollectionKind>;
  /** fetch data from the table: "process.data_element" */
  process_data_element: Array<ProcessDataElement>;
  /** fetch aggregated fields from the table: "process.data_element" */
  process_data_element_aggregate: ProcessDataElementAggregate;
  /** fetch data from the table: "process.data_element" using primary key columns */
  process_data_element_by_pk?: Maybe<ProcessDataElement>;
  /** fetch data from the table: "process.data_element_collection_kind" */
  process_data_element_collection_kind: Array<ProcessDataElementCollectionKind>;
  /** fetch aggregated fields from the table: "process.data_element_collection_kind" */
  process_data_element_collection_kind_aggregate: ProcessDataElementCollectionKindAggregate;
  /** fetch data from the table: "process.data_element_collection_kind" using primary key columns */
  process_data_element_collection_kind_by_pk?: Maybe<ProcessDataElementCollectionKind>;
  /** fetch data from the table: "process.data_element_kind" */
  process_data_element_kind: Array<ProcessDataElementKind>;
  /** fetch aggregated fields from the table: "process.data_element_kind" */
  process_data_element_kind_aggregate: ProcessDataElementKindAggregate;
  /** fetch data from the table: "process.data_element_kind" using primary key columns */
  process_data_element_kind_by_pk?: Maybe<ProcessDataElementKind>;
  /** fetch data from the table: "process.material_state" */
  process_material_state: Array<ProcessMaterialState>;
  /** fetch aggregated fields from the table: "process.material_state" */
  process_material_state_aggregate: ProcessMaterialStateAggregate;
  /** fetch data from the table: "process.material_state" using primary key columns */
  process_material_state_by_pk?: Maybe<ProcessMaterialState>;
  /** fetch data from the table: "process.material_state_history" */
  process_material_state_history: Array<ProcessMaterialStateHistory>;
  /** fetch aggregated fields from the table: "process.material_state_history" */
  process_material_state_history_aggregate: ProcessMaterialStateHistoryAggregate;
  /** fetch data from the table: "process.material_state_history" using primary key columns */
  process_material_state_history_by_pk?: Maybe<ProcessMaterialStateHistory>;
  /** fetch data from the table: "process.process" */
  process_process: Array<ProcessProcess>;
  /** fetch aggregated fields from the table: "process.process" */
  process_process_aggregate: ProcessProcessAggregate;
  /** fetch data from the table: "process.process" using primary key columns */
  process_process_by_pk?: Maybe<ProcessProcess>;
  /** fetch data from the table: "process.process_status" */
  process_process_status: Array<ProcessProcessStatus>;
  /** fetch aggregated fields from the table: "process.process_status" */
  process_process_status_aggregate: ProcessProcessStatusAggregate;
  /** fetch data from the table: "process.process_status" using primary key columns */
  process_process_status_by_pk?: Maybe<ProcessProcessStatus>;
  /** fetch data from the table: "process.spec" */
  process_spec: Array<ProcessSpec>;
  /** fetch aggregated fields from the table: "process.spec" */
  process_spec_aggregate: ProcessSpecAggregate;
  /** fetch data from the table: "process.spec" using primary key columns */
  process_spec_by_pk?: Maybe<ProcessSpec>;
  /** fetch data from the table: "process.spec_order" */
  process_spec_order: Array<ProcessSpecOrder>;
  /** fetch aggregated fields from the table: "process.spec_order" */
  process_spec_order_aggregate: ProcessSpecOrderAggregate;
  /** fetch data from the table: "process.spec_order" using primary key columns */
  process_spec_order_by_pk?: Maybe<ProcessSpecOrder>;
};


export type QueryRootAppletDeploymentArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


export type QueryRootAppletDeploymentAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


export type QueryRootAppletDeploymentByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootAppletDeploymentLinkedDesignVersionArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


export type QueryRootAppletDeploymentLinkedDesignVersionAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


export type QueryRootAppletDeploymentLinkedDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootAppletDesignArgs = {
  distinct_on?: Maybe<Array<AppletDesignSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignOrderBy>>;
  where?: Maybe<AppletDesignBoolExp>;
};


export type QueryRootAppletDesignAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignOrderBy>>;
  where?: Maybe<AppletDesignBoolExp>;
};


export type QueryRootAppletDesignByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootAppletDesignVersionArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


export type QueryRootAppletDesignVersionAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


export type QueryRootAppletDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootAppletDesignVersionStatusArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionStatusOrderBy>>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};


export type QueryRootAppletDesignVersionStatusAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionStatusOrderBy>>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};


export type QueryRootAppletDesignVersionStatusByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootAppletRegistrationCodeArgs = {
  distinct_on?: Maybe<Array<AppletRegistrationCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRegistrationCodeOrderBy>>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};


export type QueryRootAppletRegistrationCodeAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRegistrationCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRegistrationCodeOrderBy>>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};


export type QueryRootAppletRegistrationCodeByPkArgs = {
  context_id: Scalars['uuid'];
  created_by_id: Scalars['uuid'];
};


export type QueryRootAppletRunnerArgs = {
  distinct_on?: Maybe<Array<AppletRunnerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerOrderBy>>;
  where?: Maybe<AppletRunnerBoolExp>;
};


export type QueryRootAppletRunnerAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRunnerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerOrderBy>>;
  where?: Maybe<AppletRunnerBoolExp>;
};


export type QueryRootAppletRunnerByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootAppletRunnerContextArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


export type QueryRootAppletRunnerContextAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


export type QueryRootAppletRunnerContextByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAclArgs = {
  distinct_on?: Maybe<Array<ArgoAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAclOrderBy>>;
  where?: Maybe<ArgoAclBoolExp>;
};


export type QueryRootArgoAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAclOrderBy>>;
  where?: Maybe<ArgoAclBoolExp>;
};


export type QueryRootArgoAclByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootArgoAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


export type QueryRootArgoAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


export type QueryRootArgoAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAttributeDataArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


export type QueryRootArgoAttributeDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


export type QueryRootArgoAttributeDataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAttributeHistoryStatusTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeHistoryStatusTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeHistoryStatusTypeOrderBy>>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};


export type QueryRootArgoAttributeHistoryStatusTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeHistoryStatusTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeHistoryStatusTypeOrderBy>>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};


export type QueryRootArgoAttributeHistoryStatusTypeByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootArgoAttributeSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


export type QueryRootArgoAttributeSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


export type QueryRootArgoAttributeSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAttributeSchemaDefinitionArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


export type QueryRootArgoAttributeSchemaDefinitionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


export type QueryRootArgoAttributeSchemaDefinitionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAttributeSchemaDefinitionTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};


export type QueryRootArgoAttributeSchemaDefinitionTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};


export type QueryRootArgoAttributeSchemaDefinitionTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootArgoAttributeSchemaTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};


export type QueryRootArgoAttributeSchemaTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};


export type QueryRootArgoAttributeSchemaTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootArgoAuditArgs = {
  distinct_on?: Maybe<Array<ArgoAuditSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuditOrderBy>>;
  where?: Maybe<ArgoAuditBoolExp>;
};


export type QueryRootArgoAuditAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuditSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuditOrderBy>>;
  where?: Maybe<ArgoAuditBoolExp>;
};


export type QueryRootArgoAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAuthProviderArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderOrderBy>>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};


export type QueryRootArgoAuthProviderAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderOrderBy>>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};


export type QueryRootArgoAuthProviderByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootArgoAuthProviderLocalArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


export type QueryRootArgoAuthProviderLocalAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


export type QueryRootArgoAuthProviderLocalByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAuthProviderLocalSettingArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};


export type QueryRootArgoAuthProviderLocalSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};


export type QueryRootArgoAuthProviderLocalSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAuthProviderMsalArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};


export type QueryRootArgoAuthProviderMsalAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};


export type QueryRootArgoAuthProviderMsalByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAuthProviderMsalSettingArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};


export type QueryRootArgoAuthProviderMsalSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};


export type QueryRootArgoAuthProviderMsalSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoAuthProviderRecordArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


export type QueryRootArgoAuthProviderRecordAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


export type QueryRootArgoAuthProviderRecordByPkArgs = {
  auth_provider_record_id: Scalars['uuid'];
};


export type QueryRootArgoAuthRefreshTokenArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


export type QueryRootArgoAuthRefreshTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


export type QueryRootArgoAuthRefreshTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type QueryRootArgoCalendarAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type QueryRootArgoCalendarByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarCurrentAndNextArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarCurrentAndNextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarCurrentAndNextOrderBy>>;
  where?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
};


export type QueryRootArgoCalendarCurrentAndNextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarCurrentAndNextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarCurrentAndNextOrderBy>>;
  where?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
};


export type QueryRootArgoCalendarEventArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


export type QueryRootArgoCalendarEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


export type QueryRootArgoCalendarEventByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarEventSequenceArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSequenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventSequenceOrderBy>>;
  where?: Maybe<ArgoCalendarEventSequenceBoolExp>;
};


export type QueryRootArgoCalendarEventSequenceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSequenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventSequenceOrderBy>>;
  where?: Maybe<ArgoCalendarEventSequenceBoolExp>;
};


export type QueryRootArgoCalendarEventUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


export type QueryRootArgoCalendarEventUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


export type QueryRootArgoCalendarEventUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarEventUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


export type QueryRootArgoCalendarEventUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


export type QueryRootArgoCalendarEventUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarEventUdfSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


export type QueryRootArgoCalendarEventUdfSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


export type QueryRootArgoCalendarEventUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCalendarLocationArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


export type QueryRootArgoCalendarLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


export type QueryRootArgoCalendarLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoConnectionArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionOrderBy>>;
  where?: Maybe<ArgoConnectionBoolExp>;
};


export type QueryRootArgoConnectionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionOrderBy>>;
  where?: Maybe<ArgoConnectionBoolExp>;
};


export type QueryRootArgoConnectionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoConnectionConfigArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


export type QueryRootArgoConnectionConfigAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


export type QueryRootArgoConnectionConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoConnectionConfigStatusArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigStatusOrderBy>>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};


export type QueryRootArgoConnectionConfigStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigStatusOrderBy>>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};


export type QueryRootArgoConnectionConfigStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootArgoConnectionKindArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionKindOrderBy>>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};


export type QueryRootArgoConnectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionKindOrderBy>>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};


export type QueryRootArgoConnectionKindByPkArgs = {
  kind: Scalars['String'];
};


export type QueryRootArgoContextArgs = {
  distinct_on?: Maybe<Array<ArgoContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoContextOrderBy>>;
  where?: Maybe<ArgoContextBoolExp>;
};


export type QueryRootArgoContextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoContextOrderBy>>;
  where?: Maybe<ArgoContextBoolExp>;
};


export type QueryRootArgoContextByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoCronTaskArgs = {
  distinct_on?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCronTaskOrderBy>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


export type QueryRootArgoCronTaskAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCronTaskOrderBy>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


export type QueryRootArgoCronTaskByPkArgs = {
  cron_name: Scalars['String'];
};


export type QueryRootArgoEventArgs = {
  distinct_on?: Maybe<Array<ArgoEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventOrderBy>>;
  where?: Maybe<ArgoEventBoolExp>;
};


export type QueryRootArgoEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventOrderBy>>;
  where?: Maybe<ArgoEventBoolExp>;
};


export type QueryRootArgoEventByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoEventTypeArgs = {
  distinct_on?: Maybe<Array<ArgoEventTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventTypeOrderBy>>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};


export type QueryRootArgoEventTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoEventTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventTypeOrderBy>>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};


export type QueryRootArgoEventTypeByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootArgoHasuraPermissionArgs = {
  distinct_on?: Maybe<Array<ArgoHasuraPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoHasuraPermissionOrderBy>>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};


export type QueryRootArgoHasuraPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoHasuraPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoHasuraPermissionOrderBy>>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};


export type QueryRootArgoHasuraPermissionByPkArgs = {
  name: Scalars['String'];
};


export type QueryRootArgoLinkArgs = {
  distinct_on?: Maybe<Array<ArgoLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLinkOrderBy>>;
  where?: Maybe<ArgoLinkBoolExp>;
};


export type QueryRootArgoLinkAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLinkOrderBy>>;
  where?: Maybe<ArgoLinkBoolExp>;
};


export type QueryRootArgoLinkByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoLocationArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


export type QueryRootArgoLocationActiveCalendarArgs = {
  args: ArgoLocationActiveCalendarArgs;
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type QueryRootArgoLocationActiveCalendarAggregateArgs = {
  args: ArgoLocationActiveCalendarArgs;
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type QueryRootArgoLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


export type QueryRootArgoLocationAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


export type QueryRootArgoLocationAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


export type QueryRootArgoLocationAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoLocationAttributeHistoryArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};


export type QueryRootArgoLocationAttributeHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};


export type QueryRootArgoLocationAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoLocationClassArgs = {
  distinct_on?: Maybe<Array<ArgoLocationClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationClassOrderBy>>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};


export type QueryRootArgoLocationClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationClassOrderBy>>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};


export type QueryRootArgoLocationClassByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoLogArgs = {
  distinct_on?: Maybe<Array<ArgoLogSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogOrderBy>>;
  where?: Maybe<ArgoLogBoolExp>;
};


export type QueryRootArgoLogAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogOrderBy>>;
  where?: Maybe<ArgoLogBoolExp>;
};


export type QueryRootArgoLogByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootArgoLogCategoryArgs = {
  distinct_on?: Maybe<Array<ArgoLogCategorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogCategoryOrderBy>>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};


export type QueryRootArgoLogCategoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogCategorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogCategoryOrderBy>>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};


export type QueryRootArgoLogCategoryByPkArgs = {
  category: Scalars['String'];
};


export type QueryRootArgoLogDurationArgs = {
  distinct_on?: Maybe<Array<ArgoLogDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogDurationOrderBy>>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};


export type QueryRootArgoLogDurationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogDurationOrderBy>>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};


export type QueryRootArgoLogLevelArgs = {
  distinct_on?: Maybe<Array<ArgoLogLevelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogLevelOrderBy>>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};


export type QueryRootArgoLogLevelAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogLevelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogLevelOrderBy>>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};


export type QueryRootArgoLogLevelByPkArgs = {
  level: Scalars['String'];
};


export type QueryRootArgoMaterialArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


export type QueryRootArgoMaterialActivityArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityOrderBy>>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};


export type QueryRootArgoMaterialActivityAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityOrderBy>>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};


export type QueryRootArgoMaterialActivityByPkArgs = {
  material_activity_id: Scalars['uuid'];
};


export type QueryRootArgoMaterialActivityKindArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityKindOrderBy>>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};


export type QueryRootArgoMaterialActivityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityKindOrderBy>>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};


export type QueryRootArgoMaterialActivityKindByPkArgs = {
  kind: Scalars['String'];
};


export type QueryRootArgoMaterialAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


export type QueryRootArgoMaterialAssemblyArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type QueryRootArgoMaterialAssemblyAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type QueryRootArgoMaterialAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


export type QueryRootArgoMaterialAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


export type QueryRootArgoMaterialAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialAttributeHistoryArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};


export type QueryRootArgoMaterialAttributeHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};


export type QueryRootArgoMaterialAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialClassArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassOrderBy>>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};


export type QueryRootArgoMaterialClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassOrderBy>>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};


export type QueryRootArgoMaterialClassAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


export type QueryRootArgoMaterialClassAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


export type QueryRootArgoMaterialClassAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialClassAttributeSettingArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


export type QueryRootArgoMaterialClassAttributeSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


export type QueryRootArgoMaterialClassAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialClassByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialClassProcessArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


export type QueryRootArgoMaterialClassProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


export type QueryRootArgoMaterialClassProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialMarriageArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};


export type QueryRootArgoMaterialMarriageAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};


export type QueryRootArgoMaterialMarriageByPkArgs = {
  material_marriage_id: Scalars['uuid'];
};


export type QueryRootArgoMaterialMarriageStatusArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageStatusOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};


export type QueryRootArgoMaterialMarriageStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageStatusOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};


export type QueryRootArgoMaterialMarriageStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootArgoMaterialModelArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


export type QueryRootArgoMaterialModelAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


export type QueryRootArgoMaterialModelAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


export type QueryRootArgoMaterialModelAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


export type QueryRootArgoMaterialModelAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialModelAttributeSettingArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


export type QueryRootArgoMaterialModelAttributeSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


export type QueryRootArgoMaterialModelAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialModelByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialModelProcessArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


export type QueryRootArgoMaterialModelProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


export type QueryRootArgoMaterialModelProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialQuantityKindArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialQuantityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialQuantityKindOrderBy>>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};


export type QueryRootArgoMaterialQuantityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialQuantityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialQuantityKindOrderBy>>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};


export type QueryRootArgoMaterialQuantityKindByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootArgoMaterialStatusArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialStatusOrderBy>>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};


export type QueryRootArgoMaterialStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialStatusOrderBy>>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};


export type QueryRootArgoMaterialStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootArgoMaterialUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


export type QueryRootArgoMaterialUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


export type QueryRootArgoMaterialUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


export type QueryRootArgoMaterialUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


export type QueryRootArgoMaterialUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMaterialUdfSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


export type QueryRootArgoMaterialUdfSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


export type QueryRootArgoMaterialUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMediaConfigArgs = {
  distinct_on?: Maybe<Array<ArgoMediaConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaConfigOrderBy>>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};


export type QueryRootArgoMediaConfigAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMediaConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaConfigOrderBy>>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};


export type QueryRootArgoMediaConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoMediaInstanceArgs = {
  distinct_on?: Maybe<Array<ArgoMediaInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaInstanceOrderBy>>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};


export type QueryRootArgoMediaInstanceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMediaInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaInstanceOrderBy>>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};


export type QueryRootArgoMediaInstanceByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoPgTimezoneNamesArgs = {
  distinct_on?: Maybe<Array<ArgoPgTimezoneNamesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoPgTimezoneNamesOrderBy>>;
  where?: Maybe<ArgoPgTimezoneNamesBoolExp>;
};


export type QueryRootArgoPgTimezoneNamesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoPgTimezoneNamesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoPgTimezoneNamesOrderBy>>;
  where?: Maybe<ArgoPgTimezoneNamesBoolExp>;
};


export type QueryRootArgoRoleArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


export type QueryRootArgoRoleAclArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


export type QueryRootArgoRoleAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


export type QueryRootArgoRoleAclByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


export type QueryRootArgoRoleByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoScheduleArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


export type QueryRootArgoScheduleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


export type QueryRootArgoScheduleByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoScheduleDayArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleDaySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleDayOrderBy>>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};


export type QueryRootArgoScheduleDayAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleDaySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleDayOrderBy>>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};


export type QueryRootArgoScheduleDayByPkArgs = {
  day: Scalars['String'];
};


export type QueryRootArgoScheduleEventArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


export type QueryRootArgoScheduleEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


export type QueryRootArgoScheduleEventByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoScheduleModeArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleModeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleModeOrderBy>>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};


export type QueryRootArgoScheduleModeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleModeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleModeOrderBy>>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};


export type QueryRootArgoScheduleModeByPkArgs = {
  mode: Scalars['String'];
};


export type QueryRootArgoSnArgs = {
  distinct_on?: Maybe<Array<ArgoSnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnOrderBy>>;
  where?: Maybe<ArgoSnBoolExp>;
};


export type QueryRootArgoSnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnOrderBy>>;
  where?: Maybe<ArgoSnBoolExp>;
};


export type QueryRootArgoSnByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['bigint'];
};


export type QueryRootArgoSnFormatArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


export type QueryRootArgoSnFormatAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


export type QueryRootArgoSnFormatByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['Int'];
};


export type QueryRootArgoSnFormatStatusArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatStatusOrderBy>>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};


export type QueryRootArgoSnFormatStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatStatusOrderBy>>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};


export type QueryRootArgoSnFormatStatusByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootArgoSnFormatUniquenessArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatUniquenessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatUniquenessOrderBy>>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};


export type QueryRootArgoSnFormatUniquenessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatUniquenessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatUniquenessOrderBy>>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};


export type QueryRootArgoSnFormatUniquenessByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootArgoTraverseAssembliesArgs = {
  args: ArgoTraverseAssembliesArgs;
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type QueryRootArgoTraverseAssembliesAggregateArgs = {
  args: ArgoTraverseAssembliesArgs;
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type QueryRootArgoUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


export type QueryRootArgoUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


export type QueryRootArgoUdfColumnByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoUdfColumnDataTypeArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnDataTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};


export type QueryRootArgoUdfColumnDataTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnDataTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};


export type QueryRootArgoUdfColumnDataTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootArgoUdfColumnTypeArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};


export type QueryRootArgoUdfColumnTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};


export type QueryRootArgoUdfColumnTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootArgoUomArgs = {
  distinct_on?: Maybe<Array<ArgoUomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUomOrderBy>>;
  where?: Maybe<ArgoUomBoolExp>;
};


export type QueryRootArgoUomAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUomOrderBy>>;
  where?: Maybe<ArgoUomBoolExp>;
};


export type QueryRootArgoUomByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootArgoUserArgs = {
  distinct_on?: Maybe<Array<ArgoUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserOrderBy>>;
  where?: Maybe<ArgoUserBoolExp>;
};


export type QueryRootArgoUserAccessTokenArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


export type QueryRootArgoUserAccessTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


export type QueryRootArgoUserAccessTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoUserAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserOrderBy>>;
  where?: Maybe<ArgoUserBoolExp>;
};


export type QueryRootArgoUserBadgeArgs = {
  distinct_on?: Maybe<Array<ArgoUserBadgeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserBadgeOrderBy>>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};


export type QueryRootArgoUserBadgeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserBadgeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserBadgeOrderBy>>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};


export type QueryRootArgoUserBadgeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoUserByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoUserContextArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


export type QueryRootArgoUserContextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


export type QueryRootArgoUserContextByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoUserRoleArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


export type QueryRootArgoUserRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


export type QueryRootArgoUserRoleByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoVwAclRoleArgs = {
  distinct_on?: Maybe<Array<ArgoVwAclRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAclRoleOrderBy>>;
  where?: Maybe<ArgoVwAclRoleBoolExp>;
};


export type QueryRootArgoVwAclRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwAclRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAclRoleOrderBy>>;
  where?: Maybe<ArgoVwAclRoleBoolExp>;
};


export type QueryRootArgoVwActiveLocationCalendarArgs = {
  distinct_on?: Maybe<Array<ArgoVwActiveLocationCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwActiveLocationCalendarOrderBy>>;
  where?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
};


export type QueryRootArgoVwActiveLocationCalendarAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwActiveLocationCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwActiveLocationCalendarOrderBy>>;
  where?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
};


export type QueryRootArgoVwAuthUserAccessTokenArgs = {
  distinct_on?: Maybe<Array<ArgoVwAuthUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAuthUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
};


export type QueryRootArgoVwAuthUserAccessTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwAuthUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAuthUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
};


export type QueryRootArgoVwEventTypeUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoVwEventTypeUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwEventTypeUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
};


export type QueryRootArgoVwEventTypeUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwEventTypeUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwEventTypeUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
};


export type QueryRootArgoVwLocationHierarchyArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


export type QueryRootArgoVwLocationHierarchyAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


export type QueryRootArgoVwMaterialByClassArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


export type QueryRootArgoVwMaterialByClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


export type QueryRootArgoVwMaterialClassUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialClassUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialClassUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
};


export type QueryRootArgoVwMaterialClassUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialClassUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialClassUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
};


export type QueryRootArgoVwMaterialModelProcessesByClassArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


export type QueryRootArgoVwMaterialModelProcessesByClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


export type QueryRootArgoVwRoleAclArgs = {
  distinct_on?: Maybe<Array<ArgoVwRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwRoleAclOrderBy>>;
  where?: Maybe<ArgoVwRoleAclBoolExp>;
};


export type QueryRootArgoVwRoleAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwRoleAclOrderBy>>;
  where?: Maybe<ArgoVwRoleAclBoolExp>;
};


export type QueryRootArgoVwTimestamptzArgs = {
  distinct_on?: Maybe<Array<ArgoVwTimestamptzSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwTimestamptzOrderBy>>;
  where?: Maybe<ArgoVwTimestamptzBoolExp>;
};


export type QueryRootArgoVwTimestamptzAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwTimestamptzSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwTimestamptzOrderBy>>;
  where?: Maybe<ArgoVwTimestamptzBoolExp>;
};


export type QueryRootArgoVwUserAclsArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserAclsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserAclsOrderBy>>;
  where?: Maybe<ArgoVwUserAclsBoolExp>;
};


export type QueryRootArgoVwUserAclsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserAclsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserAclsOrderBy>>;
  where?: Maybe<ArgoVwUserAclsBoolExp>;
};


export type QueryRootArgoVwUserContextAclArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


export type QueryRootArgoVwUserContextAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


export type QueryRootArgoVwUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


export type QueryRootArgoVwUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


export type QueryRootArgoWorkInstructionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};


export type QueryRootArgoWorkInstructionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};


export type QueryRootArgoWorkInstructionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkInstructionInstanceArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkInstructionInstanceStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootArgoWorkInstructionInstanceStepArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceStepAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


export type QueryRootArgoWorkInstructionInstanceStepByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkInstructionVersionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


export type QueryRootArgoWorkInstructionVersionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


export type QueryRootArgoWorkInstructionVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkInstructionVersionStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};


export type QueryRootArgoWorkInstructionVersionStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};


export type QueryRootArgoWorkInstructionVersionStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootArgoWorkOrderArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderOrderBy>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


export type QueryRootArgoWorkOrderActivityArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};


export type QueryRootArgoWorkOrderActivityAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};


export type QueryRootArgoWorkOrderActivityByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkOrderActivityKindArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityKindOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};


export type QueryRootArgoWorkOrderActivityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityKindOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};


export type QueryRootArgoWorkOrderActivityKindByPkArgs = {
  kind: Scalars['String'];
};


export type QueryRootArgoWorkOrderAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderOrderBy>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


export type QueryRootArgoWorkOrderByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkOrderLocationArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


export type QueryRootArgoWorkOrderLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


export type QueryRootArgoWorkOrderLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkOrderMaterialArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


export type QueryRootArgoWorkOrderMaterialAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


export type QueryRootArgoWorkOrderMaterialByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootArgoWorkOrderRestrictionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderRestrictionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderRestrictionOrderBy>>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};


export type QueryRootArgoWorkOrderRestrictionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderRestrictionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderRestrictionOrderBy>>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};


export type QueryRootArgoWorkOrderRestrictionByPkArgs = {
  restriction: Scalars['String'];
};


export type QueryRootArgoWorkOrderStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderStatusOrderBy>>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};


export type QueryRootArgoWorkOrderStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderStatusOrderBy>>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};


export type QueryRootArgoWorkOrderStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootFisAssetArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


export type QueryRootFisAssetAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


export type QueryRootFisAssetByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisAssetCodeArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


export type QueryRootFisAssetCodeAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


export type QueryRootFisAssetCodeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisAssetTagArgs = {
  distinct_on?: Maybe<Array<FisAssetTagSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagOrderBy>>;
  where?: Maybe<FisAssetTagBoolExp>;
};


export type QueryRootFisAssetTagAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTagSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagOrderBy>>;
  where?: Maybe<FisAssetTagBoolExp>;
};


export type QueryRootFisAssetTagByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisAssetTagLinkArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


export type QueryRootFisAssetTagLinkAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


export type QueryRootFisAssetTagLinkByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisAssetTypeArgs = {
  distinct_on?: Maybe<Array<FisAssetTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTypeOrderBy>>;
  where?: Maybe<FisAssetTypeBoolExp>;
};


export type QueryRootFisAssetTypeAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTypeOrderBy>>;
  where?: Maybe<FisAssetTypeBoolExp>;
};


export type QueryRootFisAssetTypeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisCoreStateArgs = {
  distinct_on?: Maybe<Array<FisCoreStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisCoreStateOrderBy>>;
  where?: Maybe<FisCoreStateBoolExp>;
};


export type QueryRootFisCoreStateAggregateArgs = {
  distinct_on?: Maybe<Array<FisCoreStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisCoreStateOrderBy>>;
  where?: Maybe<FisCoreStateBoolExp>;
};


export type QueryRootFisCoreStateByPkArgs = {
  state: Scalars['String'];
};


export type QueryRootFisDataArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


export type QueryRootFisDataAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


export type QueryRootFisDataByPkArgs = {
  data_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type QueryRootFisDataLabelArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


export type QueryRootFisDataLabelAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


export type QueryRootFisDataLabelByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootFisDataTimingArgs = {
  distinct_on?: Maybe<Array<FisDataTimingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTimingOrderBy>>;
  where?: Maybe<FisDataTimingBoolExp>;
};


export type QueryRootFisDataTimingAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTimingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTimingOrderBy>>;
  where?: Maybe<FisDataTimingBoolExp>;
};


export type QueryRootFisDataTimingByPkArgs = {
  timing: Scalars['String'];
};


export type QueryRootFisDataTrackCountArgs = {
  distinct_on?: Maybe<Array<FisDataTrackCountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackCountOrderBy>>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};


export type QueryRootFisDataTrackCountAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackCountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackCountOrderBy>>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};


export type QueryRootFisDataTrackCountByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type QueryRootFisDataTrackDurationArgs = {
  distinct_on?: Maybe<Array<FisDataTrackDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackDurationOrderBy>>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};


export type QueryRootFisDataTrackDurationAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackDurationOrderBy>>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};


export type QueryRootFisDataTrackDurationByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  num_val: Scalars['float8'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type QueryRootFisDataTrackScalarArgs = {
  distinct_on?: Maybe<Array<FisDataTrackScalarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackScalarOrderBy>>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};


export type QueryRootFisDataTrackScalarAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackScalarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackScalarOrderBy>>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};


export type QueryRootFisDataTrackScalarByPkArgs = {
  asset_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type QueryRootFisDataTypeArgs = {
  distinct_on?: Maybe<Array<FisDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTypeOrderBy>>;
  where?: Maybe<FisDataTypeBoolExp>;
};


export type QueryRootFisDataTypeAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTypeOrderBy>>;
  where?: Maybe<FisDataTypeBoolExp>;
};


export type QueryRootFisDataTypeByPkArgs = {
  type: Scalars['String'];
};


export type QueryRootFisReportConstraintArgs = {
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type QueryRootFisReportConstraintAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type QueryRootFisReportDetailArgs = {
  distinct_on?: Maybe<Array<FisReportDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportDetailOrderBy>>;
  where?: Maybe<FisReportDetailBoolExp>;
};


export type QueryRootFisReportDetailAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportDetailOrderBy>>;
  where?: Maybe<FisReportDetailBoolExp>;
};


export type QueryRootFisReportMtbfArgs = {
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type QueryRootFisReportMtbfAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type QueryRootFisReportOeeArgs = {
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type QueryRootFisReportOeeAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type QueryRootFisReportStateArgs = {
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type QueryRootFisReportStateAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type QueryRootFisReportStateColumnArgs = {
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type QueryRootFisReportStateColumnAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type QueryRootFisReportTopFaultArgs = {
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type QueryRootFisReportTopFaultAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type QueryRootFisRunReportConstraintArgs = {
  args: FisRunReportConstraintArgs;
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type QueryRootFisRunReportConstraintAggregateArgs = {
  args: FisRunReportConstraintArgs;
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type QueryRootFisRunReportMtbfArgs = {
  args: FisRunReportMtbfArgs;
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type QueryRootFisRunReportMtbfAggregateArgs = {
  args: FisRunReportMtbfArgs;
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type QueryRootFisRunReportOeeArgs = {
  args: FisRunReportOeeArgs;
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type QueryRootFisRunReportOeeAggregateArgs = {
  args: FisRunReportOeeArgs;
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type QueryRootFisRunReportStateArgs = {
  args: FisRunReportStateArgs;
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type QueryRootFisRunReportStateAggregateArgs = {
  args: FisRunReportStateArgs;
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type QueryRootFisRunReportStateColumnArgs = {
  args: FisRunReportStateColumnArgs;
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type QueryRootFisRunReportStateColumnAggregateArgs = {
  args: FisRunReportStateColumnArgs;
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type QueryRootFisRunReportTopFaultArgs = {
  args: FisRunReportTopFaultArgs;
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type QueryRootFisRunReportTopFaultAggregateArgs = {
  args: FisRunReportTopFaultArgs;
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type QueryRootPlv8ResponseArgs = {
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


export type QueryRootPlv8ResponseAggregateArgs = {
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


export type QueryRootPlv8ValueResponseArgs = {
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


export type QueryRootPlv8ValueResponseAggregateArgs = {
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


export type QueryRootProcessCollectionArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


export type QueryRootProcessCollectionAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


export type QueryRootProcessCollectionByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootProcessCollectionDataArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


export type QueryRootProcessCollectionDataAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


export type QueryRootProcessCollectionDataByPkArgs = {
  collection_id: Scalars['uuid'];
  data_element_id: Scalars['uuid'];
};


export type QueryRootProcessCollectionKindArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionKindOrderBy>>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};


export type QueryRootProcessCollectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionKindOrderBy>>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};


export type QueryRootProcessCollectionKindByPkArgs = {
  kind: Scalars['String'];
};


export type QueryRootProcessDataElementArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


export type QueryRootProcessDataElementAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


export type QueryRootProcessDataElementByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootProcessDataElementCollectionKindArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementCollectionKindOrderBy>>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};


export type QueryRootProcessDataElementCollectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementCollectionKindOrderBy>>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};


export type QueryRootProcessDataElementCollectionKindByPkArgs = {
  collection_kind: Scalars['String'];
};


export type QueryRootProcessDataElementKindArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementKindOrderBy>>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};


export type QueryRootProcessDataElementKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementKindOrderBy>>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};


export type QueryRootProcessDataElementKindByPkArgs = {
  kind: Scalars['String'];
};


export type QueryRootProcessMaterialStateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


export type QueryRootProcessMaterialStateAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


export type QueryRootProcessMaterialStateByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootProcessMaterialStateHistoryArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


export type QueryRootProcessMaterialStateHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


export type QueryRootProcessMaterialStateHistoryByPkArgs = {
  material_state_history_id: Scalars['uuid'];
};


export type QueryRootProcessProcessArgs = {
  distinct_on?: Maybe<Array<ProcessProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessOrderBy>>;
  where?: Maybe<ProcessProcessBoolExp>;
};


export type QueryRootProcessProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessOrderBy>>;
  where?: Maybe<ProcessProcessBoolExp>;
};


export type QueryRootProcessProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootProcessProcessStatusArgs = {
  distinct_on?: Maybe<Array<ProcessProcessStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessStatusOrderBy>>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};


export type QueryRootProcessProcessStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessProcessStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessStatusOrderBy>>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};


export type QueryRootProcessProcessStatusByPkArgs = {
  status: Scalars['String'];
};


export type QueryRootProcessSpecArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


export type QueryRootProcessSpecAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


export type QueryRootProcessSpecByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootProcessSpecOrderArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


export type QueryRootProcessSpecOrderAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


export type QueryRootProcessSpecOrderByPkArgs = {
  id: Scalars['uuid'];
};


/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: Maybe<Scalars['smallint']>;
  _gt?: Maybe<Scalars['smallint']>;
  _gte?: Maybe<Scalars['smallint']>;
  _in?: Maybe<Array<Scalars['smallint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['smallint']>;
  _lte?: Maybe<Scalars['smallint']>;
  _neq?: Maybe<Scalars['smallint']>;
  _nin?: Maybe<Array<Scalars['smallint']>>;
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "applet.deployment" */
  applet_deployment: Array<AppletDeployment>;
  /** fetch aggregated fields from the table: "applet.deployment" */
  applet_deployment_aggregate: AppletDeploymentAggregate;
  /** fetch data from the table: "applet.deployment" using primary key columns */
  applet_deployment_by_pk?: Maybe<AppletDeployment>;
  /** fetch data from the table: "applet.deployment_linked_design_version" */
  applet_deployment_linked_design_version: Array<AppletDeploymentLinkedDesignVersion>;
  /** fetch aggregated fields from the table: "applet.deployment_linked_design_version" */
  applet_deployment_linked_design_version_aggregate: AppletDeploymentLinkedDesignVersionAggregate;
  /** fetch data from the table: "applet.deployment_linked_design_version" using primary key columns */
  applet_deployment_linked_design_version_by_pk?: Maybe<AppletDeploymentLinkedDesignVersion>;
  /** fetch data from the table in a streaming manner: "applet.deployment_linked_design_version" */
  applet_deployment_linked_design_version_stream: Array<AppletDeploymentLinkedDesignVersion>;
  /** fetch data from the table in a streaming manner: "applet.deployment" */
  applet_deployment_stream: Array<AppletDeployment>;
  /** fetch data from the table: "applet.design" */
  applet_design: Array<AppletDesign>;
  /** fetch aggregated fields from the table: "applet.design" */
  applet_design_aggregate: AppletDesignAggregate;
  /** fetch data from the table: "applet.design" using primary key columns */
  applet_design_by_pk?: Maybe<AppletDesign>;
  /** fetch data from the table in a streaming manner: "applet.design" */
  applet_design_stream: Array<AppletDesign>;
  /** fetch data from the table: "applet.design_version" */
  applet_design_version: Array<AppletDesignVersion>;
  /** fetch aggregated fields from the table: "applet.design_version" */
  applet_design_version_aggregate: AppletDesignVersionAggregate;
  /** fetch data from the table: "applet.design_version" using primary key columns */
  applet_design_version_by_pk?: Maybe<AppletDesignVersion>;
  /** fetch data from the table: "applet.design_version_status" */
  applet_design_version_status: Array<AppletDesignVersionStatus>;
  /** fetch aggregated fields from the table: "applet.design_version_status" */
  applet_design_version_status_aggregate: AppletDesignVersionStatusAggregate;
  /** fetch data from the table: "applet.design_version_status" using primary key columns */
  applet_design_version_status_by_pk?: Maybe<AppletDesignVersionStatus>;
  /** fetch data from the table in a streaming manner: "applet.design_version_status" */
  applet_design_version_status_stream: Array<AppletDesignVersionStatus>;
  /** fetch data from the table in a streaming manner: "applet.design_version" */
  applet_design_version_stream: Array<AppletDesignVersion>;
  /** fetch data from the table: "applet.registration_code" */
  applet_registration_code: Array<AppletRegistrationCode>;
  /** fetch aggregated fields from the table: "applet.registration_code" */
  applet_registration_code_aggregate: AppletRegistrationCodeAggregate;
  /** fetch data from the table: "applet.registration_code" using primary key columns */
  applet_registration_code_by_pk?: Maybe<AppletRegistrationCode>;
  /** fetch data from the table in a streaming manner: "applet.registration_code" */
  applet_registration_code_stream: Array<AppletRegistrationCode>;
  /** fetch data from the table: "applet.runner" */
  applet_runner: Array<AppletRunner>;
  /** fetch aggregated fields from the table: "applet.runner" */
  applet_runner_aggregate: AppletRunnerAggregate;
  /** fetch data from the table: "applet.runner" using primary key columns */
  applet_runner_by_pk?: Maybe<AppletRunner>;
  /** fetch data from the table: "applet.runner_context" */
  applet_runner_context: Array<AppletRunnerContext>;
  /** fetch aggregated fields from the table: "applet.runner_context" */
  applet_runner_context_aggregate: AppletRunnerContextAggregate;
  /** fetch data from the table: "applet.runner_context" using primary key columns */
  applet_runner_context_by_pk?: Maybe<AppletRunnerContext>;
  /** fetch data from the table in a streaming manner: "applet.runner_context" */
  applet_runner_context_stream: Array<AppletRunnerContext>;
  /** fetch data from the table in a streaming manner: "applet.runner" */
  applet_runner_stream: Array<AppletRunner>;
  /** fetch data from the table: "argo.acl" */
  argo_acl: Array<ArgoAcl>;
  /** fetch aggregated fields from the table: "argo.acl" */
  argo_acl_aggregate: ArgoAclAggregate;
  /** fetch data from the table: "argo.acl" using primary key columns */
  argo_acl_by_pk?: Maybe<ArgoAcl>;
  /** fetch data from the table in a streaming manner: "argo.acl" */
  argo_acl_stream: Array<ArgoAcl>;
  /** fetch data from the table: "argo.attribute" */
  argo_attribute: Array<ArgoAttribute>;
  /** fetch aggregated fields from the table: "argo.attribute" */
  argo_attribute_aggregate: ArgoAttributeAggregate;
  /** fetch data from the table: "argo.attribute" using primary key columns */
  argo_attribute_by_pk?: Maybe<ArgoAttribute>;
  /** fetch data from the table: "argo.attribute_data" */
  argo_attribute_data: Array<ArgoAttributeData>;
  /** fetch aggregated fields from the table: "argo.attribute_data" */
  argo_attribute_data_aggregate: ArgoAttributeDataAggregate;
  /** fetch data from the table: "argo.attribute_data" using primary key columns */
  argo_attribute_data_by_pk?: Maybe<ArgoAttributeData>;
  /** fetch data from the table in a streaming manner: "argo.attribute_data" */
  argo_attribute_data_stream: Array<ArgoAttributeData>;
  /** fetch data from the table: "argo.attribute_history_status_type" */
  argo_attribute_history_status_type: Array<ArgoAttributeHistoryStatusType>;
  /** fetch aggregated fields from the table: "argo.attribute_history_status_type" */
  argo_attribute_history_status_type_aggregate: ArgoAttributeHistoryStatusTypeAggregate;
  /** fetch data from the table: "argo.attribute_history_status_type" using primary key columns */
  argo_attribute_history_status_type_by_pk?: Maybe<ArgoAttributeHistoryStatusType>;
  /** fetch data from the table in a streaming manner: "argo.attribute_history_status_type" */
  argo_attribute_history_status_type_stream: Array<ArgoAttributeHistoryStatusType>;
  /** fetch data from the table: "argo.attribute_schema" */
  argo_attribute_schema: Array<ArgoAttributeSchema>;
  /** fetch aggregated fields from the table: "argo.attribute_schema" */
  argo_attribute_schema_aggregate: ArgoAttributeSchemaAggregate;
  /** fetch data from the table: "argo.attribute_schema" using primary key columns */
  argo_attribute_schema_by_pk?: Maybe<ArgoAttributeSchema>;
  /** fetch data from the table: "argo.attribute_schema_definition" */
  argo_attribute_schema_definition: Array<ArgoAttributeSchemaDefinition>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_definition" */
  argo_attribute_schema_definition_aggregate: ArgoAttributeSchemaDefinitionAggregate;
  /** fetch data from the table: "argo.attribute_schema_definition" using primary key columns */
  argo_attribute_schema_definition_by_pk?: Maybe<ArgoAttributeSchemaDefinition>;
  /** fetch data from the table in a streaming manner: "argo.attribute_schema_definition" */
  argo_attribute_schema_definition_stream: Array<ArgoAttributeSchemaDefinition>;
  /** fetch data from the table: "argo.attribute_schema_definition_type" */
  argo_attribute_schema_definition_type: Array<ArgoAttributeSchemaDefinitionType>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_definition_type" */
  argo_attribute_schema_definition_type_aggregate: ArgoAttributeSchemaDefinitionTypeAggregate;
  /** fetch data from the table: "argo.attribute_schema_definition_type" using primary key columns */
  argo_attribute_schema_definition_type_by_pk?: Maybe<ArgoAttributeSchemaDefinitionType>;
  /** fetch data from the table in a streaming manner: "argo.attribute_schema_definition_type" */
  argo_attribute_schema_definition_type_stream: Array<ArgoAttributeSchemaDefinitionType>;
  /** fetch data from the table in a streaming manner: "argo.attribute_schema" */
  argo_attribute_schema_stream: Array<ArgoAttributeSchema>;
  /** fetch data from the table: "argo.attribute_schema_type" */
  argo_attribute_schema_type: Array<ArgoAttributeSchemaType>;
  /** fetch aggregated fields from the table: "argo.attribute_schema_type" */
  argo_attribute_schema_type_aggregate: ArgoAttributeSchemaTypeAggregate;
  /** fetch data from the table: "argo.attribute_schema_type" using primary key columns */
  argo_attribute_schema_type_by_pk?: Maybe<ArgoAttributeSchemaType>;
  /** fetch data from the table in a streaming manner: "argo.attribute_schema_type" */
  argo_attribute_schema_type_stream: Array<ArgoAttributeSchemaType>;
  /** fetch data from the table in a streaming manner: "argo.attribute" */
  argo_attribute_stream: Array<ArgoAttribute>;
  /** fetch data from the table: "argo.audit" */
  argo_audit: Array<ArgoAudit>;
  /** fetch aggregated fields from the table: "argo.audit" */
  argo_audit_aggregate: ArgoAuditAggregate;
  /** fetch data from the table: "argo.audit" using primary key columns */
  argo_audit_by_pk?: Maybe<ArgoAudit>;
  /** fetch data from the table in a streaming manner: "argo.audit" */
  argo_audit_stream: Array<ArgoAudit>;
  /** fetch data from the table: "argo.auth_provider" */
  argo_auth_provider: Array<ArgoAuthProvider>;
  /** fetch aggregated fields from the table: "argo.auth_provider" */
  argo_auth_provider_aggregate: ArgoAuthProviderAggregate;
  /** fetch data from the table: "argo.auth_provider" using primary key columns */
  argo_auth_provider_by_pk?: Maybe<ArgoAuthProvider>;
  /** fetch data from the table: "argo.auth_provider_local" */
  argo_auth_provider_local: Array<ArgoAuthProviderLocal>;
  /** fetch aggregated fields from the table: "argo.auth_provider_local" */
  argo_auth_provider_local_aggregate: ArgoAuthProviderLocalAggregate;
  /** fetch data from the table: "argo.auth_provider_local" using primary key columns */
  argo_auth_provider_local_by_pk?: Maybe<ArgoAuthProviderLocal>;
  /** fetch data from the table: "argo.auth_provider_local_setting" */
  argo_auth_provider_local_setting: Array<ArgoAuthProviderLocalSetting>;
  /** fetch aggregated fields from the table: "argo.auth_provider_local_setting" */
  argo_auth_provider_local_setting_aggregate: ArgoAuthProviderLocalSettingAggregate;
  /** fetch data from the table: "argo.auth_provider_local_setting" using primary key columns */
  argo_auth_provider_local_setting_by_pk?: Maybe<ArgoAuthProviderLocalSetting>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider_local_setting" */
  argo_auth_provider_local_setting_stream: Array<ArgoAuthProviderLocalSetting>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider_local" */
  argo_auth_provider_local_stream: Array<ArgoAuthProviderLocal>;
  /** fetch data from the table: "argo.auth_provider_msal" */
  argo_auth_provider_msal: Array<ArgoAuthProviderMsal>;
  /** fetch aggregated fields from the table: "argo.auth_provider_msal" */
  argo_auth_provider_msal_aggregate: ArgoAuthProviderMsalAggregate;
  /** fetch data from the table: "argo.auth_provider_msal" using primary key columns */
  argo_auth_provider_msal_by_pk?: Maybe<ArgoAuthProviderMsal>;
  /** fetch data from the table: "argo.auth_provider_msal_setting" */
  argo_auth_provider_msal_setting: Array<ArgoAuthProviderMsalSetting>;
  /** fetch aggregated fields from the table: "argo.auth_provider_msal_setting" */
  argo_auth_provider_msal_setting_aggregate: ArgoAuthProviderMsalSettingAggregate;
  /** fetch data from the table: "argo.auth_provider_msal_setting" using primary key columns */
  argo_auth_provider_msal_setting_by_pk?: Maybe<ArgoAuthProviderMsalSetting>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider_msal_setting" */
  argo_auth_provider_msal_setting_stream: Array<ArgoAuthProviderMsalSetting>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider_msal" */
  argo_auth_provider_msal_stream: Array<ArgoAuthProviderMsal>;
  /** fetch data from the table: "argo.auth_provider_record" */
  argo_auth_provider_record: Array<ArgoAuthProviderRecord>;
  /** fetch aggregated fields from the table: "argo.auth_provider_record" */
  argo_auth_provider_record_aggregate: ArgoAuthProviderRecordAggregate;
  /** fetch data from the table: "argo.auth_provider_record" using primary key columns */
  argo_auth_provider_record_by_pk?: Maybe<ArgoAuthProviderRecord>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider_record" */
  argo_auth_provider_record_stream: Array<ArgoAuthProviderRecord>;
  /** fetch data from the table in a streaming manner: "argo.auth_provider" */
  argo_auth_provider_stream: Array<ArgoAuthProvider>;
  /** fetch data from the table: "argo.auth_refresh_token" */
  argo_auth_refresh_token: Array<ArgoAuthRefreshToken>;
  /** fetch aggregated fields from the table: "argo.auth_refresh_token" */
  argo_auth_refresh_token_aggregate: ArgoAuthRefreshTokenAggregate;
  /** fetch data from the table: "argo.auth_refresh_token" using primary key columns */
  argo_auth_refresh_token_by_pk?: Maybe<ArgoAuthRefreshToken>;
  /** fetch data from the table in a streaming manner: "argo.auth_refresh_token" */
  argo_auth_refresh_token_stream: Array<ArgoAuthRefreshToken>;
  /** fetch data from the table: "argo.calendar" */
  argo_calendar: Array<ArgoCalendar>;
  /** fetch aggregated fields from the table: "argo.calendar" */
  argo_calendar_aggregate: ArgoCalendarAggregate;
  /** fetch data from the table: "argo.calendar" using primary key columns */
  argo_calendar_by_pk?: Maybe<ArgoCalendar>;
  /** fetch data from the table: "argo.calendar_current_and_next" */
  argo_calendar_current_and_next: Array<ArgoCalendarCurrentAndNext>;
  /** fetch aggregated fields from the table: "argo.calendar_current_and_next" */
  argo_calendar_current_and_next_aggregate: ArgoCalendarCurrentAndNextAggregate;
  /** fetch data from the table in a streaming manner: "argo.calendar_current_and_next" */
  argo_calendar_current_and_next_stream: Array<ArgoCalendarCurrentAndNext>;
  /** fetch data from the table: "argo.calendar_event" */
  argo_calendar_event: Array<ArgoCalendarEvent>;
  /** fetch aggregated fields from the table: "argo.calendar_event" */
  argo_calendar_event_aggregate: ArgoCalendarEventAggregate;
  /** fetch data from the table: "argo.calendar_event" using primary key columns */
  argo_calendar_event_by_pk?: Maybe<ArgoCalendarEvent>;
  /** fetch data from the table: "argo.calendar_event_sequence" */
  argo_calendar_event_sequence: Array<ArgoCalendarEventSequence>;
  /** fetch aggregated fields from the table: "argo.calendar_event_sequence" */
  argo_calendar_event_sequence_aggregate: ArgoCalendarEventSequenceAggregate;
  /** fetch data from the table in a streaming manner: "argo.calendar_event_sequence" */
  argo_calendar_event_sequence_stream: Array<ArgoCalendarEventSequence>;
  /** fetch data from the table in a streaming manner: "argo.calendar_event" */
  argo_calendar_event_stream: Array<ArgoCalendarEvent>;
  /** fetch data from the table: "argo.calendar_event_udf_data" */
  argo_calendar_event_udf_data: Array<ArgoCalendarEventUdfData>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_data" */
  argo_calendar_event_udf_data_aggregate: ArgoCalendarEventUdfDataAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_data" using primary key columns */
  argo_calendar_event_udf_data_by_pk?: Maybe<ArgoCalendarEventUdfData>;
  /** fetch data from the table in a streaming manner: "argo.calendar_event_udf_data" */
  argo_calendar_event_udf_data_stream: Array<ArgoCalendarEventUdfData>;
  /** fetch data from the table: "argo.calendar_event_udf_default_data" */
  argo_calendar_event_udf_default_data: Array<ArgoCalendarEventUdfDefaultData>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_default_data" */
  argo_calendar_event_udf_default_data_aggregate: ArgoCalendarEventUdfDefaultDataAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_default_data" using primary key columns */
  argo_calendar_event_udf_default_data_by_pk?: Maybe<ArgoCalendarEventUdfDefaultData>;
  /** fetch data from the table in a streaming manner: "argo.calendar_event_udf_default_data" */
  argo_calendar_event_udf_default_data_stream: Array<ArgoCalendarEventUdfDefaultData>;
  /** fetch data from the table: "argo.calendar_event_udf_schema" */
  argo_calendar_event_udf_schema: Array<ArgoCalendarEventUdfSchema>;
  /** fetch aggregated fields from the table: "argo.calendar_event_udf_schema" */
  argo_calendar_event_udf_schema_aggregate: ArgoCalendarEventUdfSchemaAggregate;
  /** fetch data from the table: "argo.calendar_event_udf_schema" using primary key columns */
  argo_calendar_event_udf_schema_by_pk?: Maybe<ArgoCalendarEventUdfSchema>;
  /** fetch data from the table in a streaming manner: "argo.calendar_event_udf_schema" */
  argo_calendar_event_udf_schema_stream: Array<ArgoCalendarEventUdfSchema>;
  /** fetch data from the table: "argo.calendar_location" */
  argo_calendar_location: Array<ArgoCalendarLocation>;
  /** fetch aggregated fields from the table: "argo.calendar_location" */
  argo_calendar_location_aggregate: ArgoCalendarLocationAggregate;
  /** fetch data from the table: "argo.calendar_location" using primary key columns */
  argo_calendar_location_by_pk?: Maybe<ArgoCalendarLocation>;
  /** fetch data from the table in a streaming manner: "argo.calendar_location" */
  argo_calendar_location_stream: Array<ArgoCalendarLocation>;
  /** fetch data from the table in a streaming manner: "argo.calendar" */
  argo_calendar_stream: Array<ArgoCalendar>;
  /** fetch data from the table: "argo.connection" */
  argo_connection: Array<ArgoConnection>;
  /** fetch aggregated fields from the table: "argo.connection" */
  argo_connection_aggregate: ArgoConnectionAggregate;
  /** fetch data from the table: "argo.connection" using primary key columns */
  argo_connection_by_pk?: Maybe<ArgoConnection>;
  /** fetch data from the table: "argo.connection_config" */
  argo_connection_config: Array<ArgoConnectionConfig>;
  /** fetch aggregated fields from the table: "argo.connection_config" */
  argo_connection_config_aggregate: ArgoConnectionConfigAggregate;
  /** fetch data from the table: "argo.connection_config" using primary key columns */
  argo_connection_config_by_pk?: Maybe<ArgoConnectionConfig>;
  /** fetch data from the table: "argo.connection_config_status" */
  argo_connection_config_status: Array<ArgoConnectionConfigStatus>;
  /** fetch aggregated fields from the table: "argo.connection_config_status" */
  argo_connection_config_status_aggregate: ArgoConnectionConfigStatusAggregate;
  /** fetch data from the table: "argo.connection_config_status" using primary key columns */
  argo_connection_config_status_by_pk?: Maybe<ArgoConnectionConfigStatus>;
  /** fetch data from the table in a streaming manner: "argo.connection_config_status" */
  argo_connection_config_status_stream: Array<ArgoConnectionConfigStatus>;
  /** fetch data from the table in a streaming manner: "argo.connection_config" */
  argo_connection_config_stream: Array<ArgoConnectionConfig>;
  /** fetch data from the table: "argo.connection_kind" */
  argo_connection_kind: Array<ArgoConnectionKind>;
  /** fetch aggregated fields from the table: "argo.connection_kind" */
  argo_connection_kind_aggregate: ArgoConnectionKindAggregate;
  /** fetch data from the table: "argo.connection_kind" using primary key columns */
  argo_connection_kind_by_pk?: Maybe<ArgoConnectionKind>;
  /** fetch data from the table in a streaming manner: "argo.connection_kind" */
  argo_connection_kind_stream: Array<ArgoConnectionKind>;
  /** fetch data from the table in a streaming manner: "argo.connection" */
  argo_connection_stream: Array<ArgoConnection>;
  /** fetch data from the table: "argo.context" */
  argo_context: Array<ArgoContext>;
  /** fetch aggregated fields from the table: "argo.context" */
  argo_context_aggregate: ArgoContextAggregate;
  /** fetch data from the table: "argo.context" using primary key columns */
  argo_context_by_pk?: Maybe<ArgoContext>;
  /** fetch data from the table in a streaming manner: "argo.context" */
  argo_context_stream: Array<ArgoContext>;
  /** fetch data from the table: "argo.cron_task" */
  argo_cron_task: Array<ArgoCronTask>;
  /** fetch aggregated fields from the table: "argo.cron_task" */
  argo_cron_task_aggregate: ArgoCronTaskAggregate;
  /** fetch data from the table: "argo.cron_task" using primary key columns */
  argo_cron_task_by_pk?: Maybe<ArgoCronTask>;
  /** fetch data from the table in a streaming manner: "argo.cron_task" */
  argo_cron_task_stream: Array<ArgoCronTask>;
  /** fetch data from the table: "argo.event" */
  argo_event: Array<ArgoEvent>;
  /** fetch aggregated fields from the table: "argo.event" */
  argo_event_aggregate: ArgoEventAggregate;
  /** fetch data from the table: "argo.event" using primary key columns */
  argo_event_by_pk?: Maybe<ArgoEvent>;
  /** fetch data from the table in a streaming manner: "argo.event" */
  argo_event_stream: Array<ArgoEvent>;
  /** fetch data from the table: "argo.event_type" */
  argo_event_type: Array<ArgoEventType>;
  /** fetch aggregated fields from the table: "argo.event_type" */
  argo_event_type_aggregate: ArgoEventTypeAggregate;
  /** fetch data from the table: "argo.event_type" using primary key columns */
  argo_event_type_by_pk?: Maybe<ArgoEventType>;
  /** fetch data from the table in a streaming manner: "argo.event_type" */
  argo_event_type_stream: Array<ArgoEventType>;
  /** fetch data from the table: "argo.hasura_permission" */
  argo_hasura_permission: Array<ArgoHasuraPermission>;
  /** fetch aggregated fields from the table: "argo.hasura_permission" */
  argo_hasura_permission_aggregate: ArgoHasuraPermissionAggregate;
  /** fetch data from the table: "argo.hasura_permission" using primary key columns */
  argo_hasura_permission_by_pk?: Maybe<ArgoHasuraPermission>;
  /** fetch data from the table in a streaming manner: "argo.hasura_permission" */
  argo_hasura_permission_stream: Array<ArgoHasuraPermission>;
  /** fetch data from the table: "argo.link" */
  argo_link: Array<ArgoLink>;
  /** fetch aggregated fields from the table: "argo.link" */
  argo_link_aggregate: ArgoLinkAggregate;
  /** fetch data from the table: "argo.link" using primary key columns */
  argo_link_by_pk?: Maybe<ArgoLink>;
  /** fetch data from the table in a streaming manner: "argo.link" */
  argo_link_stream: Array<ArgoLink>;
  /** fetch data from the table: "argo.location" */
  argo_location: Array<ArgoLocation>;
  /** execute function "argo.location_active_calendar" which returns "argo.calendar" */
  argo_location_active_calendar: Array<ArgoCalendar>;
  /** execute function "argo.location_active_calendar" and query aggregates on result of table type "argo.calendar" */
  argo_location_active_calendar_aggregate: ArgoCalendarAggregate;
  /** fetch aggregated fields from the table: "argo.location" */
  argo_location_aggregate: ArgoLocationAggregate;
  /** fetch data from the table: "argo.location_attribute" */
  argo_location_attribute: Array<ArgoLocationAttribute>;
  /** fetch aggregated fields from the table: "argo.location_attribute" */
  argo_location_attribute_aggregate: ArgoLocationAttributeAggregate;
  /** fetch data from the table: "argo.location_attribute" using primary key columns */
  argo_location_attribute_by_pk?: Maybe<ArgoLocationAttribute>;
  /** fetch data from the table: "argo.location_attribute_history" */
  argo_location_attribute_history: Array<ArgoLocationAttributeHistory>;
  /** fetch aggregated fields from the table: "argo.location_attribute_history" */
  argo_location_attribute_history_aggregate: ArgoLocationAttributeHistoryAggregate;
  /** fetch data from the table: "argo.location_attribute_history" using primary key columns */
  argo_location_attribute_history_by_pk?: Maybe<ArgoLocationAttributeHistory>;
  /** fetch data from the table in a streaming manner: "argo.location_attribute_history" */
  argo_location_attribute_history_stream: Array<ArgoLocationAttributeHistory>;
  /** fetch data from the table in a streaming manner: "argo.location_attribute" */
  argo_location_attribute_stream: Array<ArgoLocationAttribute>;
  /** fetch data from the table: "argo.location" using primary key columns */
  argo_location_by_pk?: Maybe<ArgoLocation>;
  /** fetch data from the table: "argo.location_class" */
  argo_location_class: Array<ArgoLocationClass>;
  /** fetch aggregated fields from the table: "argo.location_class" */
  argo_location_class_aggregate: ArgoLocationClassAggregate;
  /** fetch data from the table: "argo.location_class" using primary key columns */
  argo_location_class_by_pk?: Maybe<ArgoLocationClass>;
  /** fetch data from the table in a streaming manner: "argo.location_class" */
  argo_location_class_stream: Array<ArgoLocationClass>;
  /** fetch data from the table in a streaming manner: "argo.location" */
  argo_location_stream: Array<ArgoLocation>;
  /** fetch data from the table: "argo.log" */
  argo_log: Array<ArgoLog>;
  /** fetch aggregated fields from the table: "argo.log" */
  argo_log_aggregate: ArgoLogAggregate;
  /** fetch data from the table: "argo.log" using primary key columns */
  argo_log_by_pk?: Maybe<ArgoLog>;
  /** fetch data from the table: "argo.log_category" */
  argo_log_category: Array<ArgoLogCategory>;
  /** fetch aggregated fields from the table: "argo.log_category" */
  argo_log_category_aggregate: ArgoLogCategoryAggregate;
  /** fetch data from the table: "argo.log_category" using primary key columns */
  argo_log_category_by_pk?: Maybe<ArgoLogCategory>;
  /** fetch data from the table in a streaming manner: "argo.log_category" */
  argo_log_category_stream: Array<ArgoLogCategory>;
  /** fetch data from the table: "argo.log_duration" */
  argo_log_duration: Array<ArgoLogDuration>;
  /** fetch aggregated fields from the table: "argo.log_duration" */
  argo_log_duration_aggregate: ArgoLogDurationAggregate;
  /** fetch data from the table in a streaming manner: "argo.log_duration" */
  argo_log_duration_stream: Array<ArgoLogDuration>;
  /** fetch data from the table: "argo.log_level" */
  argo_log_level: Array<ArgoLogLevel>;
  /** fetch aggregated fields from the table: "argo.log_level" */
  argo_log_level_aggregate: ArgoLogLevelAggregate;
  /** fetch data from the table: "argo.log_level" using primary key columns */
  argo_log_level_by_pk?: Maybe<ArgoLogLevel>;
  /** fetch data from the table in a streaming manner: "argo.log_level" */
  argo_log_level_stream: Array<ArgoLogLevel>;
  /** fetch data from the table in a streaming manner: "argo.log" */
  argo_log_stream: Array<ArgoLog>;
  /** fetch data from the table: "argo.material" */
  argo_material: Array<ArgoMaterial>;
  /** fetch data from the table: "argo.material_activity" */
  argo_material_activity: Array<ArgoMaterialActivity>;
  /** fetch aggregated fields from the table: "argo.material_activity" */
  argo_material_activity_aggregate: ArgoMaterialActivityAggregate;
  /** fetch data from the table: "argo.material_activity" using primary key columns */
  argo_material_activity_by_pk?: Maybe<ArgoMaterialActivity>;
  /** fetch data from the table: "argo.material_activity_kind" */
  argo_material_activity_kind: Array<ArgoMaterialActivityKind>;
  /** fetch aggregated fields from the table: "argo.material_activity_kind" */
  argo_material_activity_kind_aggregate: ArgoMaterialActivityKindAggregate;
  /** fetch data from the table: "argo.material_activity_kind" using primary key columns */
  argo_material_activity_kind_by_pk?: Maybe<ArgoMaterialActivityKind>;
  /** fetch data from the table in a streaming manner: "argo.material_activity_kind" */
  argo_material_activity_kind_stream: Array<ArgoMaterialActivityKind>;
  /** fetch data from the table in a streaming manner: "argo.material_activity" */
  argo_material_activity_stream: Array<ArgoMaterialActivity>;
  /** fetch aggregated fields from the table: "argo.material" */
  argo_material_aggregate: ArgoMaterialAggregate;
  /** fetch data from the table: "argo.material_assembly" */
  argo_material_assembly: Array<ArgoMaterialAssembly>;
  /** fetch aggregated fields from the table: "argo.material_assembly" */
  argo_material_assembly_aggregate: ArgoMaterialAssemblyAggregate;
  /** fetch data from the table in a streaming manner: "argo.material_assembly" */
  argo_material_assembly_stream: Array<ArgoMaterialAssembly>;
  /** fetch data from the table: "argo.material_attribute" */
  argo_material_attribute: Array<ArgoMaterialAttribute>;
  /** fetch aggregated fields from the table: "argo.material_attribute" */
  argo_material_attribute_aggregate: ArgoMaterialAttributeAggregate;
  /** fetch data from the table: "argo.material_attribute" using primary key columns */
  argo_material_attribute_by_pk?: Maybe<ArgoMaterialAttribute>;
  /** fetch data from the table: "argo.material_attribute_history" */
  argo_material_attribute_history: Array<ArgoMaterialAttributeHistory>;
  /** fetch aggregated fields from the table: "argo.material_attribute_history" */
  argo_material_attribute_history_aggregate: ArgoMaterialAttributeHistoryAggregate;
  /** fetch data from the table: "argo.material_attribute_history" using primary key columns */
  argo_material_attribute_history_by_pk?: Maybe<ArgoMaterialAttributeHistory>;
  /** fetch data from the table in a streaming manner: "argo.material_attribute_history" */
  argo_material_attribute_history_stream: Array<ArgoMaterialAttributeHistory>;
  /** fetch data from the table in a streaming manner: "argo.material_attribute" */
  argo_material_attribute_stream: Array<ArgoMaterialAttribute>;
  /** fetch data from the table: "argo.material" using primary key columns */
  argo_material_by_pk?: Maybe<ArgoMaterial>;
  /** fetch data from the table: "argo.material_class" */
  argo_material_class: Array<ArgoMaterialClass>;
  /** fetch aggregated fields from the table: "argo.material_class" */
  argo_material_class_aggregate: ArgoMaterialClassAggregate;
  /** fetch data from the table: "argo.material_class_attribute" */
  argo_material_class_attribute: Array<ArgoMaterialClassAttribute>;
  /** fetch aggregated fields from the table: "argo.material_class_attribute" */
  argo_material_class_attribute_aggregate: ArgoMaterialClassAttributeAggregate;
  /** fetch data from the table: "argo.material_class_attribute" using primary key columns */
  argo_material_class_attribute_by_pk?: Maybe<ArgoMaterialClassAttribute>;
  /** fetch data from the table: "argo.material_class_attribute_setting" */
  argo_material_class_attribute_setting: Array<ArgoMaterialClassAttributeSetting>;
  /** fetch aggregated fields from the table: "argo.material_class_attribute_setting" */
  argo_material_class_attribute_setting_aggregate: ArgoMaterialClassAttributeSettingAggregate;
  /** fetch data from the table: "argo.material_class_attribute_setting" using primary key columns */
  argo_material_class_attribute_setting_by_pk?: Maybe<ArgoMaterialClassAttributeSetting>;
  /** fetch data from the table in a streaming manner: "argo.material_class_attribute_setting" */
  argo_material_class_attribute_setting_stream: Array<ArgoMaterialClassAttributeSetting>;
  /** fetch data from the table in a streaming manner: "argo.material_class_attribute" */
  argo_material_class_attribute_stream: Array<ArgoMaterialClassAttribute>;
  /** fetch data from the table: "argo.material_class" using primary key columns */
  argo_material_class_by_pk?: Maybe<ArgoMaterialClass>;
  /** fetch data from the table: "argo.material_class_process" */
  argo_material_class_process: Array<ArgoMaterialClassProcess>;
  /** fetch aggregated fields from the table: "argo.material_class_process" */
  argo_material_class_process_aggregate: ArgoMaterialClassProcessAggregate;
  /** fetch data from the table: "argo.material_class_process" using primary key columns */
  argo_material_class_process_by_pk?: Maybe<ArgoMaterialClassProcess>;
  /** fetch data from the table in a streaming manner: "argo.material_class_process" */
  argo_material_class_process_stream: Array<ArgoMaterialClassProcess>;
  /** fetch data from the table in a streaming manner: "argo.material_class" */
  argo_material_class_stream: Array<ArgoMaterialClass>;
  /** fetch data from the table: "argo.material_marriage" */
  argo_material_marriage: Array<ArgoMaterialMarriage>;
  /** fetch aggregated fields from the table: "argo.material_marriage" */
  argo_material_marriage_aggregate: ArgoMaterialMarriageAggregate;
  /** fetch data from the table: "argo.material_marriage" using primary key columns */
  argo_material_marriage_by_pk?: Maybe<ArgoMaterialMarriage>;
  /** fetch data from the table: "argo.material_marriage_status" */
  argo_material_marriage_status: Array<ArgoMaterialMarriageStatus>;
  /** fetch aggregated fields from the table: "argo.material_marriage_status" */
  argo_material_marriage_status_aggregate: ArgoMaterialMarriageStatusAggregate;
  /** fetch data from the table: "argo.material_marriage_status" using primary key columns */
  argo_material_marriage_status_by_pk?: Maybe<ArgoMaterialMarriageStatus>;
  /** fetch data from the table in a streaming manner: "argo.material_marriage_status" */
  argo_material_marriage_status_stream: Array<ArgoMaterialMarriageStatus>;
  /** fetch data from the table in a streaming manner: "argo.material_marriage" */
  argo_material_marriage_stream: Array<ArgoMaterialMarriage>;
  /** fetch data from the table: "argo.material_model" */
  argo_material_model: Array<ArgoMaterialModel>;
  /** fetch aggregated fields from the table: "argo.material_model" */
  argo_material_model_aggregate: ArgoMaterialModelAggregate;
  /** fetch data from the table: "argo.material_model_attribute" */
  argo_material_model_attribute: Array<ArgoMaterialModelAttribute>;
  /** fetch aggregated fields from the table: "argo.material_model_attribute" */
  argo_material_model_attribute_aggregate: ArgoMaterialModelAttributeAggregate;
  /** fetch data from the table: "argo.material_model_attribute" using primary key columns */
  argo_material_model_attribute_by_pk?: Maybe<ArgoMaterialModelAttribute>;
  /** fetch data from the table: "argo.material_model_attribute_setting" */
  argo_material_model_attribute_setting: Array<ArgoMaterialModelAttributeSetting>;
  /** fetch aggregated fields from the table: "argo.material_model_attribute_setting" */
  argo_material_model_attribute_setting_aggregate: ArgoMaterialModelAttributeSettingAggregate;
  /** fetch data from the table: "argo.material_model_attribute_setting" using primary key columns */
  argo_material_model_attribute_setting_by_pk?: Maybe<ArgoMaterialModelAttributeSetting>;
  /** fetch data from the table in a streaming manner: "argo.material_model_attribute_setting" */
  argo_material_model_attribute_setting_stream: Array<ArgoMaterialModelAttributeSetting>;
  /** fetch data from the table in a streaming manner: "argo.material_model_attribute" */
  argo_material_model_attribute_stream: Array<ArgoMaterialModelAttribute>;
  /** fetch data from the table: "argo.material_model" using primary key columns */
  argo_material_model_by_pk?: Maybe<ArgoMaterialModel>;
  /** fetch data from the table: "argo.material_model_process" */
  argo_material_model_process: Array<ArgoMaterialModelProcess>;
  /** fetch aggregated fields from the table: "argo.material_model_process" */
  argo_material_model_process_aggregate: ArgoMaterialModelProcessAggregate;
  /** fetch data from the table: "argo.material_model_process" using primary key columns */
  argo_material_model_process_by_pk?: Maybe<ArgoMaterialModelProcess>;
  /** fetch data from the table in a streaming manner: "argo.material_model_process" */
  argo_material_model_process_stream: Array<ArgoMaterialModelProcess>;
  /** fetch data from the table in a streaming manner: "argo.material_model" */
  argo_material_model_stream: Array<ArgoMaterialModel>;
  /** fetch data from the table: "argo.material_quantity_kind" */
  argo_material_quantity_kind: Array<ArgoMaterialQuantityKind>;
  /** fetch aggregated fields from the table: "argo.material_quantity_kind" */
  argo_material_quantity_kind_aggregate: ArgoMaterialQuantityKindAggregate;
  /** fetch data from the table: "argo.material_quantity_kind" using primary key columns */
  argo_material_quantity_kind_by_pk?: Maybe<ArgoMaterialQuantityKind>;
  /** fetch data from the table in a streaming manner: "argo.material_quantity_kind" */
  argo_material_quantity_kind_stream: Array<ArgoMaterialQuantityKind>;
  /** fetch data from the table: "argo.material_status" */
  argo_material_status: Array<ArgoMaterialStatus>;
  /** fetch aggregated fields from the table: "argo.material_status" */
  argo_material_status_aggregate: ArgoMaterialStatusAggregate;
  /** fetch data from the table: "argo.material_status" using primary key columns */
  argo_material_status_by_pk?: Maybe<ArgoMaterialStatus>;
  /** fetch data from the table in a streaming manner: "argo.material_status" */
  argo_material_status_stream: Array<ArgoMaterialStatus>;
  /** fetch data from the table in a streaming manner: "argo.material" */
  argo_material_stream: Array<ArgoMaterial>;
  /** fetch data from the table: "argo.material_udf_data" */
  argo_material_udf_data: Array<ArgoMaterialUdfData>;
  /** fetch aggregated fields from the table: "argo.material_udf_data" */
  argo_material_udf_data_aggregate: ArgoMaterialUdfDataAggregate;
  /** fetch data from the table: "argo.material_udf_data" using primary key columns */
  argo_material_udf_data_by_pk?: Maybe<ArgoMaterialUdfData>;
  /** fetch data from the table in a streaming manner: "argo.material_udf_data" */
  argo_material_udf_data_stream: Array<ArgoMaterialUdfData>;
  /** fetch data from the table: "argo.material_udf_default_data" */
  argo_material_udf_default_data: Array<ArgoMaterialUdfDefaultData>;
  /** fetch aggregated fields from the table: "argo.material_udf_default_data" */
  argo_material_udf_default_data_aggregate: ArgoMaterialUdfDefaultDataAggregate;
  /** fetch data from the table: "argo.material_udf_default_data" using primary key columns */
  argo_material_udf_default_data_by_pk?: Maybe<ArgoMaterialUdfDefaultData>;
  /** fetch data from the table in a streaming manner: "argo.material_udf_default_data" */
  argo_material_udf_default_data_stream: Array<ArgoMaterialUdfDefaultData>;
  /** fetch data from the table: "argo.material_udf_schema" */
  argo_material_udf_schema: Array<ArgoMaterialUdfSchema>;
  /** fetch aggregated fields from the table: "argo.material_udf_schema" */
  argo_material_udf_schema_aggregate: ArgoMaterialUdfSchemaAggregate;
  /** fetch data from the table: "argo.material_udf_schema" using primary key columns */
  argo_material_udf_schema_by_pk?: Maybe<ArgoMaterialUdfSchema>;
  /** fetch data from the table in a streaming manner: "argo.material_udf_schema" */
  argo_material_udf_schema_stream: Array<ArgoMaterialUdfSchema>;
  /** fetch data from the table: "argo.media_config" */
  argo_media_config: Array<ArgoMediaConfig>;
  /** fetch aggregated fields from the table: "argo.media_config" */
  argo_media_config_aggregate: ArgoMediaConfigAggregate;
  /** fetch data from the table: "argo.media_config" using primary key columns */
  argo_media_config_by_pk?: Maybe<ArgoMediaConfig>;
  /** fetch data from the table in a streaming manner: "argo.media_config" */
  argo_media_config_stream: Array<ArgoMediaConfig>;
  /** fetch data from the table: "argo.media_instance" */
  argo_media_instance: Array<ArgoMediaInstance>;
  /** fetch aggregated fields from the table: "argo.media_instance" */
  argo_media_instance_aggregate: ArgoMediaInstanceAggregate;
  /** fetch data from the table: "argo.media_instance" using primary key columns */
  argo_media_instance_by_pk?: Maybe<ArgoMediaInstance>;
  /** fetch data from the table in a streaming manner: "argo.media_instance" */
  argo_media_instance_stream: Array<ArgoMediaInstance>;
  /** fetch data from the table: "argo.pg_timezone_names" */
  argo_pg_timezone_names: Array<ArgoPgTimezoneNames>;
  /** fetch aggregated fields from the table: "argo.pg_timezone_names" */
  argo_pg_timezone_names_aggregate: ArgoPgTimezoneNamesAggregate;
  /** fetch data from the table in a streaming manner: "argo.pg_timezone_names" */
  argo_pg_timezone_names_stream: Array<ArgoPgTimezoneNames>;
  /** fetch data from the table: "argo.role" */
  argo_role: Array<ArgoRole>;
  /** fetch data from the table: "argo.role_acl" */
  argo_role_acl: Array<ArgoRoleAcl>;
  /** fetch aggregated fields from the table: "argo.role_acl" */
  argo_role_acl_aggregate: ArgoRoleAclAggregate;
  /** fetch data from the table: "argo.role_acl" using primary key columns */
  argo_role_acl_by_pk?: Maybe<ArgoRoleAcl>;
  /** fetch data from the table in a streaming manner: "argo.role_acl" */
  argo_role_acl_stream: Array<ArgoRoleAcl>;
  /** fetch aggregated fields from the table: "argo.role" */
  argo_role_aggregate: ArgoRoleAggregate;
  /** fetch data from the table: "argo.role" using primary key columns */
  argo_role_by_pk?: Maybe<ArgoRole>;
  /** fetch data from the table in a streaming manner: "argo.role" */
  argo_role_stream: Array<ArgoRole>;
  /** fetch data from the table: "argo.schedule" */
  argo_schedule: Array<ArgoSchedule>;
  /** fetch aggregated fields from the table: "argo.schedule" */
  argo_schedule_aggregate: ArgoScheduleAggregate;
  /** fetch data from the table: "argo.schedule" using primary key columns */
  argo_schedule_by_pk?: Maybe<ArgoSchedule>;
  /** fetch data from the table: "argo.schedule_day" */
  argo_schedule_day: Array<ArgoScheduleDay>;
  /** fetch aggregated fields from the table: "argo.schedule_day" */
  argo_schedule_day_aggregate: ArgoScheduleDayAggregate;
  /** fetch data from the table: "argo.schedule_day" using primary key columns */
  argo_schedule_day_by_pk?: Maybe<ArgoScheduleDay>;
  /** fetch data from the table in a streaming manner: "argo.schedule_day" */
  argo_schedule_day_stream: Array<ArgoScheduleDay>;
  /** fetch data from the table: "argo.schedule_event" */
  argo_schedule_event: Array<ArgoScheduleEvent>;
  /** fetch aggregated fields from the table: "argo.schedule_event" */
  argo_schedule_event_aggregate: ArgoScheduleEventAggregate;
  /** fetch data from the table: "argo.schedule_event" using primary key columns */
  argo_schedule_event_by_pk?: Maybe<ArgoScheduleEvent>;
  /** fetch data from the table in a streaming manner: "argo.schedule_event" */
  argo_schedule_event_stream: Array<ArgoScheduleEvent>;
  /** fetch data from the table: "argo.schedule_mode" */
  argo_schedule_mode: Array<ArgoScheduleMode>;
  /** fetch aggregated fields from the table: "argo.schedule_mode" */
  argo_schedule_mode_aggregate: ArgoScheduleModeAggregate;
  /** fetch data from the table: "argo.schedule_mode" using primary key columns */
  argo_schedule_mode_by_pk?: Maybe<ArgoScheduleMode>;
  /** fetch data from the table in a streaming manner: "argo.schedule_mode" */
  argo_schedule_mode_stream: Array<ArgoScheduleMode>;
  /** fetch data from the table in a streaming manner: "argo.schedule" */
  argo_schedule_stream: Array<ArgoSchedule>;
  /** fetch data from the table: "argo.sn" */
  argo_sn: Array<ArgoSn>;
  /** fetch aggregated fields from the table: "argo.sn" */
  argo_sn_aggregate: ArgoSnAggregate;
  /** fetch data from the table: "argo.sn" using primary key columns */
  argo_sn_by_pk?: Maybe<ArgoSn>;
  /** fetch data from the table: "argo.sn_format" */
  argo_sn_format: Array<ArgoSnFormat>;
  /** fetch aggregated fields from the table: "argo.sn_format" */
  argo_sn_format_aggregate: ArgoSnFormatAggregate;
  /** fetch data from the table: "argo.sn_format" using primary key columns */
  argo_sn_format_by_pk?: Maybe<ArgoSnFormat>;
  /** fetch data from the table: "argo.sn_format_status" */
  argo_sn_format_status: Array<ArgoSnFormatStatus>;
  /** fetch aggregated fields from the table: "argo.sn_format_status" */
  argo_sn_format_status_aggregate: ArgoSnFormatStatusAggregate;
  /** fetch data from the table: "argo.sn_format_status" using primary key columns */
  argo_sn_format_status_by_pk?: Maybe<ArgoSnFormatStatus>;
  /** fetch data from the table in a streaming manner: "argo.sn_format_status" */
  argo_sn_format_status_stream: Array<ArgoSnFormatStatus>;
  /** fetch data from the table in a streaming manner: "argo.sn_format" */
  argo_sn_format_stream: Array<ArgoSnFormat>;
  /** fetch data from the table: "argo.sn_format_uniqueness" */
  argo_sn_format_uniqueness: Array<ArgoSnFormatUniqueness>;
  /** fetch aggregated fields from the table: "argo.sn_format_uniqueness" */
  argo_sn_format_uniqueness_aggregate: ArgoSnFormatUniquenessAggregate;
  /** fetch data from the table: "argo.sn_format_uniqueness" using primary key columns */
  argo_sn_format_uniqueness_by_pk?: Maybe<ArgoSnFormatUniqueness>;
  /** fetch data from the table in a streaming manner: "argo.sn_format_uniqueness" */
  argo_sn_format_uniqueness_stream: Array<ArgoSnFormatUniqueness>;
  /** fetch data from the table in a streaming manner: "argo.sn" */
  argo_sn_stream: Array<ArgoSn>;
  /** execute function "argo.traverse_assemblies" which returns "argo.material_assembly" */
  argo_traverse_assemblies: Array<ArgoMaterialAssembly>;
  /** execute function "argo.traverse_assemblies" and query aggregates on result of table type "argo.material_assembly" */
  argo_traverse_assemblies_aggregate: ArgoMaterialAssemblyAggregate;
  /** fetch data from the table: "argo.udf_column" */
  argo_udf_column: Array<ArgoUdfColumn>;
  /** fetch aggregated fields from the table: "argo.udf_column" */
  argo_udf_column_aggregate: ArgoUdfColumnAggregate;
  /** fetch data from the table: "argo.udf_column" using primary key columns */
  argo_udf_column_by_pk?: Maybe<ArgoUdfColumn>;
  /** fetch data from the table: "argo.udf_column_data_type" */
  argo_udf_column_data_type: Array<ArgoUdfColumnDataType>;
  /** fetch aggregated fields from the table: "argo.udf_column_data_type" */
  argo_udf_column_data_type_aggregate: ArgoUdfColumnDataTypeAggregate;
  /** fetch data from the table: "argo.udf_column_data_type" using primary key columns */
  argo_udf_column_data_type_by_pk?: Maybe<ArgoUdfColumnDataType>;
  /** fetch data from the table in a streaming manner: "argo.udf_column_data_type" */
  argo_udf_column_data_type_stream: Array<ArgoUdfColumnDataType>;
  /** fetch data from the table in a streaming manner: "argo.udf_column" */
  argo_udf_column_stream: Array<ArgoUdfColumn>;
  /** fetch data from the table: "argo.udf_column_type" */
  argo_udf_column_type: Array<ArgoUdfColumnType>;
  /** fetch aggregated fields from the table: "argo.udf_column_type" */
  argo_udf_column_type_aggregate: ArgoUdfColumnTypeAggregate;
  /** fetch data from the table: "argo.udf_column_type" using primary key columns */
  argo_udf_column_type_by_pk?: Maybe<ArgoUdfColumnType>;
  /** fetch data from the table in a streaming manner: "argo.udf_column_type" */
  argo_udf_column_type_stream: Array<ArgoUdfColumnType>;
  /** fetch data from the table: "argo.uom" */
  argo_uom: Array<ArgoUom>;
  /** fetch aggregated fields from the table: "argo.uom" */
  argo_uom_aggregate: ArgoUomAggregate;
  /** fetch data from the table: "argo.uom" using primary key columns */
  argo_uom_by_pk?: Maybe<ArgoUom>;
  /** fetch data from the table in a streaming manner: "argo.uom" */
  argo_uom_stream: Array<ArgoUom>;
  /** fetch data from the table: "argo.user" */
  argo_user: Array<ArgoUser>;
  /** fetch data from the table: "argo.user_access_token" */
  argo_user_access_token: Array<ArgoUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.user_access_token" */
  argo_user_access_token_aggregate: ArgoUserAccessTokenAggregate;
  /** fetch data from the table: "argo.user_access_token" using primary key columns */
  argo_user_access_token_by_pk?: Maybe<ArgoUserAccessToken>;
  /** fetch data from the table in a streaming manner: "argo.user_access_token" */
  argo_user_access_token_stream: Array<ArgoUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.user" */
  argo_user_aggregate: ArgoUserAggregate;
  /** fetch data from the table: "argo.user_badge" */
  argo_user_badge: Array<ArgoUserBadge>;
  /** fetch aggregated fields from the table: "argo.user_badge" */
  argo_user_badge_aggregate: ArgoUserBadgeAggregate;
  /** fetch data from the table: "argo.user_badge" using primary key columns */
  argo_user_badge_by_pk?: Maybe<ArgoUserBadge>;
  /** fetch data from the table in a streaming manner: "argo.user_badge" */
  argo_user_badge_stream: Array<ArgoUserBadge>;
  /** fetch data from the table: "argo.user" using primary key columns */
  argo_user_by_pk?: Maybe<ArgoUser>;
  /** fetch data from the table: "argo.user_context" */
  argo_user_context: Array<ArgoUserContext>;
  /** fetch aggregated fields from the table: "argo.user_context" */
  argo_user_context_aggregate: ArgoUserContextAggregate;
  /** fetch data from the table: "argo.user_context" using primary key columns */
  argo_user_context_by_pk?: Maybe<ArgoUserContext>;
  /** fetch data from the table in a streaming manner: "argo.user_context" */
  argo_user_context_stream: Array<ArgoUserContext>;
  /** fetch data from the table: "argo.user_role" */
  argo_user_role: Array<ArgoUserRole>;
  /** fetch aggregated fields from the table: "argo.user_role" */
  argo_user_role_aggregate: ArgoUserRoleAggregate;
  /** fetch data from the table: "argo.user_role" using primary key columns */
  argo_user_role_by_pk?: Maybe<ArgoUserRole>;
  /** fetch data from the table in a streaming manner: "argo.user_role" */
  argo_user_role_stream: Array<ArgoUserRole>;
  /** fetch data from the table in a streaming manner: "argo.user" */
  argo_user_stream: Array<ArgoUser>;
  /** fetch data from the table: "argo.vw_acl_role" */
  argo_vw_acl_role: Array<ArgoVwAclRole>;
  /** fetch aggregated fields from the table: "argo.vw_acl_role" */
  argo_vw_acl_role_aggregate: ArgoVwAclRoleAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_acl_role" */
  argo_vw_acl_role_stream: Array<ArgoVwAclRole>;
  /** fetch data from the table: "argo.vw_active_location_calendar" */
  argo_vw_active_location_calendar: Array<ArgoVwActiveLocationCalendar>;
  /** fetch aggregated fields from the table: "argo.vw_active_location_calendar" */
  argo_vw_active_location_calendar_aggregate: ArgoVwActiveLocationCalendarAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_active_location_calendar" */
  argo_vw_active_location_calendar_stream: Array<ArgoVwActiveLocationCalendar>;
  /** fetch data from the table: "argo.vw_auth_user_access_token" */
  argo_vw_auth_user_access_token: Array<ArgoVwAuthUserAccessToken>;
  /** fetch aggregated fields from the table: "argo.vw_auth_user_access_token" */
  argo_vw_auth_user_access_token_aggregate: ArgoVwAuthUserAccessTokenAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_auth_user_access_token" */
  argo_vw_auth_user_access_token_stream: Array<ArgoVwAuthUserAccessToken>;
  /** fetch data from the table: "argo.vw_event_type_udf_column" */
  argo_vw_event_type_udf_column: Array<ArgoVwEventTypeUdfColumn>;
  /** fetch aggregated fields from the table: "argo.vw_event_type_udf_column" */
  argo_vw_event_type_udf_column_aggregate: ArgoVwEventTypeUdfColumnAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_event_type_udf_column" */
  argo_vw_event_type_udf_column_stream: Array<ArgoVwEventTypeUdfColumn>;
  /** fetch data from the table: "argo.vw_location_hierarchy" */
  argo_vw_location_hierarchy: Array<ArgoVwLocationHierarchy>;
  /** fetch aggregated fields from the table: "argo.vw_location_hierarchy" */
  argo_vw_location_hierarchy_aggregate: ArgoVwLocationHierarchyAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_location_hierarchy" */
  argo_vw_location_hierarchy_stream: Array<ArgoVwLocationHierarchy>;
  /** fetch data from the table: "argo.vw_material_by_class" */
  argo_vw_material_by_class: Array<ArgoVwMaterialByClass>;
  /** fetch aggregated fields from the table: "argo.vw_material_by_class" */
  argo_vw_material_by_class_aggregate: ArgoVwMaterialByClassAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_material_by_class" */
  argo_vw_material_by_class_stream: Array<ArgoVwMaterialByClass>;
  /** fetch data from the table: "argo.vw_material_class_udf_column" */
  argo_vw_material_class_udf_column: Array<ArgoVwMaterialClassUdfColumn>;
  /** fetch aggregated fields from the table: "argo.vw_material_class_udf_column" */
  argo_vw_material_class_udf_column_aggregate: ArgoVwMaterialClassUdfColumnAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_material_class_udf_column" */
  argo_vw_material_class_udf_column_stream: Array<ArgoVwMaterialClassUdfColumn>;
  /** fetch data from the table: "argo.vw_material_model_processes_by_class" */
  argo_vw_material_model_processes_by_class: Array<ArgoVwMaterialModelProcessesByClass>;
  /** fetch aggregated fields from the table: "argo.vw_material_model_processes_by_class" */
  argo_vw_material_model_processes_by_class_aggregate: ArgoVwMaterialModelProcessesByClassAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_material_model_processes_by_class" */
  argo_vw_material_model_processes_by_class_stream: Array<ArgoVwMaterialModelProcessesByClass>;
  /** fetch data from the table: "argo.vw_role_acl" */
  argo_vw_role_acl: Array<ArgoVwRoleAcl>;
  /** fetch aggregated fields from the table: "argo.vw_role_acl" */
  argo_vw_role_acl_aggregate: ArgoVwRoleAclAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_role_acl" */
  argo_vw_role_acl_stream: Array<ArgoVwRoleAcl>;
  /** fetch data from the table: "argo.vw_timestamptz" */
  argo_vw_timestamptz: Array<ArgoVwTimestamptz>;
  /** fetch aggregated fields from the table: "argo.vw_timestamptz" */
  argo_vw_timestamptz_aggregate: ArgoVwTimestamptzAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_timestamptz" */
  argo_vw_timestamptz_stream: Array<ArgoVwTimestamptz>;
  /** fetch data from the table: "argo.vw_user_acls" */
  argo_vw_user_acls: Array<ArgoVwUserAcls>;
  /** fetch aggregated fields from the table: "argo.vw_user_acls" */
  argo_vw_user_acls_aggregate: ArgoVwUserAclsAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_user_acls" */
  argo_vw_user_acls_stream: Array<ArgoVwUserAcls>;
  /** fetch data from the table: "argo.vw_user_context_acl" */
  argo_vw_user_context_acl: Array<ArgoVwUserContextAcl>;
  /** fetch aggregated fields from the table: "argo.vw_user_context_acl" */
  argo_vw_user_context_acl_aggregate: ArgoVwUserContextAclAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_user_context_acl" */
  argo_vw_user_context_acl_stream: Array<ArgoVwUserContextAcl>;
  /** fetch data from the table: "argo.vw_user_roles" */
  argo_vw_user_roles: Array<ArgoVwUserRoles>;
  /** fetch aggregated fields from the table: "argo.vw_user_roles" */
  argo_vw_user_roles_aggregate: ArgoVwUserRolesAggregate;
  /** fetch data from the table in a streaming manner: "argo.vw_user_roles" */
  argo_vw_user_roles_stream: Array<ArgoVwUserRoles>;
  /** fetch data from the table: "argo.work_instruction" */
  argo_work_instruction: Array<ArgoWorkInstruction>;
  /** fetch aggregated fields from the table: "argo.work_instruction" */
  argo_work_instruction_aggregate: ArgoWorkInstructionAggregate;
  /** fetch data from the table: "argo.work_instruction" using primary key columns */
  argo_work_instruction_by_pk?: Maybe<ArgoWorkInstruction>;
  /** fetch data from the table: "argo.work_instruction_instance" */
  argo_work_instruction_instance: Array<ArgoWorkInstructionInstance>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance" */
  argo_work_instruction_instance_aggregate: ArgoWorkInstructionInstanceAggregate;
  /** fetch data from the table: "argo.work_instruction_instance" using primary key columns */
  argo_work_instruction_instance_by_pk?: Maybe<ArgoWorkInstructionInstance>;
  /** fetch data from the table: "argo.work_instruction_instance_status" */
  argo_work_instruction_instance_status: Array<ArgoWorkInstructionInstanceStatus>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance_status" */
  argo_work_instruction_instance_status_aggregate: ArgoWorkInstructionInstanceStatusAggregate;
  /** fetch data from the table: "argo.work_instruction_instance_status" using primary key columns */
  argo_work_instruction_instance_status_by_pk?: Maybe<ArgoWorkInstructionInstanceStatus>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction_instance_status" */
  argo_work_instruction_instance_status_stream: Array<ArgoWorkInstructionInstanceStatus>;
  /** fetch data from the table: "argo.work_instruction_instance_step" */
  argo_work_instruction_instance_step: Array<ArgoWorkInstructionInstanceStep>;
  /** fetch aggregated fields from the table: "argo.work_instruction_instance_step" */
  argo_work_instruction_instance_step_aggregate: ArgoWorkInstructionInstanceStepAggregate;
  /** fetch data from the table: "argo.work_instruction_instance_step" using primary key columns */
  argo_work_instruction_instance_step_by_pk?: Maybe<ArgoWorkInstructionInstanceStep>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction_instance_step" */
  argo_work_instruction_instance_step_stream: Array<ArgoWorkInstructionInstanceStep>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction_instance" */
  argo_work_instruction_instance_stream: Array<ArgoWorkInstructionInstance>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction" */
  argo_work_instruction_stream: Array<ArgoWorkInstruction>;
  /** fetch data from the table: "argo.work_instruction_version" */
  argo_work_instruction_version: Array<ArgoWorkInstructionVersion>;
  /** fetch aggregated fields from the table: "argo.work_instruction_version" */
  argo_work_instruction_version_aggregate: ArgoWorkInstructionVersionAggregate;
  /** fetch data from the table: "argo.work_instruction_version" using primary key columns */
  argo_work_instruction_version_by_pk?: Maybe<ArgoWorkInstructionVersion>;
  /** fetch data from the table: "argo.work_instruction_version_status" */
  argo_work_instruction_version_status: Array<ArgoWorkInstructionVersionStatus>;
  /** fetch aggregated fields from the table: "argo.work_instruction_version_status" */
  argo_work_instruction_version_status_aggregate: ArgoWorkInstructionVersionStatusAggregate;
  /** fetch data from the table: "argo.work_instruction_version_status" using primary key columns */
  argo_work_instruction_version_status_by_pk?: Maybe<ArgoWorkInstructionVersionStatus>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction_version_status" */
  argo_work_instruction_version_status_stream: Array<ArgoWorkInstructionVersionStatus>;
  /** fetch data from the table in a streaming manner: "argo.work_instruction_version" */
  argo_work_instruction_version_stream: Array<ArgoWorkInstructionVersion>;
  /** fetch data from the table: "argo.work_order" */
  argo_work_order: Array<ArgoWorkOrder>;
  /** fetch data from the table: "argo.work_order_activity" */
  argo_work_order_activity: Array<ArgoWorkOrderActivity>;
  /** fetch aggregated fields from the table: "argo.work_order_activity" */
  argo_work_order_activity_aggregate: ArgoWorkOrderActivityAggregate;
  /** fetch data from the table: "argo.work_order_activity" using primary key columns */
  argo_work_order_activity_by_pk?: Maybe<ArgoWorkOrderActivity>;
  /** fetch data from the table: "argo.work_order_activity_kind" */
  argo_work_order_activity_kind: Array<ArgoWorkOrderActivityKind>;
  /** fetch aggregated fields from the table: "argo.work_order_activity_kind" */
  argo_work_order_activity_kind_aggregate: ArgoWorkOrderActivityKindAggregate;
  /** fetch data from the table: "argo.work_order_activity_kind" using primary key columns */
  argo_work_order_activity_kind_by_pk?: Maybe<ArgoWorkOrderActivityKind>;
  /** fetch data from the table in a streaming manner: "argo.work_order_activity_kind" */
  argo_work_order_activity_kind_stream: Array<ArgoWorkOrderActivityKind>;
  /** fetch data from the table in a streaming manner: "argo.work_order_activity" */
  argo_work_order_activity_stream: Array<ArgoWorkOrderActivity>;
  /** fetch aggregated fields from the table: "argo.work_order" */
  argo_work_order_aggregate: ArgoWorkOrderAggregate;
  /** fetch data from the table: "argo.work_order" using primary key columns */
  argo_work_order_by_pk?: Maybe<ArgoWorkOrder>;
  /** fetch data from the table: "argo.work_order_location" */
  argo_work_order_location: Array<ArgoWorkOrderLocation>;
  /** fetch aggregated fields from the table: "argo.work_order_location" */
  argo_work_order_location_aggregate: ArgoWorkOrderLocationAggregate;
  /** fetch data from the table: "argo.work_order_location" using primary key columns */
  argo_work_order_location_by_pk?: Maybe<ArgoWorkOrderLocation>;
  /** fetch data from the table in a streaming manner: "argo.work_order_location" */
  argo_work_order_location_stream: Array<ArgoWorkOrderLocation>;
  /** fetch data from the table: "argo.work_order_material" */
  argo_work_order_material: Array<ArgoWorkOrderMaterial>;
  /** fetch aggregated fields from the table: "argo.work_order_material" */
  argo_work_order_material_aggregate: ArgoWorkOrderMaterialAggregate;
  /** fetch data from the table: "argo.work_order_material" using primary key columns */
  argo_work_order_material_by_pk?: Maybe<ArgoWorkOrderMaterial>;
  /** fetch data from the table in a streaming manner: "argo.work_order_material" */
  argo_work_order_material_stream: Array<ArgoWorkOrderMaterial>;
  /** fetch data from the table: "argo.work_order_restriction" */
  argo_work_order_restriction: Array<ArgoWorkOrderRestriction>;
  /** fetch aggregated fields from the table: "argo.work_order_restriction" */
  argo_work_order_restriction_aggregate: ArgoWorkOrderRestrictionAggregate;
  /** fetch data from the table: "argo.work_order_restriction" using primary key columns */
  argo_work_order_restriction_by_pk?: Maybe<ArgoWorkOrderRestriction>;
  /** fetch data from the table in a streaming manner: "argo.work_order_restriction" */
  argo_work_order_restriction_stream: Array<ArgoWorkOrderRestriction>;
  /** fetch data from the table: "argo.work_order_status" */
  argo_work_order_status: Array<ArgoWorkOrderStatus>;
  /** fetch aggregated fields from the table: "argo.work_order_status" */
  argo_work_order_status_aggregate: ArgoWorkOrderStatusAggregate;
  /** fetch data from the table: "argo.work_order_status" using primary key columns */
  argo_work_order_status_by_pk?: Maybe<ArgoWorkOrderStatus>;
  /** fetch data from the table in a streaming manner: "argo.work_order_status" */
  argo_work_order_status_stream: Array<ArgoWorkOrderStatus>;
  /** fetch data from the table in a streaming manner: "argo.work_order" */
  argo_work_order_stream: Array<ArgoWorkOrder>;
  /** fetch data from the table: "fis.asset" */
  fis_asset: Array<FisAsset>;
  /** fetch aggregated fields from the table: "fis.asset" */
  fis_asset_aggregate: FisAssetAggregate;
  /** fetch data from the table: "fis.asset" using primary key columns */
  fis_asset_by_pk?: Maybe<FisAsset>;
  /** fetch data from the table: "fis.asset_code" */
  fis_asset_code: Array<FisAssetCode>;
  /** fetch aggregated fields from the table: "fis.asset_code" */
  fis_asset_code_aggregate: FisAssetCodeAggregate;
  /** fetch data from the table: "fis.asset_code" using primary key columns */
  fis_asset_code_by_pk?: Maybe<FisAssetCode>;
  /** fetch data from the table in a streaming manner: "fis.asset_code" */
  fis_asset_code_stream: Array<FisAssetCode>;
  /** fetch data from the table in a streaming manner: "fis.asset" */
  fis_asset_stream: Array<FisAsset>;
  /** fetch data from the table: "fis.asset_tag" */
  fis_asset_tag: Array<FisAssetTag>;
  /** fetch aggregated fields from the table: "fis.asset_tag" */
  fis_asset_tag_aggregate: FisAssetTagAggregate;
  /** fetch data from the table: "fis.asset_tag" using primary key columns */
  fis_asset_tag_by_pk?: Maybe<FisAssetTag>;
  /** fetch data from the table: "fis.asset_tag_link" */
  fis_asset_tag_link: Array<FisAssetTagLink>;
  /** fetch aggregated fields from the table: "fis.asset_tag_link" */
  fis_asset_tag_link_aggregate: FisAssetTagLinkAggregate;
  /** fetch data from the table: "fis.asset_tag_link" using primary key columns */
  fis_asset_tag_link_by_pk?: Maybe<FisAssetTagLink>;
  /** fetch data from the table in a streaming manner: "fis.asset_tag_link" */
  fis_asset_tag_link_stream: Array<FisAssetTagLink>;
  /** fetch data from the table in a streaming manner: "fis.asset_tag" */
  fis_asset_tag_stream: Array<FisAssetTag>;
  /** fetch data from the table: "fis.asset_type" */
  fis_asset_type: Array<FisAssetType>;
  /** fetch aggregated fields from the table: "fis.asset_type" */
  fis_asset_type_aggregate: FisAssetTypeAggregate;
  /** fetch data from the table: "fis.asset_type" using primary key columns */
  fis_asset_type_by_pk?: Maybe<FisAssetType>;
  /** fetch data from the table in a streaming manner: "fis.asset_type" */
  fis_asset_type_stream: Array<FisAssetType>;
  /** fetch data from the table: "fis.core_state" */
  fis_core_state: Array<FisCoreState>;
  /** fetch aggregated fields from the table: "fis.core_state" */
  fis_core_state_aggregate: FisCoreStateAggregate;
  /** fetch data from the table: "fis.core_state" using primary key columns */
  fis_core_state_by_pk?: Maybe<FisCoreState>;
  /** fetch data from the table in a streaming manner: "fis.core_state" */
  fis_core_state_stream: Array<FisCoreState>;
  /** fetch data from the table: "fis.data" */
  fis_data: Array<FisData>;
  /** fetch aggregated fields from the table: "fis.data" */
  fis_data_aggregate: FisDataAggregate;
  /** fetch data from the table: "fis.data" using primary key columns */
  fis_data_by_pk?: Maybe<FisData>;
  /** fetch data from the table: "fis.data_label" */
  fis_data_label: Array<FisDataLabel>;
  /** fetch aggregated fields from the table: "fis.data_label" */
  fis_data_label_aggregate: FisDataLabelAggregate;
  /** fetch data from the table: "fis.data_label" using primary key columns */
  fis_data_label_by_pk?: Maybe<FisDataLabel>;
  /** fetch data from the table in a streaming manner: "fis.data_label" */
  fis_data_label_stream: Array<FisDataLabel>;
  /** fetch data from the table in a streaming manner: "fis.data" */
  fis_data_stream: Array<FisData>;
  /** fetch data from the table: "fis.data_timing" */
  fis_data_timing: Array<FisDataTiming>;
  /** fetch aggregated fields from the table: "fis.data_timing" */
  fis_data_timing_aggregate: FisDataTimingAggregate;
  /** fetch data from the table: "fis.data_timing" using primary key columns */
  fis_data_timing_by_pk?: Maybe<FisDataTiming>;
  /** fetch data from the table in a streaming manner: "fis.data_timing" */
  fis_data_timing_stream: Array<FisDataTiming>;
  /** fetch data from the table: "fis.data_track_count" */
  fis_data_track_count: Array<FisDataTrackCount>;
  /** fetch aggregated fields from the table: "fis.data_track_count" */
  fis_data_track_count_aggregate: FisDataTrackCountAggregate;
  /** fetch data from the table: "fis.data_track_count" using primary key columns */
  fis_data_track_count_by_pk?: Maybe<FisDataTrackCount>;
  /** fetch data from the table in a streaming manner: "fis.data_track_count" */
  fis_data_track_count_stream: Array<FisDataTrackCount>;
  /** fetch data from the table: "fis.data_track_duration" */
  fis_data_track_duration: Array<FisDataTrackDuration>;
  /** fetch aggregated fields from the table: "fis.data_track_duration" */
  fis_data_track_duration_aggregate: FisDataTrackDurationAggregate;
  /** fetch data from the table: "fis.data_track_duration" using primary key columns */
  fis_data_track_duration_by_pk?: Maybe<FisDataTrackDuration>;
  /** fetch data from the table in a streaming manner: "fis.data_track_duration" */
  fis_data_track_duration_stream: Array<FisDataTrackDuration>;
  /** fetch data from the table: "fis.data_track_scalar" */
  fis_data_track_scalar: Array<FisDataTrackScalar>;
  /** fetch aggregated fields from the table: "fis.data_track_scalar" */
  fis_data_track_scalar_aggregate: FisDataTrackScalarAggregate;
  /** fetch data from the table: "fis.data_track_scalar" using primary key columns */
  fis_data_track_scalar_by_pk?: Maybe<FisDataTrackScalar>;
  /** fetch data from the table in a streaming manner: "fis.data_track_scalar" */
  fis_data_track_scalar_stream: Array<FisDataTrackScalar>;
  /** fetch data from the table: "fis.data_type" */
  fis_data_type: Array<FisDataType>;
  /** fetch aggregated fields from the table: "fis.data_type" */
  fis_data_type_aggregate: FisDataTypeAggregate;
  /** fetch data from the table: "fis.data_type" using primary key columns */
  fis_data_type_by_pk?: Maybe<FisDataType>;
  /** fetch data from the table in a streaming manner: "fis.data_type" */
  fis_data_type_stream: Array<FisDataType>;
  /** fetch data from the table: "fis.report_constraint" */
  fis_report_constraint: Array<FisReportConstraint>;
  /** fetch aggregated fields from the table: "fis.report_constraint" */
  fis_report_constraint_aggregate: FisReportConstraintAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_constraint" */
  fis_report_constraint_stream: Array<FisReportConstraint>;
  /** fetch data from the table: "fis.report_detail" */
  fis_report_detail: Array<FisReportDetail>;
  /** fetch aggregated fields from the table: "fis.report_detail" */
  fis_report_detail_aggregate: FisReportDetailAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_detail" */
  fis_report_detail_stream: Array<FisReportDetail>;
  /** fetch data from the table: "fis.report_mtbf" */
  fis_report_mtbf: Array<FisReportMtbf>;
  /** fetch aggregated fields from the table: "fis.report_mtbf" */
  fis_report_mtbf_aggregate: FisReportMtbfAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_mtbf" */
  fis_report_mtbf_stream: Array<FisReportMtbf>;
  /** fetch data from the table: "fis.report_oee" */
  fis_report_oee: Array<FisReportOee>;
  /** fetch aggregated fields from the table: "fis.report_oee" */
  fis_report_oee_aggregate: FisReportOeeAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_oee" */
  fis_report_oee_stream: Array<FisReportOee>;
  /** fetch data from the table: "fis.report_state" */
  fis_report_state: Array<FisReportState>;
  /** fetch aggregated fields from the table: "fis.report_state" */
  fis_report_state_aggregate: FisReportStateAggregate;
  /** fetch data from the table: "fis.report_state_column" */
  fis_report_state_column: Array<FisReportStateColumn>;
  /** fetch aggregated fields from the table: "fis.report_state_column" */
  fis_report_state_column_aggregate: FisReportStateColumnAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_state_column" */
  fis_report_state_column_stream: Array<FisReportStateColumn>;
  /** fetch data from the table in a streaming manner: "fis.report_state" */
  fis_report_state_stream: Array<FisReportState>;
  /** fetch data from the table: "fis.report_top_fault" */
  fis_report_top_fault: Array<FisReportTopFault>;
  /** fetch aggregated fields from the table: "fis.report_top_fault" */
  fis_report_top_fault_aggregate: FisReportTopFaultAggregate;
  /** fetch data from the table in a streaming manner: "fis.report_top_fault" */
  fis_report_top_fault_stream: Array<FisReportTopFault>;
  /** execute function "fis.run_report_constraint" which returns "fis.report_constraint" */
  fis_run_report_constraint: Array<FisReportConstraint>;
  /** execute function "fis.run_report_constraint" and query aggregates on result of table type "fis.report_constraint" */
  fis_run_report_constraint_aggregate: FisReportConstraintAggregate;
  /** execute function "fis.run_report_mtbf" which returns "fis.report_mtbf" */
  fis_run_report_mtbf: Array<FisReportMtbf>;
  /** execute function "fis.run_report_mtbf" and query aggregates on result of table type "fis.report_mtbf" */
  fis_run_report_mtbf_aggregate: FisReportMtbfAggregate;
  /** execute function "fis.run_report_oee" which returns "fis.report_oee" */
  fis_run_report_oee: Array<FisReportOee>;
  /** execute function "fis.run_report_oee" and query aggregates on result of table type "fis.report_oee" */
  fis_run_report_oee_aggregate: FisReportOeeAggregate;
  /** execute function "fis.run_report_state" which returns "fis.report_state" */
  fis_run_report_state: Array<FisReportState>;
  /** execute function "fis.run_report_state" and query aggregates on result of table type "fis.report_state" */
  fis_run_report_state_aggregate: FisReportStateAggregate;
  /** execute function "fis.run_report_state_column" which returns "fis.report_state_column" */
  fis_run_report_state_column: Array<FisReportStateColumn>;
  /** execute function "fis.run_report_state_column" and query aggregates on result of table type "fis.report_state_column" */
  fis_run_report_state_column_aggregate: FisReportStateColumnAggregate;
  /** execute function "fis.run_report_top_fault" which returns "fis.report_top_fault" */
  fis_run_report_top_fault: Array<FisReportTopFault>;
  /** execute function "fis.run_report_top_fault" and query aggregates on result of table type "fis.report_top_fault" */
  fis_run_report_top_fault_aggregate: FisReportTopFaultAggregate;
  /** fetch data from the table: "plv8_response" */
  plv8_response: Array<Plv8Response>;
  /** fetch aggregated fields from the table: "plv8_response" */
  plv8_response_aggregate: Plv8ResponseAggregate;
  /** fetch data from the table in a streaming manner: "plv8_response" */
  plv8_response_stream: Array<Plv8Response>;
  /** fetch data from the table: "plv8_value_response" */
  plv8_value_response: Array<Plv8ValueResponse>;
  /** fetch aggregated fields from the table: "plv8_value_response" */
  plv8_value_response_aggregate: Plv8ValueResponseAggregate;
  /** fetch data from the table in a streaming manner: "plv8_value_response" */
  plv8_value_response_stream: Array<Plv8ValueResponse>;
  /** fetch data from the table: "process.collection" */
  process_collection: Array<ProcessCollection>;
  /** fetch aggregated fields from the table: "process.collection" */
  process_collection_aggregate: ProcessCollectionAggregate;
  /** fetch data from the table: "process.collection" using primary key columns */
  process_collection_by_pk?: Maybe<ProcessCollection>;
  /** fetch data from the table: "process.collection_data" */
  process_collection_data: Array<ProcessCollectionData>;
  /** fetch aggregated fields from the table: "process.collection_data" */
  process_collection_data_aggregate: ProcessCollectionDataAggregate;
  /** fetch data from the table: "process.collection_data" using primary key columns */
  process_collection_data_by_pk?: Maybe<ProcessCollectionData>;
  /** fetch data from the table in a streaming manner: "process.collection_data" */
  process_collection_data_stream: Array<ProcessCollectionData>;
  /** fetch data from the table: "process.collection_kind" */
  process_collection_kind: Array<ProcessCollectionKind>;
  /** fetch aggregated fields from the table: "process.collection_kind" */
  process_collection_kind_aggregate: ProcessCollectionKindAggregate;
  /** fetch data from the table: "process.collection_kind" using primary key columns */
  process_collection_kind_by_pk?: Maybe<ProcessCollectionKind>;
  /** fetch data from the table in a streaming manner: "process.collection_kind" */
  process_collection_kind_stream: Array<ProcessCollectionKind>;
  /** fetch data from the table in a streaming manner: "process.collection" */
  process_collection_stream: Array<ProcessCollection>;
  /** fetch data from the table: "process.data_element" */
  process_data_element: Array<ProcessDataElement>;
  /** fetch aggregated fields from the table: "process.data_element" */
  process_data_element_aggregate: ProcessDataElementAggregate;
  /** fetch data from the table: "process.data_element" using primary key columns */
  process_data_element_by_pk?: Maybe<ProcessDataElement>;
  /** fetch data from the table: "process.data_element_collection_kind" */
  process_data_element_collection_kind: Array<ProcessDataElementCollectionKind>;
  /** fetch aggregated fields from the table: "process.data_element_collection_kind" */
  process_data_element_collection_kind_aggregate: ProcessDataElementCollectionKindAggregate;
  /** fetch data from the table: "process.data_element_collection_kind" using primary key columns */
  process_data_element_collection_kind_by_pk?: Maybe<ProcessDataElementCollectionKind>;
  /** fetch data from the table in a streaming manner: "process.data_element_collection_kind" */
  process_data_element_collection_kind_stream: Array<ProcessDataElementCollectionKind>;
  /** fetch data from the table: "process.data_element_kind" */
  process_data_element_kind: Array<ProcessDataElementKind>;
  /** fetch aggregated fields from the table: "process.data_element_kind" */
  process_data_element_kind_aggregate: ProcessDataElementKindAggregate;
  /** fetch data from the table: "process.data_element_kind" using primary key columns */
  process_data_element_kind_by_pk?: Maybe<ProcessDataElementKind>;
  /** fetch data from the table in a streaming manner: "process.data_element_kind" */
  process_data_element_kind_stream: Array<ProcessDataElementKind>;
  /** fetch data from the table in a streaming manner: "process.data_element" */
  process_data_element_stream: Array<ProcessDataElement>;
  /** fetch data from the table: "process.material_state" */
  process_material_state: Array<ProcessMaterialState>;
  /** fetch aggregated fields from the table: "process.material_state" */
  process_material_state_aggregate: ProcessMaterialStateAggregate;
  /** fetch data from the table: "process.material_state" using primary key columns */
  process_material_state_by_pk?: Maybe<ProcessMaterialState>;
  /** fetch data from the table: "process.material_state_history" */
  process_material_state_history: Array<ProcessMaterialStateHistory>;
  /** fetch aggregated fields from the table: "process.material_state_history" */
  process_material_state_history_aggregate: ProcessMaterialStateHistoryAggregate;
  /** fetch data from the table: "process.material_state_history" using primary key columns */
  process_material_state_history_by_pk?: Maybe<ProcessMaterialStateHistory>;
  /** fetch data from the table in a streaming manner: "process.material_state_history" */
  process_material_state_history_stream: Array<ProcessMaterialStateHistory>;
  /** fetch data from the table in a streaming manner: "process.material_state" */
  process_material_state_stream: Array<ProcessMaterialState>;
  /** fetch data from the table: "process.process" */
  process_process: Array<ProcessProcess>;
  /** fetch aggregated fields from the table: "process.process" */
  process_process_aggregate: ProcessProcessAggregate;
  /** fetch data from the table: "process.process" using primary key columns */
  process_process_by_pk?: Maybe<ProcessProcess>;
  /** fetch data from the table: "process.process_status" */
  process_process_status: Array<ProcessProcessStatus>;
  /** fetch aggregated fields from the table: "process.process_status" */
  process_process_status_aggregate: ProcessProcessStatusAggregate;
  /** fetch data from the table: "process.process_status" using primary key columns */
  process_process_status_by_pk?: Maybe<ProcessProcessStatus>;
  /** fetch data from the table in a streaming manner: "process.process_status" */
  process_process_status_stream: Array<ProcessProcessStatus>;
  /** fetch data from the table in a streaming manner: "process.process" */
  process_process_stream: Array<ProcessProcess>;
  /** fetch data from the table: "process.spec" */
  process_spec: Array<ProcessSpec>;
  /** fetch aggregated fields from the table: "process.spec" */
  process_spec_aggregate: ProcessSpecAggregate;
  /** fetch data from the table: "process.spec" using primary key columns */
  process_spec_by_pk?: Maybe<ProcessSpec>;
  /** fetch data from the table: "process.spec_order" */
  process_spec_order: Array<ProcessSpecOrder>;
  /** fetch aggregated fields from the table: "process.spec_order" */
  process_spec_order_aggregate: ProcessSpecOrderAggregate;
  /** fetch data from the table: "process.spec_order" using primary key columns */
  process_spec_order_by_pk?: Maybe<ProcessSpecOrder>;
  /** fetch data from the table in a streaming manner: "process.spec_order" */
  process_spec_order_stream: Array<ProcessSpecOrder>;
  /** fetch data from the table in a streaming manner: "process.spec" */
  process_spec_stream: Array<ProcessSpec>;
};


export type SubscriptionRootAppletDeploymentArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


export type SubscriptionRootAppletDeploymentAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentOrderBy>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


export type SubscriptionRootAppletDeploymentByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootAppletDeploymentLinkedDesignVersionArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


export type SubscriptionRootAppletDeploymentLinkedDesignVersionAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDeploymentLinkedDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDeploymentLinkedDesignVersionOrderBy>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


export type SubscriptionRootAppletDeploymentLinkedDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootAppletDeploymentLinkedDesignVersionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletDeploymentLinkedDesignVersionStreamCursorInput>>;
  where?: Maybe<AppletDeploymentLinkedDesignVersionBoolExp>;
};


export type SubscriptionRootAppletDeploymentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletDeploymentStreamCursorInput>>;
  where?: Maybe<AppletDeploymentBoolExp>;
};


export type SubscriptionRootAppletDesignArgs = {
  distinct_on?: Maybe<Array<AppletDesignSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignOrderBy>>;
  where?: Maybe<AppletDesignBoolExp>;
};


export type SubscriptionRootAppletDesignAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignOrderBy>>;
  where?: Maybe<AppletDesignBoolExp>;
};


export type SubscriptionRootAppletDesignByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootAppletDesignStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletDesignStreamCursorInput>>;
  where?: Maybe<AppletDesignBoolExp>;
};


export type SubscriptionRootAppletDesignVersionArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


export type SubscriptionRootAppletDesignVersionAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionOrderBy>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


export type SubscriptionRootAppletDesignVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootAppletDesignVersionStatusArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionStatusOrderBy>>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};


export type SubscriptionRootAppletDesignVersionStatusAggregateArgs = {
  distinct_on?: Maybe<Array<AppletDesignVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletDesignVersionStatusOrderBy>>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};


export type SubscriptionRootAppletDesignVersionStatusByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAppletDesignVersionStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletDesignVersionStatusStreamCursorInput>>;
  where?: Maybe<AppletDesignVersionStatusBoolExp>;
};


export type SubscriptionRootAppletDesignVersionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletDesignVersionStreamCursorInput>>;
  where?: Maybe<AppletDesignVersionBoolExp>;
};


export type SubscriptionRootAppletRegistrationCodeArgs = {
  distinct_on?: Maybe<Array<AppletRegistrationCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRegistrationCodeOrderBy>>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};


export type SubscriptionRootAppletRegistrationCodeAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRegistrationCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRegistrationCodeOrderBy>>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};


export type SubscriptionRootAppletRegistrationCodeByPkArgs = {
  context_id: Scalars['uuid'];
  created_by_id: Scalars['uuid'];
};


export type SubscriptionRootAppletRegistrationCodeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletRegistrationCodeStreamCursorInput>>;
  where?: Maybe<AppletRegistrationCodeBoolExp>;
};


export type SubscriptionRootAppletRunnerArgs = {
  distinct_on?: Maybe<Array<AppletRunnerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerOrderBy>>;
  where?: Maybe<AppletRunnerBoolExp>;
};


export type SubscriptionRootAppletRunnerAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRunnerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerOrderBy>>;
  where?: Maybe<AppletRunnerBoolExp>;
};


export type SubscriptionRootAppletRunnerByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootAppletRunnerContextArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


export type SubscriptionRootAppletRunnerContextAggregateArgs = {
  distinct_on?: Maybe<Array<AppletRunnerContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AppletRunnerContextOrderBy>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


export type SubscriptionRootAppletRunnerContextByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootAppletRunnerContextStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletRunnerContextStreamCursorInput>>;
  where?: Maybe<AppletRunnerContextBoolExp>;
};


export type SubscriptionRootAppletRunnerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AppletRunnerStreamCursorInput>>;
  where?: Maybe<AppletRunnerBoolExp>;
};


export type SubscriptionRootArgoAclArgs = {
  distinct_on?: Maybe<Array<ArgoAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAclOrderBy>>;
  where?: Maybe<ArgoAclBoolExp>;
};


export type SubscriptionRootArgoAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAclOrderBy>>;
  where?: Maybe<ArgoAclBoolExp>;
};


export type SubscriptionRootArgoAclByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootArgoAclStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAclStreamCursorInput>>;
  where?: Maybe<ArgoAclBoolExp>;
};


export type SubscriptionRootArgoAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


export type SubscriptionRootArgoAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeOrderBy>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


export type SubscriptionRootArgoAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAttributeDataArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


export type SubscriptionRootArgoAttributeDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeDataOrderBy>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


export type SubscriptionRootArgoAttributeDataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAttributeDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeDataStreamCursorInput>>;
  where?: Maybe<ArgoAttributeDataBoolExp>;
};


export type SubscriptionRootArgoAttributeHistoryStatusTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeHistoryStatusTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeHistoryStatusTypeOrderBy>>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeHistoryStatusTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeHistoryStatusTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeHistoryStatusTypeOrderBy>>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeHistoryStatusTypeByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoAttributeHistoryStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeHistoryStatusTypeStreamCursorInput>>;
  where?: Maybe<ArgoAttributeHistoryStatusTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAttributeSchemaDefinitionArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaDefinitionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaDefinitionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAttributeSchemaDefinitionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeSchemaDefinitionStreamCursorInput>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaDefinitionTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaDefinitionTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaDefinitionTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaDefinitionTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootArgoAttributeSchemaDefinitionTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeSchemaDefinitionTypeStreamCursorInput>>;
  where?: Maybe<ArgoAttributeSchemaDefinitionTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeSchemaStreamCursorInput>>;
  where?: Maybe<ArgoAttributeSchemaBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaTypeArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAttributeSchemaTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAttributeSchemaTypeOrderBy>>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeSchemaTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootArgoAttributeSchemaTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeSchemaTypeStreamCursorInput>>;
  where?: Maybe<ArgoAttributeSchemaTypeBoolExp>;
};


export type SubscriptionRootArgoAttributeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAttributeStreamCursorInput>>;
  where?: Maybe<ArgoAttributeBoolExp>;
};


export type SubscriptionRootArgoAuditArgs = {
  distinct_on?: Maybe<Array<ArgoAuditSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuditOrderBy>>;
  where?: Maybe<ArgoAuditBoolExp>;
};


export type SubscriptionRootArgoAuditAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuditSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuditOrderBy>>;
  where?: Maybe<ArgoAuditBoolExp>;
};


export type SubscriptionRootArgoAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuditStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuditStreamCursorInput>>;
  where?: Maybe<ArgoAuditBoolExp>;
};


export type SubscriptionRootArgoAuthProviderArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderOrderBy>>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};


export type SubscriptionRootArgoAuthProviderAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderOrderBy>>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};


export type SubscriptionRootArgoAuthProviderByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootArgoAuthProviderLocalArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderLocalAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderLocalByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthProviderLocalSettingArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderLocalSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderLocalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderLocalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderLocalSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthProviderLocalSettingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderLocalSettingStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderLocalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderLocalStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderLocalStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderLocalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthProviderMsalSettingArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderMsalSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderMsalSettingOrderBy>>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthProviderMsalSettingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderMsalSettingStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderMsalSettingBoolExp>;
};


export type SubscriptionRootArgoAuthProviderMsalStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderMsalStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderMsalBoolExp>;
};


export type SubscriptionRootArgoAuthProviderRecordArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


export type SubscriptionRootArgoAuthProviderRecordAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthProviderRecordSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthProviderRecordOrderBy>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


export type SubscriptionRootArgoAuthProviderRecordByPkArgs = {
  auth_provider_record_id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthProviderRecordStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderRecordStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderRecordBoolExp>;
};


export type SubscriptionRootArgoAuthProviderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthProviderStreamCursorInput>>;
  where?: Maybe<ArgoAuthProviderBoolExp>;
};


export type SubscriptionRootArgoAuthRefreshTokenArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


export type SubscriptionRootArgoAuthRefreshTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoAuthRefreshTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoAuthRefreshTokenOrderBy>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


export type SubscriptionRootArgoAuthRefreshTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoAuthRefreshTokenStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoAuthRefreshTokenStreamCursorInput>>;
  where?: Maybe<ArgoAuthRefreshTokenBoolExp>;
};


export type SubscriptionRootArgoCalendarArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type SubscriptionRootArgoCalendarAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type SubscriptionRootArgoCalendarByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarCurrentAndNextArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarCurrentAndNextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarCurrentAndNextOrderBy>>;
  where?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
};


export type SubscriptionRootArgoCalendarCurrentAndNextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarCurrentAndNextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarCurrentAndNextOrderBy>>;
  where?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
};


export type SubscriptionRootArgoCalendarCurrentAndNextStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarCurrentAndNextStreamCursorInput>>;
  where?: Maybe<ArgoCalendarCurrentAndNextBoolExp>;
};


export type SubscriptionRootArgoCalendarEventArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


export type SubscriptionRootArgoCalendarEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventOrderBy>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


export type SubscriptionRootArgoCalendarEventByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarEventSequenceArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSequenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventSequenceOrderBy>>;
  where?: Maybe<ArgoCalendarEventSequenceBoolExp>;
};


export type SubscriptionRootArgoCalendarEventSequenceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventSequenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventSequenceOrderBy>>;
  where?: Maybe<ArgoCalendarEventSequenceBoolExp>;
};


export type SubscriptionRootArgoCalendarEventSequenceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarEventSequenceStreamCursorInput>>;
  where?: Maybe<ArgoCalendarEventSequenceBoolExp>;
};


export type SubscriptionRootArgoCalendarEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarEventStreamCursorInput>>;
  where?: Maybe<ArgoCalendarEventBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarEventUdfDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarEventUdfDataStreamCursorInput>>;
  where?: Maybe<ArgoCalendarEventUdfDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarEventUdfDefaultDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarEventUdfDefaultDataStreamCursorInput>>;
  where?: Maybe<ArgoCalendarEventUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarEventUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarEventUdfSchemaOrderBy>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoCalendarEventUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarEventUdfSchemaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarEventUdfSchemaStreamCursorInput>>;
  where?: Maybe<ArgoCalendarEventUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoCalendarLocationArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


export type SubscriptionRootArgoCalendarLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCalendarLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarLocationOrderBy>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


export type SubscriptionRootArgoCalendarLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoCalendarLocationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarLocationStreamCursorInput>>;
  where?: Maybe<ArgoCalendarLocationBoolExp>;
};


export type SubscriptionRootArgoCalendarStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCalendarStreamCursorInput>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type SubscriptionRootArgoConnectionArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionOrderBy>>;
  where?: Maybe<ArgoConnectionBoolExp>;
};


export type SubscriptionRootArgoConnectionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionOrderBy>>;
  where?: Maybe<ArgoConnectionBoolExp>;
};


export type SubscriptionRootArgoConnectionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoConnectionConfigArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


export type SubscriptionRootArgoConnectionConfigAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigOrderBy>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


export type SubscriptionRootArgoConnectionConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoConnectionConfigStatusArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigStatusOrderBy>>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};


export type SubscriptionRootArgoConnectionConfigStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionConfigStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionConfigStatusOrderBy>>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};


export type SubscriptionRootArgoConnectionConfigStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoConnectionConfigStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoConnectionConfigStatusStreamCursorInput>>;
  where?: Maybe<ArgoConnectionConfigStatusBoolExp>;
};


export type SubscriptionRootArgoConnectionConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoConnectionConfigStreamCursorInput>>;
  where?: Maybe<ArgoConnectionConfigBoolExp>;
};


export type SubscriptionRootArgoConnectionKindArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionKindOrderBy>>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};


export type SubscriptionRootArgoConnectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoConnectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoConnectionKindOrderBy>>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};


export type SubscriptionRootArgoConnectionKindByPkArgs = {
  kind: Scalars['String'];
};


export type SubscriptionRootArgoConnectionKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoConnectionKindStreamCursorInput>>;
  where?: Maybe<ArgoConnectionKindBoolExp>;
};


export type SubscriptionRootArgoConnectionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoConnectionStreamCursorInput>>;
  where?: Maybe<ArgoConnectionBoolExp>;
};


export type SubscriptionRootArgoContextArgs = {
  distinct_on?: Maybe<Array<ArgoContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoContextOrderBy>>;
  where?: Maybe<ArgoContextBoolExp>;
};


export type SubscriptionRootArgoContextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoContextOrderBy>>;
  where?: Maybe<ArgoContextBoolExp>;
};


export type SubscriptionRootArgoContextByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoContextStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoContextStreamCursorInput>>;
  where?: Maybe<ArgoContextBoolExp>;
};


export type SubscriptionRootArgoCronTaskArgs = {
  distinct_on?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCronTaskOrderBy>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


export type SubscriptionRootArgoCronTaskAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoCronTaskSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCronTaskOrderBy>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


export type SubscriptionRootArgoCronTaskByPkArgs = {
  cron_name: Scalars['String'];
};


export type SubscriptionRootArgoCronTaskStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoCronTaskStreamCursorInput>>;
  where?: Maybe<ArgoCronTaskBoolExp>;
};


export type SubscriptionRootArgoEventArgs = {
  distinct_on?: Maybe<Array<ArgoEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventOrderBy>>;
  where?: Maybe<ArgoEventBoolExp>;
};


export type SubscriptionRootArgoEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventOrderBy>>;
  where?: Maybe<ArgoEventBoolExp>;
};


export type SubscriptionRootArgoEventByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoEventStreamCursorInput>>;
  where?: Maybe<ArgoEventBoolExp>;
};


export type SubscriptionRootArgoEventTypeArgs = {
  distinct_on?: Maybe<Array<ArgoEventTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventTypeOrderBy>>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};


export type SubscriptionRootArgoEventTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoEventTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoEventTypeOrderBy>>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};


export type SubscriptionRootArgoEventTypeByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootArgoEventTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoEventTypeStreamCursorInput>>;
  where?: Maybe<ArgoEventTypeBoolExp>;
};


export type SubscriptionRootArgoHasuraPermissionArgs = {
  distinct_on?: Maybe<Array<ArgoHasuraPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoHasuraPermissionOrderBy>>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};


export type SubscriptionRootArgoHasuraPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoHasuraPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoHasuraPermissionOrderBy>>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};


export type SubscriptionRootArgoHasuraPermissionByPkArgs = {
  name: Scalars['String'];
};


export type SubscriptionRootArgoHasuraPermissionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoHasuraPermissionStreamCursorInput>>;
  where?: Maybe<ArgoHasuraPermissionBoolExp>;
};


export type SubscriptionRootArgoLinkArgs = {
  distinct_on?: Maybe<Array<ArgoLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLinkOrderBy>>;
  where?: Maybe<ArgoLinkBoolExp>;
};


export type SubscriptionRootArgoLinkAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLinkOrderBy>>;
  where?: Maybe<ArgoLinkBoolExp>;
};


export type SubscriptionRootArgoLinkByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoLinkStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLinkStreamCursorInput>>;
  where?: Maybe<ArgoLinkBoolExp>;
};


export type SubscriptionRootArgoLocationArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


export type SubscriptionRootArgoLocationActiveCalendarArgs = {
  args: ArgoLocationActiveCalendarArgs;
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type SubscriptionRootArgoLocationActiveCalendarAggregateArgs = {
  args: ArgoLocationActiveCalendarArgs;
  distinct_on?: Maybe<Array<ArgoCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoCalendarOrderBy>>;
  where?: Maybe<ArgoCalendarBoolExp>;
};


export type SubscriptionRootArgoLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationOrderBy>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeOrderBy>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoLocationAttributeHistoryArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoLocationAttributeHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLocationAttributeHistoryStreamCursorInput>>;
  where?: Maybe<ArgoLocationAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoLocationAttributeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLocationAttributeStreamCursorInput>>;
  where?: Maybe<ArgoLocationAttributeBoolExp>;
};


export type SubscriptionRootArgoLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoLocationClassArgs = {
  distinct_on?: Maybe<Array<ArgoLocationClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationClassOrderBy>>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};


export type SubscriptionRootArgoLocationClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLocationClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLocationClassOrderBy>>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};


export type SubscriptionRootArgoLocationClassByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoLocationClassStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLocationClassStreamCursorInput>>;
  where?: Maybe<ArgoLocationClassBoolExp>;
};


export type SubscriptionRootArgoLocationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLocationStreamCursorInput>>;
  where?: Maybe<ArgoLocationBoolExp>;
};


export type SubscriptionRootArgoLogArgs = {
  distinct_on?: Maybe<Array<ArgoLogSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogOrderBy>>;
  where?: Maybe<ArgoLogBoolExp>;
};


export type SubscriptionRootArgoLogAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogOrderBy>>;
  where?: Maybe<ArgoLogBoolExp>;
};


export type SubscriptionRootArgoLogByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootArgoLogCategoryArgs = {
  distinct_on?: Maybe<Array<ArgoLogCategorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogCategoryOrderBy>>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};


export type SubscriptionRootArgoLogCategoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogCategorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogCategoryOrderBy>>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};


export type SubscriptionRootArgoLogCategoryByPkArgs = {
  category: Scalars['String'];
};


export type SubscriptionRootArgoLogCategoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLogCategoryStreamCursorInput>>;
  where?: Maybe<ArgoLogCategoryBoolExp>;
};


export type SubscriptionRootArgoLogDurationArgs = {
  distinct_on?: Maybe<Array<ArgoLogDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogDurationOrderBy>>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};


export type SubscriptionRootArgoLogDurationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogDurationOrderBy>>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};


export type SubscriptionRootArgoLogDurationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLogDurationStreamCursorInput>>;
  where?: Maybe<ArgoLogDurationBoolExp>;
};


export type SubscriptionRootArgoLogLevelArgs = {
  distinct_on?: Maybe<Array<ArgoLogLevelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogLevelOrderBy>>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};


export type SubscriptionRootArgoLogLevelAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoLogLevelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoLogLevelOrderBy>>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};


export type SubscriptionRootArgoLogLevelByPkArgs = {
  level: Scalars['String'];
};


export type SubscriptionRootArgoLogLevelStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLogLevelStreamCursorInput>>;
  where?: Maybe<ArgoLogLevelBoolExp>;
};


export type SubscriptionRootArgoLogStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoLogStreamCursorInput>>;
  where?: Maybe<ArgoLogBoolExp>;
};


export type SubscriptionRootArgoMaterialArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityOrderBy>>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityOrderBy>>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityByPkArgs = {
  material_activity_id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialActivityKindArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityKindOrderBy>>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialActivityKindOrderBy>>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityKindByPkArgs = {
  kind: Scalars['String'];
};


export type SubscriptionRootArgoMaterialActivityKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialActivityKindStreamCursorInput>>;
  where?: Maybe<ArgoMaterialActivityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialActivityStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialActivityStreamCursorInput>>;
  where?: Maybe<ArgoMaterialActivityBoolExp>;
};


export type SubscriptionRootArgoMaterialAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialOrderBy>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


export type SubscriptionRootArgoMaterialAssemblyArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type SubscriptionRootArgoMaterialAssemblyAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type SubscriptionRootArgoMaterialAssemblyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialAssemblyStreamCursorInput>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialAttributeHistoryArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialAttributeHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAttributeHistoryOrderBy>>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeHistoryByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialAttributeHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialAttributeHistoryStreamCursorInput>>;
  where?: Maybe<ArgoMaterialAttributeHistoryBoolExp>;
};


export type SubscriptionRootArgoMaterialAttributeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialAttributeStreamCursorInput>>;
  where?: Maybe<ArgoMaterialAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialClassArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassOrderBy>>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassOrderBy>>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialClassAttributeSettingArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialClassAttributeSettingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialClassAttributeSettingStreamCursorInput>>;
  where?: Maybe<ArgoMaterialClassAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialClassAttributeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialClassAttributeStreamCursorInput>>;
  where?: Maybe<ArgoMaterialClassAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialClassByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialClassProcessArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialClassProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialClassProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialClassProcessOrderBy>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialClassProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialClassProcessStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialClassProcessStreamCursorInput>>;
  where?: Maybe<ArgoMaterialClassProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialClassStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialClassStreamCursorInput>>;
  where?: Maybe<ArgoMaterialClassBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageByPkArgs = {
  material_marriage_id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialMarriageStatusArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageStatusOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialMarriageStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialMarriageStatusOrderBy>>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootArgoMaterialMarriageStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialMarriageStatusStreamCursorInput>>;
  where?: Maybe<ArgoMaterialMarriageStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialMarriageStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialMarriageStreamCursorInput>>;
  where?: Maybe<ArgoMaterialMarriageBoolExp>;
};


export type SubscriptionRootArgoMaterialModelArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelOrderBy>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialModelAttributeSettingArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeSettingAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelAttributeSettingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelAttributeSettingOrderBy>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeSettingByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialModelAttributeSettingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialModelAttributeSettingStreamCursorInput>>;
  where?: Maybe<ArgoMaterialModelAttributeSettingBoolExp>;
};


export type SubscriptionRootArgoMaterialModelAttributeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialModelAttributeStreamCursorInput>>;
  where?: Maybe<ArgoMaterialModelAttributeBoolExp>;
};


export type SubscriptionRootArgoMaterialModelByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialModelProcessArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialModelProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialModelProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialModelProcessOrderBy>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialModelProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialModelProcessStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialModelProcessStreamCursorInput>>;
  where?: Maybe<ArgoMaterialModelProcessBoolExp>;
};


export type SubscriptionRootArgoMaterialModelStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialModelStreamCursorInput>>;
  where?: Maybe<ArgoMaterialModelBoolExp>;
};


export type SubscriptionRootArgoMaterialQuantityKindArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialQuantityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialQuantityKindOrderBy>>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialQuantityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialQuantityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialQuantityKindOrderBy>>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialQuantityKindByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootArgoMaterialQuantityKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialQuantityKindStreamCursorInput>>;
  where?: Maybe<ArgoMaterialQuantityKindBoolExp>;
};


export type SubscriptionRootArgoMaterialStatusArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialStatusOrderBy>>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialStatusOrderBy>>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoMaterialStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialStatusStreamCursorInput>>;
  where?: Maybe<ArgoMaterialStatusBoolExp>;
};


export type SubscriptionRootArgoMaterialStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialStreamCursorInput>>;
  where?: Maybe<ArgoMaterialBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialUdfDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialUdfDataStreamCursorInput>>;
  where?: Maybe<ArgoMaterialUdfDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDefaultDataArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDefaultDataAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfDefaultDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfDefaultDataOrderBy>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfDefaultDataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialUdfDefaultDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialUdfDefaultDataStreamCursorInput>>;
  where?: Maybe<ArgoMaterialUdfDefaultDataBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfSchemaArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfSchemaAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMaterialUdfSchemaSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialUdfSchemaOrderBy>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoMaterialUdfSchemaByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMaterialUdfSchemaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMaterialUdfSchemaStreamCursorInput>>;
  where?: Maybe<ArgoMaterialUdfSchemaBoolExp>;
};


export type SubscriptionRootArgoMediaConfigArgs = {
  distinct_on?: Maybe<Array<ArgoMediaConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaConfigOrderBy>>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};


export type SubscriptionRootArgoMediaConfigAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMediaConfigSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaConfigOrderBy>>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};


export type SubscriptionRootArgoMediaConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMediaConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMediaConfigStreamCursorInput>>;
  where?: Maybe<ArgoMediaConfigBoolExp>;
};


export type SubscriptionRootArgoMediaInstanceArgs = {
  distinct_on?: Maybe<Array<ArgoMediaInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaInstanceOrderBy>>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};


export type SubscriptionRootArgoMediaInstanceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoMediaInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMediaInstanceOrderBy>>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};


export type SubscriptionRootArgoMediaInstanceByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoMediaInstanceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoMediaInstanceStreamCursorInput>>;
  where?: Maybe<ArgoMediaInstanceBoolExp>;
};


export type SubscriptionRootArgoPgTimezoneNamesArgs = {
  distinct_on?: Maybe<Array<ArgoPgTimezoneNamesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoPgTimezoneNamesOrderBy>>;
  where?: Maybe<ArgoPgTimezoneNamesBoolExp>;
};


export type SubscriptionRootArgoPgTimezoneNamesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoPgTimezoneNamesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoPgTimezoneNamesOrderBy>>;
  where?: Maybe<ArgoPgTimezoneNamesBoolExp>;
};


export type SubscriptionRootArgoPgTimezoneNamesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoPgTimezoneNamesStreamCursorInput>>;
  where?: Maybe<ArgoPgTimezoneNamesBoolExp>;
};


export type SubscriptionRootArgoRoleArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


export type SubscriptionRootArgoRoleAclArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


export type SubscriptionRootArgoRoleAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleAclOrderBy>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


export type SubscriptionRootArgoRoleAclByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoRoleAclStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoRoleAclStreamCursorInput>>;
  where?: Maybe<ArgoRoleAclBoolExp>;
};


export type SubscriptionRootArgoRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoRoleOrderBy>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


export type SubscriptionRootArgoRoleByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoRoleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoRoleStreamCursorInput>>;
  where?: Maybe<ArgoRoleBoolExp>;
};


export type SubscriptionRootArgoScheduleArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


export type SubscriptionRootArgoScheduleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleOrderBy>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


export type SubscriptionRootArgoScheduleByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoScheduleDayArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleDaySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleDayOrderBy>>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};


export type SubscriptionRootArgoScheduleDayAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleDaySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleDayOrderBy>>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};


export type SubscriptionRootArgoScheduleDayByPkArgs = {
  day: Scalars['String'];
};


export type SubscriptionRootArgoScheduleDayStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoScheduleDayStreamCursorInput>>;
  where?: Maybe<ArgoScheduleDayBoolExp>;
};


export type SubscriptionRootArgoScheduleEventArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


export type SubscriptionRootArgoScheduleEventAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleEventOrderBy>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


export type SubscriptionRootArgoScheduleEventByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoScheduleEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoScheduleEventStreamCursorInput>>;
  where?: Maybe<ArgoScheduleEventBoolExp>;
};


export type SubscriptionRootArgoScheduleModeArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleModeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleModeOrderBy>>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};


export type SubscriptionRootArgoScheduleModeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoScheduleModeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoScheduleModeOrderBy>>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};


export type SubscriptionRootArgoScheduleModeByPkArgs = {
  mode: Scalars['String'];
};


export type SubscriptionRootArgoScheduleModeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoScheduleModeStreamCursorInput>>;
  where?: Maybe<ArgoScheduleModeBoolExp>;
};


export type SubscriptionRootArgoScheduleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoScheduleStreamCursorInput>>;
  where?: Maybe<ArgoScheduleBoolExp>;
};


export type SubscriptionRootArgoSnArgs = {
  distinct_on?: Maybe<Array<ArgoSnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnOrderBy>>;
  where?: Maybe<ArgoSnBoolExp>;
};


export type SubscriptionRootArgoSnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnOrderBy>>;
  where?: Maybe<ArgoSnBoolExp>;
};


export type SubscriptionRootArgoSnByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['bigint'];
};


export type SubscriptionRootArgoSnFormatArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


export type SubscriptionRootArgoSnFormatAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatOrderBy>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


export type SubscriptionRootArgoSnFormatByPkArgs = {
  context_id: Scalars['uuid'];
  id: Scalars['Int'];
};


export type SubscriptionRootArgoSnFormatStatusArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatStatusOrderBy>>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};


export type SubscriptionRootArgoSnFormatStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatStatusOrderBy>>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};


export type SubscriptionRootArgoSnFormatStatusByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootArgoSnFormatStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoSnFormatStatusStreamCursorInput>>;
  where?: Maybe<ArgoSnFormatStatusBoolExp>;
};


export type SubscriptionRootArgoSnFormatStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoSnFormatStreamCursorInput>>;
  where?: Maybe<ArgoSnFormatBoolExp>;
};


export type SubscriptionRootArgoSnFormatUniquenessArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatUniquenessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatUniquenessOrderBy>>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};


export type SubscriptionRootArgoSnFormatUniquenessAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoSnFormatUniquenessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoSnFormatUniquenessOrderBy>>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};


export type SubscriptionRootArgoSnFormatUniquenessByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootArgoSnFormatUniquenessStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoSnFormatUniquenessStreamCursorInput>>;
  where?: Maybe<ArgoSnFormatUniquenessBoolExp>;
};


export type SubscriptionRootArgoSnStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoSnStreamCursorInput>>;
  where?: Maybe<ArgoSnBoolExp>;
};


export type SubscriptionRootArgoTraverseAssembliesArgs = {
  args: ArgoTraverseAssembliesArgs;
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type SubscriptionRootArgoTraverseAssembliesAggregateArgs = {
  args: ArgoTraverseAssembliesArgs;
  distinct_on?: Maybe<Array<ArgoMaterialAssemblySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoMaterialAssemblyOrderBy>>;
  where?: Maybe<ArgoMaterialAssemblyBoolExp>;
};


export type SubscriptionRootArgoUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


export type SubscriptionRootArgoUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnOrderBy>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


export type SubscriptionRootArgoUdfColumnByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUdfColumnDataTypeArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnDataTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};


export type SubscriptionRootArgoUdfColumnDataTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnDataTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};


export type SubscriptionRootArgoUdfColumnDataTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootArgoUdfColumnDataTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUdfColumnDataTypeStreamCursorInput>>;
  where?: Maybe<ArgoUdfColumnDataTypeBoolExp>;
};


export type SubscriptionRootArgoUdfColumnStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUdfColumnStreamCursorInput>>;
  where?: Maybe<ArgoUdfColumnBoolExp>;
};


export type SubscriptionRootArgoUdfColumnTypeArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};


export type SubscriptionRootArgoUdfColumnTypeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUdfColumnTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUdfColumnTypeOrderBy>>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};


export type SubscriptionRootArgoUdfColumnTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootArgoUdfColumnTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUdfColumnTypeStreamCursorInput>>;
  where?: Maybe<ArgoUdfColumnTypeBoolExp>;
};


export type SubscriptionRootArgoUomArgs = {
  distinct_on?: Maybe<Array<ArgoUomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUomOrderBy>>;
  where?: Maybe<ArgoUomBoolExp>;
};


export type SubscriptionRootArgoUomAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUomOrderBy>>;
  where?: Maybe<ArgoUomBoolExp>;
};


export type SubscriptionRootArgoUomByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootArgoUomStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUomStreamCursorInput>>;
  where?: Maybe<ArgoUomBoolExp>;
};


export type SubscriptionRootArgoUserArgs = {
  distinct_on?: Maybe<Array<ArgoUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserOrderBy>>;
  where?: Maybe<ArgoUserBoolExp>;
};


export type SubscriptionRootArgoUserAccessTokenArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoUserAccessTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoUserAccessTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUserAccessTokenStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUserAccessTokenStreamCursorInput>>;
  where?: Maybe<ArgoUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoUserAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserOrderBy>>;
  where?: Maybe<ArgoUserBoolExp>;
};


export type SubscriptionRootArgoUserBadgeArgs = {
  distinct_on?: Maybe<Array<ArgoUserBadgeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserBadgeOrderBy>>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};


export type SubscriptionRootArgoUserBadgeAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserBadgeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserBadgeOrderBy>>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};


export type SubscriptionRootArgoUserBadgeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUserBadgeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUserBadgeStreamCursorInput>>;
  where?: Maybe<ArgoUserBadgeBoolExp>;
};


export type SubscriptionRootArgoUserByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUserContextArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


export type SubscriptionRootArgoUserContextAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserContextSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserContextOrderBy>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


export type SubscriptionRootArgoUserContextByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUserContextStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUserContextStreamCursorInput>>;
  where?: Maybe<ArgoUserContextBoolExp>;
};


export type SubscriptionRootArgoUserRoleArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


export type SubscriptionRootArgoUserRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoUserRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoUserRoleOrderBy>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


export type SubscriptionRootArgoUserRoleByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoUserRoleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUserRoleStreamCursorInput>>;
  where?: Maybe<ArgoUserRoleBoolExp>;
};


export type SubscriptionRootArgoUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoUserStreamCursorInput>>;
  where?: Maybe<ArgoUserBoolExp>;
};


export type SubscriptionRootArgoVwAclRoleArgs = {
  distinct_on?: Maybe<Array<ArgoVwAclRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAclRoleOrderBy>>;
  where?: Maybe<ArgoVwAclRoleBoolExp>;
};


export type SubscriptionRootArgoVwAclRoleAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwAclRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAclRoleOrderBy>>;
  where?: Maybe<ArgoVwAclRoleBoolExp>;
};


export type SubscriptionRootArgoVwAclRoleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwAclRoleStreamCursorInput>>;
  where?: Maybe<ArgoVwAclRoleBoolExp>;
};


export type SubscriptionRootArgoVwActiveLocationCalendarArgs = {
  distinct_on?: Maybe<Array<ArgoVwActiveLocationCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwActiveLocationCalendarOrderBy>>;
  where?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
};


export type SubscriptionRootArgoVwActiveLocationCalendarAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwActiveLocationCalendarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwActiveLocationCalendarOrderBy>>;
  where?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
};


export type SubscriptionRootArgoVwActiveLocationCalendarStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwActiveLocationCalendarStreamCursorInput>>;
  where?: Maybe<ArgoVwActiveLocationCalendarBoolExp>;
};


export type SubscriptionRootArgoVwAuthUserAccessTokenArgs = {
  distinct_on?: Maybe<Array<ArgoVwAuthUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAuthUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoVwAuthUserAccessTokenAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwAuthUserAccessTokenSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwAuthUserAccessTokenOrderBy>>;
  where?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoVwAuthUserAccessTokenStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwAuthUserAccessTokenStreamCursorInput>>;
  where?: Maybe<ArgoVwAuthUserAccessTokenBoolExp>;
};


export type SubscriptionRootArgoVwEventTypeUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoVwEventTypeUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwEventTypeUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwEventTypeUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwEventTypeUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwEventTypeUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwEventTypeUdfColumnStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwEventTypeUdfColumnStreamCursorInput>>;
  where?: Maybe<ArgoVwEventTypeUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwLocationHierarchyArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


export type SubscriptionRootArgoVwLocationHierarchyAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwLocationHierarchySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwLocationHierarchyOrderBy>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


export type SubscriptionRootArgoVwLocationHierarchyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwLocationHierarchyStreamCursorInput>>;
  where?: Maybe<ArgoVwLocationHierarchyBoolExp>;
};


export type SubscriptionRootArgoVwMaterialByClassArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


export type SubscriptionRootArgoVwMaterialByClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


export type SubscriptionRootArgoVwMaterialByClassStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwMaterialByClassStreamCursorInput>>;
  where?: Maybe<ArgoVwMaterialByClassBoolExp>;
};


export type SubscriptionRootArgoVwMaterialClassUdfColumnArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialClassUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialClassUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwMaterialClassUdfColumnAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialClassUdfColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialClassUdfColumnOrderBy>>;
  where?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwMaterialClassUdfColumnStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwMaterialClassUdfColumnStreamCursorInput>>;
  where?: Maybe<ArgoVwMaterialClassUdfColumnBoolExp>;
};


export type SubscriptionRootArgoVwMaterialModelProcessesByClassArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


export type SubscriptionRootArgoVwMaterialModelProcessesByClassAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwMaterialModelProcessesByClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwMaterialModelProcessesByClassOrderBy>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


export type SubscriptionRootArgoVwMaterialModelProcessesByClassStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwMaterialModelProcessesByClassStreamCursorInput>>;
  where?: Maybe<ArgoVwMaterialModelProcessesByClassBoolExp>;
};


export type SubscriptionRootArgoVwRoleAclArgs = {
  distinct_on?: Maybe<Array<ArgoVwRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwRoleAclOrderBy>>;
  where?: Maybe<ArgoVwRoleAclBoolExp>;
};


export type SubscriptionRootArgoVwRoleAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwRoleAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwRoleAclOrderBy>>;
  where?: Maybe<ArgoVwRoleAclBoolExp>;
};


export type SubscriptionRootArgoVwRoleAclStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwRoleAclStreamCursorInput>>;
  where?: Maybe<ArgoVwRoleAclBoolExp>;
};


export type SubscriptionRootArgoVwTimestamptzArgs = {
  distinct_on?: Maybe<Array<ArgoVwTimestamptzSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwTimestamptzOrderBy>>;
  where?: Maybe<ArgoVwTimestamptzBoolExp>;
};


export type SubscriptionRootArgoVwTimestamptzAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwTimestamptzSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwTimestamptzOrderBy>>;
  where?: Maybe<ArgoVwTimestamptzBoolExp>;
};


export type SubscriptionRootArgoVwTimestamptzStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwTimestamptzStreamCursorInput>>;
  where?: Maybe<ArgoVwTimestamptzBoolExp>;
};


export type SubscriptionRootArgoVwUserAclsArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserAclsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserAclsOrderBy>>;
  where?: Maybe<ArgoVwUserAclsBoolExp>;
};


export type SubscriptionRootArgoVwUserAclsAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserAclsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserAclsOrderBy>>;
  where?: Maybe<ArgoVwUserAclsBoolExp>;
};


export type SubscriptionRootArgoVwUserAclsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwUserAclsStreamCursorInput>>;
  where?: Maybe<ArgoVwUserAclsBoolExp>;
};


export type SubscriptionRootArgoVwUserContextAclArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


export type SubscriptionRootArgoVwUserContextAclAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserContextAclSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserContextAclOrderBy>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


export type SubscriptionRootArgoVwUserContextAclStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwUserContextAclStreamCursorInput>>;
  where?: Maybe<ArgoVwUserContextAclBoolExp>;
};


export type SubscriptionRootArgoVwUserRolesArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


export type SubscriptionRootArgoVwUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoVwUserRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoVwUserRolesOrderBy>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


export type SubscriptionRootArgoVwUserRolesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoVwUserRolesStreamCursorInput>>;
  where?: Maybe<ArgoVwUserRolesBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkInstructionInstanceArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkInstructionInstanceStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoWorkInstructionInstanceStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionInstanceStatusStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionInstanceStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStepArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStepAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionInstanceStepSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionInstanceStepOrderBy>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStepByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkInstructionInstanceStepStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionInstanceStepStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionInstanceStepBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionInstanceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionInstanceStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionInstanceBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkInstructionVersionStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkInstructionVersionStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkInstructionVersionStatusOrderBy>>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoWorkInstructionVersionStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionVersionStatusStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionVersionStatusBoolExp>;
};


export type SubscriptionRootArgoWorkInstructionVersionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkInstructionVersionStreamCursorInput>>;
  where?: Maybe<ArgoWorkInstructionVersionBoolExp>;
};


export type SubscriptionRootArgoWorkOrderArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderOrderBy>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkOrderActivityKindArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityKindOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityKindAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderActivityKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderActivityKindOrderBy>>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityKindByPkArgs = {
  kind: Scalars['String'];
};


export type SubscriptionRootArgoWorkOrderActivityKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderActivityKindStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderActivityKindBoolExp>;
};


export type SubscriptionRootArgoWorkOrderActivityStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderActivityStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderActivityBoolExp>;
};


export type SubscriptionRootArgoWorkOrderAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderOrderBy>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


export type SubscriptionRootArgoWorkOrderByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkOrderLocationArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


export type SubscriptionRootArgoWorkOrderLocationAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderLocationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderLocationOrderBy>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


export type SubscriptionRootArgoWorkOrderLocationByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkOrderLocationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderLocationStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderLocationBoolExp>;
};


export type SubscriptionRootArgoWorkOrderMaterialArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


export type SubscriptionRootArgoWorkOrderMaterialAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderMaterialSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderMaterialOrderBy>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


export type SubscriptionRootArgoWorkOrderMaterialByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootArgoWorkOrderMaterialStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderMaterialStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderMaterialBoolExp>;
};


export type SubscriptionRootArgoWorkOrderRestrictionArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderRestrictionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderRestrictionOrderBy>>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};


export type SubscriptionRootArgoWorkOrderRestrictionAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderRestrictionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderRestrictionOrderBy>>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};


export type SubscriptionRootArgoWorkOrderRestrictionByPkArgs = {
  restriction: Scalars['String'];
};


export type SubscriptionRootArgoWorkOrderRestrictionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderRestrictionStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderRestrictionBoolExp>;
};


export type SubscriptionRootArgoWorkOrderStatusArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderStatusOrderBy>>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};


export type SubscriptionRootArgoWorkOrderStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ArgoWorkOrderStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ArgoWorkOrderStatusOrderBy>>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};


export type SubscriptionRootArgoWorkOrderStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootArgoWorkOrderStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderStatusStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderStatusBoolExp>;
};


export type SubscriptionRootArgoWorkOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ArgoWorkOrderStreamCursorInput>>;
  where?: Maybe<ArgoWorkOrderBoolExp>;
};


export type SubscriptionRootFisAssetArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


export type SubscriptionRootFisAssetAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetOrderBy>>;
  where?: Maybe<FisAssetBoolExp>;
};


export type SubscriptionRootFisAssetByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisAssetCodeArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


export type SubscriptionRootFisAssetCodeAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetCodeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetCodeOrderBy>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


export type SubscriptionRootFisAssetCodeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisAssetCodeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisAssetCodeStreamCursorInput>>;
  where?: Maybe<FisAssetCodeBoolExp>;
};


export type SubscriptionRootFisAssetStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisAssetStreamCursorInput>>;
  where?: Maybe<FisAssetBoolExp>;
};


export type SubscriptionRootFisAssetTagArgs = {
  distinct_on?: Maybe<Array<FisAssetTagSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagOrderBy>>;
  where?: Maybe<FisAssetTagBoolExp>;
};


export type SubscriptionRootFisAssetTagAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTagSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagOrderBy>>;
  where?: Maybe<FisAssetTagBoolExp>;
};


export type SubscriptionRootFisAssetTagByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisAssetTagLinkArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


export type SubscriptionRootFisAssetTagLinkAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTagLinkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTagLinkOrderBy>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


export type SubscriptionRootFisAssetTagLinkByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisAssetTagLinkStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisAssetTagLinkStreamCursorInput>>;
  where?: Maybe<FisAssetTagLinkBoolExp>;
};


export type SubscriptionRootFisAssetTagStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisAssetTagStreamCursorInput>>;
  where?: Maybe<FisAssetTagBoolExp>;
};


export type SubscriptionRootFisAssetTypeArgs = {
  distinct_on?: Maybe<Array<FisAssetTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTypeOrderBy>>;
  where?: Maybe<FisAssetTypeBoolExp>;
};


export type SubscriptionRootFisAssetTypeAggregateArgs = {
  distinct_on?: Maybe<Array<FisAssetTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisAssetTypeOrderBy>>;
  where?: Maybe<FisAssetTypeBoolExp>;
};


export type SubscriptionRootFisAssetTypeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisAssetTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisAssetTypeStreamCursorInput>>;
  where?: Maybe<FisAssetTypeBoolExp>;
};


export type SubscriptionRootFisCoreStateArgs = {
  distinct_on?: Maybe<Array<FisCoreStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisCoreStateOrderBy>>;
  where?: Maybe<FisCoreStateBoolExp>;
};


export type SubscriptionRootFisCoreStateAggregateArgs = {
  distinct_on?: Maybe<Array<FisCoreStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisCoreStateOrderBy>>;
  where?: Maybe<FisCoreStateBoolExp>;
};


export type SubscriptionRootFisCoreStateByPkArgs = {
  state: Scalars['String'];
};


export type SubscriptionRootFisCoreStateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisCoreStateStreamCursorInput>>;
  where?: Maybe<FisCoreStateBoolExp>;
};


export type SubscriptionRootFisDataArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


export type SubscriptionRootFisDataAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataOrderBy>>;
  where?: Maybe<FisDataBoolExp>;
};


export type SubscriptionRootFisDataByPkArgs = {
  data_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type SubscriptionRootFisDataLabelArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


export type SubscriptionRootFisDataLabelAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataLabelSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataLabelOrderBy>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


export type SubscriptionRootFisDataLabelByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootFisDataLabelStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataLabelStreamCursorInput>>;
  where?: Maybe<FisDataLabelBoolExp>;
};


export type SubscriptionRootFisDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataStreamCursorInput>>;
  where?: Maybe<FisDataBoolExp>;
};


export type SubscriptionRootFisDataTimingArgs = {
  distinct_on?: Maybe<Array<FisDataTimingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTimingOrderBy>>;
  where?: Maybe<FisDataTimingBoolExp>;
};


export type SubscriptionRootFisDataTimingAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTimingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTimingOrderBy>>;
  where?: Maybe<FisDataTimingBoolExp>;
};


export type SubscriptionRootFisDataTimingByPkArgs = {
  timing: Scalars['String'];
};


export type SubscriptionRootFisDataTimingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataTimingStreamCursorInput>>;
  where?: Maybe<FisDataTimingBoolExp>;
};


export type SubscriptionRootFisDataTrackCountArgs = {
  distinct_on?: Maybe<Array<FisDataTrackCountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackCountOrderBy>>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};


export type SubscriptionRootFisDataTrackCountAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackCountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackCountOrderBy>>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};


export type SubscriptionRootFisDataTrackCountByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type SubscriptionRootFisDataTrackCountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataTrackCountStreamCursorInput>>;
  where?: Maybe<FisDataTrackCountBoolExp>;
};


export type SubscriptionRootFisDataTrackDurationArgs = {
  distinct_on?: Maybe<Array<FisDataTrackDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackDurationOrderBy>>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};


export type SubscriptionRootFisDataTrackDurationAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackDurationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackDurationOrderBy>>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};


export type SubscriptionRootFisDataTrackDurationByPkArgs = {
  asset_id: Scalars['uuid'];
  calendar_event_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  num_val: Scalars['float8'];
  shift_calendar_event_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type SubscriptionRootFisDataTrackDurationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataTrackDurationStreamCursorInput>>;
  where?: Maybe<FisDataTrackDurationBoolExp>;
};


export type SubscriptionRootFisDataTrackScalarArgs = {
  distinct_on?: Maybe<Array<FisDataTrackScalarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackScalarOrderBy>>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};


export type SubscriptionRootFisDataTrackScalarAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTrackScalarSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTrackScalarOrderBy>>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};


export type SubscriptionRootFisDataTrackScalarByPkArgs = {
  asset_id: Scalars['uuid'];
  data_label_id: Scalars['uuid'];
  time: Scalars['timestamp'];
};


export type SubscriptionRootFisDataTrackScalarStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataTrackScalarStreamCursorInput>>;
  where?: Maybe<FisDataTrackScalarBoolExp>;
};


export type SubscriptionRootFisDataTypeArgs = {
  distinct_on?: Maybe<Array<FisDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTypeOrderBy>>;
  where?: Maybe<FisDataTypeBoolExp>;
};


export type SubscriptionRootFisDataTypeAggregateArgs = {
  distinct_on?: Maybe<Array<FisDataTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisDataTypeOrderBy>>;
  where?: Maybe<FisDataTypeBoolExp>;
};


export type SubscriptionRootFisDataTypeByPkArgs = {
  type: Scalars['String'];
};


export type SubscriptionRootFisDataTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisDataTypeStreamCursorInput>>;
  where?: Maybe<FisDataTypeBoolExp>;
};


export type SubscriptionRootFisReportConstraintArgs = {
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type SubscriptionRootFisReportConstraintAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type SubscriptionRootFisReportConstraintStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportConstraintStreamCursorInput>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type SubscriptionRootFisReportDetailArgs = {
  distinct_on?: Maybe<Array<FisReportDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportDetailOrderBy>>;
  where?: Maybe<FisReportDetailBoolExp>;
};


export type SubscriptionRootFisReportDetailAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportDetailOrderBy>>;
  where?: Maybe<FisReportDetailBoolExp>;
};


export type SubscriptionRootFisReportDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportDetailStreamCursorInput>>;
  where?: Maybe<FisReportDetailBoolExp>;
};


export type SubscriptionRootFisReportMtbfArgs = {
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type SubscriptionRootFisReportMtbfAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type SubscriptionRootFisReportMtbfStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportMtbfStreamCursorInput>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type SubscriptionRootFisReportOeeArgs = {
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type SubscriptionRootFisReportOeeAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type SubscriptionRootFisReportOeeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportOeeStreamCursorInput>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type SubscriptionRootFisReportStateArgs = {
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type SubscriptionRootFisReportStateAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type SubscriptionRootFisReportStateColumnArgs = {
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type SubscriptionRootFisReportStateColumnAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type SubscriptionRootFisReportStateColumnStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportStateColumnStreamCursorInput>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type SubscriptionRootFisReportStateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportStateStreamCursorInput>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type SubscriptionRootFisReportTopFaultArgs = {
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type SubscriptionRootFisReportTopFaultAggregateArgs = {
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type SubscriptionRootFisReportTopFaultStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<FisReportTopFaultStreamCursorInput>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type SubscriptionRootFisRunReportConstraintArgs = {
  args: FisRunReportConstraintArgs;
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type SubscriptionRootFisRunReportConstraintAggregateArgs = {
  args: FisRunReportConstraintArgs;
  distinct_on?: Maybe<Array<FisReportConstraintSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportConstraintOrderBy>>;
  where?: Maybe<FisReportConstraintBoolExp>;
};


export type SubscriptionRootFisRunReportMtbfArgs = {
  args: FisRunReportMtbfArgs;
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type SubscriptionRootFisRunReportMtbfAggregateArgs = {
  args: FisRunReportMtbfArgs;
  distinct_on?: Maybe<Array<FisReportMtbfSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportMtbfOrderBy>>;
  where?: Maybe<FisReportMtbfBoolExp>;
};


export type SubscriptionRootFisRunReportOeeArgs = {
  args: FisRunReportOeeArgs;
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type SubscriptionRootFisRunReportOeeAggregateArgs = {
  args: FisRunReportOeeArgs;
  distinct_on?: Maybe<Array<FisReportOeeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportOeeOrderBy>>;
  where?: Maybe<FisReportOeeBoolExp>;
};


export type SubscriptionRootFisRunReportStateArgs = {
  args: FisRunReportStateArgs;
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type SubscriptionRootFisRunReportStateAggregateArgs = {
  args: FisRunReportStateArgs;
  distinct_on?: Maybe<Array<FisReportStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateOrderBy>>;
  where?: Maybe<FisReportStateBoolExp>;
};


export type SubscriptionRootFisRunReportStateColumnArgs = {
  args: FisRunReportStateColumnArgs;
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type SubscriptionRootFisRunReportStateColumnAggregateArgs = {
  args: FisRunReportStateColumnArgs;
  distinct_on?: Maybe<Array<FisReportStateColumnSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportStateColumnOrderBy>>;
  where?: Maybe<FisReportStateColumnBoolExp>;
};


export type SubscriptionRootFisRunReportTopFaultArgs = {
  args: FisRunReportTopFaultArgs;
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type SubscriptionRootFisRunReportTopFaultAggregateArgs = {
  args: FisRunReportTopFaultArgs;
  distinct_on?: Maybe<Array<FisReportTopFaultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FisReportTopFaultOrderBy>>;
  where?: Maybe<FisReportTopFaultBoolExp>;
};


export type SubscriptionRootPlv8ResponseArgs = {
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


export type SubscriptionRootPlv8ResponseAggregateArgs = {
  distinct_on?: Maybe<Array<Plv8ResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ResponseOrderBy>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


export type SubscriptionRootPlv8ResponseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Plv8ResponseStreamCursorInput>>;
  where?: Maybe<Plv8ResponseBoolExp>;
};


export type SubscriptionRootPlv8ValueResponseArgs = {
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


export type SubscriptionRootPlv8ValueResponseAggregateArgs = {
  distinct_on?: Maybe<Array<Plv8ValueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plv8ValueResponseOrderBy>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


export type SubscriptionRootPlv8ValueResponseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Plv8ValueResponseStreamCursorInput>>;
  where?: Maybe<Plv8ValueResponseBoolExp>;
};


export type SubscriptionRootProcessCollectionArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


export type SubscriptionRootProcessCollectionAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionOrderBy>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


export type SubscriptionRootProcessCollectionByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessCollectionDataArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


export type SubscriptionRootProcessCollectionDataAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionDataSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionDataOrderBy>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


export type SubscriptionRootProcessCollectionDataByPkArgs = {
  collection_id: Scalars['uuid'];
  data_element_id: Scalars['uuid'];
};


export type SubscriptionRootProcessCollectionDataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessCollectionDataStreamCursorInput>>;
  where?: Maybe<ProcessCollectionDataBoolExp>;
};


export type SubscriptionRootProcessCollectionKindArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionKindOrderBy>>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};


export type SubscriptionRootProcessCollectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessCollectionKindOrderBy>>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};


export type SubscriptionRootProcessCollectionKindByPkArgs = {
  kind: Scalars['String'];
};


export type SubscriptionRootProcessCollectionKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessCollectionKindStreamCursorInput>>;
  where?: Maybe<ProcessCollectionKindBoolExp>;
};


export type SubscriptionRootProcessCollectionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessCollectionStreamCursorInput>>;
  where?: Maybe<ProcessCollectionBoolExp>;
};


export type SubscriptionRootProcessDataElementArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


export type SubscriptionRootProcessDataElementAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementOrderBy>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


export type SubscriptionRootProcessDataElementByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessDataElementCollectionKindArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementCollectionKindOrderBy>>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};


export type SubscriptionRootProcessDataElementCollectionKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementCollectionKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementCollectionKindOrderBy>>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};


export type SubscriptionRootProcessDataElementCollectionKindByPkArgs = {
  collection_kind: Scalars['String'];
};


export type SubscriptionRootProcessDataElementCollectionKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessDataElementCollectionKindStreamCursorInput>>;
  where?: Maybe<ProcessDataElementCollectionKindBoolExp>;
};


export type SubscriptionRootProcessDataElementKindArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementKindOrderBy>>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};


export type SubscriptionRootProcessDataElementKindAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessDataElementKindSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessDataElementKindOrderBy>>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};


export type SubscriptionRootProcessDataElementKindByPkArgs = {
  kind: Scalars['String'];
};


export type SubscriptionRootProcessDataElementKindStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessDataElementKindStreamCursorInput>>;
  where?: Maybe<ProcessDataElementKindBoolExp>;
};


export type SubscriptionRootProcessDataElementStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessDataElementStreamCursorInput>>;
  where?: Maybe<ProcessDataElementBoolExp>;
};


export type SubscriptionRootProcessMaterialStateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


export type SubscriptionRootProcessMaterialStateAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateOrderBy>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


export type SubscriptionRootProcessMaterialStateByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessMaterialStateHistoryArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


export type SubscriptionRootProcessMaterialStateHistoryAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessMaterialStateHistorySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessMaterialStateHistoryOrderBy>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


export type SubscriptionRootProcessMaterialStateHistoryByPkArgs = {
  material_state_history_id: Scalars['uuid'];
};


export type SubscriptionRootProcessMaterialStateHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessMaterialStateHistoryStreamCursorInput>>;
  where?: Maybe<ProcessMaterialStateHistoryBoolExp>;
};


export type SubscriptionRootProcessMaterialStateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessMaterialStateStreamCursorInput>>;
  where?: Maybe<ProcessMaterialStateBoolExp>;
};


export type SubscriptionRootProcessProcessArgs = {
  distinct_on?: Maybe<Array<ProcessProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessOrderBy>>;
  where?: Maybe<ProcessProcessBoolExp>;
};


export type SubscriptionRootProcessProcessAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessProcessSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessOrderBy>>;
  where?: Maybe<ProcessProcessBoolExp>;
};


export type SubscriptionRootProcessProcessByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessProcessStatusArgs = {
  distinct_on?: Maybe<Array<ProcessProcessStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessStatusOrderBy>>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};


export type SubscriptionRootProcessProcessStatusAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessProcessStatusSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessProcessStatusOrderBy>>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};


export type SubscriptionRootProcessProcessStatusByPkArgs = {
  status: Scalars['String'];
};


export type SubscriptionRootProcessProcessStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessProcessStatusStreamCursorInput>>;
  where?: Maybe<ProcessProcessStatusBoolExp>;
};


export type SubscriptionRootProcessProcessStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessProcessStreamCursorInput>>;
  where?: Maybe<ProcessProcessBoolExp>;
};


export type SubscriptionRootProcessSpecArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


export type SubscriptionRootProcessSpecAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderBy>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


export type SubscriptionRootProcessSpecByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessSpecOrderArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


export type SubscriptionRootProcessSpecOrderAggregateArgs = {
  distinct_on?: Maybe<Array<ProcessSpecOrderSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ProcessSpecOrderOrderBy>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


export type SubscriptionRootProcessSpecOrderByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootProcessSpecOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessSpecOrderStreamCursorInput>>;
  where?: Maybe<ProcessSpecOrderBoolExp>;
};


export type SubscriptionRootProcessSpecStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<ProcessSpecStreamCursorInput>>;
  where?: Maybe<ProcessSpecBoolExp>;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};


/** Boolean expression to compare columns of type "tsrange". All fields are combined with logical 'AND'. */
export type TsrangeComparisonExp = {
  _eq?: Maybe<Scalars['tsrange']>;
  _gt?: Maybe<Scalars['tsrange']>;
  _gte?: Maybe<Scalars['tsrange']>;
  _in?: Maybe<Array<Scalars['tsrange']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['tsrange']>;
  _lte?: Maybe<Scalars['tsrange']>;
  _neq?: Maybe<Scalars['tsrange']>;
  _nin?: Maybe<Array<Scalars['tsrange']>>;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};
